/**-----------------------------------------------------------------------------------------
* Copyright © 2020 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
import { isDevMode, Directive, TemplateRef, Optional, EventEmitter, Input, Output, HostBinding, ViewChild, ElementRef, ContentChild, Component, forwardRef, Injector, Renderer2, NgZone, ChangeDetectorRef, Inject, Injectable, HostListener, ViewChildren, NgModule, ViewContainerRef, ContentChildren } from '@angular/core';
import { NgControl, NG_VALUE_ACCESSOR, NG_VALIDATORS, RadioControlValueAccessor } from '@angular/forms';
import { Subscription, fromEvent, interval, merge, Observable } from 'rxjs';
import { take, filter, concatMap, startWith, takeUntil, skip, debounceTime } from 'rxjs/operators';
import { LocalizationService, L10N_PREFIX, RTL, ComponentMessages } from '@progress/kendo-angular-l10n';
import { Keys, guid, hasObservers, anyChanged, isDocumentAvailable, KendoInput, isChanged, DraggableModule, EventsModule, ResizeSensorModule } from '@progress/kendo-angular-common';
import { browser, mobileOS } from '@progress/kendo-common';
import { IntlService } from '@progress/kendo-angular-intl';
import { CommonModule } from '@angular/common';
import { PopupService, PopupModule } from '@progress/kendo-angular-popup';
import { Color, parseColor, namedColors } from '@progress/kendo-drawing';

/**
 * @hidden
 *
 * Checks if the value is `null` or `undefined`. Falsy values like '', 0, false, NaN, etc. are regarded as present.
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@progress/kendo-angular-l10n';
import * as ɵngcc2 from '@progress/kendo-angular-common';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@progress/kendo-angular-intl';
import * as ɵngcc5 from '@progress/kendo-angular-popup';

const _c0 = ["wrap"];
const _c1 = ["track"];
const _c2 = ["sliderSelection"];
const _c3 = ["ticks"];
const _c4 = ["draghandle"];
const _c5 = ["decreaseButton"];
const _c6 = ["increaseButton"];
var I18N_7;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The title of the **Increase** button of the Slider.
     * @meaning kendo.slider.increment
     */ 
    const MSG_EXTERNAL_8302125540024939132$$DIST_FESM2015_INDEX_JS_8 = goog.getMsg("increment");
    I18N_7 = MSG_EXTERNAL_8302125540024939132$$DIST_FESM2015_INDEX_JS_8;
}
else {
    I18N_7 = $localize `:kendo.slider.increment|The title of the **Increase** button of the Slider.␟0fa71630d40c425b9c366afd7f6c3cecc5bef59d␟8302125540024939132:increment`;
}
var I18N_9;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The title of the **Decrease** button of the Slider.
     * @meaning kendo.slider.decrement
     */ 
    const MSG_EXTERNAL_652458644240352212$$DIST_FESM2015_INDEX_JS_10 = goog.getMsg("decrement");
    I18N_9 = MSG_EXTERNAL_652458644240352212$$DIST_FESM2015_INDEX_JS_10;
}
else {
    I18N_9 = $localize `:kendo.slider.decrement|The title of the **Decrease** button of the Slider.␟042c26f68d78afd6834ea46a5f7533850fe8c800␟652458644240352212:decrement`;
}
var I18N_11;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The title of the drag handle of the Slider.
     * @meaning kendo.slider.dragHandle
     */ 
    const MSG_EXTERNAL_9117416417579607469$$DIST_FESM2015_INDEX_JS_12 = goog.getMsg("Drag");
    I18N_11 = MSG_EXTERNAL_9117416417579607469$$DIST_FESM2015_INDEX_JS_12;
}
else {
    I18N_11 = $localize `:kendo.slider.dragHandle|The title of the drag handle of the Slider.␟481eb98e9cd8ef8e8b22051796441901e883763d␟9117416417579607469:Drag`;
}
const _c13 = ["increment", I18N_7, "decrement", I18N_9, "dragHandle", I18N_11];
function SliderComponent_a_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 13, 14);
    ɵngcc0.ɵɵelement(2, "span", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r217 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("title", ctx_r217.decrementMessage);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r217.decrementMessage);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("k-i-arrow-w", !ctx_r217.vertical)("k-i-arrow-s", ctx_r217.vertical);
} }
function SliderComponent_a_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 16, 17);
    ɵngcc0.ɵɵelement(2, "span", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r218 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("title", ctx_r218.incrementMessage);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r218.incrementMessage);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("k-i-arrow-e", !ctx_r218.vertical)("k-i-arrow-n", ctx_r218.vertical);
} }
function SliderComponent_ul_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ul", 18, 19);
} if (rf & 2) {
    const ctx_r219 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("tickTitle", ctx_r219.title)("vertical", ctx_r219.vertical)("step", ctx_r219.smallStep)("largeStep", ctx_r219.largeStep)("min", ctx_r219.min)("max", ctx_r219.max)("labelTemplate", ctx_r219.labelTemplate == null ? null : ctx_r219.labelTemplate.templateRef);
} }
const _c14 = function (a0, a1, a2, a3) { return { focus: a0, blur: a1, click: a2, keydown: a3 }; };
const _c15 = ["draghandleStart"];
const _c16 = ["draghandleEnd"];
var I18N_17;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The title of the **Start** drag handle of the Slider.
     * @meaning kendo.rangeslider.dragHandleStart
     */ 
    const MSG_EXTERNAL_1512034289801794423$$DIST_FESM2015_INDEX_JS_18 = goog.getMsg("Drag");
    I18N_17 = MSG_EXTERNAL_1512034289801794423$$DIST_FESM2015_INDEX_JS_18;
}
else {
    I18N_17 = $localize `:kendo.rangeslider.dragHandleStart|The title of the **Start** drag handle of the Slider.␟4487c64285c2d8cdb336be783b6cb9304ce86007␟1512034289801794423:Drag`;
}
var I18N_19;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The title of the **End** drag handle of the Slider.
     * @meaning kendo.rangeslider.dragHandleEnd
     */ 
    const MSG_EXTERNAL_6915505327582510906$$DIST_FESM2015_INDEX_JS_20 = goog.getMsg("Drag");
    I18N_19 = MSG_EXTERNAL_6915505327582510906$$DIST_FESM2015_INDEX_JS_20;
}
else {
    I18N_19 = $localize `:kendo.rangeslider.dragHandleEnd|The title of the **End** drag handle of the Slider.␟d6af522570cc1aff06104cee4b7780d6835e01d1␟6915505327582510906:Drag`;
}
const _c21 = ["dragHandleStart", I18N_17, "dragHandleEnd", I18N_19];
function RangeSliderComponent_ul_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ul", 12, 13);
} if (rf & 2) {
    const ctx_r227 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("tickTitle", ctx_r227.title)("vertical", ctx_r227.vertical)("step", ctx_r227.smallStep)("largeStep", ctx_r227.largeStep)("min", ctx_r227.min)("max", ctx_r227.max)("labelTemplate", ctx_r227.labelTemplate == null ? null : ctx_r227.labelTemplate.templateRef);
} }
const _c22 = function (a0, a1) { return { click: a0, keydown: a1 }; };
const _c23 = ["wrapper"];
var I18N_24;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The **On** label of the Switch.
     * @meaning kendo.switch.on
     */ 
    const MSG_EXTERNAL_818154782831456441$$DIST_FESM2015_INDEX_JS_25 = goog.getMsg("ON");
    I18N_24 = MSG_EXTERNAL_818154782831456441$$DIST_FESM2015_INDEX_JS_25;
}
else {
    I18N_24 = $localize `:kendo.switch.on|The **On** label of the Switch.␟155f0a38198ffbf0429c5dbf9765e74f246a8617␟818154782831456441:ON`;
}
var I18N_26;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The **Off** label of the Switch.
     * @meaning kendo.switch.off
     */ 
    const MSG_EXTERNAL_759820891948194060$$DIST_FESM2015_INDEX_JS_27 = goog.getMsg("OFF");
    I18N_26 = MSG_EXTERNAL_759820891948194060$$DIST_FESM2015_INDEX_JS_27;
}
else {
    I18N_26 = $localize `:kendo.switch.off|The **Off** label of the Switch.␟79df1a6d2b35c32b2948e3cee56dd3ffe28127bc␟759820891948194060:OFF`;
}
const _c28 = ["on", I18N_24, "off", I18N_26];
const _c29 = function (a0, a1, a2, a3) { return { click: a0, keydown: a1, focus: a2, blur: a3 }; };
function TextBoxContainerComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 1);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r234 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("for", ctx_r234.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r234.floatingLabel);
} }
const _c30 = ["*"];
const _c31 = ["numericInput"];
const _c32 = ["numericWrap"];
var I18N_33;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The title for the **Increment** button in the NumericTextBox
     * @meaning kendo.numerictextbox.increment
     */ 
    const MSG_EXTERNAL_4467784268438010275$$DIST_FESM2015_INDEX_JS_34 = goog.getMsg("Increase value");
    I18N_33 = MSG_EXTERNAL_4467784268438010275$$DIST_FESM2015_INDEX_JS_34;
}
else {
    I18N_33 = $localize `:kendo.numerictextbox.increment|The title for the **Increment** button in the NumericTextBox␟0fc68540ffa04fdc246cf6cf8a1fed085f8b19a5␟4467784268438010275:Increase value`;
}
var I18N_35;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The title for the **Decrement** button in the NumericTextBox
     * @meaning kendo.numerictextbox.decrement
     */ 
    const MSG_EXTERNAL_3960022057994897997$$DIST_FESM2015_INDEX_JS_36 = goog.getMsg("Decrease value");
    I18N_35 = MSG_EXTERNAL_3960022057994897997$$DIST_FESM2015_INDEX_JS_36;
}
else {
    I18N_35 = $localize `:kendo.numerictextbox.decrement|The title for the **Decrement** button in the NumericTextBox␟df4751834075bf970c77d0da2c960b4e19a6b0dd␟3960022057994897997:Decrease value`;
}
const _c37 = ["increment", I18N_33, "decrement", I18N_35];
const _c38 = function (a0, a1) { return { mouseup: a0, mouseleave: a1 }; };
const _c39 = function (a0) { return { mousedown: a0 }; };
function NumericTextBoxComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵelementStart(1, "span", 7);
    ɵngcc0.ɵɵelement(2, "span", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 9);
    ɵngcc0.ɵɵelement(4, "span", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r237 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("kendoEventsOutsideAngular", ɵngcc0.ɵɵpureFunction2(11, _c38, ctx_r237.releaseArrow, ctx_r237.releaseArrow));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("k-state-active", ctx_r237.arrowDirection === ctx_r237.ArrowDirection.Up);
    ɵngcc0.ɵɵproperty("kendoEventsOutsideAngular", ɵngcc0.ɵɵpureFunction1(14, _c39, ctx_r237.increasePress))("title", ctx_r237.incrementTitle);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r237.incrementTitle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("k-state-active", ctx_r237.arrowDirection === ctx_r237.ArrowDirection.Down);
    ɵngcc0.ɵɵproperty("kendoEventsOutsideAngular", ɵngcc0.ɵɵpureFunction1(16, _c39, ctx_r237.decreasePress))("title", ctx_r237.decrementTitle);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r237.decrementTitle);
} }
const _c40 = function (a0, a1) { return { mousewheel: a0, DOMMouseScroll: a1 }; };
const _c41 = function (a0, a1, a2, a3, a4, a5, a6) { return { mousedown: a0, dragenter: a1, keydown: a2, input: a3, focus: a4, blur: a5, paste: a6 }; };
const _c42 = ["input"];
const _c43 = function (a0, a1, a2, a3, a4) { return { focus: a0, blur: a1, click: a2, dragstart: a3, drop: a4 }; };
const _c44 = ["tickElement"];
const _c45 = ["kendoSliderTicks", ""];
function SliderTicksComponent_li_0_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵelementContainer(1, 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tick_r242 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r244 = ɵngcc0.ɵɵnextContext();
    const _r240 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r244.labelTemplate || _r240)("ngTemplateOutletContext", tick_r242);
} }
function SliderTicksComponent_li_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\u00A0");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function SliderTicksComponent_li_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 2, 3);
    ɵngcc0.ɵɵelementContainerStart(2, 4);
    ɵngcc0.ɵɵtemplate(3, SliderTicksComponent_li_0_span_3_Template, 2, 2, "span", 5);
    ɵngcc0.ɵɵtemplate(4, SliderTicksComponent_li_0_ng_container_4_Template, 2, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tick_r242 = ctx.$implicit;
    const ctx_r239 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r239.tickTitle(tick_r242.value));
    ɵngcc0.ɵɵproperty("ngClass", tick_r242.classes);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngSwitch", tick_r242.large);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", false);
} }
function SliderTicksComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const value_r247 = ctx.value;
    const ctx_r241 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r241.tickTitle(value_r247), " ");
} }
var I18N_46;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The title for the **Clear** button in the TextBox.
     * @meaning kendo.textbox.clear
     */ 
    const MSG_EXTERNAL_2651889799249671820$$DIST_FESM2015_INDEX_JS_47 = goog.getMsg("Clear");
    I18N_46 = MSG_EXTERNAL_2651889799249671820$$DIST_FESM2015_INDEX_JS_47;
}
else {
    I18N_46 = $localize `:kendo.textbox.clear|The title for the **Clear** button in the TextBox.␟e6edd360fd0d3c873c0d94a3aecd3c407d31da5a␟2651889799249671820:Clear`;
}
const _c48 = ["clear", I18N_46];
function TextBoxComponent_3_ng_template_0_Template(rf, ctx) { }
function TextBoxComponent_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TextBoxComponent_3_ng_template_0_Template, 0, 0, "ng-template", 8);
} if (rf & 2) {
    const ctx_r248 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r248.prefixTemplate == null ? null : ctx_r248.prefixTemplate.templateRef);
} }
function TextBoxComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 9);
} if (rf & 2) {
    const ctx_r250 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r250.errorIconClasses);
} }
function TextBoxComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 9);
} if (rf & 2) {
    const ctx_r251 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r251.successIconClasses);
} }
function TextBoxComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    const _r256 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵlistener("click", function TextBoxComponent_span_9_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r256); const ctx_r255 = ɵngcc0.ɵɵnextContext(); return ctx_r255.clearValue(); })("mousedown", function TextBoxComponent_span_9_Template_span_mousedown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r256); return $event.preventDefault(); })("keydown.enter", function TextBoxComponent_span_9_Template_span_keydown_enter_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r256); const ctx_r258 = ɵngcc0.ɵɵnextContext(); return ctx_r258.clearValue($event); })("keydown.space", function TextBoxComponent_span_9_Template_span_keydown_space_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r256); const ctx_r259 = ɵngcc0.ɵɵnextContext(); return ctx_r259.clearValue($event); });
    ɵngcc0.ɵɵelement(1, "span", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r252 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("tabindex", ctx_r252.tabIndex)("title", ctx_r252.clearTitle());
    ɵngcc0.ɵɵattribute("aria-label", ctx_r252.clearTitle());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r252.clearButtonClasses);
} }
function TextBoxComponent_10_ng_template_0_Template(rf, ctx) { }
function TextBoxComponent_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TextBoxComponent_10_ng_template_0_Template, 0, 0, "ng-template", 8);
} if (rf & 2) {
    const ctx_r253 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r253.suffixTemplate == null ? null : ctx_r253.suffixTemplate.templateRef);
} }
const _c49 = function (a0, a1, a2) { return { focus: a0, blur: a1, input: a2 }; };
const _c50 = ["palette"];
const _c51 = ["container"];
const _c52 = ["popupTemplate"];
function ColorPickerComponent_span_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 10);
} }
function ColorPickerComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r269 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵlistener("click", function ColorPickerComponent_span_2_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r269); const ctx_r268 = ɵngcc0.ɵɵnextContext(); return ctx_r268.handleActiveColorClick(); });
    ɵngcc0.ɵɵtemplate(1, ColorPickerComponent_span_2_span_1_Template, 1, 0, "span", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r262 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("background-color", ctx_r262.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r262.value);
} }
function ColorPickerComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    const _r271 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵlistener("click", function ColorPickerComponent_span_3_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r271); const ctx_r270 = ɵngcc0.ɵɵnextContext(); return ctx_r270.handleActiveColorClick(); });
    ɵngcc0.ɵɵelement(1, "span", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r263 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r263.iconStyles);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("background-color", ctx_r263.value);
} }
function ColorPickerComponent_ng_template_6_kendo_colorgradient_0_Template(rf, ctx) { if (rf & 1) {
    const _r275 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "kendo-colorgradient", 15);
    ɵngcc0.ɵɵlistener("focusout", function ColorPickerComponent_ng_template_6_kendo_colorgradient_0_Template_kendo_colorgradient_focusout_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r275); const ctx_r274 = ɵngcc0.ɵɵnextContext(2); return ctx_r274.handlePopupBlur($event); })("valueChange", function ColorPickerComponent_ng_template_6_kendo_colorgradient_0_Template_kendo_colorgradient_valueChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r275); const ctx_r276 = ɵngcc0.ɵɵnextContext(2); return ctx_r276.handleValueChange($event, false); })("keydown", function ColorPickerComponent_ng_template_6_kendo_colorgradient_0_Template_kendo_colorgradient_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r275); const ctx_r277 = ɵngcc0.ɵɵnextContext(2); return ctx_r277.handlePopupKeyDown($event.keyCode); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r272 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("value", ctx_r272.value)("format", ctx_r272.format)("opacity", ctx_r272.gradientSettings.opacity)("clearButton", ctx_r272.gradientSettings.clearButton);
} }
function ColorPickerComponent_ng_template_6_kendo_colorpalette_1_Template(rf, ctx) { if (rf & 1) {
    const _r280 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "kendo-colorpalette", 16, 17);
    ɵngcc0.ɵɵlistener("blur", function ColorPickerComponent_ng_template_6_kendo_colorpalette_1_Template_kendo_colorpalette_blur_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r280); const ctx_r279 = ɵngcc0.ɵɵnextContext(2); return ctx_r279.handlePopupBlur($event); })("cellSelection", function ColorPickerComponent_ng_template_6_kendo_colorpalette_1_Template_kendo_colorpalette_cellSelection_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r280); const ctx_r281 = ɵngcc0.ɵɵnextContext(2); return ctx_r281.handleValueChange($event, true); })("mousedown", function ColorPickerComponent_ng_template_6_kendo_colorpalette_1_Template_kendo_colorpalette_mousedown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r280); return $event.preventDefault(); })("keydown", function ColorPickerComponent_ng_template_6_kendo_colorpalette_1_Template_kendo_colorpalette_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r280); const ctx_r283 = ɵngcc0.ɵɵnextContext(2); return ctx_r283.handlePopupKeyDown($event.keyCode); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r273 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("palette", ctx_r273.paletteSettings.palette)("columns", ctx_r273.paletteSettings.columns)("tileSize", ctx_r273.paletteSettings.tileSize)("format", ctx_r273.format)("value", ctx_r273.value);
} }
function ColorPickerComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ColorPickerComponent_ng_template_6_kendo_colorgradient_0_Template, 1, 4, "kendo-colorgradient", 13);
    ɵngcc0.ɵɵtemplate(1, ColorPickerComponent_ng_template_6_kendo_colorpalette_1_Template, 2, 5, "kendo-colorpalette", 14);
} if (rf & 2) {
    const ctx_r265 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r265.view === "gradient" || ctx_r265.view === "combo");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r265.view === "palette" || ctx_r265.view === "combo");
} }
const _c53 = function (a1, a2) { return { "k-picker-wrap": true, "k-state-disabled": a1, "k-state-focused": a2 }; };
const _c54 = function (a0, a1, a2, a3) { return { backgroundColor: a0, width: a1, height: a2, minWidth: a3 }; };
function ColorPaletteComponent_tr_3_td_1_Template(rf, ctx) { if (rf & 1) {
    const _r292 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 5);
    ɵngcc0.ɵɵlistener("click", function ColorPaletteComponent_tr_3_td_1_Template_td_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r292); const color_r288 = ctx.$implicit; const colIndex_r289 = ctx.index; const rowIndex_r286 = ɵngcc0.ɵɵnextContext().index; const ctx_r290 = ɵngcc0.ɵɵnextContext(); return ctx_r290.handleCellSelection(color_r288, { row: rowIndex_r286, col: colIndex_r289 }); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const color_r288 = ctx.$implicit;
    const colIndex_r289 = ctx.index;
    const rowIndex_r286 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r287 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("k-state-selected", (ctx_r287.focusedCell == null ? null : ctx_r287.focusedCell.row) === rowIndex_r286 && (ctx_r287.focusedCell == null ? null : ctx_r287.focusedCell.col) === colIndex_r289);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction4(4, _c54, color_r288, ctx_r287.tileLayout.width + "px", ctx_r287.tileLayout.height + "px", ctx_r287.tileLayout.width + "px"));
    ɵngcc0.ɵɵattribute("value", color_r288);
} }
function ColorPaletteComponent_tr_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr", 3);
    ɵngcc0.ɵɵtemplate(1, ColorPaletteComponent_tr_3_td_1_Template, 1, 9, "td", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r285 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", row_r285);
} }
const _c55 = ["alphaSlider"];
const _c56 = ["gradientWrapper"];
const _c57 = ["dragHandle"];
function ColorGradientComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    const _r299 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵlistener("click", function ColorGradientComponent_span_7_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r299); const ctx_r298 = ɵngcc0.ɵɵnextContext(); return ctx_r298.reset(); });
    ɵngcc0.ɵɵelement(1, "span", 11);
    ɵngcc0.ɵɵelementEnd();
} }
function ColorGradientComponent_kendo_slider_9_Template(rf, ctx) { if (rf & 1) {
    const _r302 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "kendo-slider", 12, 13);
    ɵngcc0.ɵɵlistener("valueChange", function ColorGradientComponent_kendo_slider_9_Template_kendo_slider_valueChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r302); const ctx_r301 = ɵngcc0.ɵɵnextContext(); return ctx_r301.handleAlphaSliderChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r297 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r297.disabled)("readonly", ctx_r297.readonly)("showButtons", false)("tickPlacement", "none")("vertical", true)("min", 0)("max", 100)("smallStep", 1)("largeStep", 10)("value", ctx_r297.alphaSliderValue);
} }
function ColorInputComponent_kendo_numerictextbox_6_Template(rf, ctx) { if (rf & 1) {
    const _r307 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "kendo-numerictextbox", 9);
    ɵngcc0.ɵɵlistener("valueChange", function ColorInputComponent_kendo_numerictextbox_6_Template_kendo_numerictextbox_valueChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r307); const ctx_r306 = ɵngcc0.ɵɵnextContext(); return ctx_r306.rgba.a = $event; })("blur", function ColorInputComponent_kendo_numerictextbox_6_Template_kendo_numerictextbox_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r307); const ctx_r308 = ɵngcc0.ɵɵnextContext(); return ctx_r308.handleRgbaInputBlur(); })("valueChange", function ColorInputComponent_kendo_numerictextbox_6_Template_kendo_numerictextbox_valueChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r307); const ctx_r309 = ɵngcc0.ɵɵnextContext(); return ctx_r309.handleRgbaValueChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r304 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r304.disabled)("readonly", ctx_r304.readonly)("min", 0)("max", 1)("value", ctx_r304.rgba.a)("autoCorrect", true)("spinners", false)("step", 0.01)("format", "n2")("decimals", 2);
} }
function ColorInputComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "a");
    ɵngcc0.ɵɵelementEnd();
} }
function FormFieldComponent_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 2, ["*ngIf", "hasHints"]);
} }
function FormFieldComponent_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 3, ["*ngIf", "hasErrors"]);
} }
const _c58 = [[["label"], ["kendo-label"]], "*", [["kendo-formhint"]], [["kendo-formerror"]]];
const _c59 = ["label, kendo-label", "*", "kendo-formhint", "kendo-formerror"];
const isPresent = (value) => value !== null && value !== undefined;
/**
 * @hidden
 */
const areSame = (value1, value2) => value1 === value2 || (value1 === null && value2 === undefined) || (value1 === undefined && value2 === null);
/**
 * @hidden
 */
const requiresZoneOnBlur = (ngControl) => ngControl &&
    (!ngControl.touched || (ngControl.control && ngControl.control.updateOn === 'blur'));
/**
 * @hidden
 *
 * Fits the contender number into the specified bounds. If the number is NaN or null, the min is returned.
 *
 * @param contender Represents the number you want to fit into specified bounds.
 * @param min The inclusive lower bound number.
 * @param max The inclusive upper bound number.
 */
const fitIntoBounds = (contender, min, max) => {
    if (!isPresent(contender) || isNaN(contender)) {
        return min;
    }
    return contender <= min ? min : contender >= max ? max : contender;
};

/**
 * @hidden
 */
const MAX_PRECISION = 20;
/**
 * @hidden
 */
const limitPrecision = (precision) => Math.min(precision, MAX_PRECISION);
/**
 * @hidden
 */
const fractionLength = (value) => {
    return (String(value).split('.')[1] || "").length;
};
const maxFractionLength = (value1, value2) => {
    return Math.max(fractionLength(value1), fractionLength(value2));
};
/**
 * @hidden
 */
const toFixedPrecision = (value, precision) => {
    const maxPrecision = limitPrecision(precision);
    return parseFloat(value.toFixed(maxPrecision));
};
/**
 * @hidden
 */
const add = (value1, value2) => {
    const maxPrecision = maxFractionLength(value1, value2);
    return toFixedPrecision(value1 + value2, maxPrecision);
};
/**
 * @hidden
 */
const subtract = (value1, value2) => {
    return add(value1, -value2);
};
/**
 * @hidden
 */
const multiply = (value1, value2) => {
    const maxPrecision = fractionLength(value1) + fractionLength(value2);
    return toFixedPrecision(value1 * value2, maxPrecision);
};
/**
 * @hidden
 */
const divide = (dividend, divisor) => {
    if (divisor === 0) {
        return NaN;
    }
    const power = maxFractionLength(dividend, divisor);
    const correctionValue = Math.pow(10, power);
    return ((correctionValue * dividend) / (correctionValue * divisor));
};
/**
 * @hidden
 */
const remainder = (dividend, divisor) => {
    return Math.abs(subtract(dividend, multiply(divisor, Math.floor(divide(dividend, divisor)))));
};

/**
 * @hidden
 */
const calculateFixedTrackSize = ({ max, min, smallStep, fixedTickWidth }) => ((max - min) / smallStep) * fixedTickWidth;
/**
 * @hidden
 */
const calculateTrackSize = (wrapperWidth, offset, showButtons = true) => {
    const BUTTONS_COUNT = 2;
    const trackOffset = showButtons ? parseFloat(offset) * BUTTONS_COUNT : 0;
    const trackWidth = wrapperWidth - trackOffset;
    return Math.floor(trackWidth);
};
/**
 * @hidden
 */
const calculateTicksCount = (min = 0, max = 0, smallStep = 1) => {
    if (smallStep <= 0) {
        throw new Error('Invalid argument: smallStep must be a positive number');
    }
    const adjustedRange = Math.abs(subtract(max, min));
    const adjustedRatio = Math.floor(divide(adjustedRange, smallStep));
    const result = add(adjustedRatio, 1);
    return result;
};
/**
 * @hidden
 */
const calculateValueFromTick = (index, { max, min, smallStep, reverse, vertical }) => {
    const value = add(min, multiply(index, smallStep));
    return vertical || reverse ? Math.abs(subtract(value, max)) : value;
};
/**
 * @hidden
 */
const calculateHandlePosition = ({ handleWidth, trackWidth, min, max, reverse, value }) => {
    const halfHandleWidth = Math.floor(handleWidth / 2);
    const step = trackWidth / Math.abs(max - min);
    let pos = isPresent(value) ? step * (value - min) : min;
    if (reverse) {
        pos = trackWidth - pos;
    }
    return Math.floor(pos - halfHandleWidth);
};
/**
 * @hidden
 */
const decreaseValueToStep = (value, { max, min, smallStep, largeStep }, large = false) => {
    const step = large && largeStep ? multiply(smallStep, largeStep) : smallStep;
    const stepValue = subtract(value, min);
    let result;
    const stepRemainder = remainder(stepValue, step);
    if (stepRemainder === 0) {
        result = subtract(stepValue, step);
    }
    else {
        result = subtract(stepValue, stepRemainder);
    }
    return limitValue(add(result, min), min, max);
};
/**
 * @hidden
 */
const increaseValueToStep = (value, { max, min, smallStep, largeStep }, large = false) => {
    const step = large && largeStep ? multiply(smallStep, largeStep) : smallStep;
    const stepValue = subtract(value, min);
    const stepRemainder = remainder(stepValue, step);
    const result = add(subtract(stepValue, stepRemainder), step);
    return limitValue(add(result, min), min, max);
};
/**
 * @hidden
 */
const isStartHandle = (dragHandle) => dragHandle.id.indexOf('k-start-handle') > -1;
/**
 * @hidden
 */
const snapValue = (value, options) => {
    const { smallStep, min, max } = options;
    const limited = limitValue(value, min, max);
    if (value !== limited) {
        return limited;
    }
    const left = decreaseValueToStep(value, options);
    const right = increaseValueToStep(value, options);
    if ((value - min) % smallStep === 0) {
        return value;
    }
    if (right - value <= (right - left) / 2) {
        return right;
    }
    return left;
};
/**
 * @hidden
 */
const trimValue = (max, min, value) => {
    if (value > max) {
        return max;
    }
    if (value < min) {
        return min;
    }
    return value;
};
/**
 * @hidden
 */
const trimValueRange = (max, min, value) => {
    return value ? [trimValue(max, min, value[0]), trimValue(max, min, value[1])] : [min, min];
};
/**
 * @hidden
 */
const identity = (value) => value;
/**
 * @hidden
 */
const isSameRange = (value1, value2) => areSame(value1[0], value2[0]) && areSame(value1[1], value2[1]);
/**
 * @hidden
 */
const elementOffset = (element) => {
    const box = element.getBoundingClientRect();
    const documentElement = document.documentElement;
    return {
        left: box.left + (window.pageXOffset || documentElement.scrollLeft) - (documentElement.clientLeft || 0),
        top: box.top + (window.pageYOffset || documentElement.scrollTop) - (documentElement.clientTop || 0)
    };
};
/**
 * @hidden
 */
const limitValue = (value, min, max) => {
    return Math.max(Math.min(value, max), min);
};
/**
 * @hidden
 */
const eventValue = (eventArgs, scaleElement, options) => {
    const { min, max, vertical, rtl } = options;
    const trackOffset = elementOffset(scaleElement);
    const offset = vertical ? eventArgs.pageY - trackOffset.top : eventArgs.pageX - trackOffset.left;
    const scale = (max - min) / (vertical ? scaleElement.clientHeight : scaleElement.clientWidth);
    const offsetValue = offset * scale;
    let value = rtl || vertical ? max - offsetValue : min + offsetValue;
    const stepFractionLength = fractionLength(options.smallStep);
    value = toFixedPrecision(value, stepFractionLength + 1);
    return snapValue(value, options);
};
/**
 * @hidden
 */
const isButton = (element) => {
    return element.className.indexOf('k-button-increase') >= 0 || element.className.indexOf('k-button-decrease') >= 0;
};
/**
 * @hidden
 */
const increment = (options) => {
    return increaseValueToStep(options.value, options);
};
/**
 * @hidden
 */
const decrement = (options) => {
    return decreaseValueToStep(options.value, options);
};
/**
 * @hidden
 */
const incrementLarge = (options) => {
    return increaseValueToStep(options.value, options, true);
};
/**
 * @hidden
 */
const decrementLarge = (options) => {
    return decreaseValueToStep(options.value, options, true);
};
/**
 * @hidden
 */
const validateValue = (value) => {
    if (isDevMode && value && value[0] > value[1]) {
        throw new Error('[RangeSlider] The start value should not be greater than the end value.');
    }
};

/**
 * @hidden
 */
class SliderModelBase {
    constructor(props, wrapper, track, renderer) {
        this.props = props;
        this.wrapper = wrapper;
        this.track = track;
        this.renderer = renderer;
        this.props = props;
        this.wrapper = wrapper;
        this.track = track;
        this.tickSizes = this.getTickSizes();
    }
    resizeTrack() {
        const orientation = this.props.vertical ? 'height' : 'width';
        const trackWidth = this.trackWidth();
        this.track.style[orientation] = `${trackWidth}px`;
    }
    resizeTicks(ticksContainer, ticks) {
        const dimension = this.props.vertical ? "height" : "width";
        [...ticks].map((tick, index) => tick.style[dimension] = `${this.tickSizes[index]}px`);
        if (this.props.vertical) {
            this.adjustPadding(ticksContainer);
        }
    }
    resizeWrapper() {
        const dimension = this.props.vertical ? "height" : "width";
        const wrapperSize = this.elementSize(this.wrapper);
        const trackWidth = calculateTrackSize(wrapperSize, this.elementOffset(this.track));
        const fixedTrackWidth = calculateFixedTrackSize(this.props);
        const wrapperParentEl = this.wrapper.parentElement;
        if (trackWidth > fixedTrackWidth) {
            wrapperParentEl.style[dimension] = `${wrapperSize - (trackWidth - fixedTrackWidth)}px`;
        }
        else {
            wrapperParentEl.style[dimension] = `${wrapperSize + (fixedTrackWidth - trackWidth)}px`;
        }
    }
    trackWidth() {
        if (this.props.fixedTickWidth) {
            return calculateFixedTrackSize(this.props);
        }
        return calculateTrackSize(this.elementSize(this.wrapper), this.elementOffset(this.track), this.props.buttons);
    }
    getTickSizes() {
        const { min, max, smallStep } = this.props;
        const count = calculateTicksCount(min, max, smallStep);
        const trackSize = this.trackWidth();
        const distStep = trackSize / subtract(max, min);
        const result = [];
        let usedSpace = 0;
        let endPoint = 0;
        for (let i = 0; i < count; i++) {
            if (i === 0 || i === count - 1) {
                endPoint += (smallStep / 2) * distStep;
            }
            else {
                endPoint += smallStep * distStep;
            }
            // ensure that the sum of the tick sizes does not exceed the track width
            endPoint = +endPoint.toFixed(2) - 0.01;
            const size = Math.round(endPoint - usedSpace);
            result.push(size);
            usedSpace += size;
        }
        if (usedSpace >= trackSize) {
            result[result.length - 1] -= 1;
        }
        return result;
    }
    adjustPadding(ticksContainer) {
        const totalTickSize = this.tickSizes.reduce((prev, curr) => prev + curr, 0);
        const trackWidth = this.trackWidth();
        const reminder = trackWidth - totalTickSize;
        if (reminder !== 0) {
            const padding = reminder + this.elementOffset(this.track);
            ticksContainer.style.paddingTop = `${padding}px`;
        }
    }
    elementOffset(element) {
        const { vertical } = this.props;
        const style = getComputedStyle(element);
        return parseInt(vertical ? style.bottom : style.left, 10);
    }
    elementSize(element) {
        const { vertical } = this.props;
        return vertical ? element.clientHeight : element.clientWidth;
    }
}

/**
 * @hidden
 */
class SliderModel extends SliderModelBase {
    positionHandle(dragHandle) {
        const { max, min, reverse, vertical } = this.props;
        const position = vertical ? 'bottom' : 'left';
        const trackWidth = this.trackWidth();
        const value = trimValue(max, min, this.props.value);
        this.handlePosition = calculateHandlePosition({
            min,
            max,
            reverse,
            value,
            trackWidth,
            handleWidth: dragHandle.offsetWidth
        });
        this.renderer.setStyle(dragHandle, position, `${this.handlePosition}px`);
    }
    positionSelection(dragHandle, selection) {
        const { reverse, vertical } = this.props;
        const dimension = vertical ? 'height' : 'width';
        const handleWidth = Math.floor(dragHandle.offsetWidth / 2);
        let size = this.handlePosition + handleWidth;
        if (reverse) {
            size = this.trackWidth() - size;
        }
        this.renderer.setStyle(selection, dimension, `${size}px`);
    }
}

const UNTOUCHED = 'ng-untouched';
const toClassList = (classNames) => String(classNames).trim().split(' ');
/**
 * @hidden
 */
const hasClass = (element, className) => Boolean(toClassList(element.className).find((name) => name === className));
/**
 * @hidden
 */
function invokeElementMethod(element, name, ...args) {
    if (element && element.nativeElement) {
        return element.nativeElement[name].apply(element.nativeElement, args);
    }
}
/**
 * @hidden
 */
const isUntouched = (element) => element && element.nativeElement && hasClass(element.nativeElement, UNTOUCHED);
/**
 * @hidden
 */
const containsFocus = (hostElement, contender) => hostElement && contender && (hostElement === contender || hostElement.contains(contender));
/**
 * @hidden
 */
const closest = (node, predicate) => {
    while (node && !predicate(node)) {
        node = node.parentNode;
    }
    return node;
};

/**
 * Represents the template for the labels of the Slider.
 * To define the labels template, nest an `<ng-template>` tag with the `kendoSliderLabelTemplate` directive inside
 * the `<kendo-slider>` tag. The template context is passed to the `label` value.
 *
 * @example
 * ```ts-no-run
 *
 * _@Component({
 *     selector: 'my-app',
 *     template: `
 *         <kendo-slider [largeStep]="2">
 *           <ng-template kendoSliderLabelTemplate let-value="value">
 *             <b>{{value}}</b>
 *           </ng-template>
 *         </kendo-slider>
 *     `
 * })
 *
 * class AppComponent {
 * }
 *
 * ```
 */
class LabelTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
LabelTemplateDirective.ɵfac = function LabelTemplateDirective_Factory(t) { return new (t || LabelTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef, 8)); };
LabelTemplateDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: LabelTemplateDirective, selectors: [["", "kendoSliderLabelTemplate", ""]] });
/** @nocollapse */
LabelTemplateDirective.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LabelTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoSliderLabelTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * @hidden
 */
class SliderBase {
    constructor(localizationService, injector, renderer, ngZone, changeDetector, hostElement) {
        this.localizationService = localizationService;
        this.injector = injector;
        this.renderer = renderer;
        this.ngZone = ngZone;
        this.changeDetector = changeDetector;
        this.hostElement = hostElement;
        /**
         * Defines the title of the ticks ([see example]({% slug ticks_slider %}#toc-titles)). The default title
         * for each tick is its Slider value. If you use a callback function, the function accepts an argument
         * that holds the value of the component and returns a string with the new title.
         */
        this.title = identity;
        /**
         * Denotes the location of the tick marks in the Slider ([see example]({% slug ticks_slider %}#toc-placement)).
         *
         * The available options are:
         * * `before`&mdash;The tick marks are located to the top side of the horizontal track or to the left side of a vertical track.
         * * `after`&mdash;The tick marks are located to the bottom side of the horizontal track or to the right side of the vertical track.
         * * `both`&mdash; (Default) The tick marks are located on both sides of the track.
         * * `none`&mdash;The tick marks are not visible. The actual elements are not added to the DOM tree.
         */
        this.tickPlacement = 'both';
        /**
         * If `vertical` is set to `true`, the orientation of the Slider changes from horizontal to vertical
         * ([see example]({% slug orientation_slider %})).
         */
        this.vertical = false;
        /**
         * The minimum value of the Slider ([see example]({% slug predefinedsteps_slider %}#toc-small-steps)).
         * The attribute accepts both integers and floating-point numbers.
         */
        this.min = 0;
        /**
         * The maximum value of the Slider ([see example]({% slug predefinedsteps_slider %}#toc-small-steps)).
         * The attribute accepts both integers and floating-point numbers.
         */
        this.max = 10;
        /**
         * The step value of the Slider ([see example]({% slug predefinedsteps_slider %}#toc-small-steps)).
         * Accepts positive values only. Can be an integer or a floating-point number.
         */
        this.smallStep = 1;
        /**
         * Specifies that every n<sup>th</sup> tick will be large and will have a label
         * ([see example]({% slug predefinedsteps_slider %}#toc-large-steps)).
         * Accepts positive integer values only.
         */
        this.largeStep = null;
        /**
         * Determines whether the Slider is disabled ([see example]({% slug disabledstate_slider %})).
         */
        this.disabled = false;
        /**
         * Determines whether the Slider is in its read-only state ([see example]({% slug readonly_slider %})).
         */
        this.readonly = false;
        /**
         * Specifies the [`tabindex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) of the Slider.
         */
        this.tabindex = 0;
        /**
         * Fires each time the user focuses the component.
         */
        this.onFocus = new EventEmitter(); //tslint:disable-line:no-output-rename
        /**
         * Fires each time the component is blurred.
         */
        this.onBlur = new EventEmitter(); //tslint:disable-line:no-output-rename
        /**
         * Fires each time the user selects a new value.
         */
        this.valueChange = new EventEmitter();
        this.sliderClass = true;
        this.widgetClass = true;
        this.subscriptions = new Subscription();
        /**
         * @hidden
         */
        this.ifEnabled = (callback, event) => {
            if (!this.isDisabled) {
                callback.call(this, event);
            }
        };
        this.direction = localizationService.rtl ? 'rtl' : 'ltr';
    }
    get horizontalClass() {
        return !this.vertical;
    }
    get verticalClass() {
        return this.vertical;
    }
    get disabledClass() {
        return this.disabled;
    }
    /**
     * @hidden
     * Called when the status of the component changes to or from `disabled`.
     * Depending on the value, it enables or disables the appropriate DOM element.
     *
     * @param isDisabled
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    ngOnInit() {
        this.subscriptions.add(this.localizationService
            .changes
            .subscribe(({ rtl }) => {
            this.direction = rtl ? 'rtl' : 'ltr';
            this.sizeComponent();
        }));
        if (this.hostElement) {
            this.renderer.removeAttribute(this.hostElement.nativeElement, "tabindex");
        }
        this.control = this.injector.get(NgControl, null);
    }
    /**
     * @hidden
     */
    get isDisabled() {
        return this.disabled || this.readonly;
    }
    /**
     * @hidden
     * Used by the FloatingLabel to determine if the component is empty.
     */
    isEmpty() {
        return false;
    }
    get reverse() {
        return this.localizationService.rtl && !this.vertical;
    }
    get keyBinding() {
        const reverse = this.reverse;
        return {
            [Keys.ArrowLeft]: reverse ? increment : decrement,
            [Keys.ArrowRight]: reverse ? decrement : increment,
            [Keys.ArrowDown]: decrement,
            [Keys.ArrowUp]: increment,
            [Keys.PageUp]: incrementLarge,
            [Keys.PageDown]: decrementLarge,
            [Keys.Home]: ({ min }) => min,
            [Keys.End]: ({ max }) => max
        };
    }
    resetStyles(elements) {
        elements.forEach(el => {
            if (el) {
                if (this.vertical) {
                    this.renderer.removeStyle(el, 'width');
                    this.renderer.removeStyle(el, 'left');
                    this.renderer.removeStyle(el, 'right');
                }
                else {
                    this.renderer.removeStyle(el, 'height');
                    this.renderer.removeStyle(el, 'bottom');
                }
                this.renderer.removeStyle(el, 'padding-top');
            }
        });
    }
}
SliderBase.ɵfac = function SliderBase_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
SliderBase.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SliderBase, contentQueries: function SliderBase_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, LabelTemplateDirective, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.labelTemplate = _t.first);
    } }, viewQuery: function SliderBase_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c0, true);
        ɵngcc0.ɵɵstaticViewQuery(_c1, true);
        ɵngcc0.ɵɵstaticViewQuery(_c2, true);
        ɵngcc0.ɵɵviewQuery(_c3, true, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c3, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.wrapper = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.track = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sliderSelection = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.ticksContainer = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.ticks = _t.first);
    } }, hostVars: 11, hostBindings: function SliderBase_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.direction);
        ɵngcc0.ɵɵclassProp("k-slider", ctx.sliderClass)("k-widget", ctx.widgetClass)("k-slider-horizontal", ctx.horizontalClass)("k-slider-vertical", ctx.verticalClass)("k-state-disabled", ctx.disabledClass);
    } }, inputs: { title: "title", tickPlacement: "tickPlacement", vertical: "vertical", min: "min", max: "max", smallStep: "smallStep", largeStep: "largeStep", disabled: "disabled", readonly: "readonly", tabindex: "tabindex", fixedTickWidth: "fixedTickWidth" }, outputs: { onFocus: "focus", onBlur: "blur", valueChange: "valueChange" } });
SliderBase.propDecorators = {
    title: [{ type: Input }],
    tickPlacement: [{ type: Input }],
    vertical: [{ type: Input }],
    min: [{ type: Input }],
    max: [{ type: Input }],
    smallStep: [{ type: Input }],
    largeStep: [{ type: Input }],
    fixedTickWidth: [{ type: Input }],
    disabled: [{ type: Input }],
    readonly: [{ type: Input }],
    tabindex: [{ type: Input }],
    onFocus: [{ type: Output, args: ['focus',] }],
    onBlur: [{ type: Output, args: ['blur',] }],
    valueChange: [{ type: Output }],
    direction: [{ type: HostBinding, args: ['attr.dir',] }],
    horizontalClass: [{ type: HostBinding, args: ['class.k-slider-horizontal',] }],
    verticalClass: [{ type: HostBinding, args: ['class.k-slider-vertical',] }],
    sliderClass: [{ type: HostBinding, args: ['class.k-slider',] }],
    widgetClass: [{ type: HostBinding, args: ['class.k-widget',] }],
    disabledClass: [{ type: HostBinding, args: ['class.k-state-disabled',] }],
    wrapper: [{ type: ViewChild, args: ['wrap', { static: true },] }],
    track: [{ type: ViewChild, args: ['track', { static: true },] }],
    sliderSelection: [{ type: ViewChild, args: ['sliderSelection', { static: true },] }],
    ticksContainer: [{ type: ViewChild, args: ['ticks', { read: ElementRef },] }],
    ticks: [{ type: ViewChild, args: ['ticks',] }],
    labelTemplate: [{ type: ContentChild, args: [LabelTemplateDirective,] }]
};


const FOCUSED = 'k-state-focused';
const PRESSED = 'k-pressed';
/**
 * Represents the [Kendo UI Slider component for Angular]({% slug overview_slider %}).
 */
class SliderComponent extends SliderBase {
    constructor(localization, injector, renderer, ngZone, changeDetector, hostElement) {
        super(localization, injector, renderer, ngZone, changeDetector, hostElement);
        this.localization = localization;
        this.injector = injector;
        this.renderer = renderer;
        this.ngZone = ngZone;
        this.changeDetector = changeDetector;
        this.hostElement = hostElement;
        /**
         * @hidden
         */
        this.focusableId = `k-${guid()}`;
        /**
         * Determines if the animation will be played on value change.
         * Regardless of this setting, no animation will be played during the initial rendering.
         */
        this.animate = true;
        /**
         * Renders the arrow side buttons of the Slider ([see example]({% slug sidebuttons_slider %}#toc-hidden-state)).
         * When `showButtons` is set to `false`, the buttons are not displayed.
         */
        this.showButtons = true;
        /**
         * The current value of the Slider when it is initially displayed.
         * The component can use either NgModel or the `value` binding but not both of them at the same time.
         */
        this.value = this.min;
        /**
         * @hidden
         */
        this.handleFocus = () => {
            this.focused = true;
            if (hasObservers(this.onFocus)) {
                this.ngZone.run(() => {
                    this.onFocus.emit();
                });
            }
        };
        /**
         * @hidden
         */
        this.handleBlur = () => {
            this.changeDetector.markForCheck();
            this.focused = false;
            if (hasObservers(this.onBlur) || requiresZoneOnBlur(this.control)) {
                this.ngZone.run(() => {
                    this.ngTouched();
                    this.onBlur.emit();
                });
            }
        };
        /**
         * @hidden
         */
        this.onWrapClick = (args) => {
            const target = args.target;
            if (!this.isDisabled && !(isButton(target) || isButton(target.parentNode))) {
                const value = eventValue(args, this.track.nativeElement, this.getProps());
                this.changeValue(value);
            }
        };
        /**
         * @hidden
         */
        this.onKeyDown = (e) => {
            const options = this.getProps();
            const { max, min } = options;
            const handler = this.keyBinding[e.keyCode];
            if (this.isDisabled || !handler) {
                return;
            }
            const value = handler(options);
            this.changeValue(trimValue(max, min, value));
            e.preventDefault();
        };
        this.ngChange = (_) => { };
        this.ngTouched = () => { };
        this.decreaseValue = () => {
            this.changeValue(decreaseValueToStep(this.value, this.getProps()));
        };
        this.increaseValue = () => {
            this.changeValue(increaseValueToStep(this.value, this.getProps()));
        };
    }
    /**
     * @hidden
     */
    set tabIndex(tabIndex) {
        this.tabindex = tabIndex;
    }
    get tabIndex() {
        return this.tabindex;
    }
    /**
     * Focuses the Slider.
     *
     * @example
     * ```ts-no-run
     * _@Component({
     * selector: 'my-app',
     * template: `
     *  <button (click)="slider.focus()">Focus</button>
     *  <kendo-slider #slider></kendo-slider>
     * `
     * })
     * class AppComponent { }
     * ```
     */
    focus() {
        invokeElementMethod(this.wrapper, 'focus');
    }
    /**
     * Blurs the Slider.
     */
    blur() {
        invokeElementMethod(this.wrapper, 'blur');
    }
    ngOnChanges(changes) {
        if (anyChanged(['value', 'fixedTickWidth', 'tickPlacement'], changes, true)) {
            this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
                this.sizeComponent(false);
            });
        }
    }
    ngAfterViewInit() {
        if (!isDocumentAvailable()) {
            return;
        }
        if (this.showButtons) {
            this.setValueChangeInterval(this.increaseButton.nativeElement, () => this.increaseValue());
            this.setValueChangeInterval(this.decreaseButton.nativeElement, () => this.decreaseValue());
        }
        this.sizeComponent(false);
        if (this.ticks) {
            this.ticks.tickElements
                .changes
                .subscribe(() => this.sizeComponent(false));
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    /**
     * @hidden
     */
    get incrementMessage() {
        return this.incrementTitle || this.localizationService.get('increment');
    }
    /**
     * @hidden
     */
    get decrementMessage() {
        return this.decrementTitle || this.localizationService.get('decrement');
    }
    /**
     * @hidden
     */
    get dragHandleMessage() {
        return this.dragHandleTitle || this.localizationService.get('dragHandle');
    }
    /**
     * @hidden
     */
    handleDragPress(args) {
        if (args.originalEvent) {
            args.originalEvent.preventDefault();
        }
        this.focus();
        this.renderer.removeClass(this.hostElement.nativeElement, 'k-slider-transitions');
    }
    /**
     * @hidden
     */
    onHandleDrag(args) {
        this.dragging = true;
        this.changeValue(eventValue(args, this.track.nativeElement, this.getProps()));
    }
    /**
     * @hidden
     */
    onHandleRelease() {
        this.dragging = false; //needed for animation
        this.renderer.addClass(this.hostElement.nativeElement, 'k-slider-transitions');
    }
    //ngModel binding
    /**
     * @hidden
     */
    writeValue(value) {
        this.value = value;
        this.sizeComponent(this.animate);
    }
    /**
     * @hidden
     */
    registerOnChange(fn) {
        this.ngChange = fn;
    }
    /**
     * @hidden
     */
    registerOnTouched(fn) {
        this.ngTouched = fn;
    }
    /**
     * @hidden
     */
    changeValue(value) {
        if (!areSame(this.value, value)) {
            this.ngZone.run(() => {
                this.value = value;
                this.ngChange(value);
                this.valueChange.emit(value);
                this.sizeComponent(this.animate);
            });
        }
    }
    /**
     * @hidden
     */
    sizeComponent(animate) {
        if (!isDocumentAvailable()) {
            return;
        }
        const wrapper = this.wrapper.nativeElement;
        const track = this.track.nativeElement;
        const selectionEl = this.sliderSelection.nativeElement;
        const dragHandleEl = this.draghandle.nativeElement;
        const ticks = this.ticks ? this.ticksContainer.nativeElement : null;
        if (!animate) {
            this.renderer.removeClass(this.hostElement.nativeElement, 'k-slider-transitions');
        }
        this.resetStyles([track, selectionEl, dragHandleEl, ticks, this.hostElement.nativeElement]);
        const props = this.getProps();
        const model = new SliderModel(props, wrapper, track, this.renderer);
        model.resizeTrack();
        if (this.ticks) { //for case when tickPlacement: none
            model.resizeTicks(this.ticksContainer.nativeElement, this.ticks.tickElements.map(element => element.nativeElement));
        }
        model.positionHandle(dragHandleEl);
        model.positionSelection(dragHandleEl, selectionEl);
        if (!animate) {
            this.hostElement.nativeElement.getBoundingClientRect();
            this.renderer.addClass(this.hostElement.nativeElement, 'k-slider-transitions');
        }
        if (this.fixedTickWidth) {
            model.resizeWrapper();
        }
    }
    set focused(value) {
        if (this.isFocused !== value && this.hostElement) {
            const element = this.hostElement.nativeElement;
            if (value) {
                this.renderer.addClass(element, FOCUSED);
            }
            else {
                this.renderer.removeClass(element, FOCUSED);
            }
            this.isFocused = value;
        }
    }
    set dragging(value) {
        if (this.isDragged !== value && this.sliderSelection && this.draghandle) {
            const sliderSelection = this.sliderSelection.nativeElement;
            const draghandle = this.draghandle.nativeElement;
            if (value) {
                this.renderer.addClass(sliderSelection, PRESSED);
                this.renderer.addClass(draghandle, PRESSED);
            }
            else {
                this.renderer.removeClass(sliderSelection, PRESSED);
                this.renderer.removeClass(draghandle, PRESSED);
            }
            this.isDragged = value;
        }
    }
    setValueChangeInterval(element, callback) {
        this.ngZone.runOutsideAngular(() => {
            const mousedown = fromEvent(element, 'mousedown');
            const mouseup = fromEvent(element, 'mouseup');
            const mouseout = fromEvent(element, 'mouseout');
            const subscription = mousedown.pipe(filter((e) => e.button === 0 && !this.isDisabled), concatMap(() => interval(150).pipe(startWith(-1), takeUntil(merge(mouseup, mouseout))))).subscribe(() => {
                this.focus();
                callback();
            });
            this.subscriptions.add(subscription);
        });
    }
    getProps() {
        return {
            buttons: this.showButtons,
            disabled: this.disabled,
            fixedTickWidth: this.fixedTickWidth,
            largeStep: this.largeStep,
            max: this.max,
            min: this.min,
            readonly: this.readonly,
            reverse: this.reverse,
            rtl: this.localizationService.rtl,
            smallStep: this.smallStep,
            value: trimValue(this.max, this.min, this.value),
            vertical: this.vertical
        };
    }
}
SliderComponent.ɵfac = function SliderComponent_Factory(t) { return new (t || SliderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SliderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SliderComponent, selectors: [["kendo-slider"]], viewQuery: function SliderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c4, true);
        ɵngcc0.ɵɵviewQuery(_c5, true);
        ɵngcc0.ɵɵviewQuery(_c6, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.draghandle = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.decreaseButton = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.increaseButton = _t.first);
    } }, inputs: { focusableId: "focusableId", animate: "animate", showButtons: "showButtons", value: "value", tabIndex: "tabIndex", dragHandleTitle: "dragHandleTitle", incrementTitle: "incrementTitle", decrementTitle: "decrementTitle" }, exportAs: ["kendoSlider"], features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            { provide: L10N_PREFIX, useValue: 'kendo.slider' },
            { multi: true, provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SliderComponent) },
            { provide: KendoInput, useExisting: forwardRef(() => SliderComponent) }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 14, vars: 26, consts: [["kendoSliderLocalizedMessages", "", 6, "increment", "decrement", "dragHandle"], [1, "k-slider-wrap", 3, "id", "kendoEventsOutsideAngular"], ["wrap", ""], ["class", "k-button k-button-decrease", 3, "title", 4, "ngIf"], ["class", "k-button k-button-increase", 3, "title", 4, "ngIf"], ["kendoSliderTicks", "", 3, "tickTitle", "vertical", "step", "largeStep", "min", "max", "labelTemplate", 4, "ngIf"], [1, "k-slider-track"], ["track", ""], [1, "k-slider-selection"], ["sliderSelection", ""], ["role", "slider", "kendoDraggable", "", 1, "k-draghandle", 3, "title", "kendoPress", "kendoDrag", "kendoRelease"], ["draghandle", ""], [3, "resize"], [1, "k-button", "k-button-decrease", 3, "title"], ["decreaseButton", ""], [1, "k-icon"], [1, "k-button", "k-button-increase", 3, "title"], ["increaseButton", ""], ["kendoSliderTicks", "", 3, "tickTitle", "vertical", "step", "largeStep", "min", "max", "labelTemplate"], ["ticks", ""]], template: function SliderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵi18nAttributes(1, _c13);
        ɵngcc0.ɵɵelementStart(2, "div", 1, 2);
        ɵngcc0.ɵɵtemplate(4, SliderComponent_a_4_Template, 3, 6, "a", 3);
        ɵngcc0.ɵɵtemplate(5, SliderComponent_a_5_Template, 3, 6, "a", 4);
        ɵngcc0.ɵɵtemplate(6, SliderComponent_ul_6_Template, 2, 7, "ul", 5);
        ɵngcc0.ɵɵelementStart(7, "div", 6, 7);
        ɵngcc0.ɵɵelement(9, "div", 8, 9);
        ɵngcc0.ɵɵelementStart(11, "a", 10, 11);
        ɵngcc0.ɵɵlistener("kendoPress", function SliderComponent_Template_a_kendoPress_11_listener($event) { return ctx.ifEnabled(ctx.handleDragPress, $event); })("kendoDrag", function SliderComponent_Template_a_kendoDrag_11_listener($event) { return ctx.ifEnabled(ctx.onHandleDrag, $event); })("kendoRelease", function SliderComponent_Template_a_kendoRelease_11_listener($event) { return ctx.ifEnabled(ctx.onHandleRelease, $event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "kendo-resize-sensor", 12);
        ɵngcc0.ɵɵlistener("resize", function SliderComponent_Template_kendo_resize_sensor_resize_13_listener() { return ctx.sizeComponent(false); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("k-slider-buttons", ctx.showButtons)("k-slider-topleft", ctx.tickPlacement === "before")("k-slider-bottomright", ctx.tickPlacement === "after");
        ɵngcc0.ɵɵproperty("id", ctx.focusableId)("kendoEventsOutsideAngular", ɵngcc0.ɵɵpureFunction4(21, _c14, ctx.handleFocus, ctx.handleBlur, ctx.onWrapClick, ctx.onKeyDown));
        ɵngcc0.ɵɵattribute("tabindex", ctx.disabled ? undefined : ctx.tabIndex);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showButtons);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showButtons);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tickPlacement !== "none");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵstyleProp("touch-action", ctx.isDisabled ? "" : "none");
        ɵngcc0.ɵɵproperty("title", ctx.dragHandleMessage);
        ɵngcc0.ɵɵattribute("aria-valuemin", ctx.min)("aria-valuemax", ctx.max)("aria-valuenow", ctx.value)("aria-disabled", ctx.disabled ? true : undefined)("aria-readonly", ctx.readonly ? true : undefined)("aria-orientation", ctx.vertical ? "vertical" : "horizontal");
    } }, directives: function () { return [LocalizedSliderMessagesDirective, ɵngcc2.EventsOutsideAngularDirective, ɵngcc3.NgIf, ɵngcc2.DraggableDirective, ɵngcc2.ResizeSensorComponent, SliderTicksComponent]; }, encapsulation: 2 });
/** @nocollapse */
SliderComponent.ctorParameters = () => [
    { type: LocalizationService },
    { type: Injector },
    { type: Renderer2 },
    { type: NgZone },
    { type: ChangeDetectorRef },
    { type: ElementRef }
];
SliderComponent.propDecorators = {
    focusableId: [{ type: Input }],
    dragHandleTitle: [{ type: Input }],
    incrementTitle: [{ type: Input }],
    animate: [{ type: Input }],
    decrementTitle: [{ type: Input }],
    showButtons: [{ type: Input }],
    value: [{ type: Input }],
    tabIndex: [{ type: Input }],
    draghandle: [{ type: ViewChild, args: ['draghandle', { static: true },] }],
    decreaseButton: [{ type: ViewChild, args: ['decreaseButton',] }],
    increaseButton: [{ type: ViewChild, args: ['increaseButton',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SliderComponent, [{
        type: Component,
        args: [{
                exportAs: 'kendoSlider',
                providers: [
                    LocalizationService,
                    { provide: L10N_PREFIX, useValue: 'kendo.slider' },
                    { multi: true, provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SliderComponent) },
                    { provide: KendoInput, useExisting: forwardRef(() => SliderComponent) }
                ],
                selector: 'kendo-slider',
                template: `
        <ng-container kendoSliderLocalizedMessages
            i18n-increment="kendo.slider.increment|The title of the **Increase** button of the Slider."
            increment="increment"
            i18n-decrement="kendo.slider.decrement|The title of the **Decrease** button of the Slider."
            decrement="decrement"
            i18n-dragHandle="kendo.slider.dragHandle|The title of the drag handle of the Slider."
            dragHandle="Drag"
        >
        <div class="k-slider-wrap" #wrap
            [id]="focusableId"
            [class.k-slider-buttons]="showButtons"
            [class.k-slider-topleft]="tickPlacement === 'before'"
            [class.k-slider-bottomright]="tickPlacement === 'after'"
            [attr.tabindex]="disabled ? undefined : tabIndex"
            [kendoEventsOutsideAngular]="{ focus: handleFocus, blur: handleBlur, click: onWrapClick, keydown: onKeyDown }"
            >
            <a
                #decreaseButton
                *ngIf="showButtons"
                class="k-button k-button-decrease"
                [title]="decrementMessage"
                [attr.aria-label]="decrementMessage"
            >
                <span class="k-icon"
                    [class.k-i-arrow-w]="!vertical"
                    [class.k-i-arrow-s]="vertical"
                >
                </span>
            </a>
            <a
                *ngIf="showButtons"
                #increaseButton
                class="k-button k-button-increase"
                [title]="incrementMessage"
                [attr.aria-label]="incrementMessage"
            >
                <span class="k-icon"
                    [class.k-i-arrow-e]="!vertical"
                    [class.k-i-arrow-n]="vertical"
                >
                </span>
            </a>
            <ul kendoSliderTicks
                #ticks
                *ngIf="tickPlacement !== 'none'"
                [tickTitle]="title"
                [vertical]="vertical"
                [step]="smallStep"
                [largeStep]="largeStep"
                [min]="min"
                [max]="max"
                [labelTemplate]="labelTemplate?.templateRef"
            >
            </ul>
        <div #track class="k-slider-track">
            <div #sliderSelection class="k-slider-selection">
            </div>
                <a #draghandle
                    role="slider"
                    [attr.aria-valuemin]="min"
                    [attr.aria-valuemax]="max"
                    [attr.aria-valuenow]="value"
                    [attr.aria-disabled]="disabled ? true : undefined"
                    [attr.aria-readonly]="readonly ? true : undefined"
                    [attr.aria-orientation]="vertical ? 'vertical' : 'horizontal'"
                    [style.touch-action]="isDisabled ? '' : 'none'"
                    class="k-draghandle"
                    [title]="dragHandleMessage"
                    kendoDraggable
                    (kendoPress)="ifEnabled(handleDragPress, $event)"
                    (kendoDrag)="ifEnabled(onHandleDrag, $event)"
                    (kendoRelease)="ifEnabled(onHandleRelease, $event)"
                ></a>
            </div>
            <kendo-resize-sensor (resize)="sizeComponent(false)"></kendo-resize-sensor>
        </div>
  `
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }, { type: ɵngcc0.Injector }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }]; }, { focusableId: [{
            type: Input
        }], animate: [{
            type: Input
        }], showButtons: [{
            type: Input
        }], value: [{
            type: Input
        }], tabIndex: [{
            type: Input
        }], dragHandleTitle: [{
            type: Input
        }], incrementTitle: [{
            type: Input
        }], decrementTitle: [{
            type: Input
        }], draghandle: [{
            type: ViewChild,
            args: ['draghandle', { static: true }]
        }], decreaseButton: [{
            type: ViewChild,
            args: ['decreaseButton']
        }], increaseButton: [{
            type: ViewChild,
            args: ['increaseButton']
        }] }); })();

/**
 * @hidden
 */
class RangeSliderModel extends SliderModelBase {
    positionHandle(dragHandle) {
        if (!dragHandle.id) {
            return;
        }
        const { max, min, reverse, vertical } = this.props;
        const position = vertical ? 'bottom' : 'left';
        const trackWidth = this.trackWidth();
        const value = isStartHandle(dragHandle) ? trimValueRange(max, min, this.props.value)[0]
            : trimValueRange(max, min, this.props.value)[1];
        if (isStartHandle(dragHandle)) {
            this.startHandlePosition = calculateHandlePosition({
                min,
                max,
                reverse,
                value,
                trackWidth,
                handleWidth: dragHandle.offsetWidth
            });
            this.renderer.setStyle(dragHandle, position, `${this.startHandlePosition}px`);
        }
        else {
            this.endHandlePosition = calculateHandlePosition({
                min,
                max,
                reverse,
                value,
                trackWidth,
                handleWidth: dragHandle.offsetWidth
            });
            this.renderer.setStyle(dragHandle, position, `${this.endHandlePosition}px`);
        }
    }
    positionSelection(dragHandle, selection) {
        const { reverse, vertical } = this.props;
        const dimension = vertical ? 'height' : 'width';
        const position = vertical ? 'bottom' : reverse ? 'right' : 'left';
        const handleWidth = Math.floor(dragHandle.offsetWidth / 2);
        const size = Math.abs(this.endHandlePosition - this.startHandlePosition);
        const currentSelectionPosition = vertical ? dragHandle.style.bottom : dragHandle.style.left;
        this.renderer.setStyle(selection, dimension, `${size}px`);
        this.renderer.setStyle(selection, position, reverse ? this.trackWidth() - parseFloat(currentSelectionPosition) - handleWidth + 'px'
            : parseFloat(currentSelectionPosition) + handleWidth + 'px');
    }
}

const PRESSED$1 = 'k-pressed';
/**
 * Represents the [Kendo UI RangeSlider component for Angular]({% slug overview_rangeslider %}).
 */
class RangeSliderComponent extends SliderBase {
    constructor(localization, injector, renderer, ngZone, changeDetector, hostElement) {
        super(localization, injector, renderer, ngZone, changeDetector, hostElement);
        this.localization = localization;
        this.injector = injector;
        this.renderer = renderer;
        this.ngZone = ngZone;
        this.changeDetector = changeDetector;
        this.hostElement = hostElement;
        /**
         * @hidden
         */
        this.startHandleId = `k-start-handle-${guid()}`;
        /**
         * @hidden
         */
        this.endHandleId = `k-end-handle-${guid()}`;
        /**
         * @hidden
         */
        this.focusableId = this.startHandleId;
        this.handleZIndex = 0;
        this.activeHandle = 'startHandle';
        this.focusChangedProgrammatically = false;
        /**
         * @hidden
         */
        this.onWrapClick = (args) => {
            if (!this.isDisabled) {
                this.value = this.value || [this.min, this.min];
                const trackValue = eventValue(args, this.track.nativeElement, this.getProps());
                let newRangeValue;
                const [startValue, endValue] = newRangeValue = this.value;
                if (trackValue <= startValue) {
                    newRangeValue = [trackValue, endValue];
                    this.activeHandle = 'startHandle';
                }
                else if (startValue < trackValue && trackValue < endValue) {
                    if (trackValue < (startValue + endValue) / 2) {
                        newRangeValue = [trackValue, endValue];
                        this.activeHandle = 'startHandle';
                    }
                    else {
                        newRangeValue = [startValue, trackValue];
                        this.activeHandle = 'endHandle';
                    }
                }
                else if (trackValue >= endValue) {
                    newRangeValue = [startValue, trackValue];
                    this.activeHandle = 'endHandle';
                }
                const activeHandle = this.activeHandle === 'startHandle' ? this.draghandleStart : this.draghandleEnd;
                invokeElementMethod(activeHandle, 'focus');
                this.changeValue(newRangeValue);
            }
        };
        /**
         * @hidden
         */
        this.onKeyDown = (e) => {
            this.value = this.value || [this.min, this.min];
            const options = this.getProps();
            const { max, min } = options;
            const handler = this.keyBinding[e.keyCode];
            if (this.isDisabled || !handler) {
                return;
            }
            this.renderer.setStyle(e.target, 'zIndex', ++this.handleZIndex);
            const startHandleIsActive = isStartHandle(e.target);
            const value = handler(Object.assign({}, options, { value: startHandleIsActive ? this.value[0] : this.value[1] }));
            if (startHandleIsActive) {
                if (value > this.value[1]) {
                    this.value[1] = value;
                }
            }
            else {
                if (value < this.value[0]) {
                    this.value[0] = value;
                }
            }
            const trimmedValue = trimValue(max, min, value);
            const newValue = startHandleIsActive ? [trimmedValue, this.value[1]]
                : [this.value[0], trimmedValue];
            this.changeValue(newValue);
            e.preventDefault();
        };
        this.ngChange = (_) => { };
        this.ngTouched = () => { };
        this.handleBlur = () => {
            this.changeDetector.markForCheck();
            this.focused = false;
            if (hasObservers(this.onBlur) || requiresZoneOnBlur(this.control)) {
                this.ngZone.run(() => {
                    this.ngTouched();
                    if (!this.focusChangedProgrammatically) {
                        this.onBlur.emit();
                    }
                });
            }
        };
    }
    /**
     * Focuses the RangeSlider.
     *
     * @example
     * ```ts-no-run
     * _@Component({
     * selector: 'my-app',
     * template: `
     *     <div>
     *         <button class="k-button" (click)="slider.focus()">Focus</button>
     *     </div>
     *     <kendo-rangeslider #slider></kendo-rangeslider>
     * `
     * })
     * class AppComponent { }
     * ```
     */
    focus() {
        this.focusChangedProgrammatically = true;
        invokeElementMethod(this.draghandleStart, 'focus');
        this.focusChangedProgrammatically = false;
    }
    /**
     * Blurs the RangeSlider.
     */
    blur() {
        this.focusChangedProgrammatically = true;
        const activeHandle = this.activeHandle === 'startHandle' ? this.draghandleStart : this.draghandleEnd;
        invokeElementMethod(activeHandle, 'blur');
        this.handleBlur();
        this.focusChangedProgrammatically = false;
    }
    ngOnInit() {
        if (!this.value) {
            this.value = [this.min, this.max];
        }
        super.ngOnInit();
    }
    ngOnChanges(changes) {
        if (anyChanged(['value', 'fixedTickWidth', 'tickPlacement'], changes, true)) {
            if (changes.value && changes.value.currentValue) {
                validateValue(changes.value.currentValue);
            }
            this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
                this.sizeComponent();
            });
        }
    }
    ngAfterViewInit() {
        if (!isDocumentAvailable()) {
            return;
        }
        this.sizeComponent();
        if (this.ticks) {
            this.ticks.tickElements
                .changes
                .subscribe(() => this.sizeComponent());
        }
        this.attachElementEventHandlers();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    /**
     * @hidden
     */
    textFor(key) {
        return this.localization.get(key);
    }
    /**
     * @hidden
     */
    get valueText() {
        return this.value ? `${this.value[0]} - ${this.value[1]}` : '';
    }
    /**
     * @hidden
     */
    handleDragPress(args) {
        if (args.originalEvent) {
            args.originalEvent.preventDefault();
        }
        const target = args.originalEvent.target;
        this.draggedHandle = target;
        this.renderer.setStyle(target, 'zIndex', ++this.handleZIndex);
    }
    /**
     * @hidden
     */
    onHandleDrag(args) {
        this.value = this.value || [this.min, this.min];
        const target = args.originalEvent.target;
        const lastCoords = this.draggedHandle.getBoundingClientRect();
        this.lastHandlePosition = { x: lastCoords.left, y: lastCoords.top };
        this.dragging = { value: true, target };
        const left = args.pageX < this.lastHandlePosition.x;
        const right = args.pageX > this.lastHandlePosition.x;
        const up = args.pageY > this.lastHandlePosition.y;
        const moveStartHandle = () => this.changeValue([eventValue(args, this.track.nativeElement, this.getProps()), this.value[1]]);
        const moveEndHandle = () => this.changeValue([this.value[0], eventValue(args, this.track.nativeElement, this.getProps())]);
        const moveBothHandles = () => this.changeValue([eventValue(args, this.track.nativeElement, this.getProps()), eventValue(args, this.track.nativeElement, this.getProps())]);
        const activeStartHandle = isStartHandle(this.draggedHandle);
        const vertical = this.vertical;
        const horizontal = !vertical;
        const forward = (vertical && up) || (this.reverse ? horizontal && right : horizontal && left);
        // const forward = (this.reverse ? (!this.vertical && !left) : (!this.vertical && left)) || (this.vertical && up);
        if (this.value[0] === this.value[1]) {
            if (forward) {
                activeStartHandle ? moveStartHandle() : moveBothHandles();
            }
            else {
                activeStartHandle ? moveBothHandles() : moveEndHandle();
            }
        }
        else {
            activeStartHandle ? moveStartHandle() : moveEndHandle();
        }
    }
    /**
     * @hidden
     */
    onHandleRelease(args) {
        this.dragging = { value: false, target: args.originalEvent.target }; //needed for animation
        this.draggedHandle = undefined;
    }
    //ngModel binding
    /**
     * @hidden
     */
    writeValue(value) {
        validateValue(value);
        this.value = value;
        this.sizeComponent();
    }
    /**
     * @hidden
     */
    registerOnChange(fn) {
        this.ngChange = fn;
    }
    /**
     * @hidden
     */
    registerOnTouched(fn) {
        this.ngTouched = fn;
    }
    /**
     * @hidden
     */
    changeValue(value) {
        if (!this.value || !isSameRange(this.value, value)) {
            this.ngZone.run(() => {
                this.value = value;
                this.ngChange(value);
                if (this.value) {
                    this.valueChange.emit(value);
                }
                this.sizeComponent();
            });
        }
    }
    /**
     * @hidden
     */
    sizeComponent() {
        if (!isDocumentAvailable()) {
            return;
        }
        const wrapper = this.wrapper.nativeElement;
        const track = this.track.nativeElement;
        const selectionEl = this.sliderSelection.nativeElement;
        const dragHandleStartEl = this.draghandleStart.nativeElement;
        const dragHandleEndEl = this.draghandleEnd.nativeElement;
        const ticks = this.ticks ? this.ticksContainer.nativeElement : null;
        this.resetStyles([track, selectionEl, dragHandleStartEl, dragHandleEndEl, ticks, this.hostElement.nativeElement]);
        const props = this.getProps();
        const model = new RangeSliderModel(props, wrapper, track, this.renderer);
        model.resizeTrack();
        if (this.ticks) { //for case when tickPlacement: none
            model.resizeTicks(this.ticksContainer.nativeElement, this.ticks.tickElements.map(element => element.nativeElement));
        }
        model.positionHandle(dragHandleStartEl);
        model.positionHandle(dragHandleEndEl);
        model.positionSelection(dragHandleStartEl, selectionEl);
        if (this.fixedTickWidth) {
            model.resizeWrapper();
        }
    }
    /**
     * @hidden
     */
    get isDisabled() {
        return this.disabled || this.readonly;
    }
    /**
     * @hidden
     * Used by the FloatingLabel to determine if the component is empty.
     */
    isEmpty() {
        return false;
    }
    set focused(value) {
        if (this.isFocused !== value && this.hostElement) {
            this.isFocused = value;
        }
    }
    set dragging(data) {
        if (this.isDragged !== data.value && this.sliderSelection && this.draghandleStart && this.draghandleEnd) {
            const sliderSelection = this.sliderSelection.nativeElement;
            const draghandle = data.target;
            if (data.value) {
                this.renderer.addClass(sliderSelection, PRESSED$1);
                this.renderer.addClass(draghandle, PRESSED$1);
            }
            else {
                this.renderer.removeClass(sliderSelection, PRESSED$1);
                this.renderer.removeClass(draghandle, PRESSED$1);
            }
            this.isDragged = data.value;
        }
    }
    getProps() {
        return {
            disabled: this.disabled,
            fixedTickWidth: this.fixedTickWidth,
            largeStep: this.largeStep,
            max: this.max,
            min: this.min,
            readonly: this.readonly,
            reverse: this.reverse,
            rtl: this.localizationService.rtl,
            smallStep: this.smallStep,
            value: trimValueRange(this.max, this.min, this.value),
            vertical: this.vertical,
            buttons: false
        };
    }
    attachElementEventHandlers() {
        const hostElement = this.hostElement.nativeElement;
        let tabbing = false;
        let cursorInsideWrapper = false;
        this.ngZone.runOutsideAngular(() => {
            // focusIn and focusOut are relative to the host element
            this.subscriptions.add(this.renderer.listen(hostElement, 'focusin', () => {
                if (!this.isFocused) {
                    this.ngZone.run(() => {
                        if (!this.focusChangedProgrammatically) {
                            this.onFocus.emit();
                        }
                        this.focused = true;
                    });
                }
            }));
            this.subscriptions.add(this.renderer.listen(hostElement, 'focusout', (args) => {
                if (!this.isFocused) {
                    return;
                }
                if (tabbing) {
                    if (args.relatedTarget !== this.draghandleStart.nativeElement && args.relatedTarget !== this.draghandleEnd.nativeElement) {
                        this.handleBlur();
                    }
                    tabbing = false;
                }
                else {
                    if (!cursorInsideWrapper) {
                        this.handleBlur();
                    }
                }
            }));
            this.subscriptions.add(this.renderer.listen(hostElement, 'mouseenter', () => {
                cursorInsideWrapper = true;
            }));
            this.subscriptions.add(this.renderer.listen(hostElement, 'mouseleave', () => {
                cursorInsideWrapper = false;
            }));
            this.subscriptions.add(this.renderer.listen(hostElement, 'keydown', (args) => {
                if (args.keyCode === Keys.Tab) {
                    tabbing = true;
                }
                else {
                    tabbing = false;
                }
            }));
        });
    }
}
RangeSliderComponent.ɵfac = function RangeSliderComponent_Factory(t) { return new (t || RangeSliderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
RangeSliderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RangeSliderComponent, selectors: [["kendo-rangeslider"]], viewQuery: function RangeSliderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c15, true);
        ɵngcc0.ɵɵstaticViewQuery(_c16, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.draghandleStart = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.draghandleEnd = _t.first);
    } }, inputs: { value: "value" }, exportAs: ["kendoRangeSlider"], features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            { provide: L10N_PREFIX, useValue: 'kendo.rangeslider' },
            { multi: true, provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RangeSliderComponent) },
            { provide: KendoInput, useExisting: forwardRef(() => RangeSliderComponent) }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 14, vars: 33, consts: [["kendoSliderLocalizedMessages", "", 6, "dragHandleStart", "dragHandleEnd"], [1, "k-slider-wrap", 3, "kendoEventsOutsideAngular"], ["wrap", ""], ["kendoSliderTicks", "", 3, "tickTitle", "vertical", "step", "largeStep", "min", "max", "labelTemplate", 4, "ngIf"], [1, "k-slider-track"], ["track", ""], [1, "k-slider-selection"], ["sliderSelection", ""], ["role", "slider", "kendoDraggable", "", 1, "k-draghandle", 3, "id", "title", "kendoPress", "kendoDrag", "kendoRelease"], ["draghandleStart", ""], ["draghandleEnd", ""], [3, "resize"], ["kendoSliderTicks", "", 3, "tickTitle", "vertical", "step", "largeStep", "min", "max", "labelTemplate"], ["ticks", ""]], template: function RangeSliderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵi18nAttributes(1, _c21);
        ɵngcc0.ɵɵelementStart(2, "div", 1, 2);
        ɵngcc0.ɵɵtemplate(4, RangeSliderComponent_ul_4_Template, 2, 7, "ul", 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4, 5);
        ɵngcc0.ɵɵelement(7, "div", 6, 7);
        ɵngcc0.ɵɵelementStart(9, "a", 8, 9);
        ɵngcc0.ɵɵlistener("kendoPress", function RangeSliderComponent_Template_a_kendoPress_9_listener($event) { return ctx.ifEnabled(ctx.handleDragPress, $event); })("kendoDrag", function RangeSliderComponent_Template_a_kendoDrag_9_listener($event) { return ctx.ifEnabled(ctx.onHandleDrag, $event); })("kendoRelease", function RangeSliderComponent_Template_a_kendoRelease_9_listener($event) { return ctx.ifEnabled(ctx.onHandleRelease, $event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "a", 8, 10);
        ɵngcc0.ɵɵlistener("kendoPress", function RangeSliderComponent_Template_a_kendoPress_11_listener($event) { return ctx.ifEnabled(ctx.handleDragPress, $event); })("kendoDrag", function RangeSliderComponent_Template_a_kendoDrag_11_listener($event) { return ctx.ifEnabled(ctx.onHandleDrag, $event); })("kendoRelease", function RangeSliderComponent_Template_a_kendoRelease_11_listener($event) { return ctx.ifEnabled(ctx.onHandleRelease, $event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "kendo-resize-sensor", 11);
        ɵngcc0.ɵɵlistener("resize", function RangeSliderComponent_Template_kendo_resize_sensor_resize_13_listener() { return ctx.sizeComponent(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("k-slider-topleft", ctx.tickPlacement === "before")("k-slider-bottomright", ctx.tickPlacement === "after");
        ɵngcc0.ɵɵproperty("kendoEventsOutsideAngular", ɵngcc0.ɵɵpureFunction2(30, _c22, ctx.onWrapClick, ctx.onKeyDown));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tickPlacement !== "none");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵstyleProp("touch-action", ctx.isDisabled ? "" : "none");
        ɵngcc0.ɵɵproperty("id", ctx.startHandleId)("title", ctx.textFor("dragHandleStart"));
        ɵngcc0.ɵɵattribute("tabindex", ctx.disabled ? undefined : ctx.tabindex)("aria-valuemin", ctx.min)("aria-valuemax", ctx.max)("aria-valuenow", ctx.value ? ctx.value[0] : null)("aria-valuetext", ctx.valueText)("aria-disabled", ctx.disabled ? true : undefined)("aria-readonly", ctx.readonly ? true : undefined)("aria-orientation", ctx.vertical ? "vertical" : "horizontal");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("touch-action", ctx.isDisabled ? "" : "none");
        ɵngcc0.ɵɵproperty("id", ctx.endHandleId)("title", ctx.textFor("dragHandleEnd"));
        ɵngcc0.ɵɵattribute("tabindex", ctx.disabled ? undefined : ctx.tabindex)("aria-valuemin", ctx.min)("aria-valuemax", ctx.max)("aria-valuenow", ctx.value ? ctx.value[1] : null)("aria-valuetext", ctx.valueText)("aria-disabled", ctx.disabled ? true : undefined)("aria-readonly", ctx.readonly ? true : undefined)("aria-orientation", ctx.vertical ? "vertical" : "horizontal");
    } }, directives: function () { return [LocalizedRangeSliderMessagesDirective, ɵngcc2.EventsOutsideAngularDirective, ɵngcc3.NgIf, ɵngcc2.DraggableDirective, ɵngcc2.ResizeSensorComponent, SliderTicksComponent]; }, encapsulation: 2 });
/** @nocollapse */
RangeSliderComponent.ctorParameters = () => [
    { type: LocalizationService },
    { type: Injector },
    { type: Renderer2 },
    { type: NgZone },
    { type: ChangeDetectorRef },
    { type: ElementRef }
];
RangeSliderComponent.propDecorators = {
    value: [{ type: Input }],
    draghandleStart: [{ type: ViewChild, args: ['draghandleStart', { static: true },] }],
    draghandleEnd: [{ type: ViewChild, args: ['draghandleEnd', { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RangeSliderComponent, [{
        type: Component,
        args: [{
                exportAs: 'kendoRangeSlider',
                providers: [
                    LocalizationService,
                    { provide: L10N_PREFIX, useValue: 'kendo.rangeslider' },
                    { multi: true, provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RangeSliderComponent) },
                    { provide: KendoInput, useExisting: forwardRef(() => RangeSliderComponent) }
                ],
                selector: 'kendo-rangeslider',
                template: `
        <ng-container kendoSliderLocalizedMessages
            i18n-dragHandleStart="kendo.rangeslider.dragHandleStart|The title of the **Start** drag handle of the Slider."
            dragHandleStart="Drag"
            i18n-dragHandleEnd="kendo.rangeslider.dragHandleEnd|The title of the **End** drag handle of the Slider."
            dragHandleEnd="Drag"
        >

        <div class="k-slider-wrap" #wrap
            [class.k-slider-topleft]="tickPlacement === 'before'"
            [class.k-slider-bottomright]="tickPlacement === 'after'"
            [kendoEventsOutsideAngular]="{ click: onWrapClick, keydown: onKeyDown }"
            >
            <ul kendoSliderTicks
                #ticks
                *ngIf="tickPlacement !== 'none'"
                [tickTitle]="title"
                [vertical]="vertical"
                [step]="smallStep"
                [largeStep]="largeStep"
                [min]="min"
                [max]="max"
                [labelTemplate]="labelTemplate?.templateRef"
            >
            </ul>
            <div #track class="k-slider-track">
                <div #sliderSelection class="k-slider-selection">
                </div>
                <a #draghandleStart
                    role="slider"
                    [id]="startHandleId"
                    [attr.tabindex]="disabled ? undefined : tabindex"
                    [attr.aria-valuemin]="min"
                    [attr.aria-valuemax]="max"
                    [attr.aria-valuenow]="value ? value[0] : null"
                    [attr.aria-valuetext]="valueText"
                    [attr.aria-disabled]="disabled ? true : undefined"
                    [attr.aria-readonly]="readonly ? true : undefined"
                    [attr.aria-orientation]="vertical ? 'vertical' : 'horizontal'"
                    [style.touch-action]="isDisabled ? '' : 'none'"
                    class="k-draghandle"
                    [title]="textFor('dragHandleStart')"
                    kendoDraggable
                    (kendoPress)="ifEnabled(handleDragPress ,$event)"
                    (kendoDrag)="ifEnabled(onHandleDrag ,$event)"
                    (kendoRelease)="ifEnabled(onHandleRelease, $event)"
                ></a>
                <a #draghandleEnd
                    role="slider"
                    [id]="endHandleId"
                    [attr.tabindex]="disabled ? undefined : tabindex"
                    [attr.aria-valuemin]="min"
                    [attr.aria-valuemax]="max"
                    [attr.aria-valuenow]="value ? value[1] : null"
                    [attr.aria-valuetext]="valueText"
                    [attr.aria-disabled]="disabled ? true : undefined"
                    [attr.aria-readonly]="readonly ? true : undefined"
                    [attr.aria-orientation]="vertical ? 'vertical' : 'horizontal'"
                    [style.touch-action]="isDisabled ? '' : 'none'"
                    class="k-draghandle"
                    [title]="textFor('dragHandleEnd')"
                    kendoDraggable
                    (kendoPress)="ifEnabled(handleDragPress ,$event)"
                    (kendoDrag)="ifEnabled(onHandleDrag ,$event)"
                    (kendoRelease)="ifEnabled(onHandleRelease, $event)"
                ></a>
            </div>

            <kendo-resize-sensor (resize)="sizeComponent()"></kendo-resize-sensor>
        </div>
  `
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }, { type: ɵngcc0.Injector }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }]; }, { value: [{
            type: Input
        }], draghandleStart: [{
            type: ViewChild,
            args: ['draghandleStart', { static: true }]
        }], draghandleEnd: [{
            type: ViewChild,
            args: ['draghandleEnd', { static: true }]
        }] }); })();

const FOCUSED$1 = 'k-state-focused';
/**
 * Represents the [Kendo UI Switch component for Angular]({% slug overview_switch %}).
 */
class SwitchComponent {
    constructor(renderer, hostElement, localizationService, injector, changeDetector, ngZone) {
        this.renderer = renderer;
        this.hostElement = hostElement;
        this.localizationService = localizationService;
        this.injector = injector;
        this.changeDetector = changeDetector;
        this.ngZone = ngZone;
        /**
         * @hidden
         */
        this.focusableId = `k-${guid()}`;
        /**
         * Sets the current value of the Switch when it is initially displayed.
         */
        this.checked = false;
        /**
         * Determines whether the Switch is disabled ([see example]({% slug disabled_switch %})).
         */
        this.disabled = false;
        /**
         * Determines whether the Switch is in its read-only state ([see example]({% slug readonly_switch %})).
         */
        this.readonly = false;
        /**
         * Specifies the [`tabindex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) of the Switch.
         */
        this.tabindex = 0;
        /**
         * Fires each time the user focuses the `input` element.
         */
        this.onFocus = new EventEmitter(); //tslint:disable-line:no-output-rename
        /**
         * Fires each time the `input` element gets blurred.
         */
        this.onBlur = new EventEmitter(); //tslint:disable-line:no-output-rename
        /**
         * Fires each time the user selects a new value.
         */
        this.valueChange = new EventEmitter();
        this.ngChange = (_) => { };
        this.ngTouched = () => { };
        /**
         * @hidden
         */
        this.handleFocus = () => {
            this.focused = true;
            if (hasObservers(this.onFocus)) {
                this.ngZone.run(() => {
                    this.onFocus.emit();
                });
            }
        };
        /**
         * @hidden
         */
        this.handleBlur = () => {
            this.changeDetector.markForCheck();
            this.focused = false;
            if (hasObservers(this.onBlur) || requiresZoneOnBlur(this.control)) {
                this.ngZone.run(() => {
                    this.ngTouched();
                    this.onBlur.emit();
                });
            }
        };
        this.direction = localizationService.rtl ? 'rtl' : 'ltr';
        this.keyDownHandler = this.keyDownHandler.bind(this);
        this.clickHandler = this.clickHandler.bind(this);
    }
    /**
     * @hidden
     */
    set tabIndex(tabIndex) {
        this.tabindex = tabIndex;
    }
    get tabIndex() {
        return this.tabindex;
    }
    get ieClass() {
        return browser && browser.msie;
    }
    get ariaDisabled() {
        return this.disabled ? true : undefined;
    }
    get ariaReadonly() {
        return this.readonly;
    }
    get hostClasses() {
        return true;
    }
    get switchOnClass() {
        return this.checked;
    }
    get switchOffClass() {
        return !this.checked;
    }
    get disabledClass() {
        return this.disabled;
    }
    /**
     * @hidden
     */
    get onLabelMessage() {
        return this.onLabel || this.localizationService.get('on');
    }
    /**
     * @hidden
     */
    get offLabelMessage() {
        return this.offLabel || this.localizationService.get('off');
    }
    get isEnabled() {
        return !this.disabled && !this.readonly;
    }
    ngOnInit() {
        if (this.hostElement) {
            const wrapper = this.hostElement.nativeElement;
            this.renderer.removeAttribute(wrapper, "tabindex");
        }
        this.localizationChangeSubscription = this.localizationService
            .changes
            .pipe(skip(1))
            .subscribe(({ rtl }) => {
            this.direction = rtl ? 'rtl' : 'ltr';
        });
        this.control = this.injector.get(NgControl, null);
    }
    ngOnDestroy() {
        if (this.localizationChangeSubscription) {
            this.localizationChangeSubscription.unsubscribe();
        }
    }
    /**
     * Focuses the Switch.
     *
     * @example
     * ```ts-no-run
     * _@Component({
     * selector: 'my-app',
     * template: `
     *  <button (click)="switch.focus()">Focus</button>
     *  <kendo-switch #switch></kendo-switch>
     * `
     * })
     * class AppComponent { }
     * ```
     */
    focus() {
        if (!this.wrapper) {
            return;
        }
        this.wrapper.nativeElement.focus();
    }
    /**
     * Blurs the Switch.
     */
    blur() {
        if (!this.wrapper) {
            return;
        }
        this.wrapper.nativeElement.blur();
    }
    /**
     * @hidden
     * Called when the status of the component changes to or from `disabled`.
     * Depending on the value, it enables or disables the appropriate DOM element.
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.changeDetector.markForCheck();
    }
    /**
     * @hidden
     */
    writeValue(value) {
        this.checked = value === null ? false : value;
        this.changeDetector.markForCheck();
    }
    /**
     * @hidden
     */
    registerOnChange(fn) {
        this.ngChange = fn;
    }
    /**
     * @hidden
     */
    registerOnTouched(fn) {
        this.ngTouched = fn;
    }
    /**
     * @hidden
     */
    keyDownHandler(e) {
        const keyCode = e.keyCode;
        if (this.isEnabled && (keyCode === Keys.Space || keyCode === Keys.Enter)) {
            this.changeValue(!this.checked);
            e.preventDefault();
        }
    }
    /**
     * @hidden
     */
    clickHandler() {
        if (this.isEnabled) {
            this.changeValue(!this.checked);
        }
    }
    /**
     * @hidden
     * Used by the TextBoxContainer to determine if the component is empty.
     */
    isEmpty() {
        return false;
    }
    changeValue(value) {
        if (this.checked !== value) {
            this.ngZone.run(() => {
                this.checked = value;
                this.ngChange(value);
                this.valueChange.emit(value);
                this.changeDetector.markForCheck();
            });
        }
    }
    set focused(value) {
        if (this.isFocused !== value && this.hostElement) {
            const element = this.hostElement.nativeElement;
            if (value) {
                this.renderer.addClass(element, FOCUSED$1);
            }
            else {
                this.renderer.removeClass(element, FOCUSED$1);
            }
            this.isFocused = value;
        }
    }
}
SwitchComponent.ɵfac = function SwitchComponent_Factory(t) { return new (t || SwitchComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SwitchComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SwitchComponent, selectors: [["kendo-switch"]], viewQuery: function SwitchComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c23, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.wrapper = _t.first);
    } }, hostVars: 15, hostBindings: function SwitchComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.direction)("aria-disabled", ctx.ariaDisabled)("aria-readonly", ctx.ariaReadonly);
        ɵngcc0.ɵɵclassProp("k-ie", ctx.ieClass)("k-widget", ctx.hostClasses)("k-switch", ctx.hostClasses)("k-switch-on", ctx.switchOnClass)("k-switch-off", ctx.switchOffClass)("k-state-disabled", ctx.disabledClass);
    } }, inputs: { focusableId: "focusableId", checked: "checked", disabled: "disabled", readonly: "readonly", tabindex: "tabindex", tabIndex: "tabIndex", onLabel: "onLabel", offLabel: "offLabel" }, outputs: { onFocus: "focus", onBlur: "blur", valueChange: "valueChange" }, exportAs: ["kendoSwitch"], features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            { provide: L10N_PREFIX, useValue: 'kendo.switch' },
            {
                multi: true,
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SwitchComponent) /* tslint:disable-line */
            },
            {
                provide: KendoInput,
                useExisting: forwardRef(() => SwitchComponent)
            }
        ])], decls: 9, vars: 13, consts: [["kendoSwitchLocalizedMessages", "", 6, "on", "off"], ["role", "switch", 1, "k-switch-container", 3, "id", "kendoEventsOutsideAngular"], ["wrapper", ""], [1, "k-switch-label-on"], [1, "k-switch-label-off"], [1, "k-switch-handle"]], template: function SwitchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵi18nAttributes(1, _c28);
        ɵngcc0.ɵɵelementStart(2, "span", 1, 2);
        ɵngcc0.ɵɵelementStart(4, "span", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "span", 4);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(8, "span", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("id", ctx.focusableId)("kendoEventsOutsideAngular", ɵngcc0.ɵɵpureFunction4(8, _c29, ctx.clickHandler, ctx.keyDownHandler, ctx.handleFocus, ctx.handleBlur));
        ɵngcc0.ɵɵattribute("aria-checked", ctx.checked)("tabindex", ctx.disabled ? undefined : ctx.tabIndex);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("aria-hidden", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.onLabelMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-hidden", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.offLabelMessage);
    } }, directives: function () { return [LocalizedSwitchMessagesDirective, ɵngcc2.EventsOutsideAngularDirective]; }, encapsulation: 2 });
/** @nocollapse */
SwitchComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: LocalizationService },
    { type: Injector },
    { type: ChangeDetectorRef },
    { type: NgZone }
];
SwitchComponent.propDecorators = {
    focusableId: [{ type: Input }],
    onLabel: [{ type: Input }],
    offLabel: [{ type: Input }],
    checked: [{ type: Input }],
    disabled: [{ type: Input }],
    readonly: [{ type: Input }],
    tabindex: [{ type: Input }],
    tabIndex: [{ type: Input }],
    onFocus: [{ type: Output, args: ['focus',] }],
    onBlur: [{ type: Output, args: ['blur',] }],
    valueChange: [{ type: Output }],
    wrapper: [{ type: ViewChild, args: ['wrapper',] }],
    direction: [{ type: HostBinding, args: ['attr.dir',] }],
    ieClass: [{ type: HostBinding, args: ['class.k-ie',] }],
    ariaDisabled: [{ type: HostBinding, args: ['attr.aria-disabled',] }],
    ariaReadonly: [{ type: HostBinding, args: ['attr.aria-readonly',] }],
    hostClasses: [{ type: HostBinding, args: ['class.k-widget',] }, { type: HostBinding, args: ['class.k-switch',] }],
    switchOnClass: [{ type: HostBinding, args: ['class.k-switch-on',] }],
    switchOffClass: [{ type: HostBinding, args: ['class.k-switch-off',] }],
    disabledClass: [{ type: HostBinding, args: ['class.k-state-disabled',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SwitchComponent, [{
        type: Component,
        args: [{
                exportAs: 'kendoSwitch',
                providers: [
                    LocalizationService,
                    { provide: L10N_PREFIX, useValue: 'kendo.switch' },
                    {
                        multi: true,
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => SwitchComponent) /* tslint:disable-line */
                    },
                    {
                        provide: KendoInput,
                        useExisting: forwardRef(() => SwitchComponent)
                    }
                ],
                selector: 'kendo-switch',
                template: `
        <ng-container kendoSwitchLocalizedMessages
            i18n-on="kendo.switch.on|The **On** label of the Switch."
            on="ON"
            i18n-off="kendo.switch.off|The **Off** label of the Switch."
            off="OFF"
        >

        <span
            #wrapper
            class="k-switch-container"
            [id]="focusableId"
            role="switch"
            [attr.aria-checked]="checked"
            [attr.tabindex]="(disabled ? undefined : tabIndex)"
            [kendoEventsOutsideAngular]="{ click: clickHandler, keydown: keyDownHandler, focus: handleFocus, blur: handleBlur }"
        >
            <span class="k-switch-label-on" [attr.aria-hidden]="true" >{{onLabelMessage}}</span>
            <span class="k-switch-label-off" [attr.aria-hidden]="true">{{offLabelMessage}}</span>
            <span class="k-switch-handle"></span>
        </span>
  `
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc1.LocalizationService }, { type: ɵngcc0.Injector }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.NgZone }]; }, { focusableId: [{
            type: Input
        }], checked: [{
            type: Input
        }], disabled: [{
            type: Input
        }], readonly: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], onFocus: [{
            type: Output,
            args: ['focus']
        }], onBlur: [{
            type: Output,
            args: ['blur']
        }], valueChange: [{
            type: Output
        }], direction: [{
            type: HostBinding,
            args: ['attr.dir']
        }], tabIndex: [{
            type: Input
        }], ieClass: [{
            type: HostBinding,
            args: ['class.k-ie']
        }], ariaDisabled: [{
            type: HostBinding,
            args: ['attr.aria-disabled']
        }], ariaReadonly: [{
            type: HostBinding,
            args: ['attr.aria-readonly']
        }], hostClasses: [{
            type: HostBinding,
            args: ['class.k-widget']
        }, {
            type: HostBinding,
            args: ['class.k-switch']
        }], switchOnClass: [{
            type: HostBinding,
            args: ['class.k-switch-on']
        }], switchOffClass: [{
            type: HostBinding,
            args: ['class.k-switch-off']
        }], disabledClass: [{
            type: HostBinding,
            args: ['class.k-state-disabled']
        }], onLabel: [{
            type: Input
        }], offLabel: [{
            type: Input
        }], wrapper: [{
            type: ViewChild,
            args: ['wrapper']
        }] }); })();

/**
 * Represents the [Kendo UI TextArea directive for the Inputs components for Angular]({% slug overview_textarea %}).
 * Provides floating labels to `textarea` elements.
 *
 * @example
 * ```ts-no-run
 * <textarea kendoTextArea></textarea>
 * ```
 */
class TextAreaDirective {
    constructor(renderer, element, zone, changeDetector, injector, rtl) {
        this.renderer = renderer;
        this.element = element;
        this.zone = zone;
        this.changeDetector = changeDetector;
        this.injector = injector;
        this.elementClass = true;
        this.autofillClass = true;
        /**
         * Fires each time the textarea value is changed.
         */
        this.valueChange = new EventEmitter();
        /**
         * Specifies if the `textarea` element will resize its height automatically
         * ([see example]({% slug overview_textarea %}#toc-auto-resizing)).
         *
         * @default false
         */
        this.autoSize = false;
        /**
         * @hidden
         */
        this.onFocus = new EventEmitter();
        /**
         * @hidden
         */
        this.onBlur = new EventEmitter();
        /**
         * @hidden
         */
        this.onValueChange = new EventEmitter();
        /**
         * @hidden
         */
        this.autoFillStart = new EventEmitter();
        /**
         * @hidden
         */
        this.autoFillEnd = new EventEmitter();
        this.listeners = [];
        this.ngChange = (_) => { };
        this.ngTouched = () => { };
        this.direction = rtl ? 'rtl' : 'ltr';
    }
    get id() {
        return this.element.nativeElement.id;
    }
    set id(id) {
        this.renderer.setAttribute(this.element.nativeElement, 'id', id);
    }
    /**
     * @hidden
     */
    writeValue(value) {
        this.elementValue = value;
        this.resize();
    }
    /**
     * @hidden
     */
    registerOnChange(fn) {
        this.ngChange = fn;
    }
    /**
     * @hidden
     */
    registerOnTouched(fn) {
        this.ngTouched = fn;
    }
    /**
     * @hidden
     */
    setDisabledState(isDisabled) {
        this.setElementProperty('disabled', isDisabled);
    }
    ngOnInit() {
        const element = this.element.nativeElement;
        this.zone.runOutsideAngular(() => {
            this.listeners = [
                this.renderer.listen(element, 'focus', this.handleFocus.bind(this)),
                this.renderer.listen(element, 'blur', this.handleBlur.bind(this)),
                this.renderer.listen(element, 'animationstart', (e) => {
                    if (e.animationName === 'autoFillStart') {
                        this.autoFillStart.emit();
                    }
                    else if (e.animationName === 'autoFillEnd') {
                        this.autoFillEnd.emit();
                    }
                })
            ];
            if (isDocumentAvailable() && this.autoSize) {
                this.resizeSubscription = fromEvent(window, 'resize')
                    .pipe((debounceTime(50)))
                    .subscribe(() => this.resize());
            }
            this.inputSubscription = fromEvent(element, 'input')
                .subscribe(this.handleInput.bind(this));
        });
        this.control = this.injector.get(NgControl, null);
    }
    ngOnChanges(changes) {
        const element = this.element.nativeElement;
        if (changes.value) {
            this.elementValue = this.value;
        }
        if (changes.autoSize) {
            if (this.autoSize) {
                this.initialHeight = element.offsetHeight;
                this.renderer.setStyle(element, 'resize', 'none');
            }
            else {
                this.renderer.setStyle(element, 'overflow-y', 'auto');
                this.renderer.setStyle(element, 'resize', 'both');
                element.style.height = `${this.initialHeight}px`;
            }
        }
        this.resize();
    }
    ngOnDestroy() {
        this.listeners.forEach(listener => listener());
        if (this.inputSubscription) {
            this.inputSubscription.unsubscribe();
        }
        if (this.resizeSubscription) {
            this.resizeSubscription.unsubscribe();
        }
    }
    get elementValue() {
        if (this.element) {
            return this.element.nativeElement.value;
        }
        return '';
    }
    set elementValue(value) {
        this.setElementProperty('value', (value === undefined || value === null) ? '' : value);
    }
    setElementProperty(name, value) {
        if (this.element) {
            this.renderer.setProperty(this.element.nativeElement, name, value);
        }
    }
    resize() {
        if (!this.autoSize) {
            return;
        }
        const element = this.element.nativeElement;
        this.renderer.setStyle(element, 'overflow-y', 'hidden');
        element.style.height = `${this.initialHeight}px`;
        const scrollHeight = element.scrollHeight;
        if (scrollHeight > this.initialHeight) {
            element.style.height = `${scrollHeight}px`;
        }
    }
    handleInput() {
        const value = this.elementValue;
        this.value = value;
        if (this.control || hasObservers(this.onValueChange) || hasObservers(this.valueChange)) {
            this.zone.run(() => {
                this.ngChange(value);
                this.onValueChange.emit(value);
                this.valueChange.emit(value);
                this.changeDetector.markForCheck();
            });
        }
        this.resize();
    }
    handleFocus() {
        if (hasObservers(this.onFocus)) {
            this.zone.run(() => {
                this.onFocus.emit();
            });
        }
    }
    handleBlur() {
        if (hasObservers(this.onBlur) || requiresZoneOnBlur(this.control)) {
            this.zone.run(() => {
                this.ngTouched();
                this.onBlur.emit();
                this.changeDetector.markForCheck();
            });
        }
    }
}
TextAreaDirective.ɵfac = function TextAreaDirective_Factory(t) { return new (t || TextAreaDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(RTL, 8)); };
TextAreaDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TextAreaDirective, selectors: [["textarea", "kendoTextArea", ""]], hostVars: 5, hostBindings: function TextAreaDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.direction);
        ɵngcc0.ɵɵclassProp("k-textarea", ctx.elementClass)("k-autofill", ctx.autofillClass);
    } }, inputs: { autoSize: "autoSize", value: "value" }, outputs: { valueChange: "valueChange" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => TextAreaDirective),
                multi: true
            }, {
                provide: KendoInput,
                useExisting: forwardRef(() => TextAreaDirective)
            }]), ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
TextAreaDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: NgZone },
    { type: ChangeDetectorRef },
    { type: Injector },
    { type: Boolean, decorators: [{ type: Optional }, { type: Inject, args: [RTL,] }] }
];
TextAreaDirective.propDecorators = {
    elementClass: [{ type: HostBinding, args: ['class.k-textarea',] }],
    autofillClass: [{ type: HostBinding, args: ['class.k-autofill',] }],
    direction: [{ type: HostBinding, args: ['attr.dir',] }],
    valueChange: [{ type: Output }],
    autoSize: [{ type: Input }],
    value: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TextAreaDirective, [{
        type: Directive,
        args: [{
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => TextAreaDirective),
                        multi: true
                    }, {
                        provide: KendoInput,
                        useExisting: forwardRef(() => TextAreaDirective)
                    }],
                selector: 'textarea[kendoTextArea]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.Injector }, { type: Boolean, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [RTL]
            }] }]; }, { elementClass: [{
            type: HostBinding,
            args: ['class.k-textarea']
        }], autofillClass: [{
            type: HostBinding,
            args: ['class.k-autofill']
        }], valueChange: [{
            type: Output
        }], autoSize: [{
            type: Input
        }], direction: [{
            type: HostBinding,
            args: ['attr.dir']
        }], value: [{
            type: Input
        }] }); })();

/**
 * @hidden
 */
class FloatingLabelInputAdapter {
    constructor(component, formControl) {
        this.component = component;
        const isObservableOrEventEmitter = (event) => event instanceof Observable || event instanceof EventEmitter;
        if (isObservableOrEventEmitter(component.onFocus)) {
            this.onFocus = component.onFocus;
        }
        if (isObservableOrEventEmitter(component.autoFillStart)) {
            this.autoFillStart = component.autoFillStart;
        }
        if (isObservableOrEventEmitter(component.autoFillEnd)) {
            this.autoFillEnd = component.autoFillEnd;
        }
        if (isObservableOrEventEmitter(component.onBlur)) {
            this.onBlur = component.onBlur;
        }
        if (formControl) {
            this.onValueChange = formControl.valueChanges;
        }
        else if (component.onValueChange) {
            this.onValueChange = component.onValueChange;
        }
    }
    get focusableId() {
        const component = this.component;
        if ('focusableId' in component) {
            return component.focusableId;
        }
        else if ('id' in component) {
            return component.id;
        }
        return "";
    }
    set focusableId(value) {
        const component = this.component;
        if ('focusableId' in component) {
            component.focusableId = value;
        }
        else if ('id' in component) {
            component.id = value;
        }
    }
}

const isFunction = (x) => Object.prototype.toString.call(x) === '[object Function]';
/**
 * @hidden
 */
class TextBoxContainerComponent {
    constructor(elementRef, renderer, changeDetectorRef, rtl) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.changeDetectorRef = changeDetectorRef;
        /**
         * @hidden
         */
        this.focused = false;
        /**
         * @hidden
         */
        this.empty = true;
        /**
         * @hidden
         */
        this.invalid = false;
        this._subscriptions = [];
        this.autoFillStarted = false;
        this.direction = rtl ? 'rtl' : 'ltr';
        this.renderer.removeAttribute(this.elementRef.nativeElement, "id");
    }
    get hostClasses() {
        return true;
    }
    get textareaElementClass() {
        return !!this.textarea;
    }
    get focusedClass() {
        return this.focused;
    }
    get invalidClass() {
        return this.invalid;
    }
    /**
     * @hidden
     */
    ngAfterContentInit() {
        if (!this.formControl && !this.kendoInput) {
            if (isDevMode()) {
                throw new Error("The TextBoxContainer requires a Kendo Input component" +
                    " or a forms-bound component to function properly.");
            }
            return;
        }
        // add focus/blur/valueChange handlers
        const control = new FloatingLabelInputAdapter(this.kendoInput || this.formControl.valueAccessor, this.formControl);
        const setFocus = (isFocused) => () => {
            this.focused = isFocused;
            this.updateState();
        };
        this.subscribe(control, 'onFocus', setFocus(true));
        this.subscribe(control, 'onBlur', setFocus(false));
        this.subscribe(control, 'autoFillStart', () => {
            this.autoFillStarted = true;
            this.renderer.removeClass(this.elementRef.nativeElement, 'k-state-empty');
        });
        this.subscribe(control, 'autoFillEnd', () => {
            if (this.autoFillStarted) {
                this.autoFillStarted = false;
                if (this.empty) {
                    this.renderer.addClass(this.elementRef.nativeElement, 'k-state-empty');
                }
            }
        });
        const updateState = () => this.updateState();
        updateState();
        this.subscribe(control, 'onValueChange', updateState);
        // set label id for floating label
        if (this.id && control.focusableId) {
            // input wins
            this.id = control.focusableId;
        }
        else if (this.id) {
            control.focusableId = this.id;
        }
        else if (control.focusableId) {
            this.id = control.focusableId;
        }
        else {
            const id = "_" + guid();
            control.focusableId = id;
            this.id = id;
        }
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
        this._subscriptions.forEach(s => s.unsubscribe());
        this._subscriptions = [];
    }
    subscribe(control, eventName, handler) {
        if (control[eventName] instanceof EventEmitter) {
            const subscription = control[eventName].subscribe(handler);
            this._subscriptions.push(subscription);
        }
    }
    updateState() {
        const empty = value => {
            // zero is not an empty value (e.g., NumericTextBox)
            if (value === 0 || value === false) {
                return false;
            }
            // empty arrays are an empty value (e.g., MultiSelect)
            if (Array.isArray(value) && !value.length) {
                return true;
            }
            return !value;
        };
        const formControl = this.formControl;
        if (formControl) {
            const valueAccessor = formControl.valueAccessor;
            if (isFunction(valueAccessor.isEmpty)) {
                this.empty = valueAccessor.isEmpty();
            }
            else {
                this.empty = empty(formControl.value);
            }
            this.invalid = formControl.invalid && (formControl.touched || formControl.dirty);
        }
        else {
            this.empty = isFunction(this.kendoInput.isEmpty) ?
                this.kendoInput.isEmpty() : empty(this.kendoInput.value);
        }
        if (this.empty) {
            this.renderer.addClass(this.elementRef.nativeElement, 'k-state-empty');
        }
        else {
            this.renderer.removeClass(this.elementRef.nativeElement, 'k-state-empty');
        }
        this.changeDetectorRef.markForCheck();
    }
}
TextBoxContainerComponent.ɵfac = function TextBoxContainerComponent_Factory(t) { return new (t || TextBoxContainerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(RTL, 8)); };
TextBoxContainerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TextBoxContainerComponent, selectors: [["kendo-textbox-container"]], contentQueries: function TextBoxContainerComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, KendoInput, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, TextAreaDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgControl, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.kendoInput = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.textarea = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.formControl = _t.first);
    } }, hostVars: 9, hostBindings: function TextBoxContainerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.direction);
        ɵngcc0.ɵɵclassProp("k-textbox-container", ctx.hostClasses)("k-textarea-wrapper", ctx.textareaElementClass)("k-state-focused", ctx.focusedClass)("k-state-invalid", ctx.invalidClass);
    } }, inputs: { id: "id", floatingLabel: "floatingLabel" }, ngContentSelectors: _c30, decls: 2, vars: 1, consts: [["class", "k-label", 3, "for", 4, "ngIf"], [1, "k-label", 3, "for"]], template: function TextBoxContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵtemplate(1, TextBoxContainerComponent_label_1_Template, 2, 2, "label", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.floatingLabel);
    } }, directives: [ɵngcc3.NgIf], encapsulation: 2 });
/** @nocollapse */
TextBoxContainerComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: ChangeDetectorRef },
    { type: Boolean, decorators: [{ type: Optional }, { type: Inject, args: [RTL,] }] }
];
TextBoxContainerComponent.propDecorators = {
    hostClasses: [{ type: HostBinding, args: ['class.k-textbox-container',] }],
    textareaElementClass: [{ type: HostBinding, args: ['class.k-textarea-wrapper',] }],
    focusedClass: [{ type: HostBinding, args: ['class.k-state-focused',] }],
    invalidClass: [{ type: HostBinding, args: ['class.k-state-invalid',] }],
    direction: [{ type: HostBinding, args: ['attr.dir',] }],
    id: [{ type: Input }],
    floatingLabel: [{ type: Input }],
    kendoInput: [{ type: ContentChild, args: [KendoInput,] }],
    textarea: [{ type: ContentChild, args: [TextAreaDirective,] }],
    formControl: [{ type: ContentChild, args: [NgControl,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TextBoxContainerComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-textbox-container',
                template: `
        <ng-content></ng-content>
        <label *ngIf="floatingLabel" [for]="id" class="k-label">{{ floatingLabel }}</label>
    `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: Boolean, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [RTL]
            }] }]; }, { direction: [{
            type: HostBinding,
            args: ['attr.dir']
        }], hostClasses: [{
            type: HostBinding,
            args: ['class.k-textbox-container']
        }], textareaElementClass: [{
            type: HostBinding,
            args: ['class.k-textarea-wrapper']
        }], focusedClass: [{
            type: HostBinding,
            args: ['class.k-state-focused']
        }], invalidClass: [{
            type: HostBinding,
            args: ['class.k-state-invalid']
        }], id: [{
            type: Input
        }], floatingLabel: [{
            type: Input
        }], kendoInput: [{
            type: ContentChild,
            args: [KendoInput]
        }], textarea: [{
            type: ContentChild,
            args: [TextAreaDirective]
        }], formControl: [{
            type: ContentChild,
            args: [NgControl]
        }] }); })();

/**
 * Represents the [Kendo UI TextBox directive]({% slug overview_textbox %}) for the Inputs components for Angular.
 * Used to style the textbox of any `input` element.
 *
 * @example
 * ```ts-no-run
 * <input kendoTextBox />
 * <input kendoTextBox type="email" />
 * <input kendoTextBox type="password" />
 * ```
 */
class TextBoxDirective {
    constructor(renderer, inputElement, ngZone) {
        this.renderer = renderer;
        this.inputElement = inputElement;
        this.ngZone = ngZone;
        this.hostClass = true;
        /**
         * @hidden
         */
        this.onFocus = new EventEmitter();
        /**
         * @hidden
         */
        this.onBlur = new EventEmitter();
        /**
         * @hidden
         */
        this.onValueChange = new EventEmitter();
        /**
         * @hidden
         */
        this.autoFillStart = new EventEmitter();
        /**
         * @hidden
         */
        this.autoFillEnd = new EventEmitter();
        this.listeners = [];
    }
    /**
     * @hidden
     */
    set value(text) {
        if (!this.inputElement) {
            return;
        }
        this.inputElement.nativeElement.value = (text === undefined || text === null) ? '' : text;
        this.onValueChange.emit();
    }
    /**
     * @hidden
     */
    get value() {
        return this.inputElement.nativeElement.value;
    }
    get id() {
        return this.inputElement.nativeElement.id;
    }
    set id(id) {
        this.renderer.setAttribute(this.inputElement.nativeElement, 'id', id);
    }
    ngAfterViewInit() {
        const input = this.inputElement.nativeElement;
        this.listeners = [
            this.renderer.listen(input, 'focus', () => this.onFocus.emit()),
            this.renderer.listen(input, 'blur', () => this.onBlur.emit())
        ];
        this.ngZone.runOutsideAngular(() => {
            this.renderer.listen(input, 'animationstart', (e) => {
                if (e.animationName === 'autoFillStart') {
                    this.autoFillStart.emit();
                }
                else if (e.animationName === 'autoFillEnd') {
                    this.autoFillEnd.emit();
                }
            });
        });
    }
    ngOnDestroy() {
        this.listeners.forEach(listener => listener());
    }
}
TextBoxDirective.ɵfac = function TextBoxDirective_Factory(t) { return new (t || TextBoxDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
TextBoxDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TextBoxDirective, selectors: [["input", "kendoTextBox", ""]], hostVars: 2, hostBindings: function TextBoxDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-textbox", ctx.hostClass);
    } }, inputs: { value: "value" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: KendoInput,
                useExisting: forwardRef(() => TextBoxDirective)
            }])] });
/** @nocollapse */
TextBoxDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: NgZone }
];
TextBoxDirective.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class.k-textbox',] }],
    value: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TextBoxDirective, [{
        type: Directive,
        args: [{
                selector: 'input[kendoTextBox]',
                providers: [{
                        provide: KendoInput,
                        useExisting: forwardRef(() => TextBoxDirective)
                    }]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, { hostClass: [{
            type: HostBinding,
            args: ['class.k-textbox']
        }], value: [{
            type: Input
        }] }); })();

/**
 * @hidden
 */
const createMaxValidator = (maxValue) => {
    return (c) => {
        if (!isPresent(maxValue) || !isPresent(c.value) || c.value <= maxValue) {
            return null;
        }
        return {
            maxError: {
                maxValue: maxValue,
                value: c.value
            }
        };
    };
};

/**
 * @hidden
 */
const createMinValidator = (minValue) => {
    return (c) => {
        if (!isPresent(minValue) || !isPresent(c.value) || c.value >= minValue) {
            return null;
        }
        return {
            minError: {
                minValue: minValue,
                value: c.value
            }
        };
    };
};

/**
 * @hidden
 */
const MIN_DOC_LINK = 'http://www.telerik.com/kendo-angular-ui/components/inputs/api/NumericTextBoxComponent/#toc-min';
/**
 * @hidden
 */
const MAX_DOC_LINK = 'http://www.telerik.com/kendo-angular-ui/components/inputs/api/NumericTextBoxComponent/#toc-max';
/**
 * @hidden
 */
const POINT = ".";
/**
 * @hidden
 */
const INITIAL_SPIN_DELAY = 500;
/**
 * @hidden
 */
const SPIN_DELAY = 50;
/**
 * @hidden
 */
const EXPONENT_REGEX = /[eE][\-+]?([0-9]+)/;

/**
 * @hidden
 */
const numericRegex = (options) => {
    const { autoCorrect, decimals, min } = options;
    let separator = options.separator;
    if (separator === POINT) {
        separator = '\\' + separator;
    }
    const signPattern = autoCorrect && min !== null && min >= 0 ? '' : '-?';
    let numberPattern;
    if (decimals === 0) {
        numberPattern = '\\d*';
    }
    else {
        numberPattern = `(?:(?:\\d+(${separator}\\d*)?)|(?:${separator}\\d*))?`;
    }
    return new RegExp(`^${signPattern}${numberPattern}$`);
};
/**
 * @hidden
 */
const decimalPart = (value) => {
    return value >= 0 ? Math.floor(value) : Math.ceil(value);
};
/**
 * @hidden
 */
const noop = (_) => { }; // tslint:disable-line:no-empty
/**
 * @hidden
 */
const defined = (value) => {
    return typeof value !== 'undefined';
};
/**
 * @hidden
 */
const isNumber = (value) => {
    return !isNaN(value) && value !== null;
};
/**
 * @hidden
 */
function pad(value, digits) {
    const count = digits - String(value).length;
    let result = value;
    if (count > 0) {
        const padString = new Array(count + 1).join("0");
        result = parseFloat(value + padString);
    }
    return result;
}
/**
 * @hidden
 */
const getDeltaFromMouseWheel = (e) => {
    let delta = 0;
    if (e.wheelDelta) {
        delta = e.wheelDelta / 120;
        delta = delta > 0 ? Math.ceil(delta) : Math.floor(delta);
    }
    else if (e.detail) {
        delta = Math.round(-e.detail / 3);
    }
    return delta;
};
/**
 * @hidden
 */
const getCaretPosition = (element) => element.selectionStart;
/**
 * @hidden
 */
const extractSignificantNumericChars = (formattedString, separator) => {
    const significantCharacters = `${separator}0123456789-`;
    return formattedString.split('').reduce((acc, curr) => significantCharacters.includes(curr) ? ++acc : acc, 0);
};

/**
 * @hidden
 */
var ArrowDirection;
(function (ArrowDirection) {
    ArrowDirection[ArrowDirection["Down"] = -1] = "Down";
    ArrowDirection[ArrowDirection["None"] = 0] = "None";
    ArrowDirection[ArrowDirection["Up"] = 1] = "Up";
})(ArrowDirection || (ArrowDirection = {}));

const PARSABLE_OPTIONS = ['min', 'max', 'step', 'decimals'];
const PARSABLE_DEFAULTS = {
    decimals: null,
    max: null,
    min: null,
    step: 1
};
const FOCUSED$2 = 'k-state-focused';
const FORMATTED_VALUE = 'k-formatted-value';
/**
 * Represents the [Kendo UI NumericTextBox component for Angular]({% slug overview_numerictextbox %}).
 */
class NumericTextBoxComponent {
    constructor(intl, renderer, localizationService, injector, ngZone, changeDetector, hostElement) {
        this.intl = intl;
        this.renderer = renderer;
        this.localizationService = localizationService;
        this.injector = injector;
        this.ngZone = ngZone;
        this.changeDetector = changeDetector;
        this.hostElement = hostElement;
        /**
         * @hidden
         */
        this.focusableId = `k-${guid()}`;
        /**
         * Determines whether the NumericTextBox is disabled ([see example]({% slug disabled_numerictextbox %})).
         */
        this.disabled = false;
        /**
         * Determines whether the NumericTextBox is in its read-only state ([see example]({% slug readonly_numerictextbox %})).
         */
        this.readonly = false;
        /**
         * Sets the title of the `input` element of the NumericTextBox.
         */
        this.title = '';
        /**
         * Specifies whether the value will be auto-corrected based on the minimum and maximum values
         * ([see example]({% slug precision_numerictextbox %})).
         */
        this.autoCorrect = false;
        /**
         * Specifies the number of decimals that the user can enter when the input is focused
         * ([see example]({% slug precision_numerictextbox %})).
         */
        this.decimals = null;
        /**
         * Specifies the value that is used to increment or decrement the component value
         * ([see example]({% slug predefinedsteps_numerictextbox %})).
         */
        this.step = 1;
        /**
         * Specifies whether the **Up** and **Down** spin buttons will be rendered
         * ([see example]({% slug spinbuttons_numerictextbox %})).
         */
        this.spinners = true;
        /**
         * Determines whether the built-in minimum or maximum validators are enforced when a form is validated.
         *
         * > The 4.2.0 Angular version introduces the `min` and `max` validation directives. As a result, even if you set `rangeValidation`
         * to `false`, the built-in Angular validators will be executed.
         */
        this.rangeValidation = true;
        /**
         * Specifies the [`tabindex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) of the component.
         */
        this.tabindex = 0;
        /**
         * Determines whether the whole value will be selected when the NumericTextBox is clicked. Defaults to `true`.
         */
        this.selectOnFocus = true;
        /**
         * Specifies the value of the NumericTextBox
         * ([see example]({% slug formats_numerictextbox %})).
         */
        this.value = null;
        /**
         * Fires each time the user selects a new value ([see example]({% slug overview_numerictextbox %}#toc-events)).
         */
        this.valueChange = new EventEmitter();
        /**
         * Fires each time the user focuses the `input` element ([see example]({% slug overview_numerictextbox %}#toc-events)).
         */
        this.onFocus = new EventEmitter();
        /**
         * Fires each time the `input` element gets blurred ([see example]({% slug overview_numerictextbox %}#toc-events)).
         */
        this.onBlur = new EventEmitter();
        /**
         * @hidden
         */
        this.ArrowDirection = ArrowDirection;
        /**
         * @hidden
         */
        this.arrowDirection = ArrowDirection.None;
        this.inputValue = '';
        this.minValidateFn = noop;
        this.maxValidateFn = noop;
        this._format = "n2";
        this.isPasted = false;
        this.mouseDown = false;
        this.ngChange = noop;
        this.ngTouched = noop;
        this.ngValidatorChange = noop;
        /**
         * @hidden
         */
        this.increasePress = (e) => {
            this.arrowPress(ArrowDirection.Up, e);
        };
        /**
         * @hidden
         */
        this.decreasePress = (e) => {
            this.arrowPress(ArrowDirection.Down, e);
        };
        /**
         * @hidden
         */
        this.releaseArrow = () => {
            clearTimeout(this.spinTimeout);
            if (this.arrowDirection !== ArrowDirection.None) {
                this.arrowDirection = ArrowDirection.None;
                this.changeDetector.detectChanges();
            }
        };
        /**
         * @hidden
         */
        this.handlePaste = () => {
            this.isPasted = true;
        };
        /**
         * @hidden
         */
        this.handleInput = () => {
            const input = this.numericInput.nativeElement;
            let { selectionStart, selectionEnd, value: inputValue } = input;
            if (this.pressedKey === Keys.NumpadDecimal) {
                inputValue = this.replaceNumpadDotValue();
            }
            if (this.isPasted) {
                inputValue = this.formatInputValue(this.intl.parseNumber(inputValue));
            }
            if (!this.isValid(inputValue)) {
                input.value = this.inputValue;
                this.setSelection(selectionStart - 1, selectionEnd - 1);
                return;
            }
            const parsedValue = this.intl.parseNumber(inputValue);
            let value = this.restrictDecimals(parsedValue);
            if (this.autoCorrect) {
                const limited = this.limitInputValue(value);
                value = limited.value;
                selectionStart = limited.selectionStart;
                selectionEnd = limited.selectionEnd;
            }
            if (parsedValue !== value || this.hasTrailingZeros(inputValue) || !this.focused) {
                this.setInputValue(value);
                this.setSelection(selectionStart, selectionEnd);
            }
            else {
                this.inputValue = inputValue;
            }
            if (this.isPasted) {
                input.value = this.inputValue;
            }
            this.updateValue(value);
            this.previousSelection = null;
            this.isPasted = false;
        };
        /**
         * @hidden
         */
        this.handleDragEnter = () => {
            if (!this.focused && !this.isDisabled) {
                this.setInputValue(this.value, true);
            }
        };
        /**
         * @hidden
         */
        this.handleMouseDown = () => {
            this.mouseDown = true;
        };
        /**
         * @hidden
         */
        this.handleFocus = () => {
            if (!this.focused) {
                this.focused = true;
                if (!this.isDisabled) {
                    const shouldSelectAll = this.selectOnFocus || !this.mouseDown;
                    this.ngZone.runOutsideAngular(() => {
                        setTimeout(() => {
                            if (shouldSelectAll) {
                                this.selectAll();
                            }
                            else {
                                this.selectCaret();
                            }
                        }, 0);
                    });
                }
            }
            this.mouseDown = false;
            if (hasObservers(this.onFocus)) {
                this.ngZone.run(() => {
                    this.onFocus.emit();
                });
            }
        };
        /**
         * @hidden
         */
        this.handleBlur = () => {
            this.changeDetector.markForCheck();
            this.focused = false;
            //blur is thrown before input when dragging the input text in IE
            if (this.inputValue !== this.elementValue) {
                this.handleInput();
            }
            this.setInputValue();
            if (hasObservers(this.onBlur) || requiresZoneOnBlur(this.control)) {
                this.ngZone.run(() => {
                    this.ngTouched();
                    this.onBlur.emit();
                });
            }
        };
        /**
         * @hidden
         */
        this.handleKeyDown = (e) => {
            if (this.isDisabled) {
                return;
            }
            let step;
            if (e.keyCode === Keys.ArrowDown) {
                step = -1;
            }
            else if (e.keyCode === Keys.ArrowUp) {
                step = 1;
            }
            if (step && this.step) {
                e.preventDefault();
                this.addStep(step);
            }
            const input = this.numericInput.nativeElement;
            this.previousSelection = {
                end: input.selectionEnd,
                start: input.selectionStart
            };
            this.pressedKey = e.keyCode;
        };
        /**
         * @hidden
         */
        this.handleWheel = (e) => {
            if (this.focused && !this.isDisabled) {
                e.preventDefault();
                const delta = getDeltaFromMouseWheel(e);
                this.addStep(delta);
            }
        };
        this.direction = localizationService.rtl ? 'rtl' : 'ltr';
    }
    /**
     * Specifies the number format which is used when the NumericTextBox is not focused
     * ([see example]({% slug formats_numerictextbox %})).
     * If `format` is set to `null` or `undefined`, the default format will be used.
     */
    get format() {
        const format = this._format;
        return format !== null && format !== undefined ? format : 'n2';
    }
    set format(value) {
        this._format = value;
    }
    /**
     * @hidden
     */
    set tabIndex(tabIndex) {
        this.tabindex = tabIndex;
    }
    get tabIndex() {
        return this.tabindex;
    }
    get widgetClasses() {
        return true;
    }
    ngOnInit() {
        this.subscriptions = this.localizationService
            .changes
            .subscribe(({ rtl }) => {
            this.direction = rtl ? 'rtl' : 'ltr';
        });
        this.subscriptions.add(this.intl.changes.subscribe(this.intlChange.bind(this)));
        if (this.hostElement) {
            this.renderer.removeAttribute(this.hostElement.nativeElement, "tabindex");
        }
        this.control = this.injector.get(NgControl, null);
    }
    /**
     * @hidden
     */
    ngOnChanges(changes) {
        if (anyChanged(PARSABLE_OPTIONS, changes, false)) {
            this.parseOptions(PARSABLE_OPTIONS.filter(option => changes[option]));
        }
        this.verifySettings();
        if (anyChanged(['min', 'max', 'rangeValidation'], changes, false)) {
            this.minValidateFn = this.rangeValidation ? createMinValidator(this.min) : noop;
            this.maxValidateFn = this.rangeValidation ? createMaxValidator(this.max) : noop;
            this.ngValidatorChange();
        }
        if (anyChanged(['autoCorrect', 'decimals', 'min'], changes)) {
            delete this.numericRegex;
        }
        if (anyChanged(['value', 'format'], changes, false)) {
            this.verifyValue(this.value);
            this.value = this.restrictModelValue(this.value);
            if (!this.focused || (this.intl.parseNumber(this.elementValue) !== this.value)) {
                this.setInputValue();
            }
        }
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
        clearTimeout(this.spinTimeout);
    }
    /**
     * @hidden
     */
    validate(control) {
        return this.minValidateFn(control) || this.maxValidateFn(control);
    }
    /**
     * @hidden
     */
    registerOnValidatorChange(fn) {
        this.ngValidatorChange = fn;
    }
    /**
     * @hidden
     */
    writeValue(value) {
        this.verifyValue(value);
        let restrictedValue = this.restrictModelValue(value);
        this.value = restrictedValue;
        this.setInputValue();
    }
    /**
     * @hidden
     */
    registerOnChange(fn) {
        this.ngChange = fn;
    }
    /**
     * @hidden
     */
    registerOnTouched(fn) {
        this.ngTouched = fn;
    }
    /**
     * @hidden
     * Called when the status of the component changes to or from `disabled`.
     * Depending on the value, it enables or disables the appropriate DOM element.
     *
     * @param isDisabled
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * Focuses the NumericTextBox.
     *
     * @example
     * ```ts-no-run
     * _@Component({
     * selector: 'my-app',
     * template: `
     *  <button (click)="numerictextbox.focus()">Focus NumericTextBox</button>
     *  <kendo-numerictextbox #numerictextbox></kendo-numerictextbox>
     * `
     * })
     * class AppComponent { }
     * ```
     */
    focus() {
        invokeElementMethod(this.numericInput, 'focus');
    }
    /**
     * Blurs the NumericTextBox.
     */
    blur() {
        invokeElementMethod(this.numericInput, 'blur');
    }
    /**
     * Notifies the `NumericTextBoxComponent` that the input value should be changed.
     * Can be used to update the input after setting the component properties directly.
     */
    notifyValueChange() {
        this.setInputValue();
    }
    /**
     * @hidden
     */
    get incrementTitle() {
        return this.localizationService.get('increment');
    }
    /**
     * @hidden
     */
    get decrementTitle() {
        return this.localizationService.get('decrement');
    }
    get decimalSeparator() {
        const numberSymbols = this.intl.numberSymbols();
        return numberSymbols.decimal;
    }
    get elementValue() {
        return this.numericInput.nativeElement.value;
    }
    set elementValue(value) {
        this.renderer.setProperty(this.numericInput.nativeElement, 'value', value);
    }
    get focused() {
        return this.isFocused;
    }
    get hasDecimals() {
        return this.decimals !== null && this.decimals >= 0;
    }
    set focused(value) {
        if (this.isFocused !== value && this.numericWrap) {
            const wrap = this.numericWrap.nativeElement;
            const input = this.numericInput.nativeElement;
            if (value) {
                this.renderer.addClass(wrap, FOCUSED$2);
                if (!this.isDisabled) {
                    this.renderer.removeClass(input, FORMATTED_VALUE);
                }
            }
            else {
                this.renderer.removeClass(wrap, FOCUSED$2);
                this.renderer.addClass(input, FORMATTED_VALUE);
            }
            this.isFocused = value;
        }
    }
    get isDisabled() {
        return this.disabled || this.readonly;
    }
    arrowPress(direction, e) {
        e.preventDefault();
        if (this.isDisabled) {
            return;
        }
        if (!mobileOS) {
            this.focused = true;
            this.focus();
        }
        if (this.arrowDirection !== direction) {
            this.arrowDirection = direction;
            this.changeDetector.detectChanges();
        }
        if (this.step) {
            this.spin(direction, INITIAL_SPIN_DELAY);
        }
        else {
            this.setInputValue();
        }
    }
    updateValue(value) {
        if (!areSame(this.value, value)) {
            this.ngZone.run(() => {
                this.value = value;
                this.ngChange(value);
                this.valueChange.emit(value);
                this.changeDetector.markForCheck();
            });
        }
    }
    replaceNumpadDotValue() {
        let value = this.inputValue || "";
        if (this.previousSelection) {
            const input = this.numericInput.nativeElement;
            const { selectionStart, selectionEnd } = input;
            const { start, end } = this.previousSelection;
            input.value = value = value.substring(0, start) + this.decimalSeparator + value.substring(end);
            this.setSelection(selectionStart, selectionEnd);
        }
        return value;
    }
    isValid(value) {
        if (!this.numericRegex) {
            this.numericRegex = numericRegex({
                autoCorrect: this.autoCorrect,
                decimals: this.decimals,
                min: this.min,
                separator: this.decimalSeparator
            });
        }
        return this.numericRegex.test(value);
    }
    spin(step, timeout) {
        clearTimeout(this.spinTimeout);
        this.spinTimeout = window.setTimeout(() => {
            this.spin(step, SPIN_DELAY);
        }, timeout);
        this.addStep(step);
    }
    addStep(step) {
        let value = add(this.value || 0, this.step * step);
        value = this.limitValue(value);
        value = this.restrictDecimals(value);
        this.setInputValue(value);
        this.updateValue(value);
    }
    setSelection(start, end) {
        if (this.focused) {
            invokeElementMethod(this.numericInput, 'setSelectionRange', start, end);
        }
    }
    limitValue(value) {
        let result = value;
        if (!this.isInRange(value)) {
            if (isNumber(this.max) && value > this.max) {
                result = this.max;
            }
            if (isNumber(this.min) && value < this.min) {
                result = this.min;
            }
        }
        return result;
    }
    limitInputValue(value) {
        let { selectionStart, selectionEnd, value: enteredValue } = this.numericInput.nativeElement;
        let limitedValue = value;
        let selectToEnd = false;
        if (!this.isInRange(value)) {
            const lengthChange = enteredValue.length - String(this.inputValue).length;
            const { min, max } = this;
            const hasMax = isNumber(max);
            const hasMin = isNumber(min);
            let padLimit, replaceNext;
            let correctedValue = value;
            if (selectionStart === 0 && this.inputValue.substr(1) === enteredValue) {
                return {
                    selectionEnd: selectionEnd,
                    selectionStart: selectionStart,
                    value: null
                };
            }
            if (hasMax && value > max) {
                if (value > 0) {
                    replaceNext = true;
                }
                else {
                    padLimit = max;
                }
            }
            else if (hasMin && value < min) {
                if (value > 0) {
                    padLimit = min;
                }
                else {
                    replaceNext = true;
                }
            }
            if (padLimit) {
                const paddedValue = this.tryPadValue(value, padLimit);
                if (paddedValue && decimalPart(value) !== decimalPart(padLimit)) {
                    correctedValue = paddedValue;
                    selectToEnd = true;
                }
            }
            else if (replaceNext) {
                if (this.inputValue && selectionStart !== enteredValue.length) {
                    correctedValue = parseFloat(enteredValue.substr(0, selectionStart) +
                        enteredValue.substr(selectionStart + lengthChange));
                }
            }
            limitedValue = this.limitValue(correctedValue);
            selectToEnd = (selectToEnd || limitedValue !== correctedValue) && this.previousSelection &&
                (this.previousSelection.end - this.previousSelection.start + lengthChange) > 0;
        }
        return {
            selectionEnd: selectToEnd ? String(limitedValue).length : selectionEnd,
            selectionStart: selectionStart,
            value: limitedValue
        };
    }
    tryPadValue(value, limit) {
        const limitLength = String(Math.floor(limit)).length;
        const zeroPadded = pad(value, limitLength);
        const zeroPaddedNext = pad(value, limitLength + 1);
        let result;
        if (this.isInRange(zeroPadded)) {
            result = zeroPadded;
        }
        else if (this.isInRange(zeroPaddedNext)) {
            result = zeroPaddedNext;
        }
        return result;
    }
    isInRange(value) {
        return !isNumber(value) || ((!isNumber(this.min) || this.min <= value) && (!isNumber(this.max) || value <= this.max));
    }
    restrictModelValue(value) {
        let result = this.restrictDecimals(value, true);
        if (this.autoCorrect && this.limitValue(result) !== result) {
            result = null;
        }
        return result;
    }
    restrictDecimals(value, round) {
        let result = value;
        if (value && this.hasDecimals) {
            const decimals = this.decimals;
            const stringValue = String(value);
            if (round || EXPONENT_REGEX.test(stringValue)) {
                result = toFixedPrecision(value, decimals);
            }
            else {
                const parts = stringValue.split(POINT);
                let fraction = parts[1];
                if (fraction && fraction.length > decimals) {
                    fraction = fraction.substr(0, decimals);
                    result = parseFloat(`${parts[0]}${POINT}${fraction}`);
                }
            }
        }
        return result;
    }
    formatInputValue(value) {
        let stringValue = String(value);
        const exponentMatch = EXPONENT_REGEX.exec(stringValue);
        if (exponentMatch) {
            stringValue = value.toFixed(limitPrecision(parseInt(exponentMatch[1], 10)));
        }
        return stringValue.replace(POINT, this.decimalSeparator);
    }
    formatValue(value, focused) {
        let formattedValue;
        if (value === null || !defined(value) || value === '') {
            formattedValue = '';
        }
        else if (focused && !this.readonly) {
            formattedValue = this.formatInputValue(value);
        }
        else {
            formattedValue = this.intl.formatNumber(value, this.format);
        }
        return formattedValue;
    }
    setInputValue(value = this.value, focused = this.focused) {
        const formattedValue = this.formatValue(value, focused);
        this.elementValue = formattedValue;
        this.inputValue = formattedValue;
    }
    verifySettings() {
        if (!isDevMode()) {
            return;
        }
        if (this.min !== null && this.max !== null && this.min > this.max) {
            throw new Error(`The max value should be bigger than the min. See ${MIN_DOC_LINK} and ${MAX_DOC_LINK}.`);
        }
    }
    verifyValue(value) {
        if (isDevMode() && value && typeof value !== 'number') {
            throw new Error(`The NumericTextBox component requires value of type Number and ${JSON.stringify(value)} was set.`);
        }
    }
    parseOptions(options) {
        for (let idx = 0; idx < options.length; idx++) {
            const name = options[idx];
            const value = this[name];
            if (typeof value === 'string') {
                const parsed = parseFloat(value);
                const valid = !isNaN(parsed);
                if (isDevMode() && !valid && value !== '') {
                    throw new Error('The NumericTextBox component requires value of type Number or a String representing ' +
                        `a number for the ${name} property and ${JSON.stringify(value)} was set.`);
                }
                this[name] = valid ? parsed : PARSABLE_DEFAULTS[name];
            }
        }
    }
    intlChange() {
        delete this.numericRegex;
        if (this.numericInput && (!this.focused || !this.isValid(this.elementValue))) {
            this.setInputValue();
        }
    }
    hasTrailingZeros(inputValue) {
        if (this.hasDecimals && this.focused) {
            const fraction = inputValue.split(this.decimalSeparator)[1];
            return fraction && fraction.length > this.decimals && fraction.lastIndexOf('0') === fraction.length - 1;
        }
    }
    selectAll() {
        this.setInputValue();
        this.setSelection(0, this.inputValue.length);
    }
    selectCaret() {
        const caretPosition = getCaretPosition(this.numericInput.nativeElement);
        const formattedValue = this.elementValue;
        const partialValue = formattedValue.substring(0, caretPosition);
        this.setInputValue();
        if (partialValue.length) {
            const significantCharsInFormattedValue = extractSignificantNumericChars(partialValue, this.decimalSeparator);
            const adjustedSignificantChars = this.adjustSignificantChars(formattedValue, significantCharsInFormattedValue);
            this.setSelection(adjustedSignificantChars, adjustedSignificantChars);
        }
        else {
            this.setSelection(0, 0);
        }
    }
    numberOfLeadingZeroes(formattedValue) {
        const separatorIndex = formattedValue.indexOf(this.decimalSeparator);
        const matchedLeadingZeroes = formattedValue.match(/^[^1-9]*?(0+)/);
        if (matchedLeadingZeroes) {
            const lengthOfMatch = matchedLeadingZeroes[0].length;
            const lengthOfLeadingZeroesMatch = matchedLeadingZeroes[1].length;
            return lengthOfMatch === separatorIndex ? lengthOfLeadingZeroesMatch - 1 : lengthOfLeadingZeroesMatch;
        }
        return 0;
    }
    adjustSignificantChars(formattedValue, significantChars) {
        const leadingZeroes = this.numberOfLeadingZeroes(formattedValue);
        if (leadingZeroes > 0) {
            return Math.max(0, significantChars - leadingZeroes);
        }
        return significantChars;
    }
}
NumericTextBoxComponent.ɵfac = function NumericTextBoxComponent_Factory(t) { return new (t || NumericTextBoxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.IntlService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NumericTextBoxComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NumericTextBoxComponent, selectors: [["kendo-numerictextbox"]], viewQuery: function NumericTextBoxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c31, true);
        ɵngcc0.ɵɵviewQuery(_c32, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.numericInput = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.numericWrap = _t.first);
    } }, hostVars: 5, hostBindings: function NumericTextBoxComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.direction);
        ɵngcc0.ɵɵclassProp("k-widget", ctx.widgetClasses)("k-numerictextbox", ctx.widgetClasses);
    } }, inputs: { focusableId: "focusableId", disabled: "disabled", readonly: "readonly", title: "title", autoCorrect: "autoCorrect", decimals: "decimals", step: "step", spinners: "spinners", rangeValidation: "rangeValidation", tabindex: "tabindex", selectOnFocus: "selectOnFocus", value: "value", format: "format", tabIndex: "tabIndex", max: "max", min: "min", placeholder: "placeholder" }, outputs: { valueChange: "valueChange", onFocus: "focus", onBlur: "blur" }, exportAs: ["kendoNumericTextBox"], features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            { provide: L10N_PREFIX, useValue: 'kendo.numerictextbox' },
            { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => NumericTextBoxComponent), multi: true },
            { provide: NG_VALIDATORS, useExisting: forwardRef(() => NumericTextBoxComponent), multi: true },
            { provide: KendoInput, useExisting: forwardRef(() => NumericTextBoxComponent) }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 7, vars: 25, consts: [["kendoNumericTextBoxLocalizedMessages", "", 6, "increment", "decrement"], [1, "k-numeric-wrap", 3, "kendoEventsOutsideAngular"], ["numericWrap", ""], ["role", "spinbutton", "autocomplete", "off", "autocorrect", "off", 1, "k-input", "k-formatted-value", 3, "id", "tabindex", "disabled", "readonly", "kendoEventsOutsideAngular"], ["numericInput", ""], ["class", "k-select", 3, "kendoEventsOutsideAngular", 4, "ngIf"], [1, "k-select", 3, "kendoEventsOutsideAngular"], [1, "k-link", "k-link-increase", 3, "kendoEventsOutsideAngular", "title"], [1, "k-icon", "k-i-arrow-n"], [1, "k-link", "k-link-decrease", 3, "kendoEventsOutsideAngular", "title"], [1, "k-icon", "k-i-arrow-s"]], template: function NumericTextBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵi18nAttributes(1, _c37);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementStart(2, "span", 1, 2);
        ɵngcc0.ɵɵelement(4, "input", 3, 4);
        ɵngcc0.ɵɵtemplate(6, NumericTextBoxComponent_span_6_Template, 5, 18, "span", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("k-state-disabled", ctx.disabled);
        ɵngcc0.ɵɵproperty("kendoEventsOutsideAngular", ɵngcc0.ɵɵpureFunction2(14, _c40, ctx.handleWheel, ctx.handleWheel));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("id", ctx.focusableId)("tabindex", ctx.tabIndex)("disabled", ctx.disabled)("readonly", ctx.readonly)("kendoEventsOutsideAngular", ɵngcc0.ɵɵpureFunction7(17, _c41, ctx.handleMouseDown, ctx.handleDragEnter, ctx.handleKeyDown, ctx.handleInput, ctx.handleFocus, ctx.handleBlur, ctx.handlePaste));
        ɵngcc0.ɵɵattribute("aria-valuemin", ctx.min)("aria-valuemax", ctx.max)("aria-valuenow", ctx.value)("title", ctx.title)("placeholder", ctx.placeholder);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.spinners);
    } }, directives: function () { return [LocalizedNumericTextBoxMessagesDirective, ɵngcc2.EventsOutsideAngularDirective, ɵngcc3.NgIf]; }, encapsulation: 2 });
/** @nocollapse */
NumericTextBoxComponent.ctorParameters = () => [
    { type: IntlService },
    { type: Renderer2 },
    { type: LocalizationService },
    { type: Injector },
    { type: NgZone },
    { type: ChangeDetectorRef },
    { type: ElementRef }
];
NumericTextBoxComponent.propDecorators = {
    focusableId: [{ type: Input }],
    disabled: [{ type: Input }],
    readonly: [{ type: Input }],
    title: [{ type: Input }],
    autoCorrect: [{ type: Input }],
    format: [{ type: Input }],
    max: [{ type: Input }],
    min: [{ type: Input }],
    decimals: [{ type: Input }],
    placeholder: [{ type: Input }],
    step: [{ type: Input }],
    spinners: [{ type: Input }],
    rangeValidation: [{ type: Input }],
    tabindex: [{ type: Input }],
    tabIndex: [{ type: Input }],
    selectOnFocus: [{ type: Input }],
    value: [{ type: Input }],
    valueChange: [{ type: Output }],
    onFocus: [{ type: Output, args: ['focus',] }],
    onBlur: [{ type: Output, args: ['blur',] }],
    numericInput: [{ type: ViewChild, args: ['numericInput', { static: true },] }],
    numericWrap: [{ type: ViewChild, args: ['numericWrap',] }],
    direction: [{ type: HostBinding, args: ['attr.dir',] }],
    widgetClasses: [{ type: HostBinding, args: ['class.k-widget',] }, { type: HostBinding, args: ['class.k-numerictextbox',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NumericTextBoxComponent, [{
        type: Component,
        args: [{
                exportAs: 'kendoNumericTextBox',
                providers: [
                    LocalizationService,
                    { provide: L10N_PREFIX, useValue: 'kendo.numerictextbox' },
                    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => NumericTextBoxComponent), multi: true },
                    { provide: NG_VALIDATORS, useExisting: forwardRef(() => NumericTextBoxComponent), multi: true },
                    { provide: KendoInput, useExisting: forwardRef(() => NumericTextBoxComponent) }
                ],
                selector: 'kendo-numerictextbox',
                template: `
        <ng-container kendoNumericTextBoxLocalizedMessages
            i18n-increment="kendo.numerictextbox.increment|The title for the **Increment** button in the NumericTextBox"
            increment="Increase value"
            i18n-decrement="kendo.numerictextbox.decrement|The title for the **Decrement** button in the NumericTextBox"
            decrement="Decrease value"
        >
        </ng-container>
        <span
            class="k-numeric-wrap"
            [class.k-state-disabled]="disabled"
            [kendoEventsOutsideAngular]="{ mousewheel: handleWheel, DOMMouseScroll: handleWheel }"
            #numericWrap>
            <input
            role="spinbutton"
            class="k-input k-formatted-value"
            autocomplete="off"
            autocorrect="off"
            [id]="focusableId"
            [attr.aria-valuemin]="min"
            [attr.aria-valuemax]="max"
            [attr.aria-valuenow]="value"
            [attr.title]="title"
            [attr.placeholder]="placeholder"
            [tabindex]="tabIndex"
            [disabled]="disabled"
            [readonly]="readonly"
            [kendoEventsOutsideAngular]="{
                mousedown: handleMouseDown,
                dragenter: handleDragEnter,
                keydown: handleKeyDown,
                input: handleInput,
                focus: handleFocus,
                blur: handleBlur,
                paste: handlePaste
            }"
            #numericInput />
            <span class="k-select" *ngIf="spinners" [kendoEventsOutsideAngular]="{ mouseup: releaseArrow, mouseleave: releaseArrow }">
                <span
                    [kendoEventsOutsideAngular]="{ mousedown: increasePress }"
                    [attr.aria-label]="incrementTitle"
                    [title]="incrementTitle"
                    [class.k-state-active]="arrowDirection === ArrowDirection.Up"
                    class="k-link k-link-increase"
                >
                    <span class="k-icon k-i-arrow-n"></span>
                </span>
                <span
                    [kendoEventsOutsideAngular]="{ mousedown: decreasePress }"
                    [attr.aria-label]="decrementTitle"
                    [title]="decrementTitle"
                    [class.k-state-active]="arrowDirection === ArrowDirection.Down"
                    class="k-link k-link-decrease"
                >
                    <span class="k-icon k-i-arrow-s"></span>
                </span>
            </span>
        </span>
      `
            }]
    }], function () { return [{ type: ɵngcc4.IntlService }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc1.LocalizationService }, { type: ɵngcc0.Injector }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }]; }, { focusableId: [{
            type: Input
        }], disabled: [{
            type: Input
        }], readonly: [{
            type: Input
        }], title: [{
            type: Input
        }], autoCorrect: [{
            type: Input
        }], decimals: [{
            type: Input
        }], step: [{
            type: Input
        }], spinners: [{
            type: Input
        }], rangeValidation: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], selectOnFocus: [{
            type: Input
        }], value: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], onFocus: [{
            type: Output,
            args: ['focus']
        }], onBlur: [{
            type: Output,
            args: ['blur']
        }], direction: [{
            type: HostBinding,
            args: ['attr.dir']
        }], format: [{
            type: Input
        }], tabIndex: [{
            type: Input
        }], widgetClasses: [{
            type: HostBinding,
            args: ['class.k-widget']
        }, {
            type: HostBinding,
            args: ['class.k-numerictextbox']
        }], max: [{
            type: Input
        }], min: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], numericInput: [{
            type: ViewChild,
            args: ['numericInput', { static: true }]
        }], numericWrap: [{
            type: ViewChild,
            args: ['numericWrap']
        }] }); })();

/**
 * @hidden
 */
class NumericTextBoxMessages extends ComponentMessages {
}
NumericTextBoxMessages.ɵfac = function NumericTextBoxMessages_Factory(t) { return ɵNumericTextBoxMessages_BaseFactory(t || NumericTextBoxMessages); };
NumericTextBoxMessages.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NumericTextBoxMessages, inputs: { decrement: "decrement", increment: "increment" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
NumericTextBoxMessages.propDecorators = {
    decrement: [{ type: Input }],
    increment: [{ type: Input }]
};
const ɵNumericTextBoxMessages_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(NumericTextBoxMessages);

/**
 * Custom component messages override default component messages.
 */
class NumericTextBoxCustomMessagesComponent extends NumericTextBoxMessages {
    constructor(service) {
        super();
        this.service = service;
    }
    get override() {
        return true;
    }
}
NumericTextBoxCustomMessagesComponent.ɵfac = function NumericTextBoxCustomMessagesComponent_Factory(t) { return new (t || NumericTextBoxCustomMessagesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
NumericTextBoxCustomMessagesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NumericTextBoxCustomMessagesComponent, selectors: [["kendo-numerictextbox-messages"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NumericTextBoxMessages,
                useExisting: forwardRef(() => NumericTextBoxCustomMessagesComponent) // tslint:disable-line:no-forward-ref
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function NumericTextBoxCustomMessagesComponent_Template(rf, ctx) { }, encapsulation: 2 });
/** @nocollapse */
NumericTextBoxCustomMessagesComponent.ctorParameters = () => [
    { type: LocalizationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NumericTextBoxCustomMessagesComponent, [{
        type: Component,
        args: [{
                providers: [
                    {
                        provide: NumericTextBoxMessages,
                        useExisting: forwardRef(() => NumericTextBoxCustomMessagesComponent) // tslint:disable-line:no-forward-ref
                    }
                ],
                selector: 'kendo-numerictextbox-messages',
                template: ``
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }]; }, null); })();

/**
 * @hidden
 */
var ResultType;
(function (ResultType) {
    ResultType[ResultType["Literal"] = 0] = "Literal";
    ResultType[ResultType["Mask"] = 1] = "Mask";
    ResultType[ResultType["Undefined"] = 2] = "Undefined";
})(ResultType || (ResultType = {}));
/**
 * @hidden
 */
class Result {
    constructor(value, rest, type = ResultType.Undefined) {
        this.value = value;
        this.rest = rest;
        this.type = type;
    }
    //map :: Functor f => f a ~> (a -> b) -> f b
    map(fn) {
        return new Result(fn(this.value), this.rest);
    }
    //chain :: Chain m => m a ~> (a -> m b) -> m b
    chain(fn) {
        return fn(this.value, this.rest);
    }
    fold(s, _ /*we don't need it*/) {
        return s(this.value, this.rest);
    }
    concat(r) {
        return this.map((vs, _) => r.chain((v, __) => vs.concat([v])));
    }
    toString() {
        return `Result({ value: '${this.value}', rest: ${this.rest} })`;
    }
}

/**
 * @hidden
 */
class Stream {
    constructor(input = [], control = []) {
        this.input = input;
        this.control = control;
        this.inputCursor = 0;
        this.controlCursor = 0;
    }
    eof() {
        return this.inputCursor >= this.input.length;
    }
    // Get the first value from the input.
    next() {
        return {
            char: this.input[this.inputCursor++],
            control: this.control[this.controlCursor++]
        };
    }
    peek() {
        return {
            char: this.input[this.inputCursor],
            control: this.control[this.controlCursor]
        };
    }
    eat_input() {
        this.inputCursor++;
    }
    eat_control() {
        this.controlCursor++;
    }
    eat() {
        this.inputCursor++;
        this.controlCursor++;
    }
}

const toArray = (value) => (value || '').split('');
const ESCAPE_CHARACTER = '\\';
/**
 * @hidden
 */
class Parser {
    constructor(parse) {
        this.parse = parse;
    }
    run(input, control = '') {
        if (input instanceof Stream) {
            return this.parse(input);
        }
        else {
            return this.parse(new Stream(toArray(input), toArray(control)));
        }
    }
    //map :: Functor f => f a ~> (a -> b) -> f b
    map(f) {
        return new Parser(stream => this.parse(stream).map(f));
    }
    //chain :: Chain m => m a ~> (a -> m b) -> m b
    chain(f) {
        return new Parser(stream => this.parse(stream).chain((v, s) => f(v).run(s)));
    }
    isLiteral(c) {
        return this.run(c).type === ResultType.Literal;
    }
}
/**
 * @hidden
 */
const mask = ({ prompt, promptPlaceholder }) => rule => new Parser(stream => {
    while (!stream.eof()) {
        const { char, control } = stream.peek();
        if (char === control && control === prompt) {
            stream.eat();
            return new Result(prompt, stream, ResultType.Mask);
        }
        if (rule.test(char)) {
            stream.eat();
            return new Result(char, stream, ResultType.Mask);
        }
        if (char === promptPlaceholder) {
            stream.eat();
            return new Result(prompt, stream, ResultType.Mask);
        }
        stream.eat_input();
    }
    stream.eat();
    return new Result(prompt, stream, ResultType.Mask);
});
/**
 * @hidden
 */
const literal = _token => new Parser(stream => {
    //    let {char, control} = stream.peek();
    let char = stream.peek().char;
    if (char === _token) {
        stream.eat();
        return new Result(_token, stream, ResultType.Literal);
    }
    //    if (control === _token) {
    //        while (!stream.eof() && char !== _token) {
    //            stream.eat_input();
    //            char = stream.peek().char;
    //        }
    //    }
    //
    //    if (control !== undefined) {
    //        stream.eat();
    //    }
    return new Result(_token, stream, ResultType.Literal);
});
/**
 * @hidden
 */
const unmask = prompt => rule => new Parser(stream => {
    while (!stream.eof()) {
        const { char, control } = stream.peek();
        if (char === prompt && control === prompt) {
            stream.eat();
            return new Result(char, stream);
        }
        if (rule.test(char)) {
            stream.eat();
            return new Result(char, stream);
        }
        stream.eat_input();
    }
    stream.eat();
    return new Result('', stream);
});
/**
 * @hidden
 */
const unliteral = _token => new Parser(stream => {
    if (stream.eof()) {
        return new Result('', stream);
    }
    const { char } = stream.peek();
    if (char === _token) {
        stream.eat();
    }
    return new Result(_token, stream);
});
/**
 * @hidden
 */
const token = (rules, creator) => new Parser(stream => {
    let { char } = stream.next();
    const rule = rules[char];
    if (char === ESCAPE_CHARACTER) {
        char = stream.next().char;
        return new Result(creator.literal(char), stream);
    }
    if (!rule) {
        return new Result(creator.literal(char), stream);
    }
    return new Result(creator.mask(rule), stream);
});
/**
 * @hidden
 */
const rawMask = ({ prompt, promptPlaceholder }) => new Parser(stream => {
    let { char } = stream.next();
    if (char === prompt) {
        return new Result(promptPlaceholder, stream);
    }
    return new Result(char, stream);
});
/**
 * @hidden
 */
const rawLiteral = includeLiterals => new Parser(stream => {
    let { char } = stream.next();
    if (includeLiterals) {
        return new Result(char, stream);
    }
    return new Result('', stream);
});

/**
 * @hidden
 */
const always = value => new Parser(stream => new Result(value, stream));
/**
 * @hidden
 */
const append = (p1, p2) => p1.chain(vs => p2.map(v => vs.concat([v])));
/**
 * @hidden
 */
const sequence = list => list.reduce((acc, parser) => append(acc, parser), always([]));
/**
 * @hidden
 */
const greedy = parser => new Parser(stream => {
    let result = new Result([], stream);
    while (!stream.eof()) {
        result = result.concat(parser.run(stream));
    }
    return result;
});

/**
 * @hidden
 */
class MaskingService {
    constructor() {
        this.rules = {};
        this.prompt = "_";
        this.mask = "";
        this.promptPlaceholder = " ";
        this.includeLiterals = false;
        this.maskTokens = [];
        this.unmaskTokens = [];
        this.rawTokens = [];
        this.validationTokens = [];
    }
    update({ mask: mask$$1 = '', prompt = '', promptPlaceholder = ' ', rules = {}, includeLiterals = false }) {
        this.mask = mask$$1;
        this.prompt = prompt;
        this.promptPlaceholder = promptPlaceholder;
        this.rules = rules;
        this.includeLiterals = includeLiterals;
        this.tokenize();
    }
    validationValue(maskedValue = '') {
        let value = maskedValue;
        sequence(this.validationTokens)
            .run(maskedValue)
            .fold(unmasked => {
            value = unmasked.join('');
        });
        return value;
    }
    rawValue(maskedValue = '') {
        let value = maskedValue;
        if (!this.rawTokens.length) {
            return value;
        }
        sequence(this.rawTokens)
            .run(maskedValue)
            .fold(unmasked => {
            value = unmasked.join('');
        });
        return value;
    }
    /**
     * @hidden
     */
    maskRaw(rawValue = '') {
        let value = rawValue;
        if (!this.maskTokens.length) {
            return value;
        }
        sequence(this.maskTokens)
            .run(rawValue)
            .fold(masked => {
            value = masked.join('');
        });
        return value;
    }
    maskInput(input, control, splitPoint) {
        if (input.length < control.length) {
            return this.maskRemoved(input, control, splitPoint);
        }
        return this.maskInserted(input, control, splitPoint);
    }
    maskInRange(pasted, oldValue, start, end) {
        let value = '';
        let selection = end;
        const beforeChange = oldValue.split('').slice(0, start);
        const afterChange = oldValue.split('').slice(end);
        sequence(this.maskTokens.slice(start, end))
            .run(pasted)
            .fold(masked => {
            value = beforeChange
                .concat(masked)
                .concat(afterChange)
                .join('');
        });
        return {
            selection,
            value
        };
    }
    maskRemoved(input, control, splitPoint) {
        let value = '';
        let selection = splitPoint;
        const unchanged = input.split('').slice(splitPoint);
        const changed = input.split('').slice(0, splitPoint).join('');
        const take$$1 = this.maskTokens.length - (input.length - splitPoint);
        sequence(this.maskTokens.slice(0, take$$1))
            .run(changed, control)
            .fold(masked => {
            selection = this.adjustPosition(masked, selection);
            value = masked.concat(unchanged).join('');
        });
        return {
            selection,
            value
        };
    }
    adjustPosition(input, selection) {
        const caretChar = input[selection];
        const isLiteral = this.maskTokens[selection].isLiteral(caretChar);
        if (!isLiteral && caretChar !== this.prompt) {
            return selection + 1;
        }
        return selection;
    }
    maskInserted(input, control, splitPoint) {
        let value = '';
        let selection = splitPoint;
        const changed = input.slice(0, splitPoint);
        sequence(this.unmaskTokens)
            .run(changed, control)
            .chain(unmasked => {
            selection = unmasked.join('').length;
            const unchanged = control.slice(selection);
            return sequence(this.maskTokens)
                .run(unmasked.join('') + unchanged, control);
        })
            .fold(masked => {
            value = masked.join('');
        });
        return {
            selection,
            value
        };
    }
    get maskTokenCreator() {
        const { prompt, promptPlaceholder } = this;
        return {
            literal: rule => literal(rule),
            mask: rule => mask({ prompt, promptPlaceholder })(rule)
        };
    }
    get unmaskTokenCreator() {
        return {
            literal: rule => unliteral(rule),
            mask: rule => unmask(this.prompt)(rule)
        };
    }
    get rawTokenCreator() {
        const { prompt, promptPlaceholder, includeLiterals } = this;
        return {
            literal: _ => rawLiteral(includeLiterals),
            mask: _ => rawMask({ prompt, promptPlaceholder })
        };
    }
    get validationTokenCreator() {
        const { prompt } = this;
        return {
            literal: _ => rawLiteral(false),
            mask: _ => rawMask({ prompt, promptPlaceholder: '' })
        };
    }
    tokenize() {
        greedy(token(this.rules, this.maskTokenCreator))
            .run(this.mask)
            .fold((tokens, _) => {
            this.maskTokens = tokens;
        });
        greedy(token(this.rules, this.unmaskTokenCreator))
            .run(this.mask)
            .fold((tokens, _) => {
            this.unmaskTokens = tokens;
        });
        greedy(token(this.rules, this.rawTokenCreator))
            .run(this.mask)
            .fold((tokens, _) => {
            this.rawTokens = tokens;
        });
        greedy(token(this.rules, this.validationTokenCreator))
            .run(this.mask)
            .fold((tokens, _) => {
            this.validationTokens = tokens;
        });
    }
}
MaskingService.ɵfac = function MaskingService_Factory(t) { return new (t || MaskingService)(); };
MaskingService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: MaskingService, factory: MaskingService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MaskingService, [{
        type: Injectable
    }], function () { return []; }, null); })();

const resolvedPromise = Promise.resolve(null);
const FOCUSED$3 = 'k-state-focused';
/**
 * Represents the [Kendo UI MaskedTextBox component for Angular]({% slug overview_maskedtextbox %}).
 *
 * @example
 * ```ts-no-run
 *
 * _@Component({
 *     selector: 'my-app',
 *     template: `
 *      <kendo-maskedtextbox
 *          [mask]="mask"
 *          [value]="value">
 *      </kendo-maskedtextbox>
 *     `
 * })
 *
 * class AppComponent {
 *  public value: string = "9580128055807792";
 *  public mask: string = "0000-0000-0000-0000";
 * }
 * ```
 */
class MaskedTextBoxComponent {
    constructor(service, renderer, hostElement, ngZone, injector, changeDetector, rtl) {
        this.service = service;
        this.renderer = renderer;
        this.hostElement = hostElement;
        this.ngZone = ngZone;
        this.injector = injector;
        this.changeDetector = changeDetector;
        /**
         * @hidden
         */
        this.focusableId = `k-${guid()}`;
        /**
         * Determines whether the MaskedTextBox is disabled ([see example]({% slug disabled_maskedtextbox %})).
         */
        this.disabled = false;
        /**
         * Determines whether the MaskedTextBox is in its read-only state ([see example]({% slug readonly_maskedtextbox %})).
         */
        this.readonly = false;
        this.hostClasses = true;
        /**
         * Represents a prompt character for the masked value.
         * @default `_`
         */
        this.prompt = '_';
        /**
         * Indicates a character which represents an empty position in the raw value.
         * @default ' '
         */
        this.promptPlaceholder = ' ';
        /**
         * Indicates whether to include literals in the raw value  ([see example]({% slug value_maskedtextbox %})).
         * @default false
         */
        this.includeLiterals = false;
        /**
         * Specifies if the mask should be shown on focus for empty value.
         */
        this.maskOnFocus = false;
        /**
         * Determines whether the built-in mask validator is enforced when a form is validated
         * ([see example]({% slug validation_maskedtextbox %})).
         * @default true
         */
        this.maskValidation = true;
        /**
         * Specifies the [`tabindex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) of the component.
         */
        this.tabindex = 0;
        /**
         * Fires each time the user focuses the `input` element.
         *
         * > To wire the event programmatically, use the `onFocus` property.
         *
         * @example
         * ```ts-no-run
         * _@Component({
         * selector: 'my-app',
         * template: `
         *  <kendo-maskedtextbox (focus)="handleFocus()"></kendo-maskedtextbox>
         * `
         * })
         * class AppComponent {
         *   public handleFocus(): void {
         *      console.log("Component is focused");
         *   }
         * }
         * ```
         */
        this.onFocus = new EventEmitter(); //tslint:disable-line:no-output-rename
        /**
         * Fires each time the `input` element gets blurred.
         *
         * > To wire the event programmatically, use the `onBlur` property.
         *
         * @example
         * ```ts-no-run
         * _@Component({
         * selector: 'my-app',
         * template: `
         *  <kendo-maskedtextbox (blur)="handleBlur()"></kendo-maskedtextbox>
         * `
         * })
         * class AppComponent {
         *   public handleBlur(): void {
         *      console.log("Component is blurred");
         *   }
         * }
         * ```
         */
        this.onBlur = new EventEmitter(); //tslint:disable-line:no-output-rename
        /**
         * Fires each time the value changes.
         */
        this.valueChange = new EventEmitter();
        this.focusClick = false;
        this.defaultRules = {
            "#": /[\d\s\+\-]/,
            "&": /[\S]/,
            "0": /[\d]/,
            "9": /[\d\s]/,
            "?": /[a-zA-Z\s]/,
            "A": /[a-zA-Z0-9]/,
            "C": /./,
            "L": /[a-zA-Z]/,
            "a": /[a-zA-Z0-9\s]/
        };
        this.isPasted = false;
        this.selection = [0, 0];
        /**
         * @hidden
         */
        this.handleFocus = () => {
            this.focused = true;
            if (this.maskOnFocus && this.emptyMask) {
                this.updateInput(this.service.maskRaw(this.value));
                this.ngZone.runOutsideAngular(() => {
                    setTimeout(() => { this.setSelection(0, 0); }, 0);
                });
            }
            if (hasObservers(this.onFocus)) {
                this.ngZone.run(() => {
                    this.onFocus.emit();
                });
            }
        };
        /**
         * @hidden
         */
        this.handleClick = () => {
            if (this.focused && !this.focusClick) {
                this.focusClick = true;
                const { selectionStart, selectionEnd } = this.input.nativeElement;
                if (selectionStart === selectionEnd) {
                    this.setFocusSelection();
                }
            }
        };
        /**
         * @hidden
         */
        this.handleBlur = () => {
            this.changeDetector.markForCheck();
            this.focused = false;
            this.focusClick = false;
            if (this.maskOnFocus && this.emptyMask) {
                this.updateInput(this.maskedValue);
            }
            if (hasObservers(this.onBlur) || requiresZoneOnBlur(this.control)) {
                this.ngZone.run(() => {
                    this.onTouched();
                    this.onBlur.emit();
                });
            }
        };
        this.onChange = (_) => { };
        this.onTouched = () => { };
        this.direction = rtl ? 'rtl' : 'ltr';
        this.updateService();
    }
    get hostDisabledClass() {
        return this.disabled;
    }
    /**
     * Exposes the RegExp-based mask validation array ([see example]({% slug masks_maskedtextbox %})).
     */
    get rules() {
        return this._rules || this.defaultRules;
    }
    set rules(value) {
        this._rules = Object.assign({}, this.defaultRules, value);
    }
    /**
     * @hidden
     */
    set tabIndex(tabIndex) {
        this.tabindex = tabIndex;
    }
    get tabIndex() {
        return this.tabindex;
    }
    ngOnInit() {
        if (this.hostElement) {
            this.renderer.removeAttribute(this.hostElement.nativeElement, "tabindex");
        }
        this.control = this.injector.get(NgControl, null);
    }
    /**
     * @hidden
     * Used by the TextBoxContainer to determine if the MaskedTextBox is empty.
     */
    isEmpty() {
        if (this.input) {
            return !Boolean(this.input.nativeElement.value);
        }
    }
    /**
     * @hidden
     */
    handleDragDrop() {
        return false;
    }
    /**
     * Focuses the MaskedTextBox.
     *
     * @example
     * ```ts-no-run
     * _@Component({
     * selector: 'my-app',
     * template: `
     *  <button (click)="maskedinput.focus()">Focus the input</button>
     *  <kendo-maskedtextbox #maskedinput></kendo-maskedtextbox>
     * `
     * })
     * class AppComponent { }
     * ```
     */
    focus() {
        if (!this.input) {
            return;
        }
        this.input.nativeElement.focus();
        this.setFocusSelection();
    }
    /**
     * Blurs the MaskedTextBox.
     */
    blur() {
        if (!this.input) {
            return;
        }
        this.input.nativeElement.blur();
    }
    /**
     * @hidden
     */
    pasteHandler(e) {
        const { selectionStart, selectionEnd } = e.target;
        if (selectionEnd === selectionStart) {
            return;
        }
        this.isPasted = true;
        this.selection = [selectionStart, selectionEnd];
    }
    /**
     * @hidden
     */
    inputHandler(e) {
        const value = e.target.value;
        const [start, end] = this.selection;
        if (!this.mask) {
            this.updateValue(value);
            this.isPasted = false;
            return;
        }
        let result;
        if (this.isPasted) {
            this.isPasted = false;
            const rightPart = this.maskedValue.length - end;
            const to = value.length - rightPart;
            result = this.service.maskInRange(value.slice(start, to), this.maskedValue, start, end);
        }
        else {
            result = this.service.maskInput(value, this.maskedValue, e.target.selectionStart);
        }
        this.updateInput(result.value, result.selection);
        this.updateValue(result.value);
    }
    /**
     * @hidden
     */
    ngOnChanges(changes) {
        if (changes.value) {
            this.value = this.normalizeValue();
        }
        if (!this.mask) {
            this.updateInput(this.value);
            return;
        }
        const next = this.extractChanges(changes);
        this.updateService(next);
        if (isChanged('value', changes)) {
            const maskedValue = this.service.maskRaw(this.value);
            if (maskedValue !== this.maskedValue) {
                this.updateInput(maskedValue);
            }
        }
        else if (anyChanged(['promptPlaceholder', 'includeLiterals'], changes)) {
            resolvedPromise.then(() => {
                this.updateValue(this.maskedValue);
            });
        }
        else {
            this.updateInput(this.service.maskRaw(this.value));
        }
    }
    /**
     * @hidden
     * Writes a new value to the element.
     */
    writeValue(value) {
        this.value = this.normalizeValue(value);
        this.updateInput(this.service.maskRaw(this.value));
    }
    /**
     * @hidden
     * Sets the function that will be called when a `change` event is triggered.
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * @hidden
     * Sets the function that will be called when a `touch` event is triggered.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * @hidden
     * Called when the status of the component changes to or from `disabled`.
     * Depending on the value, it enables or disables the appropriate DOM element.
     *
     * @param isDisabled
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @hidden
     */
    validate(_) {
        if (this.maskValidation === false || !this.mask) {
            return null;
        }
        if (!this.service.validationValue(this.maskedValue)) {
            return null;
        }
        if (this.maskedValue.indexOf(this.prompt) !== -1) {
            return {
                patternError: {
                    mask: this.mask,
                    maskedValue: this.maskedValue,
                    value: this.value
                }
            };
        }
        return null;
    }
    /**
     * @hidden
     */
    updateValue(maskedValue) {
        if (this.mask && !this.service.validationValue(maskedValue)) {
            this.value = '';
        }
        else {
            this.value = this.service.rawValue(maskedValue);
        }
        this.onChange(this.value);
        this.valueChange.emit(this.value);
    }
    updateInput(maskedValue = '', selection) {
        this.maskedValue = maskedValue;
        const value = this.maskOnFocus && !this.focused && this.emptyMask ? '' : maskedValue;
        this.renderer.setProperty(this.input.nativeElement, "value", value);
        if (selection !== undefined) {
            this.setSelection(selection, selection);
        }
    }
    extractChanges(changes) {
        return Object.keys(changes).filter(key => key !== 'rules').reduce((obj, key) => {
            obj[key] = changes[key].currentValue;
            return obj;
        }, {}); // tslint:disable-line:align
    }
    updateService(extra) {
        const config = Object.assign({
            includeLiterals: this.includeLiterals,
            mask: this.mask,
            prompt: this.prompt,
            promptPlaceholder: this.promptPlaceholder,
            rules: this.rules
        }, extra); // tslint:disable-line:align
        this.service.update(config);
    }
    setSelection(start = this.selection[0], end = this.selection[1]) {
        if (this.focused) {
            invokeElementMethod(this.input, 'setSelectionRange', start, end);
        }
    }
    get emptyMask() {
        return this.service.maskRaw() === this.maskedValue;
    }
    setFocusSelection() {
        const selectionStart = this.input.nativeElement.selectionStart;
        const index = this.maskedValue ? this.maskedValue.indexOf(this.prompt) : 0;
        if (index >= 0 && index < selectionStart) {
            this.selection = [index, index];
            this.setSelection();
        }
    }
    get focused() {
        return this.isFocused;
    }
    set focused(value) {
        if (this.isFocused !== value && this.hostElement) {
            const element = this.hostElement.nativeElement;
            if (value) {
                this.renderer.addClass(element, FOCUSED$3);
            }
            else {
                this.renderer.removeClass(element, FOCUSED$3);
            }
            this.isFocused = value;
        }
    }
    normalizeValue(value = this.value) {
        const present = isPresent(value);
        if (present && typeof value !== 'string') {
            if (isDevMode()) {
                throw new Error('The MaskedTextBox component supports only string values.');
            }
            return String(value);
        }
        return present ? value : '';
    }
}
MaskedTextBoxComponent.ɵfac = function MaskedTextBoxComponent_Factory(t) { return new (t || MaskedTextBoxComponent)(ɵngcc0.ɵɵdirectiveInject(MaskingService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(RTL, 8)); };
MaskedTextBoxComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MaskedTextBoxComponent, selectors: [["kendo-maskedtextbox"]], viewQuery: function MaskedTextBoxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c42, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, hostVars: 7, hostBindings: function MaskedTextBoxComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("paste", function MaskedTextBoxComponent_paste_HostBindingHandler($event) { return ctx.pasteHandler($event); })("input", function MaskedTextBoxComponent_input_HostBindingHandler($event) { return ctx.inputHandler($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.direction);
        ɵngcc0.ɵɵclassProp("k-widget", ctx.hostClasses)("k-maskedtextbox", ctx.hostClasses)("k-state-disabled", ctx.hostDisabledClass);
    } }, inputs: { focusableId: "focusableId", disabled: "disabled", readonly: "readonly", prompt: "prompt", promptPlaceholder: "promptPlaceholder", includeLiterals: "includeLiterals", maskOnFocus: "maskOnFocus", maskValidation: "maskValidation", tabindex: "tabindex", rules: "rules", tabIndex: "tabIndex", value: "value", title: "title", mask: "mask" }, outputs: { onFocus: "focus", onBlur: "blur", valueChange: "valueChange" }, exportAs: ["kendoMaskedTextBox"], features: [ɵngcc0.ɵɵProvidersFeature([
            MaskingService,
            {
                multi: true,
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => MaskedTextBoxComponent) /* tslint:disable-line */
            },
            {
                multi: true,
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => MaskedTextBoxComponent) /* tslint:disable-line */
            },
            {
                provide: KendoInput,
                useExisting: forwardRef(() => MaskedTextBoxComponent)
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 12, consts: [["type", "text", "autocomplete", "off", "autocorrect", "off", "autocapitalize", "off", "spellcheck", "false", 1, "k-textbox", 3, "id", "tabindex", "disabled", "readonly", "kendoEventsOutsideAngular"], ["input", ""]], template: function MaskedTextBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "input", 0, 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.focusableId)("tabindex", ctx.tabIndex)("disabled", ctx.disabled)("readonly", ctx.readonly)("kendoEventsOutsideAngular", ɵngcc0.ɵɵpureFunction5(6, _c43, ctx.handleFocus, ctx.handleBlur, ctx.handleClick, ctx.handleDragDrop, ctx.handleDragDrop));
        ɵngcc0.ɵɵattribute("title", ctx.title);
    } }, directives: [ɵngcc2.EventsOutsideAngularDirective], encapsulation: 2 });
/** @nocollapse */
MaskedTextBoxComponent.ctorParameters = () => [
    { type: MaskingService },
    { type: Renderer2 },
    { type: ElementRef },
    { type: NgZone },
    { type: Injector },
    { type: ChangeDetectorRef },
    { type: Boolean, decorators: [{ type: Optional }, { type: Inject, args: [RTL,] }] }
];
MaskedTextBoxComponent.propDecorators = {
    focusableId: [{ type: Input }],
    disabled: [{ type: Input }],
    readonly: [{ type: Input }],
    title: [{ type: Input }],
    direction: [{ type: HostBinding, args: ['attr.dir',] }],
    hostClasses: [{ type: HostBinding, args: ['class.k-widget',] }, { type: HostBinding, args: ['class.k-maskedtextbox',] }],
    hostDisabledClass: [{ type: HostBinding, args: ['class.k-state-disabled',] }],
    mask: [{ type: Input }],
    value: [{ type: Input }],
    rules: [{ type: Input }],
    prompt: [{ type: Input }],
    promptPlaceholder: [{ type: Input }],
    includeLiterals: [{ type: Input }],
    maskOnFocus: [{ type: Input }],
    maskValidation: [{ type: Input }],
    tabindex: [{ type: Input }],
    tabIndex: [{ type: Input }],
    onFocus: [{ type: Output, args: ['focus',] }],
    onBlur: [{ type: Output, args: ['blur',] }],
    valueChange: [{ type: Output }],
    input: [{ type: ViewChild, args: ['input', { static: true },] }],
    pasteHandler: [{ type: HostListener, args: ['paste', ['$event'],] }],
    inputHandler: [{ type: HostListener, args: ['input', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MaskedTextBoxComponent, [{
        type: Component,
        args: [{
                exportAs: 'kendoMaskedTextBox',
                providers: [
                    MaskingService,
                    {
                        multi: true,
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => MaskedTextBoxComponent) /* tslint:disable-line */
                    },
                    {
                        multi: true,
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef(() => MaskedTextBoxComponent) /* tslint:disable-line */
                    },
                    {
                        provide: KendoInput,
                        useExisting: forwardRef(() => MaskedTextBoxComponent)
                    }
                ],
                selector: 'kendo-maskedtextbox',
                template: `
        <input type="text"
            #input
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            class="k-textbox"
            [id]="focusableId"
            [tabindex]="tabIndex"
            [attr.title]="title"
            [disabled]="disabled"
            [readonly]="readonly"
            [kendoEventsOutsideAngular]="{
                focus: handleFocus,
                blur: handleBlur,
                click: handleClick,
                dragstart: handleDragDrop,
                drop: handleDragDrop
            }"
        />
    `
            }]
    }], function () { return [{ type: MaskingService }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.Injector }, { type: ɵngcc0.ChangeDetectorRef }, { type: Boolean, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [RTL]
            }] }]; }, { focusableId: [{
            type: Input
        }], disabled: [{
            type: Input
        }], readonly: [{
            type: Input
        }], hostClasses: [{
            type: HostBinding,
            args: ['class.k-widget']
        }, {
            type: HostBinding,
            args: ['class.k-maskedtextbox']
        }], prompt: [{
            type: Input
        }], promptPlaceholder: [{
            type: Input
        }], includeLiterals: [{
            type: Input
        }], maskOnFocus: [{
            type: Input
        }], maskValidation: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], onFocus: [{
            type: Output,
            args: ['focus']
        }], onBlur: [{
            type: Output,
            args: ['blur']
        }], valueChange: [{
            type: Output
        }], direction: [{
            type: HostBinding,
            args: ['attr.dir']
        }], hostDisabledClass: [{
            type: HostBinding,
            args: ['class.k-state-disabled']
        }], rules: [{
            type: Input
        }], tabIndex: [{
            type: Input
        }], pasteHandler: [{
            type: HostListener,
            args: ['paste', ['$event']]
        }], inputHandler: [{
            type: HostListener,
            args: ['input', ['$event']]
        }], value: [{
            type: Input
        }], title: [{
            type: Input
        }], mask: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: ['input', { static: true }]
        }] }); })();

/* tslint:disable:component-selector */
/**
 * @hidden
 */
class SliderTick {
    constructor(value) {
        this.value = value;
        this.classes = {
            'k-tick': true
        };
    }
}
/**
 * @hidden
 */
class SliderTicksComponent {
    constructor(rtl) {
        this.rtl = rtl;
        this.wrapperClasses = 'k-reset k-slider-items';
        this.ticks = [];
    }
    ngOnChanges(_) {
        this.createTicks();
    }
    createTicks() {
        const count = calculateTicksCount(this.min, this.max, this.step);
        const largeStep = this.largeStep;
        const tickValueProps = {
            max: this.max,
            min: this.min,
            smallStep: this.step
        };
        let result = [];
        for (let i = 0; i < count; i++) {
            result.push(new SliderTick(calculateValueFromTick(i, tickValueProps)));
            if (largeStep && i % largeStep === 0) {
                result[i].large = true;
                result[i].classes['k-tick-large'] = true;
            }
        }
        if (this.rtl || this.vertical) {
            result = result.reverse();
        }
        if (result.length > 0) {
            Object.assign(result[0].classes, this.endTickClasses(true));
            Object.assign(result[result.length - 1].classes, this.endTickClasses(false));
        }
        this.ticks = result;
    }
    endTickClasses(first) {
        return {
            'k-first': (first && !this.vertical) || (!first && this.vertical),
            'k-last': (!first && !this.vertical) || (first && this.vertical)
        };
    }
}
SliderTicksComponent.ɵfac = function SliderTicksComponent_Factory(t) { return new (t || SliderTicksComponent)(ɵngcc0.ɵɵdirectiveInject(RTL, 8)); };
SliderTicksComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SliderTicksComponent, selectors: [["", "kendoSliderTicks", ""]], viewQuery: function SliderTicksComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c44, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tickElements = _t);
    } }, hostVars: 2, hostBindings: function SliderTicksComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.wrapperClasses);
    } }, inputs: { tickTitle: "tickTitle", vertical: "vertical", step: "step", largeStep: "largeStep", min: "min", max: "max", labelTemplate: "labelTemplate" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], attrs: _c45, decls: 3, vars: 1, consts: [["role", "presentation", 3, "ngClass", "title", 4, "ngFor", "ngForOf"], ["defaultLabel", ""], ["role", "presentation", 3, "ngClass", "title"], ["tickElement", ""], [3, "ngSwitch"], ["class", "k-label", 4, "ngSwitchCase"], [4, "ngSwitchCase"], [1, "k-label"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function SliderTicksComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SliderTicksComponent_li_0_Template, 5, 5, "li", 0);
        ɵngcc0.ɵɵtemplate(1, SliderTicksComponent_ng_template_1_Template, 1, 1, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.ticks);
    } }, directives: [ɵngcc3.NgForOf, ɵngcc3.NgClass, ɵngcc3.NgSwitch, ɵngcc3.NgSwitchCase, ɵngcc3.NgTemplateOutlet], encapsulation: 2 });
/** @nocollapse */
SliderTicksComponent.ctorParameters = () => [
    { type: Boolean, decorators: [{ type: Optional }, { type: Inject, args: [RTL,] }] }
];
SliderTicksComponent.propDecorators = {
    wrapperClasses: [{ type: HostBinding, args: ['class',] }],
    tickTitle: [{ type: Input }],
    vertical: [{ type: Input }],
    step: [{ type: Input }],
    largeStep: [{ type: Input }],
    min: [{ type: Input }],
    max: [{ type: Input }],
    labelTemplate: [{ type: Input }],
    tickElements: [{ type: ViewChildren, args: ['tickElement',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SliderTicksComponent, [{
        type: Component,
        args: [{
                selector: '[kendoSliderTicks]',
                template: `
    <li #tickElement *ngFor="let tick of ticks;"
        [ngClass]="tick.classes"
        title="{{ tickTitle(tick.value) }}"
        role="presentation"
     >
         <ng-container [ngSwitch]="tick.large">
            <span class="k-label" *ngSwitchCase="true">
                <ng-container [ngTemplateOutlet]="labelTemplate || defaultLabel" [ngTemplateOutletContext]="tick">
                </ng-container>
            </span>
            <ng-container *ngSwitchCase="false">&nbsp;</ng-container>
         </ng-container>
     </li>

     <ng-template #defaultLabel let-value="value">
        {{ tickTitle(value) }}
     </ng-template>
  `
            }]
    }], function () { return [{ type: Boolean, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [RTL]
            }] }]; }, { wrapperClasses: [{
            type: HostBinding,
            args: ['class']
        }], tickTitle: [{
            type: Input
        }], vertical: [{
            type: Input
        }], step: [{
            type: Input
        }], largeStep: [{
            type: Input
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], labelTemplate: [{
            type: Input
        }], tickElements: [{
            type: ViewChildren,
            args: ['tickElement']
        }] }); })();

/**
 * @hidden
 */
class SlidersCommonModule {
}
SlidersCommonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SlidersCommonModule });
SlidersCommonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SlidersCommonModule_Factory(t) { return new (t || SlidersCommonModule)(); }, imports: [[CommonModule, DraggableModule, EventsModule, ResizeSensorModule],
        DraggableModule,
        EventsModule,
        ResizeSensorModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SlidersCommonModule, { declarations: function () { return [SliderTicksComponent,
        LabelTemplateDirective]; }, imports: function () { return [CommonModule, DraggableModule, EventsModule, ResizeSensorModule]; }, exports: function () { return [LabelTemplateDirective,
        SliderTicksComponent,
        DraggableModule,
        EventsModule,
        ResizeSensorModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SlidersCommonModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SliderTicksComponent,
                    LabelTemplateDirective
                ],
                exports: [
                    LabelTemplateDirective,
                    SliderTicksComponent,
                    DraggableModule,
                    EventsModule,
                    ResizeSensorModule
                ],
                imports: [CommonModule, DraggableModule, EventsModule, ResizeSensorModule]
            }]
    }], null, null); })();

/**
 * @hidden
 */
class SliderMessages extends ComponentMessages {
}
SliderMessages.ɵfac = function SliderMessages_Factory(t) { return ɵSliderMessages_BaseFactory(t || SliderMessages); };
SliderMessages.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SliderMessages, inputs: { decrement: "decrement", increment: "increment", dragHandle: "dragHandle" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
SliderMessages.propDecorators = {
    decrement: [{ type: Input }],
    increment: [{ type: Input }],
    dragHandle: [{ type: Input }]
};
const ɵSliderMessages_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(SliderMessages);

/**
 * @hidden
 */
class LocalizedSliderMessagesDirective extends SliderMessages {
    constructor(service) {
        super();
        this.service = service;
    }
}
LocalizedSliderMessagesDirective.ɵfac = function LocalizedSliderMessagesDirective_Factory(t) { return new (t || LocalizedSliderMessagesDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
LocalizedSliderMessagesDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: LocalizedSliderMessagesDirective, selectors: [["", "kendoSliderLocalizedMessages", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: SliderMessages,
                useExisting: forwardRef(() => LocalizedSliderMessagesDirective) // tslint:disable-line:no-forward-ref
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
LocalizedSliderMessagesDirective.ctorParameters = () => [
    { type: LocalizationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LocalizedSliderMessagesDirective, [{
        type: Directive,
        args: [{
                providers: [
                    {
                        provide: SliderMessages,
                        useExisting: forwardRef(() => LocalizedSliderMessagesDirective) // tslint:disable-line:no-forward-ref
                    }
                ],
                selector: '[kendoSliderLocalizedMessages]'
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }]; }, null); })();

/**
 * Custom component messages override default component messages.
 */
class SliderCustomMessagesComponent extends SliderMessages {
    constructor(service) {
        super();
        this.service = service;
    }
    get override() {
        return true;
    }
}
SliderCustomMessagesComponent.ɵfac = function SliderCustomMessagesComponent_Factory(t) { return new (t || SliderCustomMessagesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
SliderCustomMessagesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SliderCustomMessagesComponent, selectors: [["kendo-slider-messages"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: SliderMessages,
                useExisting: forwardRef(() => SliderCustomMessagesComponent) // tslint:disable-line:no-forward-ref
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function SliderCustomMessagesComponent_Template(rf, ctx) { }, encapsulation: 2 });
/** @nocollapse */
SliderCustomMessagesComponent.ctorParameters = () => [
    { type: LocalizationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SliderCustomMessagesComponent, [{
        type: Component,
        args: [{
                providers: [
                    {
                        provide: SliderMessages,
                        useExisting: forwardRef(() => SliderCustomMessagesComponent) // tslint:disable-line:no-forward-ref
                    }
                ],
                selector: 'kendo-slider-messages',
                template: ``
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }]; }, null); })();

/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the Slider component.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the Inputs module
 * import { SliderModule } from '@progress/kendo-angular-inputs';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 * import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, BrowserAnimationsModule, SliderModule], // import Slider module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
class SliderModule {
}
SliderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SliderModule });
SliderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SliderModule_Factory(t) { return new (t || SliderModule)(); }, imports: [[CommonModule, SlidersCommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SliderModule, { declarations: function () { return [SliderComponent,
        SliderCustomMessagesComponent,
        LocalizedSliderMessagesDirective]; }, imports: function () { return [CommonModule,
        SlidersCommonModule]; }, exports: function () { return [SliderComponent,
        SliderCustomMessagesComponent,
        LabelTemplateDirective,
        LocalizedSliderMessagesDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SliderModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SliderComponent,
                    SliderCustomMessagesComponent,
                    LocalizedSliderMessagesDirective
                ],
                exports: [
                    SliderComponent,
                    SliderCustomMessagesComponent,
                    LabelTemplateDirective,
                    LocalizedSliderMessagesDirective
                ],
                imports: [CommonModule, SlidersCommonModule]
            }]
    }], null, null); })();

/**
 * @hidden
 */
class RangeSliderMessages extends ComponentMessages {
}
RangeSliderMessages.ɵfac = function RangeSliderMessages_Factory(t) { return ɵRangeSliderMessages_BaseFactory(t || RangeSliderMessages); };
RangeSliderMessages.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: RangeSliderMessages, inputs: { dragHandleStart: "dragHandleStart", dragHandleEnd: "dragHandleEnd" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
RangeSliderMessages.propDecorators = {
    dragHandleStart: [{ type: Input }],
    dragHandleEnd: [{ type: Input }]
};
const ɵRangeSliderMessages_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(RangeSliderMessages);

/**
 * @hidden
 */
class LocalizedRangeSliderMessagesDirective extends RangeSliderMessages {
    constructor(service) {
        super();
        this.service = service;
    }
}
LocalizedRangeSliderMessagesDirective.ɵfac = function LocalizedRangeSliderMessagesDirective_Factory(t) { return new (t || LocalizedRangeSliderMessagesDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
LocalizedRangeSliderMessagesDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: LocalizedRangeSliderMessagesDirective, selectors: [["", "kendoSliderLocalizedMessages", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: RangeSliderMessages,
                useExisting: forwardRef(() => LocalizedRangeSliderMessagesDirective) // tslint:disable-line:no-forward-ref
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
LocalizedRangeSliderMessagesDirective.ctorParameters = () => [
    { type: LocalizationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LocalizedRangeSliderMessagesDirective, [{
        type: Directive,
        args: [{
                providers: [
                    {
                        provide: RangeSliderMessages,
                        useExisting: forwardRef(() => LocalizedRangeSliderMessagesDirective) // tslint:disable-line:no-forward-ref
                    }
                ],
                selector: '[kendoSliderLocalizedMessages]'
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }]; }, null); })();

/**
 * Custom component messages override default component messages.
 */
class RangeSliderCustomMessagesComponent extends RangeSliderMessages {
    constructor(service) {
        super();
        this.service = service;
    }
    get override() {
        return true;
    }
}
RangeSliderCustomMessagesComponent.ɵfac = function RangeSliderCustomMessagesComponent_Factory(t) { return new (t || RangeSliderCustomMessagesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
RangeSliderCustomMessagesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RangeSliderCustomMessagesComponent, selectors: [["kendo-rangeslider-messages"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: RangeSliderMessages,
                useExisting: forwardRef(() => RangeSliderCustomMessagesComponent) // tslint:disable-line:no-forward-ref
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function RangeSliderCustomMessagesComponent_Template(rf, ctx) { }, encapsulation: 2 });
/** @nocollapse */
RangeSliderCustomMessagesComponent.ctorParameters = () => [
    { type: LocalizationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RangeSliderCustomMessagesComponent, [{
        type: Component,
        args: [{
                providers: [
                    {
                        provide: RangeSliderMessages,
                        useExisting: forwardRef(() => RangeSliderCustomMessagesComponent) // tslint:disable-line:no-forward-ref
                    }
                ],
                selector: 'kendo-rangeslider-messages',
                template: ``
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }]; }, null); })();

/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the RangeSlider component.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the Inputs module
 * import { RangeSliderModule } from '@progress/kendo-angular-inputs';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 * import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, BrowserAnimationsModule, RangeSliderModule], // import RangeSlider module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
class RangeSliderModule {
}
RangeSliderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: RangeSliderModule });
RangeSliderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function RangeSliderModule_Factory(t) { return new (t || RangeSliderModule)(); }, imports: [[CommonModule, SlidersCommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(RangeSliderModule, { declarations: function () { return [RangeSliderComponent,
        RangeSliderCustomMessagesComponent,
        LocalizedRangeSliderMessagesDirective]; }, imports: function () { return [CommonModule,
        SlidersCommonModule]; }, exports: function () { return [RangeSliderComponent,
        RangeSliderCustomMessagesComponent,
        LocalizedRangeSliderMessagesDirective,
        LabelTemplateDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RangeSliderModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    RangeSliderComponent,
                    RangeSliderCustomMessagesComponent,
                    LocalizedRangeSliderMessagesDirective
                ],
                exports: [
                    RangeSliderComponent,
                    RangeSliderCustomMessagesComponent,
                    LocalizedRangeSliderMessagesDirective,
                    LabelTemplateDirective
                ],
                imports: [CommonModule, SlidersCommonModule]
            }]
    }], null, null); })();

/**
 * @hidden
 */
class Messages extends ComponentMessages {
}
Messages.ɵfac = function Messages_Factory(t) { return ɵMessages_BaseFactory(t || Messages); };
Messages.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: Messages, inputs: { on: "on", off: "off" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
Messages.propDecorators = {
    on: [{ type: Input }],
    off: [{ type: Input }]
};
const ɵMessages_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(Messages);

/**
 * @hidden
 */
class LocalizedSwitchMessagesDirective extends Messages {
    constructor(service) {
        super();
        this.service = service;
    }
}
LocalizedSwitchMessagesDirective.ɵfac = function LocalizedSwitchMessagesDirective_Factory(t) { return new (t || LocalizedSwitchMessagesDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
LocalizedSwitchMessagesDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: LocalizedSwitchMessagesDirective, selectors: [["", "kendoSwitchLocalizedMessages", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: Messages,
                useExisting: forwardRef(() => LocalizedSwitchMessagesDirective) // tslint:disable-line:no-forward-ref
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
LocalizedSwitchMessagesDirective.ctorParameters = () => [
    { type: LocalizationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LocalizedSwitchMessagesDirective, [{
        type: Directive,
        args: [{
                providers: [
                    {
                        provide: Messages,
                        useExisting: forwardRef(() => LocalizedSwitchMessagesDirective) // tslint:disable-line:no-forward-ref
                    }
                ],
                selector: '[kendoSwitchLocalizedMessages]'
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }]; }, null); })();

/**
 * Custom component messages override default component messages.
 */
class SwitchCustomMessagesComponent extends Messages {
    constructor(service) {
        super();
        this.service = service;
    }
    get override() {
        return true;
    }
}
SwitchCustomMessagesComponent.ɵfac = function SwitchCustomMessagesComponent_Factory(t) { return new (t || SwitchCustomMessagesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
SwitchCustomMessagesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SwitchCustomMessagesComponent, selectors: [["kendo-switch-messages"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: Messages,
                useExisting: forwardRef(() => SwitchCustomMessagesComponent) // tslint:disable-line:no-forward-ref
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function SwitchCustomMessagesComponent_Template(rf, ctx) { }, encapsulation: 2 });
/** @nocollapse */
SwitchCustomMessagesComponent.ctorParameters = () => [
    { type: LocalizationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SwitchCustomMessagesComponent, [{
        type: Component,
        args: [{
                providers: [
                    {
                        provide: Messages,
                        useExisting: forwardRef(() => SwitchCustomMessagesComponent) // tslint:disable-line:no-forward-ref
                    }
                ],
                selector: 'kendo-switch-messages',
                template: ``
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }]; }, null); })();

/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the Switch component.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the Switch module
 * import { SwitchModule } from '@progress/kendo-angular-inputs';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, SwitchModule], // import Switch module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
class SwitchModule {
}
SwitchModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SwitchModule });
SwitchModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SwitchModule_Factory(t) { return new (t || SwitchModule)(); }, imports: [[CommonModule, EventsModule, ResizeSensorModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SwitchModule, { declarations: function () { return [SwitchComponent,
        SwitchCustomMessagesComponent,
        LocalizedSwitchMessagesDirective]; }, imports: function () { return [CommonModule, EventsModule, ResizeSensorModule]; }, exports: function () { return [SwitchComponent,
        SwitchCustomMessagesComponent,
        LocalizedSwitchMessagesDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SwitchModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SwitchComponent,
                    SwitchCustomMessagesComponent,
                    LocalizedSwitchMessagesDirective
                ],
                exports: [
                    SwitchComponent,
                    SwitchCustomMessagesComponent,
                    LocalizedSwitchMessagesDirective
                ],
                imports: [CommonModule, EventsModule, ResizeSensorModule]
            }]
    }], null, null); })();

/**
 * @hidden
 */
class LocalizedNumericTextBoxMessagesDirective extends NumericTextBoxMessages {
    constructor(service) {
        super();
        this.service = service;
    }
}
LocalizedNumericTextBoxMessagesDirective.ɵfac = function LocalizedNumericTextBoxMessagesDirective_Factory(t) { return new (t || LocalizedNumericTextBoxMessagesDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
LocalizedNumericTextBoxMessagesDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: LocalizedNumericTextBoxMessagesDirective, selectors: [["", "kendoNumericTextBoxLocalizedMessages", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NumericTextBoxMessages,
                useExisting: forwardRef(() => LocalizedNumericTextBoxMessagesDirective) // tslint:disable-line:no-forward-ref
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
LocalizedNumericTextBoxMessagesDirective.ctorParameters = () => [
    { type: LocalizationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LocalizedNumericTextBoxMessagesDirective, [{
        type: Directive,
        args: [{
                providers: [
                    {
                        provide: NumericTextBoxMessages,
                        useExisting: forwardRef(() => LocalizedNumericTextBoxMessagesDirective) // tslint:disable-line:no-forward-ref
                    }
                ],
                selector: '[kendoNumericTextBoxLocalizedMessages]'
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }]; }, null); })();

/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the NumericTextBox component.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the NumericTextBox module
 * import { NumericTextBoxModule } from '@progress/kendo-angular-inputs';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, NumericTextBoxModule], // import NumericTextBox module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
class NumericTextBoxModule {
}
NumericTextBoxModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NumericTextBoxModule });
NumericTextBoxModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NumericTextBoxModule_Factory(t) { return new (t || NumericTextBoxModule)(); }, imports: [[CommonModule, EventsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NumericTextBoxModule, { declarations: function () { return [LocalizedNumericTextBoxMessagesDirective,
        NumericTextBoxComponent,
        NumericTextBoxCustomMessagesComponent]; }, imports: function () { return [CommonModule, EventsModule]; }, exports: function () { return [NumericTextBoxComponent,
        NumericTextBoxCustomMessagesComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NumericTextBoxModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    LocalizedNumericTextBoxMessagesDirective,
                    NumericTextBoxComponent,
                    NumericTextBoxCustomMessagesComponent
                ],
                exports: [
                    NumericTextBoxComponent,
                    NumericTextBoxCustomMessagesComponent
                ],
                imports: [CommonModule, EventsModule]
            }]
    }], null, null); })();

/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the MaskedTextBox component.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the MaskedTextBox module
 * import { MaskedTextBoxModule } from '@progress/kendo-angular-inputs';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, MaskedTextBoxModule], // import MaskedTextBox module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
class MaskedTextBoxModule {
}
MaskedTextBoxModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MaskedTextBoxModule });
MaskedTextBoxModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MaskedTextBoxModule_Factory(t) { return new (t || MaskedTextBoxModule)(); }, imports: [[CommonModule, EventsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MaskedTextBoxModule, { declarations: function () { return [MaskedTextBoxComponent]; }, imports: function () { return [CommonModule, EventsModule]; }, exports: function () { return [MaskedTextBoxComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MaskedTextBoxModule, [{
        type: NgModule,
        args: [{
                declarations: [MaskedTextBoxComponent],
                exports: [MaskedTextBoxComponent],
                imports: [CommonModule, EventsModule]
            }]
    }], null, null); })();

/**
 * Specifies the adornments in the suffix container ([see examples]({% slug adornments_textbox %}#toc-suffixadornments)).
 *  @example
 * ```ts-no-run
 * _@Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-textbox>
 *    <ng-template kendoTextBoxSuffixTemplate>
 *        <button kendoButton look="clear" icon="image"></button>
 *    </ng-template>
 *  </kendo-textbox>
 * `
 * })
 * class AppComponent {}
 * ```
 */
class TextBoxSuffixTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
TextBoxSuffixTemplateDirective.ɵfac = function TextBoxSuffixTemplateDirective_Factory(t) { return new (t || TextBoxSuffixTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef, 8)); };
TextBoxSuffixTemplateDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TextBoxSuffixTemplateDirective, selectors: [["", "kendoTextBoxSuffixTemplate", ""]] });
/** @nocollapse */
TextBoxSuffixTemplateDirective.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TextBoxSuffixTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoTextBoxSuffixTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Specifies the adornments in the prefix container ([see examples]({% slug adornments_textbox %}#toc-prefixadornments)).
 * @example
 * ```ts-no-run
 * _@Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-textbox>
 *    <ng-template kendoTextBoxPrefixTemplate>
 *        <button kendoButton look="clear" icon="image"></button>
 *    </ng-template>
 *  </kendo-textbox>
 * `
 * })
 * class AppComponent {}
 * ```
 */
class TextBoxPrefixTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
TextBoxPrefixTemplateDirective.ɵfac = function TextBoxPrefixTemplateDirective_Factory(t) { return new (t || TextBoxPrefixTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef, 8)); };
TextBoxPrefixTemplateDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TextBoxPrefixTemplateDirective, selectors: [["", "kendoTextBoxPrefixTemplate", ""]] });
/** @nocollapse */
TextBoxPrefixTemplateDirective.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TextBoxPrefixTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoTextBoxPrefixTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Optional
            }] }]; }, null); })();

class TextBoxComponent {
    constructor(localizationService, ngZone, changeDetector, renderer, injector, hostElement) {
        this.localizationService = localizationService;
        this.ngZone = ngZone;
        this.changeDetector = changeDetector;
        this.renderer = renderer;
        this.injector = injector;
        this.hostElement = hostElement;
        /**
         * Sets the `title` attribute of the `input` element of the TextBox.
         */
        this.title = '';
        /**
         * Sets the disabled state of the component.
         *
         * @default false
         */
        this.disabled = false;
        /**
         * Sets the read-only state of the component.
         *
         * @default false
         */
        this.readonly = false;
        /**
         * Specifies the `tabindex` of the TextBox.
         *
         * @default 0
         */
        this.tabindex = 0;
        /**
         * Provides a value for the TextBox.
         */
        this.value = null;
        /**
         * Determines whether the whole value will be selected when the TextBox is clicked. Defaults to `false`.
         *
         * @default false
         */
        this.selectOnFocus = false;
        /**
         * Specifies when the Success icon will be shown ([see example]({% slug validation_textbox %})).
         *
         * The possible values are:
         *
         * `boolean`&mdash;The Success icon is displayed, if the condition given by the developer is met.
         *
         * `initial`&mdash;The Success icon will be displayed when the component state is neither `invalid` nor `touched` or `dirty`.
         *
         * @default false
         */
        this.showSuccessIcon = false;
        /**
         * Specifies when the Error icon will be shown ([see example]({% slug validation_textbox %})).
         *
         * The possible values are:
         *
         * * `initial`&mdash;The Error icon will be displayed when the component state is
         * `invalid` and `touched` or `dirty`.
         * * `boolean`&mdash;The Error icon is displayed, if the condition given by the developer is met.
         *
         * @default false
         */
        this.showErrorIcon = false;
        /**
         * Specifies whether a Clear button will be rendered.
         *
         * @default false
         */
        this.clearButton = false;
        /**
         * Fires each time the value is changed&mdash;
         * when the component is blurred or the value is cleared through the **Clear** button
         * ([see example]({% slug overview_textbox %}#toc-events)).
         * When the value of the component is programmatically changed to `ngModel` or `formControl`
         * through its API or form binding, the `valueChange` event is not triggered because it
         * might cause a mix-up with the built-in `valueChange` mechanisms of the `ngModel` or `formControl` bindings.
         */
        this.valueChange = new EventEmitter();
        /**
         * Fires each time the user focuses the `input` element.
         */
        this.inputFocus = new EventEmitter();
        /**
         * Fires each time the `input` element gets blurred.
         */
        this.inputBlur = new EventEmitter();
        /**
         * Fires each time the user focuses the TextBox component.
         *
         * > To wire the event programmatically, use the `onFocus` property.
         *
         * @example
         * ```ts-no-run
         * _@Component({
         * selector: 'my-app',
         * template: `
         *  <kendo-textbox (focus)="handleFocus()"></kendo-textbox>
         * `
         * })
         * class AppComponent {
         *   public handleFocus(): void {
         *      console.log('Component is isFocused');
         *   }
         * }
         * ```
         */
        this.onFocus = new EventEmitter();
        /**
         * Fires each time the TextBox component gets blurred.
         *
         * > To wire the event programmatically, use the `onBlur` property.
         *
         * @example
         * ```ts-no-run
         * _@Component({
         * selector: 'my-app',
         * template: `
         *  <kendo-textbox (blur)="handleBlur()"></kendo-textbox>
         * `
         * })
         * class AppComponent {
         *   public handleBlur(): void {
         *      console.log('Component is blurred');
         *   }
         * }
         * ```
         */
        this.onBlur = new EventEmitter();
        this.hostClass = true;
        this._isFocused = false;
        this.focusChangedProgrammatically = false;
        /**
         * @hidden
         */
        this.handleInputFocus = () => {
            if (!this.disabled) {
                if (this.selectOnFocus && this.value) {
                    this.ngZone.run(() => {
                        setTimeout(() => { this.selectAll(); });
                    });
                }
                if (hasObservers(this.onFocus)) {
                    if (!this.isFocused) {
                        this.ngZone.run(() => {
                            this.onFocus.emit();
                        });
                    }
                }
                if (hasObservers(this.inputFocus)) {
                    if (!this.focusChangedProgrammatically || (this.focusChangedProgrammatically && this.clearButtonClicked)) {
                        this.ngZone.run(() => {
                            this.inputFocus.emit();
                        });
                    }
                }
                this.ngZone.run(() => {
                    this.isFocused = true;
                });
            }
        };
        /**
         * @hidden
         */
        this.handleInputBlur = () => {
            this.changeDetector.markForCheck();
            if (hasObservers(this.inputBlur) || requiresZoneOnBlur(this.control)) {
                this.ngZone.run(() => {
                    this.ngTouched();
                    this.inputBlur.emit();
                });
            }
        };
        /**
         * @hidden
         */
        this.handleInput = (ev) => {
            let incomingValue = ev.target.value;
            this.updateValue(incomingValue);
        };
        this.ngChange = (_) => { };
        this.ngTouched = () => { };
        this.direction = localizationService.rtl ? 'rtl' : 'ltr';
    }
    /**
     * @hidden
     */
    set tabIndex(tabIndex) {
        this.tabindex = tabIndex;
    }
    get tabIndex() {
        return this.tabindex;
    }
    get disabledClass() {
        return this.disabled;
    }
    get isFocused() {
        return this.disabled ? false : this._isFocused;
    }
    set isFocused(isFocused) {
        this._isFocused = isFocused;
    }
    ngOnInit() {
        this.control = this.injector.get(NgControl, null);
        this.checkClearButton();
        this.subscriptions = this.localizationService.changes.subscribe(({ rtl }) => {
            this.direction = rtl ? 'rtl' : 'ltr';
        });
    }
    ngAfterViewInit() {
        const hostElement = this.hostElement.nativeElement;
        let cursorInsideWrapper = false;
        let tabbing = false;
        this.ngZone.runOutsideAngular(() => {
            // focusIn and focusOut are relative to the host element
            this.subscriptions.add(this.renderer.listen(hostElement, 'focusin', () => {
                if (!this.isFocused) {
                    this.ngZone.run(() => {
                        this.onFocus.emit();
                        this.isFocused = true;
                    });
                }
            }));
            this.subscriptions.add(this.renderer.listen(hostElement, 'focusout', (args) => {
                if (!this.isFocused) {
                    return;
                }
                if (tabbing) {
                    const closestTextbox = closest(args.relatedTarget, (element) => element === this.hostElement.nativeElement);
                    if (!closestTextbox) {
                        this.handleBlur();
                    }
                    tabbing = false;
                }
                else {
                    if (!cursorInsideWrapper && !this.clearButtonClicked) {
                        this.handleBlur();
                    }
                }
            }));
            this.subscriptions.add(this.renderer.listen(hostElement, 'mouseenter', () => {
                cursorInsideWrapper = true;
            }));
            this.subscriptions.add(this.renderer.listen(hostElement, 'mouseleave', () => {
                cursorInsideWrapper = false;
            }));
            this.subscriptions.add(this.renderer.listen(hostElement, 'keydown', (args) => {
                if (args.keyCode === Keys.Tab) {
                    tabbing = true;
                }
                else {
                    tabbing = false;
                }
            }));
        });
    }
    ngOnChanges(changes) {
        if (changes.disabled || changes.readonly) {
            this.checkClearButton();
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    /**
     * Focuses the TextBox.
     *
     * @example
     * ```ts-no-run
     * _@Component({
     * selector: 'my-app',
     * template: `
     *  <button (click)="input.focus()">Focus the input</button>
     *  <kendo-textbox #input></kendo-textbox>
     * `
     * })
     * class AppComponent { }
     * ```
     */
    focus() {
        if (!this.input) {
            return;
        }
        this.focusChangedProgrammatically = true;
        this.isFocused = true;
        this.input.nativeElement.focus();
        this.focusChangedProgrammatically = false;
    }
    /**
     * Blurs the TextBox.
     */
    blur() {
        this.focusChangedProgrammatically = true;
        const isFocusedElement = this.hostElement.nativeElement.querySelector(':focus');
        if (isFocusedElement) {
            isFocusedElement.blur();
        }
        this.isFocused = false;
        this.focusChangedProgrammatically = false;
    }
    /**
     * @hidden
     */
    clearTitle() {
        return this.localizationService.get('clear');
    }
    /**
     * @hidden
     */
    checkClearButton() {
        this.showClearButton =
            !this.disabled &&
                !this.readonly &&
                this.clearButton &&
                !!this.value;
    }
    /**
     * @hidden
     */
    clearValue(ev) {
        if (ev) {
            ev.preventDefault();
        }
        this.clearButtonClicked = true;
        this.input.nativeElement.value = '';
        this.input.nativeElement.focus();
        this.updateValue(null);
        this.checkClearButton();
        this.clearButtonClicked = false;
    }
    /**
     * @hidden
     */
    writeValue(value) {
        this.value = value;
        this.checkClearButton();
    }
    /**
     * @hidden
     */
    registerOnChange(fn) {
        this.ngChange = fn;
    }
    /**
     * @hidden
     */
    registerOnTouched(fn) {
        this.ngTouched = fn;
    }
    /**
     * @hidden
     * Called when the status of the component changes to or from `disabled`.
     * Depending on the value, it enables or disables the appropriate DOM element.
     *
     * @param isDisabled
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @hidden
     */
    showErrorsInitial() {
        if (!this.control) {
            return false;
        }
        const { invalid, dirty, touched } = this.control;
        return invalid && (dirty || touched);
    }
    /**
     * @hidden
     */
    showSuccessInitial() {
        if (!this.control) {
            return false;
        }
        const { valid, dirty, touched } = this.control;
        return valid && (dirty || touched);
    }
    /**
     * @hidden
     */
    get successIconClasses() {
        return this.successIcon
            ? `k-text-success ${this.successIcon}`
            : `k-text-success k-icon k-i-check-outline`;
    }
    /**
     * @hidden
     */
    get errorIconClasses() {
        return this.errorIcon
            ? `k-text-error ${this.errorIcon}`
            : `k-text-error k-icon k-i-warning`;
    }
    /**
     * @hidden
     */
    get clearButtonClasses() {
        return this.clearButtonIcon
            ? this.clearButtonIcon
            : `k-icon k-i-close-circle`;
    }
    /**
     * @hidden
     */
    get hasErrors() {
        return this.showErrorIcon === 'initial'
            ? this.showErrorsInitial()
            : this.showErrorIcon;
    }
    /**
     * @hidden
     */
    get isSuccessful() {
        return this.showSuccessIcon === 'initial'
            ? this.showSuccessInitial()
            : this.showSuccessIcon;
    }
    setSelection(start, end) {
        if (this.isFocused) {
            invokeElementMethod(this.input, 'setSelectionRange', start, end);
        }
    }
    selectAll() {
        if (this.value) {
            this.setSelection(0, this.value.length);
        }
    }
    updateValue(value) {
        if (!areSame(this.value, value)) {
            this.ngZone.run(() => {
                this.value = value;
                this.ngChange(value);
                this.valueChange.emit(value);
                this.checkClearButton();
                this.changeDetector.markForCheck();
            });
        }
    }
    handleBlur() {
        this.ngZone.run(() => {
            if (!this.focusChangedProgrammatically) {
                this.onBlur.emit();
            }
            this.isFocused = false;
        });
    }
}
TextBoxComponent.ɵfac = function TextBoxComponent_Factory(t) { return new (t || TextBoxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TextBoxComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TextBoxComponent, selectors: [["kendo-textbox"]], contentQueries: function TextBoxComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TextBoxSuffixTemplateDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, TextBoxPrefixTemplateDirective, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.suffixTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.prefixTemplate = _t.first);
    } }, viewQuery: function TextBoxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c42, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, hostVars: 7, hostBindings: function TextBoxComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.direction);
        ɵngcc0.ɵɵclassProp("k-textbox", ctx.hostClass)("k-state-focused", ctx.isFocused)("k-state-disabled", ctx.disabledClass);
    } }, inputs: { title: "title", disabled: "disabled", readonly: "readonly", tabindex: "tabindex", value: "value", selectOnFocus: "selectOnFocus", showSuccessIcon: "showSuccessIcon", showErrorIcon: "showErrorIcon", clearButton: "clearButton", tabIndex: "tabIndex", successIcon: "successIcon", errorIcon: "errorIcon", clearButtonIcon: "clearButtonIcon", placeholder: "placeholder" }, outputs: { valueChange: "valueChange", inputFocus: "inputFocus", inputBlur: "inputBlur", onFocus: "focus", onBlur: "blur" }, exportAs: ["kendoTextBox"], features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            { provide: L10N_PREFIX, useValue: 'kendo.textbox' },
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => TextBoxComponent),
                multi: true
            },
            { provide: KendoInput, useExisting: forwardRef(() => TextBoxComponent) }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 11, vars: 16, consts: [["kendoTextBoxLocalizedMessages", "", 6, "clear"], [1, "k-input-prefix"], [4, "ngIf"], [1, "k-input", 3, "disabled", "readonly", "value", "kendoEventsOutsideAngular"], ["input", ""], [1, "k-input-suffix"], [3, "ngClass", 4, "ngIf"], ["role", "button", "class", "k-clear-value", 3, "tabindex", "title", "click", "mousedown", "keydown.enter", "keydown.space", 4, "ngIf"], [3, "ngTemplateOutlet"], [3, "ngClass"], ["role", "button", 1, "k-clear-value", 3, "tabindex", "title", "click", "mousedown", "keydown.enter", "keydown.space"]], template: function TextBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵi18nAttributes(1, _c48);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementStart(2, "span", 1);
        ɵngcc0.ɵɵtemplate(3, TextBoxComponent_3_Template, 1, 1, undefined, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(4, "input", 3, 4);
        ɵngcc0.ɵɵelementStart(6, "span", 5);
        ɵngcc0.ɵɵtemplate(7, TextBoxComponent_span_7_Template, 1, 1, "span", 6);
        ɵngcc0.ɵɵtemplate(8, TextBoxComponent_span_8_Template, 1, 1, "span", 6);
        ɵngcc0.ɵɵtemplate(9, TextBoxComponent_span_9_Template, 2, 4, "span", 7);
        ɵngcc0.ɵɵtemplate(10, TextBoxComponent_10_Template, 1, 1, undefined, 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.prefixTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("readonly", ctx.readonly)("value", ctx.value)("kendoEventsOutsideAngular", ɵngcc0.ɵɵpureFunction3(12, _c49, ctx.handleInputFocus, ctx.handleInputBlur, ctx.handleInput));
        ɵngcc0.ɵɵattribute("tabindex", ctx.disabled ? undefined : ctx.tabindex)("placeholder", ctx.placeholder)("title", ctx.title);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasErrors);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isSuccessful);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClearButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.suffixTemplate);
    } }, directives: function () { return [LocalizedTextBoxMessagesDirective, ɵngcc3.NgIf, ɵngcc2.EventsOutsideAngularDirective, ɵngcc3.NgTemplateOutlet, ɵngcc3.NgClass]; }, encapsulation: 2 });
/** @nocollapse */
TextBoxComponent.ctorParameters = () => [
    { type: LocalizationService },
    { type: NgZone },
    { type: ChangeDetectorRef },
    { type: Renderer2 },
    { type: Injector },
    { type: ElementRef }
];
TextBoxComponent.propDecorators = {
    title: [{ type: Input }],
    disabled: [{ type: Input }],
    readonly: [{ type: Input }],
    tabindex: [{ type: Input }],
    value: [{ type: Input }],
    selectOnFocus: [{ type: Input }],
    showSuccessIcon: [{ type: Input }],
    showErrorIcon: [{ type: Input }],
    clearButton: [{ type: Input }],
    successIcon: [{ type: Input }],
    errorIcon: [{ type: Input }],
    clearButtonIcon: [{ type: Input }],
    tabIndex: [{ type: Input }],
    placeholder: [{ type: Input }],
    valueChange: [{ type: Output }],
    inputFocus: [{ type: Output }],
    inputBlur: [{ type: Output }],
    onFocus: [{ type: Output, args: ['focus',] }],
    onBlur: [{ type: Output, args: ['blur',] }],
    input: [{ type: ViewChild, args: ['input', { static: true },] }],
    suffixTemplate: [{ type: ContentChild, args: [TextBoxSuffixTemplateDirective,] }],
    prefixTemplate: [{ type: ContentChild, args: [TextBoxPrefixTemplateDirective,] }],
    disabledClass: [{ type: HostBinding, args: ['class.k-state-disabled',] }],
    hostClass: [{ type: HostBinding, args: ['class.k-textbox',] }],
    isFocused: [{ type: HostBinding, args: ['class.k-state-focused',] }],
    direction: [{ type: HostBinding, args: ['attr.dir',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TextBoxComponent, [{
        type: Component,
        args: [{
                exportAs: 'kendoTextBox',
                providers: [
                    LocalizationService,
                    { provide: L10N_PREFIX, useValue: 'kendo.textbox' },
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => TextBoxComponent),
                        multi: true
                    },
                    { provide: KendoInput, useExisting: forwardRef(() => TextBoxComponent) }
                ],
                selector: 'kendo-textbox',
                template: `
        <ng-container kendoTextBoxLocalizedMessages
            i18n-clear="kendo.textbox.clear|The title for the **Clear** button in the TextBox."
            clear="Clear">
        </ng-container>
        <span class="k-input-prefix">
            <ng-template
                *ngIf="prefixTemplate"
                [ngTemplateOutlet]="prefixTemplate?.templateRef">
            </ng-template>
        </span>
        <input
            class="k-input"
            #input
            [disabled]="disabled"
            [readonly]="readonly"
            [attr.tabindex]="disabled ? undefined : tabindex"
            [value]="value"
            [attr.placeholder]="placeholder"
            [attr.title]="title"
            [kendoEventsOutsideAngular]="{
                focus: handleInputFocus,
                blur: handleInputBlur,
                input: handleInput}"/>
        <span class="k-input-suffix">
            <span *ngIf="hasErrors" [ngClass]="errorIconClasses"></span>
            <span *ngIf="isSuccessful" [ngClass]="successIconClasses"></span>
            <span
                role="button"
                class="k-clear-value"
                *ngIf="showClearButton"
                (click)="clearValue()"
                (mousedown)="$event.preventDefault()"
                [tabindex]="tabIndex"
                [attr.aria-label]="clearTitle()"
                [title]="clearTitle()"
                (keydown.enter)="clearValue($event)"
                (keydown.space)="clearValue($event)"
                >
                <span [ngClass]="clearButtonClasses"></span>
            </span>
            <ng-template
                *ngIf="suffixTemplate"
                [ngTemplateOutlet]="suffixTemplate?.templateRef">
            </ng-template>
        </span>
    `
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.Injector }, { type: ɵngcc0.ElementRef }]; }, { title: [{
            type: Input
        }], disabled: [{
            type: Input
        }], readonly: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], value: [{
            type: Input
        }], selectOnFocus: [{
            type: Input
        }], showSuccessIcon: [{
            type: Input
        }], showErrorIcon: [{
            type: Input
        }], clearButton: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], inputFocus: [{
            type: Output
        }], inputBlur: [{
            type: Output
        }], onFocus: [{
            type: Output,
            args: ['focus']
        }], onBlur: [{
            type: Output,
            args: ['blur']
        }], hostClass: [{
            type: HostBinding,
            args: ['class.k-textbox']
        }], isFocused: [{
            type: HostBinding,
            args: ['class.k-state-focused']
        }], direction: [{
            type: HostBinding,
            args: ['attr.dir']
        }], tabIndex: [{
            type: Input
        }], disabledClass: [{
            type: HostBinding,
            args: ['class.k-state-disabled']
        }], successIcon: [{
            type: Input
        }], errorIcon: [{
            type: Input
        }], clearButtonIcon: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: ['input', { static: true }]
        }], suffixTemplate: [{
            type: ContentChild,
            args: [TextBoxSuffixTemplateDirective]
        }], prefixTemplate: [{
            type: ContentChild,
            args: [TextBoxPrefixTemplateDirective]
        }] }); })();

/**
 * Specifies a separator in the content of the TextBox ([see examples]({% slug adornments_textbox %}#toc-separator)).
 * @example
 * ```ts-no-run
 * _@Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-textbox>
 *    <ng-template kendoTextBoxSuffixTemplate>
 *        <button kendoButton look="clear" icon="image"></button>
 *        <kendo-textbox-separator></kendo-textbox-separator>
 *    </ng-template>
 *  </kendo-textbox>
 * `
 * })
 * class AppComponent {}
 * ```
 */
class TextBoxSeparatorComponent {
    constructor() {
        this.hostClass = true;
    }
}
TextBoxSeparatorComponent.ɵfac = function TextBoxSeparatorComponent_Factory(t) { return new (t || TextBoxSeparatorComponent)(); };
TextBoxSeparatorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TextBoxSeparatorComponent, selectors: [["kendo-textbox-separator"]], hostVars: 2, hostBindings: function TextBoxSeparatorComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-textbox-separator", ctx.hostClass);
    } }, decls: 0, vars: 0, template: function TextBoxSeparatorComponent_Template(rf, ctx) { }, encapsulation: 2 });
TextBoxSeparatorComponent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class.k-textbox-separator',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TextBoxSeparatorComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-textbox-separator',
                template: ``
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class.k-textbox-separator']
        }] }); })();

/**
 * @hidden
 */
class TextBoxMessages extends ComponentMessages {
}
TextBoxMessages.ɵfac = function TextBoxMessages_Factory(t) { return ɵTextBoxMessages_BaseFactory(t || TextBoxMessages); };
TextBoxMessages.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TextBoxMessages, inputs: { clear: "clear" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
TextBoxMessages.propDecorators = {
    clear: [{ type: Input }]
};
const ɵTextBoxMessages_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TextBoxMessages);

/**
 * Custom component messages override default component messages.
 */
class TextBoxCustomMessagesComponent extends TextBoxMessages {
    constructor(service) {
        super();
        this.service = service;
    }
    get override() {
        return true;
    }
}
TextBoxCustomMessagesComponent.ɵfac = function TextBoxCustomMessagesComponent_Factory(t) { return new (t || TextBoxCustomMessagesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
TextBoxCustomMessagesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TextBoxCustomMessagesComponent, selectors: [["kendo-textbox-messages"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TextBoxMessages,
                useExisting: forwardRef(() => TextBoxCustomMessagesComponent) // tslint:disable-line:no-forward-ref
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function TextBoxCustomMessagesComponent_Template(rf, ctx) { }, encapsulation: 2 });
/** @nocollapse */
TextBoxCustomMessagesComponent.ctorParameters = () => [
    { type: LocalizationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TextBoxCustomMessagesComponent, [{
        type: Component,
        args: [{
                providers: [
                    {
                        provide: TextBoxMessages,
                        useExisting: forwardRef(() => TextBoxCustomMessagesComponent) // tslint:disable-line:no-forward-ref
                    }
                ],
                selector: 'kendo-textbox-messages',
                template: ``
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }]; }, null); })();

/**
 * @hidden
 */
class LocalizedTextBoxMessagesDirective extends TextBoxMessages {
    constructor(service) {
        super();
        this.service = service;
    }
}
LocalizedTextBoxMessagesDirective.ɵfac = function LocalizedTextBoxMessagesDirective_Factory(t) { return new (t || LocalizedTextBoxMessagesDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
LocalizedTextBoxMessagesDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: LocalizedTextBoxMessagesDirective, selectors: [["", "kendoTextBoxLocalizedMessages", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TextBoxMessages,
                useExisting: forwardRef(() => LocalizedTextBoxMessagesDirective) // tslint:disable-line:no-forward-ref
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
LocalizedTextBoxMessagesDirective.ctorParameters = () => [
    { type: LocalizationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LocalizedTextBoxMessagesDirective, [{
        type: Directive,
        args: [{
                providers: [
                    {
                        provide: TextBoxMessages,
                        useExisting: forwardRef(() => LocalizedTextBoxMessagesDirective) // tslint:disable-line:no-forward-ref
                    }
                ],
                selector: '[kendoTextBoxLocalizedMessages]'
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }]; }, null); })();

/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the TextBox directive.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the TextBox module
 * import { TextBoxModule } from '@progress/kendo-angular-inputs';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, TextBoxModule], // import TextBox module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
class TextBoxModule {
}
TextBoxModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TextBoxModule });
TextBoxModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TextBoxModule_Factory(t) { return new (t || TextBoxModule)(); }, imports: [[CommonModule, EventsModule],
        EventsModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TextBoxModule, { declarations: function () { return [TextBoxDirective,
        TextAreaDirective,
        TextBoxContainerComponent,
        TextBoxComponent,
        TextBoxSeparatorComponent,
        TextBoxSuffixTemplateDirective,
        TextBoxPrefixTemplateDirective,
        TextBoxCustomMessagesComponent,
        LocalizedTextBoxMessagesDirective]; }, imports: function () { return [CommonModule, EventsModule]; }, exports: function () { return [TextBoxDirective,
        TextAreaDirective,
        TextBoxContainerComponent,
        TextBoxComponent,
        TextBoxSeparatorComponent,
        TextBoxSuffixTemplateDirective,
        TextBoxPrefixTemplateDirective,
        EventsModule,
        TextBoxCustomMessagesComponent,
        LocalizedTextBoxMessagesDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TextBoxModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TextBoxDirective,
                    TextAreaDirective,
                    TextBoxContainerComponent,
                    TextBoxComponent,
                    TextBoxSeparatorComponent,
                    TextBoxSuffixTemplateDirective,
                    TextBoxPrefixTemplateDirective,
                    TextBoxCustomMessagesComponent,
                    LocalizedTextBoxMessagesDirective
                ],
                exports: [
                    TextBoxDirective,
                    TextAreaDirective,
                    TextBoxContainerComponent,
                    TextBoxComponent,
                    TextBoxSeparatorComponent,
                    TextBoxSuffixTemplateDirective,
                    TextBoxPrefixTemplateDirective,
                    EventsModule,
                    TextBoxCustomMessagesComponent,
                    LocalizedTextBoxMessagesDirective
                ],
                imports: [CommonModule, EventsModule]
            }]
    }], null, null); })();

/**
 * @hidden
 */
class PreventableEvent {
    constructor() {
        this.prevented = false;
    }
    /**
     * Prevents the default action for a specified event.
     * In this way, the source component suppresses the built-in behavior that follows the event.
     */
    preventDefault() {
        this.prevented = true;
    }
    /**
     * If the event is prevented by any of its subscribers, returns `true`.
     *
     * @returns - `true` if the default action was prevented. Otherwise, returns `false`.
     */
    isDefaultPrevented() {
        return this.prevented;
    }
}

/**
 * Fires each time the left side of the ColorPicker wrapper is clicked.
 * The event is triggered regardless of whether a ColorPicker icon is set or not.
 *
 * Provides information about the current active color and gives the option to prevent the opening of the popup.
 *
 * @example
 *
 * ```ts-no-run
 * _@Component({
 *   selector: 'my-app',
 *   template: `
 *       <kendo-colorpicker
 *           [icon]="'edit-tools'"
 *           [value]="'#900'"
 *           (activeColorClick)="handleActiveColorClick($event)"
 *       >
 *       </kendo-colorpicker>
 *   `
 * })
 * class AppComponent {
 *     public handleActiveColorClick(event: ActiveColorClickEvent): void {
 *         event.preventOpen();
 *
 *         console.log('Open prevented:', event.isOpenPrevented());
 *         console.log('Current color:', event.color);
 *     }
 *  }
 * ```
 */
class ActiveColorClickEvent {
    /**
     * @hidden
     * @param color Represents the current value of the ColorPicker.
     */
    constructor(color) {
        this.color = color;
        this.openPrevented = false;
    }
    /**
     * Prevents the opening of the popup.
     */
    preventOpen() {
        this.openPrevented = true;
    }
    /**
     * Returns `true` if the popup opening is prevented by any of its subscribers.
     *
     * @returns - Returns `true` if the open action was prevented. Otherwise, returns `false`.
     */
    isOpenPrevented() {
        return this.openPrevented;
    }
}

/**
 * @hidden
 *
 * Returns the hex or rgba string representation of the color.
 */
const parseColor$1 = (value, format, safe = true) => {
    const allowedFormats = ['hex', 'rgba', 'name'];
    if (allowedFormats.indexOf(format) === -1) {
        throw new Error(`Unsupported color output format '${format}'. The available options are 'hex', 'rgba' or 'name'.`);
    }
    if (!isPresent(value)) {
        return;
    }
    if (format === 'name') {
        return nameFormat(value, safe);
    }
    const parsedColor = parseColor(value.trim(), safe);
    if (!isPresent(parsedColor)) {
        return;
    }
    return format === 'hex' ? parsedColor.toCss() : parsedColor.toCssRgba();
};
/**
 * @hidden
 *
 * Returns an HSV object representation of the color string.
 */
const getHSV = (value, safe = true) => {
    const parsed = parseColor(value, safe);
    if (!isPresent(parsed)) {
        return {};
    }
    return parsed.toHSV();
};
/**
 * @hidden
 *
 * Returns an RGBA object representation of the color string.
 */
const getRGBA = (value, safe = true) => {
    const parsed = parseColor(value, safe);
    if (!isPresent(parsed)) {
        return {};
    }
    return parsed.toBytes();
};
/**
 * @hidden
 *
 * Returns the RGBA string representation of the color.
 */
const getColorFromHSV = (hsva) => {
    const hue = fitIntoBounds(hsva.h, 0, 359.9);
    const saturation = fitIntoBounds(hsva.s, 0, 1);
    const value = fitIntoBounds(hsva.v, 0, 1);
    const alpha = fitIntoBounds(hsva.a, 0, 1);
    return Color.fromHSV(hue, saturation, value, alpha).toCssRgba();
};
/**
 * @hidden
 *
 * Returns the RGBA string representation of the color based on the `hue`, assuming the `value`, `saturation` and `alpha` have value of `1`.
 */
const getColorFromHue = (hue) => {
    return getColorFromHSV({ h: hue, s: 1, v: 1, a: 1 });
};
/**
 * @hidden
 *
 * Returns the RGBA string representation of the color.
 */
const getColorFromRGBA = (rgba) => {
    const red = fitIntoBounds(rgba.r, 0, 255);
    const green = fitIntoBounds(rgba.g, 0, 255);
    const blue = fitIntoBounds(rgba.b, 0, 255);
    const alpha = fitIntoBounds(rgba.a, 0, 1);
    return Color.fromBytes(red, green, blue, alpha).toCssRgba();
};
/**
 *
 * @hidden
 */
function nameFormat(value, safe) {
    value = value.toLowerCase().trim();
    if (isPresent(namedColors[value])) {
        return value;
    }
    if (parseColor(value, safe)) {
        value = parseColor(value, safe).toHex();
    }
    const key = Object.keys(namedColors).find(key => namedColors[key] === value);
    if (!key && !safe) {
        throw new Error(`The provided color ${value} is not supported for 'format="name"' property.To display ${value} color, the component 'format' property shoud be set to 'hex' or 'rgba' `);
    }
    return key;
}

// tslint:disable:max-line-length
/**
 * @hidden
 */
const PALETTEPRESETS = {
    basic: {
        colors: '000000,7f7f7f,880015,ed1c24,ff7f27,fff200,22b14c,00a2e8,3f48cc,a349a4,ffffff,c3c3c3,b97a57,ffaec9,ffc90e,efe4b0,b5e61d,99d9ea,7092be,c8bfe7',
        columns: 10
    },
    office: {
        colors: 'ffffff, 000000, e6e6e6, 435569, 4371c4, ed7e32, a5a4a5, febf04, 5a9bd5, 71ae48, f2f2f3, 7f7f7f, d1cece, d5dde3, dae1f4, fce5d4, deeded, fff2cc, deeaf6, e1efd9, d7d8d8, 585959, aeabab, adbaca, b4c5e7, f6caac, dbdbdb, ffe498, bcd6ee, c5e0b2, bfbfc0, 3f3f3f, 767070, 8595b1, 8fabdb, f5b183, c9c8c9, fed965, 9bc4e5, a8d08d, a5a5a6, 262625, 393939, 334050, 2e5496, c45a11, 7b7b7a, bf9000, 2f75b5, 548235, 7f7f7f, 0b0c0c, 161616, 222a34, 203764, 843d0b, 525252, 7f6000, 1d4d79, 375623',
        columns: 10
    },
    apex: {
        colors: 'ffffff, 000000, c9c2d1, 69676d, ceb966, 9cb084, 6bb1c9, 6585cf, 7e6bc9, a379bb, f2f2f2, 7f7f7f, f4f2f5, e0e0e2, f5f1e0, ebefe6, e1eff4, e0e6f5, e5e1f4, ece4f1, d8d8d8, 595959, e9e6ec, c2c1c5, ebe3c1, d7dfcd, c3dfe9, c1ceeb, cbc3e9, dac9e3, bfbfbf, 3f3f3f, dedae3, a4a3a8, e1d5a3, c3cfb5, a6d0de, a2b5e2, b1a6de, c7aed6, a5a5a5, 262626, 9688a5, 4e4d51, ae9638, 758c5a, 3d8da9, 365bb0, 533da9, 7d4d99, 7f7f7f, 0c0c0c, 635672, 343336, 746425, 4e5d3c, 295e70, 243c75, 372970, 533366',
        columns: 10
    },
    austin: {
        colors: 'ffffff, 000000, caf278, 3e3d2d, 94c600, 71685a, ff6700, 909465, 956b43, fea022, f2f2f2, 7f7f7f, f4fce4, dddcd0, efffc0, e3e1dc, ffe0cb, e8e9df, ece1d6, feecd2, d8d8d8, 595959, e9f9c9, bbb9a1, dfff82, c8c3ba, ffc299, d2d4c0, dac3ad, fed9a6, bfbfbf, 3f3f3f, dff7ae, ada598, cfff43, ada598, ffa365, bcbfa1, c8a585, fec67a, a5a5a5, 262626, a9ea25, 2e2d21, 6f9400, 544e43, bf4d00, 6c6f4b, 6f5032, d77b00, 7f7f7f, 0c0c0c, 74a50f, 1f1e16, 4a6300, 38342d, 7f3300, 484a32, 4a3521, 8f5200',
        columns: 10
    },
    clarity: {
        colors: 'ffffff, 292934, f3f2dc, d2533c, 93a299, ad8f67, 726056, 4c5a6a, 808da0, 79463d, f2f2f2, e7e7ec, e7e5b9, f6dcd8, e9ecea, eee8e0, e4dedb, d8dde3, e5e8ec, e9d6d3, d8d8d8, c4c4d1, d5d185, edbab1, d3d9d6, ded2c2, c9beb8, b2bcc8, ccd1d9, d3aea7, bfbfbf, 8a8aa3, aca73b, e4978a, bec7c1, cdbba3, af9e94, 8c9bac, b2bac6, bd857c, a5a5a5, 56566e, 56531d, a43925, 6b7c72, 866b48, 554840, 39434f, 5c697b, 5a342d, 7f7f7f, 3b3b4b, 22210b, 6d2619, 47534c, 594730, 39302b, 262d35, 3d4652, 3c231e',
        columns: 10
    },
    slipstream: {
        colors: 'ffffff, 000000, b4dcfa, 212745, 4e67c8, 5eccf3, a7ea52, 5dceaf, ff8021, f14124, f2f2f2, 7f7f7f, 8bc9f7, c7cce4, dbe0f4, def4fc, edfadc, def5ef, ffe5d2, fcd9d3, d8d8d8, 595959, 4facf3, 909aca, b8c2e9, beeafa, dbf6b9, beebdf, ffcca6, f9b3a7, bfbfbf, 3f3f3f, 0d78c9, 5967af, 94a3de, 9ee0f7, caf297, 9de1cf, ffb279, f68d7b, a5a5a5, 262626, 063c64, 181d33, 31479f, 11b2eb, 81d319, 34ac8b, d85c00, c3260c, 7f7f7f, 0c0c0c, 021828, 101322, 202f6a, 0b769c, 568c11, 22725c, 903d00, 821908',
        columns: 10
    },
    metro: {
        colors: 'ffffff, 000000, d6ecff, 4e5b6f, 7fd13b, ea157a, feb80a, 00addc, 738ac8, 1ab39f, f2f2f2, 7f7f7f, a7d6ff, d9dde4, e5f5d7, fad0e4, fef0cd, c5f2ff, e2e7f4, c9f7f1, d8d8d8, 595959, 60b5ff, b3bcca, cbecb0, f6a1c9, fee29c, 8be6ff, c7d0e9, 94efe3, bfbfbf, 3f3f3f, 007dea, 8d9baf, b2e389, f272af, fed46b, 51d9ff, aab8de, 5fe7d5, a5a5a5, 262626, 003e75, 3a4453, 5ea226, af0f5b, c58c00, 0081a5, 425ea9, 138677, 7f7f7f, 0c0c0c, 00192e, 272d37, 3f6c19, 750a3d, 835d00, 00566e, 2c3f71, 0c594f',
        columns: 10
    },
    flow: {
        colors: 'ffffff, 000000, dbf5f9, 04617b, 0f6fc6, 009dd9, 0bd0d9, 10cf9b, 7cca62, a5c249, f2f2f2, 7f7f7f, b2e9f2, b4ecfc, c7e2fa, c4eeff, c9fafc, c9faed, e4f4df, edf2da, d8d8d8, 595959, 76d9e8, 6adafa, 90c6f6, 89deff, 93f5f9, 94f6db, cae9c0, dbe6b6, bfbfbf, 3f3f3f, 21b2c8, 20c8f7, 59a9f2, 4fceff, 5df0f6, 5ff2ca, b0dfa0, c9da91, a5a5a5, 262626, 105964, 02485c, 0b5394, 0075a2, 089ca2, 0b9b74, 54a838, 7e9532, 7f7f7f, 0c0c0c, 062328, 01303d, 073763, 004e6c, 05686c, 07674d, 387025, 546321',
        columns: 10
    },
    hardcover: {
        colors: 'ffffff, 000000, ece9c6, 895d1d, 873624, d6862d, d0be40, 877f6c, 972109, aeb795, f2f2f2, 7f7f7f, e1dca5, f2e0c6, f0d0c9, f6e6d5, f5f2d8, e7e5e1, fbc7bc, eef0e9, d8d8d8, 595959, d0c974, e6c28d, e2a293, eeceaa, ece5b2, cfccc3, f78f7a, dee2d4, bfbfbf, 3f3f3f, a29a36, daa454, d4735e, e6b681, e2d88c, b7b2a5, f35838, ced3bf, a5a5a5, 262626, 514d1b, 664515, 65281a, a2641f, a39428, 655f50, 711806, 879464, 7f7f7f, 0c0c0c, 201e0a, 442e0e, 431b11, 6c4315, 6d621a, 433f35, 4b1004, 5a6243',
        columns: 10
    },
    trek: {
        colors: 'ffffff, 000000, fbeec9, 4e3b30, f0a22e, a5644e, b58b80, c3986d, a19574, c17529, f2f2f2, 7f7f7f, f7e09e, e1d6cf, fcecd5, eddfda, f0e7e5, f3eae1, ece9e3, f5e3d1, d8d8d8, 595959, f3cc5f, c4ad9f, f9d9ab, dcc0b6, e1d0cc, e7d5c4, d9d4c7, ebc7a3, bfbfbf, 3f3f3f, d29f0f, a78470, f6c781, cba092, d2b9b2, dbc1a7, c6bfab, e1ac76, a5a5a5, 262626, 694f07, 3a2c24, c87d0e, 7b4b3a, 926255, a17242, 7b7153, 90571e, 7f7f7f, 0c0c0c, 2a1f03, 271d18, 855309, 523226, 614138, 6b4c2c, 524b37, 603a14',
        columns: 10
    },
    verve: {
        colors: 'ffffff, 000000, d2d2d2, 666666, ff388c, e40059, 9c007f, 68007f, 005bd3, 00349e, f2f2f2, 7f7f7f, bdbdbd, e0e0e0, ffd7e8, ffc6dc, ffb8f1, f1b2ff, c3dcff, b8cfff, d8d8d8, 595959, 9d9d9d, c1c1c1, ffafd1, ff8eba, ff71e4, e365ff, 87baff, 72a0ff, bfbfbf, 3f3f3f, 696969, a3a3a3, ff87ba, ff5597, ff2ad7, d519ff, 4b98ff, 2b71ff, a5a5a5, 262626, 343434, 4c4c4c, e90062, ab0042, 75005f, 4e005f, 00449e, 002676, 7f7f7f, 0c0c0c, 151515, 333333, 9b0041, 72002c, 4e003f, 34003f, 002d69, 00194f',
        columns: 10
    },
    monochrome: {
        colors: '000000, 1a1a1a, 333333, 4d4d4d, 666666, 808080, 999999, b3b3b3, cccccc, e6e6e6, f2f2f2, ffffff',
        columns: 12
    },
    accessible: {
        colors: 'black, grey, darkred, red, darkorange, gold, green, blue, darkblue, purple, white, darkgrey, saddlebrown, pink, orange, yellow, lightgreen, lightskyblue, lightblue, mediumpurple',
        columns: 10
    }
};

const DEFAULT_PRESET = 'office';
const DEFAULT_ACCESSIBLE_PRESET = 'accessible';
let serial = 0;
/**
 * Represents the [Kendo UI ColorPicker component for Angular]({% slug overview_colorpicker %}).
 * Designed to replace the `<input type="color">` HTML5 tag which is not widely supported in browsers.
 */
class ColorPickerComponent {
    constructor(popupService, localizationService) {
        this.popupService = popupService;
        /**
         * @hidden
         */
        this.hostClasses = true;
        /**
         * @hidden
         */
        this.focusableId = `k-colorpicker-${serial++}`;
        /**
         * Sets what view the ColorPicker will render in the popup.
         */
        this.view = 'gradient';
        /**
         * Sets the read-only state of the ColorPicker.
         */
        this.readonly = false;
        /**
         * Sets the disabled state of the ColorPicker.
         */
        this.disabled = false;
        /**
         * Specifies the output format of the ColorPicker.
         * The input value may be in a different format. However, it will be parsed into the output `format`
         * after the component processes it.
         *
         * If the `gradient` view is used with the `opacity` option set to true, this setting will be ignored and `rgba` will be used instead.
         *
         * The supported values are:
         * * `rgba` (default)
         * * `hex`
         * * [`name`](https://www.w3.org/wiki/CSS/Properties/color/keywords)
         */
        this.format = 'rgba';
        /**
         * Fires each time the value is changed.
         */
        this.valueChange = new EventEmitter();
        /**
         * Fires each time the popup is about to open.
         * This event is preventable. If you cancel it, the popup will remain closed.
         */
        this.open = new EventEmitter();
        /**
         * Fires each time the popup is about to close.
         * This event is preventable. If you cancel it, the popup will remain open.
         */
        this.close = new EventEmitter();
        /**
         * Fires each time ColorPicker is focused.
         */
        this.onFocus = new EventEmitter();
        /**
         * Fires each time the ColorPicker is blurred.
         */
        this.onBlur = new EventEmitter();
        /**
         * Fires each time the left side of the ColorPicker wrapper is clicked.
         * The event is triggered regardless of whether a ColorPicker icon is set or not.
         *
         * The [`ActiveColorClickEvent`]({% slug api_inputs_activecolorclickevent %}) event provides the option to prevent the popup opening.
         */
        this.activeColorClick = new EventEmitter();
        this._tabindex = 0;
        this._popupSettings = { animate: true };
        this._paletteSettings = {};
        this._gradientSettings = { opacity: true, clearButton: false };
        this.notifyNgTouched = () => { };
        this.notifyNgChanged = () => { };
        this.dynamicRTLSubscription = localizationService.changes.subscribe(({ rtl }) => {
            this.direction = rtl ? 'rtl' : 'ltr';
        });
    }
    /**
     * Specifies the value of the initially selected color.
     */
    set value(value) {
        this._value = parseColor$1(value, this.format);
    }
    get value() {
        return this._value;
    }
    /**
     * Configures the popup of the ColorPicker.
     */
    set popupSettings(value) {
        this._popupSettings = Object.assign(this._popupSettings, value);
    }
    get popupSettings() {
        return this._popupSettings;
    }
    /**
     * Configures the palette that is displayed in the ColorPicker popup.
     */
    set paletteSettings(value) {
        this._paletteSettings = Object.assign(this._paletteSettings, value);
    }
    get paletteSettings() {
        return this._paletteSettings;
    }
    /**
     * Configures the gradient that is displayed in the ColorPicker popup.
     */
    set gradientSettings(value) {
        this._gradientSettings = Object.assign(this._gradientSettings, value);
    }
    get gradientSettings() {
        return this._gradientSettings;
    }
    /**
     * Specifies the [`tabindex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) of the component.
     */
    set tabindex(value) {
        const tabindex = Number(value);
        const defaultValue = 0;
        this._tabindex = !isNaN(tabindex) ? tabindex : defaultValue;
    }
    get tabindex() {
        return !this.disabled ? this._tabindex : undefined;
    }
    /**
     * Indicates whether the ColorPicker popup is open.
     */
    get isOpen() {
        return isPresent(this.popupRef);
    }
    /**
     * @hidden
     */
    get iconStyles() {
        if (this.iconClass) {
            return this.iconClass;
        }
        if (this.icon) {
            return `k-icon k-i-${this.icon}`;
        }
    }
    ngOnInit() {
        const defaultPreset = (this.format !== 'name') ? DEFAULT_PRESET : DEFAULT_ACCESSIBLE_PRESET;
        const settingsPalette = this._paletteSettings.palette;
        const presetColumns = typeof settingsPalette === 'string' && PALETTEPRESETS[settingsPalette] ?
            PALETTEPRESETS[settingsPalette].columns :
            undefined;
        this._paletteSettings = {
            palette: settingsPalette || defaultPreset,
            tileSize: this._paletteSettings.tileSize || 24,
            columns: this._paletteSettings.columns || presetColumns || 10
        };
    }
    ngOnChanges(changes) {
        if (changes.format && changes.format.currentValue === 'name') {
            this.view = 'palette';
        }
        if (this.view === 'gradient' && this.gradientSettings.opacity) {
            this.format = 'rgba';
            this.value = parseColor$1(this.value, this.format);
        }
    }
    ngOnDestroy() {
        this.closePopup();
        if (this.dynamicRTLSubscription) {
            this.dynamicRTLSubscription.unsubscribe();
        }
    }
    /**
     * @hidden
     */
    handleWrapperClick() {
        this.toggleWithEvents(!this.isOpen);
        this.focus();
    }
    /**
     * @hidden
     */
    handleActiveColorClick() {
        this.focus();
        const event = new ActiveColorClickEvent(this.value);
        this.activeColorClick.emit(event);
        if (!event.isOpenPrevented() || this.isOpen) {
            this.handleWrapperClick();
        }
    }
    /**
     * Focuses the wrapper of the ColorPicker.
     */
    focus() {
        if (this.disabled) {
            return;
        }
        this.wrapper.nativeElement.focus();
    }
    /**
     * @hidden
     */
    handleWrapperFocus() {
        if (isPresent(this.palette)) {
            this.palette.nativeElement.focus();
        }
        if (this.isFocused) {
            return;
        }
        this.isFocused = true;
        this.onFocus.emit();
    }
    /**
     * Blurs the ColorPicker.
     */
    blur() {
        this.wrapper.nativeElement.blur();
    }
    /**
     * @hidden
     */
    handleWrapperBlur() {
        if (this.isOpen) {
            return;
        }
        this.isFocused = false;
        this.onBlur.emit();
        this.notifyNgTouched();
    }
    /**
     * Clears the color value of the ColorPicker.
     */
    reset() {
        if (!isPresent(this.value)) {
            return;
        }
        this._value = undefined;
        this.notifyNgChanged(undefined);
    }
    /**
     * Toggles the popup of the ColorPicker.
     * Does not trigger the `open` and `close` events of the component.
     *
     * @param open An optional parameter. Specifies whether the popup will be opened or closed.
     */
    toggle(open) {
        if (this.disabled || this.readonly) {
            return;
        }
        this.closePopup();
        open = isPresent(open) ? open : !this.isOpen;
        if (open) {
            this.openPopup();
        }
    }
    /**
     * @hidden
     */
    handleValueChange(color, closePopup) {
        const parsedColor = parseColor$1(color, this.format);
        const valueChange = parsedColor !== this.value;
        if (closePopup) {
            this.toggleWithEvents(false);
            this.focus();
        }
        if (valueChange) {
            this.value = parsedColor;
            this.valueChange.emit(parsedColor);
            this.notifyNgChanged(parsedColor);
        }
    }
    /**
     * @hidden
     */
    handlePopupBlur(event) {
        const focusInPopupElement = this.popupRef.popupElement.contains(event.relatedTarget);
        const wrapperClicked = event.relatedTarget === this.wrapper.nativeElement;
        if (!this.isFocused || wrapperClicked || focusInPopupElement) {
            return;
        }
        this.isFocused = false;
        this.onBlur.emit();
        this.notifyNgTouched();
        this.toggleWithEvents(false);
    }
    /**
     * @hidden
     */
    writeValue(value) {
        this.value = value;
    }
    /**
     * @hidden
     */
    registerOnChange(fn) {
        this.notifyNgChanged = fn;
    }
    /**
     * @hidden
     */
    registerOnTouched(fn) {
        this.notifyNgTouched = fn;
    }
    /**
     * @hidden
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @hidden
     */
    handleWrapperKeyDown(event) {
        if (event.keyCode === Keys.ArrowDown || event.keyCode === Keys.Enter) {
            event.preventDefault();
            this.toggleWithEvents(true);
        }
    }
    /**
     * @hidden
     */
    handlePopupKeyDown(keyCode) {
        if (keyCode === Keys.Tab || keyCode === Keys.Escape) {
            this.toggleWithEvents(false);
            this.wrapper.nativeElement.focus();
        }
    }
    /**
     * @hidden
     * Used by the TextBoxContainer to determine if the component is empty.
     */
    isEmpty() {
        return false;
    }
    toggleWithEvents(open) {
        const sameState = this.isOpen === open;
        if (this.disabled || this.readonly || sameState) {
            return;
        }
        const eventArgs = new PreventableEvent();
        open ? this.open.emit(eventArgs) : this.close.emit(eventArgs);
        if (!eventArgs.isDefaultPrevented()) {
            this.toggle(open);
        }
    }
    openPopup() {
        const horizontalAlign = this.direction === "rtl" ? "right" : "left";
        const anchorPosition = { horizontal: horizontalAlign, vertical: "bottom" };
        const popupPosition = { horizontal: horizontalAlign, vertical: "top" };
        this.popupRef = this.popupService.open({
            anchor: this.wrapper,
            animate: this.popupSettings.animate,
            appendTo: this.popupSettings.appendTo,
            popupAlign: popupPosition,
            anchorAlign: anchorPosition,
            popupClass: 'k-colorpicker-popup',
            content: this.popupTemplate,
            positionMode: 'absolute'
        });
        this.popupRef.popupAnchorViewportLeave.subscribe(() => {
            this.toggleWithEvents(false);
            if (!this.isOpen) {
                this.wrapper.nativeElement.focus({
                    preventScroll: true
                });
            }
        });
    }
    closePopup() {
        if (!this.isOpen) {
            return;
        }
        this.popupRef.close();
        this.popupRef = null;
        this.palette = null;
    }
}
ColorPickerComponent.ɵfac = function ColorPickerComponent_Factory(t) { return new (t || ColorPickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.PopupService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
ColorPickerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ColorPickerComponent, selectors: [["kendo-colorpicker"]], viewQuery: function ColorPickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c50, true, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c51, true, ViewContainerRef);
        ɵngcc0.ɵɵviewQuery(_c23, true);
        ɵngcc0.ɵɵviewQuery(_c52, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.palette = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.wrapper = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popupTemplate = _t.first);
    } }, hostVars: 5, hostBindings: function ColorPickerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.direction);
        ɵngcc0.ɵɵclassProp("k-widget", ctx.hostClasses)("k-colorpicker", ctx.hostClasses);
    } }, inputs: { focusableId: "focusableId", view: "view", readonly: "readonly", disabled: "disabled", format: "format", value: "value", popupSettings: "popupSettings", paletteSettings: "paletteSettings", gradientSettings: "gradientSettings", tabindex: "tabindex", icon: "icon", iconClass: "iconClass" }, outputs: { valueChange: "valueChange", open: "open", close: "close", onFocus: "focus", onBlur: "blur", activeColorClick: "activeColorClick" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                multi: true,
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => ColorPickerComponent)
            }, {
                provide: KendoInput,
                useExisting: forwardRef(() => ColorPickerComponent)
            },
            LocalizationService,
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.colorpicker'
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 10, vars: 9, consts: [["role", "listbox", 3, "ngClass", "id", "focus", "blur", "mousedown", "keydown"], ["wrapper", ""], ["class", "k-selected-color", 3, "background-color", "click", 4, "ngIf"], ["class", "k-tool-icon", 3, "ngClass", "click", 4, "ngIf"], [1, "k-select", 3, "click"], [1, "k-icon", "k-i-arrow-s"], ["popupTemplate", ""], ["container", ""], [1, "k-selected-color", 3, "click"], ["class", "k-icon k-i-line", 4, "ngIf"], [1, "k-icon", "k-i-line"], [1, "k-tool-icon", 3, "ngClass", "click"], [1, "k-selected-color"], ["kendoFocusOnDomReady", "", 3, "value", "format", "opacity", "clearButton", "focusout", "valueChange", "keydown", 4, "ngIf"], ["kendoFocusOnDomReady", "", 3, "palette", "columns", "tileSize", "format", "value", "blur", "cellSelection", "mousedown", "keydown", 4, "ngIf"], ["kendoFocusOnDomReady", "", 3, "value", "format", "opacity", "clearButton", "focusout", "valueChange", "keydown"], ["kendoFocusOnDomReady", "", 3, "palette", "columns", "tileSize", "format", "value", "blur", "cellSelection", "mousedown", "keydown"], ["palette", ""]], template: function ColorPickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0, 1);
        ɵngcc0.ɵɵlistener("focus", function ColorPickerComponent_Template_span_focus_0_listener() { return ctx.handleWrapperFocus(); })("blur", function ColorPickerComponent_Template_span_blur_0_listener() { return ctx.handleWrapperBlur(); })("mousedown", function ColorPickerComponent_Template_span_mousedown_0_listener($event) { return $event.preventDefault(); })("keydown", function ColorPickerComponent_Template_span_keydown_0_listener($event) { return ctx.handleWrapperKeyDown($event); });
        ɵngcc0.ɵɵtemplate(2, ColorPickerComponent_span_2_Template, 2, 3, "span", 2);
        ɵngcc0.ɵɵtemplate(3, ColorPickerComponent_span_3_Template, 2, 3, "span", 3);
        ɵngcc0.ɵɵelementStart(4, "span", 4);
        ɵngcc0.ɵɵlistener("click", function ColorPickerComponent_Template_span_click_4_listener() { return ctx.handleWrapperClick(); });
        ɵngcc0.ɵɵelement(5, "span", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, ColorPickerComponent_ng_template_6_Template, 2, 2, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementContainer(8, null, 7);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(6, _c53, ctx.disabled, ctx.isFocused))("id", ctx.focusableId);
        ɵngcc0.ɵɵattribute("aria-expanded", ctx.isOpen)("tabindex", ctx.tabindex);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.iconStyles);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconStyles);
    } }, directives: function () { return [ɵngcc3.NgClass, ɵngcc3.NgIf, ColorGradientComponent,
        FocusOnDomReadyDirective,
        ColorPaletteComponent]; }, encapsulation: 2 });
/** @nocollapse */
ColorPickerComponent.ctorParameters = () => [
    { type: PopupService },
    { type: LocalizationService }
];
ColorPickerComponent.propDecorators = {
    hostClasses: [{ type: HostBinding, args: ['class.k-widget',] }, { type: HostBinding, args: ['class.k-colorpicker',] }],
    direction: [{ type: HostBinding, args: ['attr.dir',] }],
    focusableId: [{ type: Input }],
    view: [{ type: Input }],
    readonly: [{ type: Input }],
    disabled: [{ type: Input }],
    format: [{ type: Input }],
    value: [{ type: Input }],
    popupSettings: [{ type: Input }],
    paletteSettings: [{ type: Input }],
    gradientSettings: [{ type: Input }],
    icon: [{ type: Input }],
    iconClass: [{ type: Input }],
    tabindex: [{ type: Input }],
    valueChange: [{ type: Output }],
    open: [{ type: Output }],
    close: [{ type: Output }],
    onFocus: [{ type: Output, args: ['focus',] }],
    onBlur: [{ type: Output, args: ['blur',] }],
    activeColorClick: [{ type: Output }],
    container: [{ type: ViewChild, args: ['container', { read: ViewContainerRef },] }],
    wrapper: [{ type: ViewChild, args: ['wrapper',] }],
    popupTemplate: [{ type: ViewChild, args: ['popupTemplate',] }],
    palette: [{ type: ViewChild, args: ['palette', { read: ElementRef },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ColorPickerComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-colorpicker',
                providers: [{
                        multi: true,
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => ColorPickerComponent)
                    }, {
                        provide: KendoInput,
                        useExisting: forwardRef(() => ColorPickerComponent)
                    },
                    LocalizationService,
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.colorpicker'
                    }
                ],
                template: `
        <span
            #wrapper
            [ngClass]="{
                'k-picker-wrap': true,
                'k-state-disabled': this.disabled,
                'k-state-focused': this.isFocused
            }"
            role="listbox"
            [attr.aria-expanded]="isOpen"
            [id]="focusableId"
            [attr.tabindex]="tabindex"
            (focus)="handleWrapperFocus()"
            (blur)="handleWrapperBlur()"
            (mousedown)="$event.preventDefault()"
            (keydown)="handleWrapperKeyDown($event)"
        >
            <span *ngIf="!iconStyles" class="k-selected-color" [style.background-color]="value" (click)="handleActiveColorClick()">
                <span class="k-icon k-i-line" *ngIf="!value"></span>
            </span>
            <span *ngIf="iconStyles" class="k-tool-icon" [ngClass]="iconStyles" (click)="handleActiveColorClick()">
                <span class="k-selected-color" [style.background-color]="value"></span>
            </span>
            <span class="k-select" (click)="handleWrapperClick()">
                <span class="k-icon k-i-arrow-s"></span>
            </span>
        </span>
        <ng-template #popupTemplate>
            <kendo-colorgradient
                *ngIf="view === 'gradient' || view === 'combo'"
                kendoFocusOnDomReady
                [value]="value"
                [format]="format"
                [opacity]="gradientSettings.opacity"
                [clearButton]="gradientSettings.clearButton"
                (focusout)="handlePopupBlur($event)"
                (valueChange)="handleValueChange($event, false)"
                (keydown)="handlePopupKeyDown($event.keyCode)"
            >
            </kendo-colorgradient>
            <kendo-colorpalette
                #palette
                *ngIf="view === 'palette' || view === 'combo'"
                kendoFocusOnDomReady
                [palette]="paletteSettings.palette"
                [columns]="paletteSettings.columns"
                [tileSize]="paletteSettings.tileSize"
                [format]="format"
                [value]="value"
                (blur)="handlePopupBlur($event)"
                (cellSelection)="handleValueChange($event, true)"
                (mousedown)="$event.preventDefault()"
                (keydown)="handlePopupKeyDown($event.keyCode)"
            >
            </kendo-colorpalette>
        </ng-template>
        <ng-container #container></ng-container>
    `
            }]
    }], function () { return [{ type: ɵngcc5.PopupService }, { type: ɵngcc1.LocalizationService }]; }, { hostClasses: [{
            type: HostBinding,
            args: ['class.k-widget']
        }, {
            type: HostBinding,
            args: ['class.k-colorpicker']
        }], focusableId: [{
            type: Input
        }], view: [{
            type: Input
        }], readonly: [{
            type: Input
        }], disabled: [{
            type: Input
        }], format: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], open: [{
            type: Output
        }], close: [{
            type: Output
        }], onFocus: [{
            type: Output,
            args: ['focus']
        }], onBlur: [{
            type: Output,
            args: ['blur']
        }], activeColorClick: [{
            type: Output
        }], direction: [{
            type: HostBinding,
            args: ['attr.dir']
        }], value: [{
            type: Input
        }], popupSettings: [{
            type: Input
        }], paletteSettings: [{
            type: Input
        }], gradientSettings: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], palette: [{
            type: ViewChild,
            args: ['palette', { read: ElementRef }]
        }], icon: [{
            type: Input
        }], iconClass: [{
            type: Input
        }], container: [{
            type: ViewChild,
            args: ['container', { read: ViewContainerRef }]
        }], wrapper: [{
            type: ViewChild,
            args: ['wrapper']
        }], popupTemplate: [{
            type: ViewChild,
            args: ['popupTemplate']
        }] }); })();

/**
 * @hidden
 */
class ColorPaletteService {
    constructor() {
        this.colorRows = [];
    }
    setColorMatrix(palette, columns) {
        this.colorRows = [];
        if (!(isPresent(palette) && palette.length)) {
            return;
        }
        columns = columns || palette.length;
        for (let start = 0; start < palette.length; start += columns) {
            const row = palette.slice(start, columns + start);
            this.colorRows.push(row);
        }
    }
    getCellCoordsFor(color) {
        if (!isPresent(color)) {
            return;
        }
        for (let row = 0; row < this.colorRows.length; row++) {
            for (let col = 0; col < this.colorRows[row].length; col++) {
                if (this.colorRows[row][col] === color) {
                    return { row, col };
                }
            }
        }
    }
    getColorAt(cellCoords) {
        if (!(isPresent(cellCoords) && isPresent(this.colorRows[cellCoords.row]))) {
            return;
        }
        return this.colorRows[cellCoords.row][cellCoords.col];
    }
    getNextCell(current, horizontalStep, verticalStep) {
        if (!(isPresent(current) && isPresent(current.row) && isPresent(current.col))) {
            return { row: 0, col: 0 };
        }
        const row = this.clampIndex(current.row + verticalStep, this.colorRows.length - 1);
        const col = this.clampIndex(current.col + horizontalStep, this.colorRows[row].length - 1);
        return { row, col };
    }
    clampIndex(index, max) {
        const minArrayIndex = 0;
        if (index < minArrayIndex) {
            return minArrayIndex;
        }
        if (index > max) {
            return max;
        }
        return index;
    }
}
ColorPaletteService.ɵfac = function ColorPaletteService_Factory(t) { return new (t || ColorPaletteService)(); };
ColorPaletteService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ColorPaletteService, factory: ColorPaletteService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ColorPaletteService, [{
        type: Injectable
    }], function () { return []; }, null); })();

const DEFAULT_TILE_SIZE = 24;
const DEFAULT_COLUMNS_COUNT = 10;
const DEFAULT_PRESET$1 = 'office';
const DEFAULT_ACCESSIBLE_PRESET$1 = 'accessible';
let serial$1 = 0;
/**
 * The ColorPalette component provides a set of predefined palette presets and enables you to implement a custom color palette.
 * The ColorPalette is independently used by `kendo-colorpicker` and can be directly added to the page.
 */
class ColorPaletteComponent {
    constructor(service, localizationService) {
        this.service = service;
        /**
         * @hidden
         */
        this.id = `k-colorpalette-${serial$1++}`;
        /**
         * Specifies the output format of the ColorPaletteComponent.
         * The input value may be in a different format. However, it will be parsed into the output `format`
         * after the component processes it.
         *
         * The supported values are:
         * * (Default) `hex`
         * * `rgba`
         * * `name`
         */
        this.format = 'hex';
        /**
         * Specifies the size of a color cell.
         *
         * The possible values are:
         * * (Default) `tileSize = 24`
         * * `{ width: number, height: number }`
         */
        this.tileSize = { width: DEFAULT_TILE_SIZE, height: DEFAULT_TILE_SIZE };
        /**
         * Fires each time the color selection is changed.
         */
        this.selectionChange = new EventEmitter();
        /**
         * Fires each time the value is changed.
         */
        this.valueChange = new EventEmitter();
        /**
         * Fires each time the user selects a cell with the mouse or presses `Enter`.
         *
         * @hidden
         */
        this.cellSelection = new EventEmitter();
        /**
         * @hidden
         */
        this.hostClasses = true;
        this._tabindex = 0;
        this.notifyNgTouched = () => { };
        this.notifyNgChanged = () => { };
        this.dynamicRTLSubscription = localizationService.changes.subscribe(({ rtl }) => {
            this.direction = rtl ? 'rtl' : 'ltr';
        });
    }
    /**
     * @hidden
     */
    get paletteId() {
        return this.id;
    }
    /**
     * Specifies the value of the initially selected color.
     */
    set value(value) {
        this._value = parseColor$1(value, this.format);
    }
    get value() {
        return this._value;
    }
    /**
     * Specifies the number of columns that will be displayed.
     * Defaults to `10`.
     */
    set columns(value) {
        const minColumnsCount = 1;
        this._columns = value > minColumnsCount ? value : minColumnsCount;
    }
    get columns() {
        return this._columns;
    }
    /**
     * The color palette that will be displayed.
     *
     * The supported values are:
     * * The name of the predefined palette preset (for example, `office`, `basic`, and `apex`).
     * * A string with comma-separated colors.
     * * A string array.
     */
    set palette(value) {
        if (!isPresent(value)) {
            value = DEFAULT_PRESET$1;
        }
        if (typeof value === 'string' && isPresent(PALETTEPRESETS[value])) {
            this.columns = this.columns || PALETTEPRESETS[value].columns;
            value = PALETTEPRESETS[value].colors;
        }
        const colors = (typeof value === 'string') ? value.split(',') : value;
        this._palette = colors.map(color => parseColor$1(color, this.format, false));
    }
    get palette() {
        return this._palette;
    }
    /**
     * Specifies the [`tabindex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) of the component.
     */
    set tabindex(value) {
        const tabindex = Number(value);
        const defaultValue = 0;
        this._tabindex = !isNaN(tabindex) ? tabindex : defaultValue;
    }
    get tabindex() {
        return !this.disabled ? this._tabindex : undefined;
    }
    /**
     * @hidden
     */
    get tileLayout() {
        if (typeof this.tileSize !== 'number') {
            return this.tileSize;
        }
        return { width: this.tileSize, height: this.tileSize };
    }
    /**
     * @hidden
     */
    get colorRows() {
        return this.service.colorRows;
    }
    /**
     * @hidden
     */
    get hostTabindex() { return this.tabindex; }
    /**
     * @hidden
     */
    get disabledClass() { return this.disabled; }
    ngOnInit() {
        if (this.colorRows.length === 0) {
            const defaultPreset = (this.format !== 'name') ? DEFAULT_PRESET$1 : DEFAULT_ACCESSIBLE_PRESET$1;
            this.palette = this.palette || defaultPreset;
            this.setRows();
            this.focusedCell = this.service.getCellCoordsFor(this.value);
        }
    }
    ngOnDestroy() {
        if (this.dynamicRTLSubscription) {
            this.dynamicRTLSubscription.unsubscribe();
        }
    }
    ngOnChanges(changes) {
        if (changes.palette || changes.columns) {
            this.setRows();
        }
        if (changes.palette || changes.value || changes.columns) {
            this.focusedCell = this.service.getCellCoordsFor(this.value);
        }
    }
    /**
     * @hidden
     */
    handleKeydown(event) {
        const isRTL = this.direction === 'rtl';
        switch (event.keyCode) {
            case Keys.ArrowDown:
                this.handleCellNavigation(0, 1);
                break;
            case Keys.ArrowUp:
                this.handleCellNavigation(0, -1);
                break;
            case Keys.ArrowRight:
                this.handleCellNavigation(isRTL ? -1 : 1, 0);
                break;
            case Keys.ArrowLeft:
                this.handleCellNavigation(isRTL ? 1 : -1, 0);
                break;
            case Keys.Enter:
                this.handleEnter();
                break;
            default: return;
        }
        event.preventDefault();
    }
    /**
     * @hidden
     */
    handleHostBlur() {
        this.notifyNgTouched();
    }
    /**
     * @hidden
     */
    handleCellSelection(value, focusedCell) {
        if (this.readonly) {
            return;
        }
        this.focusedCell = focusedCell;
        const parsedColor = parseColor$1(value, this.format, false);
        this.cellSelection.emit(parsedColor);
        if (this.value !== parsedColor) {
            this.value = parsedColor;
            this.valueChange.emit(parsedColor);
            this.notifyNgChanged(parsedColor);
        }
        if (this.selection !== parsedColor) {
            this.selection = parsedColor;
            this.selectionChange.emit(parsedColor);
        }
    }
    /**
     * @hidden
     */
    writeValue(value) {
        this.value = value;
        this.focusedCell = this.service.getCellCoordsFor(this.value);
    }
    /**
     * @hidden
     */
    registerOnChange(fn) {
        this.notifyNgChanged = fn;
    }
    /**
     * @hidden
     */
    registerOnTouched(fn) {
        this.notifyNgTouched = fn;
    }
    /**
     * @hidden
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @hidden
     * Used by the TextBoxContainer to determine if the component is empty.
     */
    isEmpty() {
        return false;
    }
    /**
     * Clears the color value of the ColorPalette.
     */
    reset() {
        this.focusedCell = null;
        if (isPresent(this.value)) {
            this._value = undefined;
            this.notifyNgChanged(undefined);
        }
    }
    setRows() {
        if (!isPresent(this.palette)) {
            return;
        }
        this.columns = this.columns || DEFAULT_COLUMNS_COUNT;
        this.service.setColorMatrix(this.palette, this.columns);
    }
    handleCellNavigation(horizontalStep, verticalStep) {
        if (this.readonly) {
            return;
        }
        this.focusedCell = this.service.getNextCell(this.focusedCell, horizontalStep, verticalStep);
        const selection = this.service.getColorAt(this.focusedCell);
        if (this.selection !== selection) {
            this.selection = selection;
            this.selectionChange.emit(selection);
        }
    }
    handleEnter() {
        if (!isPresent(this.focusedCell)) {
            return;
        }
        const selectedColor = this.service.getColorAt(this.focusedCell);
        this.handleCellSelection(selectedColor, this.focusedCell);
    }
}
ColorPaletteComponent.ɵfac = function ColorPaletteComponent_Factory(t) { return new (t || ColorPaletteComponent)(ɵngcc0.ɵɵdirectiveInject(ColorPaletteService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
ColorPaletteComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ColorPaletteComponent, selectors: [["kendo-colorpalette"]], hostVars: 9, hostBindings: function ColorPaletteComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function ColorPaletteComponent_keydown_HostBindingHandler($event) { return ctx.handleKeydown($event); })("blur", function ColorPaletteComponent_blur_HostBindingHandler() { return ctx.handleHostBlur(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.direction)("id", ctx.paletteId)("tabindex", ctx.hostTabindex);
        ɵngcc0.ɵɵclassProp("k-widget", ctx.hostClasses)("k-colorpalette", ctx.hostClasses)("k-state-disabled", ctx.disabledClass);
    } }, inputs: { id: "id", format: "format", tileSize: "tileSize", value: "value", columns: "columns", palette: "palette", tabindex: "tabindex", disabled: "disabled", readonly: "readonly" }, outputs: { selectionChange: "selectionChange", valueChange: "valueChange", cellSelection: "cellSelection" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                multi: true,
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => ColorPaletteComponent) // tslint:disable-line:no-forward-ref
            }, {
                provide: KendoInput,
                useExisting: forwardRef(() => ColorPaletteComponent)
            },
            ColorPaletteService,
            LocalizationService,
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.colorpalette'
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 1, consts: [["role", "grid"], ["role", "presentation", 1, "k-palette", "k-reset"], ["role", "row", 4, "ngFor", "ngForOf"], ["role", "row"], ["class", "k-item", 3, "k-state-selected", "ngStyle", "click", 4, "ngFor", "ngForOf"], [1, "k-item", 3, "ngStyle", "click"]], template: function ColorPaletteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "table", 1);
        ɵngcc0.ɵɵelementStart(2, "tbody");
        ɵngcc0.ɵɵtemplate(3, ColorPaletteComponent_tr_3_Template, 2, 1, "tr", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.colorRows);
    } }, directives: [ɵngcc3.NgForOf, ɵngcc3.NgStyle], encapsulation: 2 });
/** @nocollapse */
ColorPaletteComponent.ctorParameters = () => [
    { type: ColorPaletteService },
    { type: LocalizationService }
];
ColorPaletteComponent.propDecorators = {
    direction: [{ type: HostBinding, args: ['attr.dir',] }],
    paletteId: [{ type: HostBinding, args: ['attr.id',] }],
    id: [{ type: Input }],
    format: [{ type: Input }],
    value: [{ type: Input }],
    columns: [{ type: Input }],
    palette: [{ type: Input }],
    tabindex: [{ type: Input }],
    disabled: [{ type: Input }],
    readonly: [{ type: Input }],
    tileSize: [{ type: Input }],
    selectionChange: [{ type: Output }],
    valueChange: [{ type: Output }],
    cellSelection: [{ type: Output }],
    hostTabindex: [{ type: HostBinding, args: ['attr.tabindex',] }],
    hostClasses: [{ type: HostBinding, args: ['class.k-widget',] }, { type: HostBinding, args: ['class.k-colorpalette',] }],
    disabledClass: [{ type: HostBinding, args: ['class.k-state-disabled',] }],
    handleKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
    handleHostBlur: [{ type: HostListener, args: ['blur',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ColorPaletteComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-colorpalette',
                providers: [
                    {
                        multi: true,
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => ColorPaletteComponent) // tslint:disable-line:no-forward-ref
                    }, {
                        provide: KendoInput,
                        useExisting: forwardRef(() => ColorPaletteComponent)
                    },
                    ColorPaletteService,
                    LocalizationService,
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.colorpalette'
                    }
                ],
                template: `
        <div role="grid">
            <table class="k-palette k-reset" role="presentation">
                <tbody>
                    <tr role="row" *ngFor="let row of colorRows; let rowIndex = index">
                        <td *ngFor="let color of row; let colIndex = index"
                            [class.k-state-selected]="focusedCell?.row === rowIndex && focusedCell?.col === colIndex"
                            class="k-item"
                            [attr.value]="color"
                            (click)="handleCellSelection(color, { row: rowIndex, col: colIndex })"
                            [ngStyle]="{
                                backgroundColor: color,
                                width: tileLayout.width + 'px',
                                height: tileLayout.height + 'px',
                                minWidth: tileLayout.width + 'px'
                            }">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    `
            }]
    }], function () { return [{ type: ColorPaletteService }, { type: ɵngcc1.LocalizationService }]; }, { id: [{
            type: Input
        }], format: [{
            type: Input
        }], tileSize: [{
            type: Input
        }], selectionChange: [{
            type: Output
        }], valueChange: [{
            type: Output
        }], cellSelection: [{
            type: Output
        }], hostClasses: [{
            type: HostBinding,
            args: ['class.k-widget']
        }, {
            type: HostBinding,
            args: ['class.k-colorpalette']
        }], direction: [{
            type: HostBinding,
            args: ['attr.dir']
        }], paletteId: [{
            type: HostBinding,
            args: ['attr.id']
        }], value: [{
            type: Input
        }], columns: [{
            type: Input
        }], palette: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], hostTabindex: [{
            type: HostBinding,
            args: ['attr.tabindex']
        }], disabledClass: [{
            type: HostBinding,
            args: ['class.k-state-disabled']
        }], handleKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], handleHostBlur: [{
            type: HostListener,
            args: ['blur']
        }], disabled: [{
            type: Input
        }], readonly: [{
            type: Input
        }] }); })();

const DEFAULT_OUTPUT_FORMAT = 'rgba';
const DEFAULT_BACKGROUND_COLOR = 'rgba(255, 0, 0, 1)';
let serial$2 = 0;
/**
 * The ColorGradient component enables smooth color transitions and provides options for selecting specific colors over the drag handle.
 * The ColorGradient is independently used by `kendo-colorpicker` and can be directly added to the page.
 */
class ColorGradientComponent {
    constructor(host, ngZone, renderer, cdr, localizationService) {
        this.host = host;
        this.ngZone = ngZone;
        this.renderer = renderer;
        this.cdr = cdr;
        this.hostClasses = true;
        /**
         * @hidden
         */
        this.id = `k-colorgradient-${serial$2++}`;
        /**
         * Defines whether the alpha slider will be displayed.
         */
        this.opacity = true;
        /**
         * Sets the disabled state of the ColorGradient.
         */
        this.disabled = false;
        /**
         * Sets the read-only state of the ColorGradient.
         */
        this.readonly = false;
        /**
         * Specifies whether the ColorGradient should display a 'Clear color' button.
         */
        this.clearButton = false;
        /**
         * Fires each time the user selects a new color.
         */
        this.valueChange = new EventEmitter();
        /**
         * @hidden
         */
        this.backgroundColor = DEFAULT_BACKGROUND_COLOR;
        /**
         * @hidden
         *
         * Represents the currently selected `hue`, `saturation`, `value`, and `alpha` values.
         * The values are initially set in `ngOnInit` or in `ngOnChanges` and are
         * updated on moving the drag handle or the sliders.
         */
        this.hsva = {};
        /**
         * Specifies the output format of the ColorGradientComponent.
         * The input value may be in a different format. However, it will be parsed into the output `format`
         * after the component processes it.
         *
         * The supported values are:
         * * (Default) `rgba`
         * * `hex`
         */
        this.format = DEFAULT_OUTPUT_FORMAT;
        this._tabindex = 0;
        this.listeners = [];
        this.notifyNgChanged = () => { };
        this.notifyNgTouched = () => { };
        this.dynamicRTLSubscription = localizationService.changes.subscribe(({ rtl }) => {
            this.direction = rtl ? 'rtl' : 'ltr';
        });
    }
    get disabledClass() {
        return this.disabled;
    }
    get hostTabindex() {
        return this.tabindex;
    }
    /**
     * @hidden
     */
    get gradientId() {
        return this.id;
    }
    /**
     * Specifies the value of the initially selected color.
     */
    set value(value) {
        this._value = parseColor$1(value, this.format);
    }
    get value() {
        return this._value;
    }
    /**
     * Specifies the [`tabindex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) of the component.
     */
    set tabindex(value) {
        const tabindex = Number(value);
        const defaultValue = 0;
        this._tabindex = !isNaN(tabindex) ? tabindex : defaultValue;
    }
    get tabindex() {
        return !this.disabled ? this._tabindex : undefined;
    }
    /**
     * Indicates whether the ColorGradient or any of its content is focused.
     */
    get isFocused() {
        if (!(isDocumentAvailable() && isPresent(this.host))) {
            return false;
        }
        return this.host.nativeElement === document.activeElement || this.host.nativeElement.contains(document.activeElement);
    }
    /**
     * @hidden
     */
    get alphaSliderValue() {
        // setting the initial value to undefined to force the slider to recalculate the height of the slider track on the next cdr run
        if (!(isPresent(this.hsva) && isPresent(this.hsva.a))) {
            return;
        }
        return this.hsva.a * 100;
    }
    get gradientRect() {
        return this.gradientWrapper.nativeElement.getBoundingClientRect();
    }
    ngAfterViewInit() {
        this.updateUI();
        this.cdr.detectChanges();
        this.addEventListeners();
    }
    ngOnChanges(changes) {
        if (isChanged('value', changes) && !this.isFocused) {
            this.updateUI();
        }
    }
    ngOnDestroy() {
        this.listeners.forEach(removeListener => removeListener());
        if (this.dynamicRTLSubscription) {
            this.dynamicRTLSubscription.unsubscribe();
        }
    }
    /**
     * Focuses the component.
     */
    focus() {
        if (this.disabled) {
            return;
        }
        this.host.nativeElement.focus();
    }
    /**
     * @hidden
     */
    reset() {
        this.handleValueChange(undefined);
        this.updateUI();
    }
    /**
     * @hidden
     */
    handleDragPress(args) {
        if (this.disabled || this.readonly || !isPresent(args.originalEvent)) {
            return;
        }
        this.focus();
        args.originalEvent.preventDefault();
    }
    /**
     * @hidden
     */
    onHandleDrag(args) {
        if (this.disabled || this.readonly) {
            return;
        }
        this.renderer.addClass(this.gradientWrapper.nativeElement, 'k-dragging');
        this.changePosition(args);
    }
    /**
     * @hidden
     */
    onHandleRelease() {
        if (this.disabled || this.readonly) {
            return;
        }
        this.renderer.removeClass(this.gradientWrapper.nativeElement, 'k-dragging');
    }
    /**
     * @hidden
     */
    changePosition(position) {
        if (this.disabled || this.readonly) {
            return;
        }
        this.ngZone.run(() => this.moveDragHandle(position));
    }
    /**
     * @hidden
     */
    handleHueSliderChange(hue) {
        this.handleValueChange(getColorFromHSV(this.hsva));
        this.backgroundColor = getColorFromHue(hue);
        this.setAlphaSliderBackground(this.backgroundColor);
    }
    /**
     * @hidden
     */
    handleAlphaSliderChange(alpha) {
        this.hsva.a = alpha / 100;
        this.handleValueChange(getColorFromHSV(this.hsva));
    }
    /**
     * @hidden
     */
    handleInputsValueChange(color) {
        const parsed = parseColor$1(color, this.format);
        if (this.value !== parsed) {
            this.handleValueChange(parsed);
            this.updateUI();
        }
    }
    /**
     * @hidden
     */
    writeValue(value) {
        this.value = value;
        if (isPresent(this.gradientWrapper)) {
            this.updateUI();
        }
    }
    /**
     * @hidden
     */
    registerOnChange(fn) {
        this.notifyNgChanged = fn;
    }
    /**
     * @hidden
     */
    registerOnTouched(fn) {
        this.notifyNgTouched = fn;
    }
    /**
     * @hidden
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @hidden
     * Used by the TextBoxContainer to determine if the component is empty.
     */
    isEmpty() {
        return false;
    }
    moveDragHandle(position) {
        const deltaX = position.clientX - this.gradientRect.left;
        const deltaY = position.clientY - this.gradientRect.top;
        const top = fitIntoBounds(deltaY, 0, this.gradientRect.height);
        const left = fitIntoBounds(deltaX, 0, this.gradientRect.width);
        this.setDragHandleElementPosition(top, left);
        this.hsva.s = left / this.gradientRect.width;
        this.hsva.v = 1 - top / this.gradientRect.height;
        this.handleValueChange(getColorFromHSV(this.hsva));
        this.setAlphaSliderBackground(getColorFromHSV(Object.assign({}, this.hsva, { a: 1 })));
    }
    updateUI() {
        if (!isDocumentAvailable()) {
            return;
        }
        this.hsva = this.value ? getHSV(this.value) : { h: 0, s: 0, v: 1, a: 1 };
        const top = (1 - this.hsva.v) * this.gradientRect.height;
        const left = this.hsva.s * this.gradientRect.width;
        this.setDragHandleElementPosition(top, left);
        this.backgroundColor = getColorFromHue(this.hsva.h);
        this.setAlphaSliderBackground(this.backgroundColor);
    }
    handleValueChange(color) {
        if (this.value === color) {
            return;
        }
        this.value = color;
        this.valueChange.emit(color);
        this.notifyNgChanged(color);
    }
    setDragHandleElementPosition(top, left) {
        const dragHandle = this.dragHandle.nativeElement;
        this.renderer.setStyle(dragHandle, 'top', `${top}px`);
        this.renderer.setStyle(dragHandle, 'left', `${left}px`);
    }
    setAlphaSliderBackground(backgroundColor) {
        if (!isPresent(this.alphaSlider)) {
            return;
        }
        const sliderTrack = this.alphaSlider.track.nativeElement;
        this.renderer.setStyle(sliderTrack, 'background', `linear-gradient(to top, transparent, ${backgroundColor})`);
    }
    addEventListeners() {
        this.ngZone.runOutsideAngular(() => {
            const focusOutListener = this.renderer.listen(this.host.nativeElement, 'focusout', (event) => {
                if (!containsFocus(this.host.nativeElement, event.relatedTarget) && isUntouched(this.host)) {
                    this.ngZone.run(() => this.notifyNgTouched());
                }
            });
            this.listeners.push(focusOutListener);
        });
    }
}
ColorGradientComponent.ɵfac = function ColorGradientComponent_Factory(t) { return new (t || ColorGradientComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
ColorGradientComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ColorGradientComponent, selectors: [["kendo-colorgradient"]], viewQuery: function ColorGradientComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c55, true);
        ɵngcc0.ɵɵviewQuery(_c56, true);
        ɵngcc0.ɵɵviewQuery(_c57, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.alphaSlider = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.gradientWrapper = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dragHandle = _t.first);
    } }, hostVars: 9, hostBindings: function ColorGradientComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.direction)("tabindex", ctx.hostTabindex)("id", ctx.gradientId);
        ɵngcc0.ɵɵclassProp("k-widget", ctx.hostClasses)("k-flatcolorpicker", ctx.hostClasses)("k-state-disabled", ctx.disabledClass);
    } }, inputs: { id: "id", opacity: "opacity", disabled: "disabled", readonly: "readonly", clearButton: "clearButton", format: "format", value: "value", tabindex: "tabindex" }, outputs: { valueChange: "valueChange" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                multi: true,
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => ColorGradientComponent)
            }, {
                provide: KendoInput,
                useExisting: forwardRef(() => ColorGradientComponent)
            },
            LocalizationService,
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.colorgradient'
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 11, vars: 21, consts: [[1, "k-hbox", "k-hsv-wrap"], [1, "k-hsv-rectangle"], ["kendoDraggable", "", 1, "k-hsv-gradient", 3, "click", "kendoPress", "kendoDrag", "kendoRelease"], ["gradientWrapper", ""], [1, "k-draghandle"], ["dragHandle", ""], ["class", "k-clear-color k-button k-bare k-button-icon", 3, "click", 4, "ngIf"], [1, "k-hue-slider", 3, "disabled", "readonly", "showButtons", "tickPlacement", "vertical", "min", "max", "smallStep", "largeStep", "value", "valueChange"], ["class", "k-alpha-slider", 3, "disabled", "readonly", "showButtons", "tickPlacement", "vertical", "min", "max", "smallStep", "largeStep", "value", "valueChange", 4, "ngIf"], [3, "opacity", "value", "disabled", "readonly", "valueChange"], [1, "k-clear-color", "k-button", "k-bare", "k-button-icon", 3, "click"], [1, "k-icon", "k-i-reset-color"], [1, "k-alpha-slider", 3, "disabled", "readonly", "showButtons", "tickPlacement", "vertical", "min", "max", "smallStep", "largeStep", "value", "valueChange"], ["alphaSlider", ""]], template: function ColorGradientComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2, 3);
        ɵngcc0.ɵɵlistener("click", function ColorGradientComponent_Template_div_click_2_listener($event) { return ctx.changePosition($event); })("kendoPress", function ColorGradientComponent_Template_div_kendoPress_2_listener($event) { return ctx.handleDragPress($event); })("kendoDrag", function ColorGradientComponent_Template_div_kendoDrag_2_listener($event) { return ctx.onHandleDrag($event); })("kendoRelease", function ColorGradientComponent_Template_div_kendoRelease_2_listener() { return ctx.onHandleRelease(); });
        ɵngcc0.ɵɵelement(4, "div", 4, 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div");
        ɵngcc0.ɵɵtemplate(7, ColorGradientComponent_span_7_Template, 2, 0, "span", 6);
        ɵngcc0.ɵɵelementStart(8, "kendo-slider", 7);
        ɵngcc0.ɵɵlistener("valueChange", function ColorGradientComponent_Template_kendo_slider_valueChange_8_listener($event) { return ctx.hsva.h = $event; })("valueChange", function ColorGradientComponent_Template_kendo_slider_valueChange_8_listener($event) { return ctx.handleHueSliderChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, ColorGradientComponent_kendo_slider_9_Template, 2, 10, "kendo-slider", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "kendo-colorinput", 9);
        ɵngcc0.ɵɵlistener("valueChange", function ColorGradientComponent_Template_kendo_colorinput_valueChange_10_listener($event) { return ctx.handleInputsValueChange($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("background-color", ctx.backgroundColor);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵclassMapInterpolate1("k-hbox k-sliders-wrap ", ctx.clearButton ? "k-sliders-wrap-clearable" : "", "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.clearButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("readonly", ctx.readonly)("showButtons", false)("tickPlacement", "none")("vertical", true)("min", 0)("max", 360)("smallStep", 5)("largeStep", 10)("value", ctx.hsva.h);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.opacity && ctx.format === "rgba");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("opacity", ctx.opacity)("value", ctx.value)("disabled", ctx.disabled)("readonly", ctx.readonly);
    } }, directives: function () { return [ɵngcc2.DraggableDirective, ɵngcc3.NgIf, SliderComponent,
        ColorInputComponent]; }, encapsulation: 2 });
/** @nocollapse */
ColorGradientComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone },
    { type: Renderer2 },
    { type: ChangeDetectorRef },
    { type: LocalizationService }
];
ColorGradientComponent.propDecorators = {
    hostClasses: [{ type: HostBinding, args: ['class.k-widget',] }, { type: HostBinding, args: ['class.k-flatcolorpicker',] }],
    disabledClass: [{ type: HostBinding, args: ['class.k-state-disabled',] }],
    hostTabindex: [{ type: HostBinding, args: ['attr.tabindex',] }],
    gradientId: [{ type: HostBinding, args: ['attr.id',] }],
    id: [{ type: Input }],
    direction: [{ type: HostBinding, args: ['attr.dir',] }],
    opacity: [{ type: Input }],
    disabled: [{ type: Input }],
    readonly: [{ type: Input }],
    clearButton: [{ type: Input }],
    value: [{ type: Input }],
    tabindex: [{ type: Input }],
    valueChange: [{ type: Output }],
    format: [{ type: Input }],
    alphaSlider: [{ type: ViewChild, args: ['alphaSlider',] }],
    gradientWrapper: [{ type: ViewChild, args: ['gradientWrapper',] }],
    dragHandle: [{ type: ViewChild, args: ['dragHandle',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ColorGradientComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-colorgradient',
                providers: [{
                        multi: true,
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => ColorGradientComponent)
                    }, {
                        provide: KendoInput,
                        useExisting: forwardRef(() => ColorGradientComponent)
                    },
                    LocalizationService,
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.colorgradient'
                    }
                ],
                template: `
        <div class="k-hbox k-hsv-wrap">
            <div class="k-hsv-rectangle" [style.background-color]="backgroundColor">
                <div
                    #gradientWrapper
                    kendoDraggable
                    class="k-hsv-gradient"
                    (click)="changePosition($event)"
                    (kendoPress)="handleDragPress($event)"
                    (kendoDrag)="onHandleDrag($event)"
                    (kendoRelease)="onHandleRelease()">
                    <div
                        #dragHandle
                        class="k-draghandle"
                    >
                    </div>
                </div>
            </div>
            <div class="k-hbox k-sliders-wrap {{ clearButton ? 'k-sliders-wrap-clearable' : '' }}">
                <span class="k-clear-color k-button k-bare k-button-icon" *ngIf="clearButton" (click)="reset()">
                    <span class="k-icon k-i-reset-color"></span>
                </span>
                <kendo-slider
                    class="k-hue-slider"
                    [disabled]="disabled"
                    [readonly]="readonly"
                    [showButtons]="false"
                    [tickPlacement]="'none'"
                    [vertical]="true"
                    [min]="0"
                    [max]="360"
                    [smallStep]="5"
                    [largeStep]="10"
                    [(value)]="hsva.h"
                    (valueChange)="handleHueSliderChange($event)"
                >
                </kendo-slider>
                <kendo-slider
                    *ngIf="opacity && format === 'rgba'"
                    #alphaSlider
                    class="k-alpha-slider"
                    [disabled]="disabled"
                    [readonly]="readonly"
                    [showButtons]="false"
                    [tickPlacement]="'none'"
                    [vertical]="true"
                    [min]="0"
                    [max]="100"
                    [smallStep]="1"
                    [largeStep]="10"
                    [value]="alphaSliderValue"
                    (valueChange)="handleAlphaSliderChange($event)"
                >
                </kendo-slider>
            </div>
        </div>
        <kendo-colorinput
            [opacity]="opacity"
            [value]="value"
            [disabled]="disabled"
            [readonly]="readonly"
            (valueChange)="handleInputsValueChange($event)"
        >
        </kendo-colorinput>
`
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc1.LocalizationService }]; }, { hostClasses: [{
            type: HostBinding,
            args: ['class.k-widget']
        }, {
            type: HostBinding,
            args: ['class.k-flatcolorpicker']
        }], id: [{
            type: Input
        }], opacity: [{
            type: Input
        }], disabled: [{
            type: Input
        }], readonly: [{
            type: Input
        }], clearButton: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], format: [{
            type: Input
        }], direction: [{
            type: HostBinding,
            args: ['attr.dir']
        }], disabledClass: [{
            type: HostBinding,
            args: ['class.k-state-disabled']
        }], hostTabindex: [{
            type: HostBinding,
            args: ['attr.tabindex']
        }], gradientId: [{
            type: HostBinding,
            args: ['attr.id']
        }], value: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], alphaSlider: [{
            type: ViewChild,
            args: ['alphaSlider']
        }], gradientWrapper: [{
            type: ViewChild,
            args: ['gradientWrapper']
        }], dragHandle: [{
            type: ViewChild,
            args: ['dragHandle']
        }] }); })();

/**
 * @hidden
 */
class ColorInputComponent {
    constructor(host) {
        this.host = host;
        /**
         * Sets whether the alpha slider will be shown.
         */
        this.opacity = true;
        /**
         * Sets the disabled state of the ColorInput.
         */
        this.disabled = false;
        /**
         * Sets the read-only state of the ColorInput.
         */
        this.readonly = false;
        /**
         * Emits a parsed rgba string color.
         */
        this.valueChange = new EventEmitter();
        this.colorInputClass = true;
        /**
         * The rgba inputs values.
         */
        this.rgba = {};
    }
    /**
     * Indicates whether any of the inputs are focused.
     */
    get isFocused() {
        if (!(isDocumentAvailable() && isPresent(this.host))) {
            return false;
        }
        const activeElement = document.activeElement;
        return this.host.nativeElement.contains(activeElement);
    }
    /**
     * Indicates whether any of the rgba inputs have value.
     */
    get rgbaInputValid() {
        return Object.keys(this.rgba).every(key => isPresent(this.rgba[key]));
    }
    ngOnChanges(changes) {
        if (isPresent(changes.value) && !this.isFocused) {
            this.hex = parseColor$1(this.value, 'hex');
            this.rgba = getRGBA(this.value);
            this.rgba.a = parseColor$1(this.value, 'rgba') ? this.rgba.a : 1;
        }
    }
    handleRgbaValueChange() {
        const color = getColorFromRGBA(this.rgba);
        if (!this.rgbaInputValid || color === this.value) {
            return;
        }
        this.value = color;
        this.rgba = getRGBA(this.value);
        this.hex = parseColor$1(color, 'hex');
        this.valueChange.emit(color);
    }
    handleHexValueChange(hex) {
        this.hex = hex;
        const color = parseColor$1(hex, 'rgba');
        if (!isPresent(color) || color === this.value) {
            return;
        }
        this.value = color;
        this.rgba = getRGBA(color);
        this.valueChange.emit(color);
    }
    handleRgbaInputBlur() {
        if (!this.rgbaInputValid) {
            this.rgba = getRGBA(this.value);
        }
    }
    handleHexInputBlur() {
        this.hex = parseColor$1(this.value, 'hex');
    }
}
ColorInputComponent.ɵfac = function ColorInputComponent_Factory(t) { return new (t || ColorInputComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ColorInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ColorInputComponent, selectors: [["kendo-colorinput"]], hostVars: 2, hostBindings: function ColorInputComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-colorinputs", ctx.colorInputClass);
    } }, inputs: { opacity: "opacity", disabled: "disabled", readonly: "readonly", value: "value" }, outputs: { valueChange: "valueChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 17, vars: 32, consts: [[1, "k-hbox", "k-gradient-values"], ["placeholder", "no color", 1, "k-textbox", "k-hex-value", 3, "disabled", "readonly", "value", "blur", "input"], ["hexInput", ""], ["placeholder", "R", 3, "disabled", "readonly", "min", "max", "value", "autoCorrect", "spinners", "format", "decimals", "valueChange", "blur"], ["placeholder", "G", 3, "disabled", "readonly", "min", "max", "value", "autoCorrect", "spinners", "format", "decimals", "valueChange", "blur"], ["placeholder", "B", 3, "disabled", "readonly", "min", "max", "value", "autoCorrect", "spinners", "format", "decimals", "valueChange", "blur"], ["placeholder", "A", 3, "disabled", "readonly", "min", "max", "value", "autoCorrect", "spinners", "step", "format", "decimals", "valueChange", "blur", 4, "ngIf"], [1, "k-hex-value"], [4, "ngIf"], ["placeholder", "A", 3, "disabled", "readonly", "min", "max", "value", "autoCorrect", "spinners", "step", "format", "decimals", "valueChange", "blur"]], template: function ColorInputComponent_Template(rf, ctx) { if (rf & 1) {
        const _r310 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "input", 1, 2);
        ɵngcc0.ɵɵlistener("blur", function ColorInputComponent_Template_input_blur_1_listener() { return ctx.handleHexInputBlur(); })("input", function ColorInputComponent_Template_input_input_1_listener() { ɵngcc0.ɵɵrestoreView(_r310); const _r303 = ɵngcc0.ɵɵreference(2); return ctx.handleHexValueChange(_r303.value); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "kendo-numerictextbox", 3);
        ɵngcc0.ɵɵlistener("valueChange", function ColorInputComponent_Template_kendo_numerictextbox_valueChange_3_listener($event) { return ctx.rgba.r = $event; })("blur", function ColorInputComponent_Template_kendo_numerictextbox_blur_3_listener() { return ctx.handleRgbaInputBlur(); })("valueChange", function ColorInputComponent_Template_kendo_numerictextbox_valueChange_3_listener() { return ctx.handleRgbaValueChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "kendo-numerictextbox", 4);
        ɵngcc0.ɵɵlistener("valueChange", function ColorInputComponent_Template_kendo_numerictextbox_valueChange_4_listener($event) { return ctx.rgba.g = $event; })("blur", function ColorInputComponent_Template_kendo_numerictextbox_blur_4_listener() { return ctx.handleRgbaInputBlur(); })("valueChange", function ColorInputComponent_Template_kendo_numerictextbox_valueChange_4_listener() { return ctx.handleRgbaValueChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "kendo-numerictextbox", 5);
        ɵngcc0.ɵɵlistener("valueChange", function ColorInputComponent_Template_kendo_numerictextbox_valueChange_5_listener($event) { return ctx.rgba.b = $event; })("blur", function ColorInputComponent_Template_kendo_numerictextbox_blur_5_listener() { return ctx.handleRgbaInputBlur(); })("valueChange", function ColorInputComponent_Template_kendo_numerictextbox_valueChange_5_listener() { return ctx.handleRgbaValueChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, ColorInputComponent_kendo_numerictextbox_6_Template, 1, 10, "kendo-numerictextbox", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 0);
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵtext(9, "hex");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div");
        ɵngcc0.ɵɵtext(11, "r");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div");
        ɵngcc0.ɵɵtext(13, "g");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div");
        ɵngcc0.ɵɵtext(15, "b");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(16, ColorInputComponent_div_16_Template, 2, 0, "div", 8);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("readonly", ctx.readonly)("value", ctx.hex || "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("readonly", ctx.readonly)("min", 0)("max", 255)("value", ctx.rgba.r)("autoCorrect", true)("spinners", false)("format", "n")("decimals", 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("readonly", ctx.readonly)("min", 0)("max", 255)("value", ctx.rgba.g)("autoCorrect", true)("spinners", false)("format", "n")("decimals", 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("readonly", ctx.readonly)("min", 0)("max", 255)("value", ctx.rgba.b)("autoCorrect", true)("spinners", false)("format", "n")("decimals", 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.opacity);
        ɵngcc0.ɵɵadvance(10);
        ɵngcc0.ɵɵproperty("ngIf", ctx.opacity);
    } }, directives: [NumericTextBoxComponent, ɵngcc3.NgIf], encapsulation: 2 });
/** @nocollapse */
ColorInputComponent.ctorParameters = () => [
    { type: ElementRef }
];
ColorInputComponent.propDecorators = {
    value: [{ type: Input }],
    opacity: [{ type: Input }],
    disabled: [{ type: Input }],
    readonly: [{ type: Input }],
    valueChange: [{ type: Output }],
    colorInputClass: [{ type: HostBinding, args: ['class.k-colorinputs',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ColorInputComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-colorinput',
                template: `
        <div class="k-hbox k-gradient-values">
            <input
                #hexInput
                class="k-textbox k-hex-value"
                [disabled]="disabled"
                [readonly]="readonly"
                [value]="hex || ''"
                placeholder="no color"
                (blur)="handleHexInputBlur()"
                (input)="handleHexValueChange(hexInput.value)"
            />
            <kendo-numerictextbox
                [disabled]="disabled"
                [readonly]="readonly"
                [min]="0"
                [max]="255"
                placeholder="R"
                [(value)]="rgba.r"
                [autoCorrect]="true"
                [spinners]="false"
                [format]="'n'"
                [decimals]="0"
                (blur)="handleRgbaInputBlur()"
                (valueChange)="handleRgbaValueChange()"
            >
            </kendo-numerictextbox>
            <kendo-numerictextbox
                [disabled]="disabled"
                [readonly]="readonly"
                [min]="0"
                [max]="255"
                placeholder="G"
                [(value)]="rgba.g"
                [autoCorrect]="true"
                [spinners]="false"
                [format]="'n'"
                [decimals]="0"
                (blur)="handleRgbaInputBlur()"
                (valueChange)="handleRgbaValueChange()"
            >
            </kendo-numerictextbox>
            <kendo-numerictextbox
                [disabled]="disabled"
                [readonly]="readonly"
                [min]="0"
                [max]="255"
                placeholder="B"
                [(value)]="rgba.b"
                [autoCorrect]="true"
                [spinners]="false"
                [format]="'n'"
                [decimals]="0"
                (blur)="handleRgbaInputBlur()"
                (valueChange)="handleRgbaValueChange()"
            >
            </kendo-numerictextbox>
            <kendo-numerictextbox
                *ngIf="opacity"
                [disabled]="disabled"
                [readonly]="readonly"
                [min]="0"
                [max]="1"
                placeholder="A"
                [(value)]="rgba.a"
                [autoCorrect]="true"
                [spinners]="false"
                [step]="0.01"
                [format]="'n2'"
                [decimals]="2"
                (blur)="handleRgbaInputBlur()"
                (valueChange)="handleRgbaValueChange()"
            >
            </kendo-numerictextbox>
        </div>
        <div class="k-hbox k-gradient-values">
            <div class="k-hex-value">hex</div>
            <div>r</div>
            <div>g</div>
            <div>b</div>
            <div *ngIf="opacity">a</div>
        </div>
    `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { opacity: [{
            type: Input
        }], disabled: [{
            type: Input
        }], readonly: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], colorInputClass: [{
            type: HostBinding,
            args: ['class.k-colorinputs']
        }], value: [{
            type: Input
        }] }); })();

/**
 * @hidden
 */
class FocusOnDomReadyDirective {
    constructor(host, ngZone) {
        this.host = host;
        this.ngZone = ngZone;
    }
    ngAfterContentInit() {
        this.focusOnNextTick();
    }
    focusOnNextTick() {
        this.ngZone.runOutsideAngular(() => setTimeout(() => this.host.nativeElement.focus()));
    }
}
FocusOnDomReadyDirective.ɵfac = function FocusOnDomReadyDirective_Factory(t) { return new (t || FocusOnDomReadyDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
FocusOnDomReadyDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FocusOnDomReadyDirective, selectors: [["", "kendoFocusOnDomReady", ""]] });
/** @nocollapse */
FocusOnDomReadyDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FocusOnDomReadyDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoFocusOnDomReady]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();

const PUBLIC_DIRECTIVES = [
    ColorPickerComponent,
    ColorPaletteComponent,
    ColorGradientComponent
];
const INTERNAL_DIRECTIVES = [
    ColorInputComponent,
    FocusOnDomReadyDirective
];
/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the ColorPicker.
 */
class ColorPickerModule {
}
ColorPickerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ColorPickerModule });
ColorPickerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ColorPickerModule_Factory(t) { return new (t || ColorPickerModule)(); }, imports: [[
            SliderModule,
            NumericTextBoxModule,
            CommonModule,
            PopupModule,
            DraggableModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ColorPickerModule, { declarations: function () { return [ColorPickerComponent,
        ColorPaletteComponent,
        ColorGradientComponent,
        ColorInputComponent,
        FocusOnDomReadyDirective]; }, imports: function () { return [SliderModule,
        NumericTextBoxModule,
        CommonModule,
        PopupModule,
        DraggableModule]; }, exports: function () { return [ColorPickerComponent,
        ColorPaletteComponent,
        ColorGradientComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ColorPickerModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    PUBLIC_DIRECTIVES,
                    INTERNAL_DIRECTIVES
                ],
                exports: [PUBLIC_DIRECTIVES],
                imports: [
                    SliderModule,
                    NumericTextBoxModule,
                    CommonModule,
                    PopupModule,
                    DraggableModule
                ]
            }]
    }], null, null); })();

/**
 * Represents the directive that renders the [Kendo UI CheckBox]({% slug overview_checkbox %}) input component.
 * The directive is placed on input type="checkbox" elements.
 *
 * @example
 * ```ts-no-run
 * <input type="checkbox" kendoCheckBox />
 * ```
 */
class CheckBoxDirective {
    constructor() {
        this.kendoClass = true;
    }
}
CheckBoxDirective.ɵfac = function CheckBoxDirective_Factory(t) { return new (t || CheckBoxDirective)(); };
CheckBoxDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CheckBoxDirective, selectors: [["input", "kendoCheckBox", ""]], hostVars: 2, hostBindings: function CheckBoxDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-checkbox", ctx.kendoClass);
    } } });
CheckBoxDirective.propDecorators = {
    kendoClass: [{ type: HostBinding, args: ['class.k-checkbox',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CheckBoxDirective, [{
        type: Directive,
        args: [{
                selector: 'input[kendoCheckBox]'
            }]
    }], function () { return []; }, { kendoClass: [{
            type: HostBinding,
            args: ['class.k-checkbox']
        }] }); })();

/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the CheckBox directive.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the CheckBox module
 * import { CheckBoxModule } from '@progress/kendo-angular-inputs';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, CheckBoxModule], // import CheckBox module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
class CheckBoxModule {
}
CheckBoxModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CheckBoxModule });
CheckBoxModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CheckBoxModule_Factory(t) { return new (t || CheckBoxModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CheckBoxModule, { declarations: function () { return [CheckBoxDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CheckBoxDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CheckBoxModule, [{
        type: NgModule,
        args: [{
                declarations: [CheckBoxDirective],
                exports: [CheckBoxDirective],
                imports: [CommonModule]
            }]
    }], null, null); })();

/**
 * Represents the directive that renders the [Kendo UI RadioButton]({% slug overview_checkbox %}) input component.
 * The directive is placed on input type="radio" elements.
 *
 * @example
 * ```ts-no-run
 * <input type="radio" kendoRadioButton />
 * ```
 */
class RadioButtonDirective {
    constructor() {
        this.kendoClass = true;
    }
}
RadioButtonDirective.ɵfac = function RadioButtonDirective_Factory(t) { return new (t || RadioButtonDirective)(); };
RadioButtonDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: RadioButtonDirective, selectors: [["input", "kendoRadioButton", ""]], hostVars: 2, hostBindings: function RadioButtonDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-radio", ctx.kendoClass);
    } } });
RadioButtonDirective.propDecorators = {
    kendoClass: [{ type: HostBinding, args: ['class.k-radio',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RadioButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'input[kendoRadioButton]'
            }]
    }], function () { return []; }, { kendoClass: [{
            type: HostBinding,
            args: ['class.k-radio']
        }] }); })();

/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the RadioButton directive.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the RadioButton module
 * import { RadioButtonModule } from '@progress/kendo-angular-inputs';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, RadioButtonModule], // import RadioButton module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
class RadioButtonModule {
}
RadioButtonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: RadioButtonModule });
RadioButtonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function RadioButtonModule_Factory(t) { return new (t || RadioButtonModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(RadioButtonModule, { declarations: function () { return [RadioButtonDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [RadioButtonDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RadioButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [RadioButtonDirective],
                exports: [RadioButtonDirective],
                imports: [CommonModule]
            }]
    }], null, null); })();

let serial$3 = 0;
/**
 * Represents an error message that will be shown underneath
 * a Kendo control or native HTML form-bound component after a validation.
 */
class ErrorComponent {
    constructor() {
        this.hostClass = true;
        /**
         * Specifies the alignment of the Error message.
         *
         * The possible values are:
         * * (Default) `start`
         * * `end`
         */
        this.align = 'start';
        /**
         * @hidden
         */
        this.id = `kendo-error-${serial$3++}`;
        this.roleAttribute = 'alert';
    }
    get startClass() {
        return this.align === 'start';
    }
    get endClass() {
        return this.align === 'end';
    }
    get idAttribute() {
        return this.id;
    }
}
ErrorComponent.ɵfac = function ErrorComponent_Factory(t) { return new (t || ErrorComponent)(); };
ErrorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ErrorComponent, selectors: [["kendo-formerror"]], hostVars: 8, hostBindings: function ErrorComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.roleAttribute)("id", ctx.idAttribute);
        ɵngcc0.ɵɵclassProp("k-form-error", ctx.hostClass)("k-text-start", ctx.startClass)("k-text-end", ctx.endClass);
    } }, inputs: { align: "align" }, ngContentSelectors: _c30, decls: 1, vars: 0, template: function ErrorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
ErrorComponent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class.k-form-error',] }],
    align: [{ type: Input }],
    roleAttribute: [{ type: HostBinding, args: ['attr.role',] }],
    startClass: [{ type: HostBinding, args: ['class.k-text-start',] }],
    endClass: [{ type: HostBinding, args: ['class.k-text-end',] }],
    idAttribute: [{ type: HostBinding, args: ['attr.id',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ErrorComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-formerror',
                template: `
        <ng-content></ng-content>
    `
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class.k-form-error']
        }], align: [{
            type: Input
        }], roleAttribute: [{
            type: HostBinding,
            args: ['attr.role']
        }], startClass: [{
            type: HostBinding,
            args: ['class.k-text-start']
        }], endClass: [{
            type: HostBinding,
            args: ['class.k-text-end']
        }], idAttribute: [{
            type: HostBinding,
            args: ['attr.id']
        }] }); })();

let serial$4 = 0;
/**
 * Represents a hint message that will be shown underneath a form-bound component.
 */
class HintComponent {
    constructor() {
        /**
         * Specifies the alignment of the Hint message.
         *
         * The possible values are:
         * * (Default) `start`
         * * `end`
         */
        this.align = 'start';
        /**
         * @hidden
         */
        this.id = `kendo-hint-${serial$4++}`;
        this.hostClass = true;
    }
    get startClass() {
        return this.align === 'start';
    }
    get endClass() {
        return this.align === 'end';
    }
    get idAttribute() {
        return this.id;
    }
}
HintComponent.ɵfac = function HintComponent_Factory(t) { return new (t || HintComponent)(); };
HintComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HintComponent, selectors: [["kendo-formhint"]], hostVars: 7, hostBindings: function HintComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.idAttribute);
        ɵngcc0.ɵɵclassProp("k-form-hint", ctx.hostClass)("k-text-start", ctx.startClass)("k-text-end", ctx.endClass);
    } }, inputs: { align: "align" }, ngContentSelectors: _c30, decls: 1, vars: 0, template: function HintComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
HintComponent.propDecorators = {
    align: [{ type: Input }],
    hostClass: [{ type: HostBinding, args: ['class.k-form-hint',] }],
    startClass: [{ type: HostBinding, args: ['class.k-text-start',] }],
    endClass: [{ type: HostBinding, args: ['class.k-text-end',] }],
    idAttribute: [{ type: HostBinding, args: ['attr.id',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HintComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-formhint',
                template: `
        <ng-content></ng-content>
    `
            }]
    }], function () { return []; }, { align: [{
            type: Input
        }], hostClass: [{
            type: HostBinding,
            args: ['class.k-form-hint']
        }], startClass: [{
            type: HostBinding,
            args: ['class.k-text-start']
        }], endClass: [{
            type: HostBinding,
            args: ['class.k-text-end']
        }], idAttribute: [{
            type: HostBinding,
            args: ['attr.id']
        }] }); })();

/**
 * Specifies a container for form-bound controls (Kendo controls or native HTML controls).
 * Applies styling and behavior rules.
 */
class FormFieldComponent {
    constructor(renderer, localizationService) {
        this.renderer = renderer;
        this.localizationService = localizationService;
        this.hostClass = true;
        /**
         *
         * Specifies when the Hint messages will be shown.
         *
         * The possible values are:
         *
         * * (Default) `initial`&mdash;Allows displaying hints when the form-bound component state is
         * `valid` or `untouched` and `pristine`.
         * * `always`&mdash;Allows full control over the visibility of the hints.
         *
         */
        this.showHints = 'initial';
        /**
         * Specifies the layout orientation of the form field.
         *
         * * The possible values are:
         *
         * * (Default) `vertical`
         * * `horizontal`
         */
        this.orientation = 'vertical';
        /**
         * Specifies when the Error messages will be shown.
         *
         * The possible values are:
         *
         * * (Default) `initial`&mdash;Allows displaying errors when the form-bound component state is
         * `invalid` and `touched` or `dirty`.
         * * `always`&mdash;Allows full control over the visibility of the errors.
         *
         */
        this.showErrors = 'initial';
        this.subscriptions = new Subscription();
        this.rtl = false;
        this.subscriptions.add(this.localizationService.changes.subscribe(({ rtl }) => {
            this.rtl = rtl;
            this.direction = this.rtl ? 'rtl' : 'ltr';
        }));
    }
    get errorClass() {
        if (!this.control) {
            return false;
        }
        return this.control.invalid && (this.control.touched || this.control.dirty);
    }
    get disabledClass() {
        if (!this.control) {
            return false;
        }
        // radiobutton group
        if (this.isRadioControl(this.control)) {
            return false;
        }
        return this.disabledControl() ||
            this.disabledElement() ||
            this.disabledKendoInput();
    }
    set formControls(formControls) {
        this.validateFormControl(formControls);
        this.control = formControls.first;
    }
    /**
     * @hidden
     */
    get horizontal() {
        return this.orientation === 'horizontal';
    }
    /**
     * @hidden
     */
    get hasHints() {
        return this.showHints === 'always' ? true : this.showHintsInitial();
    }
    /**
     * @hidden
     */
    get hasErrors() {
        return this.showErrors === 'always' ? true : this.showErrorsInitial();
    }
    ngAfterViewInit() {
        this.setDescription();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    disabledKendoInput() {
        return this.kendoInput && this.kendoInput.disabled;
    }
    disabledControl() {
        return this.control.disabled;
    }
    disabledElement() {
        const elements = this.controlElementRefs.toArray();
        return elements.every(e => e.nativeElement.hasAttribute('disabled'));
    }
    validateFormControl(formControls) {
        if (isDevMode() && formControls.length !== 1 && !this.isControlGroup(formControls)) {
            throw new Error('The `kendo-formfield` component should contain ' +
                'only one control of type NgControl with a formControlName(https://angular.io/api/forms/FormControlName)' +
                'or an ngModel(https://angular.io/api/forms/NgModel) binding.');
        }
    }
    isControlGroup(formControls) {
        if (!formControls.length) {
            return false;
        }
        const name = formControls.first.name;
        return formControls.toArray().every(c => c.name === name && (this.isRadioControl(c)));
    }
    isRadioControl(control) {
        return control.valueAccessor instanceof RadioControlValueAccessor;
    }
    updateDescription() {
        const controls = this.findControlElements();
        if (!controls) {
            return;
        }
        controls.forEach((control) => {
            const ariaIds = this.generateDescriptionIds(control);
            this.renderer.setAttribute(control, 'aria-describedby', ariaIds);
        });
    }
    findControlElements() {
        if (!this.controlElementRefs) {
            return;
        }
        // if the control is KendoInput and has focusableId - dropdowns, dateinputs
        if (this.kendoInput && this.kendoInput.focusableId && isDocumentAvailable()) {
            return [document.getElementById(this.kendoInput.focusableId)];
        }
        return this.controlElementRefs.map(el => el.nativeElement);
    }
    generateDescriptionIds(control) {
        const ids = new Set();
        if (control.hasAttribute('aria-describedby')) {
            const attributes = control.getAttribute('aria-describedby').split(' ');
            attributes.forEach((attr) => {
                if (attr.includes('kendo-hint-') || attr.includes('kendo-error-')) {
                    return;
                }
                ids.add(attr);
            });
        }
        this.hintChildren.forEach((hint) => {
            ids.add(hint.id);
        });
        this.errorChildren.forEach((error) => {
            ids.add(error.id);
        });
        return Array.from(ids).join(' ');
    }
    showHintsInitial() {
        if (!this.control) {
            return true;
        }
        const { valid, untouched, pristine } = this.control;
        return valid || (untouched && pristine);
    }
    showErrorsInitial() {
        if (!this.control) {
            return false;
        }
        const { invalid, dirty, touched } = this.control;
        return invalid && (dirty || touched);
    }
    setDescription() {
        this.updateDescription();
        this.subscriptions.add(this.errorChildren.changes.subscribe(() => this.updateDescription()));
        this.subscriptions.add(this.hintChildren.changes.subscribe(() => this.updateDescription()));
    }
}
FormFieldComponent.ɵfac = function FormFieldComponent_Factory(t) { return new (t || FormFieldComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
FormFieldComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormFieldComponent, selectors: [["kendo-formfield"]], contentQueries: function FormFieldComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, KendoInput, true);
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, NgControl, true);
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, NgControl, true, ElementRef);
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, ErrorComponent, true);
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, HintComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.kendoInput = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.formControls = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.controlElementRefs = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.errorChildren = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.hintChildren = _t);
    } }, hostVars: 7, hostBindings: function FormFieldComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.direction);
        ɵngcc0.ɵɵclassProp("k-form-field", ctx.hostClass)("k-form-field-error", ctx.errorClass)("k-form-field-disabled", ctx.disabledClass);
    } }, inputs: { showHints: "showHints", orientation: "orientation", showErrors: "showErrors" }, features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.formfield'
            }
        ])], ngContentSelectors: _c59, decls: 5, vars: 4, consts: [[4, "ngIf"]], template: function FormFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c58);
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵprojection(2, 1);
        ɵngcc0.ɵɵtemplate(3, FormFieldComponent_3_Template, 1, 0, undefined, 0);
        ɵngcc0.ɵɵtemplate(4, FormFieldComponent_4_Template, 1, 0, undefined, 0);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("k-form-field-wrap", ctx.horizontal);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasHints);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasErrors);
    } }, directives: [ɵngcc3.NgIf], encapsulation: 2 });
/** @nocollapse */
FormFieldComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: LocalizationService }
];
FormFieldComponent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class.k-form-field',] }],
    direction: [{ type: HostBinding, args: ['attr.dir',] }],
    errorClass: [{ type: HostBinding, args: ['class.k-form-field-error',] }],
    disabledClass: [{ type: HostBinding, args: ['class.k-form-field-disabled',] }],
    formControls: [{ type: ContentChildren, args: [NgControl, { descendants: true, static: true },] }],
    controlElementRefs: [{ type: ContentChildren, args: [NgControl, { read: ElementRef, descendants: true, static: true },] }],
    kendoInput: [{ type: ContentChild, args: [KendoInput, { static: true },] }],
    errorChildren: [{ type: ContentChildren, args: [ErrorComponent, { descendants: true, static: true },] }],
    hintChildren: [{ type: ContentChildren, args: [HintComponent, { descendants: true, static: true },] }],
    showHints: [{ type: Input }],
    orientation: [{ type: Input }],
    showErrors: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormFieldComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-formfield',
                template: `
        <ng-content select="label, kendo-label"></ng-content>
        <div [class.k-form-field-wrap]="horizontal">
            <ng-content></ng-content>
            <ng-content select="kendo-formhint" *ngIf="hasHints"></ng-content>
            <ng-content select="kendo-formerror" *ngIf="hasErrors"></ng-content>
        </div>
    `,
                providers: [
                    LocalizationService,
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.formfield'
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc1.LocalizationService }]; }, { hostClass: [{
            type: HostBinding,
            args: ['class.k-form-field']
        }], showHints: [{
            type: Input
        }], orientation: [{
            type: Input
        }], showErrors: [{
            type: Input
        }], direction: [{
            type: HostBinding,
            args: ['attr.dir']
        }], errorClass: [{
            type: HostBinding,
            args: ['class.k-form-field-error']
        }], disabledClass: [{
            type: HostBinding,
            args: ['class.k-form-field-disabled']
        }], formControls: [{
            type: ContentChildren,
            args: [NgControl, { descendants: true, static: true }]
        }], controlElementRefs: [{
            type: ContentChildren,
            args: [NgControl, { read: ElementRef, descendants: true, static: true }]
        }], kendoInput: [{
            type: ContentChild,
            args: [KendoInput, { static: true }]
        }], errorChildren: [{
            type: ContentChildren,
            args: [ErrorComponent, { descendants: true, static: true }]
        }], hintChildren: [{
            type: ContentChildren,
            args: [HintComponent, { descendants: true, static: true }]
        }] }); })();

/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the FormField, Error and Hint components.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the FormField module
 * import { FormFieldModule } from '@progress/kendo-angular-inputs';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, FormFieldModule], // import FormField module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
class FormFieldModule {
}
FormFieldModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FormFieldModule });
FormFieldModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FormFieldModule_Factory(t) { return new (t || FormFieldModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FormFieldModule, { declarations: function () { return [HintComponent,
        ErrorComponent,
        FormFieldComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [HintComponent,
        ErrorComponent,
        FormFieldComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormFieldModule, [{
        type: NgModule,
        args: [{
                declarations: [HintComponent, ErrorComponent, FormFieldComponent],
                exports: [HintComponent, ErrorComponent, FormFieldComponent],
                imports: [CommonModule]
            }]
    }], null, null); })();

/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the Inputs components.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the Inputs module
 * import { InputsModule } from '@progress/kendo-angular-inputs';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 * import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, BrowserAnimationsModule, InputsModule], // import Inputs module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
class InputsModule {
}
InputsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: InputsModule });
InputsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function InputsModule_Factory(t) { return new (t || InputsModule)(); }, imports: [[CommonModule],
        TextBoxModule,
        SliderModule,
        RangeSliderModule,
        SwitchModule,
        NumericTextBoxModule,
        MaskedTextBoxModule,
        ColorPickerModule,
        CheckBoxModule,
        RadioButtonModule,
        FormFieldModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(InputsModule, { imports: function () { return [CommonModule]; }, exports: function () { return [TextBoxModule,
        SliderModule,
        RangeSliderModule,
        SwitchModule,
        NumericTextBoxModule,
        MaskedTextBoxModule,
        ColorPickerModule,
        CheckBoxModule,
        RadioButtonModule,
        FormFieldModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InputsModule, [{
        type: NgModule,
        args: [{
                exports: [TextBoxModule, SliderModule, RangeSliderModule, SwitchModule, NumericTextBoxModule, MaskedTextBoxModule, ColorPickerModule, CheckBoxModule, RadioButtonModule, FormFieldModule],
                imports: [CommonModule]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CheckBoxModule, ColorInputComponent, FocusOnDomReadyDirective, ColorPaletteService, MaskingService, NumericTextBoxMessages, RadioButtonModule, RangeSliderCustomMessagesComponent, RangeSliderMessages, SliderCustomMessagesComponent, SliderMessages, SliderBase, SlidersCommonModule, SwitchCustomMessagesComponent, Messages, TextBoxCustomMessagesComponent, LocalizedTextBoxMessagesDirective, TextBoxMessages, TextBoxPrefixTemplateDirective, TextBoxSeparatorComponent, TextBoxSuffixTemplateDirective, TextBoxComponent, SliderComponent, RangeSliderComponent, LabelTemplateDirective, SwitchComponent, TextBoxContainerComponent, TextBoxDirective, TextAreaDirective, NumericTextBoxComponent, NumericTextBoxCustomMessagesComponent, MaskedTextBoxComponent, InputsModule, SliderTicksComponent, SliderModule, RangeSliderModule, SwitchModule, NumericTextBoxModule, MaskedTextBoxModule, TextBoxModule, ColorPickerComponent, ColorPaletteComponent, ColorGradientComponent, ColorPickerModule, ActiveColorClickEvent, CheckBoxDirective, RadioButtonDirective, HintComponent, ErrorComponent, FormFieldComponent, FormFieldModule, LocalizedNumericTextBoxMessagesDirective, LocalizedSliderMessagesDirective, LocalizedRangeSliderMessagesDirective, LocalizedSwitchMessagesDirective };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFxQkE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBMmNDLDJJQUtDOzs7Ozs7Ozs7Ozs7a0NBSUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29WQXdLRDs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUE0QkM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F3VEQsc09BMEZDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JBc0JBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXliRCwyT0FtRkM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JBY0E7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQW9QRCwwSUF5Q0M7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JBK0JBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQWtNRCxnREFhQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQWlCQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBMExELHVEQVNDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkFtQkE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQW1GRCxtQkFTQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkFVQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQTYzQkQsK0pBd0VDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQW9DQTs7Ozs7Ozs7b01BTUQ7Ozs7O2lHQUlDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQWFELHNLQVlDOzs7Ozs7Ozs7Ozs7Ozs7OztvRkFJQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQW1hRDs7O2dEQUdDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBc2NELGdGQTZDQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JBbUNBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXlERCx5SUF3QkM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQWVBOzs7Ozs7Ozs7OztDQU1EOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzswQkFnQkM7Ozs7Ozs7OzhNQU1EOzs7Ozs7aUZBS0M7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBVUQsaURBV0M7Ozs7Ozs7Ozs7Ozs7Ozs7b0ZBSUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBYUQsOEpBWUM7Ozs7Ozs7Ozs7Ozs7Ozs7O29GQUlBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBbUNEOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7MEJBZ0JDOzs7Ozs7OztrTkFNRDs7Ozs7MkZBSUM7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBVUQsaURBV0M7Ozs7Ozs7Ozs7Ozs7Ozs7b0ZBSUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBYUQsbUtBWUM7Ozs7Ozs7Ozs7Ozs7Ozs7O29GQUlBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBbUNEOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7MEJBZ0JDOzs7Ozs7Ozs4SUFNRDs7Ozs7cUVBSUM7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBVUQsaURBV0M7Ozs7Ozs7Ozs7Ozs7Ozs7b0ZBSUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBYUQsOEpBWUM7Ozs7Ozs7Ozs7Ozs7Ozs7O29GQUlBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FrQ0Q7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzswQkFlQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FVRCxpREFXQzs7Ozs7Ozs7Ozs7Ozs7OztvRkFJQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBa0NEOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OzBCQWNDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FrQ0Q7Ozs7Ozs7OzswQkFPQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXVCRCw2SkFLQzs7Ozs7Ozs7Ozs7O2tDQUlBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBdUJELDZKQUtDOzs7Ozs7Ozs7Ozs7a0NBSUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQWtjRCxpTUErREM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkFxQ0E7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F3QkQsbUhBTUM7Ozs7Ozs7Ozs7Ozs7b0JBR0E7Ozs7Ozs7O3NKQU1EOzs7O21GQUdDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQWFELCtKQVlDOzs7Ozs7Ozs7Ozs7Ozs7OztvRkFJQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FVRCxpREFXQzs7Ozs7Ozs7Ozs7Ozs7OztvRkFJQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQWtDRDs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7MEJBNEJDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBc21CRCxzREE2RUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkErQkE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0F3REQ7OztnREFHQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQTJSRCwwRUEyQ0M7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JBMEJBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQWlURCxvREFvRkM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JBMkJBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBaUZELGdGQXdGQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQVlBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FnQkQsMklBS0M7Ozs7Ozs7Ozs7O29HQUtBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FnQkQ7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7MEJBZ0JDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBZUQsVUFLQzs7Ozs7Ozs7Ozs7O29CQUdBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FrQ0Q7Ozs7Ozs7OzswQkFPQzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQWVELFVBS0M7Ozs7Ozs7Ozs7OztvQkFHQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBa0NEOzs7Ozs7Ozs7MEJBT0M7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBaUNELDRCQVFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQVFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0ErQkQsNEJBUUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkFPQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXFMRCx1REFvQkM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JBbUJBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FrQ0Q7Ozs7Ozs7Ozs7Ozs7MEJBT0M7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBbUNEOzs7Ozs7Ozs7Ozs7Ozs7OzswQkFNQyIsInNvdXJjZXNDb250ZW50IjpbIi8qKi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tXG4qIENvcHlyaWdodCDCqSAyMDIwIFByb2dyZXNzIFNvZnR3YXJlIENvcnBvcmF0aW9uLiBBbGwgcmlnaHRzIHJlc2VydmVkLlxuKiBMaWNlbnNlZCB1bmRlciBjb21tZXJjaWFsIGxpY2Vuc2UuIFNlZSBMSUNFTlNFLm1kIGluIHRoZSBwcm9qZWN0IHJvb3QgZm9yIG1vcmUgaW5mb3JtYXRpb25cbiotLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tKi9cbmltcG9ydCB7IGlzRGV2TW9kZSwgRGlyZWN0aXZlLCBUZW1wbGF0ZVJlZiwgT3B0aW9uYWwsIEV2ZW50RW1pdHRlciwgSW5wdXQsIE91dHB1dCwgSG9zdEJpbmRpbmcsIFZpZXdDaGlsZCwgRWxlbWVudFJlZiwgQ29udGVudENoaWxkLCBDb21wb25lbnQsIGZvcndhcmRSZWYsIEluamVjdG9yLCBSZW5kZXJlcjIsIE5nWm9uZSwgQ2hhbmdlRGV0ZWN0b3JSZWYsIEluamVjdCwgSW5qZWN0YWJsZSwgSG9zdExpc3RlbmVyLCBWaWV3Q2hpbGRyZW4sIE5nTW9kdWxlLCBWaWV3Q29udGFpbmVyUmVmLCBDb250ZW50Q2hpbGRyZW4gfSBmcm9tICdAYW5ndWxhci9jb3JlJztcbmltcG9ydCB7IE5nQ29udHJvbCwgTkdfVkFMVUVfQUNDRVNTT1IsIE5HX1ZBTElEQVRPUlMsIFJhZGlvQ29udHJvbFZhbHVlQWNjZXNzb3IgfSBmcm9tICdAYW5ndWxhci9mb3Jtcyc7XG5pbXBvcnQgeyBTdWJzY3JpcHRpb24sIGZyb21FdmVudCwgaW50ZXJ2YWwsIG1lcmdlLCBPYnNlcnZhYmxlIH0gZnJvbSAncnhqcyc7XG5pbXBvcnQgeyB0YWtlLCBmaWx0ZXIsIGNvbmNhdE1hcCwgc3RhcnRXaXRoLCB0YWtlVW50aWwsIHNraXAsIGRlYm91bmNlVGltZSB9IGZyb20gJ3J4anMvb3BlcmF0b3JzJztcbmltcG9ydCB7IExvY2FsaXphdGlvblNlcnZpY2UsIEwxME5fUFJFRklYLCBSVEwsIENvbXBvbmVudE1lc3NhZ2VzIH0gZnJvbSAnQHByb2dyZXNzL2tlbmRvLWFuZ3VsYXItbDEwbic7XG5pbXBvcnQgeyBLZXlzLCBndWlkLCBoYXNPYnNlcnZlcnMsIGFueUNoYW5nZWQsIGlzRG9jdW1lbnRBdmFpbGFibGUsIEtlbmRvSW5wdXQsIGlzQ2hhbmdlZCwgRHJhZ2dhYmxlTW9kdWxlLCBFdmVudHNNb2R1bGUsIFJlc2l6ZVNlbnNvck1vZHVsZSB9IGZyb20gJ0Bwcm9ncmVzcy9rZW5kby1hbmd1bGFyLWNvbW1vbic7XG5pbXBvcnQgeyBicm93c2VyLCBtb2JpbGVPUyB9IGZyb20gJ0Bwcm9ncmVzcy9rZW5kby1jb21tb24nO1xuaW1wb3J0IHsgSW50bFNlcnZpY2UgfSBmcm9tICdAcHJvZ3Jlc3Mva2VuZG8tYW5ndWxhci1pbnRsJztcbmltcG9ydCB7IENvbW1vbk1vZHVsZSB9IGZyb20gJ0Bhbmd1bGFyL2NvbW1vbic7XG5pbXBvcnQgeyBQb3B1cFNlcnZpY2UsIFBvcHVwTW9kdWxlIH0gZnJvbSAnQHByb2dyZXNzL2tlbmRvLWFuZ3VsYXItcG9wdXAnO1xuaW1wb3J0IHsgQ29sb3IsIHBhcnNlQ29sb3IsIG5hbWVkQ29sb3JzIH0gZnJvbSAnQHByb2dyZXNzL2tlbmRvLWRyYXdpbmcnO1xuXG4vKipcbiAqIEBoaWRkZW5cbiAqXG4gKiBDaGVja3MgaWYgdGhlIHZhbHVlIGlzIGBudWxsYCBvciBgdW5kZWZpbmVkYC4gRmFsc3kgdmFsdWVzIGxpa2UgJycsIDAsIGZhbHNlLCBOYU4sIGV0Yy4gYXJlIHJlZ2FyZGVkIGFzIHByZXNlbnQuXG4gKi9cbmNvbnN0IGlzUHJlc2VudCA9ICh2YWx1ZSkgPT4gdmFsdWUgIT09IG51bGwgJiYgdmFsdWUgIT09IHVuZGVmaW5lZDtcbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCBhcmVTYW1lID0gKHZhbHVlMSwgdmFsdWUyKSA9PiB2YWx1ZTEgPT09IHZhbHVlMiB8fCAodmFsdWUxID09PSBudWxsICYmIHZhbHVlMiA9PT0gdW5kZWZpbmVkKSB8fCAodmFsdWUxID09PSB1bmRlZmluZWQgJiYgdmFsdWUyID09PSBudWxsKTtcbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCByZXF1aXJlc1pvbmVPbkJsdXIgPSAobmdDb250cm9sKSA9PiBuZ0NvbnRyb2wgJiZcbiAgICAoIW5nQ29udHJvbC50b3VjaGVkIHx8IChuZ0NvbnRyb2wuY29udHJvbCAmJiBuZ0NvbnRyb2wuY29udHJvbC51cGRhdGVPbiA9PT0gJ2JsdXInKSk7XG4vKipcbiAqIEBoaWRkZW5cbiAqXG4gKiBGaXRzIHRoZSBjb250ZW5kZXIgbnVtYmVyIGludG8gdGhlIHNwZWNpZmllZCBib3VuZHMuIElmIHRoZSBudW1iZXIgaXMgTmFOIG9yIG51bGwsIHRoZSBtaW4gaXMgcmV0dXJuZWQuXG4gKlxuICogQHBhcmFtIGNvbnRlbmRlciBSZXByZXNlbnRzIHRoZSBudW1iZXIgeW91IHdhbnQgdG8gZml0IGludG8gc3BlY2lmaWVkIGJvdW5kcy5cbiAqIEBwYXJhbSBtaW4gVGhlIGluY2x1c2l2ZSBsb3dlciBib3VuZCBudW1iZXIuXG4gKiBAcGFyYW0gbWF4IFRoZSBpbmNsdXNpdmUgdXBwZXIgYm91bmQgbnVtYmVyLlxuICovXG5jb25zdCBmaXRJbnRvQm91bmRzID0gKGNvbnRlbmRlciwgbWluLCBtYXgpID0+IHtcbiAgICBpZiAoIWlzUHJlc2VudChjb250ZW5kZXIpIHx8IGlzTmFOKGNvbnRlbmRlcikpIHtcbiAgICAgICAgcmV0dXJuIG1pbjtcbiAgICB9XG4gICAgcmV0dXJuIGNvbnRlbmRlciA8PSBtaW4gPyBtaW4gOiBjb250ZW5kZXIgPj0gbWF4ID8gbWF4IDogY29udGVuZGVyO1xufTtcblxuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IE1BWF9QUkVDSVNJT04gPSAyMDtcbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCBsaW1pdFByZWNpc2lvbiA9IChwcmVjaXNpb24pID0+IE1hdGgubWluKHByZWNpc2lvbiwgTUFYX1BSRUNJU0lPTik7XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgZnJhY3Rpb25MZW5ndGggPSAodmFsdWUpID0+IHtcbiAgICByZXR1cm4gKFN0cmluZyh2YWx1ZSkuc3BsaXQoJy4nKVsxXSB8fCBcIlwiKS5sZW5ndGg7XG59O1xuY29uc3QgbWF4RnJhY3Rpb25MZW5ndGggPSAodmFsdWUxLCB2YWx1ZTIpID0+IHtcbiAgICByZXR1cm4gTWF0aC5tYXgoZnJhY3Rpb25MZW5ndGgodmFsdWUxKSwgZnJhY3Rpb25MZW5ndGgodmFsdWUyKSk7XG59O1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IHRvRml4ZWRQcmVjaXNpb24gPSAodmFsdWUsIHByZWNpc2lvbikgPT4ge1xuICAgIGNvbnN0IG1heFByZWNpc2lvbiA9IGxpbWl0UHJlY2lzaW9uKHByZWNpc2lvbik7XG4gICAgcmV0dXJuIHBhcnNlRmxvYXQodmFsdWUudG9GaXhlZChtYXhQcmVjaXNpb24pKTtcbn07XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgYWRkID0gKHZhbHVlMSwgdmFsdWUyKSA9PiB7XG4gICAgY29uc3QgbWF4UHJlY2lzaW9uID0gbWF4RnJhY3Rpb25MZW5ndGgodmFsdWUxLCB2YWx1ZTIpO1xuICAgIHJldHVybiB0b0ZpeGVkUHJlY2lzaW9uKHZhbHVlMSArIHZhbHVlMiwgbWF4UHJlY2lzaW9uKTtcbn07XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3Qgc3VidHJhY3QgPSAodmFsdWUxLCB2YWx1ZTIpID0+IHtcbiAgICByZXR1cm4gYWRkKHZhbHVlMSwgLXZhbHVlMik7XG59O1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IG11bHRpcGx5ID0gKHZhbHVlMSwgdmFsdWUyKSA9PiB7XG4gICAgY29uc3QgbWF4UHJlY2lzaW9uID0gZnJhY3Rpb25MZW5ndGgodmFsdWUxKSArIGZyYWN0aW9uTGVuZ3RoKHZhbHVlMik7XG4gICAgcmV0dXJuIHRvRml4ZWRQcmVjaXNpb24odmFsdWUxICogdmFsdWUyLCBtYXhQcmVjaXNpb24pO1xufTtcbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCBkaXZpZGUgPSAoZGl2aWRlbmQsIGRpdmlzb3IpID0+IHtcbiAgICBpZiAoZGl2aXNvciA9PT0gMCkge1xuICAgICAgICByZXR1cm4gTmFOO1xuICAgIH1cbiAgICBjb25zdCBwb3dlciA9IG1heEZyYWN0aW9uTGVuZ3RoKGRpdmlkZW5kLCBkaXZpc29yKTtcbiAgICBjb25zdCBjb3JyZWN0aW9uVmFsdWUgPSBNYXRoLnBvdygxMCwgcG93ZXIpO1xuICAgIHJldHVybiAoKGNvcnJlY3Rpb25WYWx1ZSAqIGRpdmlkZW5kKSAvIChjb3JyZWN0aW9uVmFsdWUgKiBkaXZpc29yKSk7XG59O1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IHJlbWFpbmRlciA9IChkaXZpZGVuZCwgZGl2aXNvcikgPT4ge1xuICAgIHJldHVybiBNYXRoLmFicyhzdWJ0cmFjdChkaXZpZGVuZCwgbXVsdGlwbHkoZGl2aXNvciwgTWF0aC5mbG9vcihkaXZpZGUoZGl2aWRlbmQsIGRpdmlzb3IpKSkpKTtcbn07XG5cbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCBjYWxjdWxhdGVGaXhlZFRyYWNrU2l6ZSA9ICh7IG1heCwgbWluLCBzbWFsbFN0ZXAsIGZpeGVkVGlja1dpZHRoIH0pID0+ICgobWF4IC0gbWluKSAvIHNtYWxsU3RlcCkgKiBmaXhlZFRpY2tXaWR0aDtcbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCBjYWxjdWxhdGVUcmFja1NpemUgPSAod3JhcHBlcldpZHRoLCBvZmZzZXQsIHNob3dCdXR0b25zID0gdHJ1ZSkgPT4ge1xuICAgIGNvbnN0IEJVVFRPTlNfQ09VTlQgPSAyO1xuICAgIGNvbnN0IHRyYWNrT2Zmc2V0ID0gc2hvd0J1dHRvbnMgPyBwYXJzZUZsb2F0KG9mZnNldCkgKiBCVVRUT05TX0NPVU5UIDogMDtcbiAgICBjb25zdCB0cmFja1dpZHRoID0gd3JhcHBlcldpZHRoIC0gdHJhY2tPZmZzZXQ7XG4gICAgcmV0dXJuIE1hdGguZmxvb3IodHJhY2tXaWR0aCk7XG59O1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IGNhbGN1bGF0ZVRpY2tzQ291bnQgPSAobWluID0gMCwgbWF4ID0gMCwgc21hbGxTdGVwID0gMSkgPT4ge1xuICAgIGlmIChzbWFsbFN0ZXAgPD0gMCkge1xuICAgICAgICB0aHJvdyBuZXcgRXJyb3IoJ0ludmFsaWQgYXJndW1lbnQ6IHNtYWxsU3RlcCBtdXN0IGJlIGEgcG9zaXRpdmUgbnVtYmVyJyk7XG4gICAgfVxuICAgIGNvbnN0IGFkanVzdGVkUmFuZ2UgPSBNYXRoLmFicyhzdWJ0cmFjdChtYXgsIG1pbikpO1xuICAgIGNvbnN0IGFkanVzdGVkUmF0aW8gPSBNYXRoLmZsb29yKGRpdmlkZShhZGp1c3RlZFJhbmdlLCBzbWFsbFN0ZXApKTtcbiAgICBjb25zdCByZXN1bHQgPSBhZGQoYWRqdXN0ZWRSYXRpbywgMSk7XG4gICAgcmV0dXJuIHJlc3VsdDtcbn07XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgY2FsY3VsYXRlVmFsdWVGcm9tVGljayA9IChpbmRleCwgeyBtYXgsIG1pbiwgc21hbGxTdGVwLCByZXZlcnNlLCB2ZXJ0aWNhbCB9KSA9PiB7XG4gICAgY29uc3QgdmFsdWUgPSBhZGQobWluLCBtdWx0aXBseShpbmRleCwgc21hbGxTdGVwKSk7XG4gICAgcmV0dXJuIHZlcnRpY2FsIHx8IHJldmVyc2UgPyBNYXRoLmFicyhzdWJ0cmFjdCh2YWx1ZSwgbWF4KSkgOiB2YWx1ZTtcbn07XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgY2FsY3VsYXRlSGFuZGxlUG9zaXRpb24gPSAoeyBoYW5kbGVXaWR0aCwgdHJhY2tXaWR0aCwgbWluLCBtYXgsIHJldmVyc2UsIHZhbHVlIH0pID0+IHtcbiAgICBjb25zdCBoYWxmSGFuZGxlV2lkdGggPSBNYXRoLmZsb29yKGhhbmRsZVdpZHRoIC8gMik7XG4gICAgY29uc3Qgc3RlcCA9IHRyYWNrV2lkdGggLyBNYXRoLmFicyhtYXggLSBtaW4pO1xuICAgIGxldCBwb3MgPSBpc1ByZXNlbnQodmFsdWUpID8gc3RlcCAqICh2YWx1ZSAtIG1pbikgOiBtaW47XG4gICAgaWYgKHJldmVyc2UpIHtcbiAgICAgICAgcG9zID0gdHJhY2tXaWR0aCAtIHBvcztcbiAgICB9XG4gICAgcmV0dXJuIE1hdGguZmxvb3IocG9zIC0gaGFsZkhhbmRsZVdpZHRoKTtcbn07XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgZGVjcmVhc2VWYWx1ZVRvU3RlcCA9ICh2YWx1ZSwgeyBtYXgsIG1pbiwgc21hbGxTdGVwLCBsYXJnZVN0ZXAgfSwgbGFyZ2UgPSBmYWxzZSkgPT4ge1xuICAgIGNvbnN0IHN0ZXAgPSBsYXJnZSAmJiBsYXJnZVN0ZXAgPyBtdWx0aXBseShzbWFsbFN0ZXAsIGxhcmdlU3RlcCkgOiBzbWFsbFN0ZXA7XG4gICAgY29uc3Qgc3RlcFZhbHVlID0gc3VidHJhY3QodmFsdWUsIG1pbik7XG4gICAgbGV0IHJlc3VsdDtcbiAgICBjb25zdCBzdGVwUmVtYWluZGVyID0gcmVtYWluZGVyKHN0ZXBWYWx1ZSwgc3RlcCk7XG4gICAgaWYgKHN0ZXBSZW1haW5kZXIgPT09IDApIHtcbiAgICAgICAgcmVzdWx0ID0gc3VidHJhY3Qoc3RlcFZhbHVlLCBzdGVwKTtcbiAgICB9XG4gICAgZWxzZSB7XG4gICAgICAgIHJlc3VsdCA9IHN1YnRyYWN0KHN0ZXBWYWx1ZSwgc3RlcFJlbWFpbmRlcik7XG4gICAgfVxuICAgIHJldHVybiBsaW1pdFZhbHVlKGFkZChyZXN1bHQsIG1pbiksIG1pbiwgbWF4KTtcbn07XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgaW5jcmVhc2VWYWx1ZVRvU3RlcCA9ICh2YWx1ZSwgeyBtYXgsIG1pbiwgc21hbGxTdGVwLCBsYXJnZVN0ZXAgfSwgbGFyZ2UgPSBmYWxzZSkgPT4ge1xuICAgIGNvbnN0IHN0ZXAgPSBsYXJnZSAmJiBsYXJnZVN0ZXAgPyBtdWx0aXBseShzbWFsbFN0ZXAsIGxhcmdlU3RlcCkgOiBzbWFsbFN0ZXA7XG4gICAgY29uc3Qgc3RlcFZhbHVlID0gc3VidHJhY3QodmFsdWUsIG1pbik7XG4gICAgY29uc3Qgc3RlcFJlbWFpbmRlciA9IHJlbWFpbmRlcihzdGVwVmFsdWUsIHN0ZXApO1xuICAgIGNvbnN0IHJlc3VsdCA9IGFkZChzdWJ0cmFjdChzdGVwVmFsdWUsIHN0ZXBSZW1haW5kZXIpLCBzdGVwKTtcbiAgICByZXR1cm4gbGltaXRWYWx1ZShhZGQocmVzdWx0LCBtaW4pLCBtaW4sIG1heCk7XG59O1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IGlzU3RhcnRIYW5kbGUgPSAoZHJhZ0hhbmRsZSkgPT4gZHJhZ0hhbmRsZS5pZC5pbmRleE9mKCdrLXN0YXJ0LWhhbmRsZScpID4gLTE7XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3Qgc25hcFZhbHVlID0gKHZhbHVlLCBvcHRpb25zKSA9PiB7XG4gICAgY29uc3QgeyBzbWFsbFN0ZXAsIG1pbiwgbWF4IH0gPSBvcHRpb25zO1xuICAgIGNvbnN0IGxpbWl0ZWQgPSBsaW1pdFZhbHVlKHZhbHVlLCBtaW4sIG1heCk7XG4gICAgaWYgKHZhbHVlICE9PSBsaW1pdGVkKSB7XG4gICAgICAgIHJldHVybiBsaW1pdGVkO1xuICAgIH1cbiAgICBjb25zdCBsZWZ0ID0gZGVjcmVhc2VWYWx1ZVRvU3RlcCh2YWx1ZSwgb3B0aW9ucyk7XG4gICAgY29uc3QgcmlnaHQgPSBpbmNyZWFzZVZhbHVlVG9TdGVwKHZhbHVlLCBvcHRpb25zKTtcbiAgICBpZiAoKHZhbHVlIC0gbWluKSAlIHNtYWxsU3RlcCA9PT0gMCkge1xuICAgICAgICByZXR1cm4gdmFsdWU7XG4gICAgfVxuICAgIGlmIChyaWdodCAtIHZhbHVlIDw9IChyaWdodCAtIGxlZnQpIC8gMikge1xuICAgICAgICByZXR1cm4gcmlnaHQ7XG4gICAgfVxuICAgIHJldHVybiBsZWZ0O1xufTtcbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCB0cmltVmFsdWUgPSAobWF4LCBtaW4sIHZhbHVlKSA9PiB7XG4gICAgaWYgKHZhbHVlID4gbWF4KSB7XG4gICAgICAgIHJldHVybiBtYXg7XG4gICAgfVxuICAgIGlmICh2YWx1ZSA8IG1pbikge1xuICAgICAgICByZXR1cm4gbWluO1xuICAgIH1cbiAgICByZXR1cm4gdmFsdWU7XG59O1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IHRyaW1WYWx1ZVJhbmdlID0gKG1heCwgbWluLCB2YWx1ZSkgPT4ge1xuICAgIHJldHVybiB2YWx1ZSA/IFt0cmltVmFsdWUobWF4LCBtaW4sIHZhbHVlWzBdKSwgdHJpbVZhbHVlKG1heCwgbWluLCB2YWx1ZVsxXSldIDogW21pbiwgbWluXTtcbn07XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgaWRlbnRpdHkgPSAodmFsdWUpID0+IHZhbHVlO1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IGlzU2FtZVJhbmdlID0gKHZhbHVlMSwgdmFsdWUyKSA9PiBhcmVTYW1lKHZhbHVlMVswXSwgdmFsdWUyWzBdKSAmJiBhcmVTYW1lKHZhbHVlMVsxXSwgdmFsdWUyWzFdKTtcbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCBlbGVtZW50T2Zmc2V0ID0gKGVsZW1lbnQpID0+IHtcbiAgICBjb25zdCBib3ggPSBlbGVtZW50LmdldEJvdW5kaW5nQ2xpZW50UmVjdCgpO1xuICAgIGNvbnN0IGRvY3VtZW50RWxlbWVudCA9IGRvY3VtZW50LmRvY3VtZW50RWxlbWVudDtcbiAgICByZXR1cm4ge1xuICAgICAgICBsZWZ0OiBib3gubGVmdCArICh3aW5kb3cucGFnZVhPZmZzZXQgfHwgZG9jdW1lbnRFbGVtZW50LnNjcm9sbExlZnQpIC0gKGRvY3VtZW50RWxlbWVudC5jbGllbnRMZWZ0IHx8IDApLFxuICAgICAgICB0b3A6IGJveC50b3AgKyAod2luZG93LnBhZ2VZT2Zmc2V0IHx8IGRvY3VtZW50RWxlbWVudC5zY3JvbGxUb3ApIC0gKGRvY3VtZW50RWxlbWVudC5jbGllbnRUb3AgfHwgMClcbiAgICB9O1xufTtcbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCBsaW1pdFZhbHVlID0gKHZhbHVlLCBtaW4sIG1heCkgPT4ge1xuICAgIHJldHVybiBNYXRoLm1heChNYXRoLm1pbih2YWx1ZSwgbWF4KSwgbWluKTtcbn07XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgZXZlbnRWYWx1ZSA9IChldmVudEFyZ3MsIHNjYWxlRWxlbWVudCwgb3B0aW9ucykgPT4ge1xuICAgIGNvbnN0IHsgbWluLCBtYXgsIHZlcnRpY2FsLCBydGwgfSA9IG9wdGlvbnM7XG4gICAgY29uc3QgdHJhY2tPZmZzZXQgPSBlbGVtZW50T2Zmc2V0KHNjYWxlRWxlbWVudCk7XG4gICAgY29uc3Qgb2Zmc2V0ID0gdmVydGljYWwgPyBldmVudEFyZ3MucGFnZVkgLSB0cmFja09mZnNldC50b3AgOiBldmVudEFyZ3MucGFnZVggLSB0cmFja09mZnNldC5sZWZ0O1xuICAgIGNvbnN0IHNjYWxlID0gKG1heCAtIG1pbikgLyAodmVydGljYWwgPyBzY2FsZUVsZW1lbnQuY2xpZW50SGVpZ2h0IDogc2NhbGVFbGVtZW50LmNsaWVudFdpZHRoKTtcbiAgICBjb25zdCBvZmZzZXRWYWx1ZSA9IG9mZnNldCAqIHNjYWxlO1xuICAgIGxldCB2YWx1ZSA9IHJ0bCB8fCB2ZXJ0aWNhbCA/IG1heCAtIG9mZnNldFZhbHVlIDogbWluICsgb2Zmc2V0VmFsdWU7XG4gICAgY29uc3Qgc3RlcEZyYWN0aW9uTGVuZ3RoID0gZnJhY3Rpb25MZW5ndGgob3B0aW9ucy5zbWFsbFN0ZXApO1xuICAgIHZhbHVlID0gdG9GaXhlZFByZWNpc2lvbih2YWx1ZSwgc3RlcEZyYWN0aW9uTGVuZ3RoICsgMSk7XG4gICAgcmV0dXJuIHNuYXBWYWx1ZSh2YWx1ZSwgb3B0aW9ucyk7XG59O1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IGlzQnV0dG9uID0gKGVsZW1lbnQpID0+IHtcbiAgICByZXR1cm4gZWxlbWVudC5jbGFzc05hbWUuaW5kZXhPZignay1idXR0b24taW5jcmVhc2UnKSA+PSAwIHx8IGVsZW1lbnQuY2xhc3NOYW1lLmluZGV4T2YoJ2stYnV0dG9uLWRlY3JlYXNlJykgPj0gMDtcbn07XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgaW5jcmVtZW50ID0gKG9wdGlvbnMpID0+IHtcbiAgICByZXR1cm4gaW5jcmVhc2VWYWx1ZVRvU3RlcChvcHRpb25zLnZhbHVlLCBvcHRpb25zKTtcbn07XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgZGVjcmVtZW50ID0gKG9wdGlvbnMpID0+IHtcbiAgICByZXR1cm4gZGVjcmVhc2VWYWx1ZVRvU3RlcChvcHRpb25zLnZhbHVlLCBvcHRpb25zKTtcbn07XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgaW5jcmVtZW50TGFyZ2UgPSAob3B0aW9ucykgPT4ge1xuICAgIHJldHVybiBpbmNyZWFzZVZhbHVlVG9TdGVwKG9wdGlvbnMudmFsdWUsIG9wdGlvbnMsIHRydWUpO1xufTtcbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCBkZWNyZW1lbnRMYXJnZSA9IChvcHRpb25zKSA9PiB7XG4gICAgcmV0dXJuIGRlY3JlYXNlVmFsdWVUb1N0ZXAob3B0aW9ucy52YWx1ZSwgb3B0aW9ucywgdHJ1ZSk7XG59O1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IHZhbGlkYXRlVmFsdWUgPSAodmFsdWUpID0+IHtcbiAgICBpZiAoaXNEZXZNb2RlICYmIHZhbHVlICYmIHZhbHVlWzBdID4gdmFsdWVbMV0pIHtcbiAgICAgICAgdGhyb3cgbmV3IEVycm9yKCdbUmFuZ2VTbGlkZXJdIFRoZSBzdGFydCB2YWx1ZSBzaG91bGQgbm90IGJlIGdyZWF0ZXIgdGhhbiB0aGUgZW5kIHZhbHVlLicpO1xuICAgIH1cbn07XG5cbi8qKlxuICogQGhpZGRlblxuICovXG5jbGFzcyBTbGlkZXJNb2RlbEJhc2Uge1xuICAgIGNvbnN0cnVjdG9yKHByb3BzLCB3cmFwcGVyLCB0cmFjaywgcmVuZGVyZXIpIHtcbiAgICAgICAgdGhpcy5wcm9wcyA9IHByb3BzO1xuICAgICAgICB0aGlzLndyYXBwZXIgPSB3cmFwcGVyO1xuICAgICAgICB0aGlzLnRyYWNrID0gdHJhY2s7XG4gICAgICAgIHRoaXMucmVuZGVyZXIgPSByZW5kZXJlcjtcbiAgICAgICAgdGhpcy5wcm9wcyA9IHByb3BzO1xuICAgICAgICB0aGlzLndyYXBwZXIgPSB3cmFwcGVyO1xuICAgICAgICB0aGlzLnRyYWNrID0gdHJhY2s7XG4gICAgICAgIHRoaXMudGlja1NpemVzID0gdGhpcy5nZXRUaWNrU2l6ZXMoKTtcbiAgICB9XG4gICAgcmVzaXplVHJhY2soKSB7XG4gICAgICAgIGNvbnN0IG9yaWVudGF0aW9uID0gdGhpcy5wcm9wcy52ZXJ0aWNhbCA/ICdoZWlnaHQnIDogJ3dpZHRoJztcbiAgICAgICAgY29uc3QgdHJhY2tXaWR0aCA9IHRoaXMudHJhY2tXaWR0aCgpO1xuICAgICAgICB0aGlzLnRyYWNrLnN0eWxlW29yaWVudGF0aW9uXSA9IGAke3RyYWNrV2lkdGh9cHhgO1xuICAgIH1cbiAgICByZXNpemVUaWNrcyh0aWNrc0NvbnRhaW5lciwgdGlja3MpIHtcbiAgICAgICAgY29uc3QgZGltZW5zaW9uID0gdGhpcy5wcm9wcy52ZXJ0aWNhbCA/IFwiaGVpZ2h0XCIgOiBcIndpZHRoXCI7XG4gICAgICAgIFsuLi50aWNrc10ubWFwKCh0aWNrLCBpbmRleCkgPT4gdGljay5zdHlsZVtkaW1lbnNpb25dID0gYCR7dGhpcy50aWNrU2l6ZXNbaW5kZXhdfXB4YCk7XG4gICAgICAgIGlmICh0aGlzLnByb3BzLnZlcnRpY2FsKSB7XG4gICAgICAgICAgICB0aGlzLmFkanVzdFBhZGRpbmcodGlja3NDb250YWluZXIpO1xuICAgICAgICB9XG4gICAgfVxuICAgIHJlc2l6ZVdyYXBwZXIoKSB7XG4gICAgICAgIGNvbnN0IGRpbWVuc2lvbiA9IHRoaXMucHJvcHMudmVydGljYWwgPyBcImhlaWdodFwiIDogXCJ3aWR0aFwiO1xuICAgICAgICBjb25zdCB3cmFwcGVyU2l6ZSA9IHRoaXMuZWxlbWVudFNpemUodGhpcy53cmFwcGVyKTtcbiAgICAgICAgY29uc3QgdHJhY2tXaWR0aCA9IGNhbGN1bGF0ZVRyYWNrU2l6ZSh3cmFwcGVyU2l6ZSwgdGhpcy5lbGVtZW50T2Zmc2V0KHRoaXMudHJhY2spKTtcbiAgICAgICAgY29uc3QgZml4ZWRUcmFja1dpZHRoID0gY2FsY3VsYXRlRml4ZWRUcmFja1NpemUodGhpcy5wcm9wcyk7XG4gICAgICAgIGNvbnN0IHdyYXBwZXJQYXJlbnRFbCA9IHRoaXMud3JhcHBlci5wYXJlbnRFbGVtZW50O1xuICAgICAgICBpZiAodHJhY2tXaWR0aCA+IGZpeGVkVHJhY2tXaWR0aCkge1xuICAgICAgICAgICAgd3JhcHBlclBhcmVudEVsLnN0eWxlW2RpbWVuc2lvbl0gPSBgJHt3cmFwcGVyU2l6ZSAtICh0cmFja1dpZHRoIC0gZml4ZWRUcmFja1dpZHRoKX1weGA7XG4gICAgICAgIH1cbiAgICAgICAgZWxzZSB7XG4gICAgICAgICAgICB3cmFwcGVyUGFyZW50RWwuc3R5bGVbZGltZW5zaW9uXSA9IGAke3dyYXBwZXJTaXplICsgKGZpeGVkVHJhY2tXaWR0aCAtIHRyYWNrV2lkdGgpfXB4YDtcbiAgICAgICAgfVxuICAgIH1cbiAgICB0cmFja1dpZHRoKCkge1xuICAgICAgICBpZiAodGhpcy5wcm9wcy5maXhlZFRpY2tXaWR0aCkge1xuICAgICAgICAgICAgcmV0dXJuIGNhbGN1bGF0ZUZpeGVkVHJhY2tTaXplKHRoaXMucHJvcHMpO1xuICAgICAgICB9XG4gICAgICAgIHJldHVybiBjYWxjdWxhdGVUcmFja1NpemUodGhpcy5lbGVtZW50U2l6ZSh0aGlzLndyYXBwZXIpLCB0aGlzLmVsZW1lbnRPZmZzZXQodGhpcy50cmFjayksIHRoaXMucHJvcHMuYnV0dG9ucyk7XG4gICAgfVxuICAgIGdldFRpY2tTaXplcygpIHtcbiAgICAgICAgY29uc3QgeyBtaW4sIG1heCwgc21hbGxTdGVwIH0gPSB0aGlzLnByb3BzO1xuICAgICAgICBjb25zdCBjb3VudCA9IGNhbGN1bGF0ZVRpY2tzQ291bnQobWluLCBtYXgsIHNtYWxsU3RlcCk7XG4gICAgICAgIGNvbnN0IHRyYWNrU2l6ZSA9IHRoaXMudHJhY2tXaWR0aCgpO1xuICAgICAgICBjb25zdCBkaXN0U3RlcCA9IHRyYWNrU2l6ZSAvIHN1YnRyYWN0KG1heCwgbWluKTtcbiAgICAgICAgY29uc3QgcmVzdWx0ID0gW107XG4gICAgICAgIGxldCB1c2VkU3BhY2UgPSAwO1xuICAgICAgICBsZXQgZW5kUG9pbnQgPSAwO1xuICAgICAgICBmb3IgKGxldCBpID0gMDsgaSA8IGNvdW50OyBpKyspIHtcbiAgICAgICAgICAgIGlmIChpID09PSAwIHx8IGkgPT09IGNvdW50IC0gMSkge1xuICAgICAgICAgICAgICAgIGVuZFBvaW50ICs9IChzbWFsbFN0ZXAgLyAyKSAqIGRpc3RTdGVwO1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgZWxzZSB7XG4gICAgICAgICAgICAgICAgZW5kUG9pbnQgKz0gc21hbGxTdGVwICogZGlzdFN0ZXA7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICAvLyBlbnN1cmUgdGhhdCB0aGUgc3VtIG9mIHRoZSB0aWNrIHNpemVzIGRvZXMgbm90IGV4Y2VlZCB0aGUgdHJhY2sgd2lkdGhcbiAgICAgICAgICAgIGVuZFBvaW50ID0gK2VuZFBvaW50LnRvRml4ZWQoMikgLSAwLjAxO1xuICAgICAgICAgICAgY29uc3Qgc2l6ZSA9IE1hdGgucm91bmQoZW5kUG9pbnQgLSB1c2VkU3BhY2UpO1xuICAgICAgICAgICAgcmVzdWx0LnB1c2goc2l6ZSk7XG4gICAgICAgICAgICB1c2VkU3BhY2UgKz0gc2l6ZTtcbiAgICAgICAgfVxuICAgICAgICBpZiAodXNlZFNwYWNlID49IHRyYWNrU2l6ZSkge1xuICAgICAgICAgICAgcmVzdWx0W3Jlc3VsdC5sZW5ndGggLSAxXSAtPSAxO1xuICAgICAgICB9XG4gICAgICAgIHJldHVybiByZXN1bHQ7XG4gICAgfVxuICAgIGFkanVzdFBhZGRpbmcodGlja3NDb250YWluZXIpIHtcbiAgICAgICAgY29uc3QgdG90YWxUaWNrU2l6ZSA9IHRoaXMudGlja1NpemVzLnJlZHVjZSgocHJldiwgY3VycikgPT4gcHJldiArIGN1cnIsIDApO1xuICAgICAgICBjb25zdCB0cmFja1dpZHRoID0gdGhpcy50cmFja1dpZHRoKCk7XG4gICAgICAgIGNvbnN0IHJlbWluZGVyID0gdHJhY2tXaWR0aCAtIHRvdGFsVGlja1NpemU7XG4gICAgICAgIGlmIChyZW1pbmRlciAhPT0gMCkge1xuICAgICAgICAgICAgY29uc3QgcGFkZGluZyA9IHJlbWluZGVyICsgdGhpcy5lbGVtZW50T2Zmc2V0KHRoaXMudHJhY2spO1xuICAgICAgICAgICAgdGlja3NDb250YWluZXIuc3R5bGUucGFkZGluZ1RvcCA9IGAke3BhZGRpbmd9cHhgO1xuICAgICAgICB9XG4gICAgfVxuICAgIGVsZW1lbnRPZmZzZXQoZWxlbWVudCkge1xuICAgICAgICBjb25zdCB7IHZlcnRpY2FsIH0gPSB0aGlzLnByb3BzO1xuICAgICAgICBjb25zdCBzdHlsZSA9IGdldENvbXB1dGVkU3R5bGUoZWxlbWVudCk7XG4gICAgICAgIHJldHVybiBwYXJzZUludCh2ZXJ0aWNhbCA/IHN0eWxlLmJvdHRvbSA6IHN0eWxlLmxlZnQsIDEwKTtcbiAgICB9XG4gICAgZWxlbWVudFNpemUoZWxlbWVudCkge1xuICAgICAgICBjb25zdCB7IHZlcnRpY2FsIH0gPSB0aGlzLnByb3BzO1xuICAgICAgICByZXR1cm4gdmVydGljYWwgPyBlbGVtZW50LmNsaWVudEhlaWdodCA6IGVsZW1lbnQuY2xpZW50V2lkdGg7XG4gICAgfVxufVxuXG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY2xhc3MgU2xpZGVyTW9kZWwgZXh0ZW5kcyBTbGlkZXJNb2RlbEJhc2Uge1xuICAgIHBvc2l0aW9uSGFuZGxlKGRyYWdIYW5kbGUpIHtcbiAgICAgICAgY29uc3QgeyBtYXgsIG1pbiwgcmV2ZXJzZSwgdmVydGljYWwgfSA9IHRoaXMucHJvcHM7XG4gICAgICAgIGNvbnN0IHBvc2l0aW9uID0gdmVydGljYWwgPyAnYm90dG9tJyA6ICdsZWZ0JztcbiAgICAgICAgY29uc3QgdHJhY2tXaWR0aCA9IHRoaXMudHJhY2tXaWR0aCgpO1xuICAgICAgICBjb25zdCB2YWx1ZSA9IHRyaW1WYWx1ZShtYXgsIG1pbiwgdGhpcy5wcm9wcy52YWx1ZSk7XG4gICAgICAgIHRoaXMuaGFuZGxlUG9zaXRpb24gPSBjYWxjdWxhdGVIYW5kbGVQb3NpdGlvbih7XG4gICAgICAgICAgICBtaW4sXG4gICAgICAgICAgICBtYXgsXG4gICAgICAgICAgICByZXZlcnNlLFxuICAgICAgICAgICAgdmFsdWUsXG4gICAgICAgICAgICB0cmFja1dpZHRoLFxuICAgICAgICAgICAgaGFuZGxlV2lkdGg6IGRyYWdIYW5kbGUub2Zmc2V0V2lkdGhcbiAgICAgICAgfSk7XG4gICAgICAgIHRoaXMucmVuZGVyZXIuc2V0U3R5bGUoZHJhZ0hhbmRsZSwgcG9zaXRpb24sIGAke3RoaXMuaGFuZGxlUG9zaXRpb259cHhgKTtcbiAgICB9XG4gICAgcG9zaXRpb25TZWxlY3Rpb24oZHJhZ0hhbmRsZSwgc2VsZWN0aW9uKSB7XG4gICAgICAgIGNvbnN0IHsgcmV2ZXJzZSwgdmVydGljYWwgfSA9IHRoaXMucHJvcHM7XG4gICAgICAgIGNvbnN0IGRpbWVuc2lvbiA9IHZlcnRpY2FsID8gJ2hlaWdodCcgOiAnd2lkdGgnO1xuICAgICAgICBjb25zdCBoYW5kbGVXaWR0aCA9IE1hdGguZmxvb3IoZHJhZ0hhbmRsZS5vZmZzZXRXaWR0aCAvIDIpO1xuICAgICAgICBsZXQgc2l6ZSA9IHRoaXMuaGFuZGxlUG9zaXRpb24gKyBoYW5kbGVXaWR0aDtcbiAgICAgICAgaWYgKHJldmVyc2UpIHtcbiAgICAgICAgICAgIHNpemUgPSB0aGlzLnRyYWNrV2lkdGgoKSAtIHNpemU7XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5yZW5kZXJlci5zZXRTdHlsZShzZWxlY3Rpb24sIGRpbWVuc2lvbiwgYCR7c2l6ZX1weGApO1xuICAgIH1cbn1cblxuY29uc3QgVU5UT1VDSEVEID0gJ25nLXVudG91Y2hlZCc7XG5jb25zdCB0b0NsYXNzTGlzdCA9IChjbGFzc05hbWVzKSA9PiBTdHJpbmcoY2xhc3NOYW1lcykudHJpbSgpLnNwbGl0KCcgJyk7XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgaGFzQ2xhc3MgPSAoZWxlbWVudCwgY2xhc3NOYW1lKSA9PiBCb29sZWFuKHRvQ2xhc3NMaXN0KGVsZW1lbnQuY2xhc3NOYW1lKS5maW5kKChuYW1lKSA9PiBuYW1lID09PSBjbGFzc05hbWUpKTtcbi8qKlxuICogQGhpZGRlblxuICovXG5mdW5jdGlvbiBpbnZva2VFbGVtZW50TWV0aG9kKGVsZW1lbnQsIG5hbWUsIC4uLmFyZ3MpIHtcbiAgICBpZiAoZWxlbWVudCAmJiBlbGVtZW50Lm5hdGl2ZUVsZW1lbnQpIHtcbiAgICAgICAgcmV0dXJuIGVsZW1lbnQubmF0aXZlRWxlbWVudFtuYW1lXS5hcHBseShlbGVtZW50Lm5hdGl2ZUVsZW1lbnQsIGFyZ3MpO1xuICAgIH1cbn1cbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCBpc1VudG91Y2hlZCA9IChlbGVtZW50KSA9PiBlbGVtZW50ICYmIGVsZW1lbnQubmF0aXZlRWxlbWVudCAmJiBoYXNDbGFzcyhlbGVtZW50Lm5hdGl2ZUVsZW1lbnQsIFVOVE9VQ0hFRCk7XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgY29udGFpbnNGb2N1cyA9IChob3N0RWxlbWVudCwgY29udGVuZGVyKSA9PiBob3N0RWxlbWVudCAmJiBjb250ZW5kZXIgJiYgKGhvc3RFbGVtZW50ID09PSBjb250ZW5kZXIgfHwgaG9zdEVsZW1lbnQuY29udGFpbnMoY29udGVuZGVyKSk7XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgY2xvc2VzdCA9IChub2RlLCBwcmVkaWNhdGUpID0+IHtcbiAgICB3aGlsZSAobm9kZSAmJiAhcHJlZGljYXRlKG5vZGUpKSB7XG4gICAgICAgIG5vZGUgPSBub2RlLnBhcmVudE5vZGU7XG4gICAgfVxuICAgIHJldHVybiBub2RlO1xufTtcblxuLyoqXG4gKiBSZXByZXNlbnRzIHRoZSB0ZW1wbGF0ZSBmb3IgdGhlIGxhYmVscyBvZiB0aGUgU2xpZGVyLlxuICogVG8gZGVmaW5lIHRoZSBsYWJlbHMgdGVtcGxhdGUsIG5lc3QgYW4gYDxuZy10ZW1wbGF0ZT5gIHRhZyB3aXRoIHRoZSBga2VuZG9TbGlkZXJMYWJlbFRlbXBsYXRlYCBkaXJlY3RpdmUgaW5zaWRlXG4gKiB0aGUgYDxrZW5kby1zbGlkZXI+YCB0YWcuIFRoZSB0ZW1wbGF0ZSBjb250ZXh0IGlzIHBhc3NlZCB0byB0aGUgYGxhYmVsYCB2YWx1ZS5cbiAqXG4gKiBAZXhhbXBsZVxuICogYGBgdHMtbm8tcnVuXG4gKlxuICogX0BDb21wb25lbnQoe1xuICogICAgIHNlbGVjdG9yOiAnbXktYXBwJyxcbiAqICAgICB0ZW1wbGF0ZTogYFxuICogICAgICAgICA8a2VuZG8tc2xpZGVyIFtsYXJnZVN0ZXBdPVwiMlwiPlxuICogICAgICAgICAgIDxuZy10ZW1wbGF0ZSBrZW5kb1NsaWRlckxhYmVsVGVtcGxhdGUgbGV0LXZhbHVlPVwidmFsdWVcIj5cbiAqICAgICAgICAgICAgIDxiPnt7dmFsdWV9fTwvYj5cbiAqICAgICAgICAgICA8L25nLXRlbXBsYXRlPlxuICogICAgICAgICA8L2tlbmRvLXNsaWRlcj5cbiAqICAgICBgXG4gKiB9KVxuICpcbiAqIGNsYXNzIEFwcENvbXBvbmVudCB7XG4gKiB9XG4gKlxuICogYGBgXG4gKi9cbmNsYXNzIExhYmVsVGVtcGxhdGVEaXJlY3RpdmUge1xuICAgIGNvbnN0cnVjdG9yKHRlbXBsYXRlUmVmKSB7XG4gICAgICAgIHRoaXMudGVtcGxhdGVSZWYgPSB0ZW1wbGF0ZVJlZjtcbiAgICB9XG59XG5MYWJlbFRlbXBsYXRlRGlyZWN0aXZlLmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBEaXJlY3RpdmUsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgc2VsZWN0b3I6ICdba2VuZG9TbGlkZXJMYWJlbFRlbXBsYXRlXSdcbiAgICAgICAgICAgIH0sXSB9LFxuXTtcbi8qKiBAbm9jb2xsYXBzZSAqL1xuTGFiZWxUZW1wbGF0ZURpcmVjdGl2ZS5jdG9yUGFyYW1ldGVycyA9ICgpID0+IFtcbiAgICB7IHR5cGU6IFRlbXBsYXRlUmVmLCBkZWNvcmF0b3JzOiBbeyB0eXBlOiBPcHRpb25hbCB9XSB9XG5dO1xuXG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY2xhc3MgU2xpZGVyQmFzZSB7XG4gICAgY29uc3RydWN0b3IobG9jYWxpemF0aW9uU2VydmljZSwgaW5qZWN0b3IsIHJlbmRlcmVyLCBuZ1pvbmUsIGNoYW5nZURldGVjdG9yLCBob3N0RWxlbWVudCkge1xuICAgICAgICB0aGlzLmxvY2FsaXphdGlvblNlcnZpY2UgPSBsb2NhbGl6YXRpb25TZXJ2aWNlO1xuICAgICAgICB0aGlzLmluamVjdG9yID0gaW5qZWN0b3I7XG4gICAgICAgIHRoaXMucmVuZGVyZXIgPSByZW5kZXJlcjtcbiAgICAgICAgdGhpcy5uZ1pvbmUgPSBuZ1pvbmU7XG4gICAgICAgIHRoaXMuY2hhbmdlRGV0ZWN0b3IgPSBjaGFuZ2VEZXRlY3RvcjtcbiAgICAgICAgdGhpcy5ob3N0RWxlbWVudCA9IGhvc3RFbGVtZW50O1xuICAgICAgICAvKipcbiAgICAgICAgICogRGVmaW5lcyB0aGUgdGl0bGUgb2YgdGhlIHRpY2tzIChbc2VlIGV4YW1wbGVdKHslIHNsdWcgdGlja3Nfc2xpZGVyICV9I3RvYy10aXRsZXMpKS4gVGhlIGRlZmF1bHQgdGl0bGVcbiAgICAgICAgICogZm9yIGVhY2ggdGljayBpcyBpdHMgU2xpZGVyIHZhbHVlLiBJZiB5b3UgdXNlIGEgY2FsbGJhY2sgZnVuY3Rpb24sIHRoZSBmdW5jdGlvbiBhY2NlcHRzIGFuIGFyZ3VtZW50XG4gICAgICAgICAqIHRoYXQgaG9sZHMgdGhlIHZhbHVlIG9mIHRoZSBjb21wb25lbnQgYW5kIHJldHVybnMgYSBzdHJpbmcgd2l0aCB0aGUgbmV3IHRpdGxlLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy50aXRsZSA9IGlkZW50aXR5O1xuICAgICAgICAvKipcbiAgICAgICAgICogRGVub3RlcyB0aGUgbG9jYXRpb24gb2YgdGhlIHRpY2sgbWFya3MgaW4gdGhlIFNsaWRlciAoW3NlZSBleGFtcGxlXSh7JSBzbHVnIHRpY2tzX3NsaWRlciAlfSN0b2MtcGxhY2VtZW50KSkuXG4gICAgICAgICAqXG4gICAgICAgICAqIFRoZSBhdmFpbGFibGUgb3B0aW9ucyBhcmU6XG4gICAgICAgICAqICogYGJlZm9yZWAmbWRhc2g7VGhlIHRpY2sgbWFya3MgYXJlIGxvY2F0ZWQgdG8gdGhlIHRvcCBzaWRlIG9mIHRoZSBob3Jpem9udGFsIHRyYWNrIG9yIHRvIHRoZSBsZWZ0IHNpZGUgb2YgYSB2ZXJ0aWNhbCB0cmFjay5cbiAgICAgICAgICogKiBgYWZ0ZXJgJm1kYXNoO1RoZSB0aWNrIG1hcmtzIGFyZSBsb2NhdGVkIHRvIHRoZSBib3R0b20gc2lkZSBvZiB0aGUgaG9yaXpvbnRhbCB0cmFjayBvciB0byB0aGUgcmlnaHQgc2lkZSBvZiB0aGUgdmVydGljYWwgdHJhY2suXG4gICAgICAgICAqICogYGJvdGhgJm1kYXNoOyAoRGVmYXVsdCkgVGhlIHRpY2sgbWFya3MgYXJlIGxvY2F0ZWQgb24gYm90aCBzaWRlcyBvZiB0aGUgdHJhY2suXG4gICAgICAgICAqICogYG5vbmVgJm1kYXNoO1RoZSB0aWNrIG1hcmtzIGFyZSBub3QgdmlzaWJsZS4gVGhlIGFjdHVhbCBlbGVtZW50cyBhcmUgbm90IGFkZGVkIHRvIHRoZSBET00gdHJlZS5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMudGlja1BsYWNlbWVudCA9ICdib3RoJztcbiAgICAgICAgLyoqXG4gICAgICAgICAqIElmIGB2ZXJ0aWNhbGAgaXMgc2V0IHRvIGB0cnVlYCwgdGhlIG9yaWVudGF0aW9uIG9mIHRoZSBTbGlkZXIgY2hhbmdlcyBmcm9tIGhvcml6b250YWwgdG8gdmVydGljYWxcbiAgICAgICAgICogKFtzZWUgZXhhbXBsZV0oeyUgc2x1ZyBvcmllbnRhdGlvbl9zbGlkZXIgJX0pKS5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMudmVydGljYWwgPSBmYWxzZTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIFRoZSBtaW5pbXVtIHZhbHVlIG9mIHRoZSBTbGlkZXIgKFtzZWUgZXhhbXBsZV0oeyUgc2x1ZyBwcmVkZWZpbmVkc3RlcHNfc2xpZGVyICV9I3RvYy1zbWFsbC1zdGVwcykpLlxuICAgICAgICAgKiBUaGUgYXR0cmlidXRlIGFjY2VwdHMgYm90aCBpbnRlZ2VycyBhbmQgZmxvYXRpbmctcG9pbnQgbnVtYmVycy5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMubWluID0gMDtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIFRoZSBtYXhpbXVtIHZhbHVlIG9mIHRoZSBTbGlkZXIgKFtzZWUgZXhhbXBsZV0oeyUgc2x1ZyBwcmVkZWZpbmVkc3RlcHNfc2xpZGVyICV9I3RvYy1zbWFsbC1zdGVwcykpLlxuICAgICAgICAgKiBUaGUgYXR0cmlidXRlIGFjY2VwdHMgYm90aCBpbnRlZ2VycyBhbmQgZmxvYXRpbmctcG9pbnQgbnVtYmVycy5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMubWF4ID0gMTA7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBUaGUgc3RlcCB2YWx1ZSBvZiB0aGUgU2xpZGVyIChbc2VlIGV4YW1wbGVdKHslIHNsdWcgcHJlZGVmaW5lZHN0ZXBzX3NsaWRlciAlfSN0b2Mtc21hbGwtc3RlcHMpKS5cbiAgICAgICAgICogQWNjZXB0cyBwb3NpdGl2ZSB2YWx1ZXMgb25seS4gQ2FuIGJlIGFuIGludGVnZXIgb3IgYSBmbG9hdGluZy1wb2ludCBudW1iZXIuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLnNtYWxsU3RlcCA9IDE7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBTcGVjaWZpZXMgdGhhdCBldmVyeSBuPHN1cD50aDwvc3VwPiB0aWNrIHdpbGwgYmUgbGFyZ2UgYW5kIHdpbGwgaGF2ZSBhIGxhYmVsXG4gICAgICAgICAqIChbc2VlIGV4YW1wbGVdKHslIHNsdWcgcHJlZGVmaW5lZHN0ZXBzX3NsaWRlciAlfSN0b2MtbGFyZ2Utc3RlcHMpKS5cbiAgICAgICAgICogQWNjZXB0cyBwb3NpdGl2ZSBpbnRlZ2VyIHZhbHVlcyBvbmx5LlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5sYXJnZVN0ZXAgPSBudWxsO1xuICAgICAgICAvKipcbiAgICAgICAgICogRGV0ZXJtaW5lcyB3aGV0aGVyIHRoZSBTbGlkZXIgaXMgZGlzYWJsZWQgKFtzZWUgZXhhbXBsZV0oeyUgc2x1ZyBkaXNhYmxlZHN0YXRlX3NsaWRlciAlfSkpLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5kaXNhYmxlZCA9IGZhbHNlO1xuICAgICAgICAvKipcbiAgICAgICAgICogRGV0ZXJtaW5lcyB3aGV0aGVyIHRoZSBTbGlkZXIgaXMgaW4gaXRzIHJlYWQtb25seSBzdGF0ZSAoW3NlZSBleGFtcGxlXSh7JSBzbHVnIHJlYWRvbmx5X3NsaWRlciAlfSkpLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5yZWFkb25seSA9IGZhbHNlO1xuICAgICAgICAvKipcbiAgICAgICAgICogU3BlY2lmaWVzIHRoZSBbYHRhYmluZGV4YF0oaHR0cHM6Ly9kZXZlbG9wZXIubW96aWxsYS5vcmcvZW4tVVMvZG9jcy9XZWIvSFRNTC9HbG9iYWxfYXR0cmlidXRlcy90YWJpbmRleCkgb2YgdGhlIFNsaWRlci5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMudGFiaW5kZXggPSAwO1xuICAgICAgICAvKipcbiAgICAgICAgICogRmlyZXMgZWFjaCB0aW1lIHRoZSB1c2VyIGZvY3VzZXMgdGhlIGNvbXBvbmVudC5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMub25Gb2N1cyA9IG5ldyBFdmVudEVtaXR0ZXIoKTsgLy90c2xpbnQ6ZGlzYWJsZS1saW5lOm5vLW91dHB1dC1yZW5hbWVcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEZpcmVzIGVhY2ggdGltZSB0aGUgY29tcG9uZW50IGlzIGJsdXJyZWQuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLm9uQmx1ciA9IG5ldyBFdmVudEVtaXR0ZXIoKTsgLy90c2xpbnQ6ZGlzYWJsZS1saW5lOm5vLW91dHB1dC1yZW5hbWVcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEZpcmVzIGVhY2ggdGltZSB0aGUgdXNlciBzZWxlY3RzIGEgbmV3IHZhbHVlLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy52YWx1ZUNoYW5nZSA9IG5ldyBFdmVudEVtaXR0ZXIoKTtcbiAgICAgICAgdGhpcy5zbGlkZXJDbGFzcyA9IHRydWU7XG4gICAgICAgIHRoaXMud2lkZ2V0Q2xhc3MgPSB0cnVlO1xuICAgICAgICB0aGlzLnN1YnNjcmlwdGlvbnMgPSBuZXcgU3Vic2NyaXB0aW9uKCk7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmlmRW5hYmxlZCA9IChjYWxsYmFjaywgZXZlbnQpID0+IHtcbiAgICAgICAgICAgIGlmICghdGhpcy5pc0Rpc2FibGVkKSB7XG4gICAgICAgICAgICAgICAgY2FsbGJhY2suY2FsbCh0aGlzLCBldmVudCk7XG4gICAgICAgICAgICB9XG4gICAgICAgIH07XG4gICAgICAgIHRoaXMuZGlyZWN0aW9uID0gbG9jYWxpemF0aW9uU2VydmljZS5ydGwgPyAncnRsJyA6ICdsdHInO1xuICAgIH1cbiAgICBnZXQgaG9yaXpvbnRhbENsYXNzKCkge1xuICAgICAgICByZXR1cm4gIXRoaXMudmVydGljYWw7XG4gICAgfVxuICAgIGdldCB2ZXJ0aWNhbENsYXNzKCkge1xuICAgICAgICByZXR1cm4gdGhpcy52ZXJ0aWNhbDtcbiAgICB9XG4gICAgZ2V0IGRpc2FibGVkQ2xhc3MoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmRpc2FibGVkO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICogQ2FsbGVkIHdoZW4gdGhlIHN0YXR1cyBvZiB0aGUgY29tcG9uZW50IGNoYW5nZXMgdG8gb3IgZnJvbSBgZGlzYWJsZWRgLlxuICAgICAqIERlcGVuZGluZyBvbiB0aGUgdmFsdWUsIGl0IGVuYWJsZXMgb3IgZGlzYWJsZXMgdGhlIGFwcHJvcHJpYXRlIERPTSBlbGVtZW50LlxuICAgICAqXG4gICAgICogQHBhcmFtIGlzRGlzYWJsZWRcbiAgICAgKi9cbiAgICBzZXREaXNhYmxlZFN0YXRlKGlzRGlzYWJsZWQpIHtcbiAgICAgICAgdGhpcy5kaXNhYmxlZCA9IGlzRGlzYWJsZWQ7XG4gICAgfVxuICAgIG5nT25Jbml0KCkge1xuICAgICAgICB0aGlzLnN1YnNjcmlwdGlvbnMuYWRkKHRoaXMubG9jYWxpemF0aW9uU2VydmljZVxuICAgICAgICAgICAgLmNoYW5nZXNcbiAgICAgICAgICAgIC5zdWJzY3JpYmUoKHsgcnRsIH0pID0+IHtcbiAgICAgICAgICAgIHRoaXMuZGlyZWN0aW9uID0gcnRsID8gJ3J0bCcgOiAnbHRyJztcbiAgICAgICAgICAgIHRoaXMuc2l6ZUNvbXBvbmVudCgpO1xuICAgICAgICB9KSk7XG4gICAgICAgIGlmICh0aGlzLmhvc3RFbGVtZW50KSB7XG4gICAgICAgICAgICB0aGlzLnJlbmRlcmVyLnJlbW92ZUF0dHJpYnV0ZSh0aGlzLmhvc3RFbGVtZW50Lm5hdGl2ZUVsZW1lbnQsIFwidGFiaW5kZXhcIik7XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5jb250cm9sID0gdGhpcy5pbmplY3Rvci5nZXQoTmdDb250cm9sLCBudWxsKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIGdldCBpc0Rpc2FibGVkKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5kaXNhYmxlZCB8fCB0aGlzLnJlYWRvbmx5O1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICogVXNlZCBieSB0aGUgRmxvYXRpbmdMYWJlbCB0byBkZXRlcm1pbmUgaWYgdGhlIGNvbXBvbmVudCBpcyBlbXB0eS5cbiAgICAgKi9cbiAgICBpc0VtcHR5KCkge1xuICAgICAgICByZXR1cm4gZmFsc2U7XG4gICAgfVxuICAgIGdldCByZXZlcnNlKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5sb2NhbGl6YXRpb25TZXJ2aWNlLnJ0bCAmJiAhdGhpcy52ZXJ0aWNhbDtcbiAgICB9XG4gICAgZ2V0IGtleUJpbmRpbmcoKSB7XG4gICAgICAgIGNvbnN0IHJldmVyc2UgPSB0aGlzLnJldmVyc2U7XG4gICAgICAgIHJldHVybiB7XG4gICAgICAgICAgICBbS2V5cy5BcnJvd0xlZnRdOiByZXZlcnNlID8gaW5jcmVtZW50IDogZGVjcmVtZW50LFxuICAgICAgICAgICAgW0tleXMuQXJyb3dSaWdodF06IHJldmVyc2UgPyBkZWNyZW1lbnQgOiBpbmNyZW1lbnQsXG4gICAgICAgICAgICBbS2V5cy5BcnJvd0Rvd25dOiBkZWNyZW1lbnQsXG4gICAgICAgICAgICBbS2V5cy5BcnJvd1VwXTogaW5jcmVtZW50LFxuICAgICAgICAgICAgW0tleXMuUGFnZVVwXTogaW5jcmVtZW50TGFyZ2UsXG4gICAgICAgICAgICBbS2V5cy5QYWdlRG93bl06IGRlY3JlbWVudExhcmdlLFxuICAgICAgICAgICAgW0tleXMuSG9tZV06ICh7IG1pbiB9KSA9PiBtaW4sXG4gICAgICAgICAgICBbS2V5cy5FbmRdOiAoeyBtYXggfSkgPT4gbWF4XG4gICAgICAgIH07XG4gICAgfVxuICAgIHJlc2V0U3R5bGVzKGVsZW1lbnRzKSB7XG4gICAgICAgIGVsZW1lbnRzLmZvckVhY2goZWwgPT4ge1xuICAgICAgICAgICAgaWYgKGVsKSB7XG4gICAgICAgICAgICAgICAgaWYgKHRoaXMudmVydGljYWwpIHtcbiAgICAgICAgICAgICAgICAgICAgdGhpcy5yZW5kZXJlci5yZW1vdmVTdHlsZShlbCwgJ3dpZHRoJyk7XG4gICAgICAgICAgICAgICAgICAgIHRoaXMucmVuZGVyZXIucmVtb3ZlU3R5bGUoZWwsICdsZWZ0Jyk7XG4gICAgICAgICAgICAgICAgICAgIHRoaXMucmVuZGVyZXIucmVtb3ZlU3R5bGUoZWwsICdyaWdodCcpO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICBlbHNlIHtcbiAgICAgICAgICAgICAgICAgICAgdGhpcy5yZW5kZXJlci5yZW1vdmVTdHlsZShlbCwgJ2hlaWdodCcpO1xuICAgICAgICAgICAgICAgICAgICB0aGlzLnJlbmRlcmVyLnJlbW92ZVN0eWxlKGVsLCAnYm90dG9tJyk7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIHRoaXMucmVuZGVyZXIucmVtb3ZlU3R5bGUoZWwsICdwYWRkaW5nLXRvcCcpO1xuICAgICAgICAgICAgfVxuICAgICAgICB9KTtcbiAgICB9XG59XG5TbGlkZXJCYXNlLnByb3BEZWNvcmF0b3JzID0ge1xuICAgIHRpdGxlOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICB0aWNrUGxhY2VtZW50OiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICB2ZXJ0aWNhbDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgbWluOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBtYXg6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHNtYWxsU3RlcDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgbGFyZ2VTdGVwOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBmaXhlZFRpY2tXaWR0aDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgZGlzYWJsZWQ6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHJlYWRvbmx5OiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICB0YWJpbmRleDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgb25Gb2N1czogW3sgdHlwZTogT3V0cHV0LCBhcmdzOiBbJ2ZvY3VzJyxdIH1dLFxuICAgIG9uQmx1cjogW3sgdHlwZTogT3V0cHV0LCBhcmdzOiBbJ2JsdXInLF0gfV0sXG4gICAgdmFsdWVDaGFuZ2U6IFt7IHR5cGU6IE91dHB1dCB9XSxcbiAgICBkaXJlY3Rpb246IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2F0dHIuZGlyJyxdIH1dLFxuICAgIGhvcml6b250YWxDbGFzczogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnY2xhc3Muay1zbGlkZXItaG9yaXpvbnRhbCcsXSB9XSxcbiAgICB2ZXJ0aWNhbENsYXNzOiBbeyB0eXBlOiBIb3N0QmluZGluZywgYXJnczogWydjbGFzcy5rLXNsaWRlci12ZXJ0aWNhbCcsXSB9XSxcbiAgICBzbGlkZXJDbGFzczogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnY2xhc3Muay1zbGlkZXInLF0gfV0sXG4gICAgd2lkZ2V0Q2xhc3M6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstd2lkZ2V0JyxdIH1dLFxuICAgIGRpc2FibGVkQ2xhc3M6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstc3RhdGUtZGlzYWJsZWQnLF0gfV0sXG4gICAgd3JhcHBlcjogW3sgdHlwZTogVmlld0NoaWxkLCBhcmdzOiBbJ3dyYXAnLCB7IHN0YXRpYzogdHJ1ZSB9LF0gfV0sXG4gICAgdHJhY2s6IFt7IHR5cGU6IFZpZXdDaGlsZCwgYXJnczogWyd0cmFjaycsIHsgc3RhdGljOiB0cnVlIH0sXSB9XSxcbiAgICBzbGlkZXJTZWxlY3Rpb246IFt7IHR5cGU6IFZpZXdDaGlsZCwgYXJnczogWydzbGlkZXJTZWxlY3Rpb24nLCB7IHN0YXRpYzogdHJ1ZSB9LF0gfV0sXG4gICAgdGlja3NDb250YWluZXI6IFt7IHR5cGU6IFZpZXdDaGlsZCwgYXJnczogWyd0aWNrcycsIHsgcmVhZDogRWxlbWVudFJlZiB9LF0gfV0sXG4gICAgdGlja3M6IFt7IHR5cGU6IFZpZXdDaGlsZCwgYXJnczogWyd0aWNrcycsXSB9XSxcbiAgICBsYWJlbFRlbXBsYXRlOiBbeyB0eXBlOiBDb250ZW50Q2hpbGQsIGFyZ3M6IFtMYWJlbFRlbXBsYXRlRGlyZWN0aXZlLF0gfV1cbn07XG5cbmNvbnN0IEZPQ1VTRUQgPSAnay1zdGF0ZS1mb2N1c2VkJztcbmNvbnN0IFBSRVNTRUQgPSAnay1wcmVzc2VkJztcbi8qKlxuICogUmVwcmVzZW50cyB0aGUgW0tlbmRvIFVJIFNsaWRlciBjb21wb25lbnQgZm9yIEFuZ3VsYXJdKHslIHNsdWcgb3ZlcnZpZXdfc2xpZGVyICV9KS5cbiAqL1xuY2xhc3MgU2xpZGVyQ29tcG9uZW50IGV4dGVuZHMgU2xpZGVyQmFzZSB7XG4gICAgY29uc3RydWN0b3IobG9jYWxpemF0aW9uLCBpbmplY3RvciwgcmVuZGVyZXIsIG5nWm9uZSwgY2hhbmdlRGV0ZWN0b3IsIGhvc3RFbGVtZW50KSB7XG4gICAgICAgIHN1cGVyKGxvY2FsaXphdGlvbiwgaW5qZWN0b3IsIHJlbmRlcmVyLCBuZ1pvbmUsIGNoYW5nZURldGVjdG9yLCBob3N0RWxlbWVudCk7XG4gICAgICAgIHRoaXMubG9jYWxpemF0aW9uID0gbG9jYWxpemF0aW9uO1xuICAgICAgICB0aGlzLmluamVjdG9yID0gaW5qZWN0b3I7XG4gICAgICAgIHRoaXMucmVuZGVyZXIgPSByZW5kZXJlcjtcbiAgICAgICAgdGhpcy5uZ1pvbmUgPSBuZ1pvbmU7XG4gICAgICAgIHRoaXMuY2hhbmdlRGV0ZWN0b3IgPSBjaGFuZ2VEZXRlY3RvcjtcbiAgICAgICAgdGhpcy5ob3N0RWxlbWVudCA9IGhvc3RFbGVtZW50O1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5mb2N1c2FibGVJZCA9IGBrLSR7Z3VpZCgpfWA7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBEZXRlcm1pbmVzIGlmIHRoZSBhbmltYXRpb24gd2lsbCBiZSBwbGF5ZWQgb24gdmFsdWUgY2hhbmdlLlxuICAgICAgICAgKiBSZWdhcmRsZXNzIG9mIHRoaXMgc2V0dGluZywgbm8gYW5pbWF0aW9uIHdpbGwgYmUgcGxheWVkIGR1cmluZyB0aGUgaW5pdGlhbCByZW5kZXJpbmcuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmFuaW1hdGUgPSB0cnVlO1xuICAgICAgICAvKipcbiAgICAgICAgICogUmVuZGVycyB0aGUgYXJyb3cgc2lkZSBidXR0b25zIG9mIHRoZSBTbGlkZXIgKFtzZWUgZXhhbXBsZV0oeyUgc2x1ZyBzaWRlYnV0dG9uc19zbGlkZXIgJX0jdG9jLWhpZGRlbi1zdGF0ZSkpLlxuICAgICAgICAgKiBXaGVuIGBzaG93QnV0dG9uc2AgaXMgc2V0IHRvIGBmYWxzZWAsIHRoZSBidXR0b25zIGFyZSBub3QgZGlzcGxheWVkLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5zaG93QnV0dG9ucyA9IHRydWU7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBUaGUgY3VycmVudCB2YWx1ZSBvZiB0aGUgU2xpZGVyIHdoZW4gaXQgaXMgaW5pdGlhbGx5IGRpc3BsYXllZC5cbiAgICAgICAgICogVGhlIGNvbXBvbmVudCBjYW4gdXNlIGVpdGhlciBOZ01vZGVsIG9yIHRoZSBgdmFsdWVgIGJpbmRpbmcgYnV0IG5vdCBib3RoIG9mIHRoZW0gYXQgdGhlIHNhbWUgdGltZS5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMudmFsdWUgPSB0aGlzLm1pbjtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuaGFuZGxlRm9jdXMgPSAoKSA9PiB7XG4gICAgICAgICAgICB0aGlzLmZvY3VzZWQgPSB0cnVlO1xuICAgICAgICAgICAgaWYgKGhhc09ic2VydmVycyh0aGlzLm9uRm9jdXMpKSB7XG4gICAgICAgICAgICAgICAgdGhpcy5uZ1pvbmUucnVuKCgpID0+IHtcbiAgICAgICAgICAgICAgICAgICAgdGhpcy5vbkZvY3VzLmVtaXQoKTtcbiAgICAgICAgICAgICAgICB9KTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgfTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuaGFuZGxlQmx1ciA9ICgpID0+IHtcbiAgICAgICAgICAgIHRoaXMuY2hhbmdlRGV0ZWN0b3IubWFya0ZvckNoZWNrKCk7XG4gICAgICAgICAgICB0aGlzLmZvY3VzZWQgPSBmYWxzZTtcbiAgICAgICAgICAgIGlmIChoYXNPYnNlcnZlcnModGhpcy5vbkJsdXIpIHx8IHJlcXVpcmVzWm9uZU9uQmx1cih0aGlzLmNvbnRyb2wpKSB7XG4gICAgICAgICAgICAgICAgdGhpcy5uZ1pvbmUucnVuKCgpID0+IHtcbiAgICAgICAgICAgICAgICAgICAgdGhpcy5uZ1RvdWNoZWQoKTtcbiAgICAgICAgICAgICAgICAgICAgdGhpcy5vbkJsdXIuZW1pdCgpO1xuICAgICAgICAgICAgICAgIH0pO1xuICAgICAgICAgICAgfVxuICAgICAgICB9O1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5vbldyYXBDbGljayA9IChhcmdzKSA9PiB7XG4gICAgICAgICAgICBjb25zdCB0YXJnZXQgPSBhcmdzLnRhcmdldDtcbiAgICAgICAgICAgIGlmICghdGhpcy5pc0Rpc2FibGVkICYmICEoaXNCdXR0b24odGFyZ2V0KSB8fCBpc0J1dHRvbih0YXJnZXQucGFyZW50Tm9kZSkpKSB7XG4gICAgICAgICAgICAgICAgY29uc3QgdmFsdWUgPSBldmVudFZhbHVlKGFyZ3MsIHRoaXMudHJhY2submF0aXZlRWxlbWVudCwgdGhpcy5nZXRQcm9wcygpKTtcbiAgICAgICAgICAgICAgICB0aGlzLmNoYW5nZVZhbHVlKHZhbHVlKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgfTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMub25LZXlEb3duID0gKGUpID0+IHtcbiAgICAgICAgICAgIGNvbnN0IG9wdGlvbnMgPSB0aGlzLmdldFByb3BzKCk7XG4gICAgICAgICAgICBjb25zdCB7IG1heCwgbWluIH0gPSBvcHRpb25zO1xuICAgICAgICAgICAgY29uc3QgaGFuZGxlciA9IHRoaXMua2V5QmluZGluZ1tlLmtleUNvZGVdO1xuICAgICAgICAgICAgaWYgKHRoaXMuaXNEaXNhYmxlZCB8fCAhaGFuZGxlcikge1xuICAgICAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGNvbnN0IHZhbHVlID0gaGFuZGxlcihvcHRpb25zKTtcbiAgICAgICAgICAgIHRoaXMuY2hhbmdlVmFsdWUodHJpbVZhbHVlKG1heCwgbWluLCB2YWx1ZSkpO1xuICAgICAgICAgICAgZS5wcmV2ZW50RGVmYXVsdCgpO1xuICAgICAgICB9O1xuICAgICAgICB0aGlzLm5nQ2hhbmdlID0gKF8pID0+IHsgfTtcbiAgICAgICAgdGhpcy5uZ1RvdWNoZWQgPSAoKSA9PiB7IH07XG4gICAgICAgIHRoaXMuZGVjcmVhc2VWYWx1ZSA9ICgpID0+IHtcbiAgICAgICAgICAgIHRoaXMuY2hhbmdlVmFsdWUoZGVjcmVhc2VWYWx1ZVRvU3RlcCh0aGlzLnZhbHVlLCB0aGlzLmdldFByb3BzKCkpKTtcbiAgICAgICAgfTtcbiAgICAgICAgdGhpcy5pbmNyZWFzZVZhbHVlID0gKCkgPT4ge1xuICAgICAgICAgICAgdGhpcy5jaGFuZ2VWYWx1ZShpbmNyZWFzZVZhbHVlVG9TdGVwKHRoaXMudmFsdWUsIHRoaXMuZ2V0UHJvcHMoKSkpO1xuICAgICAgICB9O1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgc2V0IHRhYkluZGV4KHRhYkluZGV4KSB7XG4gICAgICAgIHRoaXMudGFiaW5kZXggPSB0YWJJbmRleDtcbiAgICB9XG4gICAgZ2V0IHRhYkluZGV4KCkge1xuICAgICAgICByZXR1cm4gdGhpcy50YWJpbmRleDtcbiAgICB9XG4gICAgLyoqXG4gICAgICogRm9jdXNlcyB0aGUgU2xpZGVyLlxuICAgICAqXG4gICAgICogQGV4YW1wbGVcbiAgICAgKiBgYGB0cy1uby1ydW5cbiAgICAgKiBfQENvbXBvbmVudCh7XG4gICAgICogc2VsZWN0b3I6ICdteS1hcHAnLFxuICAgICAqIHRlbXBsYXRlOiBgXG4gICAgICogIDxidXR0b24gKGNsaWNrKT1cInNsaWRlci5mb2N1cygpXCI+Rm9jdXM8L2J1dHRvbj5cbiAgICAgKiAgPGtlbmRvLXNsaWRlciAjc2xpZGVyPjwva2VuZG8tc2xpZGVyPlxuICAgICAqIGBcbiAgICAgKiB9KVxuICAgICAqIGNsYXNzIEFwcENvbXBvbmVudCB7IH1cbiAgICAgKiBgYGBcbiAgICAgKi9cbiAgICBmb2N1cygpIHtcbiAgICAgICAgaW52b2tlRWxlbWVudE1ldGhvZCh0aGlzLndyYXBwZXIsICdmb2N1cycpO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBCbHVycyB0aGUgU2xpZGVyLlxuICAgICAqL1xuICAgIGJsdXIoKSB7XG4gICAgICAgIGludm9rZUVsZW1lbnRNZXRob2QodGhpcy53cmFwcGVyLCAnYmx1cicpO1xuICAgIH1cbiAgICBuZ09uQ2hhbmdlcyhjaGFuZ2VzKSB7XG4gICAgICAgIGlmIChhbnlDaGFuZ2VkKFsndmFsdWUnLCAnZml4ZWRUaWNrV2lkdGgnLCAndGlja1BsYWNlbWVudCddLCBjaGFuZ2VzLCB0cnVlKSkge1xuICAgICAgICAgICAgdGhpcy5uZ1pvbmUub25TdGFibGUuYXNPYnNlcnZhYmxlKCkucGlwZSh0YWtlKDEpKS5zdWJzY3JpYmUoKCkgPT4ge1xuICAgICAgICAgICAgICAgIHRoaXMuc2l6ZUNvbXBvbmVudChmYWxzZSk7XG4gICAgICAgICAgICB9KTtcbiAgICAgICAgfVxuICAgIH1cbiAgICBuZ0FmdGVyVmlld0luaXQoKSB7XG4gICAgICAgIGlmICghaXNEb2N1bWVudEF2YWlsYWJsZSgpKSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgaWYgKHRoaXMuc2hvd0J1dHRvbnMpIHtcbiAgICAgICAgICAgIHRoaXMuc2V0VmFsdWVDaGFuZ2VJbnRlcnZhbCh0aGlzLmluY3JlYXNlQnV0dG9uLm5hdGl2ZUVsZW1lbnQsICgpID0+IHRoaXMuaW5jcmVhc2VWYWx1ZSgpKTtcbiAgICAgICAgICAgIHRoaXMuc2V0VmFsdWVDaGFuZ2VJbnRlcnZhbCh0aGlzLmRlY3JlYXNlQnV0dG9uLm5hdGl2ZUVsZW1lbnQsICgpID0+IHRoaXMuZGVjcmVhc2VWYWx1ZSgpKTtcbiAgICAgICAgfVxuICAgICAgICB0aGlzLnNpemVDb21wb25lbnQoZmFsc2UpO1xuICAgICAgICBpZiAodGhpcy50aWNrcykge1xuICAgICAgICAgICAgdGhpcy50aWNrcy50aWNrRWxlbWVudHNcbiAgICAgICAgICAgICAgICAuY2hhbmdlc1xuICAgICAgICAgICAgICAgIC5zdWJzY3JpYmUoKCkgPT4gdGhpcy5zaXplQ29tcG9uZW50KGZhbHNlKSk7XG4gICAgICAgIH1cbiAgICB9XG4gICAgbmdPbkRlc3Ryb3koKSB7XG4gICAgICAgIHRoaXMuc3Vic2NyaXB0aW9ucy51bnN1YnNjcmliZSgpO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgZ2V0IGluY3JlbWVudE1lc3NhZ2UoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmluY3JlbWVudFRpdGxlIHx8IHRoaXMubG9jYWxpemF0aW9uU2VydmljZS5nZXQoJ2luY3JlbWVudCcpO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgZ2V0IGRlY3JlbWVudE1lc3NhZ2UoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmRlY3JlbWVudFRpdGxlIHx8IHRoaXMubG9jYWxpemF0aW9uU2VydmljZS5nZXQoJ2RlY3JlbWVudCcpO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgZ2V0IGRyYWdIYW5kbGVNZXNzYWdlKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5kcmFnSGFuZGxlVGl0bGUgfHwgdGhpcy5sb2NhbGl6YXRpb25TZXJ2aWNlLmdldCgnZHJhZ0hhbmRsZScpO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgaGFuZGxlRHJhZ1ByZXNzKGFyZ3MpIHtcbiAgICAgICAgaWYgKGFyZ3Mub3JpZ2luYWxFdmVudCkge1xuICAgICAgICAgICAgYXJncy5vcmlnaW5hbEV2ZW50LnByZXZlbnREZWZhdWx0KCk7XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5mb2N1cygpO1xuICAgICAgICB0aGlzLnJlbmRlcmVyLnJlbW92ZUNsYXNzKHRoaXMuaG9zdEVsZW1lbnQubmF0aXZlRWxlbWVudCwgJ2stc2xpZGVyLXRyYW5zaXRpb25zJyk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBvbkhhbmRsZURyYWcoYXJncykge1xuICAgICAgICB0aGlzLmRyYWdnaW5nID0gdHJ1ZTtcbiAgICAgICAgdGhpcy5jaGFuZ2VWYWx1ZShldmVudFZhbHVlKGFyZ3MsIHRoaXMudHJhY2submF0aXZlRWxlbWVudCwgdGhpcy5nZXRQcm9wcygpKSk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBvbkhhbmRsZVJlbGVhc2UoKSB7XG4gICAgICAgIHRoaXMuZHJhZ2dpbmcgPSBmYWxzZTsgLy9uZWVkZWQgZm9yIGFuaW1hdGlvblxuICAgICAgICB0aGlzLnJlbmRlcmVyLmFkZENsYXNzKHRoaXMuaG9zdEVsZW1lbnQubmF0aXZlRWxlbWVudCwgJ2stc2xpZGVyLXRyYW5zaXRpb25zJyk7XG4gICAgfVxuICAgIC8vbmdNb2RlbCBiaW5kaW5nXG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHdyaXRlVmFsdWUodmFsdWUpIHtcbiAgICAgICAgdGhpcy52YWx1ZSA9IHZhbHVlO1xuICAgICAgICB0aGlzLnNpemVDb21wb25lbnQodGhpcy5hbmltYXRlKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHJlZ2lzdGVyT25DaGFuZ2UoZm4pIHtcbiAgICAgICAgdGhpcy5uZ0NoYW5nZSA9IGZuO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgcmVnaXN0ZXJPblRvdWNoZWQoZm4pIHtcbiAgICAgICAgdGhpcy5uZ1RvdWNoZWQgPSBmbjtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIGNoYW5nZVZhbHVlKHZhbHVlKSB7XG4gICAgICAgIGlmICghYXJlU2FtZSh0aGlzLnZhbHVlLCB2YWx1ZSkpIHtcbiAgICAgICAgICAgIHRoaXMubmdab25lLnJ1bigoKSA9PiB7XG4gICAgICAgICAgICAgICAgdGhpcy52YWx1ZSA9IHZhbHVlO1xuICAgICAgICAgICAgICAgIHRoaXMubmdDaGFuZ2UodmFsdWUpO1xuICAgICAgICAgICAgICAgIHRoaXMudmFsdWVDaGFuZ2UuZW1pdCh2YWx1ZSk7XG4gICAgICAgICAgICAgICAgdGhpcy5zaXplQ29tcG9uZW50KHRoaXMuYW5pbWF0ZSk7XG4gICAgICAgICAgICB9KTtcbiAgICAgICAgfVxuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgc2l6ZUNvbXBvbmVudChhbmltYXRlKSB7XG4gICAgICAgIGlmICghaXNEb2N1bWVudEF2YWlsYWJsZSgpKSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgY29uc3Qgd3JhcHBlciA9IHRoaXMud3JhcHBlci5uYXRpdmVFbGVtZW50O1xuICAgICAgICBjb25zdCB0cmFjayA9IHRoaXMudHJhY2submF0aXZlRWxlbWVudDtcbiAgICAgICAgY29uc3Qgc2VsZWN0aW9uRWwgPSB0aGlzLnNsaWRlclNlbGVjdGlvbi5uYXRpdmVFbGVtZW50O1xuICAgICAgICBjb25zdCBkcmFnSGFuZGxlRWwgPSB0aGlzLmRyYWdoYW5kbGUubmF0aXZlRWxlbWVudDtcbiAgICAgICAgY29uc3QgdGlja3MgPSB0aGlzLnRpY2tzID8gdGhpcy50aWNrc0NvbnRhaW5lci5uYXRpdmVFbGVtZW50IDogbnVsbDtcbiAgICAgICAgaWYgKCFhbmltYXRlKSB7XG4gICAgICAgICAgICB0aGlzLnJlbmRlcmVyLnJlbW92ZUNsYXNzKHRoaXMuaG9zdEVsZW1lbnQubmF0aXZlRWxlbWVudCwgJ2stc2xpZGVyLXRyYW5zaXRpb25zJyk7XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5yZXNldFN0eWxlcyhbdHJhY2ssIHNlbGVjdGlvbkVsLCBkcmFnSGFuZGxlRWwsIHRpY2tzLCB0aGlzLmhvc3RFbGVtZW50Lm5hdGl2ZUVsZW1lbnRdKTtcbiAgICAgICAgY29uc3QgcHJvcHMgPSB0aGlzLmdldFByb3BzKCk7XG4gICAgICAgIGNvbnN0IG1vZGVsID0gbmV3IFNsaWRlck1vZGVsKHByb3BzLCB3cmFwcGVyLCB0cmFjaywgdGhpcy5yZW5kZXJlcik7XG4gICAgICAgIG1vZGVsLnJlc2l6ZVRyYWNrKCk7XG4gICAgICAgIGlmICh0aGlzLnRpY2tzKSB7IC8vZm9yIGNhc2Ugd2hlbiB0aWNrUGxhY2VtZW50OiBub25lXG4gICAgICAgICAgICBtb2RlbC5yZXNpemVUaWNrcyh0aGlzLnRpY2tzQ29udGFpbmVyLm5hdGl2ZUVsZW1lbnQsIHRoaXMudGlja3MudGlja0VsZW1lbnRzLm1hcChlbGVtZW50ID0+IGVsZW1lbnQubmF0aXZlRWxlbWVudCkpO1xuICAgICAgICB9XG4gICAgICAgIG1vZGVsLnBvc2l0aW9uSGFuZGxlKGRyYWdIYW5kbGVFbCk7XG4gICAgICAgIG1vZGVsLnBvc2l0aW9uU2VsZWN0aW9uKGRyYWdIYW5kbGVFbCwgc2VsZWN0aW9uRWwpO1xuICAgICAgICBpZiAoIWFuaW1hdGUpIHtcbiAgICAgICAgICAgIHRoaXMuaG9zdEVsZW1lbnQubmF0aXZlRWxlbWVudC5nZXRCb3VuZGluZ0NsaWVudFJlY3QoKTtcbiAgICAgICAgICAgIHRoaXMucmVuZGVyZXIuYWRkQ2xhc3ModGhpcy5ob3N0RWxlbWVudC5uYXRpdmVFbGVtZW50LCAnay1zbGlkZXItdHJhbnNpdGlvbnMnKTtcbiAgICAgICAgfVxuICAgICAgICBpZiAodGhpcy5maXhlZFRpY2tXaWR0aCkge1xuICAgICAgICAgICAgbW9kZWwucmVzaXplV3JhcHBlcigpO1xuICAgICAgICB9XG4gICAgfVxuICAgIHNldCBmb2N1c2VkKHZhbHVlKSB7XG4gICAgICAgIGlmICh0aGlzLmlzRm9jdXNlZCAhPT0gdmFsdWUgJiYgdGhpcy5ob3N0RWxlbWVudCkge1xuICAgICAgICAgICAgY29uc3QgZWxlbWVudCA9IHRoaXMuaG9zdEVsZW1lbnQubmF0aXZlRWxlbWVudDtcbiAgICAgICAgICAgIGlmICh2YWx1ZSkge1xuICAgICAgICAgICAgICAgIHRoaXMucmVuZGVyZXIuYWRkQ2xhc3MoZWxlbWVudCwgRk9DVVNFRCk7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICBlbHNlIHtcbiAgICAgICAgICAgICAgICB0aGlzLnJlbmRlcmVyLnJlbW92ZUNsYXNzKGVsZW1lbnQsIEZPQ1VTRUQpO1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgdGhpcy5pc0ZvY3VzZWQgPSB2YWx1ZTtcbiAgICAgICAgfVxuICAgIH1cbiAgICBzZXQgZHJhZ2dpbmcodmFsdWUpIHtcbiAgICAgICAgaWYgKHRoaXMuaXNEcmFnZ2VkICE9PSB2YWx1ZSAmJiB0aGlzLnNsaWRlclNlbGVjdGlvbiAmJiB0aGlzLmRyYWdoYW5kbGUpIHtcbiAgICAgICAgICAgIGNvbnN0IHNsaWRlclNlbGVjdGlvbiA9IHRoaXMuc2xpZGVyU2VsZWN0aW9uLm5hdGl2ZUVsZW1lbnQ7XG4gICAgICAgICAgICBjb25zdCBkcmFnaGFuZGxlID0gdGhpcy5kcmFnaGFuZGxlLm5hdGl2ZUVsZW1lbnQ7XG4gICAgICAgICAgICBpZiAodmFsdWUpIHtcbiAgICAgICAgICAgICAgICB0aGlzLnJlbmRlcmVyLmFkZENsYXNzKHNsaWRlclNlbGVjdGlvbiwgUFJFU1NFRCk7XG4gICAgICAgICAgICAgICAgdGhpcy5yZW5kZXJlci5hZGRDbGFzcyhkcmFnaGFuZGxlLCBQUkVTU0VEKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGVsc2Uge1xuICAgICAgICAgICAgICAgIHRoaXMucmVuZGVyZXIucmVtb3ZlQ2xhc3Moc2xpZGVyU2VsZWN0aW9uLCBQUkVTU0VEKTtcbiAgICAgICAgICAgICAgICB0aGlzLnJlbmRlcmVyLnJlbW92ZUNsYXNzKGRyYWdoYW5kbGUsIFBSRVNTRUQpO1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgdGhpcy5pc0RyYWdnZWQgPSB2YWx1ZTtcbiAgICAgICAgfVxuICAgIH1cbiAgICBzZXRWYWx1ZUNoYW5nZUludGVydmFsKGVsZW1lbnQsIGNhbGxiYWNrKSB7XG4gICAgICAgIHRoaXMubmdab25lLnJ1bk91dHNpZGVBbmd1bGFyKCgpID0+IHtcbiAgICAgICAgICAgIGNvbnN0IG1vdXNlZG93biA9IGZyb21FdmVudChlbGVtZW50LCAnbW91c2Vkb3duJyk7XG4gICAgICAgICAgICBjb25zdCBtb3VzZXVwID0gZnJvbUV2ZW50KGVsZW1lbnQsICdtb3VzZXVwJyk7XG4gICAgICAgICAgICBjb25zdCBtb3VzZW91dCA9IGZyb21FdmVudChlbGVtZW50LCAnbW91c2VvdXQnKTtcbiAgICAgICAgICAgIGNvbnN0IHN1YnNjcmlwdGlvbiA9IG1vdXNlZG93bi5waXBlKGZpbHRlcigoZSkgPT4gZS5idXR0b24gPT09IDAgJiYgIXRoaXMuaXNEaXNhYmxlZCksIGNvbmNhdE1hcCgoKSA9PiBpbnRlcnZhbCgxNTApLnBpcGUoc3RhcnRXaXRoKC0xKSwgdGFrZVVudGlsKG1lcmdlKG1vdXNldXAsIG1vdXNlb3V0KSkpKSkuc3Vic2NyaWJlKCgpID0+IHtcbiAgICAgICAgICAgICAgICB0aGlzLmZvY3VzKCk7XG4gICAgICAgICAgICAgICAgY2FsbGJhY2soKTtcbiAgICAgICAgICAgIH0pO1xuICAgICAgICAgICAgdGhpcy5zdWJzY3JpcHRpb25zLmFkZChzdWJzY3JpcHRpb24pO1xuICAgICAgICB9KTtcbiAgICB9XG4gICAgZ2V0UHJvcHMoKSB7XG4gICAgICAgIHJldHVybiB7XG4gICAgICAgICAgICBidXR0b25zOiB0aGlzLnNob3dCdXR0b25zLFxuICAgICAgICAgICAgZGlzYWJsZWQ6IHRoaXMuZGlzYWJsZWQsXG4gICAgICAgICAgICBmaXhlZFRpY2tXaWR0aDogdGhpcy5maXhlZFRpY2tXaWR0aCxcbiAgICAgICAgICAgIGxhcmdlU3RlcDogdGhpcy5sYXJnZVN0ZXAsXG4gICAgICAgICAgICBtYXg6IHRoaXMubWF4LFxuICAgICAgICAgICAgbWluOiB0aGlzLm1pbixcbiAgICAgICAgICAgIHJlYWRvbmx5OiB0aGlzLnJlYWRvbmx5LFxuICAgICAgICAgICAgcmV2ZXJzZTogdGhpcy5yZXZlcnNlLFxuICAgICAgICAgICAgcnRsOiB0aGlzLmxvY2FsaXphdGlvblNlcnZpY2UucnRsLFxuICAgICAgICAgICAgc21hbGxTdGVwOiB0aGlzLnNtYWxsU3RlcCxcbiAgICAgICAgICAgIHZhbHVlOiB0cmltVmFsdWUodGhpcy5tYXgsIHRoaXMubWluLCB0aGlzLnZhbHVlKSxcbiAgICAgICAgICAgIHZlcnRpY2FsOiB0aGlzLnZlcnRpY2FsXG4gICAgICAgIH07XG4gICAgfVxufVxuU2xpZGVyQ29tcG9uZW50LmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBDb21wb25lbnQsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgZXhwb3J0QXM6ICdrZW5kb1NsaWRlcicsXG4gICAgICAgICAgICAgICAgcHJvdmlkZXJzOiBbXG4gICAgICAgICAgICAgICAgICAgIExvY2FsaXphdGlvblNlcnZpY2UsXG4gICAgICAgICAgICAgICAgICAgIHsgcHJvdmlkZTogTDEwTl9QUkVGSVgsIHVzZVZhbHVlOiAna2VuZG8uc2xpZGVyJyB9LFxuICAgICAgICAgICAgICAgICAgICB7IG11bHRpOiB0cnVlLCBwcm92aWRlOiBOR19WQUxVRV9BQ0NFU1NPUiwgdXNlRXhpc3Rpbmc6IGZvcndhcmRSZWYoKCkgPT4gU2xpZGVyQ29tcG9uZW50KSB9LFxuICAgICAgICAgICAgICAgICAgICB7IHByb3ZpZGU6IEtlbmRvSW5wdXQsIHVzZUV4aXN0aW5nOiBmb3J3YXJkUmVmKCgpID0+IFNsaWRlckNvbXBvbmVudCkgfVxuICAgICAgICAgICAgICAgIF0sXG4gICAgICAgICAgICAgICAgc2VsZWN0b3I6ICdrZW5kby1zbGlkZXInLFxuICAgICAgICAgICAgICAgIHRlbXBsYXRlOiBgXG4gICAgICAgIDxuZy1jb250YWluZXIga2VuZG9TbGlkZXJMb2NhbGl6ZWRNZXNzYWdlc1xuICAgICAgICAgICAgaTE4bi1pbmNyZW1lbnQ9XCJrZW5kby5zbGlkZXIuaW5jcmVtZW50fFRoZSB0aXRsZSBvZiB0aGUgKipJbmNyZWFzZSoqIGJ1dHRvbiBvZiB0aGUgU2xpZGVyLlwiXG4gICAgICAgICAgICBpbmNyZW1lbnQ9XCJpbmNyZW1lbnRcIlxuICAgICAgICAgICAgaTE4bi1kZWNyZW1lbnQ9XCJrZW5kby5zbGlkZXIuZGVjcmVtZW50fFRoZSB0aXRsZSBvZiB0aGUgKipEZWNyZWFzZSoqIGJ1dHRvbiBvZiB0aGUgU2xpZGVyLlwiXG4gICAgICAgICAgICBkZWNyZW1lbnQ9XCJkZWNyZW1lbnRcIlxuICAgICAgICAgICAgaTE4bi1kcmFnSGFuZGxlPVwia2VuZG8uc2xpZGVyLmRyYWdIYW5kbGV8VGhlIHRpdGxlIG9mIHRoZSBkcmFnIGhhbmRsZSBvZiB0aGUgU2xpZGVyLlwiXG4gICAgICAgICAgICBkcmFnSGFuZGxlPVwiRHJhZ1wiXG4gICAgICAgID5cbiAgICAgICAgPGRpdiBjbGFzcz1cImstc2xpZGVyLXdyYXBcIiAjd3JhcFxuICAgICAgICAgICAgW2lkXT1cImZvY3VzYWJsZUlkXCJcbiAgICAgICAgICAgIFtjbGFzcy5rLXNsaWRlci1idXR0b25zXT1cInNob3dCdXR0b25zXCJcbiAgICAgICAgICAgIFtjbGFzcy5rLXNsaWRlci10b3BsZWZ0XT1cInRpY2tQbGFjZW1lbnQgPT09ICdiZWZvcmUnXCJcbiAgICAgICAgICAgIFtjbGFzcy5rLXNsaWRlci1ib3R0b21yaWdodF09XCJ0aWNrUGxhY2VtZW50ID09PSAnYWZ0ZXInXCJcbiAgICAgICAgICAgIFthdHRyLnRhYmluZGV4XT1cImRpc2FibGVkID8gdW5kZWZpbmVkIDogdGFiSW5kZXhcIlxuICAgICAgICAgICAgW2tlbmRvRXZlbnRzT3V0c2lkZUFuZ3VsYXJdPVwieyBmb2N1czogaGFuZGxlRm9jdXMsIGJsdXI6IGhhbmRsZUJsdXIsIGNsaWNrOiBvbldyYXBDbGljaywga2V5ZG93bjogb25LZXlEb3duIH1cIlxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgPGFcbiAgICAgICAgICAgICAgICAjZGVjcmVhc2VCdXR0b25cbiAgICAgICAgICAgICAgICAqbmdJZj1cInNob3dCdXR0b25zXCJcbiAgICAgICAgICAgICAgICBjbGFzcz1cImstYnV0dG9uIGstYnV0dG9uLWRlY3JlYXNlXCJcbiAgICAgICAgICAgICAgICBbdGl0bGVdPVwiZGVjcmVtZW50TWVzc2FnZVwiXG4gICAgICAgICAgICAgICAgW2F0dHIuYXJpYS1sYWJlbF09XCJkZWNyZW1lbnRNZXNzYWdlXCJcbiAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICA8c3BhbiBjbGFzcz1cImstaWNvblwiXG4gICAgICAgICAgICAgICAgICAgIFtjbGFzcy5rLWktYXJyb3ctd109XCIhdmVydGljYWxcIlxuICAgICAgICAgICAgICAgICAgICBbY2xhc3Muay1pLWFycm93LXNdPVwidmVydGljYWxcIlxuICAgICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICA8L3NwYW4+XG4gICAgICAgICAgICA8L2E+XG4gICAgICAgICAgICA8YVxuICAgICAgICAgICAgICAgICpuZ0lmPVwic2hvd0J1dHRvbnNcIlxuICAgICAgICAgICAgICAgICNpbmNyZWFzZUJ1dHRvblxuICAgICAgICAgICAgICAgIGNsYXNzPVwiay1idXR0b24gay1idXR0b24taW5jcmVhc2VcIlxuICAgICAgICAgICAgICAgIFt0aXRsZV09XCJpbmNyZW1lbnRNZXNzYWdlXCJcbiAgICAgICAgICAgICAgICBbYXR0ci5hcmlhLWxhYmVsXT1cImluY3JlbWVudE1lc3NhZ2VcIlxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwiay1pY29uXCJcbiAgICAgICAgICAgICAgICAgICAgW2NsYXNzLmstaS1hcnJvdy1lXT1cIiF2ZXJ0aWNhbFwiXG4gICAgICAgICAgICAgICAgICAgIFtjbGFzcy5rLWktYXJyb3ctbl09XCJ2ZXJ0aWNhbFwiXG4gICAgICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgIDwvc3Bhbj5cbiAgICAgICAgICAgIDwvYT5cbiAgICAgICAgICAgIDx1bCBrZW5kb1NsaWRlclRpY2tzXG4gICAgICAgICAgICAgICAgI3RpY2tzXG4gICAgICAgICAgICAgICAgKm5nSWY9XCJ0aWNrUGxhY2VtZW50ICE9PSAnbm9uZSdcIlxuICAgICAgICAgICAgICAgIFt0aWNrVGl0bGVdPVwidGl0bGVcIlxuICAgICAgICAgICAgICAgIFt2ZXJ0aWNhbF09XCJ2ZXJ0aWNhbFwiXG4gICAgICAgICAgICAgICAgW3N0ZXBdPVwic21hbGxTdGVwXCJcbiAgICAgICAgICAgICAgICBbbGFyZ2VTdGVwXT1cImxhcmdlU3RlcFwiXG4gICAgICAgICAgICAgICAgW21pbl09XCJtaW5cIlxuICAgICAgICAgICAgICAgIFttYXhdPVwibWF4XCJcbiAgICAgICAgICAgICAgICBbbGFiZWxUZW1wbGF0ZV09XCJsYWJlbFRlbXBsYXRlPy50ZW1wbGF0ZVJlZlwiXG4gICAgICAgICAgICA+XG4gICAgICAgICAgICA8L3VsPlxuICAgICAgICA8ZGl2ICN0cmFjayBjbGFzcz1cImstc2xpZGVyLXRyYWNrXCI+XG4gICAgICAgICAgICA8ZGl2ICNzbGlkZXJTZWxlY3Rpb24gY2xhc3M9XCJrLXNsaWRlci1zZWxlY3Rpb25cIj5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgIDxhICNkcmFnaGFuZGxlXG4gICAgICAgICAgICAgICAgICAgIHJvbGU9XCJzbGlkZXJcIlxuICAgICAgICAgICAgICAgICAgICBbYXR0ci5hcmlhLXZhbHVlbWluXT1cIm1pblwiXG4gICAgICAgICAgICAgICAgICAgIFthdHRyLmFyaWEtdmFsdWVtYXhdPVwibWF4XCJcbiAgICAgICAgICAgICAgICAgICAgW2F0dHIuYXJpYS12YWx1ZW5vd109XCJ2YWx1ZVwiXG4gICAgICAgICAgICAgICAgICAgIFthdHRyLmFyaWEtZGlzYWJsZWRdPVwiZGlzYWJsZWQgPyB0cnVlIDogdW5kZWZpbmVkXCJcbiAgICAgICAgICAgICAgICAgICAgW2F0dHIuYXJpYS1yZWFkb25seV09XCJyZWFkb25seSA/IHRydWUgOiB1bmRlZmluZWRcIlxuICAgICAgICAgICAgICAgICAgICBbYXR0ci5hcmlhLW9yaWVudGF0aW9uXT1cInZlcnRpY2FsID8gJ3ZlcnRpY2FsJyA6ICdob3Jpem9udGFsJ1wiXG4gICAgICAgICAgICAgICAgICAgIFtzdHlsZS50b3VjaC1hY3Rpb25dPVwiaXNEaXNhYmxlZCA/ICcnIDogJ25vbmUnXCJcbiAgICAgICAgICAgICAgICAgICAgY2xhc3M9XCJrLWRyYWdoYW5kbGVcIlxuICAgICAgICAgICAgICAgICAgICBbdGl0bGVdPVwiZHJhZ0hhbmRsZU1lc3NhZ2VcIlxuICAgICAgICAgICAgICAgICAgICBrZW5kb0RyYWdnYWJsZVxuICAgICAgICAgICAgICAgICAgICAoa2VuZG9QcmVzcyk9XCJpZkVuYWJsZWQoaGFuZGxlRHJhZ1ByZXNzLCAkZXZlbnQpXCJcbiAgICAgICAgICAgICAgICAgICAgKGtlbmRvRHJhZyk9XCJpZkVuYWJsZWQob25IYW5kbGVEcmFnLCAkZXZlbnQpXCJcbiAgICAgICAgICAgICAgICAgICAgKGtlbmRvUmVsZWFzZSk9XCJpZkVuYWJsZWQob25IYW5kbGVSZWxlYXNlLCAkZXZlbnQpXCJcbiAgICAgICAgICAgICAgICA+PC9hPlxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICA8a2VuZG8tcmVzaXplLXNlbnNvciAocmVzaXplKT1cInNpemVDb21wb25lbnQoZmFsc2UpXCI+PC9rZW5kby1yZXNpemUtc2Vuc29yPlxuICAgICAgICA8L2Rpdj5cbiAgYFxuICAgICAgICAgICAgfSxdIH0sXG5dO1xuLyoqIEBub2NvbGxhcHNlICovXG5TbGlkZXJDb21wb25lbnQuY3RvclBhcmFtZXRlcnMgPSAoKSA9PiBbXG4gICAgeyB0eXBlOiBMb2NhbGl6YXRpb25TZXJ2aWNlIH0sXG4gICAgeyB0eXBlOiBJbmplY3RvciB9LFxuICAgIHsgdHlwZTogUmVuZGVyZXIyIH0sXG4gICAgeyB0eXBlOiBOZ1pvbmUgfSxcbiAgICB7IHR5cGU6IENoYW5nZURldGVjdG9yUmVmIH0sXG4gICAgeyB0eXBlOiBFbGVtZW50UmVmIH1cbl07XG5TbGlkZXJDb21wb25lbnQucHJvcERlY29yYXRvcnMgPSB7XG4gICAgZm9jdXNhYmxlSWQ6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIGRyYWdIYW5kbGVUaXRsZTogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgaW5jcmVtZW50VGl0bGU6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIGFuaW1hdGU6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIGRlY3JlbWVudFRpdGxlOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBzaG93QnV0dG9uczogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgdmFsdWU6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHRhYkluZGV4OiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBkcmFnaGFuZGxlOiBbeyB0eXBlOiBWaWV3Q2hpbGQsIGFyZ3M6IFsnZHJhZ2hhbmRsZScsIHsgc3RhdGljOiB0cnVlIH0sXSB9XSxcbiAgICBkZWNyZWFzZUJ1dHRvbjogW3sgdHlwZTogVmlld0NoaWxkLCBhcmdzOiBbJ2RlY3JlYXNlQnV0dG9uJyxdIH1dLFxuICAgIGluY3JlYXNlQnV0dG9uOiBbeyB0eXBlOiBWaWV3Q2hpbGQsIGFyZ3M6IFsnaW5jcmVhc2VCdXR0b24nLF0gfV1cbn07XG5cbi8qKlxuICogQGhpZGRlblxuICovXG5jbGFzcyBSYW5nZVNsaWRlck1vZGVsIGV4dGVuZHMgU2xpZGVyTW9kZWxCYXNlIHtcbiAgICBwb3NpdGlvbkhhbmRsZShkcmFnSGFuZGxlKSB7XG4gICAgICAgIGlmICghZHJhZ0hhbmRsZS5pZCkge1xuICAgICAgICAgICAgcmV0dXJuO1xuICAgICAgICB9XG4gICAgICAgIGNvbnN0IHsgbWF4LCBtaW4sIHJldmVyc2UsIHZlcnRpY2FsIH0gPSB0aGlzLnByb3BzO1xuICAgICAgICBjb25zdCBwb3NpdGlvbiA9IHZlcnRpY2FsID8gJ2JvdHRvbScgOiAnbGVmdCc7XG4gICAgICAgIGNvbnN0IHRyYWNrV2lkdGggPSB0aGlzLnRyYWNrV2lkdGgoKTtcbiAgICAgICAgY29uc3QgdmFsdWUgPSBpc1N0YXJ0SGFuZGxlKGRyYWdIYW5kbGUpID8gdHJpbVZhbHVlUmFuZ2UobWF4LCBtaW4sIHRoaXMucHJvcHMudmFsdWUpWzBdXG4gICAgICAgICAgICA6IHRyaW1WYWx1ZVJhbmdlKG1heCwgbWluLCB0aGlzLnByb3BzLnZhbHVlKVsxXTtcbiAgICAgICAgaWYgKGlzU3RhcnRIYW5kbGUoZHJhZ0hhbmRsZSkpIHtcbiAgICAgICAgICAgIHRoaXMuc3RhcnRIYW5kbGVQb3NpdGlvbiA9IGNhbGN1bGF0ZUhhbmRsZVBvc2l0aW9uKHtcbiAgICAgICAgICAgICAgICBtaW4sXG4gICAgICAgICAgICAgICAgbWF4LFxuICAgICAgICAgICAgICAgIHJldmVyc2UsXG4gICAgICAgICAgICAgICAgdmFsdWUsXG4gICAgICAgICAgICAgICAgdHJhY2tXaWR0aCxcbiAgICAgICAgICAgICAgICBoYW5kbGVXaWR0aDogZHJhZ0hhbmRsZS5vZmZzZXRXaWR0aFxuICAgICAgICAgICAgfSk7XG4gICAgICAgICAgICB0aGlzLnJlbmRlcmVyLnNldFN0eWxlKGRyYWdIYW5kbGUsIHBvc2l0aW9uLCBgJHt0aGlzLnN0YXJ0SGFuZGxlUG9zaXRpb259cHhgKTtcbiAgICAgICAgfVxuICAgICAgICBlbHNlIHtcbiAgICAgICAgICAgIHRoaXMuZW5kSGFuZGxlUG9zaXRpb24gPSBjYWxjdWxhdGVIYW5kbGVQb3NpdGlvbih7XG4gICAgICAgICAgICAgICAgbWluLFxuICAgICAgICAgICAgICAgIG1heCxcbiAgICAgICAgICAgICAgICByZXZlcnNlLFxuICAgICAgICAgICAgICAgIHZhbHVlLFxuICAgICAgICAgICAgICAgIHRyYWNrV2lkdGgsXG4gICAgICAgICAgICAgICAgaGFuZGxlV2lkdGg6IGRyYWdIYW5kbGUub2Zmc2V0V2lkdGhcbiAgICAgICAgICAgIH0pO1xuICAgICAgICAgICAgdGhpcy5yZW5kZXJlci5zZXRTdHlsZShkcmFnSGFuZGxlLCBwb3NpdGlvbiwgYCR7dGhpcy5lbmRIYW5kbGVQb3NpdGlvbn1weGApO1xuICAgICAgICB9XG4gICAgfVxuICAgIHBvc2l0aW9uU2VsZWN0aW9uKGRyYWdIYW5kbGUsIHNlbGVjdGlvbikge1xuICAgICAgICBjb25zdCB7IHJldmVyc2UsIHZlcnRpY2FsIH0gPSB0aGlzLnByb3BzO1xuICAgICAgICBjb25zdCBkaW1lbnNpb24gPSB2ZXJ0aWNhbCA/ICdoZWlnaHQnIDogJ3dpZHRoJztcbiAgICAgICAgY29uc3QgcG9zaXRpb24gPSB2ZXJ0aWNhbCA/ICdib3R0b20nIDogcmV2ZXJzZSA/ICdyaWdodCcgOiAnbGVmdCc7XG4gICAgICAgIGNvbnN0IGhhbmRsZVdpZHRoID0gTWF0aC5mbG9vcihkcmFnSGFuZGxlLm9mZnNldFdpZHRoIC8gMik7XG4gICAgICAgIGNvbnN0IHNpemUgPSBNYXRoLmFicyh0aGlzLmVuZEhhbmRsZVBvc2l0aW9uIC0gdGhpcy5zdGFydEhhbmRsZVBvc2l0aW9uKTtcbiAgICAgICAgY29uc3QgY3VycmVudFNlbGVjdGlvblBvc2l0aW9uID0gdmVydGljYWwgPyBkcmFnSGFuZGxlLnN0eWxlLmJvdHRvbSA6IGRyYWdIYW5kbGUuc3R5bGUubGVmdDtcbiAgICAgICAgdGhpcy5yZW5kZXJlci5zZXRTdHlsZShzZWxlY3Rpb24sIGRpbWVuc2lvbiwgYCR7c2l6ZX1weGApO1xuICAgICAgICB0aGlzLnJlbmRlcmVyLnNldFN0eWxlKHNlbGVjdGlvbiwgcG9zaXRpb24sIHJldmVyc2UgPyB0aGlzLnRyYWNrV2lkdGgoKSAtIHBhcnNlRmxvYXQoY3VycmVudFNlbGVjdGlvblBvc2l0aW9uKSAtIGhhbmRsZVdpZHRoICsgJ3B4J1xuICAgICAgICAgICAgOiBwYXJzZUZsb2F0KGN1cnJlbnRTZWxlY3Rpb25Qb3NpdGlvbikgKyBoYW5kbGVXaWR0aCArICdweCcpO1xuICAgIH1cbn1cblxuY29uc3QgUFJFU1NFRCQxID0gJ2stcHJlc3NlZCc7XG4vKipcbiAqIFJlcHJlc2VudHMgdGhlIFtLZW5kbyBVSSBSYW5nZVNsaWRlciBjb21wb25lbnQgZm9yIEFuZ3VsYXJdKHslIHNsdWcgb3ZlcnZpZXdfcmFuZ2VzbGlkZXIgJX0pLlxuICovXG5jbGFzcyBSYW5nZVNsaWRlckNvbXBvbmVudCBleHRlbmRzIFNsaWRlckJhc2Uge1xuICAgIGNvbnN0cnVjdG9yKGxvY2FsaXphdGlvbiwgaW5qZWN0b3IsIHJlbmRlcmVyLCBuZ1pvbmUsIGNoYW5nZURldGVjdG9yLCBob3N0RWxlbWVudCkge1xuICAgICAgICBzdXBlcihsb2NhbGl6YXRpb24sIGluamVjdG9yLCByZW5kZXJlciwgbmdab25lLCBjaGFuZ2VEZXRlY3RvciwgaG9zdEVsZW1lbnQpO1xuICAgICAgICB0aGlzLmxvY2FsaXphdGlvbiA9IGxvY2FsaXphdGlvbjtcbiAgICAgICAgdGhpcy5pbmplY3RvciA9IGluamVjdG9yO1xuICAgICAgICB0aGlzLnJlbmRlcmVyID0gcmVuZGVyZXI7XG4gICAgICAgIHRoaXMubmdab25lID0gbmdab25lO1xuICAgICAgICB0aGlzLmNoYW5nZURldGVjdG9yID0gY2hhbmdlRGV0ZWN0b3I7XG4gICAgICAgIHRoaXMuaG9zdEVsZW1lbnQgPSBob3N0RWxlbWVudDtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuc3RhcnRIYW5kbGVJZCA9IGBrLXN0YXJ0LWhhbmRsZS0ke2d1aWQoKX1gO1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5lbmRIYW5kbGVJZCA9IGBrLWVuZC1oYW5kbGUtJHtndWlkKCl9YDtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuZm9jdXNhYmxlSWQgPSB0aGlzLnN0YXJ0SGFuZGxlSWQ7XG4gICAgICAgIHRoaXMuaGFuZGxlWkluZGV4ID0gMDtcbiAgICAgICAgdGhpcy5hY3RpdmVIYW5kbGUgPSAnc3RhcnRIYW5kbGUnO1xuICAgICAgICB0aGlzLmZvY3VzQ2hhbmdlZFByb2dyYW1tYXRpY2FsbHkgPSBmYWxzZTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMub25XcmFwQ2xpY2sgPSAoYXJncykgPT4ge1xuICAgICAgICAgICAgaWYgKCF0aGlzLmlzRGlzYWJsZWQpIHtcbiAgICAgICAgICAgICAgICB0aGlzLnZhbHVlID0gdGhpcy52YWx1ZSB8fCBbdGhpcy5taW4sIHRoaXMubWluXTtcbiAgICAgICAgICAgICAgICBjb25zdCB0cmFja1ZhbHVlID0gZXZlbnRWYWx1ZShhcmdzLCB0aGlzLnRyYWNrLm5hdGl2ZUVsZW1lbnQsIHRoaXMuZ2V0UHJvcHMoKSk7XG4gICAgICAgICAgICAgICAgbGV0IG5ld1JhbmdlVmFsdWU7XG4gICAgICAgICAgICAgICAgY29uc3QgW3N0YXJ0VmFsdWUsIGVuZFZhbHVlXSA9IG5ld1JhbmdlVmFsdWUgPSB0aGlzLnZhbHVlO1xuICAgICAgICAgICAgICAgIGlmICh0cmFja1ZhbHVlIDw9IHN0YXJ0VmFsdWUpIHtcbiAgICAgICAgICAgICAgICAgICAgbmV3UmFuZ2VWYWx1ZSA9IFt0cmFja1ZhbHVlLCBlbmRWYWx1ZV07XG4gICAgICAgICAgICAgICAgICAgIHRoaXMuYWN0aXZlSGFuZGxlID0gJ3N0YXJ0SGFuZGxlJztcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgZWxzZSBpZiAoc3RhcnRWYWx1ZSA8IHRyYWNrVmFsdWUgJiYgdHJhY2tWYWx1ZSA8IGVuZFZhbHVlKSB7XG4gICAgICAgICAgICAgICAgICAgIGlmICh0cmFja1ZhbHVlIDwgKHN0YXJ0VmFsdWUgKyBlbmRWYWx1ZSkgLyAyKSB7XG4gICAgICAgICAgICAgICAgICAgICAgICBuZXdSYW5nZVZhbHVlID0gW3RyYWNrVmFsdWUsIGVuZFZhbHVlXTtcbiAgICAgICAgICAgICAgICAgICAgICAgIHRoaXMuYWN0aXZlSGFuZGxlID0gJ3N0YXJ0SGFuZGxlJztcbiAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgICAgICBlbHNlIHtcbiAgICAgICAgICAgICAgICAgICAgICAgIG5ld1JhbmdlVmFsdWUgPSBbc3RhcnRWYWx1ZSwgdHJhY2tWYWx1ZV07XG4gICAgICAgICAgICAgICAgICAgICAgICB0aGlzLmFjdGl2ZUhhbmRsZSA9ICdlbmRIYW5kbGUnO1xuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIGVsc2UgaWYgKHRyYWNrVmFsdWUgPj0gZW5kVmFsdWUpIHtcbiAgICAgICAgICAgICAgICAgICAgbmV3UmFuZ2VWYWx1ZSA9IFtzdGFydFZhbHVlLCB0cmFja1ZhbHVlXTtcbiAgICAgICAgICAgICAgICAgICAgdGhpcy5hY3RpdmVIYW5kbGUgPSAnZW5kSGFuZGxlJztcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgY29uc3QgYWN0aXZlSGFuZGxlID0gdGhpcy5hY3RpdmVIYW5kbGUgPT09ICdzdGFydEhhbmRsZScgPyB0aGlzLmRyYWdoYW5kbGVTdGFydCA6IHRoaXMuZHJhZ2hhbmRsZUVuZDtcbiAgICAgICAgICAgICAgICBpbnZva2VFbGVtZW50TWV0aG9kKGFjdGl2ZUhhbmRsZSwgJ2ZvY3VzJyk7XG4gICAgICAgICAgICAgICAgdGhpcy5jaGFuZ2VWYWx1ZShuZXdSYW5nZVZhbHVlKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgfTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMub25LZXlEb3duID0gKGUpID0+IHtcbiAgICAgICAgICAgIHRoaXMudmFsdWUgPSB0aGlzLnZhbHVlIHx8IFt0aGlzLm1pbiwgdGhpcy5taW5dO1xuICAgICAgICAgICAgY29uc3Qgb3B0aW9ucyA9IHRoaXMuZ2V0UHJvcHMoKTtcbiAgICAgICAgICAgIGNvbnN0IHsgbWF4LCBtaW4gfSA9IG9wdGlvbnM7XG4gICAgICAgICAgICBjb25zdCBoYW5kbGVyID0gdGhpcy5rZXlCaW5kaW5nW2Uua2V5Q29kZV07XG4gICAgICAgICAgICBpZiAodGhpcy5pc0Rpc2FibGVkIHx8ICFoYW5kbGVyKSB7XG4gICAgICAgICAgICAgICAgcmV0dXJuO1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgdGhpcy5yZW5kZXJlci5zZXRTdHlsZShlLnRhcmdldCwgJ3pJbmRleCcsICsrdGhpcy5oYW5kbGVaSW5kZXgpO1xuICAgICAgICAgICAgY29uc3Qgc3RhcnRIYW5kbGVJc0FjdGl2ZSA9IGlzU3RhcnRIYW5kbGUoZS50YXJnZXQpO1xuICAgICAgICAgICAgY29uc3QgdmFsdWUgPSBoYW5kbGVyKE9iamVjdC5hc3NpZ24oe30sIG9wdGlvbnMsIHsgdmFsdWU6IHN0YXJ0SGFuZGxlSXNBY3RpdmUgPyB0aGlzLnZhbHVlWzBdIDogdGhpcy52YWx1ZVsxXSB9KSk7XG4gICAgICAgICAgICBpZiAoc3RhcnRIYW5kbGVJc0FjdGl2ZSkge1xuICAgICAgICAgICAgICAgIGlmICh2YWx1ZSA+IHRoaXMudmFsdWVbMV0pIHtcbiAgICAgICAgICAgICAgICAgICAgdGhpcy52YWx1ZVsxXSA9IHZhbHVlO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGVsc2Uge1xuICAgICAgICAgICAgICAgIGlmICh2YWx1ZSA8IHRoaXMudmFsdWVbMF0pIHtcbiAgICAgICAgICAgICAgICAgICAgdGhpcy52YWx1ZVswXSA9IHZhbHVlO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGNvbnN0IHRyaW1tZWRWYWx1ZSA9IHRyaW1WYWx1ZShtYXgsIG1pbiwgdmFsdWUpO1xuICAgICAgICAgICAgY29uc3QgbmV3VmFsdWUgPSBzdGFydEhhbmRsZUlzQWN0aXZlID8gW3RyaW1tZWRWYWx1ZSwgdGhpcy52YWx1ZVsxXV1cbiAgICAgICAgICAgICAgICA6IFt0aGlzLnZhbHVlWzBdLCB0cmltbWVkVmFsdWVdO1xuICAgICAgICAgICAgdGhpcy5jaGFuZ2VWYWx1ZShuZXdWYWx1ZSk7XG4gICAgICAgICAgICBlLnByZXZlbnREZWZhdWx0KCk7XG4gICAgICAgIH07XG4gICAgICAgIHRoaXMubmdDaGFuZ2UgPSAoXykgPT4geyB9O1xuICAgICAgICB0aGlzLm5nVG91Y2hlZCA9ICgpID0+IHsgfTtcbiAgICAgICAgdGhpcy5oYW5kbGVCbHVyID0gKCkgPT4ge1xuICAgICAgICAgICAgdGhpcy5jaGFuZ2VEZXRlY3Rvci5tYXJrRm9yQ2hlY2soKTtcbiAgICAgICAgICAgIHRoaXMuZm9jdXNlZCA9IGZhbHNlO1xuICAgICAgICAgICAgaWYgKGhhc09ic2VydmVycyh0aGlzLm9uQmx1cikgfHwgcmVxdWlyZXNab25lT25CbHVyKHRoaXMuY29udHJvbCkpIHtcbiAgICAgICAgICAgICAgICB0aGlzLm5nWm9uZS5ydW4oKCkgPT4ge1xuICAgICAgICAgICAgICAgICAgICB0aGlzLm5nVG91Y2hlZCgpO1xuICAgICAgICAgICAgICAgICAgICBpZiAoIXRoaXMuZm9jdXNDaGFuZ2VkUHJvZ3JhbW1hdGljYWxseSkge1xuICAgICAgICAgICAgICAgICAgICAgICAgdGhpcy5vbkJsdXIuZW1pdCgpO1xuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgfSk7XG4gICAgICAgICAgICB9XG4gICAgICAgIH07XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEZvY3VzZXMgdGhlIFJhbmdlU2xpZGVyLlxuICAgICAqXG4gICAgICogQGV4YW1wbGVcbiAgICAgKiBgYGB0cy1uby1ydW5cbiAgICAgKiBfQENvbXBvbmVudCh7XG4gICAgICogc2VsZWN0b3I6ICdteS1hcHAnLFxuICAgICAqIHRlbXBsYXRlOiBgXG4gICAgICogICAgIDxkaXY+XG4gICAgICogICAgICAgICA8YnV0dG9uIGNsYXNzPVwiay1idXR0b25cIiAoY2xpY2spPVwic2xpZGVyLmZvY3VzKClcIj5Gb2N1czwvYnV0dG9uPlxuICAgICAqICAgICA8L2Rpdj5cbiAgICAgKiAgICAgPGtlbmRvLXJhbmdlc2xpZGVyICNzbGlkZXI+PC9rZW5kby1yYW5nZXNsaWRlcj5cbiAgICAgKiBgXG4gICAgICogfSlcbiAgICAgKiBjbGFzcyBBcHBDb21wb25lbnQgeyB9XG4gICAgICogYGBgXG4gICAgICovXG4gICAgZm9jdXMoKSB7XG4gICAgICAgIHRoaXMuZm9jdXNDaGFuZ2VkUHJvZ3JhbW1hdGljYWxseSA9IHRydWU7XG4gICAgICAgIGludm9rZUVsZW1lbnRNZXRob2QodGhpcy5kcmFnaGFuZGxlU3RhcnQsICdmb2N1cycpO1xuICAgICAgICB0aGlzLmZvY3VzQ2hhbmdlZFByb2dyYW1tYXRpY2FsbHkgPSBmYWxzZTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQmx1cnMgdGhlIFJhbmdlU2xpZGVyLlxuICAgICAqL1xuICAgIGJsdXIoKSB7XG4gICAgICAgIHRoaXMuZm9jdXNDaGFuZ2VkUHJvZ3JhbW1hdGljYWxseSA9IHRydWU7XG4gICAgICAgIGNvbnN0IGFjdGl2ZUhhbmRsZSA9IHRoaXMuYWN0aXZlSGFuZGxlID09PSAnc3RhcnRIYW5kbGUnID8gdGhpcy5kcmFnaGFuZGxlU3RhcnQgOiB0aGlzLmRyYWdoYW5kbGVFbmQ7XG4gICAgICAgIGludm9rZUVsZW1lbnRNZXRob2QoYWN0aXZlSGFuZGxlLCAnYmx1cicpO1xuICAgICAgICB0aGlzLmhhbmRsZUJsdXIoKTtcbiAgICAgICAgdGhpcy5mb2N1c0NoYW5nZWRQcm9ncmFtbWF0aWNhbGx5ID0gZmFsc2U7XG4gICAgfVxuICAgIG5nT25Jbml0KCkge1xuICAgICAgICBpZiAoIXRoaXMudmFsdWUpIHtcbiAgICAgICAgICAgIHRoaXMudmFsdWUgPSBbdGhpcy5taW4sIHRoaXMubWF4XTtcbiAgICAgICAgfVxuICAgICAgICBzdXBlci5uZ09uSW5pdCgpO1xuICAgIH1cbiAgICBuZ09uQ2hhbmdlcyhjaGFuZ2VzKSB7XG4gICAgICAgIGlmIChhbnlDaGFuZ2VkKFsndmFsdWUnLCAnZml4ZWRUaWNrV2lkdGgnLCAndGlja1BsYWNlbWVudCddLCBjaGFuZ2VzLCB0cnVlKSkge1xuICAgICAgICAgICAgaWYgKGNoYW5nZXMudmFsdWUgJiYgY2hhbmdlcy52YWx1ZS5jdXJyZW50VmFsdWUpIHtcbiAgICAgICAgICAgICAgICB2YWxpZGF0ZVZhbHVlKGNoYW5nZXMudmFsdWUuY3VycmVudFZhbHVlKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIHRoaXMubmdab25lLm9uU3RhYmxlLmFzT2JzZXJ2YWJsZSgpLnBpcGUodGFrZSgxKSkuc3Vic2NyaWJlKCgpID0+IHtcbiAgICAgICAgICAgICAgICB0aGlzLnNpemVDb21wb25lbnQoKTtcbiAgICAgICAgICAgIH0pO1xuICAgICAgICB9XG4gICAgfVxuICAgIG5nQWZ0ZXJWaWV3SW5pdCgpIHtcbiAgICAgICAgaWYgKCFpc0RvY3VtZW50QXZhaWxhYmxlKCkpIHtcbiAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgfVxuICAgICAgICB0aGlzLnNpemVDb21wb25lbnQoKTtcbiAgICAgICAgaWYgKHRoaXMudGlja3MpIHtcbiAgICAgICAgICAgIHRoaXMudGlja3MudGlja0VsZW1lbnRzXG4gICAgICAgICAgICAgICAgLmNoYW5nZXNcbiAgICAgICAgICAgICAgICAuc3Vic2NyaWJlKCgpID0+IHRoaXMuc2l6ZUNvbXBvbmVudCgpKTtcbiAgICAgICAgfVxuICAgICAgICB0aGlzLmF0dGFjaEVsZW1lbnRFdmVudEhhbmRsZXJzKCk7XG4gICAgfVxuICAgIG5nT25EZXN0cm95KCkge1xuICAgICAgICB0aGlzLnN1YnNjcmlwdGlvbnMudW5zdWJzY3JpYmUoKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHRleHRGb3Ioa2V5KSB7XG4gICAgICAgIHJldHVybiB0aGlzLmxvY2FsaXphdGlvbi5nZXQoa2V5KTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIGdldCB2YWx1ZVRleHQoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLnZhbHVlID8gYCR7dGhpcy52YWx1ZVswXX0gLSAke3RoaXMudmFsdWVbMV19YCA6ICcnO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgaGFuZGxlRHJhZ1ByZXNzKGFyZ3MpIHtcbiAgICAgICAgaWYgKGFyZ3Mub3JpZ2luYWxFdmVudCkge1xuICAgICAgICAgICAgYXJncy5vcmlnaW5hbEV2ZW50LnByZXZlbnREZWZhdWx0KCk7XG4gICAgICAgIH1cbiAgICAgICAgY29uc3QgdGFyZ2V0ID0gYXJncy5vcmlnaW5hbEV2ZW50LnRhcmdldDtcbiAgICAgICAgdGhpcy5kcmFnZ2VkSGFuZGxlID0gdGFyZ2V0O1xuICAgICAgICB0aGlzLnJlbmRlcmVyLnNldFN0eWxlKHRhcmdldCwgJ3pJbmRleCcsICsrdGhpcy5oYW5kbGVaSW5kZXgpO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgb25IYW5kbGVEcmFnKGFyZ3MpIHtcbiAgICAgICAgdGhpcy52YWx1ZSA9IHRoaXMudmFsdWUgfHwgW3RoaXMubWluLCB0aGlzLm1pbl07XG4gICAgICAgIGNvbnN0IHRhcmdldCA9IGFyZ3Mub3JpZ2luYWxFdmVudC50YXJnZXQ7XG4gICAgICAgIGNvbnN0IGxhc3RDb29yZHMgPSB0aGlzLmRyYWdnZWRIYW5kbGUuZ2V0Qm91bmRpbmdDbGllbnRSZWN0KCk7XG4gICAgICAgIHRoaXMubGFzdEhhbmRsZVBvc2l0aW9uID0geyB4OiBsYXN0Q29vcmRzLmxlZnQsIHk6IGxhc3RDb29yZHMudG9wIH07XG4gICAgICAgIHRoaXMuZHJhZ2dpbmcgPSB7IHZhbHVlOiB0cnVlLCB0YXJnZXQgfTtcbiAgICAgICAgY29uc3QgbGVmdCA9IGFyZ3MucGFnZVggPCB0aGlzLmxhc3RIYW5kbGVQb3NpdGlvbi54O1xuICAgICAgICBjb25zdCByaWdodCA9IGFyZ3MucGFnZVggPiB0aGlzLmxhc3RIYW5kbGVQb3NpdGlvbi54O1xuICAgICAgICBjb25zdCB1cCA9IGFyZ3MucGFnZVkgPiB0aGlzLmxhc3RIYW5kbGVQb3NpdGlvbi55O1xuICAgICAgICBjb25zdCBtb3ZlU3RhcnRIYW5kbGUgPSAoKSA9PiB0aGlzLmNoYW5nZVZhbHVlKFtldmVudFZhbHVlKGFyZ3MsIHRoaXMudHJhY2submF0aXZlRWxlbWVudCwgdGhpcy5nZXRQcm9wcygpKSwgdGhpcy52YWx1ZVsxXV0pO1xuICAgICAgICBjb25zdCBtb3ZlRW5kSGFuZGxlID0gKCkgPT4gdGhpcy5jaGFuZ2VWYWx1ZShbdGhpcy52YWx1ZVswXSwgZXZlbnRWYWx1ZShhcmdzLCB0aGlzLnRyYWNrLm5hdGl2ZUVsZW1lbnQsIHRoaXMuZ2V0UHJvcHMoKSldKTtcbiAgICAgICAgY29uc3QgbW92ZUJvdGhIYW5kbGVzID0gKCkgPT4gdGhpcy5jaGFuZ2VWYWx1ZShbZXZlbnRWYWx1ZShhcmdzLCB0aGlzLnRyYWNrLm5hdGl2ZUVsZW1lbnQsIHRoaXMuZ2V0UHJvcHMoKSksIGV2ZW50VmFsdWUoYXJncywgdGhpcy50cmFjay5uYXRpdmVFbGVtZW50LCB0aGlzLmdldFByb3BzKCkpXSk7XG4gICAgICAgIGNvbnN0IGFjdGl2ZVN0YXJ0SGFuZGxlID0gaXNTdGFydEhhbmRsZSh0aGlzLmRyYWdnZWRIYW5kbGUpO1xuICAgICAgICBjb25zdCB2ZXJ0aWNhbCA9IHRoaXMudmVydGljYWw7XG4gICAgICAgIGNvbnN0IGhvcml6b250YWwgPSAhdmVydGljYWw7XG4gICAgICAgIGNvbnN0IGZvcndhcmQgPSAodmVydGljYWwgJiYgdXApIHx8ICh0aGlzLnJldmVyc2UgPyBob3Jpem9udGFsICYmIHJpZ2h0IDogaG9yaXpvbnRhbCAmJiBsZWZ0KTtcbiAgICAgICAgLy8gY29uc3QgZm9yd2FyZCA9ICh0aGlzLnJldmVyc2UgPyAoIXRoaXMudmVydGljYWwgJiYgIWxlZnQpIDogKCF0aGlzLnZlcnRpY2FsICYmIGxlZnQpKSB8fCAodGhpcy52ZXJ0aWNhbCAmJiB1cCk7XG4gICAgICAgIGlmICh0aGlzLnZhbHVlWzBdID09PSB0aGlzLnZhbHVlWzFdKSB7XG4gICAgICAgICAgICBpZiAoZm9yd2FyZCkge1xuICAgICAgICAgICAgICAgIGFjdGl2ZVN0YXJ0SGFuZGxlID8gbW92ZVN0YXJ0SGFuZGxlKCkgOiBtb3ZlQm90aEhhbmRsZXMoKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGVsc2Uge1xuICAgICAgICAgICAgICAgIGFjdGl2ZVN0YXJ0SGFuZGxlID8gbW92ZUJvdGhIYW5kbGVzKCkgOiBtb3ZlRW5kSGFuZGxlKCk7XG4gICAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgICAgZWxzZSB7XG4gICAgICAgICAgICBhY3RpdmVTdGFydEhhbmRsZSA/IG1vdmVTdGFydEhhbmRsZSgpIDogbW92ZUVuZEhhbmRsZSgpO1xuICAgICAgICB9XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBvbkhhbmRsZVJlbGVhc2UoYXJncykge1xuICAgICAgICB0aGlzLmRyYWdnaW5nID0geyB2YWx1ZTogZmFsc2UsIHRhcmdldDogYXJncy5vcmlnaW5hbEV2ZW50LnRhcmdldCB9OyAvL25lZWRlZCBmb3IgYW5pbWF0aW9uXG4gICAgICAgIHRoaXMuZHJhZ2dlZEhhbmRsZSA9IHVuZGVmaW5lZDtcbiAgICB9XG4gICAgLy9uZ01vZGVsIGJpbmRpbmdcbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgd3JpdGVWYWx1ZSh2YWx1ZSkge1xuICAgICAgICB2YWxpZGF0ZVZhbHVlKHZhbHVlKTtcbiAgICAgICAgdGhpcy52YWx1ZSA9IHZhbHVlO1xuICAgICAgICB0aGlzLnNpemVDb21wb25lbnQoKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHJlZ2lzdGVyT25DaGFuZ2UoZm4pIHtcbiAgICAgICAgdGhpcy5uZ0NoYW5nZSA9IGZuO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgcmVnaXN0ZXJPblRvdWNoZWQoZm4pIHtcbiAgICAgICAgdGhpcy5uZ1RvdWNoZWQgPSBmbjtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIGNoYW5nZVZhbHVlKHZhbHVlKSB7XG4gICAgICAgIGlmICghdGhpcy52YWx1ZSB8fCAhaXNTYW1lUmFuZ2UodGhpcy52YWx1ZSwgdmFsdWUpKSB7XG4gICAgICAgICAgICB0aGlzLm5nWm9uZS5ydW4oKCkgPT4ge1xuICAgICAgICAgICAgICAgIHRoaXMudmFsdWUgPSB2YWx1ZTtcbiAgICAgICAgICAgICAgICB0aGlzLm5nQ2hhbmdlKHZhbHVlKTtcbiAgICAgICAgICAgICAgICBpZiAodGhpcy52YWx1ZSkge1xuICAgICAgICAgICAgICAgICAgICB0aGlzLnZhbHVlQ2hhbmdlLmVtaXQodmFsdWUpO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICB0aGlzLnNpemVDb21wb25lbnQoKTtcbiAgICAgICAgICAgIH0pO1xuICAgICAgICB9XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBzaXplQ29tcG9uZW50KCkge1xuICAgICAgICBpZiAoIWlzRG9jdW1lbnRBdmFpbGFibGUoKSkge1xuICAgICAgICAgICAgcmV0dXJuO1xuICAgICAgICB9XG4gICAgICAgIGNvbnN0IHdyYXBwZXIgPSB0aGlzLndyYXBwZXIubmF0aXZlRWxlbWVudDtcbiAgICAgICAgY29uc3QgdHJhY2sgPSB0aGlzLnRyYWNrLm5hdGl2ZUVsZW1lbnQ7XG4gICAgICAgIGNvbnN0IHNlbGVjdGlvbkVsID0gdGhpcy5zbGlkZXJTZWxlY3Rpb24ubmF0aXZlRWxlbWVudDtcbiAgICAgICAgY29uc3QgZHJhZ0hhbmRsZVN0YXJ0RWwgPSB0aGlzLmRyYWdoYW5kbGVTdGFydC5uYXRpdmVFbGVtZW50O1xuICAgICAgICBjb25zdCBkcmFnSGFuZGxlRW5kRWwgPSB0aGlzLmRyYWdoYW5kbGVFbmQubmF0aXZlRWxlbWVudDtcbiAgICAgICAgY29uc3QgdGlja3MgPSB0aGlzLnRpY2tzID8gdGhpcy50aWNrc0NvbnRhaW5lci5uYXRpdmVFbGVtZW50IDogbnVsbDtcbiAgICAgICAgdGhpcy5yZXNldFN0eWxlcyhbdHJhY2ssIHNlbGVjdGlvbkVsLCBkcmFnSGFuZGxlU3RhcnRFbCwgZHJhZ0hhbmRsZUVuZEVsLCB0aWNrcywgdGhpcy5ob3N0RWxlbWVudC5uYXRpdmVFbGVtZW50XSk7XG4gICAgICAgIGNvbnN0IHByb3BzID0gdGhpcy5nZXRQcm9wcygpO1xuICAgICAgICBjb25zdCBtb2RlbCA9IG5ldyBSYW5nZVNsaWRlck1vZGVsKHByb3BzLCB3cmFwcGVyLCB0cmFjaywgdGhpcy5yZW5kZXJlcik7XG4gICAgICAgIG1vZGVsLnJlc2l6ZVRyYWNrKCk7XG4gICAgICAgIGlmICh0aGlzLnRpY2tzKSB7IC8vZm9yIGNhc2Ugd2hlbiB0aWNrUGxhY2VtZW50OiBub25lXG4gICAgICAgICAgICBtb2RlbC5yZXNpemVUaWNrcyh0aGlzLnRpY2tzQ29udGFpbmVyLm5hdGl2ZUVsZW1lbnQsIHRoaXMudGlja3MudGlja0VsZW1lbnRzLm1hcChlbGVtZW50ID0+IGVsZW1lbnQubmF0aXZlRWxlbWVudCkpO1xuICAgICAgICB9XG4gICAgICAgIG1vZGVsLnBvc2l0aW9uSGFuZGxlKGRyYWdIYW5kbGVTdGFydEVsKTtcbiAgICAgICAgbW9kZWwucG9zaXRpb25IYW5kbGUoZHJhZ0hhbmRsZUVuZEVsKTtcbiAgICAgICAgbW9kZWwucG9zaXRpb25TZWxlY3Rpb24oZHJhZ0hhbmRsZVN0YXJ0RWwsIHNlbGVjdGlvbkVsKTtcbiAgICAgICAgaWYgKHRoaXMuZml4ZWRUaWNrV2lkdGgpIHtcbiAgICAgICAgICAgIG1vZGVsLnJlc2l6ZVdyYXBwZXIoKTtcbiAgICAgICAgfVxuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgZ2V0IGlzRGlzYWJsZWQoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmRpc2FibGVkIHx8IHRoaXMucmVhZG9ubHk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKiBVc2VkIGJ5IHRoZSBGbG9hdGluZ0xhYmVsIHRvIGRldGVybWluZSBpZiB0aGUgY29tcG9uZW50IGlzIGVtcHR5LlxuICAgICAqL1xuICAgIGlzRW1wdHkoKSB7XG4gICAgICAgIHJldHVybiBmYWxzZTtcbiAgICB9XG4gICAgc2V0IGZvY3VzZWQodmFsdWUpIHtcbiAgICAgICAgaWYgKHRoaXMuaXNGb2N1c2VkICE9PSB2YWx1ZSAmJiB0aGlzLmhvc3RFbGVtZW50KSB7XG4gICAgICAgICAgICB0aGlzLmlzRm9jdXNlZCA9IHZhbHVlO1xuICAgICAgICB9XG4gICAgfVxuICAgIHNldCBkcmFnZ2luZyhkYXRhKSB7XG4gICAgICAgIGlmICh0aGlzLmlzRHJhZ2dlZCAhPT0gZGF0YS52YWx1ZSAmJiB0aGlzLnNsaWRlclNlbGVjdGlvbiAmJiB0aGlzLmRyYWdoYW5kbGVTdGFydCAmJiB0aGlzLmRyYWdoYW5kbGVFbmQpIHtcbiAgICAgICAgICAgIGNvbnN0IHNsaWRlclNlbGVjdGlvbiA9IHRoaXMuc2xpZGVyU2VsZWN0aW9uLm5hdGl2ZUVsZW1lbnQ7XG4gICAgICAgICAgICBjb25zdCBkcmFnaGFuZGxlID0gZGF0YS50YXJnZXQ7XG4gICAgICAgICAgICBpZiAoZGF0YS52YWx1ZSkge1xuICAgICAgICAgICAgICAgIHRoaXMucmVuZGVyZXIuYWRkQ2xhc3Moc2xpZGVyU2VsZWN0aW9uLCBQUkVTU0VEJDEpO1xuICAgICAgICAgICAgICAgIHRoaXMucmVuZGVyZXIuYWRkQ2xhc3MoZHJhZ2hhbmRsZSwgUFJFU1NFRCQxKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGVsc2Uge1xuICAgICAgICAgICAgICAgIHRoaXMucmVuZGVyZXIucmVtb3ZlQ2xhc3Moc2xpZGVyU2VsZWN0aW9uLCBQUkVTU0VEJDEpO1xuICAgICAgICAgICAgICAgIHRoaXMucmVuZGVyZXIucmVtb3ZlQ2xhc3MoZHJhZ2hhbmRsZSwgUFJFU1NFRCQxKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIHRoaXMuaXNEcmFnZ2VkID0gZGF0YS52YWx1ZTtcbiAgICAgICAgfVxuICAgIH1cbiAgICBnZXRQcm9wcygpIHtcbiAgICAgICAgcmV0dXJuIHtcbiAgICAgICAgICAgIGRpc2FibGVkOiB0aGlzLmRpc2FibGVkLFxuICAgICAgICAgICAgZml4ZWRUaWNrV2lkdGg6IHRoaXMuZml4ZWRUaWNrV2lkdGgsXG4gICAgICAgICAgICBsYXJnZVN0ZXA6IHRoaXMubGFyZ2VTdGVwLFxuICAgICAgICAgICAgbWF4OiB0aGlzLm1heCxcbiAgICAgICAgICAgIG1pbjogdGhpcy5taW4sXG4gICAgICAgICAgICByZWFkb25seTogdGhpcy5yZWFkb25seSxcbiAgICAgICAgICAgIHJldmVyc2U6IHRoaXMucmV2ZXJzZSxcbiAgICAgICAgICAgIHJ0bDogdGhpcy5sb2NhbGl6YXRpb25TZXJ2aWNlLnJ0bCxcbiAgICAgICAgICAgIHNtYWxsU3RlcDogdGhpcy5zbWFsbFN0ZXAsXG4gICAgICAgICAgICB2YWx1ZTogdHJpbVZhbHVlUmFuZ2UodGhpcy5tYXgsIHRoaXMubWluLCB0aGlzLnZhbHVlKSxcbiAgICAgICAgICAgIHZlcnRpY2FsOiB0aGlzLnZlcnRpY2FsLFxuICAgICAgICAgICAgYnV0dG9uczogZmFsc2VcbiAgICAgICAgfTtcbiAgICB9XG4gICAgYXR0YWNoRWxlbWVudEV2ZW50SGFuZGxlcnMoKSB7XG4gICAgICAgIGNvbnN0IGhvc3RFbGVtZW50ID0gdGhpcy5ob3N0RWxlbWVudC5uYXRpdmVFbGVtZW50O1xuICAgICAgICBsZXQgdGFiYmluZyA9IGZhbHNlO1xuICAgICAgICBsZXQgY3Vyc29ySW5zaWRlV3JhcHBlciA9IGZhbHNlO1xuICAgICAgICB0aGlzLm5nWm9uZS5ydW5PdXRzaWRlQW5ndWxhcigoKSA9PiB7XG4gICAgICAgICAgICAvLyBmb2N1c0luIGFuZCBmb2N1c091dCBhcmUgcmVsYXRpdmUgdG8gdGhlIGhvc3QgZWxlbWVudFxuICAgICAgICAgICAgdGhpcy5zdWJzY3JpcHRpb25zLmFkZCh0aGlzLnJlbmRlcmVyLmxpc3Rlbihob3N0RWxlbWVudCwgJ2ZvY3VzaW4nLCAoKSA9PiB7XG4gICAgICAgICAgICAgICAgaWYgKCF0aGlzLmlzRm9jdXNlZCkge1xuICAgICAgICAgICAgICAgICAgICB0aGlzLm5nWm9uZS5ydW4oKCkgPT4ge1xuICAgICAgICAgICAgICAgICAgICAgICAgaWYgKCF0aGlzLmZvY3VzQ2hhbmdlZFByb2dyYW1tYXRpY2FsbHkpIHtcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICB0aGlzLm9uRm9jdXMuZW1pdCgpO1xuICAgICAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgICAgICAgICAgdGhpcy5mb2N1c2VkID0gdHJ1ZTtcbiAgICAgICAgICAgICAgICAgICAgfSk7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfSkpO1xuICAgICAgICAgICAgdGhpcy5zdWJzY3JpcHRpb25zLmFkZCh0aGlzLnJlbmRlcmVyLmxpc3Rlbihob3N0RWxlbWVudCwgJ2ZvY3Vzb3V0JywgKGFyZ3MpID0+IHtcbiAgICAgICAgICAgICAgICBpZiAoIXRoaXMuaXNGb2N1c2VkKSB7XG4gICAgICAgICAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgaWYgKHRhYmJpbmcpIHtcbiAgICAgICAgICAgICAgICAgICAgaWYgKGFyZ3MucmVsYXRlZFRhcmdldCAhPT0gdGhpcy5kcmFnaGFuZGxlU3RhcnQubmF0aXZlRWxlbWVudCAmJiBhcmdzLnJlbGF0ZWRUYXJnZXQgIT09IHRoaXMuZHJhZ2hhbmRsZUVuZC5uYXRpdmVFbGVtZW50KSB7XG4gICAgICAgICAgICAgICAgICAgICAgICB0aGlzLmhhbmRsZUJsdXIoKTtcbiAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgICAgICB0YWJiaW5nID0gZmFsc2U7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIGVsc2Uge1xuICAgICAgICAgICAgICAgICAgICBpZiAoIWN1cnNvckluc2lkZVdyYXBwZXIpIHtcbiAgICAgICAgICAgICAgICAgICAgICAgIHRoaXMuaGFuZGxlQmx1cigpO1xuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfSkpO1xuICAgICAgICAgICAgdGhpcy5zdWJzY3JpcHRpb25zLmFkZCh0aGlzLnJlbmRlcmVyLmxpc3Rlbihob3N0RWxlbWVudCwgJ21vdXNlZW50ZXInLCAoKSA9PiB7XG4gICAgICAgICAgICAgICAgY3Vyc29ySW5zaWRlV3JhcHBlciA9IHRydWU7XG4gICAgICAgICAgICB9KSk7XG4gICAgICAgICAgICB0aGlzLnN1YnNjcmlwdGlvbnMuYWRkKHRoaXMucmVuZGVyZXIubGlzdGVuKGhvc3RFbGVtZW50LCAnbW91c2VsZWF2ZScsICgpID0+IHtcbiAgICAgICAgICAgICAgICBjdXJzb3JJbnNpZGVXcmFwcGVyID0gZmFsc2U7XG4gICAgICAgICAgICB9KSk7XG4gICAgICAgICAgICB0aGlzLnN1YnNjcmlwdGlvbnMuYWRkKHRoaXMucmVuZGVyZXIubGlzdGVuKGhvc3RFbGVtZW50LCAna2V5ZG93bicsIChhcmdzKSA9PiB7XG4gICAgICAgICAgICAgICAgaWYgKGFyZ3Mua2V5Q29kZSA9PT0gS2V5cy5UYWIpIHtcbiAgICAgICAgICAgICAgICAgICAgdGFiYmluZyA9IHRydWU7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIGVsc2Uge1xuICAgICAgICAgICAgICAgICAgICB0YWJiaW5nID0gZmFsc2U7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfSkpO1xuICAgICAgICB9KTtcbiAgICB9XG59XG5SYW5nZVNsaWRlckNvbXBvbmVudC5kZWNvcmF0b3JzID0gW1xuICAgIHsgdHlwZTogQ29tcG9uZW50LCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIGV4cG9ydEFzOiAna2VuZG9SYW5nZVNsaWRlcicsXG4gICAgICAgICAgICAgICAgcHJvdmlkZXJzOiBbXG4gICAgICAgICAgICAgICAgICAgIExvY2FsaXphdGlvblNlcnZpY2UsXG4gICAgICAgICAgICAgICAgICAgIHsgcHJvdmlkZTogTDEwTl9QUkVGSVgsIHVzZVZhbHVlOiAna2VuZG8ucmFuZ2VzbGlkZXInIH0sXG4gICAgICAgICAgICAgICAgICAgIHsgbXVsdGk6IHRydWUsIHByb3ZpZGU6IE5HX1ZBTFVFX0FDQ0VTU09SLCB1c2VFeGlzdGluZzogZm9yd2FyZFJlZigoKSA9PiBSYW5nZVNsaWRlckNvbXBvbmVudCkgfSxcbiAgICAgICAgICAgICAgICAgICAgeyBwcm92aWRlOiBLZW5kb0lucHV0LCB1c2VFeGlzdGluZzogZm9yd2FyZFJlZigoKSA9PiBSYW5nZVNsaWRlckNvbXBvbmVudCkgfVxuICAgICAgICAgICAgICAgIF0sXG4gICAgICAgICAgICAgICAgc2VsZWN0b3I6ICdrZW5kby1yYW5nZXNsaWRlcicsXG4gICAgICAgICAgICAgICAgdGVtcGxhdGU6IGBcbiAgICAgICAgPG5nLWNvbnRhaW5lciBrZW5kb1NsaWRlckxvY2FsaXplZE1lc3NhZ2VzXG4gICAgICAgICAgICBpMThuLWRyYWdIYW5kbGVTdGFydD1cImtlbmRvLnJhbmdlc2xpZGVyLmRyYWdIYW5kbGVTdGFydHxUaGUgdGl0bGUgb2YgdGhlICoqU3RhcnQqKiBkcmFnIGhhbmRsZSBvZiB0aGUgU2xpZGVyLlwiXG4gICAgICAgICAgICBkcmFnSGFuZGxlU3RhcnQ9XCJEcmFnXCJcbiAgICAgICAgICAgIGkxOG4tZHJhZ0hhbmRsZUVuZD1cImtlbmRvLnJhbmdlc2xpZGVyLmRyYWdIYW5kbGVFbmR8VGhlIHRpdGxlIG9mIHRoZSAqKkVuZCoqIGRyYWcgaGFuZGxlIG9mIHRoZSBTbGlkZXIuXCJcbiAgICAgICAgICAgIGRyYWdIYW5kbGVFbmQ9XCJEcmFnXCJcbiAgICAgICAgPlxuXG4gICAgICAgIDxkaXYgY2xhc3M9XCJrLXNsaWRlci13cmFwXCIgI3dyYXBcbiAgICAgICAgICAgIFtjbGFzcy5rLXNsaWRlci10b3BsZWZ0XT1cInRpY2tQbGFjZW1lbnQgPT09ICdiZWZvcmUnXCJcbiAgICAgICAgICAgIFtjbGFzcy5rLXNsaWRlci1ib3R0b21yaWdodF09XCJ0aWNrUGxhY2VtZW50ID09PSAnYWZ0ZXInXCJcbiAgICAgICAgICAgIFtrZW5kb0V2ZW50c091dHNpZGVBbmd1bGFyXT1cInsgY2xpY2s6IG9uV3JhcENsaWNrLCBrZXlkb3duOiBvbktleURvd24gfVwiXG4gICAgICAgICAgICA+XG4gICAgICAgICAgICA8dWwga2VuZG9TbGlkZXJUaWNrc1xuICAgICAgICAgICAgICAgICN0aWNrc1xuICAgICAgICAgICAgICAgICpuZ0lmPVwidGlja1BsYWNlbWVudCAhPT0gJ25vbmUnXCJcbiAgICAgICAgICAgICAgICBbdGlja1RpdGxlXT1cInRpdGxlXCJcbiAgICAgICAgICAgICAgICBbdmVydGljYWxdPVwidmVydGljYWxcIlxuICAgICAgICAgICAgICAgIFtzdGVwXT1cInNtYWxsU3RlcFwiXG4gICAgICAgICAgICAgICAgW2xhcmdlU3RlcF09XCJsYXJnZVN0ZXBcIlxuICAgICAgICAgICAgICAgIFttaW5dPVwibWluXCJcbiAgICAgICAgICAgICAgICBbbWF4XT1cIm1heFwiXG4gICAgICAgICAgICAgICAgW2xhYmVsVGVtcGxhdGVdPVwibGFiZWxUZW1wbGF0ZT8udGVtcGxhdGVSZWZcIlxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgPC91bD5cbiAgICAgICAgICAgIDxkaXYgI3RyYWNrIGNsYXNzPVwiay1zbGlkZXItdHJhY2tcIj5cbiAgICAgICAgICAgICAgICA8ZGl2ICNzbGlkZXJTZWxlY3Rpb24gY2xhc3M9XCJrLXNsaWRlci1zZWxlY3Rpb25cIj5cbiAgICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgICA8YSAjZHJhZ2hhbmRsZVN0YXJ0XG4gICAgICAgICAgICAgICAgICAgIHJvbGU9XCJzbGlkZXJcIlxuICAgICAgICAgICAgICAgICAgICBbaWRdPVwic3RhcnRIYW5kbGVJZFwiXG4gICAgICAgICAgICAgICAgICAgIFthdHRyLnRhYmluZGV4XT1cImRpc2FibGVkID8gdW5kZWZpbmVkIDogdGFiaW5kZXhcIlxuICAgICAgICAgICAgICAgICAgICBbYXR0ci5hcmlhLXZhbHVlbWluXT1cIm1pblwiXG4gICAgICAgICAgICAgICAgICAgIFthdHRyLmFyaWEtdmFsdWVtYXhdPVwibWF4XCJcbiAgICAgICAgICAgICAgICAgICAgW2F0dHIuYXJpYS12YWx1ZW5vd109XCJ2YWx1ZSA/IHZhbHVlWzBdIDogbnVsbFwiXG4gICAgICAgICAgICAgICAgICAgIFthdHRyLmFyaWEtdmFsdWV0ZXh0XT1cInZhbHVlVGV4dFwiXG4gICAgICAgICAgICAgICAgICAgIFthdHRyLmFyaWEtZGlzYWJsZWRdPVwiZGlzYWJsZWQgPyB0cnVlIDogdW5kZWZpbmVkXCJcbiAgICAgICAgICAgICAgICAgICAgW2F0dHIuYXJpYS1yZWFkb25seV09XCJyZWFkb25seSA/IHRydWUgOiB1bmRlZmluZWRcIlxuICAgICAgICAgICAgICAgICAgICBbYXR0ci5hcmlhLW9yaWVudGF0aW9uXT1cInZlcnRpY2FsID8gJ3ZlcnRpY2FsJyA6ICdob3Jpem9udGFsJ1wiXG4gICAgICAgICAgICAgICAgICAgIFtzdHlsZS50b3VjaC1hY3Rpb25dPVwiaXNEaXNhYmxlZCA/ICcnIDogJ25vbmUnXCJcbiAgICAgICAgICAgICAgICAgICAgY2xhc3M9XCJrLWRyYWdoYW5kbGVcIlxuICAgICAgICAgICAgICAgICAgICBbdGl0bGVdPVwidGV4dEZvcignZHJhZ0hhbmRsZVN0YXJ0JylcIlxuICAgICAgICAgICAgICAgICAgICBrZW5kb0RyYWdnYWJsZVxuICAgICAgICAgICAgICAgICAgICAoa2VuZG9QcmVzcyk9XCJpZkVuYWJsZWQoaGFuZGxlRHJhZ1ByZXNzICwkZXZlbnQpXCJcbiAgICAgICAgICAgICAgICAgICAgKGtlbmRvRHJhZyk9XCJpZkVuYWJsZWQob25IYW5kbGVEcmFnICwkZXZlbnQpXCJcbiAgICAgICAgICAgICAgICAgICAgKGtlbmRvUmVsZWFzZSk9XCJpZkVuYWJsZWQob25IYW5kbGVSZWxlYXNlLCAkZXZlbnQpXCJcbiAgICAgICAgICAgICAgICA+PC9hPlxuICAgICAgICAgICAgICAgIDxhICNkcmFnaGFuZGxlRW5kXG4gICAgICAgICAgICAgICAgICAgIHJvbGU9XCJzbGlkZXJcIlxuICAgICAgICAgICAgICAgICAgICBbaWRdPVwiZW5kSGFuZGxlSWRcIlxuICAgICAgICAgICAgICAgICAgICBbYXR0ci50YWJpbmRleF09XCJkaXNhYmxlZCA/IHVuZGVmaW5lZCA6IHRhYmluZGV4XCJcbiAgICAgICAgICAgICAgICAgICAgW2F0dHIuYXJpYS12YWx1ZW1pbl09XCJtaW5cIlxuICAgICAgICAgICAgICAgICAgICBbYXR0ci5hcmlhLXZhbHVlbWF4XT1cIm1heFwiXG4gICAgICAgICAgICAgICAgICAgIFthdHRyLmFyaWEtdmFsdWVub3ddPVwidmFsdWUgPyB2YWx1ZVsxXSA6IG51bGxcIlxuICAgICAgICAgICAgICAgICAgICBbYXR0ci5hcmlhLXZhbHVldGV4dF09XCJ2YWx1ZVRleHRcIlxuICAgICAgICAgICAgICAgICAgICBbYXR0ci5hcmlhLWRpc2FibGVkXT1cImRpc2FibGVkID8gdHJ1ZSA6IHVuZGVmaW5lZFwiXG4gICAgICAgICAgICAgICAgICAgIFthdHRyLmFyaWEtcmVhZG9ubHldPVwicmVhZG9ubHkgPyB0cnVlIDogdW5kZWZpbmVkXCJcbiAgICAgICAgICAgICAgICAgICAgW2F0dHIuYXJpYS1vcmllbnRhdGlvbl09XCJ2ZXJ0aWNhbCA/ICd2ZXJ0aWNhbCcgOiAnaG9yaXpvbnRhbCdcIlxuICAgICAgICAgICAgICAgICAgICBbc3R5bGUudG91Y2gtYWN0aW9uXT1cImlzRGlzYWJsZWQgPyAnJyA6ICdub25lJ1wiXG4gICAgICAgICAgICAgICAgICAgIGNsYXNzPVwiay1kcmFnaGFuZGxlXCJcbiAgICAgICAgICAgICAgICAgICAgW3RpdGxlXT1cInRleHRGb3IoJ2RyYWdIYW5kbGVFbmQnKVwiXG4gICAgICAgICAgICAgICAgICAgIGtlbmRvRHJhZ2dhYmxlXG4gICAgICAgICAgICAgICAgICAgIChrZW5kb1ByZXNzKT1cImlmRW5hYmxlZChoYW5kbGVEcmFnUHJlc3MgLCRldmVudClcIlxuICAgICAgICAgICAgICAgICAgICAoa2VuZG9EcmFnKT1cImlmRW5hYmxlZChvbkhhbmRsZURyYWcgLCRldmVudClcIlxuICAgICAgICAgICAgICAgICAgICAoa2VuZG9SZWxlYXNlKT1cImlmRW5hYmxlZChvbkhhbmRsZVJlbGVhc2UsICRldmVudClcIlxuICAgICAgICAgICAgICAgID48L2E+XG4gICAgICAgICAgICA8L2Rpdj5cblxuICAgICAgICAgICAgPGtlbmRvLXJlc2l6ZS1zZW5zb3IgKHJlc2l6ZSk9XCJzaXplQ29tcG9uZW50KClcIj48L2tlbmRvLXJlc2l6ZS1zZW5zb3I+XG4gICAgICAgIDwvZGl2PlxuICBgXG4gICAgICAgICAgICB9LF0gfSxcbl07XG4vKiogQG5vY29sbGFwc2UgKi9cblJhbmdlU2xpZGVyQ29tcG9uZW50LmN0b3JQYXJhbWV0ZXJzID0gKCkgPT4gW1xuICAgIHsgdHlwZTogTG9jYWxpemF0aW9uU2VydmljZSB9LFxuICAgIHsgdHlwZTogSW5qZWN0b3IgfSxcbiAgICB7IHR5cGU6IFJlbmRlcmVyMiB9LFxuICAgIHsgdHlwZTogTmdab25lIH0sXG4gICAgeyB0eXBlOiBDaGFuZ2VEZXRlY3RvclJlZiB9LFxuICAgIHsgdHlwZTogRWxlbWVudFJlZiB9XG5dO1xuUmFuZ2VTbGlkZXJDb21wb25lbnQucHJvcERlY29yYXRvcnMgPSB7XG4gICAgdmFsdWU6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIGRyYWdoYW5kbGVTdGFydDogW3sgdHlwZTogVmlld0NoaWxkLCBhcmdzOiBbJ2RyYWdoYW5kbGVTdGFydCcsIHsgc3RhdGljOiB0cnVlIH0sXSB9XSxcbiAgICBkcmFnaGFuZGxlRW5kOiBbeyB0eXBlOiBWaWV3Q2hpbGQsIGFyZ3M6IFsnZHJhZ2hhbmRsZUVuZCcsIHsgc3RhdGljOiB0cnVlIH0sXSB9XVxufTtcblxuY29uc3QgRk9DVVNFRCQxID0gJ2stc3RhdGUtZm9jdXNlZCc7XG4vKipcbiAqIFJlcHJlc2VudHMgdGhlIFtLZW5kbyBVSSBTd2l0Y2ggY29tcG9uZW50IGZvciBBbmd1bGFyXSh7JSBzbHVnIG92ZXJ2aWV3X3N3aXRjaCAlfSkuXG4gKi9cbmNsYXNzIFN3aXRjaENvbXBvbmVudCB7XG4gICAgY29uc3RydWN0b3IocmVuZGVyZXIsIGhvc3RFbGVtZW50LCBsb2NhbGl6YXRpb25TZXJ2aWNlLCBpbmplY3RvciwgY2hhbmdlRGV0ZWN0b3IsIG5nWm9uZSkge1xuICAgICAgICB0aGlzLnJlbmRlcmVyID0gcmVuZGVyZXI7XG4gICAgICAgIHRoaXMuaG9zdEVsZW1lbnQgPSBob3N0RWxlbWVudDtcbiAgICAgICAgdGhpcy5sb2NhbGl6YXRpb25TZXJ2aWNlID0gbG9jYWxpemF0aW9uU2VydmljZTtcbiAgICAgICAgdGhpcy5pbmplY3RvciA9IGluamVjdG9yO1xuICAgICAgICB0aGlzLmNoYW5nZURldGVjdG9yID0gY2hhbmdlRGV0ZWN0b3I7XG4gICAgICAgIHRoaXMubmdab25lID0gbmdab25lO1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5mb2N1c2FibGVJZCA9IGBrLSR7Z3VpZCgpfWA7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBTZXRzIHRoZSBjdXJyZW50IHZhbHVlIG9mIHRoZSBTd2l0Y2ggd2hlbiBpdCBpcyBpbml0aWFsbHkgZGlzcGxheWVkLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5jaGVja2VkID0gZmFsc2U7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBEZXRlcm1pbmVzIHdoZXRoZXIgdGhlIFN3aXRjaCBpcyBkaXNhYmxlZCAoW3NlZSBleGFtcGxlXSh7JSBzbHVnIGRpc2FibGVkX3N3aXRjaCAlfSkpLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5kaXNhYmxlZCA9IGZhbHNlO1xuICAgICAgICAvKipcbiAgICAgICAgICogRGV0ZXJtaW5lcyB3aGV0aGVyIHRoZSBTd2l0Y2ggaXMgaW4gaXRzIHJlYWQtb25seSBzdGF0ZSAoW3NlZSBleGFtcGxlXSh7JSBzbHVnIHJlYWRvbmx5X3N3aXRjaCAlfSkpLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5yZWFkb25seSA9IGZhbHNlO1xuICAgICAgICAvKipcbiAgICAgICAgICogU3BlY2lmaWVzIHRoZSBbYHRhYmluZGV4YF0oaHR0cHM6Ly9kZXZlbG9wZXIubW96aWxsYS5vcmcvZW4tVVMvZG9jcy9XZWIvSFRNTC9HbG9iYWxfYXR0cmlidXRlcy90YWJpbmRleCkgb2YgdGhlIFN3aXRjaC5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMudGFiaW5kZXggPSAwO1xuICAgICAgICAvKipcbiAgICAgICAgICogRmlyZXMgZWFjaCB0aW1lIHRoZSB1c2VyIGZvY3VzZXMgdGhlIGBpbnB1dGAgZWxlbWVudC5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMub25Gb2N1cyA9IG5ldyBFdmVudEVtaXR0ZXIoKTsgLy90c2xpbnQ6ZGlzYWJsZS1saW5lOm5vLW91dHB1dC1yZW5hbWVcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEZpcmVzIGVhY2ggdGltZSB0aGUgYGlucHV0YCBlbGVtZW50IGdldHMgYmx1cnJlZC5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMub25CbHVyID0gbmV3IEV2ZW50RW1pdHRlcigpOyAvL3RzbGludDpkaXNhYmxlLWxpbmU6bm8tb3V0cHV0LXJlbmFtZVxuICAgICAgICAvKipcbiAgICAgICAgICogRmlyZXMgZWFjaCB0aW1lIHRoZSB1c2VyIHNlbGVjdHMgYSBuZXcgdmFsdWUuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLnZhbHVlQ2hhbmdlID0gbmV3IEV2ZW50RW1pdHRlcigpO1xuICAgICAgICB0aGlzLm5nQ2hhbmdlID0gKF8pID0+IHsgfTtcbiAgICAgICAgdGhpcy5uZ1RvdWNoZWQgPSAoKSA9PiB7IH07XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmhhbmRsZUZvY3VzID0gKCkgPT4ge1xuICAgICAgICAgICAgdGhpcy5mb2N1c2VkID0gdHJ1ZTtcbiAgICAgICAgICAgIGlmIChoYXNPYnNlcnZlcnModGhpcy5vbkZvY3VzKSkge1xuICAgICAgICAgICAgICAgIHRoaXMubmdab25lLnJ1bigoKSA9PiB7XG4gICAgICAgICAgICAgICAgICAgIHRoaXMub25Gb2N1cy5lbWl0KCk7XG4gICAgICAgICAgICAgICAgfSk7XG4gICAgICAgICAgICB9XG4gICAgICAgIH07XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmhhbmRsZUJsdXIgPSAoKSA9PiB7XG4gICAgICAgICAgICB0aGlzLmNoYW5nZURldGVjdG9yLm1hcmtGb3JDaGVjaygpO1xuICAgICAgICAgICAgdGhpcy5mb2N1c2VkID0gZmFsc2U7XG4gICAgICAgICAgICBpZiAoaGFzT2JzZXJ2ZXJzKHRoaXMub25CbHVyKSB8fCByZXF1aXJlc1pvbmVPbkJsdXIodGhpcy5jb250cm9sKSkge1xuICAgICAgICAgICAgICAgIHRoaXMubmdab25lLnJ1bigoKSA9PiB7XG4gICAgICAgICAgICAgICAgICAgIHRoaXMubmdUb3VjaGVkKCk7XG4gICAgICAgICAgICAgICAgICAgIHRoaXMub25CbHVyLmVtaXQoKTtcbiAgICAgICAgICAgICAgICB9KTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgfTtcbiAgICAgICAgdGhpcy5kaXJlY3Rpb24gPSBsb2NhbGl6YXRpb25TZXJ2aWNlLnJ0bCA/ICdydGwnIDogJ2x0cic7XG4gICAgICAgIHRoaXMua2V5RG93bkhhbmRsZXIgPSB0aGlzLmtleURvd25IYW5kbGVyLmJpbmQodGhpcyk7XG4gICAgICAgIHRoaXMuY2xpY2tIYW5kbGVyID0gdGhpcy5jbGlja0hhbmRsZXIuYmluZCh0aGlzKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHNldCB0YWJJbmRleCh0YWJJbmRleCkge1xuICAgICAgICB0aGlzLnRhYmluZGV4ID0gdGFiSW5kZXg7XG4gICAgfVxuICAgIGdldCB0YWJJbmRleCgpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMudGFiaW5kZXg7XG4gICAgfVxuICAgIGdldCBpZUNsYXNzKCkge1xuICAgICAgICByZXR1cm4gYnJvd3NlciAmJiBicm93c2VyLm1zaWU7XG4gICAgfVxuICAgIGdldCBhcmlhRGlzYWJsZWQoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmRpc2FibGVkID8gdHJ1ZSA6IHVuZGVmaW5lZDtcbiAgICB9XG4gICAgZ2V0IGFyaWFSZWFkb25seSgpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMucmVhZG9ubHk7XG4gICAgfVxuICAgIGdldCBob3N0Q2xhc3NlcygpIHtcbiAgICAgICAgcmV0dXJuIHRydWU7XG4gICAgfVxuICAgIGdldCBzd2l0Y2hPbkNsYXNzKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5jaGVja2VkO1xuICAgIH1cbiAgICBnZXQgc3dpdGNoT2ZmQ2xhc3MoKSB7XG4gICAgICAgIHJldHVybiAhdGhpcy5jaGVja2VkO1xuICAgIH1cbiAgICBnZXQgZGlzYWJsZWRDbGFzcygpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuZGlzYWJsZWQ7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBnZXQgb25MYWJlbE1lc3NhZ2UoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLm9uTGFiZWwgfHwgdGhpcy5sb2NhbGl6YXRpb25TZXJ2aWNlLmdldCgnb24nKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIGdldCBvZmZMYWJlbE1lc3NhZ2UoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLm9mZkxhYmVsIHx8IHRoaXMubG9jYWxpemF0aW9uU2VydmljZS5nZXQoJ29mZicpO1xuICAgIH1cbiAgICBnZXQgaXNFbmFibGVkKCkge1xuICAgICAgICByZXR1cm4gIXRoaXMuZGlzYWJsZWQgJiYgIXRoaXMucmVhZG9ubHk7XG4gICAgfVxuICAgIG5nT25Jbml0KCkge1xuICAgICAgICBpZiAodGhpcy5ob3N0RWxlbWVudCkge1xuICAgICAgICAgICAgY29uc3Qgd3JhcHBlciA9IHRoaXMuaG9zdEVsZW1lbnQubmF0aXZlRWxlbWVudDtcbiAgICAgICAgICAgIHRoaXMucmVuZGVyZXIucmVtb3ZlQXR0cmlidXRlKHdyYXBwZXIsIFwidGFiaW5kZXhcIik7XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5sb2NhbGl6YXRpb25DaGFuZ2VTdWJzY3JpcHRpb24gPSB0aGlzLmxvY2FsaXphdGlvblNlcnZpY2VcbiAgICAgICAgICAgIC5jaGFuZ2VzXG4gICAgICAgICAgICAucGlwZShza2lwKDEpKVxuICAgICAgICAgICAgLnN1YnNjcmliZSgoeyBydGwgfSkgPT4ge1xuICAgICAgICAgICAgdGhpcy5kaXJlY3Rpb24gPSBydGwgPyAncnRsJyA6ICdsdHInO1xuICAgICAgICB9KTtcbiAgICAgICAgdGhpcy5jb250cm9sID0gdGhpcy5pbmplY3Rvci5nZXQoTmdDb250cm9sLCBudWxsKTtcbiAgICB9XG4gICAgbmdPbkRlc3Ryb3koKSB7XG4gICAgICAgIGlmICh0aGlzLmxvY2FsaXphdGlvbkNoYW5nZVN1YnNjcmlwdGlvbikge1xuICAgICAgICAgICAgdGhpcy5sb2NhbGl6YXRpb25DaGFuZ2VTdWJzY3JpcHRpb24udW5zdWJzY3JpYmUoKTtcbiAgICAgICAgfVxuICAgIH1cbiAgICAvKipcbiAgICAgKiBGb2N1c2VzIHRoZSBTd2l0Y2guXG4gICAgICpcbiAgICAgKiBAZXhhbXBsZVxuICAgICAqIGBgYHRzLW5vLXJ1blxuICAgICAqIF9AQ29tcG9uZW50KHtcbiAgICAgKiBzZWxlY3RvcjogJ215LWFwcCcsXG4gICAgICogdGVtcGxhdGU6IGBcbiAgICAgKiAgPGJ1dHRvbiAoY2xpY2spPVwic3dpdGNoLmZvY3VzKClcIj5Gb2N1czwvYnV0dG9uPlxuICAgICAqICA8a2VuZG8tc3dpdGNoICNzd2l0Y2g+PC9rZW5kby1zd2l0Y2g+XG4gICAgICogYFxuICAgICAqIH0pXG4gICAgICogY2xhc3MgQXBwQ29tcG9uZW50IHsgfVxuICAgICAqIGBgYFxuICAgICAqL1xuICAgIGZvY3VzKCkge1xuICAgICAgICBpZiAoIXRoaXMud3JhcHBlcikge1xuICAgICAgICAgICAgcmV0dXJuO1xuICAgICAgICB9XG4gICAgICAgIHRoaXMud3JhcHBlci5uYXRpdmVFbGVtZW50LmZvY3VzKCk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEJsdXJzIHRoZSBTd2l0Y2guXG4gICAgICovXG4gICAgYmx1cigpIHtcbiAgICAgICAgaWYgKCF0aGlzLndyYXBwZXIpIHtcbiAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgfVxuICAgICAgICB0aGlzLndyYXBwZXIubmF0aXZlRWxlbWVudC5ibHVyKCk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKiBDYWxsZWQgd2hlbiB0aGUgc3RhdHVzIG9mIHRoZSBjb21wb25lbnQgY2hhbmdlcyB0byBvciBmcm9tIGBkaXNhYmxlZGAuXG4gICAgICogRGVwZW5kaW5nIG9uIHRoZSB2YWx1ZSwgaXQgZW5hYmxlcyBvciBkaXNhYmxlcyB0aGUgYXBwcm9wcmlhdGUgRE9NIGVsZW1lbnQuXG4gICAgICovXG4gICAgc2V0RGlzYWJsZWRTdGF0ZShpc0Rpc2FibGVkKSB7XG4gICAgICAgIHRoaXMuZGlzYWJsZWQgPSBpc0Rpc2FibGVkO1xuICAgICAgICB0aGlzLmNoYW5nZURldGVjdG9yLm1hcmtGb3JDaGVjaygpO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgd3JpdGVWYWx1ZSh2YWx1ZSkge1xuICAgICAgICB0aGlzLmNoZWNrZWQgPSB2YWx1ZSA9PT0gbnVsbCA/IGZhbHNlIDogdmFsdWU7XG4gICAgICAgIHRoaXMuY2hhbmdlRGV0ZWN0b3IubWFya0ZvckNoZWNrKCk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICByZWdpc3Rlck9uQ2hhbmdlKGZuKSB7XG4gICAgICAgIHRoaXMubmdDaGFuZ2UgPSBmbjtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHJlZ2lzdGVyT25Ub3VjaGVkKGZuKSB7XG4gICAgICAgIHRoaXMubmdUb3VjaGVkID0gZm47XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBrZXlEb3duSGFuZGxlcihlKSB7XG4gICAgICAgIGNvbnN0IGtleUNvZGUgPSBlLmtleUNvZGU7XG4gICAgICAgIGlmICh0aGlzLmlzRW5hYmxlZCAmJiAoa2V5Q29kZSA9PT0gS2V5cy5TcGFjZSB8fCBrZXlDb2RlID09PSBLZXlzLkVudGVyKSkge1xuICAgICAgICAgICAgdGhpcy5jaGFuZ2VWYWx1ZSghdGhpcy5jaGVja2VkKTtcbiAgICAgICAgICAgIGUucHJldmVudERlZmF1bHQoKTtcbiAgICAgICAgfVxuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgY2xpY2tIYW5kbGVyKCkge1xuICAgICAgICBpZiAodGhpcy5pc0VuYWJsZWQpIHtcbiAgICAgICAgICAgIHRoaXMuY2hhbmdlVmFsdWUoIXRoaXMuY2hlY2tlZCk7XG4gICAgICAgIH1cbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqIFVzZWQgYnkgdGhlIFRleHRCb3hDb250YWluZXIgdG8gZGV0ZXJtaW5lIGlmIHRoZSBjb21wb25lbnQgaXMgZW1wdHkuXG4gICAgICovXG4gICAgaXNFbXB0eSgpIHtcbiAgICAgICAgcmV0dXJuIGZhbHNlO1xuICAgIH1cbiAgICBjaGFuZ2VWYWx1ZSh2YWx1ZSkge1xuICAgICAgICBpZiAodGhpcy5jaGVja2VkICE9PSB2YWx1ZSkge1xuICAgICAgICAgICAgdGhpcy5uZ1pvbmUucnVuKCgpID0+IHtcbiAgICAgICAgICAgICAgICB0aGlzLmNoZWNrZWQgPSB2YWx1ZTtcbiAgICAgICAgICAgICAgICB0aGlzLm5nQ2hhbmdlKHZhbHVlKTtcbiAgICAgICAgICAgICAgICB0aGlzLnZhbHVlQ2hhbmdlLmVtaXQodmFsdWUpO1xuICAgICAgICAgICAgICAgIHRoaXMuY2hhbmdlRGV0ZWN0b3IubWFya0ZvckNoZWNrKCk7XG4gICAgICAgICAgICB9KTtcbiAgICAgICAgfVxuICAgIH1cbiAgICBzZXQgZm9jdXNlZCh2YWx1ZSkge1xuICAgICAgICBpZiAodGhpcy5pc0ZvY3VzZWQgIT09IHZhbHVlICYmIHRoaXMuaG9zdEVsZW1lbnQpIHtcbiAgICAgICAgICAgIGNvbnN0IGVsZW1lbnQgPSB0aGlzLmhvc3RFbGVtZW50Lm5hdGl2ZUVsZW1lbnQ7XG4gICAgICAgICAgICBpZiAodmFsdWUpIHtcbiAgICAgICAgICAgICAgICB0aGlzLnJlbmRlcmVyLmFkZENsYXNzKGVsZW1lbnQsIEZPQ1VTRUQkMSk7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICBlbHNlIHtcbiAgICAgICAgICAgICAgICB0aGlzLnJlbmRlcmVyLnJlbW92ZUNsYXNzKGVsZW1lbnQsIEZPQ1VTRUQkMSk7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICB0aGlzLmlzRm9jdXNlZCA9IHZhbHVlO1xuICAgICAgICB9XG4gICAgfVxufVxuU3dpdGNoQ29tcG9uZW50LmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBDb21wb25lbnQsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgZXhwb3J0QXM6ICdrZW5kb1N3aXRjaCcsXG4gICAgICAgICAgICAgICAgcHJvdmlkZXJzOiBbXG4gICAgICAgICAgICAgICAgICAgIExvY2FsaXphdGlvblNlcnZpY2UsXG4gICAgICAgICAgICAgICAgICAgIHsgcHJvdmlkZTogTDEwTl9QUkVGSVgsIHVzZVZhbHVlOiAna2VuZG8uc3dpdGNoJyB9LFxuICAgICAgICAgICAgICAgICAgICB7XG4gICAgICAgICAgICAgICAgICAgICAgICBtdWx0aTogdHJ1ZSxcbiAgICAgICAgICAgICAgICAgICAgICAgIHByb3ZpZGU6IE5HX1ZBTFVFX0FDQ0VTU09SLFxuICAgICAgICAgICAgICAgICAgICAgICAgdXNlRXhpc3Rpbmc6IGZvcndhcmRSZWYoKCkgPT4gU3dpdGNoQ29tcG9uZW50KSAvKiB0c2xpbnQ6ZGlzYWJsZS1saW5lICovXG4gICAgICAgICAgICAgICAgICAgIH0sXG4gICAgICAgICAgICAgICAgICAgIHtcbiAgICAgICAgICAgICAgICAgICAgICAgIHByb3ZpZGU6IEtlbmRvSW5wdXQsXG4gICAgICAgICAgICAgICAgICAgICAgICB1c2VFeGlzdGluZzogZm9yd2FyZFJlZigoKSA9PiBTd2l0Y2hDb21wb25lbnQpXG4gICAgICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICBdLFxuICAgICAgICAgICAgICAgIHNlbGVjdG9yOiAna2VuZG8tc3dpdGNoJyxcbiAgICAgICAgICAgICAgICB0ZW1wbGF0ZTogYFxuICAgICAgICA8bmctY29udGFpbmVyIGtlbmRvU3dpdGNoTG9jYWxpemVkTWVzc2FnZXNcbiAgICAgICAgICAgIGkxOG4tb249XCJrZW5kby5zd2l0Y2gub258VGhlICoqT24qKiBsYWJlbCBvZiB0aGUgU3dpdGNoLlwiXG4gICAgICAgICAgICBvbj1cIk9OXCJcbiAgICAgICAgICAgIGkxOG4tb2ZmPVwia2VuZG8uc3dpdGNoLm9mZnxUaGUgKipPZmYqKiBsYWJlbCBvZiB0aGUgU3dpdGNoLlwiXG4gICAgICAgICAgICBvZmY9XCJPRkZcIlxuICAgICAgICA+XG5cbiAgICAgICAgPHNwYW5cbiAgICAgICAgICAgICN3cmFwcGVyXG4gICAgICAgICAgICBjbGFzcz1cImstc3dpdGNoLWNvbnRhaW5lclwiXG4gICAgICAgICAgICBbaWRdPVwiZm9jdXNhYmxlSWRcIlxuICAgICAgICAgICAgcm9sZT1cInN3aXRjaFwiXG4gICAgICAgICAgICBbYXR0ci5hcmlhLWNoZWNrZWRdPVwiY2hlY2tlZFwiXG4gICAgICAgICAgICBbYXR0ci50YWJpbmRleF09XCIoZGlzYWJsZWQgPyB1bmRlZmluZWQgOiB0YWJJbmRleClcIlxuICAgICAgICAgICAgW2tlbmRvRXZlbnRzT3V0c2lkZUFuZ3VsYXJdPVwieyBjbGljazogY2xpY2tIYW5kbGVyLCBrZXlkb3duOiBrZXlEb3duSGFuZGxlciwgZm9jdXM6IGhhbmRsZUZvY3VzLCBibHVyOiBoYW5kbGVCbHVyIH1cIlxuICAgICAgICA+XG4gICAgICAgICAgICA8c3BhbiBjbGFzcz1cImstc3dpdGNoLWxhYmVsLW9uXCIgW2F0dHIuYXJpYS1oaWRkZW5dPVwidHJ1ZVwiID57e29uTGFiZWxNZXNzYWdlfX08L3NwYW4+XG4gICAgICAgICAgICA8c3BhbiBjbGFzcz1cImstc3dpdGNoLWxhYmVsLW9mZlwiIFthdHRyLmFyaWEtaGlkZGVuXT1cInRydWVcIj57e29mZkxhYmVsTWVzc2FnZX19PC9zcGFuPlxuICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJrLXN3aXRjaC1oYW5kbGVcIj48L3NwYW4+XG4gICAgICAgIDwvc3Bhbj5cbiAgYFxuICAgICAgICAgICAgfSxdIH0sXG5dO1xuLyoqIEBub2NvbGxhcHNlICovXG5Td2l0Y2hDb21wb25lbnQuY3RvclBhcmFtZXRlcnMgPSAoKSA9PiBbXG4gICAgeyB0eXBlOiBSZW5kZXJlcjIgfSxcbiAgICB7IHR5cGU6IEVsZW1lbnRSZWYgfSxcbiAgICB7IHR5cGU6IExvY2FsaXphdGlvblNlcnZpY2UgfSxcbiAgICB7IHR5cGU6IEluamVjdG9yIH0sXG4gICAgeyB0eXBlOiBDaGFuZ2VEZXRlY3RvclJlZiB9LFxuICAgIHsgdHlwZTogTmdab25lIH1cbl07XG5Td2l0Y2hDb21wb25lbnQucHJvcERlY29yYXRvcnMgPSB7XG4gICAgZm9jdXNhYmxlSWQ6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIG9uTGFiZWw6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIG9mZkxhYmVsOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBjaGVja2VkOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBkaXNhYmxlZDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgcmVhZG9ubHk6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHRhYmluZGV4OiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICB0YWJJbmRleDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgb25Gb2N1czogW3sgdHlwZTogT3V0cHV0LCBhcmdzOiBbJ2ZvY3VzJyxdIH1dLFxuICAgIG9uQmx1cjogW3sgdHlwZTogT3V0cHV0LCBhcmdzOiBbJ2JsdXInLF0gfV0sXG4gICAgdmFsdWVDaGFuZ2U6IFt7IHR5cGU6IE91dHB1dCB9XSxcbiAgICB3cmFwcGVyOiBbeyB0eXBlOiBWaWV3Q2hpbGQsIGFyZ3M6IFsnd3JhcHBlcicsXSB9XSxcbiAgICBkaXJlY3Rpb246IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2F0dHIuZGlyJyxdIH1dLFxuICAgIGllQ2xhc3M6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstaWUnLF0gfV0sXG4gICAgYXJpYURpc2FibGVkOiBbeyB0eXBlOiBIb3N0QmluZGluZywgYXJnczogWydhdHRyLmFyaWEtZGlzYWJsZWQnLF0gfV0sXG4gICAgYXJpYVJlYWRvbmx5OiBbeyB0eXBlOiBIb3N0QmluZGluZywgYXJnczogWydhdHRyLmFyaWEtcmVhZG9ubHknLF0gfV0sXG4gICAgaG9zdENsYXNzZXM6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstd2lkZ2V0JyxdIH0sIHsgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnY2xhc3Muay1zd2l0Y2gnLF0gfV0sXG4gICAgc3dpdGNoT25DbGFzczogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnY2xhc3Muay1zd2l0Y2gtb24nLF0gfV0sXG4gICAgc3dpdGNoT2ZmQ2xhc3M6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstc3dpdGNoLW9mZicsXSB9XSxcbiAgICBkaXNhYmxlZENsYXNzOiBbeyB0eXBlOiBIb3N0QmluZGluZywgYXJnczogWydjbGFzcy5rLXN0YXRlLWRpc2FibGVkJyxdIH1dXG59O1xuXG4vKipcbiAqIFJlcHJlc2VudHMgdGhlIFtLZW5kbyBVSSBUZXh0QXJlYSBkaXJlY3RpdmUgZm9yIHRoZSBJbnB1dHMgY29tcG9uZW50cyBmb3IgQW5ndWxhcl0oeyUgc2x1ZyBvdmVydmlld190ZXh0YXJlYSAlfSkuXG4gKiBQcm92aWRlcyBmbG9hdGluZyBsYWJlbHMgdG8gYHRleHRhcmVhYCBlbGVtZW50cy5cbiAqXG4gKiBAZXhhbXBsZVxuICogYGBgdHMtbm8tcnVuXG4gKiA8dGV4dGFyZWEga2VuZG9UZXh0QXJlYT48L3RleHRhcmVhPlxuICogYGBgXG4gKi9cbmNsYXNzIFRleHRBcmVhRGlyZWN0aXZlIHtcbiAgICBjb25zdHJ1Y3RvcihyZW5kZXJlciwgZWxlbWVudCwgem9uZSwgY2hhbmdlRGV0ZWN0b3IsIGluamVjdG9yLCBydGwpIHtcbiAgICAgICAgdGhpcy5yZW5kZXJlciA9IHJlbmRlcmVyO1xuICAgICAgICB0aGlzLmVsZW1lbnQgPSBlbGVtZW50O1xuICAgICAgICB0aGlzLnpvbmUgPSB6b25lO1xuICAgICAgICB0aGlzLmNoYW5nZURldGVjdG9yID0gY2hhbmdlRGV0ZWN0b3I7XG4gICAgICAgIHRoaXMuaW5qZWN0b3IgPSBpbmplY3RvcjtcbiAgICAgICAgdGhpcy5lbGVtZW50Q2xhc3MgPSB0cnVlO1xuICAgICAgICB0aGlzLmF1dG9maWxsQ2xhc3MgPSB0cnVlO1xuICAgICAgICAvKipcbiAgICAgICAgICogRmlyZXMgZWFjaCB0aW1lIHRoZSB0ZXh0YXJlYSB2YWx1ZSBpcyBjaGFuZ2VkLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy52YWx1ZUNoYW5nZSA9IG5ldyBFdmVudEVtaXR0ZXIoKTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIFNwZWNpZmllcyBpZiB0aGUgYHRleHRhcmVhYCBlbGVtZW50IHdpbGwgcmVzaXplIGl0cyBoZWlnaHQgYXV0b21hdGljYWxseVxuICAgICAgICAgKiAoW3NlZSBleGFtcGxlXSh7JSBzbHVnIG92ZXJ2aWV3X3RleHRhcmVhICV9I3RvYy1hdXRvLXJlc2l6aW5nKSkuXG4gICAgICAgICAqXG4gICAgICAgICAqIEBkZWZhdWx0IGZhbHNlXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmF1dG9TaXplID0gZmFsc2U7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLm9uRm9jdXMgPSBuZXcgRXZlbnRFbWl0dGVyKCk7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLm9uQmx1ciA9IG5ldyBFdmVudEVtaXR0ZXIoKTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMub25WYWx1ZUNoYW5nZSA9IG5ldyBFdmVudEVtaXR0ZXIoKTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuYXV0b0ZpbGxTdGFydCA9IG5ldyBFdmVudEVtaXR0ZXIoKTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuYXV0b0ZpbGxFbmQgPSBuZXcgRXZlbnRFbWl0dGVyKCk7XG4gICAgICAgIHRoaXMubGlzdGVuZXJzID0gW107XG4gICAgICAgIHRoaXMubmdDaGFuZ2UgPSAoXykgPT4geyB9O1xuICAgICAgICB0aGlzLm5nVG91Y2hlZCA9ICgpID0+IHsgfTtcbiAgICAgICAgdGhpcy5kaXJlY3Rpb24gPSBydGwgPyAncnRsJyA6ICdsdHInO1xuICAgIH1cbiAgICBnZXQgaWQoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmVsZW1lbnQubmF0aXZlRWxlbWVudC5pZDtcbiAgICB9XG4gICAgc2V0IGlkKGlkKSB7XG4gICAgICAgIHRoaXMucmVuZGVyZXIuc2V0QXR0cmlidXRlKHRoaXMuZWxlbWVudC5uYXRpdmVFbGVtZW50LCAnaWQnLCBpZCk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICB3cml0ZVZhbHVlKHZhbHVlKSB7XG4gICAgICAgIHRoaXMuZWxlbWVudFZhbHVlID0gdmFsdWU7XG4gICAgICAgIHRoaXMucmVzaXplKCk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICByZWdpc3Rlck9uQ2hhbmdlKGZuKSB7XG4gICAgICAgIHRoaXMubmdDaGFuZ2UgPSBmbjtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHJlZ2lzdGVyT25Ub3VjaGVkKGZuKSB7XG4gICAgICAgIHRoaXMubmdUb3VjaGVkID0gZm47XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBzZXREaXNhYmxlZFN0YXRlKGlzRGlzYWJsZWQpIHtcbiAgICAgICAgdGhpcy5zZXRFbGVtZW50UHJvcGVydHkoJ2Rpc2FibGVkJywgaXNEaXNhYmxlZCk7XG4gICAgfVxuICAgIG5nT25Jbml0KCkge1xuICAgICAgICBjb25zdCBlbGVtZW50ID0gdGhpcy5lbGVtZW50Lm5hdGl2ZUVsZW1lbnQ7XG4gICAgICAgIHRoaXMuem9uZS5ydW5PdXRzaWRlQW5ndWxhcigoKSA9PiB7XG4gICAgICAgICAgICB0aGlzLmxpc3RlbmVycyA9IFtcbiAgICAgICAgICAgICAgICB0aGlzLnJlbmRlcmVyLmxpc3RlbihlbGVtZW50LCAnZm9jdXMnLCB0aGlzLmhhbmRsZUZvY3VzLmJpbmQodGhpcykpLFxuICAgICAgICAgICAgICAgIHRoaXMucmVuZGVyZXIubGlzdGVuKGVsZW1lbnQsICdibHVyJywgdGhpcy5oYW5kbGVCbHVyLmJpbmQodGhpcykpLFxuICAgICAgICAgICAgICAgIHRoaXMucmVuZGVyZXIubGlzdGVuKGVsZW1lbnQsICdhbmltYXRpb25zdGFydCcsIChlKSA9PiB7XG4gICAgICAgICAgICAgICAgICAgIGlmIChlLmFuaW1hdGlvbk5hbWUgPT09ICdhdXRvRmlsbFN0YXJ0Jykge1xuICAgICAgICAgICAgICAgICAgICAgICAgdGhpcy5hdXRvRmlsbFN0YXJ0LmVtaXQoKTtcbiAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgICAgICBlbHNlIGlmIChlLmFuaW1hdGlvbk5hbWUgPT09ICdhdXRvRmlsbEVuZCcpIHtcbiAgICAgICAgICAgICAgICAgICAgICAgIHRoaXMuYXV0b0ZpbGxFbmQuZW1pdCgpO1xuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgfSlcbiAgICAgICAgICAgIF07XG4gICAgICAgICAgICBpZiAoaXNEb2N1bWVudEF2YWlsYWJsZSgpICYmIHRoaXMuYXV0b1NpemUpIHtcbiAgICAgICAgICAgICAgICB0aGlzLnJlc2l6ZVN1YnNjcmlwdGlvbiA9IGZyb21FdmVudCh3aW5kb3csICdyZXNpemUnKVxuICAgICAgICAgICAgICAgICAgICAucGlwZSgoZGVib3VuY2VUaW1lKDUwKSkpXG4gICAgICAgICAgICAgICAgICAgIC5zdWJzY3JpYmUoKCkgPT4gdGhpcy5yZXNpemUoKSk7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICB0aGlzLmlucHV0U3Vic2NyaXB0aW9uID0gZnJvbUV2ZW50KGVsZW1lbnQsICdpbnB1dCcpXG4gICAgICAgICAgICAgICAgLnN1YnNjcmliZSh0aGlzLmhhbmRsZUlucHV0LmJpbmQodGhpcykpO1xuICAgICAgICB9KTtcbiAgICAgICAgdGhpcy5jb250cm9sID0gdGhpcy5pbmplY3Rvci5nZXQoTmdDb250cm9sLCBudWxsKTtcbiAgICB9XG4gICAgbmdPbkNoYW5nZXMoY2hhbmdlcykge1xuICAgICAgICBjb25zdCBlbGVtZW50ID0gdGhpcy5lbGVtZW50Lm5hdGl2ZUVsZW1lbnQ7XG4gICAgICAgIGlmIChjaGFuZ2VzLnZhbHVlKSB7XG4gICAgICAgICAgICB0aGlzLmVsZW1lbnRWYWx1ZSA9IHRoaXMudmFsdWU7XG4gICAgICAgIH1cbiAgICAgICAgaWYgKGNoYW5nZXMuYXV0b1NpemUpIHtcbiAgICAgICAgICAgIGlmICh0aGlzLmF1dG9TaXplKSB7XG4gICAgICAgICAgICAgICAgdGhpcy5pbml0aWFsSGVpZ2h0ID0gZWxlbWVudC5vZmZzZXRIZWlnaHQ7XG4gICAgICAgICAgICAgICAgdGhpcy5yZW5kZXJlci5zZXRTdHlsZShlbGVtZW50LCAncmVzaXplJywgJ25vbmUnKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGVsc2Uge1xuICAgICAgICAgICAgICAgIHRoaXMucmVuZGVyZXIuc2V0U3R5bGUoZWxlbWVudCwgJ292ZXJmbG93LXknLCAnYXV0bycpO1xuICAgICAgICAgICAgICAgIHRoaXMucmVuZGVyZXIuc2V0U3R5bGUoZWxlbWVudCwgJ3Jlc2l6ZScsICdib3RoJyk7XG4gICAgICAgICAgICAgICAgZWxlbWVudC5zdHlsZS5oZWlnaHQgPSBgJHt0aGlzLmluaXRpYWxIZWlnaHR9cHhgO1xuICAgICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICAgIHRoaXMucmVzaXplKCk7XG4gICAgfVxuICAgIG5nT25EZXN0cm95KCkge1xuICAgICAgICB0aGlzLmxpc3RlbmVycy5mb3JFYWNoKGxpc3RlbmVyID0+IGxpc3RlbmVyKCkpO1xuICAgICAgICBpZiAodGhpcy5pbnB1dFN1YnNjcmlwdGlvbikge1xuICAgICAgICAgICAgdGhpcy5pbnB1dFN1YnNjcmlwdGlvbi51bnN1YnNjcmliZSgpO1xuICAgICAgICB9XG4gICAgICAgIGlmICh0aGlzLnJlc2l6ZVN1YnNjcmlwdGlvbikge1xuICAgICAgICAgICAgdGhpcy5yZXNpemVTdWJzY3JpcHRpb24udW5zdWJzY3JpYmUoKTtcbiAgICAgICAgfVxuICAgIH1cbiAgICBnZXQgZWxlbWVudFZhbHVlKCkge1xuICAgICAgICBpZiAodGhpcy5lbGVtZW50KSB7XG4gICAgICAgICAgICByZXR1cm4gdGhpcy5lbGVtZW50Lm5hdGl2ZUVsZW1lbnQudmFsdWU7XG4gICAgICAgIH1cbiAgICAgICAgcmV0dXJuICcnO1xuICAgIH1cbiAgICBzZXQgZWxlbWVudFZhbHVlKHZhbHVlKSB7XG4gICAgICAgIHRoaXMuc2V0RWxlbWVudFByb3BlcnR5KCd2YWx1ZScsICh2YWx1ZSA9PT0gdW5kZWZpbmVkIHx8IHZhbHVlID09PSBudWxsKSA/ICcnIDogdmFsdWUpO1xuICAgIH1cbiAgICBzZXRFbGVtZW50UHJvcGVydHkobmFtZSwgdmFsdWUpIHtcbiAgICAgICAgaWYgKHRoaXMuZWxlbWVudCkge1xuICAgICAgICAgICAgdGhpcy5yZW5kZXJlci5zZXRQcm9wZXJ0eSh0aGlzLmVsZW1lbnQubmF0aXZlRWxlbWVudCwgbmFtZSwgdmFsdWUpO1xuICAgICAgICB9XG4gICAgfVxuICAgIHJlc2l6ZSgpIHtcbiAgICAgICAgaWYgKCF0aGlzLmF1dG9TaXplKSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgY29uc3QgZWxlbWVudCA9IHRoaXMuZWxlbWVudC5uYXRpdmVFbGVtZW50O1xuICAgICAgICB0aGlzLnJlbmRlcmVyLnNldFN0eWxlKGVsZW1lbnQsICdvdmVyZmxvdy15JywgJ2hpZGRlbicpO1xuICAgICAgICBlbGVtZW50LnN0eWxlLmhlaWdodCA9IGAke3RoaXMuaW5pdGlhbEhlaWdodH1weGA7XG4gICAgICAgIGNvbnN0IHNjcm9sbEhlaWdodCA9IGVsZW1lbnQuc2Nyb2xsSGVpZ2h0O1xuICAgICAgICBpZiAoc2Nyb2xsSGVpZ2h0ID4gdGhpcy5pbml0aWFsSGVpZ2h0KSB7XG4gICAgICAgICAgICBlbGVtZW50LnN0eWxlLmhlaWdodCA9IGAke3Njcm9sbEhlaWdodH1weGA7XG4gICAgICAgIH1cbiAgICB9XG4gICAgaGFuZGxlSW5wdXQoKSB7XG4gICAgICAgIGNvbnN0IHZhbHVlID0gdGhpcy5lbGVtZW50VmFsdWU7XG4gICAgICAgIHRoaXMudmFsdWUgPSB2YWx1ZTtcbiAgICAgICAgaWYgKHRoaXMuY29udHJvbCB8fCBoYXNPYnNlcnZlcnModGhpcy5vblZhbHVlQ2hhbmdlKSB8fCBoYXNPYnNlcnZlcnModGhpcy52YWx1ZUNoYW5nZSkpIHtcbiAgICAgICAgICAgIHRoaXMuem9uZS5ydW4oKCkgPT4ge1xuICAgICAgICAgICAgICAgIHRoaXMubmdDaGFuZ2UodmFsdWUpO1xuICAgICAgICAgICAgICAgIHRoaXMub25WYWx1ZUNoYW5nZS5lbWl0KHZhbHVlKTtcbiAgICAgICAgICAgICAgICB0aGlzLnZhbHVlQ2hhbmdlLmVtaXQodmFsdWUpO1xuICAgICAgICAgICAgICAgIHRoaXMuY2hhbmdlRGV0ZWN0b3IubWFya0ZvckNoZWNrKCk7XG4gICAgICAgICAgICB9KTtcbiAgICAgICAgfVxuICAgICAgICB0aGlzLnJlc2l6ZSgpO1xuICAgIH1cbiAgICBoYW5kbGVGb2N1cygpIHtcbiAgICAgICAgaWYgKGhhc09ic2VydmVycyh0aGlzLm9uRm9jdXMpKSB7XG4gICAgICAgICAgICB0aGlzLnpvbmUucnVuKCgpID0+IHtcbiAgICAgICAgICAgICAgICB0aGlzLm9uRm9jdXMuZW1pdCgpO1xuICAgICAgICAgICAgfSk7XG4gICAgICAgIH1cbiAgICB9XG4gICAgaGFuZGxlQmx1cigpIHtcbiAgICAgICAgaWYgKGhhc09ic2VydmVycyh0aGlzLm9uQmx1cikgfHwgcmVxdWlyZXNab25lT25CbHVyKHRoaXMuY29udHJvbCkpIHtcbiAgICAgICAgICAgIHRoaXMuem9uZS5ydW4oKCkgPT4ge1xuICAgICAgICAgICAgICAgIHRoaXMubmdUb3VjaGVkKCk7XG4gICAgICAgICAgICAgICAgdGhpcy5vbkJsdXIuZW1pdCgpO1xuICAgICAgICAgICAgICAgIHRoaXMuY2hhbmdlRGV0ZWN0b3IubWFya0ZvckNoZWNrKCk7XG4gICAgICAgICAgICB9KTtcbiAgICAgICAgfVxuICAgIH1cbn1cblRleHRBcmVhRGlyZWN0aXZlLmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBEaXJlY3RpdmUsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgcHJvdmlkZXJzOiBbe1xuICAgICAgICAgICAgICAgICAgICAgICAgcHJvdmlkZTogTkdfVkFMVUVfQUNDRVNTT1IsXG4gICAgICAgICAgICAgICAgICAgICAgICB1c2VFeGlzdGluZzogZm9yd2FyZFJlZigoKSA9PiBUZXh0QXJlYURpcmVjdGl2ZSksXG4gICAgICAgICAgICAgICAgICAgICAgICBtdWx0aTogdHJ1ZVxuICAgICAgICAgICAgICAgICAgICB9LCB7XG4gICAgICAgICAgICAgICAgICAgICAgICBwcm92aWRlOiBLZW5kb0lucHV0LFxuICAgICAgICAgICAgICAgICAgICAgICAgdXNlRXhpc3Rpbmc6IGZvcndhcmRSZWYoKCkgPT4gVGV4dEFyZWFEaXJlY3RpdmUpXG4gICAgICAgICAgICAgICAgICAgIH1dLFxuICAgICAgICAgICAgICAgIHNlbGVjdG9yOiAndGV4dGFyZWFba2VuZG9UZXh0QXJlYV0nXG4gICAgICAgICAgICB9LF0gfSxcbl07XG4vKiogQG5vY29sbGFwc2UgKi9cblRleHRBcmVhRGlyZWN0aXZlLmN0b3JQYXJhbWV0ZXJzID0gKCkgPT4gW1xuICAgIHsgdHlwZTogUmVuZGVyZXIyIH0sXG4gICAgeyB0eXBlOiBFbGVtZW50UmVmIH0sXG4gICAgeyB0eXBlOiBOZ1pvbmUgfSxcbiAgICB7IHR5cGU6IENoYW5nZURldGVjdG9yUmVmIH0sXG4gICAgeyB0eXBlOiBJbmplY3RvciB9LFxuICAgIHsgdHlwZTogQm9vbGVhbiwgZGVjb3JhdG9yczogW3sgdHlwZTogT3B0aW9uYWwgfSwgeyB0eXBlOiBJbmplY3QsIGFyZ3M6IFtSVEwsXSB9XSB9XG5dO1xuVGV4dEFyZWFEaXJlY3RpdmUucHJvcERlY29yYXRvcnMgPSB7XG4gICAgZWxlbWVudENsYXNzOiBbeyB0eXBlOiBIb3N0QmluZGluZywgYXJnczogWydjbGFzcy5rLXRleHRhcmVhJyxdIH1dLFxuICAgIGF1dG9maWxsQ2xhc3M6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstYXV0b2ZpbGwnLF0gfV0sXG4gICAgZGlyZWN0aW9uOiBbeyB0eXBlOiBIb3N0QmluZGluZywgYXJnczogWydhdHRyLmRpcicsXSB9XSxcbiAgICB2YWx1ZUNoYW5nZTogW3sgdHlwZTogT3V0cHV0IH1dLFxuICAgIGF1dG9TaXplOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICB2YWx1ZTogW3sgdHlwZTogSW5wdXQgfV1cbn07XG5cbi8qKlxuICogQGhpZGRlblxuICovXG5jbGFzcyBGbG9hdGluZ0xhYmVsSW5wdXRBZGFwdGVyIHtcbiAgICBjb25zdHJ1Y3Rvcihjb21wb25lbnQsIGZvcm1Db250cm9sKSB7XG4gICAgICAgIHRoaXMuY29tcG9uZW50ID0gY29tcG9uZW50O1xuICAgICAgICBjb25zdCBpc09ic2VydmFibGVPckV2ZW50RW1pdHRlciA9IChldmVudCkgPT4gZXZlbnQgaW5zdGFuY2VvZiBPYnNlcnZhYmxlIHx8IGV2ZW50IGluc3RhbmNlb2YgRXZlbnRFbWl0dGVyO1xuICAgICAgICBpZiAoaXNPYnNlcnZhYmxlT3JFdmVudEVtaXR0ZXIoY29tcG9uZW50Lm9uRm9jdXMpKSB7XG4gICAgICAgICAgICB0aGlzLm9uRm9jdXMgPSBjb21wb25lbnQub25Gb2N1cztcbiAgICAgICAgfVxuICAgICAgICBpZiAoaXNPYnNlcnZhYmxlT3JFdmVudEVtaXR0ZXIoY29tcG9uZW50LmF1dG9GaWxsU3RhcnQpKSB7XG4gICAgICAgICAgICB0aGlzLmF1dG9GaWxsU3RhcnQgPSBjb21wb25lbnQuYXV0b0ZpbGxTdGFydDtcbiAgICAgICAgfVxuICAgICAgICBpZiAoaXNPYnNlcnZhYmxlT3JFdmVudEVtaXR0ZXIoY29tcG9uZW50LmF1dG9GaWxsRW5kKSkge1xuICAgICAgICAgICAgdGhpcy5hdXRvRmlsbEVuZCA9IGNvbXBvbmVudC5hdXRvRmlsbEVuZDtcbiAgICAgICAgfVxuICAgICAgICBpZiAoaXNPYnNlcnZhYmxlT3JFdmVudEVtaXR0ZXIoY29tcG9uZW50Lm9uQmx1cikpIHtcbiAgICAgICAgICAgIHRoaXMub25CbHVyID0gY29tcG9uZW50Lm9uQmx1cjtcbiAgICAgICAgfVxuICAgICAgICBpZiAoZm9ybUNvbnRyb2wpIHtcbiAgICAgICAgICAgIHRoaXMub25WYWx1ZUNoYW5nZSA9IGZvcm1Db250cm9sLnZhbHVlQ2hhbmdlcztcbiAgICAgICAgfVxuICAgICAgICBlbHNlIGlmIChjb21wb25lbnQub25WYWx1ZUNoYW5nZSkge1xuICAgICAgICAgICAgdGhpcy5vblZhbHVlQ2hhbmdlID0gY29tcG9uZW50Lm9uVmFsdWVDaGFuZ2U7XG4gICAgICAgIH1cbiAgICB9XG4gICAgZ2V0IGZvY3VzYWJsZUlkKCkge1xuICAgICAgICBjb25zdCBjb21wb25lbnQgPSB0aGlzLmNvbXBvbmVudDtcbiAgICAgICAgaWYgKCdmb2N1c2FibGVJZCcgaW4gY29tcG9uZW50KSB7XG4gICAgICAgICAgICByZXR1cm4gY29tcG9uZW50LmZvY3VzYWJsZUlkO1xuICAgICAgICB9XG4gICAgICAgIGVsc2UgaWYgKCdpZCcgaW4gY29tcG9uZW50KSB7XG4gICAgICAgICAgICByZXR1cm4gY29tcG9uZW50LmlkO1xuICAgICAgICB9XG4gICAgICAgIHJldHVybiBcIlwiO1xuICAgIH1cbiAgICBzZXQgZm9jdXNhYmxlSWQodmFsdWUpIHtcbiAgICAgICAgY29uc3QgY29tcG9uZW50ID0gdGhpcy5jb21wb25lbnQ7XG4gICAgICAgIGlmICgnZm9jdXNhYmxlSWQnIGluIGNvbXBvbmVudCkge1xuICAgICAgICAgICAgY29tcG9uZW50LmZvY3VzYWJsZUlkID0gdmFsdWU7XG4gICAgICAgIH1cbiAgICAgICAgZWxzZSBpZiAoJ2lkJyBpbiBjb21wb25lbnQpIHtcbiAgICAgICAgICAgIGNvbXBvbmVudC5pZCA9IHZhbHVlO1xuICAgICAgICB9XG4gICAgfVxufVxuXG5jb25zdCBpc0Z1bmN0aW9uID0gKHgpID0+IE9iamVjdC5wcm90b3R5cGUudG9TdHJpbmcuY2FsbCh4KSA9PT0gJ1tvYmplY3QgRnVuY3Rpb25dJztcbi8qKlxuICogQGhpZGRlblxuICovXG5jbGFzcyBUZXh0Qm94Q29udGFpbmVyQ29tcG9uZW50IHtcbiAgICBjb25zdHJ1Y3RvcihlbGVtZW50UmVmLCByZW5kZXJlciwgY2hhbmdlRGV0ZWN0b3JSZWYsIHJ0bCkge1xuICAgICAgICB0aGlzLmVsZW1lbnRSZWYgPSBlbGVtZW50UmVmO1xuICAgICAgICB0aGlzLnJlbmRlcmVyID0gcmVuZGVyZXI7XG4gICAgICAgIHRoaXMuY2hhbmdlRGV0ZWN0b3JSZWYgPSBjaGFuZ2VEZXRlY3RvclJlZjtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuZm9jdXNlZCA9IGZhbHNlO1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5lbXB0eSA9IHRydWU7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmludmFsaWQgPSBmYWxzZTtcbiAgICAgICAgdGhpcy5fc3Vic2NyaXB0aW9ucyA9IFtdO1xuICAgICAgICB0aGlzLmF1dG9GaWxsU3RhcnRlZCA9IGZhbHNlO1xuICAgICAgICB0aGlzLmRpcmVjdGlvbiA9IHJ0bCA/ICdydGwnIDogJ2x0cic7XG4gICAgICAgIHRoaXMucmVuZGVyZXIucmVtb3ZlQXR0cmlidXRlKHRoaXMuZWxlbWVudFJlZi5uYXRpdmVFbGVtZW50LCBcImlkXCIpO1xuICAgIH1cbiAgICBnZXQgaG9zdENsYXNzZXMoKSB7XG4gICAgICAgIHJldHVybiB0cnVlO1xuICAgIH1cbiAgICBnZXQgdGV4dGFyZWFFbGVtZW50Q2xhc3MoKSB7XG4gICAgICAgIHJldHVybiAhIXRoaXMudGV4dGFyZWE7XG4gICAgfVxuICAgIGdldCBmb2N1c2VkQ2xhc3MoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmZvY3VzZWQ7XG4gICAgfVxuICAgIGdldCBpbnZhbGlkQ2xhc3MoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmludmFsaWQ7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBuZ0FmdGVyQ29udGVudEluaXQoKSB7XG4gICAgICAgIGlmICghdGhpcy5mb3JtQ29udHJvbCAmJiAhdGhpcy5rZW5kb0lucHV0KSB7XG4gICAgICAgICAgICBpZiAoaXNEZXZNb2RlKCkpIHtcbiAgICAgICAgICAgICAgICB0aHJvdyBuZXcgRXJyb3IoXCJUaGUgVGV4dEJveENvbnRhaW5lciByZXF1aXJlcyBhIEtlbmRvIElucHV0IGNvbXBvbmVudFwiICtcbiAgICAgICAgICAgICAgICAgICAgXCIgb3IgYSBmb3Jtcy1ib3VuZCBjb21wb25lbnQgdG8gZnVuY3Rpb24gcHJvcGVybHkuXCIpO1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgcmV0dXJuO1xuICAgICAgICB9XG4gICAgICAgIC8vIGFkZCBmb2N1cy9ibHVyL3ZhbHVlQ2hhbmdlIGhhbmRsZXJzXG4gICAgICAgIGNvbnN0IGNvbnRyb2wgPSBuZXcgRmxvYXRpbmdMYWJlbElucHV0QWRhcHRlcih0aGlzLmtlbmRvSW5wdXQgfHwgdGhpcy5mb3JtQ29udHJvbC52YWx1ZUFjY2Vzc29yLCB0aGlzLmZvcm1Db250cm9sKTtcbiAgICAgICAgY29uc3Qgc2V0Rm9jdXMgPSAoaXNGb2N1c2VkKSA9PiAoKSA9PiB7XG4gICAgICAgICAgICB0aGlzLmZvY3VzZWQgPSBpc0ZvY3VzZWQ7XG4gICAgICAgICAgICB0aGlzLnVwZGF0ZVN0YXRlKCk7XG4gICAgICAgIH07XG4gICAgICAgIHRoaXMuc3Vic2NyaWJlKGNvbnRyb2wsICdvbkZvY3VzJywgc2V0Rm9jdXModHJ1ZSkpO1xuICAgICAgICB0aGlzLnN1YnNjcmliZShjb250cm9sLCAnb25CbHVyJywgc2V0Rm9jdXMoZmFsc2UpKTtcbiAgICAgICAgdGhpcy5zdWJzY3JpYmUoY29udHJvbCwgJ2F1dG9GaWxsU3RhcnQnLCAoKSA9PiB7XG4gICAgICAgICAgICB0aGlzLmF1dG9GaWxsU3RhcnRlZCA9IHRydWU7XG4gICAgICAgICAgICB0aGlzLnJlbmRlcmVyLnJlbW92ZUNsYXNzKHRoaXMuZWxlbWVudFJlZi5uYXRpdmVFbGVtZW50LCAnay1zdGF0ZS1lbXB0eScpO1xuICAgICAgICB9KTtcbiAgICAgICAgdGhpcy5zdWJzY3JpYmUoY29udHJvbCwgJ2F1dG9GaWxsRW5kJywgKCkgPT4ge1xuICAgICAgICAgICAgaWYgKHRoaXMuYXV0b0ZpbGxTdGFydGVkKSB7XG4gICAgICAgICAgICAgICAgdGhpcy5hdXRvRmlsbFN0YXJ0ZWQgPSBmYWxzZTtcbiAgICAgICAgICAgICAgICBpZiAodGhpcy5lbXB0eSkge1xuICAgICAgICAgICAgICAgICAgICB0aGlzLnJlbmRlcmVyLmFkZENsYXNzKHRoaXMuZWxlbWVudFJlZi5uYXRpdmVFbGVtZW50LCAnay1zdGF0ZS1lbXB0eScpO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIH1cbiAgICAgICAgfSk7XG4gICAgICAgIGNvbnN0IHVwZGF0ZVN0YXRlID0gKCkgPT4gdGhpcy51cGRhdGVTdGF0ZSgpO1xuICAgICAgICB1cGRhdGVTdGF0ZSgpO1xuICAgICAgICB0aGlzLnN1YnNjcmliZShjb250cm9sLCAnb25WYWx1ZUNoYW5nZScsIHVwZGF0ZVN0YXRlKTtcbiAgICAgICAgLy8gc2V0IGxhYmVsIGlkIGZvciBmbG9hdGluZyBsYWJlbFxuICAgICAgICBpZiAodGhpcy5pZCAmJiBjb250cm9sLmZvY3VzYWJsZUlkKSB7XG4gICAgICAgICAgICAvLyBpbnB1dCB3aW5zXG4gICAgICAgICAgICB0aGlzLmlkID0gY29udHJvbC5mb2N1c2FibGVJZDtcbiAgICAgICAgfVxuICAgICAgICBlbHNlIGlmICh0aGlzLmlkKSB7XG4gICAgICAgICAgICBjb250cm9sLmZvY3VzYWJsZUlkID0gdGhpcy5pZDtcbiAgICAgICAgfVxuICAgICAgICBlbHNlIGlmIChjb250cm9sLmZvY3VzYWJsZUlkKSB7XG4gICAgICAgICAgICB0aGlzLmlkID0gY29udHJvbC5mb2N1c2FibGVJZDtcbiAgICAgICAgfVxuICAgICAgICBlbHNlIHtcbiAgICAgICAgICAgIGNvbnN0IGlkID0gXCJfXCIgKyBndWlkKCk7XG4gICAgICAgICAgICBjb250cm9sLmZvY3VzYWJsZUlkID0gaWQ7XG4gICAgICAgICAgICB0aGlzLmlkID0gaWQ7XG4gICAgICAgIH1cbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIG5nT25EZXN0cm95KCkge1xuICAgICAgICB0aGlzLl9zdWJzY3JpcHRpb25zLmZvckVhY2gocyA9PiBzLnVuc3Vic2NyaWJlKCkpO1xuICAgICAgICB0aGlzLl9zdWJzY3JpcHRpb25zID0gW107XG4gICAgfVxuICAgIHN1YnNjcmliZShjb250cm9sLCBldmVudE5hbWUsIGhhbmRsZXIpIHtcbiAgICAgICAgaWYgKGNvbnRyb2xbZXZlbnROYW1lXSBpbnN0YW5jZW9mIEV2ZW50RW1pdHRlcikge1xuICAgICAgICAgICAgY29uc3Qgc3Vic2NyaXB0aW9uID0gY29udHJvbFtldmVudE5hbWVdLnN1YnNjcmliZShoYW5kbGVyKTtcbiAgICAgICAgICAgIHRoaXMuX3N1YnNjcmlwdGlvbnMucHVzaChzdWJzY3JpcHRpb24pO1xuICAgICAgICB9XG4gICAgfVxuICAgIHVwZGF0ZVN0YXRlKCkge1xuICAgICAgICBjb25zdCBlbXB0eSA9IHZhbHVlID0+IHtcbiAgICAgICAgICAgIC8vIHplcm8gaXMgbm90IGFuIGVtcHR5IHZhbHVlIChlLmcuLCBOdW1lcmljVGV4dEJveClcbiAgICAgICAgICAgIGlmICh2YWx1ZSA9PT0gMCB8fCB2YWx1ZSA9PT0gZmFsc2UpIHtcbiAgICAgICAgICAgICAgICByZXR1cm4gZmFsc2U7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICAvLyBlbXB0eSBhcnJheXMgYXJlIGFuIGVtcHR5IHZhbHVlIChlLmcuLCBNdWx0aVNlbGVjdClcbiAgICAgICAgICAgIGlmIChBcnJheS5pc0FycmF5KHZhbHVlKSAmJiAhdmFsdWUubGVuZ3RoKSB7XG4gICAgICAgICAgICAgICAgcmV0dXJuIHRydWU7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICByZXR1cm4gIXZhbHVlO1xuICAgICAgICB9O1xuICAgICAgICBjb25zdCBmb3JtQ29udHJvbCA9IHRoaXMuZm9ybUNvbnRyb2w7XG4gICAgICAgIGlmIChmb3JtQ29udHJvbCkge1xuICAgICAgICAgICAgY29uc3QgdmFsdWVBY2Nlc3NvciA9IGZvcm1Db250cm9sLnZhbHVlQWNjZXNzb3I7XG4gICAgICAgICAgICBpZiAoaXNGdW5jdGlvbih2YWx1ZUFjY2Vzc29yLmlzRW1wdHkpKSB7XG4gICAgICAgICAgICAgICAgdGhpcy5lbXB0eSA9IHZhbHVlQWNjZXNzb3IuaXNFbXB0eSgpO1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgZWxzZSB7XG4gICAgICAgICAgICAgICAgdGhpcy5lbXB0eSA9IGVtcHR5KGZvcm1Db250cm9sLnZhbHVlKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIHRoaXMuaW52YWxpZCA9IGZvcm1Db250cm9sLmludmFsaWQgJiYgKGZvcm1Db250cm9sLnRvdWNoZWQgfHwgZm9ybUNvbnRyb2wuZGlydHkpO1xuICAgICAgICB9XG4gICAgICAgIGVsc2Uge1xuICAgICAgICAgICAgdGhpcy5lbXB0eSA9IGlzRnVuY3Rpb24odGhpcy5rZW5kb0lucHV0LmlzRW1wdHkpID9cbiAgICAgICAgICAgICAgICB0aGlzLmtlbmRvSW5wdXQuaXNFbXB0eSgpIDogZW1wdHkodGhpcy5rZW5kb0lucHV0LnZhbHVlKTtcbiAgICAgICAgfVxuICAgICAgICBpZiAodGhpcy5lbXB0eSkge1xuICAgICAgICAgICAgdGhpcy5yZW5kZXJlci5hZGRDbGFzcyh0aGlzLmVsZW1lbnRSZWYubmF0aXZlRWxlbWVudCwgJ2stc3RhdGUtZW1wdHknKTtcbiAgICAgICAgfVxuICAgICAgICBlbHNlIHtcbiAgICAgICAgICAgIHRoaXMucmVuZGVyZXIucmVtb3ZlQ2xhc3ModGhpcy5lbGVtZW50UmVmLm5hdGl2ZUVsZW1lbnQsICdrLXN0YXRlLWVtcHR5Jyk7XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5jaGFuZ2VEZXRlY3RvclJlZi5tYXJrRm9yQ2hlY2soKTtcbiAgICB9XG59XG5UZXh0Qm94Q29udGFpbmVyQ29tcG9uZW50LmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBDb21wb25lbnQsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgc2VsZWN0b3I6ICdrZW5kby10ZXh0Ym94LWNvbnRhaW5lcicsXG4gICAgICAgICAgICAgICAgdGVtcGxhdGU6IGBcbiAgICAgICAgPG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PlxuICAgICAgICA8bGFiZWwgKm5nSWY9XCJmbG9hdGluZ0xhYmVsXCIgW2Zvcl09XCJpZFwiIGNsYXNzPVwiay1sYWJlbFwiPnt7IGZsb2F0aW5nTGFiZWwgfX08L2xhYmVsPlxuICAgIGBcbiAgICAgICAgICAgIH0sXSB9LFxuXTtcbi8qKiBAbm9jb2xsYXBzZSAqL1xuVGV4dEJveENvbnRhaW5lckNvbXBvbmVudC5jdG9yUGFyYW1ldGVycyA9ICgpID0+IFtcbiAgICB7IHR5cGU6IEVsZW1lbnRSZWYgfSxcbiAgICB7IHR5cGU6IFJlbmRlcmVyMiB9LFxuICAgIHsgdHlwZTogQ2hhbmdlRGV0ZWN0b3JSZWYgfSxcbiAgICB7IHR5cGU6IEJvb2xlYW4sIGRlY29yYXRvcnM6IFt7IHR5cGU6IE9wdGlvbmFsIH0sIHsgdHlwZTogSW5qZWN0LCBhcmdzOiBbUlRMLF0gfV0gfVxuXTtcblRleHRCb3hDb250YWluZXJDb21wb25lbnQucHJvcERlY29yYXRvcnMgPSB7XG4gICAgaG9zdENsYXNzZXM6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstdGV4dGJveC1jb250YWluZXInLF0gfV0sXG4gICAgdGV4dGFyZWFFbGVtZW50Q2xhc3M6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstdGV4dGFyZWEtd3JhcHBlcicsXSB9XSxcbiAgICBmb2N1c2VkQ2xhc3M6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstc3RhdGUtZm9jdXNlZCcsXSB9XSxcbiAgICBpbnZhbGlkQ2xhc3M6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstc3RhdGUtaW52YWxpZCcsXSB9XSxcbiAgICBkaXJlY3Rpb246IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2F0dHIuZGlyJyxdIH1dLFxuICAgIGlkOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBmbG9hdGluZ0xhYmVsOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBrZW5kb0lucHV0OiBbeyB0eXBlOiBDb250ZW50Q2hpbGQsIGFyZ3M6IFtLZW5kb0lucHV0LF0gfV0sXG4gICAgdGV4dGFyZWE6IFt7IHR5cGU6IENvbnRlbnRDaGlsZCwgYXJnczogW1RleHRBcmVhRGlyZWN0aXZlLF0gfV0sXG4gICAgZm9ybUNvbnRyb2w6IFt7IHR5cGU6IENvbnRlbnRDaGlsZCwgYXJnczogW05nQ29udHJvbCxdIH1dXG59O1xuXG4vKipcbiAqIFJlcHJlc2VudHMgdGhlIFtLZW5kbyBVSSBUZXh0Qm94IGRpcmVjdGl2ZV0oeyUgc2x1ZyBvdmVydmlld190ZXh0Ym94ICV9KSBmb3IgdGhlIElucHV0cyBjb21wb25lbnRzIGZvciBBbmd1bGFyLlxuICogVXNlZCB0byBzdHlsZSB0aGUgdGV4dGJveCBvZiBhbnkgYGlucHV0YCBlbGVtZW50LlxuICpcbiAqIEBleGFtcGxlXG4gKiBgYGB0cy1uby1ydW5cbiAqIDxpbnB1dCBrZW5kb1RleHRCb3ggLz5cbiAqIDxpbnB1dCBrZW5kb1RleHRCb3ggdHlwZT1cImVtYWlsXCIgLz5cbiAqIDxpbnB1dCBrZW5kb1RleHRCb3ggdHlwZT1cInBhc3N3b3JkXCIgLz5cbiAqIGBgYFxuICovXG5jbGFzcyBUZXh0Qm94RGlyZWN0aXZlIHtcbiAgICBjb25zdHJ1Y3RvcihyZW5kZXJlciwgaW5wdXRFbGVtZW50LCBuZ1pvbmUpIHtcbiAgICAgICAgdGhpcy5yZW5kZXJlciA9IHJlbmRlcmVyO1xuICAgICAgICB0aGlzLmlucHV0RWxlbWVudCA9IGlucHV0RWxlbWVudDtcbiAgICAgICAgdGhpcy5uZ1pvbmUgPSBuZ1pvbmU7XG4gICAgICAgIHRoaXMuaG9zdENsYXNzID0gdHJ1ZTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMub25Gb2N1cyA9IG5ldyBFdmVudEVtaXR0ZXIoKTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMub25CbHVyID0gbmV3IEV2ZW50RW1pdHRlcigpO1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5vblZhbHVlQ2hhbmdlID0gbmV3IEV2ZW50RW1pdHRlcigpO1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5hdXRvRmlsbFN0YXJ0ID0gbmV3IEV2ZW50RW1pdHRlcigpO1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5hdXRvRmlsbEVuZCA9IG5ldyBFdmVudEVtaXR0ZXIoKTtcbiAgICAgICAgdGhpcy5saXN0ZW5lcnMgPSBbXTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHNldCB2YWx1ZSh0ZXh0KSB7XG4gICAgICAgIGlmICghdGhpcy5pbnB1dEVsZW1lbnQpIHtcbiAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgfVxuICAgICAgICB0aGlzLmlucHV0RWxlbWVudC5uYXRpdmVFbGVtZW50LnZhbHVlID0gKHRleHQgPT09IHVuZGVmaW5lZCB8fCB0ZXh0ID09PSBudWxsKSA/ICcnIDogdGV4dDtcbiAgICAgICAgdGhpcy5vblZhbHVlQ2hhbmdlLmVtaXQoKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIGdldCB2YWx1ZSgpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuaW5wdXRFbGVtZW50Lm5hdGl2ZUVsZW1lbnQudmFsdWU7XG4gICAgfVxuICAgIGdldCBpZCgpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuaW5wdXRFbGVtZW50Lm5hdGl2ZUVsZW1lbnQuaWQ7XG4gICAgfVxuICAgIHNldCBpZChpZCkge1xuICAgICAgICB0aGlzLnJlbmRlcmVyLnNldEF0dHJpYnV0ZSh0aGlzLmlucHV0RWxlbWVudC5uYXRpdmVFbGVtZW50LCAnaWQnLCBpZCk7XG4gICAgfVxuICAgIG5nQWZ0ZXJWaWV3SW5pdCgpIHtcbiAgICAgICAgY29uc3QgaW5wdXQgPSB0aGlzLmlucHV0RWxlbWVudC5uYXRpdmVFbGVtZW50O1xuICAgICAgICB0aGlzLmxpc3RlbmVycyA9IFtcbiAgICAgICAgICAgIHRoaXMucmVuZGVyZXIubGlzdGVuKGlucHV0LCAnZm9jdXMnLCAoKSA9PiB0aGlzLm9uRm9jdXMuZW1pdCgpKSxcbiAgICAgICAgICAgIHRoaXMucmVuZGVyZXIubGlzdGVuKGlucHV0LCAnYmx1cicsICgpID0+IHRoaXMub25CbHVyLmVtaXQoKSlcbiAgICAgICAgXTtcbiAgICAgICAgdGhpcy5uZ1pvbmUucnVuT3V0c2lkZUFuZ3VsYXIoKCkgPT4ge1xuICAgICAgICAgICAgdGhpcy5yZW5kZXJlci5saXN0ZW4oaW5wdXQsICdhbmltYXRpb25zdGFydCcsIChlKSA9PiB7XG4gICAgICAgICAgICAgICAgaWYgKGUuYW5pbWF0aW9uTmFtZSA9PT0gJ2F1dG9GaWxsU3RhcnQnKSB7XG4gICAgICAgICAgICAgICAgICAgIHRoaXMuYXV0b0ZpbGxTdGFydC5lbWl0KCk7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIGVsc2UgaWYgKGUuYW5pbWF0aW9uTmFtZSA9PT0gJ2F1dG9GaWxsRW5kJykge1xuICAgICAgICAgICAgICAgICAgICB0aGlzLmF1dG9GaWxsRW5kLmVtaXQoKTtcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICB9KTtcbiAgICAgICAgfSk7XG4gICAgfVxuICAgIG5nT25EZXN0cm95KCkge1xuICAgICAgICB0aGlzLmxpc3RlbmVycy5mb3JFYWNoKGxpc3RlbmVyID0+IGxpc3RlbmVyKCkpO1xuICAgIH1cbn1cblRleHRCb3hEaXJlY3RpdmUuZGVjb3JhdG9ycyA9IFtcbiAgICB7IHR5cGU6IERpcmVjdGl2ZSwgYXJnczogW3tcbiAgICAgICAgICAgICAgICBzZWxlY3RvcjogJ2lucHV0W2tlbmRvVGV4dEJveF0nLFxuICAgICAgICAgICAgICAgIHByb3ZpZGVyczogW3tcbiAgICAgICAgICAgICAgICAgICAgICAgIHByb3ZpZGU6IEtlbmRvSW5wdXQsXG4gICAgICAgICAgICAgICAgICAgICAgICB1c2VFeGlzdGluZzogZm9yd2FyZFJlZigoKSA9PiBUZXh0Qm94RGlyZWN0aXZlKVxuICAgICAgICAgICAgICAgICAgICB9XVxuICAgICAgICAgICAgfSxdIH0sXG5dO1xuLyoqIEBub2NvbGxhcHNlICovXG5UZXh0Qm94RGlyZWN0aXZlLmN0b3JQYXJhbWV0ZXJzID0gKCkgPT4gW1xuICAgIHsgdHlwZTogUmVuZGVyZXIyIH0sXG4gICAgeyB0eXBlOiBFbGVtZW50UmVmIH0sXG4gICAgeyB0eXBlOiBOZ1pvbmUgfVxuXTtcblRleHRCb3hEaXJlY3RpdmUucHJvcERlY29yYXRvcnMgPSB7XG4gICAgaG9zdENsYXNzOiBbeyB0eXBlOiBIb3N0QmluZGluZywgYXJnczogWydjbGFzcy5rLXRleHRib3gnLF0gfV0sXG4gICAgdmFsdWU6IFt7IHR5cGU6IElucHV0IH1dXG59O1xuXG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgY3JlYXRlTWF4VmFsaWRhdG9yID0gKG1heFZhbHVlKSA9PiB7XG4gICAgcmV0dXJuIChjKSA9PiB7XG4gICAgICAgIGlmICghaXNQcmVzZW50KG1heFZhbHVlKSB8fCAhaXNQcmVzZW50KGMudmFsdWUpIHx8IGMudmFsdWUgPD0gbWF4VmFsdWUpIHtcbiAgICAgICAgICAgIHJldHVybiBudWxsO1xuICAgICAgICB9XG4gICAgICAgIHJldHVybiB7XG4gICAgICAgICAgICBtYXhFcnJvcjoge1xuICAgICAgICAgICAgICAgIG1heFZhbHVlOiBtYXhWYWx1ZSxcbiAgICAgICAgICAgICAgICB2YWx1ZTogYy52YWx1ZVxuICAgICAgICAgICAgfVxuICAgICAgICB9O1xuICAgIH07XG59O1xuXG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgY3JlYXRlTWluVmFsaWRhdG9yID0gKG1pblZhbHVlKSA9PiB7XG4gICAgcmV0dXJuIChjKSA9PiB7XG4gICAgICAgIGlmICghaXNQcmVzZW50KG1pblZhbHVlKSB8fCAhaXNQcmVzZW50KGMudmFsdWUpIHx8IGMudmFsdWUgPj0gbWluVmFsdWUpIHtcbiAgICAgICAgICAgIHJldHVybiBudWxsO1xuICAgICAgICB9XG4gICAgICAgIHJldHVybiB7XG4gICAgICAgICAgICBtaW5FcnJvcjoge1xuICAgICAgICAgICAgICAgIG1pblZhbHVlOiBtaW5WYWx1ZSxcbiAgICAgICAgICAgICAgICB2YWx1ZTogYy52YWx1ZVxuICAgICAgICAgICAgfVxuICAgICAgICB9O1xuICAgIH07XG59O1xuXG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgTUlOX0RPQ19MSU5LID0gJ2h0dHA6Ly93d3cudGVsZXJpay5jb20va2VuZG8tYW5ndWxhci11aS9jb21wb25lbnRzL2lucHV0cy9hcGkvTnVtZXJpY1RleHRCb3hDb21wb25lbnQvI3RvYy1taW4nO1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IE1BWF9ET0NfTElOSyA9ICdodHRwOi8vd3d3LnRlbGVyaWsuY29tL2tlbmRvLWFuZ3VsYXItdWkvY29tcG9uZW50cy9pbnB1dHMvYXBpL051bWVyaWNUZXh0Qm94Q29tcG9uZW50LyN0b2MtbWF4Jztcbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCBQT0lOVCA9IFwiLlwiO1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IElOSVRJQUxfU1BJTl9ERUxBWSA9IDUwMDtcbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCBTUElOX0RFTEFZID0gNTA7XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgRVhQT05FTlRfUkVHRVggPSAvW2VFXVtcXC0rXT8oWzAtOV0rKS87XG5cbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCBudW1lcmljUmVnZXggPSAob3B0aW9ucykgPT4ge1xuICAgIGNvbnN0IHsgYXV0b0NvcnJlY3QsIGRlY2ltYWxzLCBtaW4gfSA9IG9wdGlvbnM7XG4gICAgbGV0IHNlcGFyYXRvciA9IG9wdGlvbnMuc2VwYXJhdG9yO1xuICAgIGlmIChzZXBhcmF0b3IgPT09IFBPSU5UKSB7XG4gICAgICAgIHNlcGFyYXRvciA9ICdcXFxcJyArIHNlcGFyYXRvcjtcbiAgICB9XG4gICAgY29uc3Qgc2lnblBhdHRlcm4gPSBhdXRvQ29ycmVjdCAmJiBtaW4gIT09IG51bGwgJiYgbWluID49IDAgPyAnJyA6ICctPyc7XG4gICAgbGV0IG51bWJlclBhdHRlcm47XG4gICAgaWYgKGRlY2ltYWxzID09PSAwKSB7XG4gICAgICAgIG51bWJlclBhdHRlcm4gPSAnXFxcXGQqJztcbiAgICB9XG4gICAgZWxzZSB7XG4gICAgICAgIG51bWJlclBhdHRlcm4gPSBgKD86KD86XFxcXGQrKCR7c2VwYXJhdG9yfVxcXFxkKik/KXwoPzoke3NlcGFyYXRvcn1cXFxcZCopKT9gO1xuICAgIH1cbiAgICByZXR1cm4gbmV3IFJlZ0V4cChgXiR7c2lnblBhdHRlcm59JHtudW1iZXJQYXR0ZXJufSRgKTtcbn07XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgZGVjaW1hbFBhcnQgPSAodmFsdWUpID0+IHtcbiAgICByZXR1cm4gdmFsdWUgPj0gMCA/IE1hdGguZmxvb3IodmFsdWUpIDogTWF0aC5jZWlsKHZhbHVlKTtcbn07XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3Qgbm9vcCA9IChfKSA9PiB7IH07IC8vIHRzbGludDpkaXNhYmxlLWxpbmU6bm8tZW1wdHlcbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCBkZWZpbmVkID0gKHZhbHVlKSA9PiB7XG4gICAgcmV0dXJuIHR5cGVvZiB2YWx1ZSAhPT0gJ3VuZGVmaW5lZCc7XG59O1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IGlzTnVtYmVyID0gKHZhbHVlKSA9PiB7XG4gICAgcmV0dXJuICFpc05hTih2YWx1ZSkgJiYgdmFsdWUgIT09IG51bGw7XG59O1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmZ1bmN0aW9uIHBhZCh2YWx1ZSwgZGlnaXRzKSB7XG4gICAgY29uc3QgY291bnQgPSBkaWdpdHMgLSBTdHJpbmcodmFsdWUpLmxlbmd0aDtcbiAgICBsZXQgcmVzdWx0ID0gdmFsdWU7XG4gICAgaWYgKGNvdW50ID4gMCkge1xuICAgICAgICBjb25zdCBwYWRTdHJpbmcgPSBuZXcgQXJyYXkoY291bnQgKyAxKS5qb2luKFwiMFwiKTtcbiAgICAgICAgcmVzdWx0ID0gcGFyc2VGbG9hdCh2YWx1ZSArIHBhZFN0cmluZyk7XG4gICAgfVxuICAgIHJldHVybiByZXN1bHQ7XG59XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgZ2V0RGVsdGFGcm9tTW91c2VXaGVlbCA9IChlKSA9PiB7XG4gICAgbGV0IGRlbHRhID0gMDtcbiAgICBpZiAoZS53aGVlbERlbHRhKSB7XG4gICAgICAgIGRlbHRhID0gZS53aGVlbERlbHRhIC8gMTIwO1xuICAgICAgICBkZWx0YSA9IGRlbHRhID4gMCA/IE1hdGguY2VpbChkZWx0YSkgOiBNYXRoLmZsb29yKGRlbHRhKTtcbiAgICB9XG4gICAgZWxzZSBpZiAoZS5kZXRhaWwpIHtcbiAgICAgICAgZGVsdGEgPSBNYXRoLnJvdW5kKC1lLmRldGFpbCAvIDMpO1xuICAgIH1cbiAgICByZXR1cm4gZGVsdGE7XG59O1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IGdldENhcmV0UG9zaXRpb24gPSAoZWxlbWVudCkgPT4gZWxlbWVudC5zZWxlY3Rpb25TdGFydDtcbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCBleHRyYWN0U2lnbmlmaWNhbnROdW1lcmljQ2hhcnMgPSAoZm9ybWF0dGVkU3RyaW5nLCBzZXBhcmF0b3IpID0+IHtcbiAgICBjb25zdCBzaWduaWZpY2FudENoYXJhY3RlcnMgPSBgJHtzZXBhcmF0b3J9MDEyMzQ1Njc4OS1gO1xuICAgIHJldHVybiBmb3JtYXR0ZWRTdHJpbmcuc3BsaXQoJycpLnJlZHVjZSgoYWNjLCBjdXJyKSA9PiBzaWduaWZpY2FudENoYXJhY3RlcnMuaW5jbHVkZXMoY3VycikgPyArK2FjYyA6IGFjYywgMCk7XG59O1xuXG4vKipcbiAqIEBoaWRkZW5cbiAqL1xudmFyIEFycm93RGlyZWN0aW9uO1xuKGZ1bmN0aW9uIChBcnJvd0RpcmVjdGlvbikge1xuICAgIEFycm93RGlyZWN0aW9uW0Fycm93RGlyZWN0aW9uW1wiRG93blwiXSA9IC0xXSA9IFwiRG93blwiO1xuICAgIEFycm93RGlyZWN0aW9uW0Fycm93RGlyZWN0aW9uW1wiTm9uZVwiXSA9IDBdID0gXCJOb25lXCI7XG4gICAgQXJyb3dEaXJlY3Rpb25bQXJyb3dEaXJlY3Rpb25bXCJVcFwiXSA9IDFdID0gXCJVcFwiO1xufSkoQXJyb3dEaXJlY3Rpb24gfHwgKEFycm93RGlyZWN0aW9uID0ge30pKTtcblxuY29uc3QgUEFSU0FCTEVfT1BUSU9OUyA9IFsnbWluJywgJ21heCcsICdzdGVwJywgJ2RlY2ltYWxzJ107XG5jb25zdCBQQVJTQUJMRV9ERUZBVUxUUyA9IHtcbiAgICBkZWNpbWFsczogbnVsbCxcbiAgICBtYXg6IG51bGwsXG4gICAgbWluOiBudWxsLFxuICAgIHN0ZXA6IDFcbn07XG5jb25zdCBGT0NVU0VEJDIgPSAnay1zdGF0ZS1mb2N1c2VkJztcbmNvbnN0IEZPUk1BVFRFRF9WQUxVRSA9ICdrLWZvcm1hdHRlZC12YWx1ZSc7XG4vKipcbiAqIFJlcHJlc2VudHMgdGhlIFtLZW5kbyBVSSBOdW1lcmljVGV4dEJveCBjb21wb25lbnQgZm9yIEFuZ3VsYXJdKHslIHNsdWcgb3ZlcnZpZXdfbnVtZXJpY3RleHRib3ggJX0pLlxuICovXG5jbGFzcyBOdW1lcmljVGV4dEJveENvbXBvbmVudCB7XG4gICAgY29uc3RydWN0b3IoaW50bCwgcmVuZGVyZXIsIGxvY2FsaXphdGlvblNlcnZpY2UsIGluamVjdG9yLCBuZ1pvbmUsIGNoYW5nZURldGVjdG9yLCBob3N0RWxlbWVudCkge1xuICAgICAgICB0aGlzLmludGwgPSBpbnRsO1xuICAgICAgICB0aGlzLnJlbmRlcmVyID0gcmVuZGVyZXI7XG4gICAgICAgIHRoaXMubG9jYWxpemF0aW9uU2VydmljZSA9IGxvY2FsaXphdGlvblNlcnZpY2U7XG4gICAgICAgIHRoaXMuaW5qZWN0b3IgPSBpbmplY3RvcjtcbiAgICAgICAgdGhpcy5uZ1pvbmUgPSBuZ1pvbmU7XG4gICAgICAgIHRoaXMuY2hhbmdlRGV0ZWN0b3IgPSBjaGFuZ2VEZXRlY3RvcjtcbiAgICAgICAgdGhpcy5ob3N0RWxlbWVudCA9IGhvc3RFbGVtZW50O1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5mb2N1c2FibGVJZCA9IGBrLSR7Z3VpZCgpfWA7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBEZXRlcm1pbmVzIHdoZXRoZXIgdGhlIE51bWVyaWNUZXh0Qm94IGlzIGRpc2FibGVkIChbc2VlIGV4YW1wbGVdKHslIHNsdWcgZGlzYWJsZWRfbnVtZXJpY3RleHRib3ggJX0pKS5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuZGlzYWJsZWQgPSBmYWxzZTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIERldGVybWluZXMgd2hldGhlciB0aGUgTnVtZXJpY1RleHRCb3ggaXMgaW4gaXRzIHJlYWQtb25seSBzdGF0ZSAoW3NlZSBleGFtcGxlXSh7JSBzbHVnIHJlYWRvbmx5X251bWVyaWN0ZXh0Ym94ICV9KSkuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLnJlYWRvbmx5ID0gZmFsc2U7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBTZXRzIHRoZSB0aXRsZSBvZiB0aGUgYGlucHV0YCBlbGVtZW50IG9mIHRoZSBOdW1lcmljVGV4dEJveC5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMudGl0bGUgPSAnJztcbiAgICAgICAgLyoqXG4gICAgICAgICAqIFNwZWNpZmllcyB3aGV0aGVyIHRoZSB2YWx1ZSB3aWxsIGJlIGF1dG8tY29ycmVjdGVkIGJhc2VkIG9uIHRoZSBtaW5pbXVtIGFuZCBtYXhpbXVtIHZhbHVlc1xuICAgICAgICAgKiAoW3NlZSBleGFtcGxlXSh7JSBzbHVnIHByZWNpc2lvbl9udW1lcmljdGV4dGJveCAlfSkpLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5hdXRvQ29ycmVjdCA9IGZhbHNlO1xuICAgICAgICAvKipcbiAgICAgICAgICogU3BlY2lmaWVzIHRoZSBudW1iZXIgb2YgZGVjaW1hbHMgdGhhdCB0aGUgdXNlciBjYW4gZW50ZXIgd2hlbiB0aGUgaW5wdXQgaXMgZm9jdXNlZFxuICAgICAgICAgKiAoW3NlZSBleGFtcGxlXSh7JSBzbHVnIHByZWNpc2lvbl9udW1lcmljdGV4dGJveCAlfSkpLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5kZWNpbWFscyA9IG51bGw7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBTcGVjaWZpZXMgdGhlIHZhbHVlIHRoYXQgaXMgdXNlZCB0byBpbmNyZW1lbnQgb3IgZGVjcmVtZW50IHRoZSBjb21wb25lbnQgdmFsdWVcbiAgICAgICAgICogKFtzZWUgZXhhbXBsZV0oeyUgc2x1ZyBwcmVkZWZpbmVkc3RlcHNfbnVtZXJpY3RleHRib3ggJX0pKS5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuc3RlcCA9IDE7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBTcGVjaWZpZXMgd2hldGhlciB0aGUgKipVcCoqIGFuZCAqKkRvd24qKiBzcGluIGJ1dHRvbnMgd2lsbCBiZSByZW5kZXJlZFxuICAgICAgICAgKiAoW3NlZSBleGFtcGxlXSh7JSBzbHVnIHNwaW5idXR0b25zX251bWVyaWN0ZXh0Ym94ICV9KSkuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLnNwaW5uZXJzID0gdHJ1ZTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIERldGVybWluZXMgd2hldGhlciB0aGUgYnVpbHQtaW4gbWluaW11bSBvciBtYXhpbXVtIHZhbGlkYXRvcnMgYXJlIGVuZm9yY2VkIHdoZW4gYSBmb3JtIGlzIHZhbGlkYXRlZC5cbiAgICAgICAgICpcbiAgICAgICAgICogPiBUaGUgNC4yLjAgQW5ndWxhciB2ZXJzaW9uIGludHJvZHVjZXMgdGhlIGBtaW5gIGFuZCBgbWF4YCB2YWxpZGF0aW9uIGRpcmVjdGl2ZXMuIEFzIGEgcmVzdWx0LCBldmVuIGlmIHlvdSBzZXQgYHJhbmdlVmFsaWRhdGlvbmBcbiAgICAgICAgICogdG8gYGZhbHNlYCwgdGhlIGJ1aWx0LWluIEFuZ3VsYXIgdmFsaWRhdG9ycyB3aWxsIGJlIGV4ZWN1dGVkLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5yYW5nZVZhbGlkYXRpb24gPSB0cnVlO1xuICAgICAgICAvKipcbiAgICAgICAgICogU3BlY2lmaWVzIHRoZSBbYHRhYmluZGV4YF0oaHR0cHM6Ly9kZXZlbG9wZXIubW96aWxsYS5vcmcvZW4tVVMvZG9jcy9XZWIvSFRNTC9HbG9iYWxfYXR0cmlidXRlcy90YWJpbmRleCkgb2YgdGhlIGNvbXBvbmVudC5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMudGFiaW5kZXggPSAwO1xuICAgICAgICAvKipcbiAgICAgICAgICogRGV0ZXJtaW5lcyB3aGV0aGVyIHRoZSB3aG9sZSB2YWx1ZSB3aWxsIGJlIHNlbGVjdGVkIHdoZW4gdGhlIE51bWVyaWNUZXh0Qm94IGlzIGNsaWNrZWQuIERlZmF1bHRzIHRvIGB0cnVlYC5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuc2VsZWN0T25Gb2N1cyA9IHRydWU7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBTcGVjaWZpZXMgdGhlIHZhbHVlIG9mIHRoZSBOdW1lcmljVGV4dEJveFxuICAgICAgICAgKiAoW3NlZSBleGFtcGxlXSh7JSBzbHVnIGZvcm1hdHNfbnVtZXJpY3RleHRib3ggJX0pKS5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMudmFsdWUgPSBudWxsO1xuICAgICAgICAvKipcbiAgICAgICAgICogRmlyZXMgZWFjaCB0aW1lIHRoZSB1c2VyIHNlbGVjdHMgYSBuZXcgdmFsdWUgKFtzZWUgZXhhbXBsZV0oeyUgc2x1ZyBvdmVydmlld19udW1lcmljdGV4dGJveCAlfSN0b2MtZXZlbnRzKSkuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLnZhbHVlQ2hhbmdlID0gbmV3IEV2ZW50RW1pdHRlcigpO1xuICAgICAgICAvKipcbiAgICAgICAgICogRmlyZXMgZWFjaCB0aW1lIHRoZSB1c2VyIGZvY3VzZXMgdGhlIGBpbnB1dGAgZWxlbWVudCAoW3NlZSBleGFtcGxlXSh7JSBzbHVnIG92ZXJ2aWV3X251bWVyaWN0ZXh0Ym94ICV9I3RvYy1ldmVudHMpKS5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMub25Gb2N1cyA9IG5ldyBFdmVudEVtaXR0ZXIoKTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEZpcmVzIGVhY2ggdGltZSB0aGUgYGlucHV0YCBlbGVtZW50IGdldHMgYmx1cnJlZCAoW3NlZSBleGFtcGxlXSh7JSBzbHVnIG92ZXJ2aWV3X251bWVyaWN0ZXh0Ym94ICV9I3RvYy1ldmVudHMpKS5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMub25CbHVyID0gbmV3IEV2ZW50RW1pdHRlcigpO1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5BcnJvd0RpcmVjdGlvbiA9IEFycm93RGlyZWN0aW9uO1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5hcnJvd0RpcmVjdGlvbiA9IEFycm93RGlyZWN0aW9uLk5vbmU7XG4gICAgICAgIHRoaXMuaW5wdXRWYWx1ZSA9ICcnO1xuICAgICAgICB0aGlzLm1pblZhbGlkYXRlRm4gPSBub29wO1xuICAgICAgICB0aGlzLm1heFZhbGlkYXRlRm4gPSBub29wO1xuICAgICAgICB0aGlzLl9mb3JtYXQgPSBcIm4yXCI7XG4gICAgICAgIHRoaXMuaXNQYXN0ZWQgPSBmYWxzZTtcbiAgICAgICAgdGhpcy5tb3VzZURvd24gPSBmYWxzZTtcbiAgICAgICAgdGhpcy5uZ0NoYW5nZSA9IG5vb3A7XG4gICAgICAgIHRoaXMubmdUb3VjaGVkID0gbm9vcDtcbiAgICAgICAgdGhpcy5uZ1ZhbGlkYXRvckNoYW5nZSA9IG5vb3A7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmluY3JlYXNlUHJlc3MgPSAoZSkgPT4ge1xuICAgICAgICAgICAgdGhpcy5hcnJvd1ByZXNzKEFycm93RGlyZWN0aW9uLlVwLCBlKTtcbiAgICAgICAgfTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuZGVjcmVhc2VQcmVzcyA9IChlKSA9PiB7XG4gICAgICAgICAgICB0aGlzLmFycm93UHJlc3MoQXJyb3dEaXJlY3Rpb24uRG93biwgZSk7XG4gICAgICAgIH07XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLnJlbGVhc2VBcnJvdyA9ICgpID0+IHtcbiAgICAgICAgICAgIGNsZWFyVGltZW91dCh0aGlzLnNwaW5UaW1lb3V0KTtcbiAgICAgICAgICAgIGlmICh0aGlzLmFycm93RGlyZWN0aW9uICE9PSBBcnJvd0RpcmVjdGlvbi5Ob25lKSB7XG4gICAgICAgICAgICAgICAgdGhpcy5hcnJvd0RpcmVjdGlvbiA9IEFycm93RGlyZWN0aW9uLk5vbmU7XG4gICAgICAgICAgICAgICAgdGhpcy5jaGFuZ2VEZXRlY3Rvci5kZXRlY3RDaGFuZ2VzKCk7XG4gICAgICAgICAgICB9XG4gICAgICAgIH07XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmhhbmRsZVBhc3RlID0gKCkgPT4ge1xuICAgICAgICAgICAgdGhpcy5pc1Bhc3RlZCA9IHRydWU7XG4gICAgICAgIH07XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmhhbmRsZUlucHV0ID0gKCkgPT4ge1xuICAgICAgICAgICAgY29uc3QgaW5wdXQgPSB0aGlzLm51bWVyaWNJbnB1dC5uYXRpdmVFbGVtZW50O1xuICAgICAgICAgICAgbGV0IHsgc2VsZWN0aW9uU3RhcnQsIHNlbGVjdGlvbkVuZCwgdmFsdWU6IGlucHV0VmFsdWUgfSA9IGlucHV0O1xuICAgICAgICAgICAgaWYgKHRoaXMucHJlc3NlZEtleSA9PT0gS2V5cy5OdW1wYWREZWNpbWFsKSB7XG4gICAgICAgICAgICAgICAgaW5wdXRWYWx1ZSA9IHRoaXMucmVwbGFjZU51bXBhZERvdFZhbHVlKCk7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICBpZiAodGhpcy5pc1Bhc3RlZCkge1xuICAgICAgICAgICAgICAgIGlucHV0VmFsdWUgPSB0aGlzLmZvcm1hdElucHV0VmFsdWUodGhpcy5pbnRsLnBhcnNlTnVtYmVyKGlucHV0VmFsdWUpKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGlmICghdGhpcy5pc1ZhbGlkKGlucHV0VmFsdWUpKSB7XG4gICAgICAgICAgICAgICAgaW5wdXQudmFsdWUgPSB0aGlzLmlucHV0VmFsdWU7XG4gICAgICAgICAgICAgICAgdGhpcy5zZXRTZWxlY3Rpb24oc2VsZWN0aW9uU3RhcnQgLSAxLCBzZWxlY3Rpb25FbmQgLSAxKTtcbiAgICAgICAgICAgICAgICByZXR1cm47XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICBjb25zdCBwYXJzZWRWYWx1ZSA9IHRoaXMuaW50bC5wYXJzZU51bWJlcihpbnB1dFZhbHVlKTtcbiAgICAgICAgICAgIGxldCB2YWx1ZSA9IHRoaXMucmVzdHJpY3REZWNpbWFscyhwYXJzZWRWYWx1ZSk7XG4gICAgICAgICAgICBpZiAodGhpcy5hdXRvQ29ycmVjdCkge1xuICAgICAgICAgICAgICAgIGNvbnN0IGxpbWl0ZWQgPSB0aGlzLmxpbWl0SW5wdXRWYWx1ZSh2YWx1ZSk7XG4gICAgICAgICAgICAgICAgdmFsdWUgPSBsaW1pdGVkLnZhbHVlO1xuICAgICAgICAgICAgICAgIHNlbGVjdGlvblN0YXJ0ID0gbGltaXRlZC5zZWxlY3Rpb25TdGFydDtcbiAgICAgICAgICAgICAgICBzZWxlY3Rpb25FbmQgPSBsaW1pdGVkLnNlbGVjdGlvbkVuZDtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGlmIChwYXJzZWRWYWx1ZSAhPT0gdmFsdWUgfHwgdGhpcy5oYXNUcmFpbGluZ1plcm9zKGlucHV0VmFsdWUpIHx8ICF0aGlzLmZvY3VzZWQpIHtcbiAgICAgICAgICAgICAgICB0aGlzLnNldElucHV0VmFsdWUodmFsdWUpO1xuICAgICAgICAgICAgICAgIHRoaXMuc2V0U2VsZWN0aW9uKHNlbGVjdGlvblN0YXJ0LCBzZWxlY3Rpb25FbmQpO1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgZWxzZSB7XG4gICAgICAgICAgICAgICAgdGhpcy5pbnB1dFZhbHVlID0gaW5wdXRWYWx1ZTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGlmICh0aGlzLmlzUGFzdGVkKSB7XG4gICAgICAgICAgICAgICAgaW5wdXQudmFsdWUgPSB0aGlzLmlucHV0VmFsdWU7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICB0aGlzLnVwZGF0ZVZhbHVlKHZhbHVlKTtcbiAgICAgICAgICAgIHRoaXMucHJldmlvdXNTZWxlY3Rpb24gPSBudWxsO1xuICAgICAgICAgICAgdGhpcy5pc1Bhc3RlZCA9IGZhbHNlO1xuICAgICAgICB9O1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5oYW5kbGVEcmFnRW50ZXIgPSAoKSA9PiB7XG4gICAgICAgICAgICBpZiAoIXRoaXMuZm9jdXNlZCAmJiAhdGhpcy5pc0Rpc2FibGVkKSB7XG4gICAgICAgICAgICAgICAgdGhpcy5zZXRJbnB1dFZhbHVlKHRoaXMudmFsdWUsIHRydWUpO1xuICAgICAgICAgICAgfVxuICAgICAgICB9O1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5oYW5kbGVNb3VzZURvd24gPSAoKSA9PiB7XG4gICAgICAgICAgICB0aGlzLm1vdXNlRG93biA9IHRydWU7XG4gICAgICAgIH07XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmhhbmRsZUZvY3VzID0gKCkgPT4ge1xuICAgICAgICAgICAgaWYgKCF0aGlzLmZvY3VzZWQpIHtcbiAgICAgICAgICAgICAgICB0aGlzLmZvY3VzZWQgPSB0cnVlO1xuICAgICAgICAgICAgICAgIGlmICghdGhpcy5pc0Rpc2FibGVkKSB7XG4gICAgICAgICAgICAgICAgICAgIGNvbnN0IHNob3VsZFNlbGVjdEFsbCA9IHRoaXMuc2VsZWN0T25Gb2N1cyB8fCAhdGhpcy5tb3VzZURvd247XG4gICAgICAgICAgICAgICAgICAgIHRoaXMubmdab25lLnJ1bk91dHNpZGVBbmd1bGFyKCgpID0+IHtcbiAgICAgICAgICAgICAgICAgICAgICAgIHNldFRpbWVvdXQoKCkgPT4ge1xuICAgICAgICAgICAgICAgICAgICAgICAgICAgIGlmIChzaG91bGRTZWxlY3RBbGwpIHtcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgdGhpcy5zZWxlY3RBbGwoKTtcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgZWxzZSB7XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHRoaXMuc2VsZWN0Q2FyZXQoKTtcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgICAgICAgICB9LCAwKTtcbiAgICAgICAgICAgICAgICAgICAgfSk7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfVxuICAgICAgICAgICAgdGhpcy5tb3VzZURvd24gPSBmYWxzZTtcbiAgICAgICAgICAgIGlmIChoYXNPYnNlcnZlcnModGhpcy5vbkZvY3VzKSkge1xuICAgICAgICAgICAgICAgIHRoaXMubmdab25lLnJ1bigoKSA9PiB7XG4gICAgICAgICAgICAgICAgICAgIHRoaXMub25Gb2N1cy5lbWl0KCk7XG4gICAgICAgICAgICAgICAgfSk7XG4gICAgICAgICAgICB9XG4gICAgICAgIH07XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmhhbmRsZUJsdXIgPSAoKSA9PiB7XG4gICAgICAgICAgICB0aGlzLmNoYW5nZURldGVjdG9yLm1hcmtGb3JDaGVjaygpO1xuICAgICAgICAgICAgdGhpcy5mb2N1c2VkID0gZmFsc2U7XG4gICAgICAgICAgICAvL2JsdXIgaXMgdGhyb3duIGJlZm9yZSBpbnB1dCB3aGVuIGRyYWdnaW5nIHRoZSBpbnB1dCB0ZXh0IGluIElFXG4gICAgICAgICAgICBpZiAodGhpcy5pbnB1dFZhbHVlICE9PSB0aGlzLmVsZW1lbnRWYWx1ZSkge1xuICAgICAgICAgICAgICAgIHRoaXMuaGFuZGxlSW5wdXQoKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIHRoaXMuc2V0SW5wdXRWYWx1ZSgpO1xuICAgICAgICAgICAgaWYgKGhhc09ic2VydmVycyh0aGlzLm9uQmx1cikgfHwgcmVxdWlyZXNab25lT25CbHVyKHRoaXMuY29udHJvbCkpIHtcbiAgICAgICAgICAgICAgICB0aGlzLm5nWm9uZS5ydW4oKCkgPT4ge1xuICAgICAgICAgICAgICAgICAgICB0aGlzLm5nVG91Y2hlZCgpO1xuICAgICAgICAgICAgICAgICAgICB0aGlzLm9uQmx1ci5lbWl0KCk7XG4gICAgICAgICAgICAgICAgfSk7XG4gICAgICAgICAgICB9XG4gICAgICAgIH07XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmhhbmRsZUtleURvd24gPSAoZSkgPT4ge1xuICAgICAgICAgICAgaWYgKHRoaXMuaXNEaXNhYmxlZCkge1xuICAgICAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGxldCBzdGVwO1xuICAgICAgICAgICAgaWYgKGUua2V5Q29kZSA9PT0gS2V5cy5BcnJvd0Rvd24pIHtcbiAgICAgICAgICAgICAgICBzdGVwID0gLTE7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICBlbHNlIGlmIChlLmtleUNvZGUgPT09IEtleXMuQXJyb3dVcCkge1xuICAgICAgICAgICAgICAgIHN0ZXAgPSAxO1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgaWYgKHN0ZXAgJiYgdGhpcy5zdGVwKSB7XG4gICAgICAgICAgICAgICAgZS5wcmV2ZW50RGVmYXVsdCgpO1xuICAgICAgICAgICAgICAgIHRoaXMuYWRkU3RlcChzdGVwKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGNvbnN0IGlucHV0ID0gdGhpcy5udW1lcmljSW5wdXQubmF0aXZlRWxlbWVudDtcbiAgICAgICAgICAgIHRoaXMucHJldmlvdXNTZWxlY3Rpb24gPSB7XG4gICAgICAgICAgICAgICAgZW5kOiBpbnB1dC5zZWxlY3Rpb25FbmQsXG4gICAgICAgICAgICAgICAgc3RhcnQ6IGlucHV0LnNlbGVjdGlvblN0YXJ0XG4gICAgICAgICAgICB9O1xuICAgICAgICAgICAgdGhpcy5wcmVzc2VkS2V5ID0gZS5rZXlDb2RlO1xuICAgICAgICB9O1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5oYW5kbGVXaGVlbCA9IChlKSA9PiB7XG4gICAgICAgICAgICBpZiAodGhpcy5mb2N1c2VkICYmICF0aGlzLmlzRGlzYWJsZWQpIHtcbiAgICAgICAgICAgICAgICBlLnByZXZlbnREZWZhdWx0KCk7XG4gICAgICAgICAgICAgICAgY29uc3QgZGVsdGEgPSBnZXREZWx0YUZyb21Nb3VzZVdoZWVsKGUpO1xuICAgICAgICAgICAgICAgIHRoaXMuYWRkU3RlcChkZWx0YSk7XG4gICAgICAgICAgICB9XG4gICAgICAgIH07XG4gICAgICAgIHRoaXMuZGlyZWN0aW9uID0gbG9jYWxpemF0aW9uU2VydmljZS5ydGwgPyAncnRsJyA6ICdsdHInO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBTcGVjaWZpZXMgdGhlIG51bWJlciBmb3JtYXQgd2hpY2ggaXMgdXNlZCB3aGVuIHRoZSBOdW1lcmljVGV4dEJveCBpcyBub3QgZm9jdXNlZFxuICAgICAqIChbc2VlIGV4YW1wbGVdKHslIHNsdWcgZm9ybWF0c19udW1lcmljdGV4dGJveCAlfSkpLlxuICAgICAqIElmIGBmb3JtYXRgIGlzIHNldCB0byBgbnVsbGAgb3IgYHVuZGVmaW5lZGAsIHRoZSBkZWZhdWx0IGZvcm1hdCB3aWxsIGJlIHVzZWQuXG4gICAgICovXG4gICAgZ2V0IGZvcm1hdCgpIHtcbiAgICAgICAgY29uc3QgZm9ybWF0ID0gdGhpcy5fZm9ybWF0O1xuICAgICAgICByZXR1cm4gZm9ybWF0ICE9PSBudWxsICYmIGZvcm1hdCAhPT0gdW5kZWZpbmVkID8gZm9ybWF0IDogJ24yJztcbiAgICB9XG4gICAgc2V0IGZvcm1hdCh2YWx1ZSkge1xuICAgICAgICB0aGlzLl9mb3JtYXQgPSB2YWx1ZTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHNldCB0YWJJbmRleCh0YWJJbmRleCkge1xuICAgICAgICB0aGlzLnRhYmluZGV4ID0gdGFiSW5kZXg7XG4gICAgfVxuICAgIGdldCB0YWJJbmRleCgpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMudGFiaW5kZXg7XG4gICAgfVxuICAgIGdldCB3aWRnZXRDbGFzc2VzKCkge1xuICAgICAgICByZXR1cm4gdHJ1ZTtcbiAgICB9XG4gICAgbmdPbkluaXQoKSB7XG4gICAgICAgIHRoaXMuc3Vic2NyaXB0aW9ucyA9IHRoaXMubG9jYWxpemF0aW9uU2VydmljZVxuICAgICAgICAgICAgLmNoYW5nZXNcbiAgICAgICAgICAgIC5zdWJzY3JpYmUoKHsgcnRsIH0pID0+IHtcbiAgICAgICAgICAgIHRoaXMuZGlyZWN0aW9uID0gcnRsID8gJ3J0bCcgOiAnbHRyJztcbiAgICAgICAgfSk7XG4gICAgICAgIHRoaXMuc3Vic2NyaXB0aW9ucy5hZGQodGhpcy5pbnRsLmNoYW5nZXMuc3Vic2NyaWJlKHRoaXMuaW50bENoYW5nZS5iaW5kKHRoaXMpKSk7XG4gICAgICAgIGlmICh0aGlzLmhvc3RFbGVtZW50KSB7XG4gICAgICAgICAgICB0aGlzLnJlbmRlcmVyLnJlbW92ZUF0dHJpYnV0ZSh0aGlzLmhvc3RFbGVtZW50Lm5hdGl2ZUVsZW1lbnQsIFwidGFiaW5kZXhcIik7XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5jb250cm9sID0gdGhpcy5pbmplY3Rvci5nZXQoTmdDb250cm9sLCBudWxsKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIG5nT25DaGFuZ2VzKGNoYW5nZXMpIHtcbiAgICAgICAgaWYgKGFueUNoYW5nZWQoUEFSU0FCTEVfT1BUSU9OUywgY2hhbmdlcywgZmFsc2UpKSB7XG4gICAgICAgICAgICB0aGlzLnBhcnNlT3B0aW9ucyhQQVJTQUJMRV9PUFRJT05TLmZpbHRlcihvcHRpb24gPT4gY2hhbmdlc1tvcHRpb25dKSk7XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy52ZXJpZnlTZXR0aW5ncygpO1xuICAgICAgICBpZiAoYW55Q2hhbmdlZChbJ21pbicsICdtYXgnLCAncmFuZ2VWYWxpZGF0aW9uJ10sIGNoYW5nZXMsIGZhbHNlKSkge1xuICAgICAgICAgICAgdGhpcy5taW5WYWxpZGF0ZUZuID0gdGhpcy5yYW5nZVZhbGlkYXRpb24gPyBjcmVhdGVNaW5WYWxpZGF0b3IodGhpcy5taW4pIDogbm9vcDtcbiAgICAgICAgICAgIHRoaXMubWF4VmFsaWRhdGVGbiA9IHRoaXMucmFuZ2VWYWxpZGF0aW9uID8gY3JlYXRlTWF4VmFsaWRhdG9yKHRoaXMubWF4KSA6IG5vb3A7XG4gICAgICAgICAgICB0aGlzLm5nVmFsaWRhdG9yQ2hhbmdlKCk7XG4gICAgICAgIH1cbiAgICAgICAgaWYgKGFueUNoYW5nZWQoWydhdXRvQ29ycmVjdCcsICdkZWNpbWFscycsICdtaW4nXSwgY2hhbmdlcykpIHtcbiAgICAgICAgICAgIGRlbGV0ZSB0aGlzLm51bWVyaWNSZWdleDtcbiAgICAgICAgfVxuICAgICAgICBpZiAoYW55Q2hhbmdlZChbJ3ZhbHVlJywgJ2Zvcm1hdCddLCBjaGFuZ2VzLCBmYWxzZSkpIHtcbiAgICAgICAgICAgIHRoaXMudmVyaWZ5VmFsdWUodGhpcy52YWx1ZSk7XG4gICAgICAgICAgICB0aGlzLnZhbHVlID0gdGhpcy5yZXN0cmljdE1vZGVsVmFsdWUodGhpcy52YWx1ZSk7XG4gICAgICAgICAgICBpZiAoIXRoaXMuZm9jdXNlZCB8fCAodGhpcy5pbnRsLnBhcnNlTnVtYmVyKHRoaXMuZWxlbWVudFZhbHVlKSAhPT0gdGhpcy52YWx1ZSkpIHtcbiAgICAgICAgICAgICAgICB0aGlzLnNldElucHV0VmFsdWUoKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgbmdPbkRlc3Ryb3koKSB7XG4gICAgICAgIGlmICh0aGlzLnN1YnNjcmlwdGlvbnMpIHtcbiAgICAgICAgICAgIHRoaXMuc3Vic2NyaXB0aW9ucy51bnN1YnNjcmliZSgpO1xuICAgICAgICB9XG4gICAgICAgIGNsZWFyVGltZW91dCh0aGlzLnNwaW5UaW1lb3V0KTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHZhbGlkYXRlKGNvbnRyb2wpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMubWluVmFsaWRhdGVGbihjb250cm9sKSB8fCB0aGlzLm1heFZhbGlkYXRlRm4oY29udHJvbCk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICByZWdpc3Rlck9uVmFsaWRhdG9yQ2hhbmdlKGZuKSB7XG4gICAgICAgIHRoaXMubmdWYWxpZGF0b3JDaGFuZ2UgPSBmbjtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHdyaXRlVmFsdWUodmFsdWUpIHtcbiAgICAgICAgdGhpcy52ZXJpZnlWYWx1ZSh2YWx1ZSk7XG4gICAgICAgIGxldCByZXN0cmljdGVkVmFsdWUgPSB0aGlzLnJlc3RyaWN0TW9kZWxWYWx1ZSh2YWx1ZSk7XG4gICAgICAgIHRoaXMudmFsdWUgPSByZXN0cmljdGVkVmFsdWU7XG4gICAgICAgIHRoaXMuc2V0SW5wdXRWYWx1ZSgpO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgcmVnaXN0ZXJPbkNoYW5nZShmbikge1xuICAgICAgICB0aGlzLm5nQ2hhbmdlID0gZm47XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICByZWdpc3Rlck9uVG91Y2hlZChmbikge1xuICAgICAgICB0aGlzLm5nVG91Y2hlZCA9IGZuO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICogQ2FsbGVkIHdoZW4gdGhlIHN0YXR1cyBvZiB0aGUgY29tcG9uZW50IGNoYW5nZXMgdG8gb3IgZnJvbSBgZGlzYWJsZWRgLlxuICAgICAqIERlcGVuZGluZyBvbiB0aGUgdmFsdWUsIGl0IGVuYWJsZXMgb3IgZGlzYWJsZXMgdGhlIGFwcHJvcHJpYXRlIERPTSBlbGVtZW50LlxuICAgICAqXG4gICAgICogQHBhcmFtIGlzRGlzYWJsZWRcbiAgICAgKi9cbiAgICBzZXREaXNhYmxlZFN0YXRlKGlzRGlzYWJsZWQpIHtcbiAgICAgICAgdGhpcy5kaXNhYmxlZCA9IGlzRGlzYWJsZWQ7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEZvY3VzZXMgdGhlIE51bWVyaWNUZXh0Qm94LlxuICAgICAqXG4gICAgICogQGV4YW1wbGVcbiAgICAgKiBgYGB0cy1uby1ydW5cbiAgICAgKiBfQENvbXBvbmVudCh7XG4gICAgICogc2VsZWN0b3I6ICdteS1hcHAnLFxuICAgICAqIHRlbXBsYXRlOiBgXG4gICAgICogIDxidXR0b24gKGNsaWNrKT1cIm51bWVyaWN0ZXh0Ym94LmZvY3VzKClcIj5Gb2N1cyBOdW1lcmljVGV4dEJveDwvYnV0dG9uPlxuICAgICAqICA8a2VuZG8tbnVtZXJpY3RleHRib3ggI251bWVyaWN0ZXh0Ym94Pjwva2VuZG8tbnVtZXJpY3RleHRib3g+XG4gICAgICogYFxuICAgICAqIH0pXG4gICAgICogY2xhc3MgQXBwQ29tcG9uZW50IHsgfVxuICAgICAqIGBgYFxuICAgICAqL1xuICAgIGZvY3VzKCkge1xuICAgICAgICBpbnZva2VFbGVtZW50TWV0aG9kKHRoaXMubnVtZXJpY0lucHV0LCAnZm9jdXMnKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQmx1cnMgdGhlIE51bWVyaWNUZXh0Qm94LlxuICAgICAqL1xuICAgIGJsdXIoKSB7XG4gICAgICAgIGludm9rZUVsZW1lbnRNZXRob2QodGhpcy5udW1lcmljSW5wdXQsICdibHVyJyk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIE5vdGlmaWVzIHRoZSBgTnVtZXJpY1RleHRCb3hDb21wb25lbnRgIHRoYXQgdGhlIGlucHV0IHZhbHVlIHNob3VsZCBiZSBjaGFuZ2VkLlxuICAgICAqIENhbiBiZSB1c2VkIHRvIHVwZGF0ZSB0aGUgaW5wdXQgYWZ0ZXIgc2V0dGluZyB0aGUgY29tcG9uZW50IHByb3BlcnRpZXMgZGlyZWN0bHkuXG4gICAgICovXG4gICAgbm90aWZ5VmFsdWVDaGFuZ2UoKSB7XG4gICAgICAgIHRoaXMuc2V0SW5wdXRWYWx1ZSgpO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgZ2V0IGluY3JlbWVudFRpdGxlKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5sb2NhbGl6YXRpb25TZXJ2aWNlLmdldCgnaW5jcmVtZW50Jyk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBnZXQgZGVjcmVtZW50VGl0bGUoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmxvY2FsaXphdGlvblNlcnZpY2UuZ2V0KCdkZWNyZW1lbnQnKTtcbiAgICB9XG4gICAgZ2V0IGRlY2ltYWxTZXBhcmF0b3IoKSB7XG4gICAgICAgIGNvbnN0IG51bWJlclN5bWJvbHMgPSB0aGlzLmludGwubnVtYmVyU3ltYm9scygpO1xuICAgICAgICByZXR1cm4gbnVtYmVyU3ltYm9scy5kZWNpbWFsO1xuICAgIH1cbiAgICBnZXQgZWxlbWVudFZhbHVlKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5udW1lcmljSW5wdXQubmF0aXZlRWxlbWVudC52YWx1ZTtcbiAgICB9XG4gICAgc2V0IGVsZW1lbnRWYWx1ZSh2YWx1ZSkge1xuICAgICAgICB0aGlzLnJlbmRlcmVyLnNldFByb3BlcnR5KHRoaXMubnVtZXJpY0lucHV0Lm5hdGl2ZUVsZW1lbnQsICd2YWx1ZScsIHZhbHVlKTtcbiAgICB9XG4gICAgZ2V0IGZvY3VzZWQoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmlzRm9jdXNlZDtcbiAgICB9XG4gICAgZ2V0IGhhc0RlY2ltYWxzKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5kZWNpbWFscyAhPT0gbnVsbCAmJiB0aGlzLmRlY2ltYWxzID49IDA7XG4gICAgfVxuICAgIHNldCBmb2N1c2VkKHZhbHVlKSB7XG4gICAgICAgIGlmICh0aGlzLmlzRm9jdXNlZCAhPT0gdmFsdWUgJiYgdGhpcy5udW1lcmljV3JhcCkge1xuICAgICAgICAgICAgY29uc3Qgd3JhcCA9IHRoaXMubnVtZXJpY1dyYXAubmF0aXZlRWxlbWVudDtcbiAgICAgICAgICAgIGNvbnN0IGlucHV0ID0gdGhpcy5udW1lcmljSW5wdXQubmF0aXZlRWxlbWVudDtcbiAgICAgICAgICAgIGlmICh2YWx1ZSkge1xuICAgICAgICAgICAgICAgIHRoaXMucmVuZGVyZXIuYWRkQ2xhc3Mod3JhcCwgRk9DVVNFRCQyKTtcbiAgICAgICAgICAgICAgICBpZiAoIXRoaXMuaXNEaXNhYmxlZCkge1xuICAgICAgICAgICAgICAgICAgICB0aGlzLnJlbmRlcmVyLnJlbW92ZUNsYXNzKGlucHV0LCBGT1JNQVRURURfVkFMVUUpO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGVsc2Uge1xuICAgICAgICAgICAgICAgIHRoaXMucmVuZGVyZXIucmVtb3ZlQ2xhc3Mod3JhcCwgRk9DVVNFRCQyKTtcbiAgICAgICAgICAgICAgICB0aGlzLnJlbmRlcmVyLmFkZENsYXNzKGlucHV0LCBGT1JNQVRURURfVkFMVUUpO1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgdGhpcy5pc0ZvY3VzZWQgPSB2YWx1ZTtcbiAgICAgICAgfVxuICAgIH1cbiAgICBnZXQgaXNEaXNhYmxlZCgpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuZGlzYWJsZWQgfHwgdGhpcy5yZWFkb25seTtcbiAgICB9XG4gICAgYXJyb3dQcmVzcyhkaXJlY3Rpb24sIGUpIHtcbiAgICAgICAgZS5wcmV2ZW50RGVmYXVsdCgpO1xuICAgICAgICBpZiAodGhpcy5pc0Rpc2FibGVkKSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgaWYgKCFtb2JpbGVPUykge1xuICAgICAgICAgICAgdGhpcy5mb2N1c2VkID0gdHJ1ZTtcbiAgICAgICAgICAgIHRoaXMuZm9jdXMoKTtcbiAgICAgICAgfVxuICAgICAgICBpZiAodGhpcy5hcnJvd0RpcmVjdGlvbiAhPT0gZGlyZWN0aW9uKSB7XG4gICAgICAgICAgICB0aGlzLmFycm93RGlyZWN0aW9uID0gZGlyZWN0aW9uO1xuICAgICAgICAgICAgdGhpcy5jaGFuZ2VEZXRlY3Rvci5kZXRlY3RDaGFuZ2VzKCk7XG4gICAgICAgIH1cbiAgICAgICAgaWYgKHRoaXMuc3RlcCkge1xuICAgICAgICAgICAgdGhpcy5zcGluKGRpcmVjdGlvbiwgSU5JVElBTF9TUElOX0RFTEFZKTtcbiAgICAgICAgfVxuICAgICAgICBlbHNlIHtcbiAgICAgICAgICAgIHRoaXMuc2V0SW5wdXRWYWx1ZSgpO1xuICAgICAgICB9XG4gICAgfVxuICAgIHVwZGF0ZVZhbHVlKHZhbHVlKSB7XG4gICAgICAgIGlmICghYXJlU2FtZSh0aGlzLnZhbHVlLCB2YWx1ZSkpIHtcbiAgICAgICAgICAgIHRoaXMubmdab25lLnJ1bigoKSA9PiB7XG4gICAgICAgICAgICAgICAgdGhpcy52YWx1ZSA9IHZhbHVlO1xuICAgICAgICAgICAgICAgIHRoaXMubmdDaGFuZ2UodmFsdWUpO1xuICAgICAgICAgICAgICAgIHRoaXMudmFsdWVDaGFuZ2UuZW1pdCh2YWx1ZSk7XG4gICAgICAgICAgICAgICAgdGhpcy5jaGFuZ2VEZXRlY3Rvci5tYXJrRm9yQ2hlY2soKTtcbiAgICAgICAgICAgIH0pO1xuICAgICAgICB9XG4gICAgfVxuICAgIHJlcGxhY2VOdW1wYWREb3RWYWx1ZSgpIHtcbiAgICAgICAgbGV0IHZhbHVlID0gdGhpcy5pbnB1dFZhbHVlIHx8IFwiXCI7XG4gICAgICAgIGlmICh0aGlzLnByZXZpb3VzU2VsZWN0aW9uKSB7XG4gICAgICAgICAgICBjb25zdCBpbnB1dCA9IHRoaXMubnVtZXJpY0lucHV0Lm5hdGl2ZUVsZW1lbnQ7XG4gICAgICAgICAgICBjb25zdCB7IHNlbGVjdGlvblN0YXJ0LCBzZWxlY3Rpb25FbmQgfSA9IGlucHV0O1xuICAgICAgICAgICAgY29uc3QgeyBzdGFydCwgZW5kIH0gPSB0aGlzLnByZXZpb3VzU2VsZWN0aW9uO1xuICAgICAgICAgICAgaW5wdXQudmFsdWUgPSB2YWx1ZSA9IHZhbHVlLnN1YnN0cmluZygwLCBzdGFydCkgKyB0aGlzLmRlY2ltYWxTZXBhcmF0b3IgKyB2YWx1ZS5zdWJzdHJpbmcoZW5kKTtcbiAgICAgICAgICAgIHRoaXMuc2V0U2VsZWN0aW9uKHNlbGVjdGlvblN0YXJ0LCBzZWxlY3Rpb25FbmQpO1xuICAgICAgICB9XG4gICAgICAgIHJldHVybiB2YWx1ZTtcbiAgICB9XG4gICAgaXNWYWxpZCh2YWx1ZSkge1xuICAgICAgICBpZiAoIXRoaXMubnVtZXJpY1JlZ2V4KSB7XG4gICAgICAgICAgICB0aGlzLm51bWVyaWNSZWdleCA9IG51bWVyaWNSZWdleCh7XG4gICAgICAgICAgICAgICAgYXV0b0NvcnJlY3Q6IHRoaXMuYXV0b0NvcnJlY3QsXG4gICAgICAgICAgICAgICAgZGVjaW1hbHM6IHRoaXMuZGVjaW1hbHMsXG4gICAgICAgICAgICAgICAgbWluOiB0aGlzLm1pbixcbiAgICAgICAgICAgICAgICBzZXBhcmF0b3I6IHRoaXMuZGVjaW1hbFNlcGFyYXRvclxuICAgICAgICAgICAgfSk7XG4gICAgICAgIH1cbiAgICAgICAgcmV0dXJuIHRoaXMubnVtZXJpY1JlZ2V4LnRlc3QodmFsdWUpO1xuICAgIH1cbiAgICBzcGluKHN0ZXAsIHRpbWVvdXQpIHtcbiAgICAgICAgY2xlYXJUaW1lb3V0KHRoaXMuc3BpblRpbWVvdXQpO1xuICAgICAgICB0aGlzLnNwaW5UaW1lb3V0ID0gd2luZG93LnNldFRpbWVvdXQoKCkgPT4ge1xuICAgICAgICAgICAgdGhpcy5zcGluKHN0ZXAsIFNQSU5fREVMQVkpO1xuICAgICAgICB9LCB0aW1lb3V0KTtcbiAgICAgICAgdGhpcy5hZGRTdGVwKHN0ZXApO1xuICAgIH1cbiAgICBhZGRTdGVwKHN0ZXApIHtcbiAgICAgICAgbGV0IHZhbHVlID0gYWRkKHRoaXMudmFsdWUgfHwgMCwgdGhpcy5zdGVwICogc3RlcCk7XG4gICAgICAgIHZhbHVlID0gdGhpcy5saW1pdFZhbHVlKHZhbHVlKTtcbiAgICAgICAgdmFsdWUgPSB0aGlzLnJlc3RyaWN0RGVjaW1hbHModmFsdWUpO1xuICAgICAgICB0aGlzLnNldElucHV0VmFsdWUodmFsdWUpO1xuICAgICAgICB0aGlzLnVwZGF0ZVZhbHVlKHZhbHVlKTtcbiAgICB9XG4gICAgc2V0U2VsZWN0aW9uKHN0YXJ0LCBlbmQpIHtcbiAgICAgICAgaWYgKHRoaXMuZm9jdXNlZCkge1xuICAgICAgICAgICAgaW52b2tlRWxlbWVudE1ldGhvZCh0aGlzLm51bWVyaWNJbnB1dCwgJ3NldFNlbGVjdGlvblJhbmdlJywgc3RhcnQsIGVuZCk7XG4gICAgICAgIH1cbiAgICB9XG4gICAgbGltaXRWYWx1ZSh2YWx1ZSkge1xuICAgICAgICBsZXQgcmVzdWx0ID0gdmFsdWU7XG4gICAgICAgIGlmICghdGhpcy5pc0luUmFuZ2UodmFsdWUpKSB7XG4gICAgICAgICAgICBpZiAoaXNOdW1iZXIodGhpcy5tYXgpICYmIHZhbHVlID4gdGhpcy5tYXgpIHtcbiAgICAgICAgICAgICAgICByZXN1bHQgPSB0aGlzLm1heDtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGlmIChpc051bWJlcih0aGlzLm1pbikgJiYgdmFsdWUgPCB0aGlzLm1pbikge1xuICAgICAgICAgICAgICAgIHJlc3VsdCA9IHRoaXMubWluO1xuICAgICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICAgIHJldHVybiByZXN1bHQ7XG4gICAgfVxuICAgIGxpbWl0SW5wdXRWYWx1ZSh2YWx1ZSkge1xuICAgICAgICBsZXQgeyBzZWxlY3Rpb25TdGFydCwgc2VsZWN0aW9uRW5kLCB2YWx1ZTogZW50ZXJlZFZhbHVlIH0gPSB0aGlzLm51bWVyaWNJbnB1dC5uYXRpdmVFbGVtZW50O1xuICAgICAgICBsZXQgbGltaXRlZFZhbHVlID0gdmFsdWU7XG4gICAgICAgIGxldCBzZWxlY3RUb0VuZCA9IGZhbHNlO1xuICAgICAgICBpZiAoIXRoaXMuaXNJblJhbmdlKHZhbHVlKSkge1xuICAgICAgICAgICAgY29uc3QgbGVuZ3RoQ2hhbmdlID0gZW50ZXJlZFZhbHVlLmxlbmd0aCAtIFN0cmluZyh0aGlzLmlucHV0VmFsdWUpLmxlbmd0aDtcbiAgICAgICAgICAgIGNvbnN0IHsgbWluLCBtYXggfSA9IHRoaXM7XG4gICAgICAgICAgICBjb25zdCBoYXNNYXggPSBpc051bWJlcihtYXgpO1xuICAgICAgICAgICAgY29uc3QgaGFzTWluID0gaXNOdW1iZXIobWluKTtcbiAgICAgICAgICAgIGxldCBwYWRMaW1pdCwgcmVwbGFjZU5leHQ7XG4gICAgICAgICAgICBsZXQgY29ycmVjdGVkVmFsdWUgPSB2YWx1ZTtcbiAgICAgICAgICAgIGlmIChzZWxlY3Rpb25TdGFydCA9PT0gMCAmJiB0aGlzLmlucHV0VmFsdWUuc3Vic3RyKDEpID09PSBlbnRlcmVkVmFsdWUpIHtcbiAgICAgICAgICAgICAgICByZXR1cm4ge1xuICAgICAgICAgICAgICAgICAgICBzZWxlY3Rpb25FbmQ6IHNlbGVjdGlvbkVuZCxcbiAgICAgICAgICAgICAgICAgICAgc2VsZWN0aW9uU3RhcnQ6IHNlbGVjdGlvblN0YXJ0LFxuICAgICAgICAgICAgICAgICAgICB2YWx1ZTogbnVsbFxuICAgICAgICAgICAgICAgIH07XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICBpZiAoaGFzTWF4ICYmIHZhbHVlID4gbWF4KSB7XG4gICAgICAgICAgICAgICAgaWYgKHZhbHVlID4gMCkge1xuICAgICAgICAgICAgICAgICAgICByZXBsYWNlTmV4dCA9IHRydWU7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIGVsc2Uge1xuICAgICAgICAgICAgICAgICAgICBwYWRMaW1pdCA9IG1heDtcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICBlbHNlIGlmIChoYXNNaW4gJiYgdmFsdWUgPCBtaW4pIHtcbiAgICAgICAgICAgICAgICBpZiAodmFsdWUgPiAwKSB7XG4gICAgICAgICAgICAgICAgICAgIHBhZExpbWl0ID0gbWluO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICBlbHNlIHtcbiAgICAgICAgICAgICAgICAgICAgcmVwbGFjZU5leHQgPSB0cnVlO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGlmIChwYWRMaW1pdCkge1xuICAgICAgICAgICAgICAgIGNvbnN0IHBhZGRlZFZhbHVlID0gdGhpcy50cnlQYWRWYWx1ZSh2YWx1ZSwgcGFkTGltaXQpO1xuICAgICAgICAgICAgICAgIGlmIChwYWRkZWRWYWx1ZSAmJiBkZWNpbWFsUGFydCh2YWx1ZSkgIT09IGRlY2ltYWxQYXJ0KHBhZExpbWl0KSkge1xuICAgICAgICAgICAgICAgICAgICBjb3JyZWN0ZWRWYWx1ZSA9IHBhZGRlZFZhbHVlO1xuICAgICAgICAgICAgICAgICAgICBzZWxlY3RUb0VuZCA9IHRydWU7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfVxuICAgICAgICAgICAgZWxzZSBpZiAocmVwbGFjZU5leHQpIHtcbiAgICAgICAgICAgICAgICBpZiAodGhpcy5pbnB1dFZhbHVlICYmIHNlbGVjdGlvblN0YXJ0ICE9PSBlbnRlcmVkVmFsdWUubGVuZ3RoKSB7XG4gICAgICAgICAgICAgICAgICAgIGNvcnJlY3RlZFZhbHVlID0gcGFyc2VGbG9hdChlbnRlcmVkVmFsdWUuc3Vic3RyKDAsIHNlbGVjdGlvblN0YXJ0KSArXG4gICAgICAgICAgICAgICAgICAgICAgICBlbnRlcmVkVmFsdWUuc3Vic3RyKHNlbGVjdGlvblN0YXJ0ICsgbGVuZ3RoQ2hhbmdlKSk7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfVxuICAgICAgICAgICAgbGltaXRlZFZhbHVlID0gdGhpcy5saW1pdFZhbHVlKGNvcnJlY3RlZFZhbHVlKTtcbiAgICAgICAgICAgIHNlbGVjdFRvRW5kID0gKHNlbGVjdFRvRW5kIHx8IGxpbWl0ZWRWYWx1ZSAhPT0gY29ycmVjdGVkVmFsdWUpICYmIHRoaXMucHJldmlvdXNTZWxlY3Rpb24gJiZcbiAgICAgICAgICAgICAgICAodGhpcy5wcmV2aW91c1NlbGVjdGlvbi5lbmQgLSB0aGlzLnByZXZpb3VzU2VsZWN0aW9uLnN0YXJ0ICsgbGVuZ3RoQ2hhbmdlKSA+IDA7XG4gICAgICAgIH1cbiAgICAgICAgcmV0dXJuIHtcbiAgICAgICAgICAgIHNlbGVjdGlvbkVuZDogc2VsZWN0VG9FbmQgPyBTdHJpbmcobGltaXRlZFZhbHVlKS5sZW5ndGggOiBzZWxlY3Rpb25FbmQsXG4gICAgICAgICAgICBzZWxlY3Rpb25TdGFydDogc2VsZWN0aW9uU3RhcnQsXG4gICAgICAgICAgICB2YWx1ZTogbGltaXRlZFZhbHVlXG4gICAgICAgIH07XG4gICAgfVxuICAgIHRyeVBhZFZhbHVlKHZhbHVlLCBsaW1pdCkge1xuICAgICAgICBjb25zdCBsaW1pdExlbmd0aCA9IFN0cmluZyhNYXRoLmZsb29yKGxpbWl0KSkubGVuZ3RoO1xuICAgICAgICBjb25zdCB6ZXJvUGFkZGVkID0gcGFkKHZhbHVlLCBsaW1pdExlbmd0aCk7XG4gICAgICAgIGNvbnN0IHplcm9QYWRkZWROZXh0ID0gcGFkKHZhbHVlLCBsaW1pdExlbmd0aCArIDEpO1xuICAgICAgICBsZXQgcmVzdWx0O1xuICAgICAgICBpZiAodGhpcy5pc0luUmFuZ2UoemVyb1BhZGRlZCkpIHtcbiAgICAgICAgICAgIHJlc3VsdCA9IHplcm9QYWRkZWQ7XG4gICAgICAgIH1cbiAgICAgICAgZWxzZSBpZiAodGhpcy5pc0luUmFuZ2UoemVyb1BhZGRlZE5leHQpKSB7XG4gICAgICAgICAgICByZXN1bHQgPSB6ZXJvUGFkZGVkTmV4dDtcbiAgICAgICAgfVxuICAgICAgICByZXR1cm4gcmVzdWx0O1xuICAgIH1cbiAgICBpc0luUmFuZ2UodmFsdWUpIHtcbiAgICAgICAgcmV0dXJuICFpc051bWJlcih2YWx1ZSkgfHwgKCghaXNOdW1iZXIodGhpcy5taW4pIHx8IHRoaXMubWluIDw9IHZhbHVlKSAmJiAoIWlzTnVtYmVyKHRoaXMubWF4KSB8fCB2YWx1ZSA8PSB0aGlzLm1heCkpO1xuICAgIH1cbiAgICByZXN0cmljdE1vZGVsVmFsdWUodmFsdWUpIHtcbiAgICAgICAgbGV0IHJlc3VsdCA9IHRoaXMucmVzdHJpY3REZWNpbWFscyh2YWx1ZSwgdHJ1ZSk7XG4gICAgICAgIGlmICh0aGlzLmF1dG9Db3JyZWN0ICYmIHRoaXMubGltaXRWYWx1ZShyZXN1bHQpICE9PSByZXN1bHQpIHtcbiAgICAgICAgICAgIHJlc3VsdCA9IG51bGw7XG4gICAgICAgIH1cbiAgICAgICAgcmV0dXJuIHJlc3VsdDtcbiAgICB9XG4gICAgcmVzdHJpY3REZWNpbWFscyh2YWx1ZSwgcm91bmQpIHtcbiAgICAgICAgbGV0IHJlc3VsdCA9IHZhbHVlO1xuICAgICAgICBpZiAodmFsdWUgJiYgdGhpcy5oYXNEZWNpbWFscykge1xuICAgICAgICAgICAgY29uc3QgZGVjaW1hbHMgPSB0aGlzLmRlY2ltYWxzO1xuICAgICAgICAgICAgY29uc3Qgc3RyaW5nVmFsdWUgPSBTdHJpbmcodmFsdWUpO1xuICAgICAgICAgICAgaWYgKHJvdW5kIHx8IEVYUE9ORU5UX1JFR0VYLnRlc3Qoc3RyaW5nVmFsdWUpKSB7XG4gICAgICAgICAgICAgICAgcmVzdWx0ID0gdG9GaXhlZFByZWNpc2lvbih2YWx1ZSwgZGVjaW1hbHMpO1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgZWxzZSB7XG4gICAgICAgICAgICAgICAgY29uc3QgcGFydHMgPSBzdHJpbmdWYWx1ZS5zcGxpdChQT0lOVCk7XG4gICAgICAgICAgICAgICAgbGV0IGZyYWN0aW9uID0gcGFydHNbMV07XG4gICAgICAgICAgICAgICAgaWYgKGZyYWN0aW9uICYmIGZyYWN0aW9uLmxlbmd0aCA+IGRlY2ltYWxzKSB7XG4gICAgICAgICAgICAgICAgICAgIGZyYWN0aW9uID0gZnJhY3Rpb24uc3Vic3RyKDAsIGRlY2ltYWxzKTtcbiAgICAgICAgICAgICAgICAgICAgcmVzdWx0ID0gcGFyc2VGbG9hdChgJHtwYXJ0c1swXX0ke1BPSU5UfSR7ZnJhY3Rpb259YCk7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICAgIHJldHVybiByZXN1bHQ7XG4gICAgfVxuICAgIGZvcm1hdElucHV0VmFsdWUodmFsdWUpIHtcbiAgICAgICAgbGV0IHN0cmluZ1ZhbHVlID0gU3RyaW5nKHZhbHVlKTtcbiAgICAgICAgY29uc3QgZXhwb25lbnRNYXRjaCA9IEVYUE9ORU5UX1JFR0VYLmV4ZWMoc3RyaW5nVmFsdWUpO1xuICAgICAgICBpZiAoZXhwb25lbnRNYXRjaCkge1xuICAgICAgICAgICAgc3RyaW5nVmFsdWUgPSB2YWx1ZS50b0ZpeGVkKGxpbWl0UHJlY2lzaW9uKHBhcnNlSW50KGV4cG9uZW50TWF0Y2hbMV0sIDEwKSkpO1xuICAgICAgICB9XG4gICAgICAgIHJldHVybiBzdHJpbmdWYWx1ZS5yZXBsYWNlKFBPSU5ULCB0aGlzLmRlY2ltYWxTZXBhcmF0b3IpO1xuICAgIH1cbiAgICBmb3JtYXRWYWx1ZSh2YWx1ZSwgZm9jdXNlZCkge1xuICAgICAgICBsZXQgZm9ybWF0dGVkVmFsdWU7XG4gICAgICAgIGlmICh2YWx1ZSA9PT0gbnVsbCB8fCAhZGVmaW5lZCh2YWx1ZSkgfHwgdmFsdWUgPT09ICcnKSB7XG4gICAgICAgICAgICBmb3JtYXR0ZWRWYWx1ZSA9ICcnO1xuICAgICAgICB9XG4gICAgICAgIGVsc2UgaWYgKGZvY3VzZWQgJiYgIXRoaXMucmVhZG9ubHkpIHtcbiAgICAgICAgICAgIGZvcm1hdHRlZFZhbHVlID0gdGhpcy5mb3JtYXRJbnB1dFZhbHVlKHZhbHVlKTtcbiAgICAgICAgfVxuICAgICAgICBlbHNlIHtcbiAgICAgICAgICAgIGZvcm1hdHRlZFZhbHVlID0gdGhpcy5pbnRsLmZvcm1hdE51bWJlcih2YWx1ZSwgdGhpcy5mb3JtYXQpO1xuICAgICAgICB9XG4gICAgICAgIHJldHVybiBmb3JtYXR0ZWRWYWx1ZTtcbiAgICB9XG4gICAgc2V0SW5wdXRWYWx1ZSh2YWx1ZSA9IHRoaXMudmFsdWUsIGZvY3VzZWQgPSB0aGlzLmZvY3VzZWQpIHtcbiAgICAgICAgY29uc3QgZm9ybWF0dGVkVmFsdWUgPSB0aGlzLmZvcm1hdFZhbHVlKHZhbHVlLCBmb2N1c2VkKTtcbiAgICAgICAgdGhpcy5lbGVtZW50VmFsdWUgPSBmb3JtYXR0ZWRWYWx1ZTtcbiAgICAgICAgdGhpcy5pbnB1dFZhbHVlID0gZm9ybWF0dGVkVmFsdWU7XG4gICAgfVxuICAgIHZlcmlmeVNldHRpbmdzKCkge1xuICAgICAgICBpZiAoIWlzRGV2TW9kZSgpKSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgaWYgKHRoaXMubWluICE9PSBudWxsICYmIHRoaXMubWF4ICE9PSBudWxsICYmIHRoaXMubWluID4gdGhpcy5tYXgpIHtcbiAgICAgICAgICAgIHRocm93IG5ldyBFcnJvcihgVGhlIG1heCB2YWx1ZSBzaG91bGQgYmUgYmlnZ2VyIHRoYW4gdGhlIG1pbi4gU2VlICR7TUlOX0RPQ19MSU5LfSBhbmQgJHtNQVhfRE9DX0xJTkt9LmApO1xuICAgICAgICB9XG4gICAgfVxuICAgIHZlcmlmeVZhbHVlKHZhbHVlKSB7XG4gICAgICAgIGlmIChpc0Rldk1vZGUoKSAmJiB2YWx1ZSAmJiB0eXBlb2YgdmFsdWUgIT09ICdudW1iZXInKSB7XG4gICAgICAgICAgICB0aHJvdyBuZXcgRXJyb3IoYFRoZSBOdW1lcmljVGV4dEJveCBjb21wb25lbnQgcmVxdWlyZXMgdmFsdWUgb2YgdHlwZSBOdW1iZXIgYW5kICR7SlNPTi5zdHJpbmdpZnkodmFsdWUpfSB3YXMgc2V0LmApO1xuICAgICAgICB9XG4gICAgfVxuICAgIHBhcnNlT3B0aW9ucyhvcHRpb25zKSB7XG4gICAgICAgIGZvciAobGV0IGlkeCA9IDA7IGlkeCA8IG9wdGlvbnMubGVuZ3RoOyBpZHgrKykge1xuICAgICAgICAgICAgY29uc3QgbmFtZSA9IG9wdGlvbnNbaWR4XTtcbiAgICAgICAgICAgIGNvbnN0IHZhbHVlID0gdGhpc1tuYW1lXTtcbiAgICAgICAgICAgIGlmICh0eXBlb2YgdmFsdWUgPT09ICdzdHJpbmcnKSB7XG4gICAgICAgICAgICAgICAgY29uc3QgcGFyc2VkID0gcGFyc2VGbG9hdCh2YWx1ZSk7XG4gICAgICAgICAgICAgICAgY29uc3QgdmFsaWQgPSAhaXNOYU4ocGFyc2VkKTtcbiAgICAgICAgICAgICAgICBpZiAoaXNEZXZNb2RlKCkgJiYgIXZhbGlkICYmIHZhbHVlICE9PSAnJykge1xuICAgICAgICAgICAgICAgICAgICB0aHJvdyBuZXcgRXJyb3IoJ1RoZSBOdW1lcmljVGV4dEJveCBjb21wb25lbnQgcmVxdWlyZXMgdmFsdWUgb2YgdHlwZSBOdW1iZXIgb3IgYSBTdHJpbmcgcmVwcmVzZW50aW5nICcgK1xuICAgICAgICAgICAgICAgICAgICAgICAgYGEgbnVtYmVyIGZvciB0aGUgJHtuYW1lfSBwcm9wZXJ0eSBhbmQgJHtKU09OLnN0cmluZ2lmeSh2YWx1ZSl9IHdhcyBzZXQuYCk7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIHRoaXNbbmFtZV0gPSB2YWxpZCA/IHBhcnNlZCA6IFBBUlNBQkxFX0RFRkFVTFRTW25hbWVdO1xuICAgICAgICAgICAgfVxuICAgICAgICB9XG4gICAgfVxuICAgIGludGxDaGFuZ2UoKSB7XG4gICAgICAgIGRlbGV0ZSB0aGlzLm51bWVyaWNSZWdleDtcbiAgICAgICAgaWYgKHRoaXMubnVtZXJpY0lucHV0ICYmICghdGhpcy5mb2N1c2VkIHx8ICF0aGlzLmlzVmFsaWQodGhpcy5lbGVtZW50VmFsdWUpKSkge1xuICAgICAgICAgICAgdGhpcy5zZXRJbnB1dFZhbHVlKCk7XG4gICAgICAgIH1cbiAgICB9XG4gICAgaGFzVHJhaWxpbmdaZXJvcyhpbnB1dFZhbHVlKSB7XG4gICAgICAgIGlmICh0aGlzLmhhc0RlY2ltYWxzICYmIHRoaXMuZm9jdXNlZCkge1xuICAgICAgICAgICAgY29uc3QgZnJhY3Rpb24gPSBpbnB1dFZhbHVlLnNwbGl0KHRoaXMuZGVjaW1hbFNlcGFyYXRvcilbMV07XG4gICAgICAgICAgICByZXR1cm4gZnJhY3Rpb24gJiYgZnJhY3Rpb24ubGVuZ3RoID4gdGhpcy5kZWNpbWFscyAmJiBmcmFjdGlvbi5sYXN0SW5kZXhPZignMCcpID09PSBmcmFjdGlvbi5sZW5ndGggLSAxO1xuICAgICAgICB9XG4gICAgfVxuICAgIHNlbGVjdEFsbCgpIHtcbiAgICAgICAgdGhpcy5zZXRJbnB1dFZhbHVlKCk7XG4gICAgICAgIHRoaXMuc2V0U2VsZWN0aW9uKDAsIHRoaXMuaW5wdXRWYWx1ZS5sZW5ndGgpO1xuICAgIH1cbiAgICBzZWxlY3RDYXJldCgpIHtcbiAgICAgICAgY29uc3QgY2FyZXRQb3NpdGlvbiA9IGdldENhcmV0UG9zaXRpb24odGhpcy5udW1lcmljSW5wdXQubmF0aXZlRWxlbWVudCk7XG4gICAgICAgIGNvbnN0IGZvcm1hdHRlZFZhbHVlID0gdGhpcy5lbGVtZW50VmFsdWU7XG4gICAgICAgIGNvbnN0IHBhcnRpYWxWYWx1ZSA9IGZvcm1hdHRlZFZhbHVlLnN1YnN0cmluZygwLCBjYXJldFBvc2l0aW9uKTtcbiAgICAgICAgdGhpcy5zZXRJbnB1dFZhbHVlKCk7XG4gICAgICAgIGlmIChwYXJ0aWFsVmFsdWUubGVuZ3RoKSB7XG4gICAgICAgICAgICBjb25zdCBzaWduaWZpY2FudENoYXJzSW5Gb3JtYXR0ZWRWYWx1ZSA9IGV4dHJhY3RTaWduaWZpY2FudE51bWVyaWNDaGFycyhwYXJ0aWFsVmFsdWUsIHRoaXMuZGVjaW1hbFNlcGFyYXRvcik7XG4gICAgICAgICAgICBjb25zdCBhZGp1c3RlZFNpZ25pZmljYW50Q2hhcnMgPSB0aGlzLmFkanVzdFNpZ25pZmljYW50Q2hhcnMoZm9ybWF0dGVkVmFsdWUsIHNpZ25pZmljYW50Q2hhcnNJbkZvcm1hdHRlZFZhbHVlKTtcbiAgICAgICAgICAgIHRoaXMuc2V0U2VsZWN0aW9uKGFkanVzdGVkU2lnbmlmaWNhbnRDaGFycywgYWRqdXN0ZWRTaWduaWZpY2FudENoYXJzKTtcbiAgICAgICAgfVxuICAgICAgICBlbHNlIHtcbiAgICAgICAgICAgIHRoaXMuc2V0U2VsZWN0aW9uKDAsIDApO1xuICAgICAgICB9XG4gICAgfVxuICAgIG51bWJlck9mTGVhZGluZ1plcm9lcyhmb3JtYXR0ZWRWYWx1ZSkge1xuICAgICAgICBjb25zdCBzZXBhcmF0b3JJbmRleCA9IGZvcm1hdHRlZFZhbHVlLmluZGV4T2YodGhpcy5kZWNpbWFsU2VwYXJhdG9yKTtcbiAgICAgICAgY29uc3QgbWF0Y2hlZExlYWRpbmdaZXJvZXMgPSBmb3JtYXR0ZWRWYWx1ZS5tYXRjaCgvXlteMS05XSo/KDArKS8pO1xuICAgICAgICBpZiAobWF0Y2hlZExlYWRpbmdaZXJvZXMpIHtcbiAgICAgICAgICAgIGNvbnN0IGxlbmd0aE9mTWF0Y2ggPSBtYXRjaGVkTGVhZGluZ1plcm9lc1swXS5sZW5ndGg7XG4gICAgICAgICAgICBjb25zdCBsZW5ndGhPZkxlYWRpbmdaZXJvZXNNYXRjaCA9IG1hdGNoZWRMZWFkaW5nWmVyb2VzWzFdLmxlbmd0aDtcbiAgICAgICAgICAgIHJldHVybiBsZW5ndGhPZk1hdGNoID09PSBzZXBhcmF0b3JJbmRleCA/IGxlbmd0aE9mTGVhZGluZ1plcm9lc01hdGNoIC0gMSA6IGxlbmd0aE9mTGVhZGluZ1plcm9lc01hdGNoO1xuICAgICAgICB9XG4gICAgICAgIHJldHVybiAwO1xuICAgIH1cbiAgICBhZGp1c3RTaWduaWZpY2FudENoYXJzKGZvcm1hdHRlZFZhbHVlLCBzaWduaWZpY2FudENoYXJzKSB7XG4gICAgICAgIGNvbnN0IGxlYWRpbmdaZXJvZXMgPSB0aGlzLm51bWJlck9mTGVhZGluZ1plcm9lcyhmb3JtYXR0ZWRWYWx1ZSk7XG4gICAgICAgIGlmIChsZWFkaW5nWmVyb2VzID4gMCkge1xuICAgICAgICAgICAgcmV0dXJuIE1hdGgubWF4KDAsIHNpZ25pZmljYW50Q2hhcnMgLSBsZWFkaW5nWmVyb2VzKTtcbiAgICAgICAgfVxuICAgICAgICByZXR1cm4gc2lnbmlmaWNhbnRDaGFycztcbiAgICB9XG59XG5OdW1lcmljVGV4dEJveENvbXBvbmVudC5kZWNvcmF0b3JzID0gW1xuICAgIHsgdHlwZTogQ29tcG9uZW50LCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIGV4cG9ydEFzOiAna2VuZG9OdW1lcmljVGV4dEJveCcsXG4gICAgICAgICAgICAgICAgcHJvdmlkZXJzOiBbXG4gICAgICAgICAgICAgICAgICAgIExvY2FsaXphdGlvblNlcnZpY2UsXG4gICAgICAgICAgICAgICAgICAgIHsgcHJvdmlkZTogTDEwTl9QUkVGSVgsIHVzZVZhbHVlOiAna2VuZG8ubnVtZXJpY3RleHRib3gnIH0sXG4gICAgICAgICAgICAgICAgICAgIHsgcHJvdmlkZTogTkdfVkFMVUVfQUNDRVNTT1IsIHVzZUV4aXN0aW5nOiBmb3J3YXJkUmVmKCgpID0+IE51bWVyaWNUZXh0Qm94Q29tcG9uZW50KSwgbXVsdGk6IHRydWUgfSxcbiAgICAgICAgICAgICAgICAgICAgeyBwcm92aWRlOiBOR19WQUxJREFUT1JTLCB1c2VFeGlzdGluZzogZm9yd2FyZFJlZigoKSA9PiBOdW1lcmljVGV4dEJveENvbXBvbmVudCksIG11bHRpOiB0cnVlIH0sXG4gICAgICAgICAgICAgICAgICAgIHsgcHJvdmlkZTogS2VuZG9JbnB1dCwgdXNlRXhpc3Rpbmc6IGZvcndhcmRSZWYoKCkgPT4gTnVtZXJpY1RleHRCb3hDb21wb25lbnQpIH1cbiAgICAgICAgICAgICAgICBdLFxuICAgICAgICAgICAgICAgIHNlbGVjdG9yOiAna2VuZG8tbnVtZXJpY3RleHRib3gnLFxuICAgICAgICAgICAgICAgIHRlbXBsYXRlOiBgXG4gICAgICAgIDxuZy1jb250YWluZXIga2VuZG9OdW1lcmljVGV4dEJveExvY2FsaXplZE1lc3NhZ2VzXG4gICAgICAgICAgICBpMThuLWluY3JlbWVudD1cImtlbmRvLm51bWVyaWN0ZXh0Ym94LmluY3JlbWVudHxUaGUgdGl0bGUgZm9yIHRoZSAqKkluY3JlbWVudCoqIGJ1dHRvbiBpbiB0aGUgTnVtZXJpY1RleHRCb3hcIlxuICAgICAgICAgICAgaW5jcmVtZW50PVwiSW5jcmVhc2UgdmFsdWVcIlxuICAgICAgICAgICAgaTE4bi1kZWNyZW1lbnQ9XCJrZW5kby5udW1lcmljdGV4dGJveC5kZWNyZW1lbnR8VGhlIHRpdGxlIGZvciB0aGUgKipEZWNyZW1lbnQqKiBidXR0b24gaW4gdGhlIE51bWVyaWNUZXh0Qm94XCJcbiAgICAgICAgICAgIGRlY3JlbWVudD1cIkRlY3JlYXNlIHZhbHVlXCJcbiAgICAgICAgPlxuICAgICAgICA8L25nLWNvbnRhaW5lcj5cbiAgICAgICAgPHNwYW5cbiAgICAgICAgICAgIGNsYXNzPVwiay1udW1lcmljLXdyYXBcIlxuICAgICAgICAgICAgW2NsYXNzLmstc3RhdGUtZGlzYWJsZWRdPVwiZGlzYWJsZWRcIlxuICAgICAgICAgICAgW2tlbmRvRXZlbnRzT3V0c2lkZUFuZ3VsYXJdPVwieyBtb3VzZXdoZWVsOiBoYW5kbGVXaGVlbCwgRE9NTW91c2VTY3JvbGw6IGhhbmRsZVdoZWVsIH1cIlxuICAgICAgICAgICAgI251bWVyaWNXcmFwPlxuICAgICAgICAgICAgPGlucHV0XG4gICAgICAgICAgICByb2xlPVwic3BpbmJ1dHRvblwiXG4gICAgICAgICAgICBjbGFzcz1cImstaW5wdXQgay1mb3JtYXR0ZWQtdmFsdWVcIlxuICAgICAgICAgICAgYXV0b2NvbXBsZXRlPVwib2ZmXCJcbiAgICAgICAgICAgIGF1dG9jb3JyZWN0PVwib2ZmXCJcbiAgICAgICAgICAgIFtpZF09XCJmb2N1c2FibGVJZFwiXG4gICAgICAgICAgICBbYXR0ci5hcmlhLXZhbHVlbWluXT1cIm1pblwiXG4gICAgICAgICAgICBbYXR0ci5hcmlhLXZhbHVlbWF4XT1cIm1heFwiXG4gICAgICAgICAgICBbYXR0ci5hcmlhLXZhbHVlbm93XT1cInZhbHVlXCJcbiAgICAgICAgICAgIFthdHRyLnRpdGxlXT1cInRpdGxlXCJcbiAgICAgICAgICAgIFthdHRyLnBsYWNlaG9sZGVyXT1cInBsYWNlaG9sZGVyXCJcbiAgICAgICAgICAgIFt0YWJpbmRleF09XCJ0YWJJbmRleFwiXG4gICAgICAgICAgICBbZGlzYWJsZWRdPVwiZGlzYWJsZWRcIlxuICAgICAgICAgICAgW3JlYWRvbmx5XT1cInJlYWRvbmx5XCJcbiAgICAgICAgICAgIFtrZW5kb0V2ZW50c091dHNpZGVBbmd1bGFyXT1cIntcbiAgICAgICAgICAgICAgICBtb3VzZWRvd246IGhhbmRsZU1vdXNlRG93bixcbiAgICAgICAgICAgICAgICBkcmFnZW50ZXI6IGhhbmRsZURyYWdFbnRlcixcbiAgICAgICAgICAgICAgICBrZXlkb3duOiBoYW5kbGVLZXlEb3duLFxuICAgICAgICAgICAgICAgIGlucHV0OiBoYW5kbGVJbnB1dCxcbiAgICAgICAgICAgICAgICBmb2N1czogaGFuZGxlRm9jdXMsXG4gICAgICAgICAgICAgICAgYmx1cjogaGFuZGxlQmx1cixcbiAgICAgICAgICAgICAgICBwYXN0ZTogaGFuZGxlUGFzdGVcbiAgICAgICAgICAgIH1cIlxuICAgICAgICAgICAgI251bWVyaWNJbnB1dCAvPlxuICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJrLXNlbGVjdFwiICpuZ0lmPVwic3Bpbm5lcnNcIiBba2VuZG9FdmVudHNPdXRzaWRlQW5ndWxhcl09XCJ7IG1vdXNldXA6IHJlbGVhc2VBcnJvdywgbW91c2VsZWF2ZTogcmVsZWFzZUFycm93IH1cIj5cbiAgICAgICAgICAgICAgICA8c3BhblxuICAgICAgICAgICAgICAgICAgICBba2VuZG9FdmVudHNPdXRzaWRlQW5ndWxhcl09XCJ7IG1vdXNlZG93bjogaW5jcmVhc2VQcmVzcyB9XCJcbiAgICAgICAgICAgICAgICAgICAgW2F0dHIuYXJpYS1sYWJlbF09XCJpbmNyZW1lbnRUaXRsZVwiXG4gICAgICAgICAgICAgICAgICAgIFt0aXRsZV09XCJpbmNyZW1lbnRUaXRsZVwiXG4gICAgICAgICAgICAgICAgICAgIFtjbGFzcy5rLXN0YXRlLWFjdGl2ZV09XCJhcnJvd0RpcmVjdGlvbiA9PT0gQXJyb3dEaXJlY3Rpb24uVXBcIlxuICAgICAgICAgICAgICAgICAgICBjbGFzcz1cImstbGluayBrLWxpbmstaW5jcmVhc2VcIlxuICAgICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJrLWljb24gay1pLWFycm93LW5cIj48L3NwYW4+XG4gICAgICAgICAgICAgICAgPC9zcGFuPlxuICAgICAgICAgICAgICAgIDxzcGFuXG4gICAgICAgICAgICAgICAgICAgIFtrZW5kb0V2ZW50c091dHNpZGVBbmd1bGFyXT1cInsgbW91c2Vkb3duOiBkZWNyZWFzZVByZXNzIH1cIlxuICAgICAgICAgICAgICAgICAgICBbYXR0ci5hcmlhLWxhYmVsXT1cImRlY3JlbWVudFRpdGxlXCJcbiAgICAgICAgICAgICAgICAgICAgW3RpdGxlXT1cImRlY3JlbWVudFRpdGxlXCJcbiAgICAgICAgICAgICAgICAgICAgW2NsYXNzLmstc3RhdGUtYWN0aXZlXT1cImFycm93RGlyZWN0aW9uID09PSBBcnJvd0RpcmVjdGlvbi5Eb3duXCJcbiAgICAgICAgICAgICAgICAgICAgY2xhc3M9XCJrLWxpbmsgay1saW5rLWRlY3JlYXNlXCJcbiAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwiay1pY29uIGstaS1hcnJvdy1zXCI+PC9zcGFuPlxuICAgICAgICAgICAgICAgIDwvc3Bhbj5cbiAgICAgICAgICAgIDwvc3Bhbj5cbiAgICAgICAgPC9zcGFuPlxuICAgICAgYFxuICAgICAgICAgICAgfSxdIH0sXG5dO1xuLyoqIEBub2NvbGxhcHNlICovXG5OdW1lcmljVGV4dEJveENvbXBvbmVudC5jdG9yUGFyYW1ldGVycyA9ICgpID0+IFtcbiAgICB7IHR5cGU6IEludGxTZXJ2aWNlIH0sXG4gICAgeyB0eXBlOiBSZW5kZXJlcjIgfSxcbiAgICB7IHR5cGU6IExvY2FsaXphdGlvblNlcnZpY2UgfSxcbiAgICB7IHR5cGU6IEluamVjdG9yIH0sXG4gICAgeyB0eXBlOiBOZ1pvbmUgfSxcbiAgICB7IHR5cGU6IENoYW5nZURldGVjdG9yUmVmIH0sXG4gICAgeyB0eXBlOiBFbGVtZW50UmVmIH1cbl07XG5OdW1lcmljVGV4dEJveENvbXBvbmVudC5wcm9wRGVjb3JhdG9ycyA9IHtcbiAgICBmb2N1c2FibGVJZDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgZGlzYWJsZWQ6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHJlYWRvbmx5OiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICB0aXRsZTogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgYXV0b0NvcnJlY3Q6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIGZvcm1hdDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgbWF4OiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBtaW46IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIGRlY2ltYWxzOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBwbGFjZWhvbGRlcjogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgc3RlcDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgc3Bpbm5lcnM6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHJhbmdlVmFsaWRhdGlvbjogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgdGFiaW5kZXg6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHRhYkluZGV4OiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBzZWxlY3RPbkZvY3VzOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICB2YWx1ZTogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgdmFsdWVDaGFuZ2U6IFt7IHR5cGU6IE91dHB1dCB9XSxcbiAgICBvbkZvY3VzOiBbeyB0eXBlOiBPdXRwdXQsIGFyZ3M6IFsnZm9jdXMnLF0gfV0sXG4gICAgb25CbHVyOiBbeyB0eXBlOiBPdXRwdXQsIGFyZ3M6IFsnYmx1cicsXSB9XSxcbiAgICBudW1lcmljSW5wdXQ6IFt7IHR5cGU6IFZpZXdDaGlsZCwgYXJnczogWydudW1lcmljSW5wdXQnLCB7IHN0YXRpYzogdHJ1ZSB9LF0gfV0sXG4gICAgbnVtZXJpY1dyYXA6IFt7IHR5cGU6IFZpZXdDaGlsZCwgYXJnczogWydudW1lcmljV3JhcCcsXSB9XSxcbiAgICBkaXJlY3Rpb246IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2F0dHIuZGlyJyxdIH1dLFxuICAgIHdpZGdldENsYXNzZXM6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstd2lkZ2V0JyxdIH0sIHsgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnY2xhc3Muay1udW1lcmljdGV4dGJveCcsXSB9XVxufTtcblxuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNsYXNzIE51bWVyaWNUZXh0Qm94TWVzc2FnZXMgZXh0ZW5kcyBDb21wb25lbnRNZXNzYWdlcyB7XG59XG5OdW1lcmljVGV4dEJveE1lc3NhZ2VzLnByb3BEZWNvcmF0b3JzID0ge1xuICAgIGRlY3JlbWVudDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgaW5jcmVtZW50OiBbeyB0eXBlOiBJbnB1dCB9XVxufTtcblxuLyoqXG4gKiBDdXN0b20gY29tcG9uZW50IG1lc3NhZ2VzIG92ZXJyaWRlIGRlZmF1bHQgY29tcG9uZW50IG1lc3NhZ2VzLlxuICovXG5jbGFzcyBOdW1lcmljVGV4dEJveEN1c3RvbU1lc3NhZ2VzQ29tcG9uZW50IGV4dGVuZHMgTnVtZXJpY1RleHRCb3hNZXNzYWdlcyB7XG4gICAgY29uc3RydWN0b3Ioc2VydmljZSkge1xuICAgICAgICBzdXBlcigpO1xuICAgICAgICB0aGlzLnNlcnZpY2UgPSBzZXJ2aWNlO1xuICAgIH1cbiAgICBnZXQgb3ZlcnJpZGUoKSB7XG4gICAgICAgIHJldHVybiB0cnVlO1xuICAgIH1cbn1cbk51bWVyaWNUZXh0Qm94Q3VzdG9tTWVzc2FnZXNDb21wb25lbnQuZGVjb3JhdG9ycyA9IFtcbiAgICB7IHR5cGU6IENvbXBvbmVudCwgYXJnczogW3tcbiAgICAgICAgICAgICAgICBwcm92aWRlcnM6IFtcbiAgICAgICAgICAgICAgICAgICAge1xuICAgICAgICAgICAgICAgICAgICAgICAgcHJvdmlkZTogTnVtZXJpY1RleHRCb3hNZXNzYWdlcyxcbiAgICAgICAgICAgICAgICAgICAgICAgIHVzZUV4aXN0aW5nOiBmb3J3YXJkUmVmKCgpID0+IE51bWVyaWNUZXh0Qm94Q3VzdG9tTWVzc2FnZXNDb21wb25lbnQpIC8vIHRzbGludDpkaXNhYmxlLWxpbmU6bm8tZm9yd2FyZC1yZWZcbiAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIF0sXG4gICAgICAgICAgICAgICAgc2VsZWN0b3I6ICdrZW5kby1udW1lcmljdGV4dGJveC1tZXNzYWdlcycsXG4gICAgICAgICAgICAgICAgdGVtcGxhdGU6IGBgXG4gICAgICAgICAgICB9LF0gfSxcbl07XG4vKiogQG5vY29sbGFwc2UgKi9cbk51bWVyaWNUZXh0Qm94Q3VzdG9tTWVzc2FnZXNDb21wb25lbnQuY3RvclBhcmFtZXRlcnMgPSAoKSA9PiBbXG4gICAgeyB0eXBlOiBMb2NhbGl6YXRpb25TZXJ2aWNlIH1cbl07XG5cbi8qKlxuICogQGhpZGRlblxuICovXG52YXIgUmVzdWx0VHlwZTtcbihmdW5jdGlvbiAoUmVzdWx0VHlwZSkge1xuICAgIFJlc3VsdFR5cGVbUmVzdWx0VHlwZVtcIkxpdGVyYWxcIl0gPSAwXSA9IFwiTGl0ZXJhbFwiO1xuICAgIFJlc3VsdFR5cGVbUmVzdWx0VHlwZVtcIk1hc2tcIl0gPSAxXSA9IFwiTWFza1wiO1xuICAgIFJlc3VsdFR5cGVbUmVzdWx0VHlwZVtcIlVuZGVmaW5lZFwiXSA9IDJdID0gXCJVbmRlZmluZWRcIjtcbn0pKFJlc3VsdFR5cGUgfHwgKFJlc3VsdFR5cGUgPSB7fSkpO1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNsYXNzIFJlc3VsdCB7XG4gICAgY29uc3RydWN0b3IodmFsdWUsIHJlc3QsIHR5cGUgPSBSZXN1bHRUeXBlLlVuZGVmaW5lZCkge1xuICAgICAgICB0aGlzLnZhbHVlID0gdmFsdWU7XG4gICAgICAgIHRoaXMucmVzdCA9IHJlc3Q7XG4gICAgICAgIHRoaXMudHlwZSA9IHR5cGU7XG4gICAgfVxuICAgIC8vbWFwIDo6IEZ1bmN0b3IgZiA9PiBmIGEgfj4gKGEgLT4gYikgLT4gZiBiXG4gICAgbWFwKGZuKSB7XG4gICAgICAgIHJldHVybiBuZXcgUmVzdWx0KGZuKHRoaXMudmFsdWUpLCB0aGlzLnJlc3QpO1xuICAgIH1cbiAgICAvL2NoYWluIDo6IENoYWluIG0gPT4gbSBhIH4+IChhIC0+IG0gYikgLT4gbSBiXG4gICAgY2hhaW4oZm4pIHtcbiAgICAgICAgcmV0dXJuIGZuKHRoaXMudmFsdWUsIHRoaXMucmVzdCk7XG4gICAgfVxuICAgIGZvbGQocywgXyAvKndlIGRvbid0IG5lZWQgaXQqLykge1xuICAgICAgICByZXR1cm4gcyh0aGlzLnZhbHVlLCB0aGlzLnJlc3QpO1xuICAgIH1cbiAgICBjb25jYXQocikge1xuICAgICAgICByZXR1cm4gdGhpcy5tYXAoKHZzLCBfKSA9PiByLmNoYWluKCh2LCBfXykgPT4gdnMuY29uY2F0KFt2XSkpKTtcbiAgICB9XG4gICAgdG9TdHJpbmcoKSB7XG4gICAgICAgIHJldHVybiBgUmVzdWx0KHsgdmFsdWU6ICcke3RoaXMudmFsdWV9JywgcmVzdDogJHt0aGlzLnJlc3R9IH0pYDtcbiAgICB9XG59XG5cbi8qKlxuICogQGhpZGRlblxuICovXG5jbGFzcyBTdHJlYW0ge1xuICAgIGNvbnN0cnVjdG9yKGlucHV0ID0gW10sIGNvbnRyb2wgPSBbXSkge1xuICAgICAgICB0aGlzLmlucHV0ID0gaW5wdXQ7XG4gICAgICAgIHRoaXMuY29udHJvbCA9IGNvbnRyb2w7XG4gICAgICAgIHRoaXMuaW5wdXRDdXJzb3IgPSAwO1xuICAgICAgICB0aGlzLmNvbnRyb2xDdXJzb3IgPSAwO1xuICAgIH1cbiAgICBlb2YoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmlucHV0Q3Vyc29yID49IHRoaXMuaW5wdXQubGVuZ3RoO1xuICAgIH1cbiAgICAvLyBHZXQgdGhlIGZpcnN0IHZhbHVlIGZyb20gdGhlIGlucHV0LlxuICAgIG5leHQoKSB7XG4gICAgICAgIHJldHVybiB7XG4gICAgICAgICAgICBjaGFyOiB0aGlzLmlucHV0W3RoaXMuaW5wdXRDdXJzb3IrK10sXG4gICAgICAgICAgICBjb250cm9sOiB0aGlzLmNvbnRyb2xbdGhpcy5jb250cm9sQ3Vyc29yKytdXG4gICAgICAgIH07XG4gICAgfVxuICAgIHBlZWsoKSB7XG4gICAgICAgIHJldHVybiB7XG4gICAgICAgICAgICBjaGFyOiB0aGlzLmlucHV0W3RoaXMuaW5wdXRDdXJzb3JdLFxuICAgICAgICAgICAgY29udHJvbDogdGhpcy5jb250cm9sW3RoaXMuY29udHJvbEN1cnNvcl1cbiAgICAgICAgfTtcbiAgICB9XG4gICAgZWF0X2lucHV0KCkge1xuICAgICAgICB0aGlzLmlucHV0Q3Vyc29yKys7XG4gICAgfVxuICAgIGVhdF9jb250cm9sKCkge1xuICAgICAgICB0aGlzLmNvbnRyb2xDdXJzb3IrKztcbiAgICB9XG4gICAgZWF0KCkge1xuICAgICAgICB0aGlzLmlucHV0Q3Vyc29yKys7XG4gICAgICAgIHRoaXMuY29udHJvbEN1cnNvcisrO1xuICAgIH1cbn1cblxuY29uc3QgdG9BcnJheSA9ICh2YWx1ZSkgPT4gKHZhbHVlIHx8ICcnKS5zcGxpdCgnJyk7XG5jb25zdCBFU0NBUEVfQ0hBUkFDVEVSID0gJ1xcXFwnO1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNsYXNzIFBhcnNlciB7XG4gICAgY29uc3RydWN0b3IocGFyc2UpIHtcbiAgICAgICAgdGhpcy5wYXJzZSA9IHBhcnNlO1xuICAgIH1cbiAgICBydW4oaW5wdXQsIGNvbnRyb2wgPSAnJykge1xuICAgICAgICBpZiAoaW5wdXQgaW5zdGFuY2VvZiBTdHJlYW0pIHtcbiAgICAgICAgICAgIHJldHVybiB0aGlzLnBhcnNlKGlucHV0KTtcbiAgICAgICAgfVxuICAgICAgICBlbHNlIHtcbiAgICAgICAgICAgIHJldHVybiB0aGlzLnBhcnNlKG5ldyBTdHJlYW0odG9BcnJheShpbnB1dCksIHRvQXJyYXkoY29udHJvbCkpKTtcbiAgICAgICAgfVxuICAgIH1cbiAgICAvL21hcCA6OiBGdW5jdG9yIGYgPT4gZiBhIH4+IChhIC0+IGIpIC0+IGYgYlxuICAgIG1hcChmKSB7XG4gICAgICAgIHJldHVybiBuZXcgUGFyc2VyKHN0cmVhbSA9PiB0aGlzLnBhcnNlKHN0cmVhbSkubWFwKGYpKTtcbiAgICB9XG4gICAgLy9jaGFpbiA6OiBDaGFpbiBtID0+IG0gYSB+PiAoYSAtPiBtIGIpIC0+IG0gYlxuICAgIGNoYWluKGYpIHtcbiAgICAgICAgcmV0dXJuIG5ldyBQYXJzZXIoc3RyZWFtID0+IHRoaXMucGFyc2Uoc3RyZWFtKS5jaGFpbigodiwgcykgPT4gZih2KS5ydW4ocykpKTtcbiAgICB9XG4gICAgaXNMaXRlcmFsKGMpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMucnVuKGMpLnR5cGUgPT09IFJlc3VsdFR5cGUuTGl0ZXJhbDtcbiAgICB9XG59XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgbWFzayA9ICh7IHByb21wdCwgcHJvbXB0UGxhY2Vob2xkZXIgfSkgPT4gcnVsZSA9PiBuZXcgUGFyc2VyKHN0cmVhbSA9PiB7XG4gICAgd2hpbGUgKCFzdHJlYW0uZW9mKCkpIHtcbiAgICAgICAgY29uc3QgeyBjaGFyLCBjb250cm9sIH0gPSBzdHJlYW0ucGVlaygpO1xuICAgICAgICBpZiAoY2hhciA9PT0gY29udHJvbCAmJiBjb250cm9sID09PSBwcm9tcHQpIHtcbiAgICAgICAgICAgIHN0cmVhbS5lYXQoKTtcbiAgICAgICAgICAgIHJldHVybiBuZXcgUmVzdWx0KHByb21wdCwgc3RyZWFtLCBSZXN1bHRUeXBlLk1hc2spO1xuICAgICAgICB9XG4gICAgICAgIGlmIChydWxlLnRlc3QoY2hhcikpIHtcbiAgICAgICAgICAgIHN0cmVhbS5lYXQoKTtcbiAgICAgICAgICAgIHJldHVybiBuZXcgUmVzdWx0KGNoYXIsIHN0cmVhbSwgUmVzdWx0VHlwZS5NYXNrKTtcbiAgICAgICAgfVxuICAgICAgICBpZiAoY2hhciA9PT0gcHJvbXB0UGxhY2Vob2xkZXIpIHtcbiAgICAgICAgICAgIHN0cmVhbS5lYXQoKTtcbiAgICAgICAgICAgIHJldHVybiBuZXcgUmVzdWx0KHByb21wdCwgc3RyZWFtLCBSZXN1bHRUeXBlLk1hc2spO1xuICAgICAgICB9XG4gICAgICAgIHN0cmVhbS5lYXRfaW5wdXQoKTtcbiAgICB9XG4gICAgc3RyZWFtLmVhdCgpO1xuICAgIHJldHVybiBuZXcgUmVzdWx0KHByb21wdCwgc3RyZWFtLCBSZXN1bHRUeXBlLk1hc2spO1xufSk7XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgbGl0ZXJhbCA9IF90b2tlbiA9PiBuZXcgUGFyc2VyKHN0cmVhbSA9PiB7XG4gICAgLy8gICAgbGV0IHtjaGFyLCBjb250cm9sfSA9IHN0cmVhbS5wZWVrKCk7XG4gICAgbGV0IGNoYXIgPSBzdHJlYW0ucGVlaygpLmNoYXI7XG4gICAgaWYgKGNoYXIgPT09IF90b2tlbikge1xuICAgICAgICBzdHJlYW0uZWF0KCk7XG4gICAgICAgIHJldHVybiBuZXcgUmVzdWx0KF90b2tlbiwgc3RyZWFtLCBSZXN1bHRUeXBlLkxpdGVyYWwpO1xuICAgIH1cbiAgICAvLyAgICBpZiAoY29udHJvbCA9PT0gX3Rva2VuKSB7XG4gICAgLy8gICAgICAgIHdoaWxlICghc3RyZWFtLmVvZigpICYmIGNoYXIgIT09IF90b2tlbikge1xuICAgIC8vICAgICAgICAgICAgc3RyZWFtLmVhdF9pbnB1dCgpO1xuICAgIC8vICAgICAgICAgICAgY2hhciA9IHN0cmVhbS5wZWVrKCkuY2hhcjtcbiAgICAvLyAgICAgICAgfVxuICAgIC8vICAgIH1cbiAgICAvL1xuICAgIC8vICAgIGlmIChjb250cm9sICE9PSB1bmRlZmluZWQpIHtcbiAgICAvLyAgICAgICAgc3RyZWFtLmVhdCgpO1xuICAgIC8vICAgIH1cbiAgICByZXR1cm4gbmV3IFJlc3VsdChfdG9rZW4sIHN0cmVhbSwgUmVzdWx0VHlwZS5MaXRlcmFsKTtcbn0pO1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IHVubWFzayA9IHByb21wdCA9PiBydWxlID0+IG5ldyBQYXJzZXIoc3RyZWFtID0+IHtcbiAgICB3aGlsZSAoIXN0cmVhbS5lb2YoKSkge1xuICAgICAgICBjb25zdCB7IGNoYXIsIGNvbnRyb2wgfSA9IHN0cmVhbS5wZWVrKCk7XG4gICAgICAgIGlmIChjaGFyID09PSBwcm9tcHQgJiYgY29udHJvbCA9PT0gcHJvbXB0KSB7XG4gICAgICAgICAgICBzdHJlYW0uZWF0KCk7XG4gICAgICAgICAgICByZXR1cm4gbmV3IFJlc3VsdChjaGFyLCBzdHJlYW0pO1xuICAgICAgICB9XG4gICAgICAgIGlmIChydWxlLnRlc3QoY2hhcikpIHtcbiAgICAgICAgICAgIHN0cmVhbS5lYXQoKTtcbiAgICAgICAgICAgIHJldHVybiBuZXcgUmVzdWx0KGNoYXIsIHN0cmVhbSk7XG4gICAgICAgIH1cbiAgICAgICAgc3RyZWFtLmVhdF9pbnB1dCgpO1xuICAgIH1cbiAgICBzdHJlYW0uZWF0KCk7XG4gICAgcmV0dXJuIG5ldyBSZXN1bHQoJycsIHN0cmVhbSk7XG59KTtcbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCB1bmxpdGVyYWwgPSBfdG9rZW4gPT4gbmV3IFBhcnNlcihzdHJlYW0gPT4ge1xuICAgIGlmIChzdHJlYW0uZW9mKCkpIHtcbiAgICAgICAgcmV0dXJuIG5ldyBSZXN1bHQoJycsIHN0cmVhbSk7XG4gICAgfVxuICAgIGNvbnN0IHsgY2hhciB9ID0gc3RyZWFtLnBlZWsoKTtcbiAgICBpZiAoY2hhciA9PT0gX3Rva2VuKSB7XG4gICAgICAgIHN0cmVhbS5lYXQoKTtcbiAgICB9XG4gICAgcmV0dXJuIG5ldyBSZXN1bHQoX3Rva2VuLCBzdHJlYW0pO1xufSk7XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgdG9rZW4gPSAocnVsZXMsIGNyZWF0b3IpID0+IG5ldyBQYXJzZXIoc3RyZWFtID0+IHtcbiAgICBsZXQgeyBjaGFyIH0gPSBzdHJlYW0ubmV4dCgpO1xuICAgIGNvbnN0IHJ1bGUgPSBydWxlc1tjaGFyXTtcbiAgICBpZiAoY2hhciA9PT0gRVNDQVBFX0NIQVJBQ1RFUikge1xuICAgICAgICBjaGFyID0gc3RyZWFtLm5leHQoKS5jaGFyO1xuICAgICAgICByZXR1cm4gbmV3IFJlc3VsdChjcmVhdG9yLmxpdGVyYWwoY2hhciksIHN0cmVhbSk7XG4gICAgfVxuICAgIGlmICghcnVsZSkge1xuICAgICAgICByZXR1cm4gbmV3IFJlc3VsdChjcmVhdG9yLmxpdGVyYWwoY2hhciksIHN0cmVhbSk7XG4gICAgfVxuICAgIHJldHVybiBuZXcgUmVzdWx0KGNyZWF0b3IubWFzayhydWxlKSwgc3RyZWFtKTtcbn0pO1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IHJhd01hc2sgPSAoeyBwcm9tcHQsIHByb21wdFBsYWNlaG9sZGVyIH0pID0+IG5ldyBQYXJzZXIoc3RyZWFtID0+IHtcbiAgICBsZXQgeyBjaGFyIH0gPSBzdHJlYW0ubmV4dCgpO1xuICAgIGlmIChjaGFyID09PSBwcm9tcHQpIHtcbiAgICAgICAgcmV0dXJuIG5ldyBSZXN1bHQocHJvbXB0UGxhY2Vob2xkZXIsIHN0cmVhbSk7XG4gICAgfVxuICAgIHJldHVybiBuZXcgUmVzdWx0KGNoYXIsIHN0cmVhbSk7XG59KTtcbi8qKlxuICogQGhpZGRlblxuICovXG5jb25zdCByYXdMaXRlcmFsID0gaW5jbHVkZUxpdGVyYWxzID0+IG5ldyBQYXJzZXIoc3RyZWFtID0+IHtcbiAgICBsZXQgeyBjaGFyIH0gPSBzdHJlYW0ubmV4dCgpO1xuICAgIGlmIChpbmNsdWRlTGl0ZXJhbHMpIHtcbiAgICAgICAgcmV0dXJuIG5ldyBSZXN1bHQoY2hhciwgc3RyZWFtKTtcbiAgICB9XG4gICAgcmV0dXJuIG5ldyBSZXN1bHQoJycsIHN0cmVhbSk7XG59KTtcblxuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IGFsd2F5cyA9IHZhbHVlID0+IG5ldyBQYXJzZXIoc3RyZWFtID0+IG5ldyBSZXN1bHQodmFsdWUsIHN0cmVhbSkpO1xuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNvbnN0IGFwcGVuZCA9IChwMSwgcDIpID0+IHAxLmNoYWluKHZzID0+IHAyLm1hcCh2ID0+IHZzLmNvbmNhdChbdl0pKSk7XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3Qgc2VxdWVuY2UgPSBsaXN0ID0+IGxpc3QucmVkdWNlKChhY2MsIHBhcnNlcikgPT4gYXBwZW5kKGFjYywgcGFyc2VyKSwgYWx3YXlzKFtdKSk7XG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgZ3JlZWR5ID0gcGFyc2VyID0+IG5ldyBQYXJzZXIoc3RyZWFtID0+IHtcbiAgICBsZXQgcmVzdWx0ID0gbmV3IFJlc3VsdChbXSwgc3RyZWFtKTtcbiAgICB3aGlsZSAoIXN0cmVhbS5lb2YoKSkge1xuICAgICAgICByZXN1bHQgPSByZXN1bHQuY29uY2F0KHBhcnNlci5ydW4oc3RyZWFtKSk7XG4gICAgfVxuICAgIHJldHVybiByZXN1bHQ7XG59KTtcblxuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNsYXNzIE1hc2tpbmdTZXJ2aWNlIHtcbiAgICBjb25zdHJ1Y3RvcigpIHtcbiAgICAgICAgdGhpcy5ydWxlcyA9IHt9O1xuICAgICAgICB0aGlzLnByb21wdCA9IFwiX1wiO1xuICAgICAgICB0aGlzLm1hc2sgPSBcIlwiO1xuICAgICAgICB0aGlzLnByb21wdFBsYWNlaG9sZGVyID0gXCIgXCI7XG4gICAgICAgIHRoaXMuaW5jbHVkZUxpdGVyYWxzID0gZmFsc2U7XG4gICAgICAgIHRoaXMubWFza1Rva2VucyA9IFtdO1xuICAgICAgICB0aGlzLnVubWFza1Rva2VucyA9IFtdO1xuICAgICAgICB0aGlzLnJhd1Rva2VucyA9IFtdO1xuICAgICAgICB0aGlzLnZhbGlkYXRpb25Ub2tlbnMgPSBbXTtcbiAgICB9XG4gICAgdXBkYXRlKHsgbWFzazogbWFzayQkMSA9ICcnLCBwcm9tcHQgPSAnJywgcHJvbXB0UGxhY2Vob2xkZXIgPSAnICcsIHJ1bGVzID0ge30sIGluY2x1ZGVMaXRlcmFscyA9IGZhbHNlIH0pIHtcbiAgICAgICAgdGhpcy5tYXNrID0gbWFzayQkMTtcbiAgICAgICAgdGhpcy5wcm9tcHQgPSBwcm9tcHQ7XG4gICAgICAgIHRoaXMucHJvbXB0UGxhY2Vob2xkZXIgPSBwcm9tcHRQbGFjZWhvbGRlcjtcbiAgICAgICAgdGhpcy5ydWxlcyA9IHJ1bGVzO1xuICAgICAgICB0aGlzLmluY2x1ZGVMaXRlcmFscyA9IGluY2x1ZGVMaXRlcmFscztcbiAgICAgICAgdGhpcy50b2tlbml6ZSgpO1xuICAgIH1cbiAgICB2YWxpZGF0aW9uVmFsdWUobWFza2VkVmFsdWUgPSAnJykge1xuICAgICAgICBsZXQgdmFsdWUgPSBtYXNrZWRWYWx1ZTtcbiAgICAgICAgc2VxdWVuY2UodGhpcy52YWxpZGF0aW9uVG9rZW5zKVxuICAgICAgICAgICAgLnJ1bihtYXNrZWRWYWx1ZSlcbiAgICAgICAgICAgIC5mb2xkKHVubWFza2VkID0+IHtcbiAgICAgICAgICAgIHZhbHVlID0gdW5tYXNrZWQuam9pbignJyk7XG4gICAgICAgIH0pO1xuICAgICAgICByZXR1cm4gdmFsdWU7XG4gICAgfVxuICAgIHJhd1ZhbHVlKG1hc2tlZFZhbHVlID0gJycpIHtcbiAgICAgICAgbGV0IHZhbHVlID0gbWFza2VkVmFsdWU7XG4gICAgICAgIGlmICghdGhpcy5yYXdUb2tlbnMubGVuZ3RoKSB7XG4gICAgICAgICAgICByZXR1cm4gdmFsdWU7XG4gICAgICAgIH1cbiAgICAgICAgc2VxdWVuY2UodGhpcy5yYXdUb2tlbnMpXG4gICAgICAgICAgICAucnVuKG1hc2tlZFZhbHVlKVxuICAgICAgICAgICAgLmZvbGQodW5tYXNrZWQgPT4ge1xuICAgICAgICAgICAgdmFsdWUgPSB1bm1hc2tlZC5qb2luKCcnKTtcbiAgICAgICAgfSk7XG4gICAgICAgIHJldHVybiB2YWx1ZTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIG1hc2tSYXcocmF3VmFsdWUgPSAnJykge1xuICAgICAgICBsZXQgdmFsdWUgPSByYXdWYWx1ZTtcbiAgICAgICAgaWYgKCF0aGlzLm1hc2tUb2tlbnMubGVuZ3RoKSB7XG4gICAgICAgICAgICByZXR1cm4gdmFsdWU7XG4gICAgICAgIH1cbiAgICAgICAgc2VxdWVuY2UodGhpcy5tYXNrVG9rZW5zKVxuICAgICAgICAgICAgLnJ1bihyYXdWYWx1ZSlcbiAgICAgICAgICAgIC5mb2xkKG1hc2tlZCA9PiB7XG4gICAgICAgICAgICB2YWx1ZSA9IG1hc2tlZC5qb2luKCcnKTtcbiAgICAgICAgfSk7XG4gICAgICAgIHJldHVybiB2YWx1ZTtcbiAgICB9XG4gICAgbWFza0lucHV0KGlucHV0LCBjb250cm9sLCBzcGxpdFBvaW50KSB7XG4gICAgICAgIGlmIChpbnB1dC5sZW5ndGggPCBjb250cm9sLmxlbmd0aCkge1xuICAgICAgICAgICAgcmV0dXJuIHRoaXMubWFza1JlbW92ZWQoaW5wdXQsIGNvbnRyb2wsIHNwbGl0UG9pbnQpO1xuICAgICAgICB9XG4gICAgICAgIHJldHVybiB0aGlzLm1hc2tJbnNlcnRlZChpbnB1dCwgY29udHJvbCwgc3BsaXRQb2ludCk7XG4gICAgfVxuICAgIG1hc2tJblJhbmdlKHBhc3RlZCwgb2xkVmFsdWUsIHN0YXJ0LCBlbmQpIHtcbiAgICAgICAgbGV0IHZhbHVlID0gJyc7XG4gICAgICAgIGxldCBzZWxlY3Rpb24gPSBlbmQ7XG4gICAgICAgIGNvbnN0IGJlZm9yZUNoYW5nZSA9IG9sZFZhbHVlLnNwbGl0KCcnKS5zbGljZSgwLCBzdGFydCk7XG4gICAgICAgIGNvbnN0IGFmdGVyQ2hhbmdlID0gb2xkVmFsdWUuc3BsaXQoJycpLnNsaWNlKGVuZCk7XG4gICAgICAgIHNlcXVlbmNlKHRoaXMubWFza1Rva2Vucy5zbGljZShzdGFydCwgZW5kKSlcbiAgICAgICAgICAgIC5ydW4ocGFzdGVkKVxuICAgICAgICAgICAgLmZvbGQobWFza2VkID0+IHtcbiAgICAgICAgICAgIHZhbHVlID0gYmVmb3JlQ2hhbmdlXG4gICAgICAgICAgICAgICAgLmNvbmNhdChtYXNrZWQpXG4gICAgICAgICAgICAgICAgLmNvbmNhdChhZnRlckNoYW5nZSlcbiAgICAgICAgICAgICAgICAuam9pbignJyk7XG4gICAgICAgIH0pO1xuICAgICAgICByZXR1cm4ge1xuICAgICAgICAgICAgc2VsZWN0aW9uLFxuICAgICAgICAgICAgdmFsdWVcbiAgICAgICAgfTtcbiAgICB9XG4gICAgbWFza1JlbW92ZWQoaW5wdXQsIGNvbnRyb2wsIHNwbGl0UG9pbnQpIHtcbiAgICAgICAgbGV0IHZhbHVlID0gJyc7XG4gICAgICAgIGxldCBzZWxlY3Rpb24gPSBzcGxpdFBvaW50O1xuICAgICAgICBjb25zdCB1bmNoYW5nZWQgPSBpbnB1dC5zcGxpdCgnJykuc2xpY2Uoc3BsaXRQb2ludCk7XG4gICAgICAgIGNvbnN0IGNoYW5nZWQgPSBpbnB1dC5zcGxpdCgnJykuc2xpY2UoMCwgc3BsaXRQb2ludCkuam9pbignJyk7XG4gICAgICAgIGNvbnN0IHRha2UkJDEgPSB0aGlzLm1hc2tUb2tlbnMubGVuZ3RoIC0gKGlucHV0Lmxlbmd0aCAtIHNwbGl0UG9pbnQpO1xuICAgICAgICBzZXF1ZW5jZSh0aGlzLm1hc2tUb2tlbnMuc2xpY2UoMCwgdGFrZSQkMSkpXG4gICAgICAgICAgICAucnVuKGNoYW5nZWQsIGNvbnRyb2wpXG4gICAgICAgICAgICAuZm9sZChtYXNrZWQgPT4ge1xuICAgICAgICAgICAgc2VsZWN0aW9uID0gdGhpcy5hZGp1c3RQb3NpdGlvbihtYXNrZWQsIHNlbGVjdGlvbik7XG4gICAgICAgICAgICB2YWx1ZSA9IG1hc2tlZC5jb25jYXQodW5jaGFuZ2VkKS5qb2luKCcnKTtcbiAgICAgICAgfSk7XG4gICAgICAgIHJldHVybiB7XG4gICAgICAgICAgICBzZWxlY3Rpb24sXG4gICAgICAgICAgICB2YWx1ZVxuICAgICAgICB9O1xuICAgIH1cbiAgICBhZGp1c3RQb3NpdGlvbihpbnB1dCwgc2VsZWN0aW9uKSB7XG4gICAgICAgIGNvbnN0IGNhcmV0Q2hhciA9IGlucHV0W3NlbGVjdGlvbl07XG4gICAgICAgIGNvbnN0IGlzTGl0ZXJhbCA9IHRoaXMubWFza1Rva2Vuc1tzZWxlY3Rpb25dLmlzTGl0ZXJhbChjYXJldENoYXIpO1xuICAgICAgICBpZiAoIWlzTGl0ZXJhbCAmJiBjYXJldENoYXIgIT09IHRoaXMucHJvbXB0KSB7XG4gICAgICAgICAgICByZXR1cm4gc2VsZWN0aW9uICsgMTtcbiAgICAgICAgfVxuICAgICAgICByZXR1cm4gc2VsZWN0aW9uO1xuICAgIH1cbiAgICBtYXNrSW5zZXJ0ZWQoaW5wdXQsIGNvbnRyb2wsIHNwbGl0UG9pbnQpIHtcbiAgICAgICAgbGV0IHZhbHVlID0gJyc7XG4gICAgICAgIGxldCBzZWxlY3Rpb24gPSBzcGxpdFBvaW50O1xuICAgICAgICBjb25zdCBjaGFuZ2VkID0gaW5wdXQuc2xpY2UoMCwgc3BsaXRQb2ludCk7XG4gICAgICAgIHNlcXVlbmNlKHRoaXMudW5tYXNrVG9rZW5zKVxuICAgICAgICAgICAgLnJ1bihjaGFuZ2VkLCBjb250cm9sKVxuICAgICAgICAgICAgLmNoYWluKHVubWFza2VkID0+IHtcbiAgICAgICAgICAgIHNlbGVjdGlvbiA9IHVubWFza2VkLmpvaW4oJycpLmxlbmd0aDtcbiAgICAgICAgICAgIGNvbnN0IHVuY2hhbmdlZCA9IGNvbnRyb2wuc2xpY2Uoc2VsZWN0aW9uKTtcbiAgICAgICAgICAgIHJldHVybiBzZXF1ZW5jZSh0aGlzLm1hc2tUb2tlbnMpXG4gICAgICAgICAgICAgICAgLnJ1bih1bm1hc2tlZC5qb2luKCcnKSArIHVuY2hhbmdlZCwgY29udHJvbCk7XG4gICAgICAgIH0pXG4gICAgICAgICAgICAuZm9sZChtYXNrZWQgPT4ge1xuICAgICAgICAgICAgdmFsdWUgPSBtYXNrZWQuam9pbignJyk7XG4gICAgICAgIH0pO1xuICAgICAgICByZXR1cm4ge1xuICAgICAgICAgICAgc2VsZWN0aW9uLFxuICAgICAgICAgICAgdmFsdWVcbiAgICAgICAgfTtcbiAgICB9XG4gICAgZ2V0IG1hc2tUb2tlbkNyZWF0b3IoKSB7XG4gICAgICAgIGNvbnN0IHsgcHJvbXB0LCBwcm9tcHRQbGFjZWhvbGRlciB9ID0gdGhpcztcbiAgICAgICAgcmV0dXJuIHtcbiAgICAgICAgICAgIGxpdGVyYWw6IHJ1bGUgPT4gbGl0ZXJhbChydWxlKSxcbiAgICAgICAgICAgIG1hc2s6IHJ1bGUgPT4gbWFzayh7IHByb21wdCwgcHJvbXB0UGxhY2Vob2xkZXIgfSkocnVsZSlcbiAgICAgICAgfTtcbiAgICB9XG4gICAgZ2V0IHVubWFza1Rva2VuQ3JlYXRvcigpIHtcbiAgICAgICAgcmV0dXJuIHtcbiAgICAgICAgICAgIGxpdGVyYWw6IHJ1bGUgPT4gdW5saXRlcmFsKHJ1bGUpLFxuICAgICAgICAgICAgbWFzazogcnVsZSA9PiB1bm1hc2sodGhpcy5wcm9tcHQpKHJ1bGUpXG4gICAgICAgIH07XG4gICAgfVxuICAgIGdldCByYXdUb2tlbkNyZWF0b3IoKSB7XG4gICAgICAgIGNvbnN0IHsgcHJvbXB0LCBwcm9tcHRQbGFjZWhvbGRlciwgaW5jbHVkZUxpdGVyYWxzIH0gPSB0aGlzO1xuICAgICAgICByZXR1cm4ge1xuICAgICAgICAgICAgbGl0ZXJhbDogXyA9PiByYXdMaXRlcmFsKGluY2x1ZGVMaXRlcmFscyksXG4gICAgICAgICAgICBtYXNrOiBfID0+IHJhd01hc2soeyBwcm9tcHQsIHByb21wdFBsYWNlaG9sZGVyIH0pXG4gICAgICAgIH07XG4gICAgfVxuICAgIGdldCB2YWxpZGF0aW9uVG9rZW5DcmVhdG9yKCkge1xuICAgICAgICBjb25zdCB7IHByb21wdCB9ID0gdGhpcztcbiAgICAgICAgcmV0dXJuIHtcbiAgICAgICAgICAgIGxpdGVyYWw6IF8gPT4gcmF3TGl0ZXJhbChmYWxzZSksXG4gICAgICAgICAgICBtYXNrOiBfID0+IHJhd01hc2soeyBwcm9tcHQsIHByb21wdFBsYWNlaG9sZGVyOiAnJyB9KVxuICAgICAgICB9O1xuICAgIH1cbiAgICB0b2tlbml6ZSgpIHtcbiAgICAgICAgZ3JlZWR5KHRva2VuKHRoaXMucnVsZXMsIHRoaXMubWFza1Rva2VuQ3JlYXRvcikpXG4gICAgICAgICAgICAucnVuKHRoaXMubWFzaylcbiAgICAgICAgICAgIC5mb2xkKCh0b2tlbnMsIF8pID0+IHtcbiAgICAgICAgICAgIHRoaXMubWFza1Rva2VucyA9IHRva2VucztcbiAgICAgICAgfSk7XG4gICAgICAgIGdyZWVkeSh0b2tlbih0aGlzLnJ1bGVzLCB0aGlzLnVubWFza1Rva2VuQ3JlYXRvcikpXG4gICAgICAgICAgICAucnVuKHRoaXMubWFzaylcbiAgICAgICAgICAgIC5mb2xkKCh0b2tlbnMsIF8pID0+IHtcbiAgICAgICAgICAgIHRoaXMudW5tYXNrVG9rZW5zID0gdG9rZW5zO1xuICAgICAgICB9KTtcbiAgICAgICAgZ3JlZWR5KHRva2VuKHRoaXMucnVsZXMsIHRoaXMucmF3VG9rZW5DcmVhdG9yKSlcbiAgICAgICAgICAgIC5ydW4odGhpcy5tYXNrKVxuICAgICAgICAgICAgLmZvbGQoKHRva2VucywgXykgPT4ge1xuICAgICAgICAgICAgdGhpcy5yYXdUb2tlbnMgPSB0b2tlbnM7XG4gICAgICAgIH0pO1xuICAgICAgICBncmVlZHkodG9rZW4odGhpcy5ydWxlcywgdGhpcy52YWxpZGF0aW9uVG9rZW5DcmVhdG9yKSlcbiAgICAgICAgICAgIC5ydW4odGhpcy5tYXNrKVxuICAgICAgICAgICAgLmZvbGQoKHRva2VucywgXykgPT4ge1xuICAgICAgICAgICAgdGhpcy52YWxpZGF0aW9uVG9rZW5zID0gdG9rZW5zO1xuICAgICAgICB9KTtcbiAgICB9XG59XG5NYXNraW5nU2VydmljZS5kZWNvcmF0b3JzID0gW1xuICAgIHsgdHlwZTogSW5qZWN0YWJsZSB9LFxuXTtcblxuY29uc3QgcmVzb2x2ZWRQcm9taXNlID0gUHJvbWlzZS5yZXNvbHZlKG51bGwpO1xuY29uc3QgRk9DVVNFRCQzID0gJ2stc3RhdGUtZm9jdXNlZCc7XG4vKipcbiAqIFJlcHJlc2VudHMgdGhlIFtLZW5kbyBVSSBNYXNrZWRUZXh0Qm94IGNvbXBvbmVudCBmb3IgQW5ndWxhcl0oeyUgc2x1ZyBvdmVydmlld19tYXNrZWR0ZXh0Ym94ICV9KS5cbiAqXG4gKiBAZXhhbXBsZVxuICogYGBgdHMtbm8tcnVuXG4gKlxuICogX0BDb21wb25lbnQoe1xuICogICAgIHNlbGVjdG9yOiAnbXktYXBwJyxcbiAqICAgICB0ZW1wbGF0ZTogYFxuICogICAgICA8a2VuZG8tbWFza2VkdGV4dGJveFxuICogICAgICAgICAgW21hc2tdPVwibWFza1wiXG4gKiAgICAgICAgICBbdmFsdWVdPVwidmFsdWVcIj5cbiAqICAgICAgPC9rZW5kby1tYXNrZWR0ZXh0Ym94PlxuICogICAgIGBcbiAqIH0pXG4gKlxuICogY2xhc3MgQXBwQ29tcG9uZW50IHtcbiAqICBwdWJsaWMgdmFsdWU6IHN0cmluZyA9IFwiOTU4MDEyODA1NTgwNzc5MlwiO1xuICogIHB1YmxpYyBtYXNrOiBzdHJpbmcgPSBcIjAwMDAtMDAwMC0wMDAwLTAwMDBcIjtcbiAqIH1cbiAqIGBgYFxuICovXG5jbGFzcyBNYXNrZWRUZXh0Qm94Q29tcG9uZW50IHtcbiAgICBjb25zdHJ1Y3RvcihzZXJ2aWNlLCByZW5kZXJlciwgaG9zdEVsZW1lbnQsIG5nWm9uZSwgaW5qZWN0b3IsIGNoYW5nZURldGVjdG9yLCBydGwpIHtcbiAgICAgICAgdGhpcy5zZXJ2aWNlID0gc2VydmljZTtcbiAgICAgICAgdGhpcy5yZW5kZXJlciA9IHJlbmRlcmVyO1xuICAgICAgICB0aGlzLmhvc3RFbGVtZW50ID0gaG9zdEVsZW1lbnQ7XG4gICAgICAgIHRoaXMubmdab25lID0gbmdab25lO1xuICAgICAgICB0aGlzLmluamVjdG9yID0gaW5qZWN0b3I7XG4gICAgICAgIHRoaXMuY2hhbmdlRGV0ZWN0b3IgPSBjaGFuZ2VEZXRlY3RvcjtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuZm9jdXNhYmxlSWQgPSBgay0ke2d1aWQoKX1gO1xuICAgICAgICAvKipcbiAgICAgICAgICogRGV0ZXJtaW5lcyB3aGV0aGVyIHRoZSBNYXNrZWRUZXh0Qm94IGlzIGRpc2FibGVkIChbc2VlIGV4YW1wbGVdKHslIHNsdWcgZGlzYWJsZWRfbWFza2VkdGV4dGJveCAlfSkpLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5kaXNhYmxlZCA9IGZhbHNlO1xuICAgICAgICAvKipcbiAgICAgICAgICogRGV0ZXJtaW5lcyB3aGV0aGVyIHRoZSBNYXNrZWRUZXh0Qm94IGlzIGluIGl0cyByZWFkLW9ubHkgc3RhdGUgKFtzZWUgZXhhbXBsZV0oeyUgc2x1ZyByZWFkb25seV9tYXNrZWR0ZXh0Ym94ICV9KSkuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLnJlYWRvbmx5ID0gZmFsc2U7XG4gICAgICAgIHRoaXMuaG9zdENsYXNzZXMgPSB0cnVlO1xuICAgICAgICAvKipcbiAgICAgICAgICogUmVwcmVzZW50cyBhIHByb21wdCBjaGFyYWN0ZXIgZm9yIHRoZSBtYXNrZWQgdmFsdWUuXG4gICAgICAgICAqIEBkZWZhdWx0IGBfYFxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5wcm9tcHQgPSAnXyc7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBJbmRpY2F0ZXMgYSBjaGFyYWN0ZXIgd2hpY2ggcmVwcmVzZW50cyBhbiBlbXB0eSBwb3NpdGlvbiBpbiB0aGUgcmF3IHZhbHVlLlxuICAgICAgICAgKiBAZGVmYXVsdCAnICdcbiAgICAgICAgICovXG4gICAgICAgIHRoaXMucHJvbXB0UGxhY2Vob2xkZXIgPSAnICc7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBJbmRpY2F0ZXMgd2hldGhlciB0byBpbmNsdWRlIGxpdGVyYWxzIGluIHRoZSByYXcgdmFsdWUgIChbc2VlIGV4YW1wbGVdKHslIHNsdWcgdmFsdWVfbWFza2VkdGV4dGJveCAlfSkpLlxuICAgICAgICAgKiBAZGVmYXVsdCBmYWxzZVxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5pbmNsdWRlTGl0ZXJhbHMgPSBmYWxzZTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIFNwZWNpZmllcyBpZiB0aGUgbWFzayBzaG91bGQgYmUgc2hvd24gb24gZm9jdXMgZm9yIGVtcHR5IHZhbHVlLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5tYXNrT25Gb2N1cyA9IGZhbHNlO1xuICAgICAgICAvKipcbiAgICAgICAgICogRGV0ZXJtaW5lcyB3aGV0aGVyIHRoZSBidWlsdC1pbiBtYXNrIHZhbGlkYXRvciBpcyBlbmZvcmNlZCB3aGVuIGEgZm9ybSBpcyB2YWxpZGF0ZWRcbiAgICAgICAgICogKFtzZWUgZXhhbXBsZV0oeyUgc2x1ZyB2YWxpZGF0aW9uX21hc2tlZHRleHRib3ggJX0pKS5cbiAgICAgICAgICogQGRlZmF1bHQgdHJ1ZVxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5tYXNrVmFsaWRhdGlvbiA9IHRydWU7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBTcGVjaWZpZXMgdGhlIFtgdGFiaW5kZXhgXShodHRwczovL2RldmVsb3Blci5tb3ppbGxhLm9yZy9lbi1VUy9kb2NzL1dlYi9IVE1ML0dsb2JhbF9hdHRyaWJ1dGVzL3RhYmluZGV4KSBvZiB0aGUgY29tcG9uZW50LlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy50YWJpbmRleCA9IDA7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBGaXJlcyBlYWNoIHRpbWUgdGhlIHVzZXIgZm9jdXNlcyB0aGUgYGlucHV0YCBlbGVtZW50LlxuICAgICAgICAgKlxuICAgICAgICAgKiA+IFRvIHdpcmUgdGhlIGV2ZW50IHByb2dyYW1tYXRpY2FsbHksIHVzZSB0aGUgYG9uRm9jdXNgIHByb3BlcnR5LlxuICAgICAgICAgKlxuICAgICAgICAgKiBAZXhhbXBsZVxuICAgICAgICAgKiBgYGB0cy1uby1ydW5cbiAgICAgICAgICogX0BDb21wb25lbnQoe1xuICAgICAgICAgKiBzZWxlY3RvcjogJ215LWFwcCcsXG4gICAgICAgICAqIHRlbXBsYXRlOiBgXG4gICAgICAgICAqICA8a2VuZG8tbWFza2VkdGV4dGJveCAoZm9jdXMpPVwiaGFuZGxlRm9jdXMoKVwiPjwva2VuZG8tbWFza2VkdGV4dGJveD5cbiAgICAgICAgICogYFxuICAgICAgICAgKiB9KVxuICAgICAgICAgKiBjbGFzcyBBcHBDb21wb25lbnQge1xuICAgICAgICAgKiAgIHB1YmxpYyBoYW5kbGVGb2N1cygpOiB2b2lkIHtcbiAgICAgICAgICogICAgICBjb25zb2xlLmxvZyhcIkNvbXBvbmVudCBpcyBmb2N1c2VkXCIpO1xuICAgICAgICAgKiAgIH1cbiAgICAgICAgICogfVxuICAgICAgICAgKiBgYGBcbiAgICAgICAgICovXG4gICAgICAgIHRoaXMub25Gb2N1cyA9IG5ldyBFdmVudEVtaXR0ZXIoKTsgLy90c2xpbnQ6ZGlzYWJsZS1saW5lOm5vLW91dHB1dC1yZW5hbWVcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEZpcmVzIGVhY2ggdGltZSB0aGUgYGlucHV0YCBlbGVtZW50IGdldHMgYmx1cnJlZC5cbiAgICAgICAgICpcbiAgICAgICAgICogPiBUbyB3aXJlIHRoZSBldmVudCBwcm9ncmFtbWF0aWNhbGx5LCB1c2UgdGhlIGBvbkJsdXJgIHByb3BlcnR5LlxuICAgICAgICAgKlxuICAgICAgICAgKiBAZXhhbXBsZVxuICAgICAgICAgKiBgYGB0cy1uby1ydW5cbiAgICAgICAgICogX0BDb21wb25lbnQoe1xuICAgICAgICAgKiBzZWxlY3RvcjogJ215LWFwcCcsXG4gICAgICAgICAqIHRlbXBsYXRlOiBgXG4gICAgICAgICAqICA8a2VuZG8tbWFza2VkdGV4dGJveCAoYmx1cik9XCJoYW5kbGVCbHVyKClcIj48L2tlbmRvLW1hc2tlZHRleHRib3g+XG4gICAgICAgICAqIGBcbiAgICAgICAgICogfSlcbiAgICAgICAgICogY2xhc3MgQXBwQ29tcG9uZW50IHtcbiAgICAgICAgICogICBwdWJsaWMgaGFuZGxlQmx1cigpOiB2b2lkIHtcbiAgICAgICAgICogICAgICBjb25zb2xlLmxvZyhcIkNvbXBvbmVudCBpcyBibHVycmVkXCIpO1xuICAgICAgICAgKiAgIH1cbiAgICAgICAgICogfVxuICAgICAgICAgKiBgYGBcbiAgICAgICAgICovXG4gICAgICAgIHRoaXMub25CbHVyID0gbmV3IEV2ZW50RW1pdHRlcigpOyAvL3RzbGludDpkaXNhYmxlLWxpbmU6bm8tb3V0cHV0LXJlbmFtZVxuICAgICAgICAvKipcbiAgICAgICAgICogRmlyZXMgZWFjaCB0aW1lIHRoZSB2YWx1ZSBjaGFuZ2VzLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy52YWx1ZUNoYW5nZSA9IG5ldyBFdmVudEVtaXR0ZXIoKTtcbiAgICAgICAgdGhpcy5mb2N1c0NsaWNrID0gZmFsc2U7XG4gICAgICAgIHRoaXMuZGVmYXVsdFJ1bGVzID0ge1xuICAgICAgICAgICAgXCIjXCI6IC9bXFxkXFxzXFwrXFwtXS8sXG4gICAgICAgICAgICBcIiZcIjogL1tcXFNdLyxcbiAgICAgICAgICAgIFwiMFwiOiAvW1xcZF0vLFxuICAgICAgICAgICAgXCI5XCI6IC9bXFxkXFxzXS8sXG4gICAgICAgICAgICBcIj9cIjogL1thLXpBLVpcXHNdLyxcbiAgICAgICAgICAgIFwiQVwiOiAvW2EtekEtWjAtOV0vLFxuICAgICAgICAgICAgXCJDXCI6IC8uLyxcbiAgICAgICAgICAgIFwiTFwiOiAvW2EtekEtWl0vLFxuICAgICAgICAgICAgXCJhXCI6IC9bYS16QS1aMC05XFxzXS9cbiAgICAgICAgfTtcbiAgICAgICAgdGhpcy5pc1Bhc3RlZCA9IGZhbHNlO1xuICAgICAgICB0aGlzLnNlbGVjdGlvbiA9IFswLCAwXTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuaGFuZGxlRm9jdXMgPSAoKSA9PiB7XG4gICAgICAgICAgICB0aGlzLmZvY3VzZWQgPSB0cnVlO1xuICAgICAgICAgICAgaWYgKHRoaXMubWFza09uRm9jdXMgJiYgdGhpcy5lbXB0eU1hc2spIHtcbiAgICAgICAgICAgICAgICB0aGlzLnVwZGF0ZUlucHV0KHRoaXMuc2VydmljZS5tYXNrUmF3KHRoaXMudmFsdWUpKTtcbiAgICAgICAgICAgICAgICB0aGlzLm5nWm9uZS5ydW5PdXRzaWRlQW5ndWxhcigoKSA9PiB7XG4gICAgICAgICAgICAgICAgICAgIHNldFRpbWVvdXQoKCkgPT4geyB0aGlzLnNldFNlbGVjdGlvbigwLCAwKTsgfSwgMCk7XG4gICAgICAgICAgICAgICAgfSk7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICBpZiAoaGFzT2JzZXJ2ZXJzKHRoaXMub25Gb2N1cykpIHtcbiAgICAgICAgICAgICAgICB0aGlzLm5nWm9uZS5ydW4oKCkgPT4ge1xuICAgICAgICAgICAgICAgICAgICB0aGlzLm9uRm9jdXMuZW1pdCgpO1xuICAgICAgICAgICAgICAgIH0pO1xuICAgICAgICAgICAgfVxuICAgICAgICB9O1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5oYW5kbGVDbGljayA9ICgpID0+IHtcbiAgICAgICAgICAgIGlmICh0aGlzLmZvY3VzZWQgJiYgIXRoaXMuZm9jdXNDbGljaykge1xuICAgICAgICAgICAgICAgIHRoaXMuZm9jdXNDbGljayA9IHRydWU7XG4gICAgICAgICAgICAgICAgY29uc3QgeyBzZWxlY3Rpb25TdGFydCwgc2VsZWN0aW9uRW5kIH0gPSB0aGlzLmlucHV0Lm5hdGl2ZUVsZW1lbnQ7XG4gICAgICAgICAgICAgICAgaWYgKHNlbGVjdGlvblN0YXJ0ID09PSBzZWxlY3Rpb25FbmQpIHtcbiAgICAgICAgICAgICAgICAgICAgdGhpcy5zZXRGb2N1c1NlbGVjdGlvbigpO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIH1cbiAgICAgICAgfTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuaGFuZGxlQmx1ciA9ICgpID0+IHtcbiAgICAgICAgICAgIHRoaXMuY2hhbmdlRGV0ZWN0b3IubWFya0ZvckNoZWNrKCk7XG4gICAgICAgICAgICB0aGlzLmZvY3VzZWQgPSBmYWxzZTtcbiAgICAgICAgICAgIHRoaXMuZm9jdXNDbGljayA9IGZhbHNlO1xuICAgICAgICAgICAgaWYgKHRoaXMubWFza09uRm9jdXMgJiYgdGhpcy5lbXB0eU1hc2spIHtcbiAgICAgICAgICAgICAgICB0aGlzLnVwZGF0ZUlucHV0KHRoaXMubWFza2VkVmFsdWUpO1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgaWYgKGhhc09ic2VydmVycyh0aGlzLm9uQmx1cikgfHwgcmVxdWlyZXNab25lT25CbHVyKHRoaXMuY29udHJvbCkpIHtcbiAgICAgICAgICAgICAgICB0aGlzLm5nWm9uZS5ydW4oKCkgPT4ge1xuICAgICAgICAgICAgICAgICAgICB0aGlzLm9uVG91Y2hlZCgpO1xuICAgICAgICAgICAgICAgICAgICB0aGlzLm9uQmx1ci5lbWl0KCk7XG4gICAgICAgICAgICAgICAgfSk7XG4gICAgICAgICAgICB9XG4gICAgICAgIH07XG4gICAgICAgIHRoaXMub25DaGFuZ2UgPSAoXykgPT4geyB9O1xuICAgICAgICB0aGlzLm9uVG91Y2hlZCA9ICgpID0+IHsgfTtcbiAgICAgICAgdGhpcy5kaXJlY3Rpb24gPSBydGwgPyAncnRsJyA6ICdsdHInO1xuICAgICAgICB0aGlzLnVwZGF0ZVNlcnZpY2UoKTtcbiAgICB9XG4gICAgZ2V0IGhvc3REaXNhYmxlZENsYXNzKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5kaXNhYmxlZDtcbiAgICB9XG4gICAgLyoqXG4gICAgICogRXhwb3NlcyB0aGUgUmVnRXhwLWJhc2VkIG1hc2sgdmFsaWRhdGlvbiBhcnJheSAoW3NlZSBleGFtcGxlXSh7JSBzbHVnIG1hc2tzX21hc2tlZHRleHRib3ggJX0pKS5cbiAgICAgKi9cbiAgICBnZXQgcnVsZXMoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLl9ydWxlcyB8fCB0aGlzLmRlZmF1bHRSdWxlcztcbiAgICB9XG4gICAgc2V0IHJ1bGVzKHZhbHVlKSB7XG4gICAgICAgIHRoaXMuX3J1bGVzID0gT2JqZWN0LmFzc2lnbih7fSwgdGhpcy5kZWZhdWx0UnVsZXMsIHZhbHVlKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHNldCB0YWJJbmRleCh0YWJJbmRleCkge1xuICAgICAgICB0aGlzLnRhYmluZGV4ID0gdGFiSW5kZXg7XG4gICAgfVxuICAgIGdldCB0YWJJbmRleCgpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMudGFiaW5kZXg7XG4gICAgfVxuICAgIG5nT25Jbml0KCkge1xuICAgICAgICBpZiAodGhpcy5ob3N0RWxlbWVudCkge1xuICAgICAgICAgICAgdGhpcy5yZW5kZXJlci5yZW1vdmVBdHRyaWJ1dGUodGhpcy5ob3N0RWxlbWVudC5uYXRpdmVFbGVtZW50LCBcInRhYmluZGV4XCIpO1xuICAgICAgICB9XG4gICAgICAgIHRoaXMuY29udHJvbCA9IHRoaXMuaW5qZWN0b3IuZ2V0KE5nQ29udHJvbCwgbnVsbCk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKiBVc2VkIGJ5IHRoZSBUZXh0Qm94Q29udGFpbmVyIHRvIGRldGVybWluZSBpZiB0aGUgTWFza2VkVGV4dEJveCBpcyBlbXB0eS5cbiAgICAgKi9cbiAgICBpc0VtcHR5KCkge1xuICAgICAgICBpZiAodGhpcy5pbnB1dCkge1xuICAgICAgICAgICAgcmV0dXJuICFCb29sZWFuKHRoaXMuaW5wdXQubmF0aXZlRWxlbWVudC52YWx1ZSk7XG4gICAgICAgIH1cbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIGhhbmRsZURyYWdEcm9wKCkge1xuICAgICAgICByZXR1cm4gZmFsc2U7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEZvY3VzZXMgdGhlIE1hc2tlZFRleHRCb3guXG4gICAgICpcbiAgICAgKiBAZXhhbXBsZVxuICAgICAqIGBgYHRzLW5vLXJ1blxuICAgICAqIF9AQ29tcG9uZW50KHtcbiAgICAgKiBzZWxlY3RvcjogJ215LWFwcCcsXG4gICAgICogdGVtcGxhdGU6IGBcbiAgICAgKiAgPGJ1dHRvbiAoY2xpY2spPVwibWFza2VkaW5wdXQuZm9jdXMoKVwiPkZvY3VzIHRoZSBpbnB1dDwvYnV0dG9uPlxuICAgICAqICA8a2VuZG8tbWFza2VkdGV4dGJveCAjbWFza2VkaW5wdXQ+PC9rZW5kby1tYXNrZWR0ZXh0Ym94PlxuICAgICAqIGBcbiAgICAgKiB9KVxuICAgICAqIGNsYXNzIEFwcENvbXBvbmVudCB7IH1cbiAgICAgKiBgYGBcbiAgICAgKi9cbiAgICBmb2N1cygpIHtcbiAgICAgICAgaWYgKCF0aGlzLmlucHV0KSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5pbnB1dC5uYXRpdmVFbGVtZW50LmZvY3VzKCk7XG4gICAgICAgIHRoaXMuc2V0Rm9jdXNTZWxlY3Rpb24oKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQmx1cnMgdGhlIE1hc2tlZFRleHRCb3guXG4gICAgICovXG4gICAgYmx1cigpIHtcbiAgICAgICAgaWYgKCF0aGlzLmlucHV0KSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5pbnB1dC5uYXRpdmVFbGVtZW50LmJsdXIoKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHBhc3RlSGFuZGxlcihlKSB7XG4gICAgICAgIGNvbnN0IHsgc2VsZWN0aW9uU3RhcnQsIHNlbGVjdGlvbkVuZCB9ID0gZS50YXJnZXQ7XG4gICAgICAgIGlmIChzZWxlY3Rpb25FbmQgPT09IHNlbGVjdGlvblN0YXJ0KSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5pc1Bhc3RlZCA9IHRydWU7XG4gICAgICAgIHRoaXMuc2VsZWN0aW9uID0gW3NlbGVjdGlvblN0YXJ0LCBzZWxlY3Rpb25FbmRdO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgaW5wdXRIYW5kbGVyKGUpIHtcbiAgICAgICAgY29uc3QgdmFsdWUgPSBlLnRhcmdldC52YWx1ZTtcbiAgICAgICAgY29uc3QgW3N0YXJ0LCBlbmRdID0gdGhpcy5zZWxlY3Rpb247XG4gICAgICAgIGlmICghdGhpcy5tYXNrKSB7XG4gICAgICAgICAgICB0aGlzLnVwZGF0ZVZhbHVlKHZhbHVlKTtcbiAgICAgICAgICAgIHRoaXMuaXNQYXN0ZWQgPSBmYWxzZTtcbiAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgfVxuICAgICAgICBsZXQgcmVzdWx0O1xuICAgICAgICBpZiAodGhpcy5pc1Bhc3RlZCkge1xuICAgICAgICAgICAgdGhpcy5pc1Bhc3RlZCA9IGZhbHNlO1xuICAgICAgICAgICAgY29uc3QgcmlnaHRQYXJ0ID0gdGhpcy5tYXNrZWRWYWx1ZS5sZW5ndGggLSBlbmQ7XG4gICAgICAgICAgICBjb25zdCB0byA9IHZhbHVlLmxlbmd0aCAtIHJpZ2h0UGFydDtcbiAgICAgICAgICAgIHJlc3VsdCA9IHRoaXMuc2VydmljZS5tYXNrSW5SYW5nZSh2YWx1ZS5zbGljZShzdGFydCwgdG8pLCB0aGlzLm1hc2tlZFZhbHVlLCBzdGFydCwgZW5kKTtcbiAgICAgICAgfVxuICAgICAgICBlbHNlIHtcbiAgICAgICAgICAgIHJlc3VsdCA9IHRoaXMuc2VydmljZS5tYXNrSW5wdXQodmFsdWUsIHRoaXMubWFza2VkVmFsdWUsIGUudGFyZ2V0LnNlbGVjdGlvblN0YXJ0KTtcbiAgICAgICAgfVxuICAgICAgICB0aGlzLnVwZGF0ZUlucHV0KHJlc3VsdC52YWx1ZSwgcmVzdWx0LnNlbGVjdGlvbik7XG4gICAgICAgIHRoaXMudXBkYXRlVmFsdWUocmVzdWx0LnZhbHVlKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIG5nT25DaGFuZ2VzKGNoYW5nZXMpIHtcbiAgICAgICAgaWYgKGNoYW5nZXMudmFsdWUpIHtcbiAgICAgICAgICAgIHRoaXMudmFsdWUgPSB0aGlzLm5vcm1hbGl6ZVZhbHVlKCk7XG4gICAgICAgIH1cbiAgICAgICAgaWYgKCF0aGlzLm1hc2spIHtcbiAgICAgICAgICAgIHRoaXMudXBkYXRlSW5wdXQodGhpcy52YWx1ZSk7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgY29uc3QgbmV4dCA9IHRoaXMuZXh0cmFjdENoYW5nZXMoY2hhbmdlcyk7XG4gICAgICAgIHRoaXMudXBkYXRlU2VydmljZShuZXh0KTtcbiAgICAgICAgaWYgKGlzQ2hhbmdlZCgndmFsdWUnLCBjaGFuZ2VzKSkge1xuICAgICAgICAgICAgY29uc3QgbWFza2VkVmFsdWUgPSB0aGlzLnNlcnZpY2UubWFza1Jhdyh0aGlzLnZhbHVlKTtcbiAgICAgICAgICAgIGlmIChtYXNrZWRWYWx1ZSAhPT0gdGhpcy5tYXNrZWRWYWx1ZSkge1xuICAgICAgICAgICAgICAgIHRoaXMudXBkYXRlSW5wdXQobWFza2VkVmFsdWUpO1xuICAgICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICAgIGVsc2UgaWYgKGFueUNoYW5nZWQoWydwcm9tcHRQbGFjZWhvbGRlcicsICdpbmNsdWRlTGl0ZXJhbHMnXSwgY2hhbmdlcykpIHtcbiAgICAgICAgICAgIHJlc29sdmVkUHJvbWlzZS50aGVuKCgpID0+IHtcbiAgICAgICAgICAgICAgICB0aGlzLnVwZGF0ZVZhbHVlKHRoaXMubWFza2VkVmFsdWUpO1xuICAgICAgICAgICAgfSk7XG4gICAgICAgIH1cbiAgICAgICAgZWxzZSB7XG4gICAgICAgICAgICB0aGlzLnVwZGF0ZUlucHV0KHRoaXMuc2VydmljZS5tYXNrUmF3KHRoaXMudmFsdWUpKTtcbiAgICAgICAgfVxuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICogV3JpdGVzIGEgbmV3IHZhbHVlIHRvIHRoZSBlbGVtZW50LlxuICAgICAqL1xuICAgIHdyaXRlVmFsdWUodmFsdWUpIHtcbiAgICAgICAgdGhpcy52YWx1ZSA9IHRoaXMubm9ybWFsaXplVmFsdWUodmFsdWUpO1xuICAgICAgICB0aGlzLnVwZGF0ZUlucHV0KHRoaXMuc2VydmljZS5tYXNrUmF3KHRoaXMudmFsdWUpKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqIFNldHMgdGhlIGZ1bmN0aW9uIHRoYXQgd2lsbCBiZSBjYWxsZWQgd2hlbiBhIGBjaGFuZ2VgIGV2ZW50IGlzIHRyaWdnZXJlZC5cbiAgICAgKi9cbiAgICByZWdpc3Rlck9uQ2hhbmdlKGZuKSB7XG4gICAgICAgIHRoaXMub25DaGFuZ2UgPSBmbjtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqIFNldHMgdGhlIGZ1bmN0aW9uIHRoYXQgd2lsbCBiZSBjYWxsZWQgd2hlbiBhIGB0b3VjaGAgZXZlbnQgaXMgdHJpZ2dlcmVkLlxuICAgICAqL1xuICAgIHJlZ2lzdGVyT25Ub3VjaGVkKGZuKSB7XG4gICAgICAgIHRoaXMub25Ub3VjaGVkID0gZm47XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKiBDYWxsZWQgd2hlbiB0aGUgc3RhdHVzIG9mIHRoZSBjb21wb25lbnQgY2hhbmdlcyB0byBvciBmcm9tIGBkaXNhYmxlZGAuXG4gICAgICogRGVwZW5kaW5nIG9uIHRoZSB2YWx1ZSwgaXQgZW5hYmxlcyBvciBkaXNhYmxlcyB0aGUgYXBwcm9wcmlhdGUgRE9NIGVsZW1lbnQuXG4gICAgICpcbiAgICAgKiBAcGFyYW0gaXNEaXNhYmxlZFxuICAgICAqL1xuICAgIHNldERpc2FibGVkU3RhdGUoaXNEaXNhYmxlZCkge1xuICAgICAgICB0aGlzLmRpc2FibGVkID0gaXNEaXNhYmxlZDtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHZhbGlkYXRlKF8pIHtcbiAgICAgICAgaWYgKHRoaXMubWFza1ZhbGlkYXRpb24gPT09IGZhbHNlIHx8ICF0aGlzLm1hc2spIHtcbiAgICAgICAgICAgIHJldHVybiBudWxsO1xuICAgICAgICB9XG4gICAgICAgIGlmICghdGhpcy5zZXJ2aWNlLnZhbGlkYXRpb25WYWx1ZSh0aGlzLm1hc2tlZFZhbHVlKSkge1xuICAgICAgICAgICAgcmV0dXJuIG51bGw7XG4gICAgICAgIH1cbiAgICAgICAgaWYgKHRoaXMubWFza2VkVmFsdWUuaW5kZXhPZih0aGlzLnByb21wdCkgIT09IC0xKSB7XG4gICAgICAgICAgICByZXR1cm4ge1xuICAgICAgICAgICAgICAgIHBhdHRlcm5FcnJvcjoge1xuICAgICAgICAgICAgICAgICAgICBtYXNrOiB0aGlzLm1hc2ssXG4gICAgICAgICAgICAgICAgICAgIG1hc2tlZFZhbHVlOiB0aGlzLm1hc2tlZFZhbHVlLFxuICAgICAgICAgICAgICAgICAgICB2YWx1ZTogdGhpcy52YWx1ZVxuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIH07XG4gICAgICAgIH1cbiAgICAgICAgcmV0dXJuIG51bGw7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICB1cGRhdGVWYWx1ZShtYXNrZWRWYWx1ZSkge1xuICAgICAgICBpZiAodGhpcy5tYXNrICYmICF0aGlzLnNlcnZpY2UudmFsaWRhdGlvblZhbHVlKG1hc2tlZFZhbHVlKSkge1xuICAgICAgICAgICAgdGhpcy52YWx1ZSA9ICcnO1xuICAgICAgICB9XG4gICAgICAgIGVsc2Uge1xuICAgICAgICAgICAgdGhpcy52YWx1ZSA9IHRoaXMuc2VydmljZS5yYXdWYWx1ZShtYXNrZWRWYWx1ZSk7XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5vbkNoYW5nZSh0aGlzLnZhbHVlKTtcbiAgICAgICAgdGhpcy52YWx1ZUNoYW5nZS5lbWl0KHRoaXMudmFsdWUpO1xuICAgIH1cbiAgICB1cGRhdGVJbnB1dChtYXNrZWRWYWx1ZSA9ICcnLCBzZWxlY3Rpb24pIHtcbiAgICAgICAgdGhpcy5tYXNrZWRWYWx1ZSA9IG1hc2tlZFZhbHVlO1xuICAgICAgICBjb25zdCB2YWx1ZSA9IHRoaXMubWFza09uRm9jdXMgJiYgIXRoaXMuZm9jdXNlZCAmJiB0aGlzLmVtcHR5TWFzayA/ICcnIDogbWFza2VkVmFsdWU7XG4gICAgICAgIHRoaXMucmVuZGVyZXIuc2V0UHJvcGVydHkodGhpcy5pbnB1dC5uYXRpdmVFbGVtZW50LCBcInZhbHVlXCIsIHZhbHVlKTtcbiAgICAgICAgaWYgKHNlbGVjdGlvbiAhPT0gdW5kZWZpbmVkKSB7XG4gICAgICAgICAgICB0aGlzLnNldFNlbGVjdGlvbihzZWxlY3Rpb24sIHNlbGVjdGlvbik7XG4gICAgICAgIH1cbiAgICB9XG4gICAgZXh0cmFjdENoYW5nZXMoY2hhbmdlcykge1xuICAgICAgICByZXR1cm4gT2JqZWN0LmtleXMoY2hhbmdlcykuZmlsdGVyKGtleSA9PiBrZXkgIT09ICdydWxlcycpLnJlZHVjZSgob2JqLCBrZXkpID0+IHtcbiAgICAgICAgICAgIG9ialtrZXldID0gY2hhbmdlc1trZXldLmN1cnJlbnRWYWx1ZTtcbiAgICAgICAgICAgIHJldHVybiBvYmo7XG4gICAgICAgIH0sIHt9KTsgLy8gdHNsaW50OmRpc2FibGUtbGluZTphbGlnblxuICAgIH1cbiAgICB1cGRhdGVTZXJ2aWNlKGV4dHJhKSB7XG4gICAgICAgIGNvbnN0IGNvbmZpZyA9IE9iamVjdC5hc3NpZ24oe1xuICAgICAgICAgICAgaW5jbHVkZUxpdGVyYWxzOiB0aGlzLmluY2x1ZGVMaXRlcmFscyxcbiAgICAgICAgICAgIG1hc2s6IHRoaXMubWFzayxcbiAgICAgICAgICAgIHByb21wdDogdGhpcy5wcm9tcHQsXG4gICAgICAgICAgICBwcm9tcHRQbGFjZWhvbGRlcjogdGhpcy5wcm9tcHRQbGFjZWhvbGRlcixcbiAgICAgICAgICAgIHJ1bGVzOiB0aGlzLnJ1bGVzXG4gICAgICAgIH0sIGV4dHJhKTsgLy8gdHNsaW50OmRpc2FibGUtbGluZTphbGlnblxuICAgICAgICB0aGlzLnNlcnZpY2UudXBkYXRlKGNvbmZpZyk7XG4gICAgfVxuICAgIHNldFNlbGVjdGlvbihzdGFydCA9IHRoaXMuc2VsZWN0aW9uWzBdLCBlbmQgPSB0aGlzLnNlbGVjdGlvblsxXSkge1xuICAgICAgICBpZiAodGhpcy5mb2N1c2VkKSB7XG4gICAgICAgICAgICBpbnZva2VFbGVtZW50TWV0aG9kKHRoaXMuaW5wdXQsICdzZXRTZWxlY3Rpb25SYW5nZScsIHN0YXJ0LCBlbmQpO1xuICAgICAgICB9XG4gICAgfVxuICAgIGdldCBlbXB0eU1hc2soKSB7XG4gICAgICAgIHJldHVybiB0aGlzLnNlcnZpY2UubWFza1JhdygpID09PSB0aGlzLm1hc2tlZFZhbHVlO1xuICAgIH1cbiAgICBzZXRGb2N1c1NlbGVjdGlvbigpIHtcbiAgICAgICAgY29uc3Qgc2VsZWN0aW9uU3RhcnQgPSB0aGlzLmlucHV0Lm5hdGl2ZUVsZW1lbnQuc2VsZWN0aW9uU3RhcnQ7XG4gICAgICAgIGNvbnN0IGluZGV4ID0gdGhpcy5tYXNrZWRWYWx1ZSA/IHRoaXMubWFza2VkVmFsdWUuaW5kZXhPZih0aGlzLnByb21wdCkgOiAwO1xuICAgICAgICBpZiAoaW5kZXggPj0gMCAmJiBpbmRleCA8IHNlbGVjdGlvblN0YXJ0KSB7XG4gICAgICAgICAgICB0aGlzLnNlbGVjdGlvbiA9IFtpbmRleCwgaW5kZXhdO1xuICAgICAgICAgICAgdGhpcy5zZXRTZWxlY3Rpb24oKTtcbiAgICAgICAgfVxuICAgIH1cbiAgICBnZXQgZm9jdXNlZCgpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuaXNGb2N1c2VkO1xuICAgIH1cbiAgICBzZXQgZm9jdXNlZCh2YWx1ZSkge1xuICAgICAgICBpZiAodGhpcy5pc0ZvY3VzZWQgIT09IHZhbHVlICYmIHRoaXMuaG9zdEVsZW1lbnQpIHtcbiAgICAgICAgICAgIGNvbnN0IGVsZW1lbnQgPSB0aGlzLmhvc3RFbGVtZW50Lm5hdGl2ZUVsZW1lbnQ7XG4gICAgICAgICAgICBpZiAodmFsdWUpIHtcbiAgICAgICAgICAgICAgICB0aGlzLnJlbmRlcmVyLmFkZENsYXNzKGVsZW1lbnQsIEZPQ1VTRUQkMyk7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICBlbHNlIHtcbiAgICAgICAgICAgICAgICB0aGlzLnJlbmRlcmVyLnJlbW92ZUNsYXNzKGVsZW1lbnQsIEZPQ1VTRUQkMyk7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICB0aGlzLmlzRm9jdXNlZCA9IHZhbHVlO1xuICAgICAgICB9XG4gICAgfVxuICAgIG5vcm1hbGl6ZVZhbHVlKHZhbHVlID0gdGhpcy52YWx1ZSkge1xuICAgICAgICBjb25zdCBwcmVzZW50ID0gaXNQcmVzZW50KHZhbHVlKTtcbiAgICAgICAgaWYgKHByZXNlbnQgJiYgdHlwZW9mIHZhbHVlICE9PSAnc3RyaW5nJykge1xuICAgICAgICAgICAgaWYgKGlzRGV2TW9kZSgpKSB7XG4gICAgICAgICAgICAgICAgdGhyb3cgbmV3IEVycm9yKCdUaGUgTWFza2VkVGV4dEJveCBjb21wb25lbnQgc3VwcG9ydHMgb25seSBzdHJpbmcgdmFsdWVzLicpO1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgcmV0dXJuIFN0cmluZyh2YWx1ZSk7XG4gICAgICAgIH1cbiAgICAgICAgcmV0dXJuIHByZXNlbnQgPyB2YWx1ZSA6ICcnO1xuICAgIH1cbn1cbk1hc2tlZFRleHRCb3hDb21wb25lbnQuZGVjb3JhdG9ycyA9IFtcbiAgICB7IHR5cGU6IENvbXBvbmVudCwgYXJnczogW3tcbiAgICAgICAgICAgICAgICBleHBvcnRBczogJ2tlbmRvTWFza2VkVGV4dEJveCcsXG4gICAgICAgICAgICAgICAgcHJvdmlkZXJzOiBbXG4gICAgICAgICAgICAgICAgICAgIE1hc2tpbmdTZXJ2aWNlLFxuICAgICAgICAgICAgICAgICAgICB7XG4gICAgICAgICAgICAgICAgICAgICAgICBtdWx0aTogdHJ1ZSxcbiAgICAgICAgICAgICAgICAgICAgICAgIHByb3ZpZGU6IE5HX1ZBTFVFX0FDQ0VTU09SLFxuICAgICAgICAgICAgICAgICAgICAgICAgdXNlRXhpc3Rpbmc6IGZvcndhcmRSZWYoKCkgPT4gTWFza2VkVGV4dEJveENvbXBvbmVudCkgLyogdHNsaW50OmRpc2FibGUtbGluZSAqL1xuICAgICAgICAgICAgICAgICAgICB9LFxuICAgICAgICAgICAgICAgICAgICB7XG4gICAgICAgICAgICAgICAgICAgICAgICBtdWx0aTogdHJ1ZSxcbiAgICAgICAgICAgICAgICAgICAgICAgIHByb3ZpZGU6IE5HX1ZBTElEQVRPUlMsXG4gICAgICAgICAgICAgICAgICAgICAgICB1c2VFeGlzdGluZzogZm9yd2FyZFJlZigoKSA9PiBNYXNrZWRUZXh0Qm94Q29tcG9uZW50KSAvKiB0c2xpbnQ6ZGlzYWJsZS1saW5lICovXG4gICAgICAgICAgICAgICAgICAgIH0sXG4gICAgICAgICAgICAgICAgICAgIHtcbiAgICAgICAgICAgICAgICAgICAgICAgIHByb3ZpZGU6IEtlbmRvSW5wdXQsXG4gICAgICAgICAgICAgICAgICAgICAgICB1c2VFeGlzdGluZzogZm9yd2FyZFJlZigoKSA9PiBNYXNrZWRUZXh0Qm94Q29tcG9uZW50KVxuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgXSxcbiAgICAgICAgICAgICAgICBzZWxlY3RvcjogJ2tlbmRvLW1hc2tlZHRleHRib3gnLFxuICAgICAgICAgICAgICAgIHRlbXBsYXRlOiBgXG4gICAgICAgIDxpbnB1dCB0eXBlPVwidGV4dFwiXG4gICAgICAgICAgICAjaW5wdXRcbiAgICAgICAgICAgIGF1dG9jb21wbGV0ZT1cIm9mZlwiXG4gICAgICAgICAgICBhdXRvY29ycmVjdD1cIm9mZlwiXG4gICAgICAgICAgICBhdXRvY2FwaXRhbGl6ZT1cIm9mZlwiXG4gICAgICAgICAgICBzcGVsbGNoZWNrPVwiZmFsc2VcIlxuICAgICAgICAgICAgY2xhc3M9XCJrLXRleHRib3hcIlxuICAgICAgICAgICAgW2lkXT1cImZvY3VzYWJsZUlkXCJcbiAgICAgICAgICAgIFt0YWJpbmRleF09XCJ0YWJJbmRleFwiXG4gICAgICAgICAgICBbYXR0ci50aXRsZV09XCJ0aXRsZVwiXG4gICAgICAgICAgICBbZGlzYWJsZWRdPVwiZGlzYWJsZWRcIlxuICAgICAgICAgICAgW3JlYWRvbmx5XT1cInJlYWRvbmx5XCJcbiAgICAgICAgICAgIFtrZW5kb0V2ZW50c091dHNpZGVBbmd1bGFyXT1cIntcbiAgICAgICAgICAgICAgICBmb2N1czogaGFuZGxlRm9jdXMsXG4gICAgICAgICAgICAgICAgYmx1cjogaGFuZGxlQmx1cixcbiAgICAgICAgICAgICAgICBjbGljazogaGFuZGxlQ2xpY2ssXG4gICAgICAgICAgICAgICAgZHJhZ3N0YXJ0OiBoYW5kbGVEcmFnRHJvcCxcbiAgICAgICAgICAgICAgICBkcm9wOiBoYW5kbGVEcmFnRHJvcFxuICAgICAgICAgICAgfVwiXG4gICAgICAgIC8+XG4gICAgYFxuICAgICAgICAgICAgfSxdIH0sXG5dO1xuLyoqIEBub2NvbGxhcHNlICovXG5NYXNrZWRUZXh0Qm94Q29tcG9uZW50LmN0b3JQYXJhbWV0ZXJzID0gKCkgPT4gW1xuICAgIHsgdHlwZTogTWFza2luZ1NlcnZpY2UgfSxcbiAgICB7IHR5cGU6IFJlbmRlcmVyMiB9LFxuICAgIHsgdHlwZTogRWxlbWVudFJlZiB9LFxuICAgIHsgdHlwZTogTmdab25lIH0sXG4gICAgeyB0eXBlOiBJbmplY3RvciB9LFxuICAgIHsgdHlwZTogQ2hhbmdlRGV0ZWN0b3JSZWYgfSxcbiAgICB7IHR5cGU6IEJvb2xlYW4sIGRlY29yYXRvcnM6IFt7IHR5cGU6IE9wdGlvbmFsIH0sIHsgdHlwZTogSW5qZWN0LCBhcmdzOiBbUlRMLF0gfV0gfVxuXTtcbk1hc2tlZFRleHRCb3hDb21wb25lbnQucHJvcERlY29yYXRvcnMgPSB7XG4gICAgZm9jdXNhYmxlSWQ6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIGRpc2FibGVkOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICByZWFkb25seTogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgdGl0bGU6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIGRpcmVjdGlvbjogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnYXR0ci5kaXInLF0gfV0sXG4gICAgaG9zdENsYXNzZXM6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstd2lkZ2V0JyxdIH0sIHsgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnY2xhc3Muay1tYXNrZWR0ZXh0Ym94JyxdIH1dLFxuICAgIGhvc3REaXNhYmxlZENsYXNzOiBbeyB0eXBlOiBIb3N0QmluZGluZywgYXJnczogWydjbGFzcy5rLXN0YXRlLWRpc2FibGVkJyxdIH1dLFxuICAgIG1hc2s6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHZhbHVlOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBydWxlczogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgcHJvbXB0OiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBwcm9tcHRQbGFjZWhvbGRlcjogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgaW5jbHVkZUxpdGVyYWxzOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBtYXNrT25Gb2N1czogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgbWFza1ZhbGlkYXRpb246IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHRhYmluZGV4OiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICB0YWJJbmRleDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgb25Gb2N1czogW3sgdHlwZTogT3V0cHV0LCBhcmdzOiBbJ2ZvY3VzJyxdIH1dLFxuICAgIG9uQmx1cjogW3sgdHlwZTogT3V0cHV0LCBhcmdzOiBbJ2JsdXInLF0gfV0sXG4gICAgdmFsdWVDaGFuZ2U6IFt7IHR5cGU6IE91dHB1dCB9XSxcbiAgICBpbnB1dDogW3sgdHlwZTogVmlld0NoaWxkLCBhcmdzOiBbJ2lucHV0JywgeyBzdGF0aWM6IHRydWUgfSxdIH1dLFxuICAgIHBhc3RlSGFuZGxlcjogW3sgdHlwZTogSG9zdExpc3RlbmVyLCBhcmdzOiBbJ3Bhc3RlJywgWyckZXZlbnQnXSxdIH1dLFxuICAgIGlucHV0SGFuZGxlcjogW3sgdHlwZTogSG9zdExpc3RlbmVyLCBhcmdzOiBbJ2lucHV0JywgWyckZXZlbnQnXSxdIH1dXG59O1xuXG4vKiB0c2xpbnQ6ZGlzYWJsZTpjb21wb25lbnQtc2VsZWN0b3IgKi9cbi8qKlxuICogQGhpZGRlblxuICovXG5jbGFzcyBTbGlkZXJUaWNrIHtcbiAgICBjb25zdHJ1Y3Rvcih2YWx1ZSkge1xuICAgICAgICB0aGlzLnZhbHVlID0gdmFsdWU7XG4gICAgICAgIHRoaXMuY2xhc3NlcyA9IHtcbiAgICAgICAgICAgICdrLXRpY2snOiB0cnVlXG4gICAgICAgIH07XG4gICAgfVxufVxuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNsYXNzIFNsaWRlclRpY2tzQ29tcG9uZW50IHtcbiAgICBjb25zdHJ1Y3RvcihydGwpIHtcbiAgICAgICAgdGhpcy5ydGwgPSBydGw7XG4gICAgICAgIHRoaXMud3JhcHBlckNsYXNzZXMgPSAnay1yZXNldCBrLXNsaWRlci1pdGVtcyc7XG4gICAgICAgIHRoaXMudGlja3MgPSBbXTtcbiAgICB9XG4gICAgbmdPbkNoYW5nZXMoXykge1xuICAgICAgICB0aGlzLmNyZWF0ZVRpY2tzKCk7XG4gICAgfVxuICAgIGNyZWF0ZVRpY2tzKCkge1xuICAgICAgICBjb25zdCBjb3VudCA9IGNhbGN1bGF0ZVRpY2tzQ291bnQodGhpcy5taW4sIHRoaXMubWF4LCB0aGlzLnN0ZXApO1xuICAgICAgICBjb25zdCBsYXJnZVN0ZXAgPSB0aGlzLmxhcmdlU3RlcDtcbiAgICAgICAgY29uc3QgdGlja1ZhbHVlUHJvcHMgPSB7XG4gICAgICAgICAgICBtYXg6IHRoaXMubWF4LFxuICAgICAgICAgICAgbWluOiB0aGlzLm1pbixcbiAgICAgICAgICAgIHNtYWxsU3RlcDogdGhpcy5zdGVwXG4gICAgICAgIH07XG4gICAgICAgIGxldCByZXN1bHQgPSBbXTtcbiAgICAgICAgZm9yIChsZXQgaSA9IDA7IGkgPCBjb3VudDsgaSsrKSB7XG4gICAgICAgICAgICByZXN1bHQucHVzaChuZXcgU2xpZGVyVGljayhjYWxjdWxhdGVWYWx1ZUZyb21UaWNrKGksIHRpY2tWYWx1ZVByb3BzKSkpO1xuICAgICAgICAgICAgaWYgKGxhcmdlU3RlcCAmJiBpICUgbGFyZ2VTdGVwID09PSAwKSB7XG4gICAgICAgICAgICAgICAgcmVzdWx0W2ldLmxhcmdlID0gdHJ1ZTtcbiAgICAgICAgICAgICAgICByZXN1bHRbaV0uY2xhc3Nlc1snay10aWNrLWxhcmdlJ10gPSB0cnVlO1xuICAgICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICAgIGlmICh0aGlzLnJ0bCB8fCB0aGlzLnZlcnRpY2FsKSB7XG4gICAgICAgICAgICByZXN1bHQgPSByZXN1bHQucmV2ZXJzZSgpO1xuICAgICAgICB9XG4gICAgICAgIGlmIChyZXN1bHQubGVuZ3RoID4gMCkge1xuICAgICAgICAgICAgT2JqZWN0LmFzc2lnbihyZXN1bHRbMF0uY2xhc3NlcywgdGhpcy5lbmRUaWNrQ2xhc3Nlcyh0cnVlKSk7XG4gICAgICAgICAgICBPYmplY3QuYXNzaWduKHJlc3VsdFtyZXN1bHQubGVuZ3RoIC0gMV0uY2xhc3NlcywgdGhpcy5lbmRUaWNrQ2xhc3NlcyhmYWxzZSkpO1xuICAgICAgICB9XG4gICAgICAgIHRoaXMudGlja3MgPSByZXN1bHQ7XG4gICAgfVxuICAgIGVuZFRpY2tDbGFzc2VzKGZpcnN0KSB7XG4gICAgICAgIHJldHVybiB7XG4gICAgICAgICAgICAnay1maXJzdCc6IChmaXJzdCAmJiAhdGhpcy52ZXJ0aWNhbCkgfHwgKCFmaXJzdCAmJiB0aGlzLnZlcnRpY2FsKSxcbiAgICAgICAgICAgICdrLWxhc3QnOiAoIWZpcnN0ICYmICF0aGlzLnZlcnRpY2FsKSB8fCAoZmlyc3QgJiYgdGhpcy52ZXJ0aWNhbClcbiAgICAgICAgfTtcbiAgICB9XG59XG5TbGlkZXJUaWNrc0NvbXBvbmVudC5kZWNvcmF0b3JzID0gW1xuICAgIHsgdHlwZTogQ29tcG9uZW50LCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIHNlbGVjdG9yOiAnW2tlbmRvU2xpZGVyVGlja3NdJyxcbiAgICAgICAgICAgICAgICB0ZW1wbGF0ZTogYFxuICAgIDxsaSAjdGlja0VsZW1lbnQgKm5nRm9yPVwibGV0IHRpY2sgb2YgdGlja3M7XCJcbiAgICAgICAgW25nQ2xhc3NdPVwidGljay5jbGFzc2VzXCJcbiAgICAgICAgdGl0bGU9XCJ7eyB0aWNrVGl0bGUodGljay52YWx1ZSkgfX1cIlxuICAgICAgICByb2xlPVwicHJlc2VudGF0aW9uXCJcbiAgICAgPlxuICAgICAgICAgPG5nLWNvbnRhaW5lciBbbmdTd2l0Y2hdPVwidGljay5sYXJnZVwiPlxuICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJrLWxhYmVsXCIgKm5nU3dpdGNoQ2FzZT1cInRydWVcIj5cbiAgICAgICAgICAgICAgICA8bmctY29udGFpbmVyIFtuZ1RlbXBsYXRlT3V0bGV0XT1cImxhYmVsVGVtcGxhdGUgfHwgZGVmYXVsdExhYmVsXCIgW25nVGVtcGxhdGVPdXRsZXRDb250ZXh0XT1cInRpY2tcIj5cbiAgICAgICAgICAgICAgICA8L25nLWNvbnRhaW5lcj5cbiAgICAgICAgICAgIDwvc3Bhbj5cbiAgICAgICAgICAgIDxuZy1jb250YWluZXIgKm5nU3dpdGNoQ2FzZT1cImZhbHNlXCI+Jm5ic3A7PC9uZy1jb250YWluZXI+XG4gICAgICAgICA8L25nLWNvbnRhaW5lcj5cbiAgICAgPC9saT5cblxuICAgICA8bmctdGVtcGxhdGUgI2RlZmF1bHRMYWJlbCBsZXQtdmFsdWU9XCJ2YWx1ZVwiPlxuICAgICAgICB7eyB0aWNrVGl0bGUodmFsdWUpIH19XG4gICAgIDwvbmctdGVtcGxhdGU+XG4gIGBcbiAgICAgICAgICAgIH0sXSB9LFxuXTtcbi8qKiBAbm9jb2xsYXBzZSAqL1xuU2xpZGVyVGlja3NDb21wb25lbnQuY3RvclBhcmFtZXRlcnMgPSAoKSA9PiBbXG4gICAgeyB0eXBlOiBCb29sZWFuLCBkZWNvcmF0b3JzOiBbeyB0eXBlOiBPcHRpb25hbCB9LCB7IHR5cGU6IEluamVjdCwgYXJnczogW1JUTCxdIH1dIH1cbl07XG5TbGlkZXJUaWNrc0NvbXBvbmVudC5wcm9wRGVjb3JhdG9ycyA9IHtcbiAgICB3cmFwcGVyQ2xhc3NlczogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnY2xhc3MnLF0gfV0sXG4gICAgdGlja1RpdGxlOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICB2ZXJ0aWNhbDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgc3RlcDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgbGFyZ2VTdGVwOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBtaW46IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIG1heDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgbGFiZWxUZW1wbGF0ZTogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgdGlja0VsZW1lbnRzOiBbeyB0eXBlOiBWaWV3Q2hpbGRyZW4sIGFyZ3M6IFsndGlja0VsZW1lbnQnLF0gfV1cbn07XG5cbi8qKlxuICogQGhpZGRlblxuICovXG5jbGFzcyBTbGlkZXJzQ29tbW9uTW9kdWxlIHtcbn1cblNsaWRlcnNDb21tb25Nb2R1bGUuZGVjb3JhdG9ycyA9IFtcbiAgICB7IHR5cGU6IE5nTW9kdWxlLCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIGRlY2xhcmF0aW9uczogW1xuICAgICAgICAgICAgICAgICAgICBTbGlkZXJUaWNrc0NvbXBvbmVudCxcbiAgICAgICAgICAgICAgICAgICAgTGFiZWxUZW1wbGF0ZURpcmVjdGl2ZVxuICAgICAgICAgICAgICAgIF0sXG4gICAgICAgICAgICAgICAgZXhwb3J0czogW1xuICAgICAgICAgICAgICAgICAgICBMYWJlbFRlbXBsYXRlRGlyZWN0aXZlLFxuICAgICAgICAgICAgICAgICAgICBTbGlkZXJUaWNrc0NvbXBvbmVudCxcbiAgICAgICAgICAgICAgICAgICAgRHJhZ2dhYmxlTW9kdWxlLFxuICAgICAgICAgICAgICAgICAgICBFdmVudHNNb2R1bGUsXG4gICAgICAgICAgICAgICAgICAgIFJlc2l6ZVNlbnNvck1vZHVsZVxuICAgICAgICAgICAgICAgIF0sXG4gICAgICAgICAgICAgICAgaW1wb3J0czogW0NvbW1vbk1vZHVsZSwgRHJhZ2dhYmxlTW9kdWxlLCBFdmVudHNNb2R1bGUsIFJlc2l6ZVNlbnNvck1vZHVsZV1cbiAgICAgICAgICAgIH0sXSB9LFxuXTtcblxuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNsYXNzIFNsaWRlck1lc3NhZ2VzIGV4dGVuZHMgQ29tcG9uZW50TWVzc2FnZXMge1xufVxuU2xpZGVyTWVzc2FnZXMucHJvcERlY29yYXRvcnMgPSB7XG4gICAgZGVjcmVtZW50OiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBpbmNyZW1lbnQ6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIGRyYWdIYW5kbGU6IFt7IHR5cGU6IElucHV0IH1dXG59O1xuXG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY2xhc3MgTG9jYWxpemVkU2xpZGVyTWVzc2FnZXNEaXJlY3RpdmUgZXh0ZW5kcyBTbGlkZXJNZXNzYWdlcyB7XG4gICAgY29uc3RydWN0b3Ioc2VydmljZSkge1xuICAgICAgICBzdXBlcigpO1xuICAgICAgICB0aGlzLnNlcnZpY2UgPSBzZXJ2aWNlO1xuICAgIH1cbn1cbkxvY2FsaXplZFNsaWRlck1lc3NhZ2VzRGlyZWN0aXZlLmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBEaXJlY3RpdmUsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgcHJvdmlkZXJzOiBbXG4gICAgICAgICAgICAgICAgICAgIHtcbiAgICAgICAgICAgICAgICAgICAgICAgIHByb3ZpZGU6IFNsaWRlck1lc3NhZ2VzLFxuICAgICAgICAgICAgICAgICAgICAgICAgdXNlRXhpc3Rpbmc6IGZvcndhcmRSZWYoKCkgPT4gTG9jYWxpemVkU2xpZGVyTWVzc2FnZXNEaXJlY3RpdmUpIC8vIHRzbGludDpkaXNhYmxlLWxpbmU6bm8tZm9yd2FyZC1yZWZcbiAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIF0sXG4gICAgICAgICAgICAgICAgc2VsZWN0b3I6ICdba2VuZG9TbGlkZXJMb2NhbGl6ZWRNZXNzYWdlc10nXG4gICAgICAgICAgICB9LF0gfSxcbl07XG4vKiogQG5vY29sbGFwc2UgKi9cbkxvY2FsaXplZFNsaWRlck1lc3NhZ2VzRGlyZWN0aXZlLmN0b3JQYXJhbWV0ZXJzID0gKCkgPT4gW1xuICAgIHsgdHlwZTogTG9jYWxpemF0aW9uU2VydmljZSB9XG5dO1xuXG4vKipcbiAqIEN1c3RvbSBjb21wb25lbnQgbWVzc2FnZXMgb3ZlcnJpZGUgZGVmYXVsdCBjb21wb25lbnQgbWVzc2FnZXMuXG4gKi9cbmNsYXNzIFNsaWRlckN1c3RvbU1lc3NhZ2VzQ29tcG9uZW50IGV4dGVuZHMgU2xpZGVyTWVzc2FnZXMge1xuICAgIGNvbnN0cnVjdG9yKHNlcnZpY2UpIHtcbiAgICAgICAgc3VwZXIoKTtcbiAgICAgICAgdGhpcy5zZXJ2aWNlID0gc2VydmljZTtcbiAgICB9XG4gICAgZ2V0IG92ZXJyaWRlKCkge1xuICAgICAgICByZXR1cm4gdHJ1ZTtcbiAgICB9XG59XG5TbGlkZXJDdXN0b21NZXNzYWdlc0NvbXBvbmVudC5kZWNvcmF0b3JzID0gW1xuICAgIHsgdHlwZTogQ29tcG9uZW50LCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIHByb3ZpZGVyczogW1xuICAgICAgICAgICAgICAgICAgICB7XG4gICAgICAgICAgICAgICAgICAgICAgICBwcm92aWRlOiBTbGlkZXJNZXNzYWdlcyxcbiAgICAgICAgICAgICAgICAgICAgICAgIHVzZUV4aXN0aW5nOiBmb3J3YXJkUmVmKCgpID0+IFNsaWRlckN1c3RvbU1lc3NhZ2VzQ29tcG9uZW50KSAvLyB0c2xpbnQ6ZGlzYWJsZS1saW5lOm5vLWZvcndhcmQtcmVmXG4gICAgICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICBdLFxuICAgICAgICAgICAgICAgIHNlbGVjdG9yOiAna2VuZG8tc2xpZGVyLW1lc3NhZ2VzJyxcbiAgICAgICAgICAgICAgICB0ZW1wbGF0ZTogYGBcbiAgICAgICAgICAgIH0sXSB9LFxuXTtcbi8qKiBAbm9jb2xsYXBzZSAqL1xuU2xpZGVyQ3VzdG9tTWVzc2FnZXNDb21wb25lbnQuY3RvclBhcmFtZXRlcnMgPSAoKSA9PiBbXG4gICAgeyB0eXBlOiBMb2NhbGl6YXRpb25TZXJ2aWNlIH1cbl07XG5cbi8qKlxuICogUmVwcmVzZW50cyB0aGUgW05nTW9kdWxlXSh7eyBzaXRlLmRhdGEudXJscy5hbmd1bGFyWyduZ21vZHVsZWFwaSddIH19KVxuICogZGVmaW5pdGlvbiBmb3IgdGhlIFNsaWRlciBjb21wb25lbnQuXG4gKlxuICogQGV4YW1wbGVcbiAqXG4gKiBgYGB0cy1uby1ydW5cbiAqIC8vIEltcG9ydCB0aGUgSW5wdXRzIG1vZHVsZVxuICogaW1wb3J0IHsgU2xpZGVyTW9kdWxlIH0gZnJvbSAnQHByb2dyZXNzL2tlbmRvLWFuZ3VsYXItaW5wdXRzJztcbiAqXG4gKiAvLyBUaGUgYnJvd3NlciBwbGF0Zm9ybSB3aXRoIGEgY29tcGlsZXJcbiAqIGltcG9ydCB7IHBsYXRmb3JtQnJvd3NlckR5bmFtaWMgfSBmcm9tICdAYW5ndWxhci9wbGF0Zm9ybS1icm93c2VyLWR5bmFtaWMnO1xuICogaW1wb3J0IHsgQnJvd3NlckFuaW1hdGlvbnNNb2R1bGUgfSBmcm9tICdAYW5ndWxhci9wbGF0Zm9ybS1icm93c2VyL2FuaW1hdGlvbnMnO1xuICpcbiAqIGltcG9ydCB7IE5nTW9kdWxlIH0gZnJvbSAnQGFuZ3VsYXIvY29yZSc7XG4gKlxuICogLy8gSW1wb3J0IHRoZSBhcHAgY29tcG9uZW50XG4gKiBpbXBvcnQgeyBBcHBDb21wb25lbnQgfSBmcm9tICcuL2FwcC5jb21wb25lbnQnO1xuICpcbiAqIC8vIERlZmluZSB0aGUgYXBwIG1vZHVsZVxuICogX0BOZ01vZHVsZSh7XG4gKiAgICAgZGVjbGFyYXRpb25zOiBbQXBwQ29tcG9uZW50XSwgLy8gZGVjbGFyZSBhcHAgY29tcG9uZW50XG4gKiAgICAgaW1wb3J0czogICAgICBbQnJvd3Nlck1vZHVsZSwgQnJvd3NlckFuaW1hdGlvbnNNb2R1bGUsIFNsaWRlck1vZHVsZV0sIC8vIGltcG9ydCBTbGlkZXIgbW9kdWxlXG4gKiAgICAgYm9vdHN0cmFwOiAgICBbQXBwQ29tcG9uZW50XVxuICogfSlcbiAqIGV4cG9ydCBjbGFzcyBBcHBNb2R1bGUge31cbiAqXG4gKiAvLyBDb21waWxlIGFuZCBsYXVuY2ggdGhlIG1vZHVsZVxuICogcGxhdGZvcm1Ccm93c2VyRHluYW1pYygpLmJvb3RzdHJhcE1vZHVsZShBcHBNb2R1bGUpO1xuICpcbiAqIGBgYFxuICovXG5jbGFzcyBTbGlkZXJNb2R1bGUge1xufVxuU2xpZGVyTW9kdWxlLmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBOZ01vZHVsZSwgYXJnczogW3tcbiAgICAgICAgICAgICAgICBkZWNsYXJhdGlvbnM6IFtcbiAgICAgICAgICAgICAgICAgICAgU2xpZGVyQ29tcG9uZW50LFxuICAgICAgICAgICAgICAgICAgICBTbGlkZXJDdXN0b21NZXNzYWdlc0NvbXBvbmVudCxcbiAgICAgICAgICAgICAgICAgICAgTG9jYWxpemVkU2xpZGVyTWVzc2FnZXNEaXJlY3RpdmVcbiAgICAgICAgICAgICAgICBdLFxuICAgICAgICAgICAgICAgIGV4cG9ydHM6IFtcbiAgICAgICAgICAgICAgICAgICAgU2xpZGVyQ29tcG9uZW50LFxuICAgICAgICAgICAgICAgICAgICBTbGlkZXJDdXN0b21NZXNzYWdlc0NvbXBvbmVudCxcbiAgICAgICAgICAgICAgICAgICAgTGFiZWxUZW1wbGF0ZURpcmVjdGl2ZSxcbiAgICAgICAgICAgICAgICAgICAgTG9jYWxpemVkU2xpZGVyTWVzc2FnZXNEaXJlY3RpdmVcbiAgICAgICAgICAgICAgICBdLFxuICAgICAgICAgICAgICAgIGltcG9ydHM6IFtDb21tb25Nb2R1bGUsIFNsaWRlcnNDb21tb25Nb2R1bGVdXG4gICAgICAgICAgICB9LF0gfSxcbl07XG5cbi8qKlxuICogQGhpZGRlblxuICovXG5jbGFzcyBSYW5nZVNsaWRlck1lc3NhZ2VzIGV4dGVuZHMgQ29tcG9uZW50TWVzc2FnZXMge1xufVxuUmFuZ2VTbGlkZXJNZXNzYWdlcy5wcm9wRGVjb3JhdG9ycyA9IHtcbiAgICBkcmFnSGFuZGxlU3RhcnQ6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIGRyYWdIYW5kbGVFbmQ6IFt7IHR5cGU6IElucHV0IH1dXG59O1xuXG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY2xhc3MgTG9jYWxpemVkUmFuZ2VTbGlkZXJNZXNzYWdlc0RpcmVjdGl2ZSBleHRlbmRzIFJhbmdlU2xpZGVyTWVzc2FnZXMge1xuICAgIGNvbnN0cnVjdG9yKHNlcnZpY2UpIHtcbiAgICAgICAgc3VwZXIoKTtcbiAgICAgICAgdGhpcy5zZXJ2aWNlID0gc2VydmljZTtcbiAgICB9XG59XG5Mb2NhbGl6ZWRSYW5nZVNsaWRlck1lc3NhZ2VzRGlyZWN0aXZlLmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBEaXJlY3RpdmUsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgcHJvdmlkZXJzOiBbXG4gICAgICAgICAgICAgICAgICAgIHtcbiAgICAgICAgICAgICAgICAgICAgICAgIHByb3ZpZGU6IFJhbmdlU2xpZGVyTWVzc2FnZXMsXG4gICAgICAgICAgICAgICAgICAgICAgICB1c2VFeGlzdGluZzogZm9yd2FyZFJlZigoKSA9PiBMb2NhbGl6ZWRSYW5nZVNsaWRlck1lc3NhZ2VzRGlyZWN0aXZlKSAvLyB0c2xpbnQ6ZGlzYWJsZS1saW5lOm5vLWZvcndhcmQtcmVmXG4gICAgICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICBdLFxuICAgICAgICAgICAgICAgIHNlbGVjdG9yOiAnW2tlbmRvU2xpZGVyTG9jYWxpemVkTWVzc2FnZXNdJ1xuICAgICAgICAgICAgfSxdIH0sXG5dO1xuLyoqIEBub2NvbGxhcHNlICovXG5Mb2NhbGl6ZWRSYW5nZVNsaWRlck1lc3NhZ2VzRGlyZWN0aXZlLmN0b3JQYXJhbWV0ZXJzID0gKCkgPT4gW1xuICAgIHsgdHlwZTogTG9jYWxpemF0aW9uU2VydmljZSB9XG5dO1xuXG4vKipcbiAqIEN1c3RvbSBjb21wb25lbnQgbWVzc2FnZXMgb3ZlcnJpZGUgZGVmYXVsdCBjb21wb25lbnQgbWVzc2FnZXMuXG4gKi9cbmNsYXNzIFJhbmdlU2xpZGVyQ3VzdG9tTWVzc2FnZXNDb21wb25lbnQgZXh0ZW5kcyBSYW5nZVNsaWRlck1lc3NhZ2VzIHtcbiAgICBjb25zdHJ1Y3RvcihzZXJ2aWNlKSB7XG4gICAgICAgIHN1cGVyKCk7XG4gICAgICAgIHRoaXMuc2VydmljZSA9IHNlcnZpY2U7XG4gICAgfVxuICAgIGdldCBvdmVycmlkZSgpIHtcbiAgICAgICAgcmV0dXJuIHRydWU7XG4gICAgfVxufVxuUmFuZ2VTbGlkZXJDdXN0b21NZXNzYWdlc0NvbXBvbmVudC5kZWNvcmF0b3JzID0gW1xuICAgIHsgdHlwZTogQ29tcG9uZW50LCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIHByb3ZpZGVyczogW1xuICAgICAgICAgICAgICAgICAgICB7XG4gICAgICAgICAgICAgICAgICAgICAgICBwcm92aWRlOiBSYW5nZVNsaWRlck1lc3NhZ2VzLFxuICAgICAgICAgICAgICAgICAgICAgICAgdXNlRXhpc3Rpbmc6IGZvcndhcmRSZWYoKCkgPT4gUmFuZ2VTbGlkZXJDdXN0b21NZXNzYWdlc0NvbXBvbmVudCkgLy8gdHNsaW50OmRpc2FibGUtbGluZTpuby1mb3J3YXJkLXJlZlxuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgXSxcbiAgICAgICAgICAgICAgICBzZWxlY3RvcjogJ2tlbmRvLXJhbmdlc2xpZGVyLW1lc3NhZ2VzJyxcbiAgICAgICAgICAgICAgICB0ZW1wbGF0ZTogYGBcbiAgICAgICAgICAgIH0sXSB9LFxuXTtcbi8qKiBAbm9jb2xsYXBzZSAqL1xuUmFuZ2VTbGlkZXJDdXN0b21NZXNzYWdlc0NvbXBvbmVudC5jdG9yUGFyYW1ldGVycyA9ICgpID0+IFtcbiAgICB7IHR5cGU6IExvY2FsaXphdGlvblNlcnZpY2UgfVxuXTtcblxuLyoqXG4gKiBSZXByZXNlbnRzIHRoZSBbTmdNb2R1bGVdKHt7IHNpdGUuZGF0YS51cmxzLmFuZ3VsYXJbJ25nbW9kdWxlYXBpJ10gfX0pXG4gKiBkZWZpbml0aW9uIGZvciB0aGUgUmFuZ2VTbGlkZXIgY29tcG9uZW50LlxuICpcbiAqIEBleGFtcGxlXG4gKlxuICogYGBgdHMtbm8tcnVuXG4gKiAvLyBJbXBvcnQgdGhlIElucHV0cyBtb2R1bGVcbiAqIGltcG9ydCB7IFJhbmdlU2xpZGVyTW9kdWxlIH0gZnJvbSAnQHByb2dyZXNzL2tlbmRvLWFuZ3VsYXItaW5wdXRzJztcbiAqXG4gKiAvLyBUaGUgYnJvd3NlciBwbGF0Zm9ybSB3aXRoIGEgY29tcGlsZXJcbiAqIGltcG9ydCB7IHBsYXRmb3JtQnJvd3NlckR5bmFtaWMgfSBmcm9tICdAYW5ndWxhci9wbGF0Zm9ybS1icm93c2VyLWR5bmFtaWMnO1xuICogaW1wb3J0IHsgQnJvd3NlckFuaW1hdGlvbnNNb2R1bGUgfSBmcm9tICdAYW5ndWxhci9wbGF0Zm9ybS1icm93c2VyL2FuaW1hdGlvbnMnO1xuICpcbiAqIGltcG9ydCB7IE5nTW9kdWxlIH0gZnJvbSAnQGFuZ3VsYXIvY29yZSc7XG4gKlxuICogLy8gSW1wb3J0IHRoZSBhcHAgY29tcG9uZW50XG4gKiBpbXBvcnQgeyBBcHBDb21wb25lbnQgfSBmcm9tICcuL2FwcC5jb21wb25lbnQnO1xuICpcbiAqIC8vIERlZmluZSB0aGUgYXBwIG1vZHVsZVxuICogX0BOZ01vZHVsZSh7XG4gKiAgICAgZGVjbGFyYXRpb25zOiBbQXBwQ29tcG9uZW50XSwgLy8gZGVjbGFyZSBhcHAgY29tcG9uZW50XG4gKiAgICAgaW1wb3J0czogICAgICBbQnJvd3Nlck1vZHVsZSwgQnJvd3NlckFuaW1hdGlvbnNNb2R1bGUsIFJhbmdlU2xpZGVyTW9kdWxlXSwgLy8gaW1wb3J0IFJhbmdlU2xpZGVyIG1vZHVsZVxuICogICAgIGJvb3RzdHJhcDogICAgW0FwcENvbXBvbmVudF1cbiAqIH0pXG4gKiBleHBvcnQgY2xhc3MgQXBwTW9kdWxlIHt9XG4gKlxuICogLy8gQ29tcGlsZSBhbmQgbGF1bmNoIHRoZSBtb2R1bGVcbiAqIHBsYXRmb3JtQnJvd3NlckR5bmFtaWMoKS5ib290c3RyYXBNb2R1bGUoQXBwTW9kdWxlKTtcbiAqXG4gKiBgYGBcbiAqL1xuY2xhc3MgUmFuZ2VTbGlkZXJNb2R1bGUge1xufVxuUmFuZ2VTbGlkZXJNb2R1bGUuZGVjb3JhdG9ycyA9IFtcbiAgICB7IHR5cGU6IE5nTW9kdWxlLCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIGRlY2xhcmF0aW9uczogW1xuICAgICAgICAgICAgICAgICAgICBSYW5nZVNsaWRlckNvbXBvbmVudCxcbiAgICAgICAgICAgICAgICAgICAgUmFuZ2VTbGlkZXJDdXN0b21NZXNzYWdlc0NvbXBvbmVudCxcbiAgICAgICAgICAgICAgICAgICAgTG9jYWxpemVkUmFuZ2VTbGlkZXJNZXNzYWdlc0RpcmVjdGl2ZVxuICAgICAgICAgICAgICAgIF0sXG4gICAgICAgICAgICAgICAgZXhwb3J0czogW1xuICAgICAgICAgICAgICAgICAgICBSYW5nZVNsaWRlckNvbXBvbmVudCxcbiAgICAgICAgICAgICAgICAgICAgUmFuZ2VTbGlkZXJDdXN0b21NZXNzYWdlc0NvbXBvbmVudCxcbiAgICAgICAgICAgICAgICAgICAgTG9jYWxpemVkUmFuZ2VTbGlkZXJNZXNzYWdlc0RpcmVjdGl2ZSxcbiAgICAgICAgICAgICAgICAgICAgTGFiZWxUZW1wbGF0ZURpcmVjdGl2ZVxuICAgICAgICAgICAgICAgIF0sXG4gICAgICAgICAgICAgICAgaW1wb3J0czogW0NvbW1vbk1vZHVsZSwgU2xpZGVyc0NvbW1vbk1vZHVsZV1cbiAgICAgICAgICAgIH0sXSB9LFxuXTtcblxuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNsYXNzIE1lc3NhZ2VzIGV4dGVuZHMgQ29tcG9uZW50TWVzc2FnZXMge1xufVxuTWVzc2FnZXMucHJvcERlY29yYXRvcnMgPSB7XG4gICAgb246IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIG9mZjogW3sgdHlwZTogSW5wdXQgfV1cbn07XG5cbi8qKlxuICogQGhpZGRlblxuICovXG5jbGFzcyBMb2NhbGl6ZWRTd2l0Y2hNZXNzYWdlc0RpcmVjdGl2ZSBleHRlbmRzIE1lc3NhZ2VzIHtcbiAgICBjb25zdHJ1Y3RvcihzZXJ2aWNlKSB7XG4gICAgICAgIHN1cGVyKCk7XG4gICAgICAgIHRoaXMuc2VydmljZSA9IHNlcnZpY2U7XG4gICAgfVxufVxuTG9jYWxpemVkU3dpdGNoTWVzc2FnZXNEaXJlY3RpdmUuZGVjb3JhdG9ycyA9IFtcbiAgICB7IHR5cGU6IERpcmVjdGl2ZSwgYXJnczogW3tcbiAgICAgICAgICAgICAgICBwcm92aWRlcnM6IFtcbiAgICAgICAgICAgICAgICAgICAge1xuICAgICAgICAgICAgICAgICAgICAgICAgcHJvdmlkZTogTWVzc2FnZXMsXG4gICAgICAgICAgICAgICAgICAgICAgICB1c2VFeGlzdGluZzogZm9yd2FyZFJlZigoKSA9PiBMb2NhbGl6ZWRTd2l0Y2hNZXNzYWdlc0RpcmVjdGl2ZSkgLy8gdHNsaW50OmRpc2FibGUtbGluZTpuby1mb3J3YXJkLXJlZlxuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgXSxcbiAgICAgICAgICAgICAgICBzZWxlY3RvcjogJ1trZW5kb1N3aXRjaExvY2FsaXplZE1lc3NhZ2VzXSdcbiAgICAgICAgICAgIH0sXSB9LFxuXTtcbi8qKiBAbm9jb2xsYXBzZSAqL1xuTG9jYWxpemVkU3dpdGNoTWVzc2FnZXNEaXJlY3RpdmUuY3RvclBhcmFtZXRlcnMgPSAoKSA9PiBbXG4gICAgeyB0eXBlOiBMb2NhbGl6YXRpb25TZXJ2aWNlIH1cbl07XG5cbi8qKlxuICogQ3VzdG9tIGNvbXBvbmVudCBtZXNzYWdlcyBvdmVycmlkZSBkZWZhdWx0IGNvbXBvbmVudCBtZXNzYWdlcy5cbiAqL1xuY2xhc3MgU3dpdGNoQ3VzdG9tTWVzc2FnZXNDb21wb25lbnQgZXh0ZW5kcyBNZXNzYWdlcyB7XG4gICAgY29uc3RydWN0b3Ioc2VydmljZSkge1xuICAgICAgICBzdXBlcigpO1xuICAgICAgICB0aGlzLnNlcnZpY2UgPSBzZXJ2aWNlO1xuICAgIH1cbiAgICBnZXQgb3ZlcnJpZGUoKSB7XG4gICAgICAgIHJldHVybiB0cnVlO1xuICAgIH1cbn1cblN3aXRjaEN1c3RvbU1lc3NhZ2VzQ29tcG9uZW50LmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBDb21wb25lbnQsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgcHJvdmlkZXJzOiBbXG4gICAgICAgICAgICAgICAgICAgIHtcbiAgICAgICAgICAgICAgICAgICAgICAgIHByb3ZpZGU6IE1lc3NhZ2VzLFxuICAgICAgICAgICAgICAgICAgICAgICAgdXNlRXhpc3Rpbmc6IGZvcndhcmRSZWYoKCkgPT4gU3dpdGNoQ3VzdG9tTWVzc2FnZXNDb21wb25lbnQpIC8vIHRzbGludDpkaXNhYmxlLWxpbmU6bm8tZm9yd2FyZC1yZWZcbiAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIF0sXG4gICAgICAgICAgICAgICAgc2VsZWN0b3I6ICdrZW5kby1zd2l0Y2gtbWVzc2FnZXMnLFxuICAgICAgICAgICAgICAgIHRlbXBsYXRlOiBgYFxuICAgICAgICAgICAgfSxdIH0sXG5dO1xuLyoqIEBub2NvbGxhcHNlICovXG5Td2l0Y2hDdXN0b21NZXNzYWdlc0NvbXBvbmVudC5jdG9yUGFyYW1ldGVycyA9ICgpID0+IFtcbiAgICB7IHR5cGU6IExvY2FsaXphdGlvblNlcnZpY2UgfVxuXTtcblxuLyoqXG4gKiBSZXByZXNlbnRzIHRoZSBbTmdNb2R1bGVdKHt7IHNpdGUuZGF0YS51cmxzLmFuZ3VsYXJbJ25nbW9kdWxlYXBpJ10gfX0pXG4gKiBkZWZpbml0aW9uIGZvciB0aGUgU3dpdGNoIGNvbXBvbmVudC5cbiAqXG4gKiBAZXhhbXBsZVxuICpcbiAqIGBgYHRzLW5vLXJ1blxuICogLy8gSW1wb3J0IHRoZSBTd2l0Y2ggbW9kdWxlXG4gKiBpbXBvcnQgeyBTd2l0Y2hNb2R1bGUgfSBmcm9tICdAcHJvZ3Jlc3Mva2VuZG8tYW5ndWxhci1pbnB1dHMnO1xuICpcbiAqIC8vIFRoZSBicm93c2VyIHBsYXRmb3JtIHdpdGggYSBjb21waWxlclxuICogaW1wb3J0IHsgcGxhdGZvcm1Ccm93c2VyRHluYW1pYyB9IGZyb20gJ0Bhbmd1bGFyL3BsYXRmb3JtLWJyb3dzZXItZHluYW1pYyc7XG4gKlxuICogaW1wb3J0IHsgTmdNb2R1bGUgfSBmcm9tICdAYW5ndWxhci9jb3JlJztcbiAqXG4gKiAvLyBJbXBvcnQgdGhlIGFwcCBjb21wb25lbnRcbiAqIGltcG9ydCB7IEFwcENvbXBvbmVudCB9IGZyb20gJy4vYXBwLmNvbXBvbmVudCc7XG4gKlxuICogLy8gRGVmaW5lIHRoZSBhcHAgbW9kdWxlXG4gKiBfQE5nTW9kdWxlKHtcbiAqICAgICBkZWNsYXJhdGlvbnM6IFtBcHBDb21wb25lbnRdLCAvLyBkZWNsYXJlIGFwcCBjb21wb25lbnRcbiAqICAgICBpbXBvcnRzOiAgICAgIFtCcm93c2VyTW9kdWxlLCBTd2l0Y2hNb2R1bGVdLCAvLyBpbXBvcnQgU3dpdGNoIG1vZHVsZVxuICogICAgIGJvb3RzdHJhcDogICAgW0FwcENvbXBvbmVudF1cbiAqIH0pXG4gKiBleHBvcnQgY2xhc3MgQXBwTW9kdWxlIHt9XG4gKlxuICogLy8gQ29tcGlsZSBhbmQgbGF1bmNoIHRoZSBtb2R1bGVcbiAqIHBsYXRmb3JtQnJvd3NlckR5bmFtaWMoKS5ib290c3RyYXBNb2R1bGUoQXBwTW9kdWxlKTtcbiAqXG4gKiBgYGBcbiAqL1xuY2xhc3MgU3dpdGNoTW9kdWxlIHtcbn1cblN3aXRjaE1vZHVsZS5kZWNvcmF0b3JzID0gW1xuICAgIHsgdHlwZTogTmdNb2R1bGUsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgZGVjbGFyYXRpb25zOiBbXG4gICAgICAgICAgICAgICAgICAgIFN3aXRjaENvbXBvbmVudCxcbiAgICAgICAgICAgICAgICAgICAgU3dpdGNoQ3VzdG9tTWVzc2FnZXNDb21wb25lbnQsXG4gICAgICAgICAgICAgICAgICAgIExvY2FsaXplZFN3aXRjaE1lc3NhZ2VzRGlyZWN0aXZlXG4gICAgICAgICAgICAgICAgXSxcbiAgICAgICAgICAgICAgICBleHBvcnRzOiBbXG4gICAgICAgICAgICAgICAgICAgIFN3aXRjaENvbXBvbmVudCxcbiAgICAgICAgICAgICAgICAgICAgU3dpdGNoQ3VzdG9tTWVzc2FnZXNDb21wb25lbnQsXG4gICAgICAgICAgICAgICAgICAgIExvY2FsaXplZFN3aXRjaE1lc3NhZ2VzRGlyZWN0aXZlXG4gICAgICAgICAgICAgICAgXSxcbiAgICAgICAgICAgICAgICBpbXBvcnRzOiBbQ29tbW9uTW9kdWxlLCBFdmVudHNNb2R1bGUsIFJlc2l6ZVNlbnNvck1vZHVsZV1cbiAgICAgICAgICAgIH0sXSB9LFxuXTtcblxuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNsYXNzIExvY2FsaXplZE51bWVyaWNUZXh0Qm94TWVzc2FnZXNEaXJlY3RpdmUgZXh0ZW5kcyBOdW1lcmljVGV4dEJveE1lc3NhZ2VzIHtcbiAgICBjb25zdHJ1Y3RvcihzZXJ2aWNlKSB7XG4gICAgICAgIHN1cGVyKCk7XG4gICAgICAgIHRoaXMuc2VydmljZSA9IHNlcnZpY2U7XG4gICAgfVxufVxuTG9jYWxpemVkTnVtZXJpY1RleHRCb3hNZXNzYWdlc0RpcmVjdGl2ZS5kZWNvcmF0b3JzID0gW1xuICAgIHsgdHlwZTogRGlyZWN0aXZlLCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIHByb3ZpZGVyczogW1xuICAgICAgICAgICAgICAgICAgICB7XG4gICAgICAgICAgICAgICAgICAgICAgICBwcm92aWRlOiBOdW1lcmljVGV4dEJveE1lc3NhZ2VzLFxuICAgICAgICAgICAgICAgICAgICAgICAgdXNlRXhpc3Rpbmc6IGZvcndhcmRSZWYoKCkgPT4gTG9jYWxpemVkTnVtZXJpY1RleHRCb3hNZXNzYWdlc0RpcmVjdGl2ZSkgLy8gdHNsaW50OmRpc2FibGUtbGluZTpuby1mb3J3YXJkLXJlZlxuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgXSxcbiAgICAgICAgICAgICAgICBzZWxlY3RvcjogJ1trZW5kb051bWVyaWNUZXh0Qm94TG9jYWxpemVkTWVzc2FnZXNdJ1xuICAgICAgICAgICAgfSxdIH0sXG5dO1xuLyoqIEBub2NvbGxhcHNlICovXG5Mb2NhbGl6ZWROdW1lcmljVGV4dEJveE1lc3NhZ2VzRGlyZWN0aXZlLmN0b3JQYXJhbWV0ZXJzID0gKCkgPT4gW1xuICAgIHsgdHlwZTogTG9jYWxpemF0aW9uU2VydmljZSB9XG5dO1xuXG4vKipcbiAqIFJlcHJlc2VudHMgdGhlIFtOZ01vZHVsZV0oe3sgc2l0ZS5kYXRhLnVybHMuYW5ndWxhclsnbmdtb2R1bGVhcGknXSB9fSlcbiAqIGRlZmluaXRpb24gZm9yIHRoZSBOdW1lcmljVGV4dEJveCBjb21wb25lbnQuXG4gKlxuICogQGV4YW1wbGVcbiAqXG4gKiBgYGB0cy1uby1ydW5cbiAqIC8vIEltcG9ydCB0aGUgTnVtZXJpY1RleHRCb3ggbW9kdWxlXG4gKiBpbXBvcnQgeyBOdW1lcmljVGV4dEJveE1vZHVsZSB9IGZyb20gJ0Bwcm9ncmVzcy9rZW5kby1hbmd1bGFyLWlucHV0cyc7XG4gKlxuICogLy8gVGhlIGJyb3dzZXIgcGxhdGZvcm0gd2l0aCBhIGNvbXBpbGVyXG4gKiBpbXBvcnQgeyBwbGF0Zm9ybUJyb3dzZXJEeW5hbWljIH0gZnJvbSAnQGFuZ3VsYXIvcGxhdGZvcm0tYnJvd3Nlci1keW5hbWljJztcbiAqXG4gKiBpbXBvcnQgeyBOZ01vZHVsZSB9IGZyb20gJ0Bhbmd1bGFyL2NvcmUnO1xuICpcbiAqIC8vIEltcG9ydCB0aGUgYXBwIGNvbXBvbmVudFxuICogaW1wb3J0IHsgQXBwQ29tcG9uZW50IH0gZnJvbSAnLi9hcHAuY29tcG9uZW50JztcbiAqXG4gKiAvLyBEZWZpbmUgdGhlIGFwcCBtb2R1bGVcbiAqIF9ATmdNb2R1bGUoe1xuICogICAgIGRlY2xhcmF0aW9uczogW0FwcENvbXBvbmVudF0sIC8vIGRlY2xhcmUgYXBwIGNvbXBvbmVudFxuICogICAgIGltcG9ydHM6ICAgICAgW0Jyb3dzZXJNb2R1bGUsIE51bWVyaWNUZXh0Qm94TW9kdWxlXSwgLy8gaW1wb3J0IE51bWVyaWNUZXh0Qm94IG1vZHVsZVxuICogICAgIGJvb3RzdHJhcDogICAgW0FwcENvbXBvbmVudF1cbiAqIH0pXG4gKiBleHBvcnQgY2xhc3MgQXBwTW9kdWxlIHt9XG4gKlxuICogLy8gQ29tcGlsZSBhbmQgbGF1bmNoIHRoZSBtb2R1bGVcbiAqIHBsYXRmb3JtQnJvd3NlckR5bmFtaWMoKS5ib290c3RyYXBNb2R1bGUoQXBwTW9kdWxlKTtcbiAqXG4gKiBgYGBcbiAqL1xuY2xhc3MgTnVtZXJpY1RleHRCb3hNb2R1bGUge1xufVxuTnVtZXJpY1RleHRCb3hNb2R1bGUuZGVjb3JhdG9ycyA9IFtcbiAgICB7IHR5cGU6IE5nTW9kdWxlLCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIGRlY2xhcmF0aW9uczogW1xuICAgICAgICAgICAgICAgICAgICBMb2NhbGl6ZWROdW1lcmljVGV4dEJveE1lc3NhZ2VzRGlyZWN0aXZlLFxuICAgICAgICAgICAgICAgICAgICBOdW1lcmljVGV4dEJveENvbXBvbmVudCxcbiAgICAgICAgICAgICAgICAgICAgTnVtZXJpY1RleHRCb3hDdXN0b21NZXNzYWdlc0NvbXBvbmVudFxuICAgICAgICAgICAgICAgIF0sXG4gICAgICAgICAgICAgICAgZXhwb3J0czogW1xuICAgICAgICAgICAgICAgICAgICBOdW1lcmljVGV4dEJveENvbXBvbmVudCxcbiAgICAgICAgICAgICAgICAgICAgTnVtZXJpY1RleHRCb3hDdXN0b21NZXNzYWdlc0NvbXBvbmVudFxuICAgICAgICAgICAgICAgIF0sXG4gICAgICAgICAgICAgICAgaW1wb3J0czogW0NvbW1vbk1vZHVsZSwgRXZlbnRzTW9kdWxlXVxuICAgICAgICAgICAgfSxdIH0sXG5dO1xuXG4vKipcbiAqIFJlcHJlc2VudHMgdGhlIFtOZ01vZHVsZV0oe3sgc2l0ZS5kYXRhLnVybHMuYW5ndWxhclsnbmdtb2R1bGVhcGknXSB9fSlcbiAqIGRlZmluaXRpb24gZm9yIHRoZSBNYXNrZWRUZXh0Qm94IGNvbXBvbmVudC5cbiAqXG4gKiBAZXhhbXBsZVxuICpcbiAqIGBgYHRzLW5vLXJ1blxuICogLy8gSW1wb3J0IHRoZSBNYXNrZWRUZXh0Qm94IG1vZHVsZVxuICogaW1wb3J0IHsgTWFza2VkVGV4dEJveE1vZHVsZSB9IGZyb20gJ0Bwcm9ncmVzcy9rZW5kby1hbmd1bGFyLWlucHV0cyc7XG4gKlxuICogLy8gVGhlIGJyb3dzZXIgcGxhdGZvcm0gd2l0aCBhIGNvbXBpbGVyXG4gKiBpbXBvcnQgeyBwbGF0Zm9ybUJyb3dzZXJEeW5hbWljIH0gZnJvbSAnQGFuZ3VsYXIvcGxhdGZvcm0tYnJvd3Nlci1keW5hbWljJztcbiAqXG4gKiBpbXBvcnQgeyBOZ01vZHVsZSB9IGZyb20gJ0Bhbmd1bGFyL2NvcmUnO1xuICpcbiAqIC8vIEltcG9ydCB0aGUgYXBwIGNvbXBvbmVudFxuICogaW1wb3J0IHsgQXBwQ29tcG9uZW50IH0gZnJvbSAnLi9hcHAuY29tcG9uZW50JztcbiAqXG4gKiAvLyBEZWZpbmUgdGhlIGFwcCBtb2R1bGVcbiAqIF9ATmdNb2R1bGUoe1xuICogICAgIGRlY2xhcmF0aW9uczogW0FwcENvbXBvbmVudF0sIC8vIGRlY2xhcmUgYXBwIGNvbXBvbmVudFxuICogICAgIGltcG9ydHM6ICAgICAgW0Jyb3dzZXJNb2R1bGUsIE1hc2tlZFRleHRCb3hNb2R1bGVdLCAvLyBpbXBvcnQgTWFza2VkVGV4dEJveCBtb2R1bGVcbiAqICAgICBib290c3RyYXA6ICAgIFtBcHBDb21wb25lbnRdXG4gKiB9KVxuICogZXhwb3J0IGNsYXNzIEFwcE1vZHVsZSB7fVxuICpcbiAqIC8vIENvbXBpbGUgYW5kIGxhdW5jaCB0aGUgbW9kdWxlXG4gKiBwbGF0Zm9ybUJyb3dzZXJEeW5hbWljKCkuYm9vdHN0cmFwTW9kdWxlKEFwcE1vZHVsZSk7XG4gKlxuICogYGBgXG4gKi9cbmNsYXNzIE1hc2tlZFRleHRCb3hNb2R1bGUge1xufVxuTWFza2VkVGV4dEJveE1vZHVsZS5kZWNvcmF0b3JzID0gW1xuICAgIHsgdHlwZTogTmdNb2R1bGUsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgZGVjbGFyYXRpb25zOiBbTWFza2VkVGV4dEJveENvbXBvbmVudF0sXG4gICAgICAgICAgICAgICAgZXhwb3J0czogW01hc2tlZFRleHRCb3hDb21wb25lbnRdLFxuICAgICAgICAgICAgICAgIGltcG9ydHM6IFtDb21tb25Nb2R1bGUsIEV2ZW50c01vZHVsZV1cbiAgICAgICAgICAgIH0sXSB9LFxuXTtcblxuLyoqXG4gKiBTcGVjaWZpZXMgdGhlIGFkb3JubWVudHMgaW4gdGhlIHN1ZmZpeCBjb250YWluZXIgKFtzZWUgZXhhbXBsZXNdKHslIHNsdWcgYWRvcm5tZW50c190ZXh0Ym94ICV9I3RvYy1zdWZmaXhhZG9ybm1lbnRzKSkuXG4gKiAgQGV4YW1wbGVcbiAqIGBgYHRzLW5vLXJ1blxuICogX0BDb21wb25lbnQoe1xuICogc2VsZWN0b3I6ICdteS1hcHAnLFxuICogdGVtcGxhdGU6IGBcbiAqICA8a2VuZG8tdGV4dGJveD5cbiAqICAgIDxuZy10ZW1wbGF0ZSBrZW5kb1RleHRCb3hTdWZmaXhUZW1wbGF0ZT5cbiAqICAgICAgICA8YnV0dG9uIGtlbmRvQnV0dG9uIGxvb2s9XCJjbGVhclwiIGljb249XCJpbWFnZVwiPjwvYnV0dG9uPlxuICogICAgPC9uZy10ZW1wbGF0ZT5cbiAqICA8L2tlbmRvLXRleHRib3g+XG4gKiBgXG4gKiB9KVxuICogY2xhc3MgQXBwQ29tcG9uZW50IHt9XG4gKiBgYGBcbiAqL1xuY2xhc3MgVGV4dEJveFN1ZmZpeFRlbXBsYXRlRGlyZWN0aXZlIHtcbiAgICBjb25zdHJ1Y3Rvcih0ZW1wbGF0ZVJlZikge1xuICAgICAgICB0aGlzLnRlbXBsYXRlUmVmID0gdGVtcGxhdGVSZWY7XG4gICAgfVxufVxuVGV4dEJveFN1ZmZpeFRlbXBsYXRlRGlyZWN0aXZlLmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBEaXJlY3RpdmUsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgc2VsZWN0b3I6ICdba2VuZG9UZXh0Qm94U3VmZml4VGVtcGxhdGVdJ1xuICAgICAgICAgICAgfSxdIH0sXG5dO1xuLyoqIEBub2NvbGxhcHNlICovXG5UZXh0Qm94U3VmZml4VGVtcGxhdGVEaXJlY3RpdmUuY3RvclBhcmFtZXRlcnMgPSAoKSA9PiBbXG4gICAgeyB0eXBlOiBUZW1wbGF0ZVJlZiwgZGVjb3JhdG9yczogW3sgdHlwZTogT3B0aW9uYWwgfV0gfVxuXTtcblxuLyoqXG4gKiBTcGVjaWZpZXMgdGhlIGFkb3JubWVudHMgaW4gdGhlIHByZWZpeCBjb250YWluZXIgKFtzZWUgZXhhbXBsZXNdKHslIHNsdWcgYWRvcm5tZW50c190ZXh0Ym94ICV9I3RvYy1wcmVmaXhhZG9ybm1lbnRzKSkuXG4gKiBAZXhhbXBsZVxuICogYGBgdHMtbm8tcnVuXG4gKiBfQENvbXBvbmVudCh7XG4gKiBzZWxlY3RvcjogJ215LWFwcCcsXG4gKiB0ZW1wbGF0ZTogYFxuICogIDxrZW5kby10ZXh0Ym94PlxuICogICAgPG5nLXRlbXBsYXRlIGtlbmRvVGV4dEJveFByZWZpeFRlbXBsYXRlPlxuICogICAgICAgIDxidXR0b24ga2VuZG9CdXR0b24gbG9vaz1cImNsZWFyXCIgaWNvbj1cImltYWdlXCI+PC9idXR0b24+XG4gKiAgICA8L25nLXRlbXBsYXRlPlxuICogIDwva2VuZG8tdGV4dGJveD5cbiAqIGBcbiAqIH0pXG4gKiBjbGFzcyBBcHBDb21wb25lbnQge31cbiAqIGBgYFxuICovXG5jbGFzcyBUZXh0Qm94UHJlZml4VGVtcGxhdGVEaXJlY3RpdmUge1xuICAgIGNvbnN0cnVjdG9yKHRlbXBsYXRlUmVmKSB7XG4gICAgICAgIHRoaXMudGVtcGxhdGVSZWYgPSB0ZW1wbGF0ZVJlZjtcbiAgICB9XG59XG5UZXh0Qm94UHJlZml4VGVtcGxhdGVEaXJlY3RpdmUuZGVjb3JhdG9ycyA9IFtcbiAgICB7IHR5cGU6IERpcmVjdGl2ZSwgYXJnczogW3tcbiAgICAgICAgICAgICAgICBzZWxlY3RvcjogJ1trZW5kb1RleHRCb3hQcmVmaXhUZW1wbGF0ZV0nXG4gICAgICAgICAgICB9LF0gfSxcbl07XG4vKiogQG5vY29sbGFwc2UgKi9cblRleHRCb3hQcmVmaXhUZW1wbGF0ZURpcmVjdGl2ZS5jdG9yUGFyYW1ldGVycyA9ICgpID0+IFtcbiAgICB7IHR5cGU6IFRlbXBsYXRlUmVmLCBkZWNvcmF0b3JzOiBbeyB0eXBlOiBPcHRpb25hbCB9XSB9XG5dO1xuXG5jbGFzcyBUZXh0Qm94Q29tcG9uZW50IHtcbiAgICBjb25zdHJ1Y3Rvcihsb2NhbGl6YXRpb25TZXJ2aWNlLCBuZ1pvbmUsIGNoYW5nZURldGVjdG9yLCByZW5kZXJlciwgaW5qZWN0b3IsIGhvc3RFbGVtZW50KSB7XG4gICAgICAgIHRoaXMubG9jYWxpemF0aW9uU2VydmljZSA9IGxvY2FsaXphdGlvblNlcnZpY2U7XG4gICAgICAgIHRoaXMubmdab25lID0gbmdab25lO1xuICAgICAgICB0aGlzLmNoYW5nZURldGVjdG9yID0gY2hhbmdlRGV0ZWN0b3I7XG4gICAgICAgIHRoaXMucmVuZGVyZXIgPSByZW5kZXJlcjtcbiAgICAgICAgdGhpcy5pbmplY3RvciA9IGluamVjdG9yO1xuICAgICAgICB0aGlzLmhvc3RFbGVtZW50ID0gaG9zdEVsZW1lbnQ7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBTZXRzIHRoZSBgdGl0bGVgIGF0dHJpYnV0ZSBvZiB0aGUgYGlucHV0YCBlbGVtZW50IG9mIHRoZSBUZXh0Qm94LlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy50aXRsZSA9ICcnO1xuICAgICAgICAvKipcbiAgICAgICAgICogU2V0cyB0aGUgZGlzYWJsZWQgc3RhdGUgb2YgdGhlIGNvbXBvbmVudC5cbiAgICAgICAgICpcbiAgICAgICAgICogQGRlZmF1bHQgZmFsc2VcbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuZGlzYWJsZWQgPSBmYWxzZTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIFNldHMgdGhlIHJlYWQtb25seSBzdGF0ZSBvZiB0aGUgY29tcG9uZW50LlxuICAgICAgICAgKlxuICAgICAgICAgKiBAZGVmYXVsdCBmYWxzZVxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5yZWFkb25seSA9IGZhbHNlO1xuICAgICAgICAvKipcbiAgICAgICAgICogU3BlY2lmaWVzIHRoZSBgdGFiaW5kZXhgIG9mIHRoZSBUZXh0Qm94LlxuICAgICAgICAgKlxuICAgICAgICAgKiBAZGVmYXVsdCAwXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLnRhYmluZGV4ID0gMDtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIFByb3ZpZGVzIGEgdmFsdWUgZm9yIHRoZSBUZXh0Qm94LlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy52YWx1ZSA9IG51bGw7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBEZXRlcm1pbmVzIHdoZXRoZXIgdGhlIHdob2xlIHZhbHVlIHdpbGwgYmUgc2VsZWN0ZWQgd2hlbiB0aGUgVGV4dEJveCBpcyBjbGlja2VkLiBEZWZhdWx0cyB0byBgZmFsc2VgLlxuICAgICAgICAgKlxuICAgICAgICAgKiBAZGVmYXVsdCBmYWxzZVxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5zZWxlY3RPbkZvY3VzID0gZmFsc2U7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBTcGVjaWZpZXMgd2hlbiB0aGUgU3VjY2VzcyBpY29uIHdpbGwgYmUgc2hvd24gKFtzZWUgZXhhbXBsZV0oeyUgc2x1ZyB2YWxpZGF0aW9uX3RleHRib3ggJX0pKS5cbiAgICAgICAgICpcbiAgICAgICAgICogVGhlIHBvc3NpYmxlIHZhbHVlcyBhcmU6XG4gICAgICAgICAqXG4gICAgICAgICAqIGBib29sZWFuYCZtZGFzaDtUaGUgU3VjY2VzcyBpY29uIGlzIGRpc3BsYXllZCwgaWYgdGhlIGNvbmRpdGlvbiBnaXZlbiBieSB0aGUgZGV2ZWxvcGVyIGlzIG1ldC5cbiAgICAgICAgICpcbiAgICAgICAgICogYGluaXRpYWxgJm1kYXNoO1RoZSBTdWNjZXNzIGljb24gd2lsbCBiZSBkaXNwbGF5ZWQgd2hlbiB0aGUgY29tcG9uZW50IHN0YXRlIGlzIG5laXRoZXIgYGludmFsaWRgIG5vciBgdG91Y2hlZGAgb3IgYGRpcnR5YC5cbiAgICAgICAgICpcbiAgICAgICAgICogQGRlZmF1bHQgZmFsc2VcbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuc2hvd1N1Y2Nlc3NJY29uID0gZmFsc2U7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBTcGVjaWZpZXMgd2hlbiB0aGUgRXJyb3IgaWNvbiB3aWxsIGJlIHNob3duIChbc2VlIGV4YW1wbGVdKHslIHNsdWcgdmFsaWRhdGlvbl90ZXh0Ym94ICV9KSkuXG4gICAgICAgICAqXG4gICAgICAgICAqIFRoZSBwb3NzaWJsZSB2YWx1ZXMgYXJlOlxuICAgICAgICAgKlxuICAgICAgICAgKiAqIGBpbml0aWFsYCZtZGFzaDtUaGUgRXJyb3IgaWNvbiB3aWxsIGJlIGRpc3BsYXllZCB3aGVuIHRoZSBjb21wb25lbnQgc3RhdGUgaXNcbiAgICAgICAgICogYGludmFsaWRgIGFuZCBgdG91Y2hlZGAgb3IgYGRpcnR5YC5cbiAgICAgICAgICogKiBgYm9vbGVhbmAmbWRhc2g7VGhlIEVycm9yIGljb24gaXMgZGlzcGxheWVkLCBpZiB0aGUgY29uZGl0aW9uIGdpdmVuIGJ5IHRoZSBkZXZlbG9wZXIgaXMgbWV0LlxuICAgICAgICAgKlxuICAgICAgICAgKiBAZGVmYXVsdCBmYWxzZVxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5zaG93RXJyb3JJY29uID0gZmFsc2U7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBTcGVjaWZpZXMgd2hldGhlciBhIENsZWFyIGJ1dHRvbiB3aWxsIGJlIHJlbmRlcmVkLlxuICAgICAgICAgKlxuICAgICAgICAgKiBAZGVmYXVsdCBmYWxzZVxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5jbGVhckJ1dHRvbiA9IGZhbHNlO1xuICAgICAgICAvKipcbiAgICAgICAgICogRmlyZXMgZWFjaCB0aW1lIHRoZSB2YWx1ZSBpcyBjaGFuZ2VkJm1kYXNoO1xuICAgICAgICAgKiB3aGVuIHRoZSBjb21wb25lbnQgaXMgYmx1cnJlZCBvciB0aGUgdmFsdWUgaXMgY2xlYXJlZCB0aHJvdWdoIHRoZSAqKkNsZWFyKiogYnV0dG9uXG4gICAgICAgICAqIChbc2VlIGV4YW1wbGVdKHslIHNsdWcgb3ZlcnZpZXdfdGV4dGJveCAlfSN0b2MtZXZlbnRzKSkuXG4gICAgICAgICAqIFdoZW4gdGhlIHZhbHVlIG9mIHRoZSBjb21wb25lbnQgaXMgcHJvZ3JhbW1hdGljYWxseSBjaGFuZ2VkIHRvIGBuZ01vZGVsYCBvciBgZm9ybUNvbnRyb2xgXG4gICAgICAgICAqIHRocm91Z2ggaXRzIEFQSSBvciBmb3JtIGJpbmRpbmcsIHRoZSBgdmFsdWVDaGFuZ2VgIGV2ZW50IGlzIG5vdCB0cmlnZ2VyZWQgYmVjYXVzZSBpdFxuICAgICAgICAgKiBtaWdodCBjYXVzZSBhIG1peC11cCB3aXRoIHRoZSBidWlsdC1pbiBgdmFsdWVDaGFuZ2VgIG1lY2hhbmlzbXMgb2YgdGhlIGBuZ01vZGVsYCBvciBgZm9ybUNvbnRyb2xgIGJpbmRpbmdzLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy52YWx1ZUNoYW5nZSA9IG5ldyBFdmVudEVtaXR0ZXIoKTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEZpcmVzIGVhY2ggdGltZSB0aGUgdXNlciBmb2N1c2VzIHRoZSBgaW5wdXRgIGVsZW1lbnQuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmlucHV0Rm9jdXMgPSBuZXcgRXZlbnRFbWl0dGVyKCk7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBGaXJlcyBlYWNoIHRpbWUgdGhlIGBpbnB1dGAgZWxlbWVudCBnZXRzIGJsdXJyZWQuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmlucHV0Qmx1ciA9IG5ldyBFdmVudEVtaXR0ZXIoKTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEZpcmVzIGVhY2ggdGltZSB0aGUgdXNlciBmb2N1c2VzIHRoZSBUZXh0Qm94IGNvbXBvbmVudC5cbiAgICAgICAgICpcbiAgICAgICAgICogPiBUbyB3aXJlIHRoZSBldmVudCBwcm9ncmFtbWF0aWNhbGx5LCB1c2UgdGhlIGBvbkZvY3VzYCBwcm9wZXJ0eS5cbiAgICAgICAgICpcbiAgICAgICAgICogQGV4YW1wbGVcbiAgICAgICAgICogYGBgdHMtbm8tcnVuXG4gICAgICAgICAqIF9AQ29tcG9uZW50KHtcbiAgICAgICAgICogc2VsZWN0b3I6ICdteS1hcHAnLFxuICAgICAgICAgKiB0ZW1wbGF0ZTogYFxuICAgICAgICAgKiAgPGtlbmRvLXRleHRib3ggKGZvY3VzKT1cImhhbmRsZUZvY3VzKClcIj48L2tlbmRvLXRleHRib3g+XG4gICAgICAgICAqIGBcbiAgICAgICAgICogfSlcbiAgICAgICAgICogY2xhc3MgQXBwQ29tcG9uZW50IHtcbiAgICAgICAgICogICBwdWJsaWMgaGFuZGxlRm9jdXMoKTogdm9pZCB7XG4gICAgICAgICAqICAgICAgY29uc29sZS5sb2coJ0NvbXBvbmVudCBpcyBpc0ZvY3VzZWQnKTtcbiAgICAgICAgICogICB9XG4gICAgICAgICAqIH1cbiAgICAgICAgICogYGBgXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLm9uRm9jdXMgPSBuZXcgRXZlbnRFbWl0dGVyKCk7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBGaXJlcyBlYWNoIHRpbWUgdGhlIFRleHRCb3ggY29tcG9uZW50IGdldHMgYmx1cnJlZC5cbiAgICAgICAgICpcbiAgICAgICAgICogPiBUbyB3aXJlIHRoZSBldmVudCBwcm9ncmFtbWF0aWNhbGx5LCB1c2UgdGhlIGBvbkJsdXJgIHByb3BlcnR5LlxuICAgICAgICAgKlxuICAgICAgICAgKiBAZXhhbXBsZVxuICAgICAgICAgKiBgYGB0cy1uby1ydW5cbiAgICAgICAgICogX0BDb21wb25lbnQoe1xuICAgICAgICAgKiBzZWxlY3RvcjogJ215LWFwcCcsXG4gICAgICAgICAqIHRlbXBsYXRlOiBgXG4gICAgICAgICAqICA8a2VuZG8tdGV4dGJveCAoYmx1cik9XCJoYW5kbGVCbHVyKClcIj48L2tlbmRvLXRleHRib3g+XG4gICAgICAgICAqIGBcbiAgICAgICAgICogfSlcbiAgICAgICAgICogY2xhc3MgQXBwQ29tcG9uZW50IHtcbiAgICAgICAgICogICBwdWJsaWMgaGFuZGxlQmx1cigpOiB2b2lkIHtcbiAgICAgICAgICogICAgICBjb25zb2xlLmxvZygnQ29tcG9uZW50IGlzIGJsdXJyZWQnKTtcbiAgICAgICAgICogICB9XG4gICAgICAgICAqIH1cbiAgICAgICAgICogYGBgXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLm9uQmx1ciA9IG5ldyBFdmVudEVtaXR0ZXIoKTtcbiAgICAgICAgdGhpcy5ob3N0Q2xhc3MgPSB0cnVlO1xuICAgICAgICB0aGlzLl9pc0ZvY3VzZWQgPSBmYWxzZTtcbiAgICAgICAgdGhpcy5mb2N1c0NoYW5nZWRQcm9ncmFtbWF0aWNhbGx5ID0gZmFsc2U7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmhhbmRsZUlucHV0Rm9jdXMgPSAoKSA9PiB7XG4gICAgICAgICAgICBpZiAoIXRoaXMuZGlzYWJsZWQpIHtcbiAgICAgICAgICAgICAgICBpZiAodGhpcy5zZWxlY3RPbkZvY3VzICYmIHRoaXMudmFsdWUpIHtcbiAgICAgICAgICAgICAgICAgICAgdGhpcy5uZ1pvbmUucnVuKCgpID0+IHtcbiAgICAgICAgICAgICAgICAgICAgICAgIHNldFRpbWVvdXQoKCkgPT4geyB0aGlzLnNlbGVjdEFsbCgpOyB9KTtcbiAgICAgICAgICAgICAgICAgICAgfSk7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIGlmIChoYXNPYnNlcnZlcnModGhpcy5vbkZvY3VzKSkge1xuICAgICAgICAgICAgICAgICAgICBpZiAoIXRoaXMuaXNGb2N1c2VkKSB7XG4gICAgICAgICAgICAgICAgICAgICAgICB0aGlzLm5nWm9uZS5ydW4oKCkgPT4ge1xuICAgICAgICAgICAgICAgICAgICAgICAgICAgIHRoaXMub25Gb2N1cy5lbWl0KCk7XG4gICAgICAgICAgICAgICAgICAgICAgICB9KTtcbiAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICBpZiAoaGFzT2JzZXJ2ZXJzKHRoaXMuaW5wdXRGb2N1cykpIHtcbiAgICAgICAgICAgICAgICAgICAgaWYgKCF0aGlzLmZvY3VzQ2hhbmdlZFByb2dyYW1tYXRpY2FsbHkgfHwgKHRoaXMuZm9jdXNDaGFuZ2VkUHJvZ3JhbW1hdGljYWxseSAmJiB0aGlzLmNsZWFyQnV0dG9uQ2xpY2tlZCkpIHtcbiAgICAgICAgICAgICAgICAgICAgICAgIHRoaXMubmdab25lLnJ1bigoKSA9PiB7XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgdGhpcy5pbnB1dEZvY3VzLmVtaXQoKTtcbiAgICAgICAgICAgICAgICAgICAgICAgIH0pO1xuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIHRoaXMubmdab25lLnJ1bigoKSA9PiB7XG4gICAgICAgICAgICAgICAgICAgIHRoaXMuaXNGb2N1c2VkID0gdHJ1ZTtcbiAgICAgICAgICAgICAgICB9KTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgfTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuaGFuZGxlSW5wdXRCbHVyID0gKCkgPT4ge1xuICAgICAgICAgICAgdGhpcy5jaGFuZ2VEZXRlY3Rvci5tYXJrRm9yQ2hlY2soKTtcbiAgICAgICAgICAgIGlmIChoYXNPYnNlcnZlcnModGhpcy5pbnB1dEJsdXIpIHx8IHJlcXVpcmVzWm9uZU9uQmx1cih0aGlzLmNvbnRyb2wpKSB7XG4gICAgICAgICAgICAgICAgdGhpcy5uZ1pvbmUucnVuKCgpID0+IHtcbiAgICAgICAgICAgICAgICAgICAgdGhpcy5uZ1RvdWNoZWQoKTtcbiAgICAgICAgICAgICAgICAgICAgdGhpcy5pbnB1dEJsdXIuZW1pdCgpO1xuICAgICAgICAgICAgICAgIH0pO1xuICAgICAgICAgICAgfVxuICAgICAgICB9O1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5oYW5kbGVJbnB1dCA9IChldikgPT4ge1xuICAgICAgICAgICAgbGV0IGluY29taW5nVmFsdWUgPSBldi50YXJnZXQudmFsdWU7XG4gICAgICAgICAgICB0aGlzLnVwZGF0ZVZhbHVlKGluY29taW5nVmFsdWUpO1xuICAgICAgICB9O1xuICAgICAgICB0aGlzLm5nQ2hhbmdlID0gKF8pID0+IHsgfTtcbiAgICAgICAgdGhpcy5uZ1RvdWNoZWQgPSAoKSA9PiB7IH07XG4gICAgICAgIHRoaXMuZGlyZWN0aW9uID0gbG9jYWxpemF0aW9uU2VydmljZS5ydGwgPyAncnRsJyA6ICdsdHInO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgc2V0IHRhYkluZGV4KHRhYkluZGV4KSB7XG4gICAgICAgIHRoaXMudGFiaW5kZXggPSB0YWJJbmRleDtcbiAgICB9XG4gICAgZ2V0IHRhYkluZGV4KCkge1xuICAgICAgICByZXR1cm4gdGhpcy50YWJpbmRleDtcbiAgICB9XG4gICAgZ2V0IGRpc2FibGVkQ2xhc3MoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmRpc2FibGVkO1xuICAgIH1cbiAgICBnZXQgaXNGb2N1c2VkKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5kaXNhYmxlZCA/IGZhbHNlIDogdGhpcy5faXNGb2N1c2VkO1xuICAgIH1cbiAgICBzZXQgaXNGb2N1c2VkKGlzRm9jdXNlZCkge1xuICAgICAgICB0aGlzLl9pc0ZvY3VzZWQgPSBpc0ZvY3VzZWQ7XG4gICAgfVxuICAgIG5nT25Jbml0KCkge1xuICAgICAgICB0aGlzLmNvbnRyb2wgPSB0aGlzLmluamVjdG9yLmdldChOZ0NvbnRyb2wsIG51bGwpO1xuICAgICAgICB0aGlzLmNoZWNrQ2xlYXJCdXR0b24oKTtcbiAgICAgICAgdGhpcy5zdWJzY3JpcHRpb25zID0gdGhpcy5sb2NhbGl6YXRpb25TZXJ2aWNlLmNoYW5nZXMuc3Vic2NyaWJlKCh7IHJ0bCB9KSA9PiB7XG4gICAgICAgICAgICB0aGlzLmRpcmVjdGlvbiA9IHJ0bCA/ICdydGwnIDogJ2x0cic7XG4gICAgICAgIH0pO1xuICAgIH1cbiAgICBuZ0FmdGVyVmlld0luaXQoKSB7XG4gICAgICAgIGNvbnN0IGhvc3RFbGVtZW50ID0gdGhpcy5ob3N0RWxlbWVudC5uYXRpdmVFbGVtZW50O1xuICAgICAgICBsZXQgY3Vyc29ySW5zaWRlV3JhcHBlciA9IGZhbHNlO1xuICAgICAgICBsZXQgdGFiYmluZyA9IGZhbHNlO1xuICAgICAgICB0aGlzLm5nWm9uZS5ydW5PdXRzaWRlQW5ndWxhcigoKSA9PiB7XG4gICAgICAgICAgICAvLyBmb2N1c0luIGFuZCBmb2N1c091dCBhcmUgcmVsYXRpdmUgdG8gdGhlIGhvc3QgZWxlbWVudFxuICAgICAgICAgICAgdGhpcy5zdWJzY3JpcHRpb25zLmFkZCh0aGlzLnJlbmRlcmVyLmxpc3Rlbihob3N0RWxlbWVudCwgJ2ZvY3VzaW4nLCAoKSA9PiB7XG4gICAgICAgICAgICAgICAgaWYgKCF0aGlzLmlzRm9jdXNlZCkge1xuICAgICAgICAgICAgICAgICAgICB0aGlzLm5nWm9uZS5ydW4oKCkgPT4ge1xuICAgICAgICAgICAgICAgICAgICAgICAgdGhpcy5vbkZvY3VzLmVtaXQoKTtcbiAgICAgICAgICAgICAgICAgICAgICAgIHRoaXMuaXNGb2N1c2VkID0gdHJ1ZTtcbiAgICAgICAgICAgICAgICAgICAgfSk7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfSkpO1xuICAgICAgICAgICAgdGhpcy5zdWJzY3JpcHRpb25zLmFkZCh0aGlzLnJlbmRlcmVyLmxpc3Rlbihob3N0RWxlbWVudCwgJ2ZvY3Vzb3V0JywgKGFyZ3MpID0+IHtcbiAgICAgICAgICAgICAgICBpZiAoIXRoaXMuaXNGb2N1c2VkKSB7XG4gICAgICAgICAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgaWYgKHRhYmJpbmcpIHtcbiAgICAgICAgICAgICAgICAgICAgY29uc3QgY2xvc2VzdFRleHRib3ggPSBjbG9zZXN0KGFyZ3MucmVsYXRlZFRhcmdldCwgKGVsZW1lbnQpID0+IGVsZW1lbnQgPT09IHRoaXMuaG9zdEVsZW1lbnQubmF0aXZlRWxlbWVudCk7XG4gICAgICAgICAgICAgICAgICAgIGlmICghY2xvc2VzdFRleHRib3gpIHtcbiAgICAgICAgICAgICAgICAgICAgICAgIHRoaXMuaGFuZGxlQmx1cigpO1xuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgICAgIHRhYmJpbmcgPSBmYWxzZTtcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgZWxzZSB7XG4gICAgICAgICAgICAgICAgICAgIGlmICghY3Vyc29ySW5zaWRlV3JhcHBlciAmJiAhdGhpcy5jbGVhckJ1dHRvbkNsaWNrZWQpIHtcbiAgICAgICAgICAgICAgICAgICAgICAgIHRoaXMuaGFuZGxlQmx1cigpO1xuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfSkpO1xuICAgICAgICAgICAgdGhpcy5zdWJzY3JpcHRpb25zLmFkZCh0aGlzLnJlbmRlcmVyLmxpc3Rlbihob3N0RWxlbWVudCwgJ21vdXNlZW50ZXInLCAoKSA9PiB7XG4gICAgICAgICAgICAgICAgY3Vyc29ySW5zaWRlV3JhcHBlciA9IHRydWU7XG4gICAgICAgICAgICB9KSk7XG4gICAgICAgICAgICB0aGlzLnN1YnNjcmlwdGlvbnMuYWRkKHRoaXMucmVuZGVyZXIubGlzdGVuKGhvc3RFbGVtZW50LCAnbW91c2VsZWF2ZScsICgpID0+IHtcbiAgICAgICAgICAgICAgICBjdXJzb3JJbnNpZGVXcmFwcGVyID0gZmFsc2U7XG4gICAgICAgICAgICB9KSk7XG4gICAgICAgICAgICB0aGlzLnN1YnNjcmlwdGlvbnMuYWRkKHRoaXMucmVuZGVyZXIubGlzdGVuKGhvc3RFbGVtZW50LCAna2V5ZG93bicsIChhcmdzKSA9PiB7XG4gICAgICAgICAgICAgICAgaWYgKGFyZ3Mua2V5Q29kZSA9PT0gS2V5cy5UYWIpIHtcbiAgICAgICAgICAgICAgICAgICAgdGFiYmluZyA9IHRydWU7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIGVsc2Uge1xuICAgICAgICAgICAgICAgICAgICB0YWJiaW5nID0gZmFsc2U7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfSkpO1xuICAgICAgICB9KTtcbiAgICB9XG4gICAgbmdPbkNoYW5nZXMoY2hhbmdlcykge1xuICAgICAgICBpZiAoY2hhbmdlcy5kaXNhYmxlZCB8fCBjaGFuZ2VzLnJlYWRvbmx5KSB7XG4gICAgICAgICAgICB0aGlzLmNoZWNrQ2xlYXJCdXR0b24oKTtcbiAgICAgICAgfVxuICAgIH1cbiAgICBuZ09uRGVzdHJveSgpIHtcbiAgICAgICAgdGhpcy5zdWJzY3JpcHRpb25zLnVuc3Vic2NyaWJlKCk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEZvY3VzZXMgdGhlIFRleHRCb3guXG4gICAgICpcbiAgICAgKiBAZXhhbXBsZVxuICAgICAqIGBgYHRzLW5vLXJ1blxuICAgICAqIF9AQ29tcG9uZW50KHtcbiAgICAgKiBzZWxlY3RvcjogJ215LWFwcCcsXG4gICAgICogdGVtcGxhdGU6IGBcbiAgICAgKiAgPGJ1dHRvbiAoY2xpY2spPVwiaW5wdXQuZm9jdXMoKVwiPkZvY3VzIHRoZSBpbnB1dDwvYnV0dG9uPlxuICAgICAqICA8a2VuZG8tdGV4dGJveCAjaW5wdXQ+PC9rZW5kby10ZXh0Ym94PlxuICAgICAqIGBcbiAgICAgKiB9KVxuICAgICAqIGNsYXNzIEFwcENvbXBvbmVudCB7IH1cbiAgICAgKiBgYGBcbiAgICAgKi9cbiAgICBmb2N1cygpIHtcbiAgICAgICAgaWYgKCF0aGlzLmlucHV0KSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5mb2N1c0NoYW5nZWRQcm9ncmFtbWF0aWNhbGx5ID0gdHJ1ZTtcbiAgICAgICAgdGhpcy5pc0ZvY3VzZWQgPSB0cnVlO1xuICAgICAgICB0aGlzLmlucHV0Lm5hdGl2ZUVsZW1lbnQuZm9jdXMoKTtcbiAgICAgICAgdGhpcy5mb2N1c0NoYW5nZWRQcm9ncmFtbWF0aWNhbGx5ID0gZmFsc2U7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEJsdXJzIHRoZSBUZXh0Qm94LlxuICAgICAqL1xuICAgIGJsdXIoKSB7XG4gICAgICAgIHRoaXMuZm9jdXNDaGFuZ2VkUHJvZ3JhbW1hdGljYWxseSA9IHRydWU7XG4gICAgICAgIGNvbnN0IGlzRm9jdXNlZEVsZW1lbnQgPSB0aGlzLmhvc3RFbGVtZW50Lm5hdGl2ZUVsZW1lbnQucXVlcnlTZWxlY3RvcignOmZvY3VzJyk7XG4gICAgICAgIGlmIChpc0ZvY3VzZWRFbGVtZW50KSB7XG4gICAgICAgICAgICBpc0ZvY3VzZWRFbGVtZW50LmJsdXIoKTtcbiAgICAgICAgfVxuICAgICAgICB0aGlzLmlzRm9jdXNlZCA9IGZhbHNlO1xuICAgICAgICB0aGlzLmZvY3VzQ2hhbmdlZFByb2dyYW1tYXRpY2FsbHkgPSBmYWxzZTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIGNsZWFyVGl0bGUoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmxvY2FsaXphdGlvblNlcnZpY2UuZ2V0KCdjbGVhcicpO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgY2hlY2tDbGVhckJ1dHRvbigpIHtcbiAgICAgICAgdGhpcy5zaG93Q2xlYXJCdXR0b24gPVxuICAgICAgICAgICAgIXRoaXMuZGlzYWJsZWQgJiZcbiAgICAgICAgICAgICAgICAhdGhpcy5yZWFkb25seSAmJlxuICAgICAgICAgICAgICAgIHRoaXMuY2xlYXJCdXR0b24gJiZcbiAgICAgICAgICAgICAgICAhIXRoaXMudmFsdWU7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBjbGVhclZhbHVlKGV2KSB7XG4gICAgICAgIGlmIChldikge1xuICAgICAgICAgICAgZXYucHJldmVudERlZmF1bHQoKTtcbiAgICAgICAgfVxuICAgICAgICB0aGlzLmNsZWFyQnV0dG9uQ2xpY2tlZCA9IHRydWU7XG4gICAgICAgIHRoaXMuaW5wdXQubmF0aXZlRWxlbWVudC52YWx1ZSA9ICcnO1xuICAgICAgICB0aGlzLmlucHV0Lm5hdGl2ZUVsZW1lbnQuZm9jdXMoKTtcbiAgICAgICAgdGhpcy51cGRhdGVWYWx1ZShudWxsKTtcbiAgICAgICAgdGhpcy5jaGVja0NsZWFyQnV0dG9uKCk7XG4gICAgICAgIHRoaXMuY2xlYXJCdXR0b25DbGlja2VkID0gZmFsc2U7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICB3cml0ZVZhbHVlKHZhbHVlKSB7XG4gICAgICAgIHRoaXMudmFsdWUgPSB2YWx1ZTtcbiAgICAgICAgdGhpcy5jaGVja0NsZWFyQnV0dG9uKCk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICByZWdpc3Rlck9uQ2hhbmdlKGZuKSB7XG4gICAgICAgIHRoaXMubmdDaGFuZ2UgPSBmbjtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHJlZ2lzdGVyT25Ub3VjaGVkKGZuKSB7XG4gICAgICAgIHRoaXMubmdUb3VjaGVkID0gZm47XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKiBDYWxsZWQgd2hlbiB0aGUgc3RhdHVzIG9mIHRoZSBjb21wb25lbnQgY2hhbmdlcyB0byBvciBmcm9tIGBkaXNhYmxlZGAuXG4gICAgICogRGVwZW5kaW5nIG9uIHRoZSB2YWx1ZSwgaXQgZW5hYmxlcyBvciBkaXNhYmxlcyB0aGUgYXBwcm9wcmlhdGUgRE9NIGVsZW1lbnQuXG4gICAgICpcbiAgICAgKiBAcGFyYW0gaXNEaXNhYmxlZFxuICAgICAqL1xuICAgIHNldERpc2FibGVkU3RhdGUoaXNEaXNhYmxlZCkge1xuICAgICAgICB0aGlzLmRpc2FibGVkID0gaXNEaXNhYmxlZDtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHNob3dFcnJvcnNJbml0aWFsKCkge1xuICAgICAgICBpZiAoIXRoaXMuY29udHJvbCkge1xuICAgICAgICAgICAgcmV0dXJuIGZhbHNlO1xuICAgICAgICB9XG4gICAgICAgIGNvbnN0IHsgaW52YWxpZCwgZGlydHksIHRvdWNoZWQgfSA9IHRoaXMuY29udHJvbDtcbiAgICAgICAgcmV0dXJuIGludmFsaWQgJiYgKGRpcnR5IHx8IHRvdWNoZWQpO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgc2hvd1N1Y2Nlc3NJbml0aWFsKCkge1xuICAgICAgICBpZiAoIXRoaXMuY29udHJvbCkge1xuICAgICAgICAgICAgcmV0dXJuIGZhbHNlO1xuICAgICAgICB9XG4gICAgICAgIGNvbnN0IHsgdmFsaWQsIGRpcnR5LCB0b3VjaGVkIH0gPSB0aGlzLmNvbnRyb2w7XG4gICAgICAgIHJldHVybiB2YWxpZCAmJiAoZGlydHkgfHwgdG91Y2hlZCk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBnZXQgc3VjY2Vzc0ljb25DbGFzc2VzKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5zdWNjZXNzSWNvblxuICAgICAgICAgICAgPyBgay10ZXh0LXN1Y2Nlc3MgJHt0aGlzLnN1Y2Nlc3NJY29ufWBcbiAgICAgICAgICAgIDogYGstdGV4dC1zdWNjZXNzIGstaWNvbiBrLWktY2hlY2stb3V0bGluZWA7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBnZXQgZXJyb3JJY29uQ2xhc3NlcygpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuZXJyb3JJY29uXG4gICAgICAgICAgICA/IGBrLXRleHQtZXJyb3IgJHt0aGlzLmVycm9ySWNvbn1gXG4gICAgICAgICAgICA6IGBrLXRleHQtZXJyb3Igay1pY29uIGstaS13YXJuaW5nYDtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIGdldCBjbGVhckJ1dHRvbkNsYXNzZXMoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmNsZWFyQnV0dG9uSWNvblxuICAgICAgICAgICAgPyB0aGlzLmNsZWFyQnV0dG9uSWNvblxuICAgICAgICAgICAgOiBgay1pY29uIGstaS1jbG9zZS1jaXJjbGVgO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgZ2V0IGhhc0Vycm9ycygpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuc2hvd0Vycm9ySWNvbiA9PT0gJ2luaXRpYWwnXG4gICAgICAgICAgICA/IHRoaXMuc2hvd0Vycm9yc0luaXRpYWwoKVxuICAgICAgICAgICAgOiB0aGlzLnNob3dFcnJvckljb247XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBnZXQgaXNTdWNjZXNzZnVsKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5zaG93U3VjY2Vzc0ljb24gPT09ICdpbml0aWFsJ1xuICAgICAgICAgICAgPyB0aGlzLnNob3dTdWNjZXNzSW5pdGlhbCgpXG4gICAgICAgICAgICA6IHRoaXMuc2hvd1N1Y2Nlc3NJY29uO1xuICAgIH1cbiAgICBzZXRTZWxlY3Rpb24oc3RhcnQsIGVuZCkge1xuICAgICAgICBpZiAodGhpcy5pc0ZvY3VzZWQpIHtcbiAgICAgICAgICAgIGludm9rZUVsZW1lbnRNZXRob2QodGhpcy5pbnB1dCwgJ3NldFNlbGVjdGlvblJhbmdlJywgc3RhcnQsIGVuZCk7XG4gICAgICAgIH1cbiAgICB9XG4gICAgc2VsZWN0QWxsKCkge1xuICAgICAgICBpZiAodGhpcy52YWx1ZSkge1xuICAgICAgICAgICAgdGhpcy5zZXRTZWxlY3Rpb24oMCwgdGhpcy52YWx1ZS5sZW5ndGgpO1xuICAgICAgICB9XG4gICAgfVxuICAgIHVwZGF0ZVZhbHVlKHZhbHVlKSB7XG4gICAgICAgIGlmICghYXJlU2FtZSh0aGlzLnZhbHVlLCB2YWx1ZSkpIHtcbiAgICAgICAgICAgIHRoaXMubmdab25lLnJ1bigoKSA9PiB7XG4gICAgICAgICAgICAgICAgdGhpcy52YWx1ZSA9IHZhbHVlO1xuICAgICAgICAgICAgICAgIHRoaXMubmdDaGFuZ2UodmFsdWUpO1xuICAgICAgICAgICAgICAgIHRoaXMudmFsdWVDaGFuZ2UuZW1pdCh2YWx1ZSk7XG4gICAgICAgICAgICAgICAgdGhpcy5jaGVja0NsZWFyQnV0dG9uKCk7XG4gICAgICAgICAgICAgICAgdGhpcy5jaGFuZ2VEZXRlY3Rvci5tYXJrRm9yQ2hlY2soKTtcbiAgICAgICAgICAgIH0pO1xuICAgICAgICB9XG4gICAgfVxuICAgIGhhbmRsZUJsdXIoKSB7XG4gICAgICAgIHRoaXMubmdab25lLnJ1bigoKSA9PiB7XG4gICAgICAgICAgICBpZiAoIXRoaXMuZm9jdXNDaGFuZ2VkUHJvZ3JhbW1hdGljYWxseSkge1xuICAgICAgICAgICAgICAgIHRoaXMub25CbHVyLmVtaXQoKTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICAgIHRoaXMuaXNGb2N1c2VkID0gZmFsc2U7XG4gICAgICAgIH0pO1xuICAgIH1cbn1cblRleHRCb3hDb21wb25lbnQuZGVjb3JhdG9ycyA9IFtcbiAgICB7IHR5cGU6IENvbXBvbmVudCwgYXJnczogW3tcbiAgICAgICAgICAgICAgICBleHBvcnRBczogJ2tlbmRvVGV4dEJveCcsXG4gICAgICAgICAgICAgICAgcHJvdmlkZXJzOiBbXG4gICAgICAgICAgICAgICAgICAgIExvY2FsaXphdGlvblNlcnZpY2UsXG4gICAgICAgICAgICAgICAgICAgIHsgcHJvdmlkZTogTDEwTl9QUkVGSVgsIHVzZVZhbHVlOiAna2VuZG8udGV4dGJveCcgfSxcbiAgICAgICAgICAgICAgICAgICAge1xuICAgICAgICAgICAgICAgICAgICAgICAgcHJvdmlkZTogTkdfVkFMVUVfQUNDRVNTT1IsXG4gICAgICAgICAgICAgICAgICAgICAgICB1c2VFeGlzdGluZzogZm9yd2FyZFJlZigoKSA9PiBUZXh0Qm94Q29tcG9uZW50KSxcbiAgICAgICAgICAgICAgICAgICAgICAgIG11bHRpOiB0cnVlXG4gICAgICAgICAgICAgICAgICAgIH0sXG4gICAgICAgICAgICAgICAgICAgIHsgcHJvdmlkZTogS2VuZG9JbnB1dCwgdXNlRXhpc3Rpbmc6IGZvcndhcmRSZWYoKCkgPT4gVGV4dEJveENvbXBvbmVudCkgfVxuICAgICAgICAgICAgICAgIF0sXG4gICAgICAgICAgICAgICAgc2VsZWN0b3I6ICdrZW5kby10ZXh0Ym94JyxcbiAgICAgICAgICAgICAgICB0ZW1wbGF0ZTogYFxuICAgICAgICA8bmctY29udGFpbmVyIGtlbmRvVGV4dEJveExvY2FsaXplZE1lc3NhZ2VzXG4gICAgICAgICAgICBpMThuLWNsZWFyPVwia2VuZG8udGV4dGJveC5jbGVhcnxUaGUgdGl0bGUgZm9yIHRoZSAqKkNsZWFyKiogYnV0dG9uIGluIHRoZSBUZXh0Qm94LlwiXG4gICAgICAgICAgICBjbGVhcj1cIkNsZWFyXCI+XG4gICAgICAgIDwvbmctY29udGFpbmVyPlxuICAgICAgICA8c3BhbiBjbGFzcz1cImstaW5wdXQtcHJlZml4XCI+XG4gICAgICAgICAgICA8bmctdGVtcGxhdGVcbiAgICAgICAgICAgICAgICAqbmdJZj1cInByZWZpeFRlbXBsYXRlXCJcbiAgICAgICAgICAgICAgICBbbmdUZW1wbGF0ZU91dGxldF09XCJwcmVmaXhUZW1wbGF0ZT8udGVtcGxhdGVSZWZcIj5cbiAgICAgICAgICAgIDwvbmctdGVtcGxhdGU+XG4gICAgICAgIDwvc3Bhbj5cbiAgICAgICAgPGlucHV0XG4gICAgICAgICAgICBjbGFzcz1cImstaW5wdXRcIlxuICAgICAgICAgICAgI2lucHV0XG4gICAgICAgICAgICBbZGlzYWJsZWRdPVwiZGlzYWJsZWRcIlxuICAgICAgICAgICAgW3JlYWRvbmx5XT1cInJlYWRvbmx5XCJcbiAgICAgICAgICAgIFthdHRyLnRhYmluZGV4XT1cImRpc2FibGVkID8gdW5kZWZpbmVkIDogdGFiaW5kZXhcIlxuICAgICAgICAgICAgW3ZhbHVlXT1cInZhbHVlXCJcbiAgICAgICAgICAgIFthdHRyLnBsYWNlaG9sZGVyXT1cInBsYWNlaG9sZGVyXCJcbiAgICAgICAgICAgIFthdHRyLnRpdGxlXT1cInRpdGxlXCJcbiAgICAgICAgICAgIFtrZW5kb0V2ZW50c091dHNpZGVBbmd1bGFyXT1cIntcbiAgICAgICAgICAgICAgICBmb2N1czogaGFuZGxlSW5wdXRGb2N1cyxcbiAgICAgICAgICAgICAgICBibHVyOiBoYW5kbGVJbnB1dEJsdXIsXG4gICAgICAgICAgICAgICAgaW5wdXQ6IGhhbmRsZUlucHV0fVwiLz5cbiAgICAgICAgPHNwYW4gY2xhc3M9XCJrLWlucHV0LXN1ZmZpeFwiPlxuICAgICAgICAgICAgPHNwYW4gKm5nSWY9XCJoYXNFcnJvcnNcIiBbbmdDbGFzc109XCJlcnJvckljb25DbGFzc2VzXCI+PC9zcGFuPlxuICAgICAgICAgICAgPHNwYW4gKm5nSWY9XCJpc1N1Y2Nlc3NmdWxcIiBbbmdDbGFzc109XCJzdWNjZXNzSWNvbkNsYXNzZXNcIj48L3NwYW4+XG4gICAgICAgICAgICA8c3BhblxuICAgICAgICAgICAgICAgIHJvbGU9XCJidXR0b25cIlxuICAgICAgICAgICAgICAgIGNsYXNzPVwiay1jbGVhci12YWx1ZVwiXG4gICAgICAgICAgICAgICAgKm5nSWY9XCJzaG93Q2xlYXJCdXR0b25cIlxuICAgICAgICAgICAgICAgIChjbGljayk9XCJjbGVhclZhbHVlKClcIlxuICAgICAgICAgICAgICAgIChtb3VzZWRvd24pPVwiJGV2ZW50LnByZXZlbnREZWZhdWx0KClcIlxuICAgICAgICAgICAgICAgIFt0YWJpbmRleF09XCJ0YWJJbmRleFwiXG4gICAgICAgICAgICAgICAgW2F0dHIuYXJpYS1sYWJlbF09XCJjbGVhclRpdGxlKClcIlxuICAgICAgICAgICAgICAgIFt0aXRsZV09XCJjbGVhclRpdGxlKClcIlxuICAgICAgICAgICAgICAgIChrZXlkb3duLmVudGVyKT1cImNsZWFyVmFsdWUoJGV2ZW50KVwiXG4gICAgICAgICAgICAgICAgKGtleWRvd24uc3BhY2UpPVwiY2xlYXJWYWx1ZSgkZXZlbnQpXCJcbiAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgPHNwYW4gW25nQ2xhc3NdPVwiY2xlYXJCdXR0b25DbGFzc2VzXCI+PC9zcGFuPlxuICAgICAgICAgICAgPC9zcGFuPlxuICAgICAgICAgICAgPG5nLXRlbXBsYXRlXG4gICAgICAgICAgICAgICAgKm5nSWY9XCJzdWZmaXhUZW1wbGF0ZVwiXG4gICAgICAgICAgICAgICAgW25nVGVtcGxhdGVPdXRsZXRdPVwic3VmZml4VGVtcGxhdGU/LnRlbXBsYXRlUmVmXCI+XG4gICAgICAgICAgICA8L25nLXRlbXBsYXRlPlxuICAgICAgICA8L3NwYW4+XG4gICAgYFxuICAgICAgICAgICAgfSxdIH0sXG5dO1xuLyoqIEBub2NvbGxhcHNlICovXG5UZXh0Qm94Q29tcG9uZW50LmN0b3JQYXJhbWV0ZXJzID0gKCkgPT4gW1xuICAgIHsgdHlwZTogTG9jYWxpemF0aW9uU2VydmljZSB9LFxuICAgIHsgdHlwZTogTmdab25lIH0sXG4gICAgeyB0eXBlOiBDaGFuZ2VEZXRlY3RvclJlZiB9LFxuICAgIHsgdHlwZTogUmVuZGVyZXIyIH0sXG4gICAgeyB0eXBlOiBJbmplY3RvciB9LFxuICAgIHsgdHlwZTogRWxlbWVudFJlZiB9XG5dO1xuVGV4dEJveENvbXBvbmVudC5wcm9wRGVjb3JhdG9ycyA9IHtcbiAgICB0aXRsZTogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgZGlzYWJsZWQ6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHJlYWRvbmx5OiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICB0YWJpbmRleDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgdmFsdWU6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHNlbGVjdE9uRm9jdXM6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHNob3dTdWNjZXNzSWNvbjogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgc2hvd0Vycm9ySWNvbjogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgY2xlYXJCdXR0b246IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHN1Y2Nlc3NJY29uOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBlcnJvckljb246IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIGNsZWFyQnV0dG9uSWNvbjogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgdGFiSW5kZXg6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHBsYWNlaG9sZGVyOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICB2YWx1ZUNoYW5nZTogW3sgdHlwZTogT3V0cHV0IH1dLFxuICAgIGlucHV0Rm9jdXM6IFt7IHR5cGU6IE91dHB1dCB9XSxcbiAgICBpbnB1dEJsdXI6IFt7IHR5cGU6IE91dHB1dCB9XSxcbiAgICBvbkZvY3VzOiBbeyB0eXBlOiBPdXRwdXQsIGFyZ3M6IFsnZm9jdXMnLF0gfV0sXG4gICAgb25CbHVyOiBbeyB0eXBlOiBPdXRwdXQsIGFyZ3M6IFsnYmx1cicsXSB9XSxcbiAgICBpbnB1dDogW3sgdHlwZTogVmlld0NoaWxkLCBhcmdzOiBbJ2lucHV0JywgeyBzdGF0aWM6IHRydWUgfSxdIH1dLFxuICAgIHN1ZmZpeFRlbXBsYXRlOiBbeyB0eXBlOiBDb250ZW50Q2hpbGQsIGFyZ3M6IFtUZXh0Qm94U3VmZml4VGVtcGxhdGVEaXJlY3RpdmUsXSB9XSxcbiAgICBwcmVmaXhUZW1wbGF0ZTogW3sgdHlwZTogQ29udGVudENoaWxkLCBhcmdzOiBbVGV4dEJveFByZWZpeFRlbXBsYXRlRGlyZWN0aXZlLF0gfV0sXG4gICAgZGlzYWJsZWRDbGFzczogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnY2xhc3Muay1zdGF0ZS1kaXNhYmxlZCcsXSB9XSxcbiAgICBob3N0Q2xhc3M6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstdGV4dGJveCcsXSB9XSxcbiAgICBpc0ZvY3VzZWQ6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstc3RhdGUtZm9jdXNlZCcsXSB9XSxcbiAgICBkaXJlY3Rpb246IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2F0dHIuZGlyJyxdIH1dXG59O1xuXG4vKipcbiAqIFNwZWNpZmllcyBhIHNlcGFyYXRvciBpbiB0aGUgY29udGVudCBvZiB0aGUgVGV4dEJveCAoW3NlZSBleGFtcGxlc10oeyUgc2x1ZyBhZG9ybm1lbnRzX3RleHRib3ggJX0jdG9jLXNlcGFyYXRvcikpLlxuICogQGV4YW1wbGVcbiAqIGBgYHRzLW5vLXJ1blxuICogX0BDb21wb25lbnQoe1xuICogc2VsZWN0b3I6ICdteS1hcHAnLFxuICogdGVtcGxhdGU6IGBcbiAqICA8a2VuZG8tdGV4dGJveD5cbiAqICAgIDxuZy10ZW1wbGF0ZSBrZW5kb1RleHRCb3hTdWZmaXhUZW1wbGF0ZT5cbiAqICAgICAgICA8YnV0dG9uIGtlbmRvQnV0dG9uIGxvb2s9XCJjbGVhclwiIGljb249XCJpbWFnZVwiPjwvYnV0dG9uPlxuICogICAgICAgIDxrZW5kby10ZXh0Ym94LXNlcGFyYXRvcj48L2tlbmRvLXRleHRib3gtc2VwYXJhdG9yPlxuICogICAgPC9uZy10ZW1wbGF0ZT5cbiAqICA8L2tlbmRvLXRleHRib3g+XG4gKiBgXG4gKiB9KVxuICogY2xhc3MgQXBwQ29tcG9uZW50IHt9XG4gKiBgYGBcbiAqL1xuY2xhc3MgVGV4dEJveFNlcGFyYXRvckNvbXBvbmVudCB7XG4gICAgY29uc3RydWN0b3IoKSB7XG4gICAgICAgIHRoaXMuaG9zdENsYXNzID0gdHJ1ZTtcbiAgICB9XG59XG5UZXh0Qm94U2VwYXJhdG9yQ29tcG9uZW50LmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBDb21wb25lbnQsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgc2VsZWN0b3I6ICdrZW5kby10ZXh0Ym94LXNlcGFyYXRvcicsXG4gICAgICAgICAgICAgICAgdGVtcGxhdGU6IGBgXG4gICAgICAgICAgICB9LF0gfSxcbl07XG5UZXh0Qm94U2VwYXJhdG9yQ29tcG9uZW50LnByb3BEZWNvcmF0b3JzID0ge1xuICAgIGhvc3RDbGFzczogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnY2xhc3Muay10ZXh0Ym94LXNlcGFyYXRvcicsXSB9XVxufTtcblxuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNsYXNzIFRleHRCb3hNZXNzYWdlcyBleHRlbmRzIENvbXBvbmVudE1lc3NhZ2VzIHtcbn1cblRleHRCb3hNZXNzYWdlcy5wcm9wRGVjb3JhdG9ycyA9IHtcbiAgICBjbGVhcjogW3sgdHlwZTogSW5wdXQgfV1cbn07XG5cbi8qKlxuICogQ3VzdG9tIGNvbXBvbmVudCBtZXNzYWdlcyBvdmVycmlkZSBkZWZhdWx0IGNvbXBvbmVudCBtZXNzYWdlcy5cbiAqL1xuY2xhc3MgVGV4dEJveEN1c3RvbU1lc3NhZ2VzQ29tcG9uZW50IGV4dGVuZHMgVGV4dEJveE1lc3NhZ2VzIHtcbiAgICBjb25zdHJ1Y3RvcihzZXJ2aWNlKSB7XG4gICAgICAgIHN1cGVyKCk7XG4gICAgICAgIHRoaXMuc2VydmljZSA9IHNlcnZpY2U7XG4gICAgfVxuICAgIGdldCBvdmVycmlkZSgpIHtcbiAgICAgICAgcmV0dXJuIHRydWU7XG4gICAgfVxufVxuVGV4dEJveEN1c3RvbU1lc3NhZ2VzQ29tcG9uZW50LmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBDb21wb25lbnQsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgcHJvdmlkZXJzOiBbXG4gICAgICAgICAgICAgICAgICAgIHtcbiAgICAgICAgICAgICAgICAgICAgICAgIHByb3ZpZGU6IFRleHRCb3hNZXNzYWdlcyxcbiAgICAgICAgICAgICAgICAgICAgICAgIHVzZUV4aXN0aW5nOiBmb3J3YXJkUmVmKCgpID0+IFRleHRCb3hDdXN0b21NZXNzYWdlc0NvbXBvbmVudCkgLy8gdHNsaW50OmRpc2FibGUtbGluZTpuby1mb3J3YXJkLXJlZlxuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgXSxcbiAgICAgICAgICAgICAgICBzZWxlY3RvcjogJ2tlbmRvLXRleHRib3gtbWVzc2FnZXMnLFxuICAgICAgICAgICAgICAgIHRlbXBsYXRlOiBgYFxuICAgICAgICAgICAgfSxdIH0sXG5dO1xuLyoqIEBub2NvbGxhcHNlICovXG5UZXh0Qm94Q3VzdG9tTWVzc2FnZXNDb21wb25lbnQuY3RvclBhcmFtZXRlcnMgPSAoKSA9PiBbXG4gICAgeyB0eXBlOiBMb2NhbGl6YXRpb25TZXJ2aWNlIH1cbl07XG5cbi8qKlxuICogQGhpZGRlblxuICovXG5jbGFzcyBMb2NhbGl6ZWRUZXh0Qm94TWVzc2FnZXNEaXJlY3RpdmUgZXh0ZW5kcyBUZXh0Qm94TWVzc2FnZXMge1xuICAgIGNvbnN0cnVjdG9yKHNlcnZpY2UpIHtcbiAgICAgICAgc3VwZXIoKTtcbiAgICAgICAgdGhpcy5zZXJ2aWNlID0gc2VydmljZTtcbiAgICB9XG59XG5Mb2NhbGl6ZWRUZXh0Qm94TWVzc2FnZXNEaXJlY3RpdmUuZGVjb3JhdG9ycyA9IFtcbiAgICB7IHR5cGU6IERpcmVjdGl2ZSwgYXJnczogW3tcbiAgICAgICAgICAgICAgICBwcm92aWRlcnM6IFtcbiAgICAgICAgICAgICAgICAgICAge1xuICAgICAgICAgICAgICAgICAgICAgICAgcHJvdmlkZTogVGV4dEJveE1lc3NhZ2VzLFxuICAgICAgICAgICAgICAgICAgICAgICAgdXNlRXhpc3Rpbmc6IGZvcndhcmRSZWYoKCkgPT4gTG9jYWxpemVkVGV4dEJveE1lc3NhZ2VzRGlyZWN0aXZlKSAvLyB0c2xpbnQ6ZGlzYWJsZS1saW5lOm5vLWZvcndhcmQtcmVmXG4gICAgICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICBdLFxuICAgICAgICAgICAgICAgIHNlbGVjdG9yOiAnW2tlbmRvVGV4dEJveExvY2FsaXplZE1lc3NhZ2VzXSdcbiAgICAgICAgICAgIH0sXSB9LFxuXTtcbi8qKiBAbm9jb2xsYXBzZSAqL1xuTG9jYWxpemVkVGV4dEJveE1lc3NhZ2VzRGlyZWN0aXZlLmN0b3JQYXJhbWV0ZXJzID0gKCkgPT4gW1xuICAgIHsgdHlwZTogTG9jYWxpemF0aW9uU2VydmljZSB9XG5dO1xuXG4vKipcbiAqIFJlcHJlc2VudHMgdGhlIFtOZ01vZHVsZV0oe3sgc2l0ZS5kYXRhLnVybHMuYW5ndWxhclsnbmdtb2R1bGVhcGknXSB9fSlcbiAqIGRlZmluaXRpb24gZm9yIHRoZSBUZXh0Qm94IGRpcmVjdGl2ZS5cbiAqXG4gKiBAZXhhbXBsZVxuICpcbiAqIGBgYHRzLW5vLXJ1blxuICogLy8gSW1wb3J0IHRoZSBUZXh0Qm94IG1vZHVsZVxuICogaW1wb3J0IHsgVGV4dEJveE1vZHVsZSB9IGZyb20gJ0Bwcm9ncmVzcy9rZW5kby1hbmd1bGFyLWlucHV0cyc7XG4gKlxuICogLy8gVGhlIGJyb3dzZXIgcGxhdGZvcm0gd2l0aCBhIGNvbXBpbGVyXG4gKiBpbXBvcnQgeyBwbGF0Zm9ybUJyb3dzZXJEeW5hbWljIH0gZnJvbSAnQGFuZ3VsYXIvcGxhdGZvcm0tYnJvd3Nlci1keW5hbWljJztcbiAqXG4gKiBpbXBvcnQgeyBOZ01vZHVsZSB9IGZyb20gJ0Bhbmd1bGFyL2NvcmUnO1xuICpcbiAqIC8vIEltcG9ydCB0aGUgYXBwIGNvbXBvbmVudFxuICogaW1wb3J0IHsgQXBwQ29tcG9uZW50IH0gZnJvbSAnLi9hcHAuY29tcG9uZW50JztcbiAqXG4gKiAvLyBEZWZpbmUgdGhlIGFwcCBtb2R1bGVcbiAqIF9ATmdNb2R1bGUoe1xuICogICAgIGRlY2xhcmF0aW9uczogW0FwcENvbXBvbmVudF0sIC8vIGRlY2xhcmUgYXBwIGNvbXBvbmVudFxuICogICAgIGltcG9ydHM6ICAgICAgW0Jyb3dzZXJNb2R1bGUsIFRleHRCb3hNb2R1bGVdLCAvLyBpbXBvcnQgVGV4dEJveCBtb2R1bGVcbiAqICAgICBib290c3RyYXA6ICAgIFtBcHBDb21wb25lbnRdXG4gKiB9KVxuICogZXhwb3J0IGNsYXNzIEFwcE1vZHVsZSB7fVxuICpcbiAqIC8vIENvbXBpbGUgYW5kIGxhdW5jaCB0aGUgbW9kdWxlXG4gKiBwbGF0Zm9ybUJyb3dzZXJEeW5hbWljKCkuYm9vdHN0cmFwTW9kdWxlKEFwcE1vZHVsZSk7XG4gKlxuICogYGBgXG4gKi9cbmNsYXNzIFRleHRCb3hNb2R1bGUge1xufVxuVGV4dEJveE1vZHVsZS5kZWNvcmF0b3JzID0gW1xuICAgIHsgdHlwZTogTmdNb2R1bGUsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgZGVjbGFyYXRpb25zOiBbXG4gICAgICAgICAgICAgICAgICAgIFRleHRCb3hEaXJlY3RpdmUsXG4gICAgICAgICAgICAgICAgICAgIFRleHRBcmVhRGlyZWN0aXZlLFxuICAgICAgICAgICAgICAgICAgICBUZXh0Qm94Q29udGFpbmVyQ29tcG9uZW50LFxuICAgICAgICAgICAgICAgICAgICBUZXh0Qm94Q29tcG9uZW50LFxuICAgICAgICAgICAgICAgICAgICBUZXh0Qm94U2VwYXJhdG9yQ29tcG9uZW50LFxuICAgICAgICAgICAgICAgICAgICBUZXh0Qm94U3VmZml4VGVtcGxhdGVEaXJlY3RpdmUsXG4gICAgICAgICAgICAgICAgICAgIFRleHRCb3hQcmVmaXhUZW1wbGF0ZURpcmVjdGl2ZSxcbiAgICAgICAgICAgICAgICAgICAgVGV4dEJveEN1c3RvbU1lc3NhZ2VzQ29tcG9uZW50LFxuICAgICAgICAgICAgICAgICAgICBMb2NhbGl6ZWRUZXh0Qm94TWVzc2FnZXNEaXJlY3RpdmVcbiAgICAgICAgICAgICAgICBdLFxuICAgICAgICAgICAgICAgIGV4cG9ydHM6IFtcbiAgICAgICAgICAgICAgICAgICAgVGV4dEJveERpcmVjdGl2ZSxcbiAgICAgICAgICAgICAgICAgICAgVGV4dEFyZWFEaXJlY3RpdmUsXG4gICAgICAgICAgICAgICAgICAgIFRleHRCb3hDb250YWluZXJDb21wb25lbnQsXG4gICAgICAgICAgICAgICAgICAgIFRleHRCb3hDb21wb25lbnQsXG4gICAgICAgICAgICAgICAgICAgIFRleHRCb3hTZXBhcmF0b3JDb21wb25lbnQsXG4gICAgICAgICAgICAgICAgICAgIFRleHRCb3hTdWZmaXhUZW1wbGF0ZURpcmVjdGl2ZSxcbiAgICAgICAgICAgICAgICAgICAgVGV4dEJveFByZWZpeFRlbXBsYXRlRGlyZWN0aXZlLFxuICAgICAgICAgICAgICAgICAgICBFdmVudHNNb2R1bGUsXG4gICAgICAgICAgICAgICAgICAgIFRleHRCb3hDdXN0b21NZXNzYWdlc0NvbXBvbmVudCxcbiAgICAgICAgICAgICAgICAgICAgTG9jYWxpemVkVGV4dEJveE1lc3NhZ2VzRGlyZWN0aXZlXG4gICAgICAgICAgICAgICAgXSxcbiAgICAgICAgICAgICAgICBpbXBvcnRzOiBbQ29tbW9uTW9kdWxlLCBFdmVudHNNb2R1bGVdXG4gICAgICAgICAgICB9LF0gfSxcbl07XG5cbi8qKlxuICogQGhpZGRlblxuICovXG5jbGFzcyBQcmV2ZW50YWJsZUV2ZW50IHtcbiAgICBjb25zdHJ1Y3RvcigpIHtcbiAgICAgICAgdGhpcy5wcmV2ZW50ZWQgPSBmYWxzZTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogUHJldmVudHMgdGhlIGRlZmF1bHQgYWN0aW9uIGZvciBhIHNwZWNpZmllZCBldmVudC5cbiAgICAgKiBJbiB0aGlzIHdheSwgdGhlIHNvdXJjZSBjb21wb25lbnQgc3VwcHJlc3NlcyB0aGUgYnVpbHQtaW4gYmVoYXZpb3IgdGhhdCBmb2xsb3dzIHRoZSBldmVudC5cbiAgICAgKi9cbiAgICBwcmV2ZW50RGVmYXVsdCgpIHtcbiAgICAgICAgdGhpcy5wcmV2ZW50ZWQgPSB0cnVlO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBJZiB0aGUgZXZlbnQgaXMgcHJldmVudGVkIGJ5IGFueSBvZiBpdHMgc3Vic2NyaWJlcnMsIHJldHVybnMgYHRydWVgLlxuICAgICAqXG4gICAgICogQHJldHVybnMgLSBgdHJ1ZWAgaWYgdGhlIGRlZmF1bHQgYWN0aW9uIHdhcyBwcmV2ZW50ZWQuIE90aGVyd2lzZSwgcmV0dXJucyBgZmFsc2VgLlxuICAgICAqL1xuICAgIGlzRGVmYXVsdFByZXZlbnRlZCgpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMucHJldmVudGVkO1xuICAgIH1cbn1cblxuLyoqXG4gKiBGaXJlcyBlYWNoIHRpbWUgdGhlIGxlZnQgc2lkZSBvZiB0aGUgQ29sb3JQaWNrZXIgd3JhcHBlciBpcyBjbGlja2VkLlxuICogVGhlIGV2ZW50IGlzIHRyaWdnZXJlZCByZWdhcmRsZXNzIG9mIHdoZXRoZXIgYSBDb2xvclBpY2tlciBpY29uIGlzIHNldCBvciBub3QuXG4gKlxuICogUHJvdmlkZXMgaW5mb3JtYXRpb24gYWJvdXQgdGhlIGN1cnJlbnQgYWN0aXZlIGNvbG9yIGFuZCBnaXZlcyB0aGUgb3B0aW9uIHRvIHByZXZlbnQgdGhlIG9wZW5pbmcgb2YgdGhlIHBvcHVwLlxuICpcbiAqIEBleGFtcGxlXG4gKlxuICogYGBgdHMtbm8tcnVuXG4gKiBfQENvbXBvbmVudCh7XG4gKiAgIHNlbGVjdG9yOiAnbXktYXBwJyxcbiAqICAgdGVtcGxhdGU6IGBcbiAqICAgICAgIDxrZW5kby1jb2xvcnBpY2tlclxuICogICAgICAgICAgIFtpY29uXT1cIidlZGl0LXRvb2xzJ1wiXG4gKiAgICAgICAgICAgW3ZhbHVlXT1cIicjOTAwJ1wiXG4gKiAgICAgICAgICAgKGFjdGl2ZUNvbG9yQ2xpY2spPVwiaGFuZGxlQWN0aXZlQ29sb3JDbGljaygkZXZlbnQpXCJcbiAqICAgICAgID5cbiAqICAgICAgIDwva2VuZG8tY29sb3JwaWNrZXI+XG4gKiAgIGBcbiAqIH0pXG4gKiBjbGFzcyBBcHBDb21wb25lbnQge1xuICogICAgIHB1YmxpYyBoYW5kbGVBY3RpdmVDb2xvckNsaWNrKGV2ZW50OiBBY3RpdmVDb2xvckNsaWNrRXZlbnQpOiB2b2lkIHtcbiAqICAgICAgICAgZXZlbnQucHJldmVudE9wZW4oKTtcbiAqXG4gKiAgICAgICAgIGNvbnNvbGUubG9nKCdPcGVuIHByZXZlbnRlZDonLCBldmVudC5pc09wZW5QcmV2ZW50ZWQoKSk7XG4gKiAgICAgICAgIGNvbnNvbGUubG9nKCdDdXJyZW50IGNvbG9yOicsIGV2ZW50LmNvbG9yKTtcbiAqICAgICB9XG4gKiAgfVxuICogYGBgXG4gKi9cbmNsYXNzIEFjdGl2ZUNvbG9yQ2xpY2tFdmVudCB7XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqIEBwYXJhbSBjb2xvciBSZXByZXNlbnRzIHRoZSBjdXJyZW50IHZhbHVlIG9mIHRoZSBDb2xvclBpY2tlci5cbiAgICAgKi9cbiAgICBjb25zdHJ1Y3Rvcihjb2xvcikge1xuICAgICAgICB0aGlzLmNvbG9yID0gY29sb3I7XG4gICAgICAgIHRoaXMub3BlblByZXZlbnRlZCA9IGZhbHNlO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBQcmV2ZW50cyB0aGUgb3BlbmluZyBvZiB0aGUgcG9wdXAuXG4gICAgICovXG4gICAgcHJldmVudE9wZW4oKSB7XG4gICAgICAgIHRoaXMub3BlblByZXZlbnRlZCA9IHRydWU7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIFJldHVybnMgYHRydWVgIGlmIHRoZSBwb3B1cCBvcGVuaW5nIGlzIHByZXZlbnRlZCBieSBhbnkgb2YgaXRzIHN1YnNjcmliZXJzLlxuICAgICAqXG4gICAgICogQHJldHVybnMgLSBSZXR1cm5zIGB0cnVlYCBpZiB0aGUgb3BlbiBhY3Rpb24gd2FzIHByZXZlbnRlZC4gT3RoZXJ3aXNlLCByZXR1cm5zIGBmYWxzZWAuXG4gICAgICovXG4gICAgaXNPcGVuUHJldmVudGVkKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5vcGVuUHJldmVudGVkO1xuICAgIH1cbn1cblxuLyoqXG4gKiBAaGlkZGVuXG4gKlxuICogUmV0dXJucyB0aGUgaGV4IG9yIHJnYmEgc3RyaW5nIHJlcHJlc2VudGF0aW9uIG9mIHRoZSBjb2xvci5cbiAqL1xuY29uc3QgcGFyc2VDb2xvciQxID0gKHZhbHVlLCBmb3JtYXQsIHNhZmUgPSB0cnVlKSA9PiB7XG4gICAgY29uc3QgYWxsb3dlZEZvcm1hdHMgPSBbJ2hleCcsICdyZ2JhJywgJ25hbWUnXTtcbiAgICBpZiAoYWxsb3dlZEZvcm1hdHMuaW5kZXhPZihmb3JtYXQpID09PSAtMSkge1xuICAgICAgICB0aHJvdyBuZXcgRXJyb3IoYFVuc3VwcG9ydGVkIGNvbG9yIG91dHB1dCBmb3JtYXQgJyR7Zm9ybWF0fScuIFRoZSBhdmFpbGFibGUgb3B0aW9ucyBhcmUgJ2hleCcsICdyZ2JhJyBvciAnbmFtZScuYCk7XG4gICAgfVxuICAgIGlmICghaXNQcmVzZW50KHZhbHVlKSkge1xuICAgICAgICByZXR1cm47XG4gICAgfVxuICAgIGlmIChmb3JtYXQgPT09ICduYW1lJykge1xuICAgICAgICByZXR1cm4gbmFtZUZvcm1hdCh2YWx1ZSwgc2FmZSk7XG4gICAgfVxuICAgIGNvbnN0IHBhcnNlZENvbG9yID0gcGFyc2VDb2xvcih2YWx1ZS50cmltKCksIHNhZmUpO1xuICAgIGlmICghaXNQcmVzZW50KHBhcnNlZENvbG9yKSkge1xuICAgICAgICByZXR1cm47XG4gICAgfVxuICAgIHJldHVybiBmb3JtYXQgPT09ICdoZXgnID8gcGFyc2VkQ29sb3IudG9Dc3MoKSA6IHBhcnNlZENvbG9yLnRvQ3NzUmdiYSgpO1xufTtcbi8qKlxuICogQGhpZGRlblxuICpcbiAqIFJldHVybnMgYW4gSFNWIG9iamVjdCByZXByZXNlbnRhdGlvbiBvZiB0aGUgY29sb3Igc3RyaW5nLlxuICovXG5jb25zdCBnZXRIU1YgPSAodmFsdWUsIHNhZmUgPSB0cnVlKSA9PiB7XG4gICAgY29uc3QgcGFyc2VkID0gcGFyc2VDb2xvcih2YWx1ZSwgc2FmZSk7XG4gICAgaWYgKCFpc1ByZXNlbnQocGFyc2VkKSkge1xuICAgICAgICByZXR1cm4ge307XG4gICAgfVxuICAgIHJldHVybiBwYXJzZWQudG9IU1YoKTtcbn07XG4vKipcbiAqIEBoaWRkZW5cbiAqXG4gKiBSZXR1cm5zIGFuIFJHQkEgb2JqZWN0IHJlcHJlc2VudGF0aW9uIG9mIHRoZSBjb2xvciBzdHJpbmcuXG4gKi9cbmNvbnN0IGdldFJHQkEgPSAodmFsdWUsIHNhZmUgPSB0cnVlKSA9PiB7XG4gICAgY29uc3QgcGFyc2VkID0gcGFyc2VDb2xvcih2YWx1ZSwgc2FmZSk7XG4gICAgaWYgKCFpc1ByZXNlbnQocGFyc2VkKSkge1xuICAgICAgICByZXR1cm4ge307XG4gICAgfVxuICAgIHJldHVybiBwYXJzZWQudG9CeXRlcygpO1xufTtcbi8qKlxuICogQGhpZGRlblxuICpcbiAqIFJldHVybnMgdGhlIFJHQkEgc3RyaW5nIHJlcHJlc2VudGF0aW9uIG9mIHRoZSBjb2xvci5cbiAqL1xuY29uc3QgZ2V0Q29sb3JGcm9tSFNWID0gKGhzdmEpID0+IHtcbiAgICBjb25zdCBodWUgPSBmaXRJbnRvQm91bmRzKGhzdmEuaCwgMCwgMzU5LjkpO1xuICAgIGNvbnN0IHNhdHVyYXRpb24gPSBmaXRJbnRvQm91bmRzKGhzdmEucywgMCwgMSk7XG4gICAgY29uc3QgdmFsdWUgPSBmaXRJbnRvQm91bmRzKGhzdmEudiwgMCwgMSk7XG4gICAgY29uc3QgYWxwaGEgPSBmaXRJbnRvQm91bmRzKGhzdmEuYSwgMCwgMSk7XG4gICAgcmV0dXJuIENvbG9yLmZyb21IU1YoaHVlLCBzYXR1cmF0aW9uLCB2YWx1ZSwgYWxwaGEpLnRvQ3NzUmdiYSgpO1xufTtcbi8qKlxuICogQGhpZGRlblxuICpcbiAqIFJldHVybnMgdGhlIFJHQkEgc3RyaW5nIHJlcHJlc2VudGF0aW9uIG9mIHRoZSBjb2xvciBiYXNlZCBvbiB0aGUgYGh1ZWAsIGFzc3VtaW5nIHRoZSBgdmFsdWVgLCBgc2F0dXJhdGlvbmAgYW5kIGBhbHBoYWAgaGF2ZSB2YWx1ZSBvZiBgMWAuXG4gKi9cbmNvbnN0IGdldENvbG9yRnJvbUh1ZSA9IChodWUpID0+IHtcbiAgICByZXR1cm4gZ2V0Q29sb3JGcm9tSFNWKHsgaDogaHVlLCBzOiAxLCB2OiAxLCBhOiAxIH0pO1xufTtcbi8qKlxuICogQGhpZGRlblxuICpcbiAqIFJldHVybnMgdGhlIFJHQkEgc3RyaW5nIHJlcHJlc2VudGF0aW9uIG9mIHRoZSBjb2xvci5cbiAqL1xuY29uc3QgZ2V0Q29sb3JGcm9tUkdCQSA9IChyZ2JhKSA9PiB7XG4gICAgY29uc3QgcmVkID0gZml0SW50b0JvdW5kcyhyZ2JhLnIsIDAsIDI1NSk7XG4gICAgY29uc3QgZ3JlZW4gPSBmaXRJbnRvQm91bmRzKHJnYmEuZywgMCwgMjU1KTtcbiAgICBjb25zdCBibHVlID0gZml0SW50b0JvdW5kcyhyZ2JhLmIsIDAsIDI1NSk7XG4gICAgY29uc3QgYWxwaGEgPSBmaXRJbnRvQm91bmRzKHJnYmEuYSwgMCwgMSk7XG4gICAgcmV0dXJuIENvbG9yLmZyb21CeXRlcyhyZWQsIGdyZWVuLCBibHVlLCBhbHBoYSkudG9Dc3NSZ2JhKCk7XG59O1xuLyoqXG4gKlxuICogQGhpZGRlblxuICovXG5mdW5jdGlvbiBuYW1lRm9ybWF0KHZhbHVlLCBzYWZlKSB7XG4gICAgdmFsdWUgPSB2YWx1ZS50b0xvd2VyQ2FzZSgpLnRyaW0oKTtcbiAgICBpZiAoaXNQcmVzZW50KG5hbWVkQ29sb3JzW3ZhbHVlXSkpIHtcbiAgICAgICAgcmV0dXJuIHZhbHVlO1xuICAgIH1cbiAgICBpZiAocGFyc2VDb2xvcih2YWx1ZSwgc2FmZSkpIHtcbiAgICAgICAgdmFsdWUgPSBwYXJzZUNvbG9yKHZhbHVlLCBzYWZlKS50b0hleCgpO1xuICAgIH1cbiAgICBjb25zdCBrZXkgPSBPYmplY3Qua2V5cyhuYW1lZENvbG9ycykuZmluZChrZXkgPT4gbmFtZWRDb2xvcnNba2V5XSA9PT0gdmFsdWUpO1xuICAgIGlmICgha2V5ICYmICFzYWZlKSB7XG4gICAgICAgIHRocm93IG5ldyBFcnJvcihgVGhlIHByb3ZpZGVkIGNvbG9yICR7dmFsdWV9IGlzIG5vdCBzdXBwb3J0ZWQgZm9yICdmb3JtYXQ9XCJuYW1lXCInIHByb3BlcnR5LlRvIGRpc3BsYXkgJHt2YWx1ZX0gY29sb3IsIHRoZSBjb21wb25lbnQgJ2Zvcm1hdCcgcHJvcGVydHkgc2hvdWQgYmUgc2V0IHRvICdoZXgnIG9yICdyZ2JhJyBgKTtcbiAgICB9XG4gICAgcmV0dXJuIGtleTtcbn1cblxuLy8gdHNsaW50OmRpc2FibGU6bWF4LWxpbmUtbGVuZ3RoXG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY29uc3QgUEFMRVRURVBSRVNFVFMgPSB7XG4gICAgYmFzaWM6IHtcbiAgICAgICAgY29sb3JzOiAnMDAwMDAwLDdmN2Y3Ziw4ODAwMTUsZWQxYzI0LGZmN2YyNyxmZmYyMDAsMjJiMTRjLDAwYTJlOCwzZjQ4Y2MsYTM0OWE0LGZmZmZmZixjM2MzYzMsYjk3YTU3LGZmYWVjOSxmZmM5MGUsZWZlNGIwLGI1ZTYxZCw5OWQ5ZWEsNzA5MmJlLGM4YmZlNycsXG4gICAgICAgIGNvbHVtbnM6IDEwXG4gICAgfSxcbiAgICBvZmZpY2U6IHtcbiAgICAgICAgY29sb3JzOiAnZmZmZmZmLCAwMDAwMDAsIGU2ZTZlNiwgNDM1NTY5LCA0MzcxYzQsIGVkN2UzMiwgYTVhNGE1LCBmZWJmMDQsIDVhOWJkNSwgNzFhZTQ4LCBmMmYyZjMsIDdmN2Y3ZiwgZDFjZWNlLCBkNWRkZTMsIGRhZTFmNCwgZmNlNWQ0LCBkZWVkZWQsIGZmZjJjYywgZGVlYWY2LCBlMWVmZDksIGQ3ZDhkOCwgNTg1OTU5LCBhZWFiYWIsIGFkYmFjYSwgYjRjNWU3LCBmNmNhYWMsIGRiZGJkYiwgZmZlNDk4LCBiY2Q2ZWUsIGM1ZTBiMiwgYmZiZmMwLCAzZjNmM2YsIDc2NzA3MCwgODU5NWIxLCA4ZmFiZGIsIGY1YjE4MywgYzljOGM5LCBmZWQ5NjUsIDliYzRlNSwgYThkMDhkLCBhNWE1YTYsIDI2MjYyNSwgMzkzOTM5LCAzMzQwNTAsIDJlNTQ5NiwgYzQ1YTExLCA3YjdiN2EsIGJmOTAwMCwgMmY3NWI1LCA1NDgyMzUsIDdmN2Y3ZiwgMGIwYzBjLCAxNjE2MTYsIDIyMmEzNCwgMjAzNzY0LCA4NDNkMGIsIDUyNTI1MiwgN2Y2MDAwLCAxZDRkNzksIDM3NTYyMycsXG4gICAgICAgIGNvbHVtbnM6IDEwXG4gICAgfSxcbiAgICBhcGV4OiB7XG4gICAgICAgIGNvbG9yczogJ2ZmZmZmZiwgMDAwMDAwLCBjOWMyZDEsIDY5Njc2ZCwgY2ViOTY2LCA5Y2IwODQsIDZiYjFjOSwgNjU4NWNmLCA3ZTZiYzksIGEzNzliYiwgZjJmMmYyLCA3ZjdmN2YsIGY0ZjJmNSwgZTBlMGUyLCBmNWYxZTAsIGViZWZlNiwgZTFlZmY0LCBlMGU2ZjUsIGU1ZTFmNCwgZWNlNGYxLCBkOGQ4ZDgsIDU5NTk1OSwgZTllNmVjLCBjMmMxYzUsIGViZTNjMSwgZDdkZmNkLCBjM2RmZTksIGMxY2VlYiwgY2JjM2U5LCBkYWM5ZTMsIGJmYmZiZiwgM2YzZjNmLCBkZWRhZTMsIGE0YTNhOCwgZTFkNWEzLCBjM2NmYjUsIGE2ZDBkZSwgYTJiNWUyLCBiMWE2ZGUsIGM3YWVkNiwgYTVhNWE1LCAyNjI2MjYsIDk2ODhhNSwgNGU0ZDUxLCBhZTk2MzgsIDc1OGM1YSwgM2Q4ZGE5LCAzNjViYjAsIDUzM2RhOSwgN2Q0ZDk5LCA3ZjdmN2YsIDBjMGMwYywgNjM1NjcyLCAzNDMzMzYsIDc0NjQyNSwgNGU1ZDNjLCAyOTVlNzAsIDI0M2M3NSwgMzcyOTcwLCA1MzMzNjYnLFxuICAgICAgICBjb2x1bW5zOiAxMFxuICAgIH0sXG4gICAgYXVzdGluOiB7XG4gICAgICAgIGNvbG9yczogJ2ZmZmZmZiwgMDAwMDAwLCBjYWYyNzgsIDNlM2QyZCwgOTRjNjAwLCA3MTY4NWEsIGZmNjcwMCwgOTA5NDY1LCA5NTZiNDMsIGZlYTAyMiwgZjJmMmYyLCA3ZjdmN2YsIGY0ZmNlNCwgZGRkY2QwLCBlZmZmYzAsIGUzZTFkYywgZmZlMGNiLCBlOGU5ZGYsIGVjZTFkNiwgZmVlY2QyLCBkOGQ4ZDgsIDU5NTk1OSwgZTlmOWM5LCBiYmI5YTEsIGRmZmY4MiwgYzhjM2JhLCBmZmMyOTksIGQyZDRjMCwgZGFjM2FkLCBmZWQ5YTYsIGJmYmZiZiwgM2YzZjNmLCBkZmY3YWUsIGFkYTU5OCwgY2ZmZjQzLCBhZGE1OTgsIGZmYTM2NSwgYmNiZmExLCBjOGE1ODUsIGZlYzY3YSwgYTVhNWE1LCAyNjI2MjYsIGE5ZWEyNSwgMmUyZDIxLCA2Zjk0MDAsIDU0NGU0MywgYmY0ZDAwLCA2YzZmNGIsIDZmNTAzMiwgZDc3YjAwLCA3ZjdmN2YsIDBjMGMwYywgNzRhNTBmLCAxZjFlMTYsIDRhNjMwMCwgMzgzNDJkLCA3ZjMzMDAsIDQ4NGEzMiwgNGEzNTIxLCA4ZjUyMDAnLFxuICAgICAgICBjb2x1bW5zOiAxMFxuICAgIH0sXG4gICAgY2xhcml0eToge1xuICAgICAgICBjb2xvcnM6ICdmZmZmZmYsIDI5MjkzNCwgZjNmMmRjLCBkMjUzM2MsIDkzYTI5OSwgYWQ4ZjY3LCA3MjYwNTYsIDRjNWE2YSwgODA4ZGEwLCA3OTQ2M2QsIGYyZjJmMiwgZTdlN2VjLCBlN2U1YjksIGY2ZGNkOCwgZTllY2VhLCBlZWU4ZTAsIGU0ZGVkYiwgZDhkZGUzLCBlNWU4ZWMsIGU5ZDZkMywgZDhkOGQ4LCBjNGM0ZDEsIGQ1ZDE4NSwgZWRiYWIxLCBkM2Q5ZDYsIGRlZDJjMiwgYzliZWI4LCBiMmJjYzgsIGNjZDFkOSwgZDNhZWE3LCBiZmJmYmYsIDhhOGFhMywgYWNhNzNiLCBlNDk3OGEsIGJlYzdjMSwgY2RiYmEzLCBhZjllOTQsIDhjOWJhYywgYjJiYWM2LCBiZDg1N2MsIGE1YTVhNSwgNTY1NjZlLCA1NjUzMWQsIGE0MzkyNSwgNmI3YzcyLCA4NjZiNDgsIDU1NDg0MCwgMzk0MzRmLCA1YzY5N2IsIDVhMzQyZCwgN2Y3ZjdmLCAzYjNiNGIsIDIyMjEwYiwgNmQyNjE5LCA0NzUzNGMsIDU5NDczMCwgMzkzMDJiLCAyNjJkMzUsIDNkNDY1MiwgM2MyMzFlJyxcbiAgICAgICAgY29sdW1uczogMTBcbiAgICB9LFxuICAgIHNsaXBzdHJlYW06IHtcbiAgICAgICAgY29sb3JzOiAnZmZmZmZmLCAwMDAwMDAsIGI0ZGNmYSwgMjEyNzQ1LCA0ZTY3YzgsIDVlY2NmMywgYTdlYTUyLCA1ZGNlYWYsIGZmODAyMSwgZjE0MTI0LCBmMmYyZjIsIDdmN2Y3ZiwgOGJjOWY3LCBjN2NjZTQsIGRiZTBmNCwgZGVmNGZjLCBlZGZhZGMsIGRlZjVlZiwgZmZlNWQyLCBmY2Q5ZDMsIGQ4ZDhkOCwgNTk1OTU5LCA0ZmFjZjMsIDkwOWFjYSwgYjhjMmU5LCBiZWVhZmEsIGRiZjZiOSwgYmVlYmRmLCBmZmNjYTYsIGY5YjNhNywgYmZiZmJmLCAzZjNmM2YsIDBkNzhjOSwgNTk2N2FmLCA5NGEzZGUsIDllZTBmNywgY2FmMjk3LCA5ZGUxY2YsIGZmYjI3OSwgZjY4ZDdiLCBhNWE1YTUsIDI2MjYyNiwgMDYzYzY0LCAxODFkMzMsIDMxNDc5ZiwgMTFiMmViLCA4MWQzMTksIDM0YWM4YiwgZDg1YzAwLCBjMzI2MGMsIDdmN2Y3ZiwgMGMwYzBjLCAwMjE4MjgsIDEwMTMyMiwgMjAyZjZhLCAwYjc2OWMsIDU2OGMxMSwgMjI3MjVjLCA5MDNkMDAsIDgyMTkwOCcsXG4gICAgICAgIGNvbHVtbnM6IDEwXG4gICAgfSxcbiAgICBtZXRybzoge1xuICAgICAgICBjb2xvcnM6ICdmZmZmZmYsIDAwMDAwMCwgZDZlY2ZmLCA0ZTViNmYsIDdmZDEzYiwgZWExNTdhLCBmZWI4MGEsIDAwYWRkYywgNzM4YWM4LCAxYWIzOWYsIGYyZjJmMiwgN2Y3ZjdmLCBhN2Q2ZmYsIGQ5ZGRlNCwgZTVmNWQ3LCBmYWQwZTQsIGZlZjBjZCwgYzVmMmZmLCBlMmU3ZjQsIGM5ZjdmMSwgZDhkOGQ4LCA1OTU5NTksIDYwYjVmZiwgYjNiY2NhLCBjYmVjYjAsIGY2YTFjOSwgZmVlMjljLCA4YmU2ZmYsIGM3ZDBlOSwgOTRlZmUzLCBiZmJmYmYsIDNmM2YzZiwgMDA3ZGVhLCA4ZDliYWYsIGIyZTM4OSwgZjI3MmFmLCBmZWQ0NmIsIDUxZDlmZiwgYWFiOGRlLCA1ZmU3ZDUsIGE1YTVhNSwgMjYyNjI2LCAwMDNlNzUsIDNhNDQ1MywgNWVhMjI2LCBhZjBmNWIsIGM1OGMwMCwgMDA4MWE1LCA0MjVlYTksIDEzODY3NywgN2Y3ZjdmLCAwYzBjMGMsIDAwMTkyZSwgMjcyZDM3LCAzZjZjMTksIDc1MGEzZCwgODM1ZDAwLCAwMDU2NmUsIDJjM2Y3MSwgMGM1OTRmJyxcbiAgICAgICAgY29sdW1uczogMTBcbiAgICB9LFxuICAgIGZsb3c6IHtcbiAgICAgICAgY29sb3JzOiAnZmZmZmZmLCAwMDAwMDAsIGRiZjVmOSwgMDQ2MTdiLCAwZjZmYzYsIDAwOWRkOSwgMGJkMGQ5LCAxMGNmOWIsIDdjY2E2MiwgYTVjMjQ5LCBmMmYyZjIsIDdmN2Y3ZiwgYjJlOWYyLCBiNGVjZmMsIGM3ZTJmYSwgYzRlZWZmLCBjOWZhZmMsIGM5ZmFlZCwgZTRmNGRmLCBlZGYyZGEsIGQ4ZDhkOCwgNTk1OTU5LCA3NmQ5ZTgsIDZhZGFmYSwgOTBjNmY2LCA4OWRlZmYsIDkzZjVmOSwgOTRmNmRiLCBjYWU5YzAsIGRiZTZiNiwgYmZiZmJmLCAzZjNmM2YsIDIxYjJjOCwgMjBjOGY3LCA1OWE5ZjIsIDRmY2VmZiwgNWRmMGY2LCA1ZmYyY2EsIGIwZGZhMCwgYzlkYTkxLCBhNWE1YTUsIDI2MjYyNiwgMTA1OTY0LCAwMjQ4NWMsIDBiNTM5NCwgMDA3NWEyLCAwODljYTIsIDBiOWI3NCwgNTRhODM4LCA3ZTk1MzIsIDdmN2Y3ZiwgMGMwYzBjLCAwNjIzMjgsIDAxMzAzZCwgMDczNzYzLCAwMDRlNmMsIDA1Njg2YywgMDc2NzRkLCAzODcwMjUsIDU0NjMyMScsXG4gICAgICAgIGNvbHVtbnM6IDEwXG4gICAgfSxcbiAgICBoYXJkY292ZXI6IHtcbiAgICAgICAgY29sb3JzOiAnZmZmZmZmLCAwMDAwMDAsIGVjZTljNiwgODk1ZDFkLCA4NzM2MjQsIGQ2ODYyZCwgZDBiZTQwLCA4NzdmNmMsIDk3MjEwOSwgYWViNzk1LCBmMmYyZjIsIDdmN2Y3ZiwgZTFkY2E1LCBmMmUwYzYsIGYwZDBjOSwgZjZlNmQ1LCBmNWYyZDgsIGU3ZTVlMSwgZmJjN2JjLCBlZWYwZTksIGQ4ZDhkOCwgNTk1OTU5LCBkMGM5NzQsIGU2YzI4ZCwgZTJhMjkzLCBlZWNlYWEsIGVjZTViMiwgY2ZjY2MzLCBmNzhmN2EsIGRlZTJkNCwgYmZiZmJmLCAzZjNmM2YsIGEyOWEzNiwgZGFhNDU0LCBkNDczNWUsIGU2YjY4MSwgZTJkODhjLCBiN2IyYTUsIGYzNTgzOCwgY2VkM2JmLCBhNWE1YTUsIDI2MjYyNiwgNTE0ZDFiLCA2NjQ1MTUsIDY1MjgxYSwgYTI2NDFmLCBhMzk0MjgsIDY1NWY1MCwgNzExODA2LCA4Nzk0NjQsIDdmN2Y3ZiwgMGMwYzBjLCAyMDFlMGEsIDQ0MmUwZSwgNDMxYjExLCA2YzQzMTUsIDZkNjIxYSwgNDMzZjM1LCA0YjEwMDQsIDVhNjI0MycsXG4gICAgICAgIGNvbHVtbnM6IDEwXG4gICAgfSxcbiAgICB0cmVrOiB7XG4gICAgICAgIGNvbG9yczogJ2ZmZmZmZiwgMDAwMDAwLCBmYmVlYzksIDRlM2IzMCwgZjBhMjJlLCBhNTY0NGUsIGI1OGI4MCwgYzM5ODZkLCBhMTk1NzQsIGMxNzUyOSwgZjJmMmYyLCA3ZjdmN2YsIGY3ZTA5ZSwgZTFkNmNmLCBmY2VjZDUsIGVkZGZkYSwgZjBlN2U1LCBmM2VhZTEsIGVjZTllMywgZjVlM2QxLCBkOGQ4ZDgsIDU5NTk1OSwgZjNjYzVmLCBjNGFkOWYsIGY5ZDlhYiwgZGNjMGI2LCBlMWQwY2MsIGU3ZDVjNCwgZDlkNGM3LCBlYmM3YTMsIGJmYmZiZiwgM2YzZjNmLCBkMjlmMGYsIGE3ODQ3MCwgZjZjNzgxLCBjYmEwOTIsIGQyYjliMiwgZGJjMWE3LCBjNmJmYWIsIGUxYWM3NiwgYTVhNWE1LCAyNjI2MjYsIDY5NGYwNywgM2EyYzI0LCBjODdkMGUsIDdiNGIzYSwgOTI2MjU1LCBhMTcyNDIsIDdiNzE1MywgOTA1NzFlLCA3ZjdmN2YsIDBjMGMwYywgMmExZjAzLCAyNzFkMTgsIDg1NTMwOSwgNTIzMjI2LCA2MTQxMzgsIDZiNGMyYywgNTI0YjM3LCA2MDNhMTQnLFxuICAgICAgICBjb2x1bW5zOiAxMFxuICAgIH0sXG4gICAgdmVydmU6IHtcbiAgICAgICAgY29sb3JzOiAnZmZmZmZmLCAwMDAwMDAsIGQyZDJkMiwgNjY2NjY2LCBmZjM4OGMsIGU0MDA1OSwgOWMwMDdmLCA2ODAwN2YsIDAwNWJkMywgMDAzNDllLCBmMmYyZjIsIDdmN2Y3ZiwgYmRiZGJkLCBlMGUwZTAsIGZmZDdlOCwgZmZjNmRjLCBmZmI4ZjEsIGYxYjJmZiwgYzNkY2ZmLCBiOGNmZmYsIGQ4ZDhkOCwgNTk1OTU5LCA5ZDlkOWQsIGMxYzFjMSwgZmZhZmQxLCBmZjhlYmEsIGZmNzFlNCwgZTM2NWZmLCA4N2JhZmYsIDcyYTBmZiwgYmZiZmJmLCAzZjNmM2YsIDY5Njk2OSwgYTNhM2EzLCBmZjg3YmEsIGZmNTU5NywgZmYyYWQ3LCBkNTE5ZmYsIDRiOThmZiwgMmI3MWZmLCBhNWE1YTUsIDI2MjYyNiwgMzQzNDM0LCA0YzRjNGMsIGU5MDA2MiwgYWIwMDQyLCA3NTAwNWYsIDRlMDA1ZiwgMDA0NDllLCAwMDI2NzYsIDdmN2Y3ZiwgMGMwYzBjLCAxNTE1MTUsIDMzMzMzMywgOWIwMDQxLCA3MjAwMmMsIDRlMDAzZiwgMzQwMDNmLCAwMDJkNjksIDAwMTk0ZicsXG4gICAgICAgIGNvbHVtbnM6IDEwXG4gICAgfSxcbiAgICBtb25vY2hyb21lOiB7XG4gICAgICAgIGNvbG9yczogJzAwMDAwMCwgMWExYTFhLCAzMzMzMzMsIDRkNGQ0ZCwgNjY2NjY2LCA4MDgwODAsIDk5OTk5OSwgYjNiM2IzLCBjY2NjY2MsIGU2ZTZlNiwgZjJmMmYyLCBmZmZmZmYnLFxuICAgICAgICBjb2x1bW5zOiAxMlxuICAgIH0sXG4gICAgYWNjZXNzaWJsZToge1xuICAgICAgICBjb2xvcnM6ICdibGFjaywgZ3JleSwgZGFya3JlZCwgcmVkLCBkYXJrb3JhbmdlLCBnb2xkLCBncmVlbiwgYmx1ZSwgZGFya2JsdWUsIHB1cnBsZSwgd2hpdGUsIGRhcmtncmV5LCBzYWRkbGVicm93biwgcGluaywgb3JhbmdlLCB5ZWxsb3csIGxpZ2h0Z3JlZW4sIGxpZ2h0c2t5Ymx1ZSwgbGlnaHRibHVlLCBtZWRpdW1wdXJwbGUnLFxuICAgICAgICBjb2x1bW5zOiAxMFxuICAgIH1cbn07XG5cbmNvbnN0IERFRkFVTFRfUFJFU0VUID0gJ29mZmljZSc7XG5jb25zdCBERUZBVUxUX0FDQ0VTU0lCTEVfUFJFU0VUID0gJ2FjY2Vzc2libGUnO1xubGV0IHNlcmlhbCA9IDA7XG4vKipcbiAqIFJlcHJlc2VudHMgdGhlIFtLZW5kbyBVSSBDb2xvclBpY2tlciBjb21wb25lbnQgZm9yIEFuZ3VsYXJdKHslIHNsdWcgb3ZlcnZpZXdfY29sb3JwaWNrZXIgJX0pLlxuICogRGVzaWduZWQgdG8gcmVwbGFjZSB0aGUgYDxpbnB1dCB0eXBlPVwiY29sb3JcIj5gIEhUTUw1IHRhZyB3aGljaCBpcyBub3Qgd2lkZWx5IHN1cHBvcnRlZCBpbiBicm93c2Vycy5cbiAqL1xuY2xhc3MgQ29sb3JQaWNrZXJDb21wb25lbnQge1xuICAgIGNvbnN0cnVjdG9yKHBvcHVwU2VydmljZSwgbG9jYWxpemF0aW9uU2VydmljZSkge1xuICAgICAgICB0aGlzLnBvcHVwU2VydmljZSA9IHBvcHVwU2VydmljZTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuaG9zdENsYXNzZXMgPSB0cnVlO1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5mb2N1c2FibGVJZCA9IGBrLWNvbG9ycGlja2VyLSR7c2VyaWFsKyt9YDtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIFNldHMgd2hhdCB2aWV3IHRoZSBDb2xvclBpY2tlciB3aWxsIHJlbmRlciBpbiB0aGUgcG9wdXAuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLnZpZXcgPSAnZ3JhZGllbnQnO1xuICAgICAgICAvKipcbiAgICAgICAgICogU2V0cyB0aGUgcmVhZC1vbmx5IHN0YXRlIG9mIHRoZSBDb2xvclBpY2tlci5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMucmVhZG9ubHkgPSBmYWxzZTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIFNldHMgdGhlIGRpc2FibGVkIHN0YXRlIG9mIHRoZSBDb2xvclBpY2tlci5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuZGlzYWJsZWQgPSBmYWxzZTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIFNwZWNpZmllcyB0aGUgb3V0cHV0IGZvcm1hdCBvZiB0aGUgQ29sb3JQaWNrZXIuXG4gICAgICAgICAqIFRoZSBpbnB1dCB2YWx1ZSBtYXkgYmUgaW4gYSBkaWZmZXJlbnQgZm9ybWF0LiBIb3dldmVyLCBpdCB3aWxsIGJlIHBhcnNlZCBpbnRvIHRoZSBvdXRwdXQgYGZvcm1hdGBcbiAgICAgICAgICogYWZ0ZXIgdGhlIGNvbXBvbmVudCBwcm9jZXNzZXMgaXQuXG4gICAgICAgICAqXG4gICAgICAgICAqIElmIHRoZSBgZ3JhZGllbnRgIHZpZXcgaXMgdXNlZCB3aXRoIHRoZSBgb3BhY2l0eWAgb3B0aW9uIHNldCB0byB0cnVlLCB0aGlzIHNldHRpbmcgd2lsbCBiZSBpZ25vcmVkIGFuZCBgcmdiYWAgd2lsbCBiZSB1c2VkIGluc3RlYWQuXG4gICAgICAgICAqXG4gICAgICAgICAqIFRoZSBzdXBwb3J0ZWQgdmFsdWVzIGFyZTpcbiAgICAgICAgICogKiBgcmdiYWAgKGRlZmF1bHQpXG4gICAgICAgICAqICogYGhleGBcbiAgICAgICAgICogKiBbYG5hbWVgXShodHRwczovL3d3dy53My5vcmcvd2lraS9DU1MvUHJvcGVydGllcy9jb2xvci9rZXl3b3JkcylcbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuZm9ybWF0ID0gJ3JnYmEnO1xuICAgICAgICAvKipcbiAgICAgICAgICogRmlyZXMgZWFjaCB0aW1lIHRoZSB2YWx1ZSBpcyBjaGFuZ2VkLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy52YWx1ZUNoYW5nZSA9IG5ldyBFdmVudEVtaXR0ZXIoKTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEZpcmVzIGVhY2ggdGltZSB0aGUgcG9wdXAgaXMgYWJvdXQgdG8gb3Blbi5cbiAgICAgICAgICogVGhpcyBldmVudCBpcyBwcmV2ZW50YWJsZS4gSWYgeW91IGNhbmNlbCBpdCwgdGhlIHBvcHVwIHdpbGwgcmVtYWluIGNsb3NlZC5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMub3BlbiA9IG5ldyBFdmVudEVtaXR0ZXIoKTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEZpcmVzIGVhY2ggdGltZSB0aGUgcG9wdXAgaXMgYWJvdXQgdG8gY2xvc2UuXG4gICAgICAgICAqIFRoaXMgZXZlbnQgaXMgcHJldmVudGFibGUuIElmIHlvdSBjYW5jZWwgaXQsIHRoZSBwb3B1cCB3aWxsIHJlbWFpbiBvcGVuLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5jbG9zZSA9IG5ldyBFdmVudEVtaXR0ZXIoKTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEZpcmVzIGVhY2ggdGltZSBDb2xvclBpY2tlciBpcyBmb2N1c2VkLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5vbkZvY3VzID0gbmV3IEV2ZW50RW1pdHRlcigpO1xuICAgICAgICAvKipcbiAgICAgICAgICogRmlyZXMgZWFjaCB0aW1lIHRoZSBDb2xvclBpY2tlciBpcyBibHVycmVkLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5vbkJsdXIgPSBuZXcgRXZlbnRFbWl0dGVyKCk7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBGaXJlcyBlYWNoIHRpbWUgdGhlIGxlZnQgc2lkZSBvZiB0aGUgQ29sb3JQaWNrZXIgd3JhcHBlciBpcyBjbGlja2VkLlxuICAgICAgICAgKiBUaGUgZXZlbnQgaXMgdHJpZ2dlcmVkIHJlZ2FyZGxlc3Mgb2Ygd2hldGhlciBhIENvbG9yUGlja2VyIGljb24gaXMgc2V0IG9yIG5vdC5cbiAgICAgICAgICpcbiAgICAgICAgICogVGhlIFtgQWN0aXZlQ29sb3JDbGlja0V2ZW50YF0oeyUgc2x1ZyBhcGlfaW5wdXRzX2FjdGl2ZWNvbG9yY2xpY2tldmVudCAlfSkgZXZlbnQgcHJvdmlkZXMgdGhlIG9wdGlvbiB0byBwcmV2ZW50IHRoZSBwb3B1cCBvcGVuaW5nLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5hY3RpdmVDb2xvckNsaWNrID0gbmV3IEV2ZW50RW1pdHRlcigpO1xuICAgICAgICB0aGlzLl90YWJpbmRleCA9IDA7XG4gICAgICAgIHRoaXMuX3BvcHVwU2V0dGluZ3MgPSB7IGFuaW1hdGU6IHRydWUgfTtcbiAgICAgICAgdGhpcy5fcGFsZXR0ZVNldHRpbmdzID0ge307XG4gICAgICAgIHRoaXMuX2dyYWRpZW50U2V0dGluZ3MgPSB7IG9wYWNpdHk6IHRydWUsIGNsZWFyQnV0dG9uOiBmYWxzZSB9O1xuICAgICAgICB0aGlzLm5vdGlmeU5nVG91Y2hlZCA9ICgpID0+IHsgfTtcbiAgICAgICAgdGhpcy5ub3RpZnlOZ0NoYW5nZWQgPSAoKSA9PiB7IH07XG4gICAgICAgIHRoaXMuZHluYW1pY1JUTFN1YnNjcmlwdGlvbiA9IGxvY2FsaXphdGlvblNlcnZpY2UuY2hhbmdlcy5zdWJzY3JpYmUoKHsgcnRsIH0pID0+IHtcbiAgICAgICAgICAgIHRoaXMuZGlyZWN0aW9uID0gcnRsID8gJ3J0bCcgOiAnbHRyJztcbiAgICAgICAgfSk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIFNwZWNpZmllcyB0aGUgdmFsdWUgb2YgdGhlIGluaXRpYWxseSBzZWxlY3RlZCBjb2xvci5cbiAgICAgKi9cbiAgICBzZXQgdmFsdWUodmFsdWUpIHtcbiAgICAgICAgdGhpcy5fdmFsdWUgPSBwYXJzZUNvbG9yJDEodmFsdWUsIHRoaXMuZm9ybWF0KTtcbiAgICB9XG4gICAgZ2V0IHZhbHVlKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5fdmFsdWU7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIENvbmZpZ3VyZXMgdGhlIHBvcHVwIG9mIHRoZSBDb2xvclBpY2tlci5cbiAgICAgKi9cbiAgICBzZXQgcG9wdXBTZXR0aW5ncyh2YWx1ZSkge1xuICAgICAgICB0aGlzLl9wb3B1cFNldHRpbmdzID0gT2JqZWN0LmFzc2lnbih0aGlzLl9wb3B1cFNldHRpbmdzLCB2YWx1ZSk7XG4gICAgfVxuICAgIGdldCBwb3B1cFNldHRpbmdzKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5fcG9wdXBTZXR0aW5ncztcbiAgICB9XG4gICAgLyoqXG4gICAgICogQ29uZmlndXJlcyB0aGUgcGFsZXR0ZSB0aGF0IGlzIGRpc3BsYXllZCBpbiB0aGUgQ29sb3JQaWNrZXIgcG9wdXAuXG4gICAgICovXG4gICAgc2V0IHBhbGV0dGVTZXR0aW5ncyh2YWx1ZSkge1xuICAgICAgICB0aGlzLl9wYWxldHRlU2V0dGluZ3MgPSBPYmplY3QuYXNzaWduKHRoaXMuX3BhbGV0dGVTZXR0aW5ncywgdmFsdWUpO1xuICAgIH1cbiAgICBnZXQgcGFsZXR0ZVNldHRpbmdzKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5fcGFsZXR0ZVNldHRpbmdzO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBDb25maWd1cmVzIHRoZSBncmFkaWVudCB0aGF0IGlzIGRpc3BsYXllZCBpbiB0aGUgQ29sb3JQaWNrZXIgcG9wdXAuXG4gICAgICovXG4gICAgc2V0IGdyYWRpZW50U2V0dGluZ3ModmFsdWUpIHtcbiAgICAgICAgdGhpcy5fZ3JhZGllbnRTZXR0aW5ncyA9IE9iamVjdC5hc3NpZ24odGhpcy5fZ3JhZGllbnRTZXR0aW5ncywgdmFsdWUpO1xuICAgIH1cbiAgICBnZXQgZ3JhZGllbnRTZXR0aW5ncygpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuX2dyYWRpZW50U2V0dGluZ3M7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIFNwZWNpZmllcyB0aGUgW2B0YWJpbmRleGBdKGh0dHBzOi8vZGV2ZWxvcGVyLm1vemlsbGEub3JnL2VuLVVTL2RvY3MvV2ViL0hUTUwvR2xvYmFsX2F0dHJpYnV0ZXMvdGFiaW5kZXgpIG9mIHRoZSBjb21wb25lbnQuXG4gICAgICovXG4gICAgc2V0IHRhYmluZGV4KHZhbHVlKSB7XG4gICAgICAgIGNvbnN0IHRhYmluZGV4ID0gTnVtYmVyKHZhbHVlKTtcbiAgICAgICAgY29uc3QgZGVmYXVsdFZhbHVlID0gMDtcbiAgICAgICAgdGhpcy5fdGFiaW5kZXggPSAhaXNOYU4odGFiaW5kZXgpID8gdGFiaW5kZXggOiBkZWZhdWx0VmFsdWU7XG4gICAgfVxuICAgIGdldCB0YWJpbmRleCgpIHtcbiAgICAgICAgcmV0dXJuICF0aGlzLmRpc2FibGVkID8gdGhpcy5fdGFiaW5kZXggOiB1bmRlZmluZWQ7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEluZGljYXRlcyB3aGV0aGVyIHRoZSBDb2xvclBpY2tlciBwb3B1cCBpcyBvcGVuLlxuICAgICAqL1xuICAgIGdldCBpc09wZW4oKSB7XG4gICAgICAgIHJldHVybiBpc1ByZXNlbnQodGhpcy5wb3B1cFJlZik7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBnZXQgaWNvblN0eWxlcygpIHtcbiAgICAgICAgaWYgKHRoaXMuaWNvbkNsYXNzKSB7XG4gICAgICAgICAgICByZXR1cm4gdGhpcy5pY29uQ2xhc3M7XG4gICAgICAgIH1cbiAgICAgICAgaWYgKHRoaXMuaWNvbikge1xuICAgICAgICAgICAgcmV0dXJuIGBrLWljb24gay1pLSR7dGhpcy5pY29ufWA7XG4gICAgICAgIH1cbiAgICB9XG4gICAgbmdPbkluaXQoKSB7XG4gICAgICAgIGNvbnN0IGRlZmF1bHRQcmVzZXQgPSAodGhpcy5mb3JtYXQgIT09ICduYW1lJykgPyBERUZBVUxUX1BSRVNFVCA6IERFRkFVTFRfQUNDRVNTSUJMRV9QUkVTRVQ7XG4gICAgICAgIGNvbnN0IHNldHRpbmdzUGFsZXR0ZSA9IHRoaXMuX3BhbGV0dGVTZXR0aW5ncy5wYWxldHRlO1xuICAgICAgICBjb25zdCBwcmVzZXRDb2x1bW5zID0gdHlwZW9mIHNldHRpbmdzUGFsZXR0ZSA9PT0gJ3N0cmluZycgJiYgUEFMRVRURVBSRVNFVFNbc2V0dGluZ3NQYWxldHRlXSA/XG4gICAgICAgICAgICBQQUxFVFRFUFJFU0VUU1tzZXR0aW5nc1BhbGV0dGVdLmNvbHVtbnMgOlxuICAgICAgICAgICAgdW5kZWZpbmVkO1xuICAgICAgICB0aGlzLl9wYWxldHRlU2V0dGluZ3MgPSB7XG4gICAgICAgICAgICBwYWxldHRlOiBzZXR0aW5nc1BhbGV0dGUgfHwgZGVmYXVsdFByZXNldCxcbiAgICAgICAgICAgIHRpbGVTaXplOiB0aGlzLl9wYWxldHRlU2V0dGluZ3MudGlsZVNpemUgfHwgMjQsXG4gICAgICAgICAgICBjb2x1bW5zOiB0aGlzLl9wYWxldHRlU2V0dGluZ3MuY29sdW1ucyB8fCBwcmVzZXRDb2x1bW5zIHx8IDEwXG4gICAgICAgIH07XG4gICAgfVxuICAgIG5nT25DaGFuZ2VzKGNoYW5nZXMpIHtcbiAgICAgICAgaWYgKGNoYW5nZXMuZm9ybWF0ICYmIGNoYW5nZXMuZm9ybWF0LmN1cnJlbnRWYWx1ZSA9PT0gJ25hbWUnKSB7XG4gICAgICAgICAgICB0aGlzLnZpZXcgPSAncGFsZXR0ZSc7XG4gICAgICAgIH1cbiAgICAgICAgaWYgKHRoaXMudmlldyA9PT0gJ2dyYWRpZW50JyAmJiB0aGlzLmdyYWRpZW50U2V0dGluZ3Mub3BhY2l0eSkge1xuICAgICAgICAgICAgdGhpcy5mb3JtYXQgPSAncmdiYSc7XG4gICAgICAgICAgICB0aGlzLnZhbHVlID0gcGFyc2VDb2xvciQxKHRoaXMudmFsdWUsIHRoaXMuZm9ybWF0KTtcbiAgICAgICAgfVxuICAgIH1cbiAgICBuZ09uRGVzdHJveSgpIHtcbiAgICAgICAgdGhpcy5jbG9zZVBvcHVwKCk7XG4gICAgICAgIGlmICh0aGlzLmR5bmFtaWNSVExTdWJzY3JpcHRpb24pIHtcbiAgICAgICAgICAgIHRoaXMuZHluYW1pY1JUTFN1YnNjcmlwdGlvbi51bnN1YnNjcmliZSgpO1xuICAgICAgICB9XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBoYW5kbGVXcmFwcGVyQ2xpY2soKSB7XG4gICAgICAgIHRoaXMudG9nZ2xlV2l0aEV2ZW50cyghdGhpcy5pc09wZW4pO1xuICAgICAgICB0aGlzLmZvY3VzKCk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBoYW5kbGVBY3RpdmVDb2xvckNsaWNrKCkge1xuICAgICAgICB0aGlzLmZvY3VzKCk7XG4gICAgICAgIGNvbnN0IGV2ZW50ID0gbmV3IEFjdGl2ZUNvbG9yQ2xpY2tFdmVudCh0aGlzLnZhbHVlKTtcbiAgICAgICAgdGhpcy5hY3RpdmVDb2xvckNsaWNrLmVtaXQoZXZlbnQpO1xuICAgICAgICBpZiAoIWV2ZW50LmlzT3BlblByZXZlbnRlZCgpIHx8IHRoaXMuaXNPcGVuKSB7XG4gICAgICAgICAgICB0aGlzLmhhbmRsZVdyYXBwZXJDbGljaygpO1xuICAgICAgICB9XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEZvY3VzZXMgdGhlIHdyYXBwZXIgb2YgdGhlIENvbG9yUGlja2VyLlxuICAgICAqL1xuICAgIGZvY3VzKCkge1xuICAgICAgICBpZiAodGhpcy5kaXNhYmxlZCkge1xuICAgICAgICAgICAgcmV0dXJuO1xuICAgICAgICB9XG4gICAgICAgIHRoaXMud3JhcHBlci5uYXRpdmVFbGVtZW50LmZvY3VzKCk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBoYW5kbGVXcmFwcGVyRm9jdXMoKSB7XG4gICAgICAgIGlmIChpc1ByZXNlbnQodGhpcy5wYWxldHRlKSkge1xuICAgICAgICAgICAgdGhpcy5wYWxldHRlLm5hdGl2ZUVsZW1lbnQuZm9jdXMoKTtcbiAgICAgICAgfVxuICAgICAgICBpZiAodGhpcy5pc0ZvY3VzZWQpIHtcbiAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgfVxuICAgICAgICB0aGlzLmlzRm9jdXNlZCA9IHRydWU7XG4gICAgICAgIHRoaXMub25Gb2N1cy5lbWl0KCk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEJsdXJzIHRoZSBDb2xvclBpY2tlci5cbiAgICAgKi9cbiAgICBibHVyKCkge1xuICAgICAgICB0aGlzLndyYXBwZXIubmF0aXZlRWxlbWVudC5ibHVyKCk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBoYW5kbGVXcmFwcGVyQmx1cigpIHtcbiAgICAgICAgaWYgKHRoaXMuaXNPcGVuKSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5pc0ZvY3VzZWQgPSBmYWxzZTtcbiAgICAgICAgdGhpcy5vbkJsdXIuZW1pdCgpO1xuICAgICAgICB0aGlzLm5vdGlmeU5nVG91Y2hlZCgpO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBDbGVhcnMgdGhlIGNvbG9yIHZhbHVlIG9mIHRoZSBDb2xvclBpY2tlci5cbiAgICAgKi9cbiAgICByZXNldCgpIHtcbiAgICAgICAgaWYgKCFpc1ByZXNlbnQodGhpcy52YWx1ZSkpIHtcbiAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgfVxuICAgICAgICB0aGlzLl92YWx1ZSA9IHVuZGVmaW5lZDtcbiAgICAgICAgdGhpcy5ub3RpZnlOZ0NoYW5nZWQodW5kZWZpbmVkKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogVG9nZ2xlcyB0aGUgcG9wdXAgb2YgdGhlIENvbG9yUGlja2VyLlxuICAgICAqIERvZXMgbm90IHRyaWdnZXIgdGhlIGBvcGVuYCBhbmQgYGNsb3NlYCBldmVudHMgb2YgdGhlIGNvbXBvbmVudC5cbiAgICAgKlxuICAgICAqIEBwYXJhbSBvcGVuIEFuIG9wdGlvbmFsIHBhcmFtZXRlci4gU3BlY2lmaWVzIHdoZXRoZXIgdGhlIHBvcHVwIHdpbGwgYmUgb3BlbmVkIG9yIGNsb3NlZC5cbiAgICAgKi9cbiAgICB0b2dnbGUob3Blbikge1xuICAgICAgICBpZiAodGhpcy5kaXNhYmxlZCB8fCB0aGlzLnJlYWRvbmx5KSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5jbG9zZVBvcHVwKCk7XG4gICAgICAgIG9wZW4gPSBpc1ByZXNlbnQob3BlbikgPyBvcGVuIDogIXRoaXMuaXNPcGVuO1xuICAgICAgICBpZiAob3Blbikge1xuICAgICAgICAgICAgdGhpcy5vcGVuUG9wdXAoKTtcbiAgICAgICAgfVxuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgaGFuZGxlVmFsdWVDaGFuZ2UoY29sb3IsIGNsb3NlUG9wdXApIHtcbiAgICAgICAgY29uc3QgcGFyc2VkQ29sb3IgPSBwYXJzZUNvbG9yJDEoY29sb3IsIHRoaXMuZm9ybWF0KTtcbiAgICAgICAgY29uc3QgdmFsdWVDaGFuZ2UgPSBwYXJzZWRDb2xvciAhPT0gdGhpcy52YWx1ZTtcbiAgICAgICAgaWYgKGNsb3NlUG9wdXApIHtcbiAgICAgICAgICAgIHRoaXMudG9nZ2xlV2l0aEV2ZW50cyhmYWxzZSk7XG4gICAgICAgICAgICB0aGlzLmZvY3VzKCk7XG4gICAgICAgIH1cbiAgICAgICAgaWYgKHZhbHVlQ2hhbmdlKSB7XG4gICAgICAgICAgICB0aGlzLnZhbHVlID0gcGFyc2VkQ29sb3I7XG4gICAgICAgICAgICB0aGlzLnZhbHVlQ2hhbmdlLmVtaXQocGFyc2VkQ29sb3IpO1xuICAgICAgICAgICAgdGhpcy5ub3RpZnlOZ0NoYW5nZWQocGFyc2VkQ29sb3IpO1xuICAgICAgICB9XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBoYW5kbGVQb3B1cEJsdXIoZXZlbnQpIHtcbiAgICAgICAgY29uc3QgZm9jdXNJblBvcHVwRWxlbWVudCA9IHRoaXMucG9wdXBSZWYucG9wdXBFbGVtZW50LmNvbnRhaW5zKGV2ZW50LnJlbGF0ZWRUYXJnZXQpO1xuICAgICAgICBjb25zdCB3cmFwcGVyQ2xpY2tlZCA9IGV2ZW50LnJlbGF0ZWRUYXJnZXQgPT09IHRoaXMud3JhcHBlci5uYXRpdmVFbGVtZW50O1xuICAgICAgICBpZiAoIXRoaXMuaXNGb2N1c2VkIHx8IHdyYXBwZXJDbGlja2VkIHx8IGZvY3VzSW5Qb3B1cEVsZW1lbnQpIHtcbiAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgfVxuICAgICAgICB0aGlzLmlzRm9jdXNlZCA9IGZhbHNlO1xuICAgICAgICB0aGlzLm9uQmx1ci5lbWl0KCk7XG4gICAgICAgIHRoaXMubm90aWZ5TmdUb3VjaGVkKCk7XG4gICAgICAgIHRoaXMudG9nZ2xlV2l0aEV2ZW50cyhmYWxzZSk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICB3cml0ZVZhbHVlKHZhbHVlKSB7XG4gICAgICAgIHRoaXMudmFsdWUgPSB2YWx1ZTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHJlZ2lzdGVyT25DaGFuZ2UoZm4pIHtcbiAgICAgICAgdGhpcy5ub3RpZnlOZ0NoYW5nZWQgPSBmbjtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHJlZ2lzdGVyT25Ub3VjaGVkKGZuKSB7XG4gICAgICAgIHRoaXMubm90aWZ5TmdUb3VjaGVkID0gZm47XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBzZXREaXNhYmxlZFN0YXRlKGlzRGlzYWJsZWQpIHtcbiAgICAgICAgdGhpcy5kaXNhYmxlZCA9IGlzRGlzYWJsZWQ7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBoYW5kbGVXcmFwcGVyS2V5RG93bihldmVudCkge1xuICAgICAgICBpZiAoZXZlbnQua2V5Q29kZSA9PT0gS2V5cy5BcnJvd0Rvd24gfHwgZXZlbnQua2V5Q29kZSA9PT0gS2V5cy5FbnRlcikge1xuICAgICAgICAgICAgZXZlbnQucHJldmVudERlZmF1bHQoKTtcbiAgICAgICAgICAgIHRoaXMudG9nZ2xlV2l0aEV2ZW50cyh0cnVlKTtcbiAgICAgICAgfVxuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgaGFuZGxlUG9wdXBLZXlEb3duKGtleUNvZGUpIHtcbiAgICAgICAgaWYgKGtleUNvZGUgPT09IEtleXMuVGFiIHx8IGtleUNvZGUgPT09IEtleXMuRXNjYXBlKSB7XG4gICAgICAgICAgICB0aGlzLnRvZ2dsZVdpdGhFdmVudHMoZmFsc2UpO1xuICAgICAgICAgICAgdGhpcy53cmFwcGVyLm5hdGl2ZUVsZW1lbnQuZm9jdXMoKTtcbiAgICAgICAgfVxuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICogVXNlZCBieSB0aGUgVGV4dEJveENvbnRhaW5lciB0byBkZXRlcm1pbmUgaWYgdGhlIGNvbXBvbmVudCBpcyBlbXB0eS5cbiAgICAgKi9cbiAgICBpc0VtcHR5KCkge1xuICAgICAgICByZXR1cm4gZmFsc2U7XG4gICAgfVxuICAgIHRvZ2dsZVdpdGhFdmVudHMob3Blbikge1xuICAgICAgICBjb25zdCBzYW1lU3RhdGUgPSB0aGlzLmlzT3BlbiA9PT0gb3BlbjtcbiAgICAgICAgaWYgKHRoaXMuZGlzYWJsZWQgfHwgdGhpcy5yZWFkb25seSB8fCBzYW1lU3RhdGUpIHtcbiAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgfVxuICAgICAgICBjb25zdCBldmVudEFyZ3MgPSBuZXcgUHJldmVudGFibGVFdmVudCgpO1xuICAgICAgICBvcGVuID8gdGhpcy5vcGVuLmVtaXQoZXZlbnRBcmdzKSA6IHRoaXMuY2xvc2UuZW1pdChldmVudEFyZ3MpO1xuICAgICAgICBpZiAoIWV2ZW50QXJncy5pc0RlZmF1bHRQcmV2ZW50ZWQoKSkge1xuICAgICAgICAgICAgdGhpcy50b2dnbGUob3Blbik7XG4gICAgICAgIH1cbiAgICB9XG4gICAgb3BlblBvcHVwKCkge1xuICAgICAgICBjb25zdCBob3Jpem9udGFsQWxpZ24gPSB0aGlzLmRpcmVjdGlvbiA9PT0gXCJydGxcIiA/IFwicmlnaHRcIiA6IFwibGVmdFwiO1xuICAgICAgICBjb25zdCBhbmNob3JQb3NpdGlvbiA9IHsgaG9yaXpvbnRhbDogaG9yaXpvbnRhbEFsaWduLCB2ZXJ0aWNhbDogXCJib3R0b21cIiB9O1xuICAgICAgICBjb25zdCBwb3B1cFBvc2l0aW9uID0geyBob3Jpem9udGFsOiBob3Jpem9udGFsQWxpZ24sIHZlcnRpY2FsOiBcInRvcFwiIH07XG4gICAgICAgIHRoaXMucG9wdXBSZWYgPSB0aGlzLnBvcHVwU2VydmljZS5vcGVuKHtcbiAgICAgICAgICAgIGFuY2hvcjogdGhpcy53cmFwcGVyLFxuICAgICAgICAgICAgYW5pbWF0ZTogdGhpcy5wb3B1cFNldHRpbmdzLmFuaW1hdGUsXG4gICAgICAgICAgICBhcHBlbmRUbzogdGhpcy5wb3B1cFNldHRpbmdzLmFwcGVuZFRvLFxuICAgICAgICAgICAgcG9wdXBBbGlnbjogcG9wdXBQb3NpdGlvbixcbiAgICAgICAgICAgIGFuY2hvckFsaWduOiBhbmNob3JQb3NpdGlvbixcbiAgICAgICAgICAgIHBvcHVwQ2xhc3M6ICdrLWNvbG9ycGlja2VyLXBvcHVwJyxcbiAgICAgICAgICAgIGNvbnRlbnQ6IHRoaXMucG9wdXBUZW1wbGF0ZSxcbiAgICAgICAgICAgIHBvc2l0aW9uTW9kZTogJ2Fic29sdXRlJ1xuICAgICAgICB9KTtcbiAgICAgICAgdGhpcy5wb3B1cFJlZi5wb3B1cEFuY2hvclZpZXdwb3J0TGVhdmUuc3Vic2NyaWJlKCgpID0+IHtcbiAgICAgICAgICAgIHRoaXMudG9nZ2xlV2l0aEV2ZW50cyhmYWxzZSk7XG4gICAgICAgICAgICBpZiAoIXRoaXMuaXNPcGVuKSB7XG4gICAgICAgICAgICAgICAgdGhpcy53cmFwcGVyLm5hdGl2ZUVsZW1lbnQuZm9jdXMoe1xuICAgICAgICAgICAgICAgICAgICBwcmV2ZW50U2Nyb2xsOiB0cnVlXG4gICAgICAgICAgICAgICAgfSk7XG4gICAgICAgICAgICB9XG4gICAgICAgIH0pO1xuICAgIH1cbiAgICBjbG9zZVBvcHVwKCkge1xuICAgICAgICBpZiAoIXRoaXMuaXNPcGVuKSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5wb3B1cFJlZi5jbG9zZSgpO1xuICAgICAgICB0aGlzLnBvcHVwUmVmID0gbnVsbDtcbiAgICAgICAgdGhpcy5wYWxldHRlID0gbnVsbDtcbiAgICB9XG59XG5Db2xvclBpY2tlckNvbXBvbmVudC5kZWNvcmF0b3JzID0gW1xuICAgIHsgdHlwZTogQ29tcG9uZW50LCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIHNlbGVjdG9yOiAna2VuZG8tY29sb3JwaWNrZXInLFxuICAgICAgICAgICAgICAgIHByb3ZpZGVyczogW3tcbiAgICAgICAgICAgICAgICAgICAgICAgIG11bHRpOiB0cnVlLFxuICAgICAgICAgICAgICAgICAgICAgICAgcHJvdmlkZTogTkdfVkFMVUVfQUNDRVNTT1IsXG4gICAgICAgICAgICAgICAgICAgICAgICB1c2VFeGlzdGluZzogZm9yd2FyZFJlZigoKSA9PiBDb2xvclBpY2tlckNvbXBvbmVudClcbiAgICAgICAgICAgICAgICAgICAgfSwge1xuICAgICAgICAgICAgICAgICAgICAgICAgcHJvdmlkZTogS2VuZG9JbnB1dCxcbiAgICAgICAgICAgICAgICAgICAgICAgIHVzZUV4aXN0aW5nOiBmb3J3YXJkUmVmKCgpID0+IENvbG9yUGlja2VyQ29tcG9uZW50KVxuICAgICAgICAgICAgICAgICAgICB9LFxuICAgICAgICAgICAgICAgICAgICBMb2NhbGl6YXRpb25TZXJ2aWNlLFxuICAgICAgICAgICAgICAgICAgICB7XG4gICAgICAgICAgICAgICAgICAgICAgICBwcm92aWRlOiBMMTBOX1BSRUZJWCxcbiAgICAgICAgICAgICAgICAgICAgICAgIHVzZVZhbHVlOiAna2VuZG8uY29sb3JwaWNrZXInXG4gICAgICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICBdLFxuICAgICAgICAgICAgICAgIHRlbXBsYXRlOiBgXG4gICAgICAgIDxzcGFuXG4gICAgICAgICAgICAjd3JhcHBlclxuICAgICAgICAgICAgW25nQ2xhc3NdPVwie1xuICAgICAgICAgICAgICAgICdrLXBpY2tlci13cmFwJzogdHJ1ZSxcbiAgICAgICAgICAgICAgICAnay1zdGF0ZS1kaXNhYmxlZCc6IHRoaXMuZGlzYWJsZWQsXG4gICAgICAgICAgICAgICAgJ2stc3RhdGUtZm9jdXNlZCc6IHRoaXMuaXNGb2N1c2VkXG4gICAgICAgICAgICB9XCJcbiAgICAgICAgICAgIHJvbGU9XCJsaXN0Ym94XCJcbiAgICAgICAgICAgIFthdHRyLmFyaWEtZXhwYW5kZWRdPVwiaXNPcGVuXCJcbiAgICAgICAgICAgIFtpZF09XCJmb2N1c2FibGVJZFwiXG4gICAgICAgICAgICBbYXR0ci50YWJpbmRleF09XCJ0YWJpbmRleFwiXG4gICAgICAgICAgICAoZm9jdXMpPVwiaGFuZGxlV3JhcHBlckZvY3VzKClcIlxuICAgICAgICAgICAgKGJsdXIpPVwiaGFuZGxlV3JhcHBlckJsdXIoKVwiXG4gICAgICAgICAgICAobW91c2Vkb3duKT1cIiRldmVudC5wcmV2ZW50RGVmYXVsdCgpXCJcbiAgICAgICAgICAgIChrZXlkb3duKT1cImhhbmRsZVdyYXBwZXJLZXlEb3duKCRldmVudClcIlxuICAgICAgICA+XG4gICAgICAgICAgICA8c3BhbiAqbmdJZj1cIiFpY29uU3R5bGVzXCIgY2xhc3M9XCJrLXNlbGVjdGVkLWNvbG9yXCIgW3N0eWxlLmJhY2tncm91bmQtY29sb3JdPVwidmFsdWVcIiAoY2xpY2spPVwiaGFuZGxlQWN0aXZlQ29sb3JDbGljaygpXCI+XG4gICAgICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJrLWljb24gay1pLWxpbmVcIiAqbmdJZj1cIiF2YWx1ZVwiPjwvc3Bhbj5cbiAgICAgICAgICAgIDwvc3Bhbj5cbiAgICAgICAgICAgIDxzcGFuICpuZ0lmPVwiaWNvblN0eWxlc1wiIGNsYXNzPVwiay10b29sLWljb25cIiBbbmdDbGFzc109XCJpY29uU3R5bGVzXCIgKGNsaWNrKT1cImhhbmRsZUFjdGl2ZUNvbG9yQ2xpY2soKVwiPlxuICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwiay1zZWxlY3RlZC1jb2xvclwiIFtzdHlsZS5iYWNrZ3JvdW5kLWNvbG9yXT1cInZhbHVlXCI+PC9zcGFuPlxuICAgICAgICAgICAgPC9zcGFuPlxuICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJrLXNlbGVjdFwiIChjbGljayk9XCJoYW5kbGVXcmFwcGVyQ2xpY2soKVwiPlxuICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwiay1pY29uIGstaS1hcnJvdy1zXCI+PC9zcGFuPlxuICAgICAgICAgICAgPC9zcGFuPlxuICAgICAgICA8L3NwYW4+XG4gICAgICAgIDxuZy10ZW1wbGF0ZSAjcG9wdXBUZW1wbGF0ZT5cbiAgICAgICAgICAgIDxrZW5kby1jb2xvcmdyYWRpZW50XG4gICAgICAgICAgICAgICAgKm5nSWY9XCJ2aWV3ID09PSAnZ3JhZGllbnQnIHx8IHZpZXcgPT09ICdjb21ibydcIlxuICAgICAgICAgICAgICAgIGtlbmRvRm9jdXNPbkRvbVJlYWR5XG4gICAgICAgICAgICAgICAgW3ZhbHVlXT1cInZhbHVlXCJcbiAgICAgICAgICAgICAgICBbZm9ybWF0XT1cImZvcm1hdFwiXG4gICAgICAgICAgICAgICAgW29wYWNpdHldPVwiZ3JhZGllbnRTZXR0aW5ncy5vcGFjaXR5XCJcbiAgICAgICAgICAgICAgICBbY2xlYXJCdXR0b25dPVwiZ3JhZGllbnRTZXR0aW5ncy5jbGVhckJ1dHRvblwiXG4gICAgICAgICAgICAgICAgKGZvY3Vzb3V0KT1cImhhbmRsZVBvcHVwQmx1cigkZXZlbnQpXCJcbiAgICAgICAgICAgICAgICAodmFsdWVDaGFuZ2UpPVwiaGFuZGxlVmFsdWVDaGFuZ2UoJGV2ZW50LCBmYWxzZSlcIlxuICAgICAgICAgICAgICAgIChrZXlkb3duKT1cImhhbmRsZVBvcHVwS2V5RG93bigkZXZlbnQua2V5Q29kZSlcIlxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgPC9rZW5kby1jb2xvcmdyYWRpZW50PlxuICAgICAgICAgICAgPGtlbmRvLWNvbG9ycGFsZXR0ZVxuICAgICAgICAgICAgICAgICNwYWxldHRlXG4gICAgICAgICAgICAgICAgKm5nSWY9XCJ2aWV3ID09PSAncGFsZXR0ZScgfHwgdmlldyA9PT0gJ2NvbWJvJ1wiXG4gICAgICAgICAgICAgICAga2VuZG9Gb2N1c09uRG9tUmVhZHlcbiAgICAgICAgICAgICAgICBbcGFsZXR0ZV09XCJwYWxldHRlU2V0dGluZ3MucGFsZXR0ZVwiXG4gICAgICAgICAgICAgICAgW2NvbHVtbnNdPVwicGFsZXR0ZVNldHRpbmdzLmNvbHVtbnNcIlxuICAgICAgICAgICAgICAgIFt0aWxlU2l6ZV09XCJwYWxldHRlU2V0dGluZ3MudGlsZVNpemVcIlxuICAgICAgICAgICAgICAgIFtmb3JtYXRdPVwiZm9ybWF0XCJcbiAgICAgICAgICAgICAgICBbdmFsdWVdPVwidmFsdWVcIlxuICAgICAgICAgICAgICAgIChibHVyKT1cImhhbmRsZVBvcHVwQmx1cigkZXZlbnQpXCJcbiAgICAgICAgICAgICAgICAoY2VsbFNlbGVjdGlvbik9XCJoYW5kbGVWYWx1ZUNoYW5nZSgkZXZlbnQsIHRydWUpXCJcbiAgICAgICAgICAgICAgICAobW91c2Vkb3duKT1cIiRldmVudC5wcmV2ZW50RGVmYXVsdCgpXCJcbiAgICAgICAgICAgICAgICAoa2V5ZG93bik9XCJoYW5kbGVQb3B1cEtleURvd24oJGV2ZW50LmtleUNvZGUpXCJcbiAgICAgICAgICAgID5cbiAgICAgICAgICAgIDwva2VuZG8tY29sb3JwYWxldHRlPlxuICAgICAgICA8L25nLXRlbXBsYXRlPlxuICAgICAgICA8bmctY29udGFpbmVyICNjb250YWluZXI+PC9uZy1jb250YWluZXI+XG4gICAgYFxuICAgICAgICAgICAgfSxdIH0sXG5dO1xuLyoqIEBub2NvbGxhcHNlICovXG5Db2xvclBpY2tlckNvbXBvbmVudC5jdG9yUGFyYW1ldGVycyA9ICgpID0+IFtcbiAgICB7IHR5cGU6IFBvcHVwU2VydmljZSB9LFxuICAgIHsgdHlwZTogTG9jYWxpemF0aW9uU2VydmljZSB9XG5dO1xuQ29sb3JQaWNrZXJDb21wb25lbnQucHJvcERlY29yYXRvcnMgPSB7XG4gICAgaG9zdENsYXNzZXM6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstd2lkZ2V0JyxdIH0sIHsgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnY2xhc3Muay1jb2xvcnBpY2tlcicsXSB9XSxcbiAgICBkaXJlY3Rpb246IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2F0dHIuZGlyJyxdIH1dLFxuICAgIGZvY3VzYWJsZUlkOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICB2aWV3OiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICByZWFkb25seTogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgZGlzYWJsZWQ6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIGZvcm1hdDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgdmFsdWU6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHBvcHVwU2V0dGluZ3M6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHBhbGV0dGVTZXR0aW5nczogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgZ3JhZGllbnRTZXR0aW5nczogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgaWNvbjogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgaWNvbkNsYXNzOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICB0YWJpbmRleDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgdmFsdWVDaGFuZ2U6IFt7IHR5cGU6IE91dHB1dCB9XSxcbiAgICBvcGVuOiBbeyB0eXBlOiBPdXRwdXQgfV0sXG4gICAgY2xvc2U6IFt7IHR5cGU6IE91dHB1dCB9XSxcbiAgICBvbkZvY3VzOiBbeyB0eXBlOiBPdXRwdXQsIGFyZ3M6IFsnZm9jdXMnLF0gfV0sXG4gICAgb25CbHVyOiBbeyB0eXBlOiBPdXRwdXQsIGFyZ3M6IFsnYmx1cicsXSB9XSxcbiAgICBhY3RpdmVDb2xvckNsaWNrOiBbeyB0eXBlOiBPdXRwdXQgfV0sXG4gICAgY29udGFpbmVyOiBbeyB0eXBlOiBWaWV3Q2hpbGQsIGFyZ3M6IFsnY29udGFpbmVyJywgeyByZWFkOiBWaWV3Q29udGFpbmVyUmVmIH0sXSB9XSxcbiAgICB3cmFwcGVyOiBbeyB0eXBlOiBWaWV3Q2hpbGQsIGFyZ3M6IFsnd3JhcHBlcicsXSB9XSxcbiAgICBwb3B1cFRlbXBsYXRlOiBbeyB0eXBlOiBWaWV3Q2hpbGQsIGFyZ3M6IFsncG9wdXBUZW1wbGF0ZScsXSB9XSxcbiAgICBwYWxldHRlOiBbeyB0eXBlOiBWaWV3Q2hpbGQsIGFyZ3M6IFsncGFsZXR0ZScsIHsgcmVhZDogRWxlbWVudFJlZiB9LF0gfV1cbn07XG5cbi8qKlxuICogQGhpZGRlblxuICovXG5jbGFzcyBDb2xvclBhbGV0dGVTZXJ2aWNlIHtcbiAgICBjb25zdHJ1Y3RvcigpIHtcbiAgICAgICAgdGhpcy5jb2xvclJvd3MgPSBbXTtcbiAgICB9XG4gICAgc2V0Q29sb3JNYXRyaXgocGFsZXR0ZSwgY29sdW1ucykge1xuICAgICAgICB0aGlzLmNvbG9yUm93cyA9IFtdO1xuICAgICAgICBpZiAoIShpc1ByZXNlbnQocGFsZXR0ZSkgJiYgcGFsZXR0ZS5sZW5ndGgpKSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgY29sdW1ucyA9IGNvbHVtbnMgfHwgcGFsZXR0ZS5sZW5ndGg7XG4gICAgICAgIGZvciAobGV0IHN0YXJ0ID0gMDsgc3RhcnQgPCBwYWxldHRlLmxlbmd0aDsgc3RhcnQgKz0gY29sdW1ucykge1xuICAgICAgICAgICAgY29uc3Qgcm93ID0gcGFsZXR0ZS5zbGljZShzdGFydCwgY29sdW1ucyArIHN0YXJ0KTtcbiAgICAgICAgICAgIHRoaXMuY29sb3JSb3dzLnB1c2gocm93KTtcbiAgICAgICAgfVxuICAgIH1cbiAgICBnZXRDZWxsQ29vcmRzRm9yKGNvbG9yKSB7XG4gICAgICAgIGlmICghaXNQcmVzZW50KGNvbG9yKSkge1xuICAgICAgICAgICAgcmV0dXJuO1xuICAgICAgICB9XG4gICAgICAgIGZvciAobGV0IHJvdyA9IDA7IHJvdyA8IHRoaXMuY29sb3JSb3dzLmxlbmd0aDsgcm93KyspIHtcbiAgICAgICAgICAgIGZvciAobGV0IGNvbCA9IDA7IGNvbCA8IHRoaXMuY29sb3JSb3dzW3Jvd10ubGVuZ3RoOyBjb2wrKykge1xuICAgICAgICAgICAgICAgIGlmICh0aGlzLmNvbG9yUm93c1tyb3ddW2NvbF0gPT09IGNvbG9yKSB7XG4gICAgICAgICAgICAgICAgICAgIHJldHVybiB7IHJvdywgY29sIH07XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfVxuICAgICAgICB9XG4gICAgfVxuICAgIGdldENvbG9yQXQoY2VsbENvb3Jkcykge1xuICAgICAgICBpZiAoIShpc1ByZXNlbnQoY2VsbENvb3JkcykgJiYgaXNQcmVzZW50KHRoaXMuY29sb3JSb3dzW2NlbGxDb29yZHMucm93XSkpKSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgcmV0dXJuIHRoaXMuY29sb3JSb3dzW2NlbGxDb29yZHMucm93XVtjZWxsQ29vcmRzLmNvbF07XG4gICAgfVxuICAgIGdldE5leHRDZWxsKGN1cnJlbnQsIGhvcml6b250YWxTdGVwLCB2ZXJ0aWNhbFN0ZXApIHtcbiAgICAgICAgaWYgKCEoaXNQcmVzZW50KGN1cnJlbnQpICYmIGlzUHJlc2VudChjdXJyZW50LnJvdykgJiYgaXNQcmVzZW50KGN1cnJlbnQuY29sKSkpIHtcbiAgICAgICAgICAgIHJldHVybiB7IHJvdzogMCwgY29sOiAwIH07XG4gICAgICAgIH1cbiAgICAgICAgY29uc3Qgcm93ID0gdGhpcy5jbGFtcEluZGV4KGN1cnJlbnQucm93ICsgdmVydGljYWxTdGVwLCB0aGlzLmNvbG9yUm93cy5sZW5ndGggLSAxKTtcbiAgICAgICAgY29uc3QgY29sID0gdGhpcy5jbGFtcEluZGV4KGN1cnJlbnQuY29sICsgaG9yaXpvbnRhbFN0ZXAsIHRoaXMuY29sb3JSb3dzW3Jvd10ubGVuZ3RoIC0gMSk7XG4gICAgICAgIHJldHVybiB7IHJvdywgY29sIH07XG4gICAgfVxuICAgIGNsYW1wSW5kZXgoaW5kZXgsIG1heCkge1xuICAgICAgICBjb25zdCBtaW5BcnJheUluZGV4ID0gMDtcbiAgICAgICAgaWYgKGluZGV4IDwgbWluQXJyYXlJbmRleCkge1xuICAgICAgICAgICAgcmV0dXJuIG1pbkFycmF5SW5kZXg7XG4gICAgICAgIH1cbiAgICAgICAgaWYgKGluZGV4ID4gbWF4KSB7XG4gICAgICAgICAgICByZXR1cm4gbWF4O1xuICAgICAgICB9XG4gICAgICAgIHJldHVybiBpbmRleDtcbiAgICB9XG59XG5Db2xvclBhbGV0dGVTZXJ2aWNlLmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBJbmplY3RhYmxlIH0sXG5dO1xuXG5jb25zdCBERUZBVUxUX1RJTEVfU0laRSA9IDI0O1xuY29uc3QgREVGQVVMVF9DT0xVTU5TX0NPVU5UID0gMTA7XG5jb25zdCBERUZBVUxUX1BSRVNFVCQxID0gJ29mZmljZSc7XG5jb25zdCBERUZBVUxUX0FDQ0VTU0lCTEVfUFJFU0VUJDEgPSAnYWNjZXNzaWJsZSc7XG5sZXQgc2VyaWFsJDEgPSAwO1xuLyoqXG4gKiBUaGUgQ29sb3JQYWxldHRlIGNvbXBvbmVudCBwcm92aWRlcyBhIHNldCBvZiBwcmVkZWZpbmVkIHBhbGV0dGUgcHJlc2V0cyBhbmQgZW5hYmxlcyB5b3UgdG8gaW1wbGVtZW50IGEgY3VzdG9tIGNvbG9yIHBhbGV0dGUuXG4gKiBUaGUgQ29sb3JQYWxldHRlIGlzIGluZGVwZW5kZW50bHkgdXNlZCBieSBga2VuZG8tY29sb3JwaWNrZXJgIGFuZCBjYW4gYmUgZGlyZWN0bHkgYWRkZWQgdG8gdGhlIHBhZ2UuXG4gKi9cbmNsYXNzIENvbG9yUGFsZXR0ZUNvbXBvbmVudCB7XG4gICAgY29uc3RydWN0b3Ioc2VydmljZSwgbG9jYWxpemF0aW9uU2VydmljZSkge1xuICAgICAgICB0aGlzLnNlcnZpY2UgPSBzZXJ2aWNlO1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5pZCA9IGBrLWNvbG9ycGFsZXR0ZS0ke3NlcmlhbCQxKyt9YDtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIFNwZWNpZmllcyB0aGUgb3V0cHV0IGZvcm1hdCBvZiB0aGUgQ29sb3JQYWxldHRlQ29tcG9uZW50LlxuICAgICAgICAgKiBUaGUgaW5wdXQgdmFsdWUgbWF5IGJlIGluIGEgZGlmZmVyZW50IGZvcm1hdC4gSG93ZXZlciwgaXQgd2lsbCBiZSBwYXJzZWQgaW50byB0aGUgb3V0cHV0IGBmb3JtYXRgXG4gICAgICAgICAqIGFmdGVyIHRoZSBjb21wb25lbnQgcHJvY2Vzc2VzIGl0LlxuICAgICAgICAgKlxuICAgICAgICAgKiBUaGUgc3VwcG9ydGVkIHZhbHVlcyBhcmU6XG4gICAgICAgICAqICogKERlZmF1bHQpIGBoZXhgXG4gICAgICAgICAqICogYHJnYmFgXG4gICAgICAgICAqICogYG5hbWVgXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmZvcm1hdCA9ICdoZXgnO1xuICAgICAgICAvKipcbiAgICAgICAgICogU3BlY2lmaWVzIHRoZSBzaXplIG9mIGEgY29sb3IgY2VsbC5cbiAgICAgICAgICpcbiAgICAgICAgICogVGhlIHBvc3NpYmxlIHZhbHVlcyBhcmU6XG4gICAgICAgICAqICogKERlZmF1bHQpIGB0aWxlU2l6ZSA9IDI0YFxuICAgICAgICAgKiAqIGB7IHdpZHRoOiBudW1iZXIsIGhlaWdodDogbnVtYmVyIH1gXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLnRpbGVTaXplID0geyB3aWR0aDogREVGQVVMVF9USUxFX1NJWkUsIGhlaWdodDogREVGQVVMVF9USUxFX1NJWkUgfTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEZpcmVzIGVhY2ggdGltZSB0aGUgY29sb3Igc2VsZWN0aW9uIGlzIGNoYW5nZWQuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLnNlbGVjdGlvbkNoYW5nZSA9IG5ldyBFdmVudEVtaXR0ZXIoKTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEZpcmVzIGVhY2ggdGltZSB0aGUgdmFsdWUgaXMgY2hhbmdlZC5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMudmFsdWVDaGFuZ2UgPSBuZXcgRXZlbnRFbWl0dGVyKCk7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBGaXJlcyBlYWNoIHRpbWUgdGhlIHVzZXIgc2VsZWN0cyBhIGNlbGwgd2l0aCB0aGUgbW91c2Ugb3IgcHJlc3NlcyBgRW50ZXJgLlxuICAgICAgICAgKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmNlbGxTZWxlY3Rpb24gPSBuZXcgRXZlbnRFbWl0dGVyKCk7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmhvc3RDbGFzc2VzID0gdHJ1ZTtcbiAgICAgICAgdGhpcy5fdGFiaW5kZXggPSAwO1xuICAgICAgICB0aGlzLm5vdGlmeU5nVG91Y2hlZCA9ICgpID0+IHsgfTtcbiAgICAgICAgdGhpcy5ub3RpZnlOZ0NoYW5nZWQgPSAoKSA9PiB7IH07XG4gICAgICAgIHRoaXMuZHluYW1pY1JUTFN1YnNjcmlwdGlvbiA9IGxvY2FsaXphdGlvblNlcnZpY2UuY2hhbmdlcy5zdWJzY3JpYmUoKHsgcnRsIH0pID0+IHtcbiAgICAgICAgICAgIHRoaXMuZGlyZWN0aW9uID0gcnRsID8gJ3J0bCcgOiAnbHRyJztcbiAgICAgICAgfSk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBnZXQgcGFsZXR0ZUlkKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5pZDtcbiAgICB9XG4gICAgLyoqXG4gICAgICogU3BlY2lmaWVzIHRoZSB2YWx1ZSBvZiB0aGUgaW5pdGlhbGx5IHNlbGVjdGVkIGNvbG9yLlxuICAgICAqL1xuICAgIHNldCB2YWx1ZSh2YWx1ZSkge1xuICAgICAgICB0aGlzLl92YWx1ZSA9IHBhcnNlQ29sb3IkMSh2YWx1ZSwgdGhpcy5mb3JtYXQpO1xuICAgIH1cbiAgICBnZXQgdmFsdWUoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLl92YWx1ZTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogU3BlY2lmaWVzIHRoZSBudW1iZXIgb2YgY29sdW1ucyB0aGF0IHdpbGwgYmUgZGlzcGxheWVkLlxuICAgICAqIERlZmF1bHRzIHRvIGAxMGAuXG4gICAgICovXG4gICAgc2V0IGNvbHVtbnModmFsdWUpIHtcbiAgICAgICAgY29uc3QgbWluQ29sdW1uc0NvdW50ID0gMTtcbiAgICAgICAgdGhpcy5fY29sdW1ucyA9IHZhbHVlID4gbWluQ29sdW1uc0NvdW50ID8gdmFsdWUgOiBtaW5Db2x1bW5zQ291bnQ7XG4gICAgfVxuICAgIGdldCBjb2x1bW5zKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5fY29sdW1ucztcbiAgICB9XG4gICAgLyoqXG4gICAgICogVGhlIGNvbG9yIHBhbGV0dGUgdGhhdCB3aWxsIGJlIGRpc3BsYXllZC5cbiAgICAgKlxuICAgICAqIFRoZSBzdXBwb3J0ZWQgdmFsdWVzIGFyZTpcbiAgICAgKiAqIFRoZSBuYW1lIG9mIHRoZSBwcmVkZWZpbmVkIHBhbGV0dGUgcHJlc2V0IChmb3IgZXhhbXBsZSwgYG9mZmljZWAsIGBiYXNpY2AsIGFuZCBgYXBleGApLlxuICAgICAqICogQSBzdHJpbmcgd2l0aCBjb21tYS1zZXBhcmF0ZWQgY29sb3JzLlxuICAgICAqICogQSBzdHJpbmcgYXJyYXkuXG4gICAgICovXG4gICAgc2V0IHBhbGV0dGUodmFsdWUpIHtcbiAgICAgICAgaWYgKCFpc1ByZXNlbnQodmFsdWUpKSB7XG4gICAgICAgICAgICB2YWx1ZSA9IERFRkFVTFRfUFJFU0VUJDE7XG4gICAgICAgIH1cbiAgICAgICAgaWYgKHR5cGVvZiB2YWx1ZSA9PT0gJ3N0cmluZycgJiYgaXNQcmVzZW50KFBBTEVUVEVQUkVTRVRTW3ZhbHVlXSkpIHtcbiAgICAgICAgICAgIHRoaXMuY29sdW1ucyA9IHRoaXMuY29sdW1ucyB8fCBQQUxFVFRFUFJFU0VUU1t2YWx1ZV0uY29sdW1ucztcbiAgICAgICAgICAgIHZhbHVlID0gUEFMRVRURVBSRVNFVFNbdmFsdWVdLmNvbG9ycztcbiAgICAgICAgfVxuICAgICAgICBjb25zdCBjb2xvcnMgPSAodHlwZW9mIHZhbHVlID09PSAnc3RyaW5nJykgPyB2YWx1ZS5zcGxpdCgnLCcpIDogdmFsdWU7XG4gICAgICAgIHRoaXMuX3BhbGV0dGUgPSBjb2xvcnMubWFwKGNvbG9yID0+IHBhcnNlQ29sb3IkMShjb2xvciwgdGhpcy5mb3JtYXQsIGZhbHNlKSk7XG4gICAgfVxuICAgIGdldCBwYWxldHRlKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5fcGFsZXR0ZTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogU3BlY2lmaWVzIHRoZSBbYHRhYmluZGV4YF0oaHR0cHM6Ly9kZXZlbG9wZXIubW96aWxsYS5vcmcvZW4tVVMvZG9jcy9XZWIvSFRNTC9HbG9iYWxfYXR0cmlidXRlcy90YWJpbmRleCkgb2YgdGhlIGNvbXBvbmVudC5cbiAgICAgKi9cbiAgICBzZXQgdGFiaW5kZXgodmFsdWUpIHtcbiAgICAgICAgY29uc3QgdGFiaW5kZXggPSBOdW1iZXIodmFsdWUpO1xuICAgICAgICBjb25zdCBkZWZhdWx0VmFsdWUgPSAwO1xuICAgICAgICB0aGlzLl90YWJpbmRleCA9ICFpc05hTih0YWJpbmRleCkgPyB0YWJpbmRleCA6IGRlZmF1bHRWYWx1ZTtcbiAgICB9XG4gICAgZ2V0IHRhYmluZGV4KCkge1xuICAgICAgICByZXR1cm4gIXRoaXMuZGlzYWJsZWQgPyB0aGlzLl90YWJpbmRleCA6IHVuZGVmaW5lZDtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIGdldCB0aWxlTGF5b3V0KCkge1xuICAgICAgICBpZiAodHlwZW9mIHRoaXMudGlsZVNpemUgIT09ICdudW1iZXInKSB7XG4gICAgICAgICAgICByZXR1cm4gdGhpcy50aWxlU2l6ZTtcbiAgICAgICAgfVxuICAgICAgICByZXR1cm4geyB3aWR0aDogdGhpcy50aWxlU2l6ZSwgaGVpZ2h0OiB0aGlzLnRpbGVTaXplIH07XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBnZXQgY29sb3JSb3dzKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5zZXJ2aWNlLmNvbG9yUm93cztcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIGdldCBob3N0VGFiaW5kZXgoKSB7IHJldHVybiB0aGlzLnRhYmluZGV4OyB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIGdldCBkaXNhYmxlZENsYXNzKCkgeyByZXR1cm4gdGhpcy5kaXNhYmxlZDsgfVxuICAgIG5nT25Jbml0KCkge1xuICAgICAgICBpZiAodGhpcy5jb2xvclJvd3MubGVuZ3RoID09PSAwKSB7XG4gICAgICAgICAgICBjb25zdCBkZWZhdWx0UHJlc2V0ID0gKHRoaXMuZm9ybWF0ICE9PSAnbmFtZScpID8gREVGQVVMVF9QUkVTRVQkMSA6IERFRkFVTFRfQUNDRVNTSUJMRV9QUkVTRVQkMTtcbiAgICAgICAgICAgIHRoaXMucGFsZXR0ZSA9IHRoaXMucGFsZXR0ZSB8fCBkZWZhdWx0UHJlc2V0O1xuICAgICAgICAgICAgdGhpcy5zZXRSb3dzKCk7XG4gICAgICAgICAgICB0aGlzLmZvY3VzZWRDZWxsID0gdGhpcy5zZXJ2aWNlLmdldENlbGxDb29yZHNGb3IodGhpcy52YWx1ZSk7XG4gICAgICAgIH1cbiAgICB9XG4gICAgbmdPbkRlc3Ryb3koKSB7XG4gICAgICAgIGlmICh0aGlzLmR5bmFtaWNSVExTdWJzY3JpcHRpb24pIHtcbiAgICAgICAgICAgIHRoaXMuZHluYW1pY1JUTFN1YnNjcmlwdGlvbi51bnN1YnNjcmliZSgpO1xuICAgICAgICB9XG4gICAgfVxuICAgIG5nT25DaGFuZ2VzKGNoYW5nZXMpIHtcbiAgICAgICAgaWYgKGNoYW5nZXMucGFsZXR0ZSB8fCBjaGFuZ2VzLmNvbHVtbnMpIHtcbiAgICAgICAgICAgIHRoaXMuc2V0Um93cygpO1xuICAgICAgICB9XG4gICAgICAgIGlmIChjaGFuZ2VzLnBhbGV0dGUgfHwgY2hhbmdlcy52YWx1ZSB8fCBjaGFuZ2VzLmNvbHVtbnMpIHtcbiAgICAgICAgICAgIHRoaXMuZm9jdXNlZENlbGwgPSB0aGlzLnNlcnZpY2UuZ2V0Q2VsbENvb3Jkc0Zvcih0aGlzLnZhbHVlKTtcbiAgICAgICAgfVxuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgaGFuZGxlS2V5ZG93bihldmVudCkge1xuICAgICAgICBjb25zdCBpc1JUTCA9IHRoaXMuZGlyZWN0aW9uID09PSAncnRsJztcbiAgICAgICAgc3dpdGNoIChldmVudC5rZXlDb2RlKSB7XG4gICAgICAgICAgICBjYXNlIEtleXMuQXJyb3dEb3duOlxuICAgICAgICAgICAgICAgIHRoaXMuaGFuZGxlQ2VsbE5hdmlnYXRpb24oMCwgMSk7XG4gICAgICAgICAgICAgICAgYnJlYWs7XG4gICAgICAgICAgICBjYXNlIEtleXMuQXJyb3dVcDpcbiAgICAgICAgICAgICAgICB0aGlzLmhhbmRsZUNlbGxOYXZpZ2F0aW9uKDAsIC0xKTtcbiAgICAgICAgICAgICAgICBicmVhaztcbiAgICAgICAgICAgIGNhc2UgS2V5cy5BcnJvd1JpZ2h0OlxuICAgICAgICAgICAgICAgIHRoaXMuaGFuZGxlQ2VsbE5hdmlnYXRpb24oaXNSVEwgPyAtMSA6IDEsIDApO1xuICAgICAgICAgICAgICAgIGJyZWFrO1xuICAgICAgICAgICAgY2FzZSBLZXlzLkFycm93TGVmdDpcbiAgICAgICAgICAgICAgICB0aGlzLmhhbmRsZUNlbGxOYXZpZ2F0aW9uKGlzUlRMID8gMSA6IC0xLCAwKTtcbiAgICAgICAgICAgICAgICBicmVhaztcbiAgICAgICAgICAgIGNhc2UgS2V5cy5FbnRlcjpcbiAgICAgICAgICAgICAgICB0aGlzLmhhbmRsZUVudGVyKCk7XG4gICAgICAgICAgICAgICAgYnJlYWs7XG4gICAgICAgICAgICBkZWZhdWx0OiByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgZXZlbnQucHJldmVudERlZmF1bHQoKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIGhhbmRsZUhvc3RCbHVyKCkge1xuICAgICAgICB0aGlzLm5vdGlmeU5nVG91Y2hlZCgpO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgaGFuZGxlQ2VsbFNlbGVjdGlvbih2YWx1ZSwgZm9jdXNlZENlbGwpIHtcbiAgICAgICAgaWYgKHRoaXMucmVhZG9ubHkpIHtcbiAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgfVxuICAgICAgICB0aGlzLmZvY3VzZWRDZWxsID0gZm9jdXNlZENlbGw7XG4gICAgICAgIGNvbnN0IHBhcnNlZENvbG9yID0gcGFyc2VDb2xvciQxKHZhbHVlLCB0aGlzLmZvcm1hdCwgZmFsc2UpO1xuICAgICAgICB0aGlzLmNlbGxTZWxlY3Rpb24uZW1pdChwYXJzZWRDb2xvcik7XG4gICAgICAgIGlmICh0aGlzLnZhbHVlICE9PSBwYXJzZWRDb2xvcikge1xuICAgICAgICAgICAgdGhpcy52YWx1ZSA9IHBhcnNlZENvbG9yO1xuICAgICAgICAgICAgdGhpcy52YWx1ZUNoYW5nZS5lbWl0KHBhcnNlZENvbG9yKTtcbiAgICAgICAgICAgIHRoaXMubm90aWZ5TmdDaGFuZ2VkKHBhcnNlZENvbG9yKTtcbiAgICAgICAgfVxuICAgICAgICBpZiAodGhpcy5zZWxlY3Rpb24gIT09IHBhcnNlZENvbG9yKSB7XG4gICAgICAgICAgICB0aGlzLnNlbGVjdGlvbiA9IHBhcnNlZENvbG9yO1xuICAgICAgICAgICAgdGhpcy5zZWxlY3Rpb25DaGFuZ2UuZW1pdChwYXJzZWRDb2xvcik7XG4gICAgICAgIH1cbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHdyaXRlVmFsdWUodmFsdWUpIHtcbiAgICAgICAgdGhpcy52YWx1ZSA9IHZhbHVlO1xuICAgICAgICB0aGlzLmZvY3VzZWRDZWxsID0gdGhpcy5zZXJ2aWNlLmdldENlbGxDb29yZHNGb3IodGhpcy52YWx1ZSk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICByZWdpc3Rlck9uQ2hhbmdlKGZuKSB7XG4gICAgICAgIHRoaXMubm90aWZ5TmdDaGFuZ2VkID0gZm47XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICByZWdpc3Rlck9uVG91Y2hlZChmbikge1xuICAgICAgICB0aGlzLm5vdGlmeU5nVG91Y2hlZCA9IGZuO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgc2V0RGlzYWJsZWRTdGF0ZShpc0Rpc2FibGVkKSB7XG4gICAgICAgIHRoaXMuZGlzYWJsZWQgPSBpc0Rpc2FibGVkO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICogVXNlZCBieSB0aGUgVGV4dEJveENvbnRhaW5lciB0byBkZXRlcm1pbmUgaWYgdGhlIGNvbXBvbmVudCBpcyBlbXB0eS5cbiAgICAgKi9cbiAgICBpc0VtcHR5KCkge1xuICAgICAgICByZXR1cm4gZmFsc2U7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIENsZWFycyB0aGUgY29sb3IgdmFsdWUgb2YgdGhlIENvbG9yUGFsZXR0ZS5cbiAgICAgKi9cbiAgICByZXNldCgpIHtcbiAgICAgICAgdGhpcy5mb2N1c2VkQ2VsbCA9IG51bGw7XG4gICAgICAgIGlmIChpc1ByZXNlbnQodGhpcy52YWx1ZSkpIHtcbiAgICAgICAgICAgIHRoaXMuX3ZhbHVlID0gdW5kZWZpbmVkO1xuICAgICAgICAgICAgdGhpcy5ub3RpZnlOZ0NoYW5nZWQodW5kZWZpbmVkKTtcbiAgICAgICAgfVxuICAgIH1cbiAgICBzZXRSb3dzKCkge1xuICAgICAgICBpZiAoIWlzUHJlc2VudCh0aGlzLnBhbGV0dGUpKSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5jb2x1bW5zID0gdGhpcy5jb2x1bW5zIHx8IERFRkFVTFRfQ09MVU1OU19DT1VOVDtcbiAgICAgICAgdGhpcy5zZXJ2aWNlLnNldENvbG9yTWF0cml4KHRoaXMucGFsZXR0ZSwgdGhpcy5jb2x1bW5zKTtcbiAgICB9XG4gICAgaGFuZGxlQ2VsbE5hdmlnYXRpb24oaG9yaXpvbnRhbFN0ZXAsIHZlcnRpY2FsU3RlcCkge1xuICAgICAgICBpZiAodGhpcy5yZWFkb25seSkge1xuICAgICAgICAgICAgcmV0dXJuO1xuICAgICAgICB9XG4gICAgICAgIHRoaXMuZm9jdXNlZENlbGwgPSB0aGlzLnNlcnZpY2UuZ2V0TmV4dENlbGwodGhpcy5mb2N1c2VkQ2VsbCwgaG9yaXpvbnRhbFN0ZXAsIHZlcnRpY2FsU3RlcCk7XG4gICAgICAgIGNvbnN0IHNlbGVjdGlvbiA9IHRoaXMuc2VydmljZS5nZXRDb2xvckF0KHRoaXMuZm9jdXNlZENlbGwpO1xuICAgICAgICBpZiAodGhpcy5zZWxlY3Rpb24gIT09IHNlbGVjdGlvbikge1xuICAgICAgICAgICAgdGhpcy5zZWxlY3Rpb24gPSBzZWxlY3Rpb247XG4gICAgICAgICAgICB0aGlzLnNlbGVjdGlvbkNoYW5nZS5lbWl0KHNlbGVjdGlvbik7XG4gICAgICAgIH1cbiAgICB9XG4gICAgaGFuZGxlRW50ZXIoKSB7XG4gICAgICAgIGlmICghaXNQcmVzZW50KHRoaXMuZm9jdXNlZENlbGwpKSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgY29uc3Qgc2VsZWN0ZWRDb2xvciA9IHRoaXMuc2VydmljZS5nZXRDb2xvckF0KHRoaXMuZm9jdXNlZENlbGwpO1xuICAgICAgICB0aGlzLmhhbmRsZUNlbGxTZWxlY3Rpb24oc2VsZWN0ZWRDb2xvciwgdGhpcy5mb2N1c2VkQ2VsbCk7XG4gICAgfVxufVxuQ29sb3JQYWxldHRlQ29tcG9uZW50LmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBDb21wb25lbnQsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgc2VsZWN0b3I6ICdrZW5kby1jb2xvcnBhbGV0dGUnLFxuICAgICAgICAgICAgICAgIHByb3ZpZGVyczogW1xuICAgICAgICAgICAgICAgICAgICB7XG4gICAgICAgICAgICAgICAgICAgICAgICBtdWx0aTogdHJ1ZSxcbiAgICAgICAgICAgICAgICAgICAgICAgIHByb3ZpZGU6IE5HX1ZBTFVFX0FDQ0VTU09SLFxuICAgICAgICAgICAgICAgICAgICAgICAgdXNlRXhpc3Rpbmc6IGZvcndhcmRSZWYoKCkgPT4gQ29sb3JQYWxldHRlQ29tcG9uZW50KSAvLyB0c2xpbnQ6ZGlzYWJsZS1saW5lOm5vLWZvcndhcmQtcmVmXG4gICAgICAgICAgICAgICAgICAgIH0sIHtcbiAgICAgICAgICAgICAgICAgICAgICAgIHByb3ZpZGU6IEtlbmRvSW5wdXQsXG4gICAgICAgICAgICAgICAgICAgICAgICB1c2VFeGlzdGluZzogZm9yd2FyZFJlZigoKSA9PiBDb2xvclBhbGV0dGVDb21wb25lbnQpXG4gICAgICAgICAgICAgICAgICAgIH0sXG4gICAgICAgICAgICAgICAgICAgIENvbG9yUGFsZXR0ZVNlcnZpY2UsXG4gICAgICAgICAgICAgICAgICAgIExvY2FsaXphdGlvblNlcnZpY2UsXG4gICAgICAgICAgICAgICAgICAgIHtcbiAgICAgICAgICAgICAgICAgICAgICAgIHByb3ZpZGU6IEwxME5fUFJFRklYLFxuICAgICAgICAgICAgICAgICAgICAgICAgdXNlVmFsdWU6ICdrZW5kby5jb2xvcnBhbGV0dGUnXG4gICAgICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICBdLFxuICAgICAgICAgICAgICAgIHRlbXBsYXRlOiBgXG4gICAgICAgIDxkaXYgcm9sZT1cImdyaWRcIj5cbiAgICAgICAgICAgIDx0YWJsZSBjbGFzcz1cImstcGFsZXR0ZSBrLXJlc2V0XCIgcm9sZT1cInByZXNlbnRhdGlvblwiPlxuICAgICAgICAgICAgICAgIDx0Ym9keT5cbiAgICAgICAgICAgICAgICAgICAgPHRyIHJvbGU9XCJyb3dcIiAqbmdGb3I9XCJsZXQgcm93IG9mIGNvbG9yUm93czsgbGV0IHJvd0luZGV4ID0gaW5kZXhcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgIDx0ZCAqbmdGb3I9XCJsZXQgY29sb3Igb2Ygcm93OyBsZXQgY29sSW5kZXggPSBpbmRleFwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgW2NsYXNzLmstc3RhdGUtc2VsZWN0ZWRdPVwiZm9jdXNlZENlbGw/LnJvdyA9PT0gcm93SW5kZXggJiYgZm9jdXNlZENlbGw/LmNvbCA9PT0gY29sSW5kZXhcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIGNsYXNzPVwiay1pdGVtXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICBbYXR0ci52YWx1ZV09XCJjb2xvclwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgKGNsaWNrKT1cImhhbmRsZUNlbGxTZWxlY3Rpb24oY29sb3IsIHsgcm93OiByb3dJbmRleCwgY29sOiBjb2xJbmRleCB9KVwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgW25nU3R5bGVdPVwie1xuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IGNvbG9yLFxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICB3aWR0aDogdGlsZUxheW91dC53aWR0aCArICdweCcsXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGhlaWdodDogdGlsZUxheW91dC5oZWlnaHQgKyAncHgnLFxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBtaW5XaWR0aDogdGlsZUxheW91dC53aWR0aCArICdweCdcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICB9XCI+XG4gICAgICAgICAgICAgICAgICAgICAgICA8L3RkPlxuICAgICAgICAgICAgICAgICAgICA8L3RyPlxuICAgICAgICAgICAgICAgIDwvdGJvZHk+XG4gICAgICAgICAgICA8L3RhYmxlPlxuICAgICAgICA8L2Rpdj5cbiAgICBgXG4gICAgICAgICAgICB9LF0gfSxcbl07XG4vKiogQG5vY29sbGFwc2UgKi9cbkNvbG9yUGFsZXR0ZUNvbXBvbmVudC5jdG9yUGFyYW1ldGVycyA9ICgpID0+IFtcbiAgICB7IHR5cGU6IENvbG9yUGFsZXR0ZVNlcnZpY2UgfSxcbiAgICB7IHR5cGU6IExvY2FsaXphdGlvblNlcnZpY2UgfVxuXTtcbkNvbG9yUGFsZXR0ZUNvbXBvbmVudC5wcm9wRGVjb3JhdG9ycyA9IHtcbiAgICBkaXJlY3Rpb246IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2F0dHIuZGlyJyxdIH1dLFxuICAgIHBhbGV0dGVJZDogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnYXR0ci5pZCcsXSB9XSxcbiAgICBpZDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgZm9ybWF0OiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICB2YWx1ZTogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgY29sdW1uczogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgcGFsZXR0ZTogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgdGFiaW5kZXg6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIGRpc2FibGVkOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICByZWFkb25seTogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgdGlsZVNpemU6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHNlbGVjdGlvbkNoYW5nZTogW3sgdHlwZTogT3V0cHV0IH1dLFxuICAgIHZhbHVlQ2hhbmdlOiBbeyB0eXBlOiBPdXRwdXQgfV0sXG4gICAgY2VsbFNlbGVjdGlvbjogW3sgdHlwZTogT3V0cHV0IH1dLFxuICAgIGhvc3RUYWJpbmRleDogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnYXR0ci50YWJpbmRleCcsXSB9XSxcbiAgICBob3N0Q2xhc3NlczogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnY2xhc3Muay13aWRnZXQnLF0gfSwgeyB0eXBlOiBIb3N0QmluZGluZywgYXJnczogWydjbGFzcy5rLWNvbG9ycGFsZXR0ZScsXSB9XSxcbiAgICBkaXNhYmxlZENsYXNzOiBbeyB0eXBlOiBIb3N0QmluZGluZywgYXJnczogWydjbGFzcy5rLXN0YXRlLWRpc2FibGVkJyxdIH1dLFxuICAgIGhhbmRsZUtleWRvd246IFt7IHR5cGU6IEhvc3RMaXN0ZW5lciwgYXJnczogWydrZXlkb3duJywgWyckZXZlbnQnXSxdIH1dLFxuICAgIGhhbmRsZUhvc3RCbHVyOiBbeyB0eXBlOiBIb3N0TGlzdGVuZXIsIGFyZ3M6IFsnYmx1cicsXSB9XVxufTtcblxuY29uc3QgREVGQVVMVF9PVVRQVVRfRk9STUFUID0gJ3JnYmEnO1xuY29uc3QgREVGQVVMVF9CQUNLR1JPVU5EX0NPTE9SID0gJ3JnYmEoMjU1LCAwLCAwLCAxKSc7XG5sZXQgc2VyaWFsJDIgPSAwO1xuLyoqXG4gKiBUaGUgQ29sb3JHcmFkaWVudCBjb21wb25lbnQgZW5hYmxlcyBzbW9vdGggY29sb3IgdHJhbnNpdGlvbnMgYW5kIHByb3ZpZGVzIG9wdGlvbnMgZm9yIHNlbGVjdGluZyBzcGVjaWZpYyBjb2xvcnMgb3ZlciB0aGUgZHJhZyBoYW5kbGUuXG4gKiBUaGUgQ29sb3JHcmFkaWVudCBpcyBpbmRlcGVuZGVudGx5IHVzZWQgYnkgYGtlbmRvLWNvbG9ycGlja2VyYCBhbmQgY2FuIGJlIGRpcmVjdGx5IGFkZGVkIHRvIHRoZSBwYWdlLlxuICovXG5jbGFzcyBDb2xvckdyYWRpZW50Q29tcG9uZW50IHtcbiAgICBjb25zdHJ1Y3Rvcihob3N0LCBuZ1pvbmUsIHJlbmRlcmVyLCBjZHIsIGxvY2FsaXphdGlvblNlcnZpY2UpIHtcbiAgICAgICAgdGhpcy5ob3N0ID0gaG9zdDtcbiAgICAgICAgdGhpcy5uZ1pvbmUgPSBuZ1pvbmU7XG4gICAgICAgIHRoaXMucmVuZGVyZXIgPSByZW5kZXJlcjtcbiAgICAgICAgdGhpcy5jZHIgPSBjZHI7XG4gICAgICAgIHRoaXMuaG9zdENsYXNzZXMgPSB0cnVlO1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5pZCA9IGBrLWNvbG9yZ3JhZGllbnQtJHtzZXJpYWwkMisrfWA7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBEZWZpbmVzIHdoZXRoZXIgdGhlIGFscGhhIHNsaWRlciB3aWxsIGJlIGRpc3BsYXllZC5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMub3BhY2l0eSA9IHRydWU7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBTZXRzIHRoZSBkaXNhYmxlZCBzdGF0ZSBvZiB0aGUgQ29sb3JHcmFkaWVudC5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuZGlzYWJsZWQgPSBmYWxzZTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIFNldHMgdGhlIHJlYWQtb25seSBzdGF0ZSBvZiB0aGUgQ29sb3JHcmFkaWVudC5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMucmVhZG9ubHkgPSBmYWxzZTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIFNwZWNpZmllcyB3aGV0aGVyIHRoZSBDb2xvckdyYWRpZW50IHNob3VsZCBkaXNwbGF5IGEgJ0NsZWFyIGNvbG9yJyBidXR0b24uXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmNsZWFyQnV0dG9uID0gZmFsc2U7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBGaXJlcyBlYWNoIHRpbWUgdGhlIHVzZXIgc2VsZWN0cyBhIG5ldyBjb2xvci5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMudmFsdWVDaGFuZ2UgPSBuZXcgRXZlbnRFbWl0dGVyKCk7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmJhY2tncm91bmRDb2xvciA9IERFRkFVTFRfQkFDS0dST1VORF9DT0xPUjtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBoaWRkZW5cbiAgICAgICAgICpcbiAgICAgICAgICogUmVwcmVzZW50cyB0aGUgY3VycmVudGx5IHNlbGVjdGVkIGBodWVgLCBgc2F0dXJhdGlvbmAsIGB2YWx1ZWAsIGFuZCBgYWxwaGFgIHZhbHVlcy5cbiAgICAgICAgICogVGhlIHZhbHVlcyBhcmUgaW5pdGlhbGx5IHNldCBpbiBgbmdPbkluaXRgIG9yIGluIGBuZ09uQ2hhbmdlc2AgYW5kIGFyZVxuICAgICAgICAgKiB1cGRhdGVkIG9uIG1vdmluZyB0aGUgZHJhZyBoYW5kbGUgb3IgdGhlIHNsaWRlcnMuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmhzdmEgPSB7fTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIFNwZWNpZmllcyB0aGUgb3V0cHV0IGZvcm1hdCBvZiB0aGUgQ29sb3JHcmFkaWVudENvbXBvbmVudC5cbiAgICAgICAgICogVGhlIGlucHV0IHZhbHVlIG1heSBiZSBpbiBhIGRpZmZlcmVudCBmb3JtYXQuIEhvd2V2ZXIsIGl0IHdpbGwgYmUgcGFyc2VkIGludG8gdGhlIG91dHB1dCBgZm9ybWF0YFxuICAgICAgICAgKiBhZnRlciB0aGUgY29tcG9uZW50IHByb2Nlc3NlcyBpdC5cbiAgICAgICAgICpcbiAgICAgICAgICogVGhlIHN1cHBvcnRlZCB2YWx1ZXMgYXJlOlxuICAgICAgICAgKiAqIChEZWZhdWx0KSBgcmdiYWBcbiAgICAgICAgICogKiBgaGV4YFxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5mb3JtYXQgPSBERUZBVUxUX09VVFBVVF9GT1JNQVQ7XG4gICAgICAgIHRoaXMuX3RhYmluZGV4ID0gMDtcbiAgICAgICAgdGhpcy5saXN0ZW5lcnMgPSBbXTtcbiAgICAgICAgdGhpcy5ub3RpZnlOZ0NoYW5nZWQgPSAoKSA9PiB7IH07XG4gICAgICAgIHRoaXMubm90aWZ5TmdUb3VjaGVkID0gKCkgPT4geyB9O1xuICAgICAgICB0aGlzLmR5bmFtaWNSVExTdWJzY3JpcHRpb24gPSBsb2NhbGl6YXRpb25TZXJ2aWNlLmNoYW5nZXMuc3Vic2NyaWJlKCh7IHJ0bCB9KSA9PiB7XG4gICAgICAgICAgICB0aGlzLmRpcmVjdGlvbiA9IHJ0bCA/ICdydGwnIDogJ2x0cic7XG4gICAgICAgIH0pO1xuICAgIH1cbiAgICBnZXQgZGlzYWJsZWRDbGFzcygpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuZGlzYWJsZWQ7XG4gICAgfVxuICAgIGdldCBob3N0VGFiaW5kZXgoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLnRhYmluZGV4O1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgZ2V0IGdyYWRpZW50SWQoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmlkO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBTcGVjaWZpZXMgdGhlIHZhbHVlIG9mIHRoZSBpbml0aWFsbHkgc2VsZWN0ZWQgY29sb3IuXG4gICAgICovXG4gICAgc2V0IHZhbHVlKHZhbHVlKSB7XG4gICAgICAgIHRoaXMuX3ZhbHVlID0gcGFyc2VDb2xvciQxKHZhbHVlLCB0aGlzLmZvcm1hdCk7XG4gICAgfVxuICAgIGdldCB2YWx1ZSgpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuX3ZhbHVlO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBTcGVjaWZpZXMgdGhlIFtgdGFiaW5kZXhgXShodHRwczovL2RldmVsb3Blci5tb3ppbGxhLm9yZy9lbi1VUy9kb2NzL1dlYi9IVE1ML0dsb2JhbF9hdHRyaWJ1dGVzL3RhYmluZGV4KSBvZiB0aGUgY29tcG9uZW50LlxuICAgICAqL1xuICAgIHNldCB0YWJpbmRleCh2YWx1ZSkge1xuICAgICAgICBjb25zdCB0YWJpbmRleCA9IE51bWJlcih2YWx1ZSk7XG4gICAgICAgIGNvbnN0IGRlZmF1bHRWYWx1ZSA9IDA7XG4gICAgICAgIHRoaXMuX3RhYmluZGV4ID0gIWlzTmFOKHRhYmluZGV4KSA/IHRhYmluZGV4IDogZGVmYXVsdFZhbHVlO1xuICAgIH1cbiAgICBnZXQgdGFiaW5kZXgoKSB7XG4gICAgICAgIHJldHVybiAhdGhpcy5kaXNhYmxlZCA/IHRoaXMuX3RhYmluZGV4IDogdW5kZWZpbmVkO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBJbmRpY2F0ZXMgd2hldGhlciB0aGUgQ29sb3JHcmFkaWVudCBvciBhbnkgb2YgaXRzIGNvbnRlbnQgaXMgZm9jdXNlZC5cbiAgICAgKi9cbiAgICBnZXQgaXNGb2N1c2VkKCkge1xuICAgICAgICBpZiAoIShpc0RvY3VtZW50QXZhaWxhYmxlKCkgJiYgaXNQcmVzZW50KHRoaXMuaG9zdCkpKSB7XG4gICAgICAgICAgICByZXR1cm4gZmFsc2U7XG4gICAgICAgIH1cbiAgICAgICAgcmV0dXJuIHRoaXMuaG9zdC5uYXRpdmVFbGVtZW50ID09PSBkb2N1bWVudC5hY3RpdmVFbGVtZW50IHx8IHRoaXMuaG9zdC5uYXRpdmVFbGVtZW50LmNvbnRhaW5zKGRvY3VtZW50LmFjdGl2ZUVsZW1lbnQpO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgZ2V0IGFscGhhU2xpZGVyVmFsdWUoKSB7XG4gICAgICAgIC8vIHNldHRpbmcgdGhlIGluaXRpYWwgdmFsdWUgdG8gdW5kZWZpbmVkIHRvIGZvcmNlIHRoZSBzbGlkZXIgdG8gcmVjYWxjdWxhdGUgdGhlIGhlaWdodCBvZiB0aGUgc2xpZGVyIHRyYWNrIG9uIHRoZSBuZXh0IGNkciBydW5cbiAgICAgICAgaWYgKCEoaXNQcmVzZW50KHRoaXMuaHN2YSkgJiYgaXNQcmVzZW50KHRoaXMuaHN2YS5hKSkpIHtcbiAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgfVxuICAgICAgICByZXR1cm4gdGhpcy5oc3ZhLmEgKiAxMDA7XG4gICAgfVxuICAgIGdldCBncmFkaWVudFJlY3QoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmdyYWRpZW50V3JhcHBlci5uYXRpdmVFbGVtZW50LmdldEJvdW5kaW5nQ2xpZW50UmVjdCgpO1xuICAgIH1cbiAgICBuZ0FmdGVyVmlld0luaXQoKSB7XG4gICAgICAgIHRoaXMudXBkYXRlVUkoKTtcbiAgICAgICAgdGhpcy5jZHIuZGV0ZWN0Q2hhbmdlcygpO1xuICAgICAgICB0aGlzLmFkZEV2ZW50TGlzdGVuZXJzKCk7XG4gICAgfVxuICAgIG5nT25DaGFuZ2VzKGNoYW5nZXMpIHtcbiAgICAgICAgaWYgKGlzQ2hhbmdlZCgndmFsdWUnLCBjaGFuZ2VzKSAmJiAhdGhpcy5pc0ZvY3VzZWQpIHtcbiAgICAgICAgICAgIHRoaXMudXBkYXRlVUkoKTtcbiAgICAgICAgfVxuICAgIH1cbiAgICBuZ09uRGVzdHJveSgpIHtcbiAgICAgICAgdGhpcy5saXN0ZW5lcnMuZm9yRWFjaChyZW1vdmVMaXN0ZW5lciA9PiByZW1vdmVMaXN0ZW5lcigpKTtcbiAgICAgICAgaWYgKHRoaXMuZHluYW1pY1JUTFN1YnNjcmlwdGlvbikge1xuICAgICAgICAgICAgdGhpcy5keW5hbWljUlRMU3Vic2NyaXB0aW9uLnVuc3Vic2NyaWJlKCk7XG4gICAgICAgIH1cbiAgICB9XG4gICAgLyoqXG4gICAgICogRm9jdXNlcyB0aGUgY29tcG9uZW50LlxuICAgICAqL1xuICAgIGZvY3VzKCkge1xuICAgICAgICBpZiAodGhpcy5kaXNhYmxlZCkge1xuICAgICAgICAgICAgcmV0dXJuO1xuICAgICAgICB9XG4gICAgICAgIHRoaXMuaG9zdC5uYXRpdmVFbGVtZW50LmZvY3VzKCk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICByZXNldCgpIHtcbiAgICAgICAgdGhpcy5oYW5kbGVWYWx1ZUNoYW5nZSh1bmRlZmluZWQpO1xuICAgICAgICB0aGlzLnVwZGF0ZVVJKCk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBoYW5kbGVEcmFnUHJlc3MoYXJncykge1xuICAgICAgICBpZiAodGhpcy5kaXNhYmxlZCB8fCB0aGlzLnJlYWRvbmx5IHx8ICFpc1ByZXNlbnQoYXJncy5vcmlnaW5hbEV2ZW50KSkge1xuICAgICAgICAgICAgcmV0dXJuO1xuICAgICAgICB9XG4gICAgICAgIHRoaXMuZm9jdXMoKTtcbiAgICAgICAgYXJncy5vcmlnaW5hbEV2ZW50LnByZXZlbnREZWZhdWx0KCk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBvbkhhbmRsZURyYWcoYXJncykge1xuICAgICAgICBpZiAodGhpcy5kaXNhYmxlZCB8fCB0aGlzLnJlYWRvbmx5KSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5yZW5kZXJlci5hZGRDbGFzcyh0aGlzLmdyYWRpZW50V3JhcHBlci5uYXRpdmVFbGVtZW50LCAnay1kcmFnZ2luZycpO1xuICAgICAgICB0aGlzLmNoYW5nZVBvc2l0aW9uKGFyZ3MpO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgb25IYW5kbGVSZWxlYXNlKCkge1xuICAgICAgICBpZiAodGhpcy5kaXNhYmxlZCB8fCB0aGlzLnJlYWRvbmx5KSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgdGhpcy5yZW5kZXJlci5yZW1vdmVDbGFzcyh0aGlzLmdyYWRpZW50V3JhcHBlci5uYXRpdmVFbGVtZW50LCAnay1kcmFnZ2luZycpO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgY2hhbmdlUG9zaXRpb24ocG9zaXRpb24pIHtcbiAgICAgICAgaWYgKHRoaXMuZGlzYWJsZWQgfHwgdGhpcy5yZWFkb25seSkge1xuICAgICAgICAgICAgcmV0dXJuO1xuICAgICAgICB9XG4gICAgICAgIHRoaXMubmdab25lLnJ1bigoKSA9PiB0aGlzLm1vdmVEcmFnSGFuZGxlKHBvc2l0aW9uKSk7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBoYW5kbGVIdWVTbGlkZXJDaGFuZ2UoaHVlKSB7XG4gICAgICAgIHRoaXMuaGFuZGxlVmFsdWVDaGFuZ2UoZ2V0Q29sb3JGcm9tSFNWKHRoaXMuaHN2YSkpO1xuICAgICAgICB0aGlzLmJhY2tncm91bmRDb2xvciA9IGdldENvbG9yRnJvbUh1ZShodWUpO1xuICAgICAgICB0aGlzLnNldEFscGhhU2xpZGVyQmFja2dyb3VuZCh0aGlzLmJhY2tncm91bmRDb2xvcik7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBoYW5kbGVBbHBoYVNsaWRlckNoYW5nZShhbHBoYSkge1xuICAgICAgICB0aGlzLmhzdmEuYSA9IGFscGhhIC8gMTAwO1xuICAgICAgICB0aGlzLmhhbmRsZVZhbHVlQ2hhbmdlKGdldENvbG9yRnJvbUhTVih0aGlzLmhzdmEpKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIGhhbmRsZUlucHV0c1ZhbHVlQ2hhbmdlKGNvbG9yKSB7XG4gICAgICAgIGNvbnN0IHBhcnNlZCA9IHBhcnNlQ29sb3IkMShjb2xvciwgdGhpcy5mb3JtYXQpO1xuICAgICAgICBpZiAodGhpcy52YWx1ZSAhPT0gcGFyc2VkKSB7XG4gICAgICAgICAgICB0aGlzLmhhbmRsZVZhbHVlQ2hhbmdlKHBhcnNlZCk7XG4gICAgICAgICAgICB0aGlzLnVwZGF0ZVVJKCk7XG4gICAgICAgIH1cbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIHdyaXRlVmFsdWUodmFsdWUpIHtcbiAgICAgICAgdGhpcy52YWx1ZSA9IHZhbHVlO1xuICAgICAgICBpZiAoaXNQcmVzZW50KHRoaXMuZ3JhZGllbnRXcmFwcGVyKSkge1xuICAgICAgICAgICAgdGhpcy51cGRhdGVVSSgpO1xuICAgICAgICB9XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICByZWdpc3Rlck9uQ2hhbmdlKGZuKSB7XG4gICAgICAgIHRoaXMubm90aWZ5TmdDaGFuZ2VkID0gZm47XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICByZWdpc3Rlck9uVG91Y2hlZChmbikge1xuICAgICAgICB0aGlzLm5vdGlmeU5nVG91Y2hlZCA9IGZuO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICovXG4gICAgc2V0RGlzYWJsZWRTdGF0ZShpc0Rpc2FibGVkKSB7XG4gICAgICAgIHRoaXMuZGlzYWJsZWQgPSBpc0Rpc2FibGVkO1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBAaGlkZGVuXG4gICAgICogVXNlZCBieSB0aGUgVGV4dEJveENvbnRhaW5lciB0byBkZXRlcm1pbmUgaWYgdGhlIGNvbXBvbmVudCBpcyBlbXB0eS5cbiAgICAgKi9cbiAgICBpc0VtcHR5KCkge1xuICAgICAgICByZXR1cm4gZmFsc2U7XG4gICAgfVxuICAgIG1vdmVEcmFnSGFuZGxlKHBvc2l0aW9uKSB7XG4gICAgICAgIGNvbnN0IGRlbHRhWCA9IHBvc2l0aW9uLmNsaWVudFggLSB0aGlzLmdyYWRpZW50UmVjdC5sZWZ0O1xuICAgICAgICBjb25zdCBkZWx0YVkgPSBwb3NpdGlvbi5jbGllbnRZIC0gdGhpcy5ncmFkaWVudFJlY3QudG9wO1xuICAgICAgICBjb25zdCB0b3AgPSBmaXRJbnRvQm91bmRzKGRlbHRhWSwgMCwgdGhpcy5ncmFkaWVudFJlY3QuaGVpZ2h0KTtcbiAgICAgICAgY29uc3QgbGVmdCA9IGZpdEludG9Cb3VuZHMoZGVsdGFYLCAwLCB0aGlzLmdyYWRpZW50UmVjdC53aWR0aCk7XG4gICAgICAgIHRoaXMuc2V0RHJhZ0hhbmRsZUVsZW1lbnRQb3NpdGlvbih0b3AsIGxlZnQpO1xuICAgICAgICB0aGlzLmhzdmEucyA9IGxlZnQgLyB0aGlzLmdyYWRpZW50UmVjdC53aWR0aDtcbiAgICAgICAgdGhpcy5oc3ZhLnYgPSAxIC0gdG9wIC8gdGhpcy5ncmFkaWVudFJlY3QuaGVpZ2h0O1xuICAgICAgICB0aGlzLmhhbmRsZVZhbHVlQ2hhbmdlKGdldENvbG9yRnJvbUhTVih0aGlzLmhzdmEpKTtcbiAgICAgICAgdGhpcy5zZXRBbHBoYVNsaWRlckJhY2tncm91bmQoZ2V0Q29sb3JGcm9tSFNWKE9iamVjdC5hc3NpZ24oe30sIHRoaXMuaHN2YSwgeyBhOiAxIH0pKSk7XG4gICAgfVxuICAgIHVwZGF0ZVVJKCkge1xuICAgICAgICBpZiAoIWlzRG9jdW1lbnRBdmFpbGFibGUoKSkge1xuICAgICAgICAgICAgcmV0dXJuO1xuICAgICAgICB9XG4gICAgICAgIHRoaXMuaHN2YSA9IHRoaXMudmFsdWUgPyBnZXRIU1YodGhpcy52YWx1ZSkgOiB7IGg6IDAsIHM6IDAsIHY6IDEsIGE6IDEgfTtcbiAgICAgICAgY29uc3QgdG9wID0gKDEgLSB0aGlzLmhzdmEudikgKiB0aGlzLmdyYWRpZW50UmVjdC5oZWlnaHQ7XG4gICAgICAgIGNvbnN0IGxlZnQgPSB0aGlzLmhzdmEucyAqIHRoaXMuZ3JhZGllbnRSZWN0LndpZHRoO1xuICAgICAgICB0aGlzLnNldERyYWdIYW5kbGVFbGVtZW50UG9zaXRpb24odG9wLCBsZWZ0KTtcbiAgICAgICAgdGhpcy5iYWNrZ3JvdW5kQ29sb3IgPSBnZXRDb2xvckZyb21IdWUodGhpcy5oc3ZhLmgpO1xuICAgICAgICB0aGlzLnNldEFscGhhU2xpZGVyQmFja2dyb3VuZCh0aGlzLmJhY2tncm91bmRDb2xvcik7XG4gICAgfVxuICAgIGhhbmRsZVZhbHVlQ2hhbmdlKGNvbG9yKSB7XG4gICAgICAgIGlmICh0aGlzLnZhbHVlID09PSBjb2xvcikge1xuICAgICAgICAgICAgcmV0dXJuO1xuICAgICAgICB9XG4gICAgICAgIHRoaXMudmFsdWUgPSBjb2xvcjtcbiAgICAgICAgdGhpcy52YWx1ZUNoYW5nZS5lbWl0KGNvbG9yKTtcbiAgICAgICAgdGhpcy5ub3RpZnlOZ0NoYW5nZWQoY29sb3IpO1xuICAgIH1cbiAgICBzZXREcmFnSGFuZGxlRWxlbWVudFBvc2l0aW9uKHRvcCwgbGVmdCkge1xuICAgICAgICBjb25zdCBkcmFnSGFuZGxlID0gdGhpcy5kcmFnSGFuZGxlLm5hdGl2ZUVsZW1lbnQ7XG4gICAgICAgIHRoaXMucmVuZGVyZXIuc2V0U3R5bGUoZHJhZ0hhbmRsZSwgJ3RvcCcsIGAke3RvcH1weGApO1xuICAgICAgICB0aGlzLnJlbmRlcmVyLnNldFN0eWxlKGRyYWdIYW5kbGUsICdsZWZ0JywgYCR7bGVmdH1weGApO1xuICAgIH1cbiAgICBzZXRBbHBoYVNsaWRlckJhY2tncm91bmQoYmFja2dyb3VuZENvbG9yKSB7XG4gICAgICAgIGlmICghaXNQcmVzZW50KHRoaXMuYWxwaGFTbGlkZXIpKSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgY29uc3Qgc2xpZGVyVHJhY2sgPSB0aGlzLmFscGhhU2xpZGVyLnRyYWNrLm5hdGl2ZUVsZW1lbnQ7XG4gICAgICAgIHRoaXMucmVuZGVyZXIuc2V0U3R5bGUoc2xpZGVyVHJhY2ssICdiYWNrZ3JvdW5kJywgYGxpbmVhci1ncmFkaWVudCh0byB0b3AsIHRyYW5zcGFyZW50LCAke2JhY2tncm91bmRDb2xvcn0pYCk7XG4gICAgfVxuICAgIGFkZEV2ZW50TGlzdGVuZXJzKCkge1xuICAgICAgICB0aGlzLm5nWm9uZS5ydW5PdXRzaWRlQW5ndWxhcigoKSA9PiB7XG4gICAgICAgICAgICBjb25zdCBmb2N1c091dExpc3RlbmVyID0gdGhpcy5yZW5kZXJlci5saXN0ZW4odGhpcy5ob3N0Lm5hdGl2ZUVsZW1lbnQsICdmb2N1c291dCcsIChldmVudCkgPT4ge1xuICAgICAgICAgICAgICAgIGlmICghY29udGFpbnNGb2N1cyh0aGlzLmhvc3QubmF0aXZlRWxlbWVudCwgZXZlbnQucmVsYXRlZFRhcmdldCkgJiYgaXNVbnRvdWNoZWQodGhpcy5ob3N0KSkge1xuICAgICAgICAgICAgICAgICAgICB0aGlzLm5nWm9uZS5ydW4oKCkgPT4gdGhpcy5ub3RpZnlOZ1RvdWNoZWQoKSk7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfSk7XG4gICAgICAgICAgICB0aGlzLmxpc3RlbmVycy5wdXNoKGZvY3VzT3V0TGlzdGVuZXIpO1xuICAgICAgICB9KTtcbiAgICB9XG59XG5Db2xvckdyYWRpZW50Q29tcG9uZW50LmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBDb21wb25lbnQsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgc2VsZWN0b3I6ICdrZW5kby1jb2xvcmdyYWRpZW50JyxcbiAgICAgICAgICAgICAgICBwcm92aWRlcnM6IFt7XG4gICAgICAgICAgICAgICAgICAgICAgICBtdWx0aTogdHJ1ZSxcbiAgICAgICAgICAgICAgICAgICAgICAgIHByb3ZpZGU6IE5HX1ZBTFVFX0FDQ0VTU09SLFxuICAgICAgICAgICAgICAgICAgICAgICAgdXNlRXhpc3Rpbmc6IGZvcndhcmRSZWYoKCkgPT4gQ29sb3JHcmFkaWVudENvbXBvbmVudClcbiAgICAgICAgICAgICAgICAgICAgfSwge1xuICAgICAgICAgICAgICAgICAgICAgICAgcHJvdmlkZTogS2VuZG9JbnB1dCxcbiAgICAgICAgICAgICAgICAgICAgICAgIHVzZUV4aXN0aW5nOiBmb3J3YXJkUmVmKCgpID0+IENvbG9yR3JhZGllbnRDb21wb25lbnQpXG4gICAgICAgICAgICAgICAgICAgIH0sXG4gICAgICAgICAgICAgICAgICAgIExvY2FsaXphdGlvblNlcnZpY2UsXG4gICAgICAgICAgICAgICAgICAgIHtcbiAgICAgICAgICAgICAgICAgICAgICAgIHByb3ZpZGU6IEwxME5fUFJFRklYLFxuICAgICAgICAgICAgICAgICAgICAgICAgdXNlVmFsdWU6ICdrZW5kby5jb2xvcmdyYWRpZW50J1xuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgXSxcbiAgICAgICAgICAgICAgICB0ZW1wbGF0ZTogYFxuICAgICAgICA8ZGl2IGNsYXNzPVwiay1oYm94IGstaHN2LXdyYXBcIj5cbiAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJrLWhzdi1yZWN0YW5nbGVcIiBbc3R5bGUuYmFja2dyb3VuZC1jb2xvcl09XCJiYWNrZ3JvdW5kQ29sb3JcIj5cbiAgICAgICAgICAgICAgICA8ZGl2XG4gICAgICAgICAgICAgICAgICAgICNncmFkaWVudFdyYXBwZXJcbiAgICAgICAgICAgICAgICAgICAga2VuZG9EcmFnZ2FibGVcbiAgICAgICAgICAgICAgICAgICAgY2xhc3M9XCJrLWhzdi1ncmFkaWVudFwiXG4gICAgICAgICAgICAgICAgICAgIChjbGljayk9XCJjaGFuZ2VQb3NpdGlvbigkZXZlbnQpXCJcbiAgICAgICAgICAgICAgICAgICAgKGtlbmRvUHJlc3MpPVwiaGFuZGxlRHJhZ1ByZXNzKCRldmVudClcIlxuICAgICAgICAgICAgICAgICAgICAoa2VuZG9EcmFnKT1cIm9uSGFuZGxlRHJhZygkZXZlbnQpXCJcbiAgICAgICAgICAgICAgICAgICAgKGtlbmRvUmVsZWFzZSk9XCJvbkhhbmRsZVJlbGVhc2UoKVwiPlxuICAgICAgICAgICAgICAgICAgICA8ZGl2XG4gICAgICAgICAgICAgICAgICAgICAgICAjZHJhZ0hhbmRsZVxuICAgICAgICAgICAgICAgICAgICAgICAgY2xhc3M9XCJrLWRyYWdoYW5kbGVcIlxuICAgICAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICA8ZGl2IGNsYXNzPVwiay1oYm94IGstc2xpZGVycy13cmFwIHt7IGNsZWFyQnV0dG9uID8gJ2stc2xpZGVycy13cmFwLWNsZWFyYWJsZScgOiAnJyB9fVwiPlxuICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwiay1jbGVhci1jb2xvciBrLWJ1dHRvbiBrLWJhcmUgay1idXR0b24taWNvblwiICpuZ0lmPVwiY2xlYXJCdXR0b25cIiAoY2xpY2spPVwicmVzZXQoKVwiPlxuICAgICAgICAgICAgICAgICAgICA8c3BhbiBjbGFzcz1cImstaWNvbiBrLWktcmVzZXQtY29sb3JcIj48L3NwYW4+XG4gICAgICAgICAgICAgICAgPC9zcGFuPlxuICAgICAgICAgICAgICAgIDxrZW5kby1zbGlkZXJcbiAgICAgICAgICAgICAgICAgICAgY2xhc3M9XCJrLWh1ZS1zbGlkZXJcIlxuICAgICAgICAgICAgICAgICAgICBbZGlzYWJsZWRdPVwiZGlzYWJsZWRcIlxuICAgICAgICAgICAgICAgICAgICBbcmVhZG9ubHldPVwicmVhZG9ubHlcIlxuICAgICAgICAgICAgICAgICAgICBbc2hvd0J1dHRvbnNdPVwiZmFsc2VcIlxuICAgICAgICAgICAgICAgICAgICBbdGlja1BsYWNlbWVudF09XCInbm9uZSdcIlxuICAgICAgICAgICAgICAgICAgICBbdmVydGljYWxdPVwidHJ1ZVwiXG4gICAgICAgICAgICAgICAgICAgIFttaW5dPVwiMFwiXG4gICAgICAgICAgICAgICAgICAgIFttYXhdPVwiMzYwXCJcbiAgICAgICAgICAgICAgICAgICAgW3NtYWxsU3RlcF09XCI1XCJcbiAgICAgICAgICAgICAgICAgICAgW2xhcmdlU3RlcF09XCIxMFwiXG4gICAgICAgICAgICAgICAgICAgIFsodmFsdWUpXT1cImhzdmEuaFwiXG4gICAgICAgICAgICAgICAgICAgICh2YWx1ZUNoYW5nZSk9XCJoYW5kbGVIdWVTbGlkZXJDaGFuZ2UoJGV2ZW50KVwiXG4gICAgICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgIDwva2VuZG8tc2xpZGVyPlxuICAgICAgICAgICAgICAgIDxrZW5kby1zbGlkZXJcbiAgICAgICAgICAgICAgICAgICAgKm5nSWY9XCJvcGFjaXR5ICYmIGZvcm1hdCA9PT0gJ3JnYmEnXCJcbiAgICAgICAgICAgICAgICAgICAgI2FscGhhU2xpZGVyXG4gICAgICAgICAgICAgICAgICAgIGNsYXNzPVwiay1hbHBoYS1zbGlkZXJcIlxuICAgICAgICAgICAgICAgICAgICBbZGlzYWJsZWRdPVwiZGlzYWJsZWRcIlxuICAgICAgICAgICAgICAgICAgICBbcmVhZG9ubHldPVwicmVhZG9ubHlcIlxuICAgICAgICAgICAgICAgICAgICBbc2hvd0J1dHRvbnNdPVwiZmFsc2VcIlxuICAgICAgICAgICAgICAgICAgICBbdGlja1BsYWNlbWVudF09XCInbm9uZSdcIlxuICAgICAgICAgICAgICAgICAgICBbdmVydGljYWxdPVwidHJ1ZVwiXG4gICAgICAgICAgICAgICAgICAgIFttaW5dPVwiMFwiXG4gICAgICAgICAgICAgICAgICAgIFttYXhdPVwiMTAwXCJcbiAgICAgICAgICAgICAgICAgICAgW3NtYWxsU3RlcF09XCIxXCJcbiAgICAgICAgICAgICAgICAgICAgW2xhcmdlU3RlcF09XCIxMFwiXG4gICAgICAgICAgICAgICAgICAgIFt2YWx1ZV09XCJhbHBoYVNsaWRlclZhbHVlXCJcbiAgICAgICAgICAgICAgICAgICAgKHZhbHVlQ2hhbmdlKT1cImhhbmRsZUFscGhhU2xpZGVyQ2hhbmdlKCRldmVudClcIlxuICAgICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICA8L2tlbmRvLXNsaWRlcj5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgPGtlbmRvLWNvbG9yaW5wdXRcbiAgICAgICAgICAgIFtvcGFjaXR5XT1cIm9wYWNpdHlcIlxuICAgICAgICAgICAgW3ZhbHVlXT1cInZhbHVlXCJcbiAgICAgICAgICAgIFtkaXNhYmxlZF09XCJkaXNhYmxlZFwiXG4gICAgICAgICAgICBbcmVhZG9ubHldPVwicmVhZG9ubHlcIlxuICAgICAgICAgICAgKHZhbHVlQ2hhbmdlKT1cImhhbmRsZUlucHV0c1ZhbHVlQ2hhbmdlKCRldmVudClcIlxuICAgICAgICA+XG4gICAgICAgIDwva2VuZG8tY29sb3JpbnB1dD5cbmBcbiAgICAgICAgICAgIH0sXSB9LFxuXTtcbi8qKiBAbm9jb2xsYXBzZSAqL1xuQ29sb3JHcmFkaWVudENvbXBvbmVudC5jdG9yUGFyYW1ldGVycyA9ICgpID0+IFtcbiAgICB7IHR5cGU6IEVsZW1lbnRSZWYgfSxcbiAgICB7IHR5cGU6IE5nWm9uZSB9LFxuICAgIHsgdHlwZTogUmVuZGVyZXIyIH0sXG4gICAgeyB0eXBlOiBDaGFuZ2VEZXRlY3RvclJlZiB9LFxuICAgIHsgdHlwZTogTG9jYWxpemF0aW9uU2VydmljZSB9XG5dO1xuQ29sb3JHcmFkaWVudENvbXBvbmVudC5wcm9wRGVjb3JhdG9ycyA9IHtcbiAgICBob3N0Q2xhc3NlczogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnY2xhc3Muay13aWRnZXQnLF0gfSwgeyB0eXBlOiBIb3N0QmluZGluZywgYXJnczogWydjbGFzcy5rLWZsYXRjb2xvcnBpY2tlcicsXSB9XSxcbiAgICBkaXNhYmxlZENsYXNzOiBbeyB0eXBlOiBIb3N0QmluZGluZywgYXJnczogWydjbGFzcy5rLXN0YXRlLWRpc2FibGVkJyxdIH1dLFxuICAgIGhvc3RUYWJpbmRleDogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnYXR0ci50YWJpbmRleCcsXSB9XSxcbiAgICBncmFkaWVudElkOiBbeyB0eXBlOiBIb3N0QmluZGluZywgYXJnczogWydhdHRyLmlkJyxdIH1dLFxuICAgIGlkOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBkaXJlY3Rpb246IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2F0dHIuZGlyJyxdIH1dLFxuICAgIG9wYWNpdHk6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIGRpc2FibGVkOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICByZWFkb25seTogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgY2xlYXJCdXR0b246IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHZhbHVlOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICB0YWJpbmRleDogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgdmFsdWVDaGFuZ2U6IFt7IHR5cGU6IE91dHB1dCB9XSxcbiAgICBmb3JtYXQ6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIGFscGhhU2xpZGVyOiBbeyB0eXBlOiBWaWV3Q2hpbGQsIGFyZ3M6IFsnYWxwaGFTbGlkZXInLF0gfV0sXG4gICAgZ3JhZGllbnRXcmFwcGVyOiBbeyB0eXBlOiBWaWV3Q2hpbGQsIGFyZ3M6IFsnZ3JhZGllbnRXcmFwcGVyJyxdIH1dLFxuICAgIGRyYWdIYW5kbGU6IFt7IHR5cGU6IFZpZXdDaGlsZCwgYXJnczogWydkcmFnSGFuZGxlJyxdIH1dXG59O1xuXG4vKipcbiAqIEBoaWRkZW5cbiAqL1xuY2xhc3MgQ29sb3JJbnB1dENvbXBvbmVudCB7XG4gICAgY29uc3RydWN0b3IoaG9zdCkge1xuICAgICAgICB0aGlzLmhvc3QgPSBob3N0O1xuICAgICAgICAvKipcbiAgICAgICAgICogU2V0cyB3aGV0aGVyIHRoZSBhbHBoYSBzbGlkZXIgd2lsbCBiZSBzaG93bi5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMub3BhY2l0eSA9IHRydWU7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBTZXRzIHRoZSBkaXNhYmxlZCBzdGF0ZSBvZiB0aGUgQ29sb3JJbnB1dC5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuZGlzYWJsZWQgPSBmYWxzZTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIFNldHMgdGhlIHJlYWQtb25seSBzdGF0ZSBvZiB0aGUgQ29sb3JJbnB1dC5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMucmVhZG9ubHkgPSBmYWxzZTtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEVtaXRzIGEgcGFyc2VkIHJnYmEgc3RyaW5nIGNvbG9yLlxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy52YWx1ZUNoYW5nZSA9IG5ldyBFdmVudEVtaXR0ZXIoKTtcbiAgICAgICAgdGhpcy5jb2xvcklucHV0Q2xhc3MgPSB0cnVlO1xuICAgICAgICAvKipcbiAgICAgICAgICogVGhlIHJnYmEgaW5wdXRzIHZhbHVlcy5cbiAgICAgICAgICovXG4gICAgICAgIHRoaXMucmdiYSA9IHt9O1xuICAgIH1cbiAgICAvKipcbiAgICAgKiBJbmRpY2F0ZXMgd2hldGhlciBhbnkgb2YgdGhlIGlucHV0cyBhcmUgZm9jdXNlZC5cbiAgICAgKi9cbiAgICBnZXQgaXNGb2N1c2VkKCkge1xuICAgICAgICBpZiAoIShpc0RvY3VtZW50QXZhaWxhYmxlKCkgJiYgaXNQcmVzZW50KHRoaXMuaG9zdCkpKSB7XG4gICAgICAgICAgICByZXR1cm4gZmFsc2U7XG4gICAgICAgIH1cbiAgICAgICAgY29uc3QgYWN0aXZlRWxlbWVudCA9IGRvY3VtZW50LmFjdGl2ZUVsZW1lbnQ7XG4gICAgICAgIHJldHVybiB0aGlzLmhvc3QubmF0aXZlRWxlbWVudC5jb250YWlucyhhY3RpdmVFbGVtZW50KTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogSW5kaWNhdGVzIHdoZXRoZXIgYW55IG9mIHRoZSByZ2JhIGlucHV0cyBoYXZlIHZhbHVlLlxuICAgICAqL1xuICAgIGdldCByZ2JhSW5wdXRWYWxpZCgpIHtcbiAgICAgICAgcmV0dXJuIE9iamVjdC5rZXlzKHRoaXMucmdiYSkuZXZlcnkoa2V5ID0+IGlzUHJlc2VudCh0aGlzLnJnYmFba2V5XSkpO1xuICAgIH1cbiAgICBuZ09uQ2hhbmdlcyhjaGFuZ2VzKSB7XG4gICAgICAgIGlmIChpc1ByZXNlbnQoY2hhbmdlcy52YWx1ZSkgJiYgIXRoaXMuaXNGb2N1c2VkKSB7XG4gICAgICAgICAgICB0aGlzLmhleCA9IHBhcnNlQ29sb3IkMSh0aGlzLnZhbHVlLCAnaGV4Jyk7XG4gICAgICAgICAgICB0aGlzLnJnYmEgPSBnZXRSR0JBKHRoaXMudmFsdWUpO1xuICAgICAgICAgICAgdGhpcy5yZ2JhLmEgPSBwYXJzZUNvbG9yJDEodGhpcy52YWx1ZSwgJ3JnYmEnKSA/IHRoaXMucmdiYS5hIDogMTtcbiAgICAgICAgfVxuICAgIH1cbiAgICBoYW5kbGVSZ2JhVmFsdWVDaGFuZ2UoKSB7XG4gICAgICAgIGNvbnN0IGNvbG9yID0gZ2V0Q29sb3JGcm9tUkdCQSh0aGlzLnJnYmEpO1xuICAgICAgICBpZiAoIXRoaXMucmdiYUlucHV0VmFsaWQgfHwgY29sb3IgPT09IHRoaXMudmFsdWUpIHtcbiAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgfVxuICAgICAgICB0aGlzLnZhbHVlID0gY29sb3I7XG4gICAgICAgIHRoaXMucmdiYSA9IGdldFJHQkEodGhpcy52YWx1ZSk7XG4gICAgICAgIHRoaXMuaGV4ID0gcGFyc2VDb2xvciQxKGNvbG9yLCAnaGV4Jyk7XG4gICAgICAgIHRoaXMudmFsdWVDaGFuZ2UuZW1pdChjb2xvcik7XG4gICAgfVxuICAgIGhhbmRsZUhleFZhbHVlQ2hhbmdlKGhleCkge1xuICAgICAgICB0aGlzLmhleCA9IGhleDtcbiAgICAgICAgY29uc3QgY29sb3IgPSBwYXJzZUNvbG9yJDEoaGV4LCAncmdiYScpO1xuICAgICAgICBpZiAoIWlzUHJlc2VudChjb2xvcikgfHwgY29sb3IgPT09IHRoaXMudmFsdWUpIHtcbiAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgfVxuICAgICAgICB0aGlzLnZhbHVlID0gY29sb3I7XG4gICAgICAgIHRoaXMucmdiYSA9IGdldFJHQkEoY29sb3IpO1xuICAgICAgICB0aGlzLnZhbHVlQ2hhbmdlLmVtaXQoY29sb3IpO1xuICAgIH1cbiAgICBoYW5kbGVSZ2JhSW5wdXRCbHVyKCkge1xuICAgICAgICBpZiAoIXRoaXMucmdiYUlucHV0VmFsaWQpIHtcbiAgICAgICAgICAgIHRoaXMucmdiYSA9IGdldFJHQkEodGhpcy52YWx1ZSk7XG4gICAgICAgIH1cbiAgICB9XG4gICAgaGFuZGxlSGV4SW5wdXRCbHVyKCkge1xuICAgICAgICB0aGlzLmhleCA9IHBhcnNlQ29sb3IkMSh0aGlzLnZhbHVlLCAnaGV4Jyk7XG4gICAgfVxufVxuQ29sb3JJbnB1dENvbXBvbmVudC5kZWNvcmF0b3JzID0gW1xuICAgIHsgdHlwZTogQ29tcG9uZW50LCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIHNlbGVjdG9yOiAna2VuZG8tY29sb3JpbnB1dCcsXG4gICAgICAgICAgICAgICAgdGVtcGxhdGU6IGBcbiAgICAgICAgPGRpdiBjbGFzcz1cImstaGJveCBrLWdyYWRpZW50LXZhbHVlc1wiPlxuICAgICAgICAgICAgPGlucHV0XG4gICAgICAgICAgICAgICAgI2hleElucHV0XG4gICAgICAgICAgICAgICAgY2xhc3M9XCJrLXRleHRib3ggay1oZXgtdmFsdWVcIlxuICAgICAgICAgICAgICAgIFtkaXNhYmxlZF09XCJkaXNhYmxlZFwiXG4gICAgICAgICAgICAgICAgW3JlYWRvbmx5XT1cInJlYWRvbmx5XCJcbiAgICAgICAgICAgICAgICBbdmFsdWVdPVwiaGV4IHx8ICcnXCJcbiAgICAgICAgICAgICAgICBwbGFjZWhvbGRlcj1cIm5vIGNvbG9yXCJcbiAgICAgICAgICAgICAgICAoYmx1cik9XCJoYW5kbGVIZXhJbnB1dEJsdXIoKVwiXG4gICAgICAgICAgICAgICAgKGlucHV0KT1cImhhbmRsZUhleFZhbHVlQ2hhbmdlKGhleElucHV0LnZhbHVlKVwiXG4gICAgICAgICAgICAvPlxuICAgICAgICAgICAgPGtlbmRvLW51bWVyaWN0ZXh0Ym94XG4gICAgICAgICAgICAgICAgW2Rpc2FibGVkXT1cImRpc2FibGVkXCJcbiAgICAgICAgICAgICAgICBbcmVhZG9ubHldPVwicmVhZG9ubHlcIlxuICAgICAgICAgICAgICAgIFttaW5dPVwiMFwiXG4gICAgICAgICAgICAgICAgW21heF09XCIyNTVcIlxuICAgICAgICAgICAgICAgIHBsYWNlaG9sZGVyPVwiUlwiXG4gICAgICAgICAgICAgICAgWyh2YWx1ZSldPVwicmdiYS5yXCJcbiAgICAgICAgICAgICAgICBbYXV0b0NvcnJlY3RdPVwidHJ1ZVwiXG4gICAgICAgICAgICAgICAgW3NwaW5uZXJzXT1cImZhbHNlXCJcbiAgICAgICAgICAgICAgICBbZm9ybWF0XT1cIiduJ1wiXG4gICAgICAgICAgICAgICAgW2RlY2ltYWxzXT1cIjBcIlxuICAgICAgICAgICAgICAgIChibHVyKT1cImhhbmRsZVJnYmFJbnB1dEJsdXIoKVwiXG4gICAgICAgICAgICAgICAgKHZhbHVlQ2hhbmdlKT1cImhhbmRsZVJnYmFWYWx1ZUNoYW5nZSgpXCJcbiAgICAgICAgICAgID5cbiAgICAgICAgICAgIDwva2VuZG8tbnVtZXJpY3RleHRib3g+XG4gICAgICAgICAgICA8a2VuZG8tbnVtZXJpY3RleHRib3hcbiAgICAgICAgICAgICAgICBbZGlzYWJsZWRdPVwiZGlzYWJsZWRcIlxuICAgICAgICAgICAgICAgIFtyZWFkb25seV09XCJyZWFkb25seVwiXG4gICAgICAgICAgICAgICAgW21pbl09XCIwXCJcbiAgICAgICAgICAgICAgICBbbWF4XT1cIjI1NVwiXG4gICAgICAgICAgICAgICAgcGxhY2Vob2xkZXI9XCJHXCJcbiAgICAgICAgICAgICAgICBbKHZhbHVlKV09XCJyZ2JhLmdcIlxuICAgICAgICAgICAgICAgIFthdXRvQ29ycmVjdF09XCJ0cnVlXCJcbiAgICAgICAgICAgICAgICBbc3Bpbm5lcnNdPVwiZmFsc2VcIlxuICAgICAgICAgICAgICAgIFtmb3JtYXRdPVwiJ24nXCJcbiAgICAgICAgICAgICAgICBbZGVjaW1hbHNdPVwiMFwiXG4gICAgICAgICAgICAgICAgKGJsdXIpPVwiaGFuZGxlUmdiYUlucHV0Qmx1cigpXCJcbiAgICAgICAgICAgICAgICAodmFsdWVDaGFuZ2UpPVwiaGFuZGxlUmdiYVZhbHVlQ2hhbmdlKClcIlxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgPC9rZW5kby1udW1lcmljdGV4dGJveD5cbiAgICAgICAgICAgIDxrZW5kby1udW1lcmljdGV4dGJveFxuICAgICAgICAgICAgICAgIFtkaXNhYmxlZF09XCJkaXNhYmxlZFwiXG4gICAgICAgICAgICAgICAgW3JlYWRvbmx5XT1cInJlYWRvbmx5XCJcbiAgICAgICAgICAgICAgICBbbWluXT1cIjBcIlxuICAgICAgICAgICAgICAgIFttYXhdPVwiMjU1XCJcbiAgICAgICAgICAgICAgICBwbGFjZWhvbGRlcj1cIkJcIlxuICAgICAgICAgICAgICAgIFsodmFsdWUpXT1cInJnYmEuYlwiXG4gICAgICAgICAgICAgICAgW2F1dG9Db3JyZWN0XT1cInRydWVcIlxuICAgICAgICAgICAgICAgIFtzcGlubmVyc109XCJmYWxzZVwiXG4gICAgICAgICAgICAgICAgW2Zvcm1hdF09XCInbidcIlxuICAgICAgICAgICAgICAgIFtkZWNpbWFsc109XCIwXCJcbiAgICAgICAgICAgICAgICAoYmx1cik9XCJoYW5kbGVSZ2JhSW5wdXRCbHVyKClcIlxuICAgICAgICAgICAgICAgICh2YWx1ZUNoYW5nZSk9XCJoYW5kbGVSZ2JhVmFsdWVDaGFuZ2UoKVwiXG4gICAgICAgICAgICA+XG4gICAgICAgICAgICA8L2tlbmRvLW51bWVyaWN0ZXh0Ym94PlxuICAgICAgICAgICAgPGtlbmRvLW51bWVyaWN0ZXh0Ym94XG4gICAgICAgICAgICAgICAgKm5nSWY9XCJvcGFjaXR5XCJcbiAgICAgICAgICAgICAgICBbZGlzYWJsZWRdPVwiZGlzYWJsZWRcIlxuICAgICAgICAgICAgICAgIFtyZWFkb25seV09XCJyZWFkb25seVwiXG4gICAgICAgICAgICAgICAgW21pbl09XCIwXCJcbiAgICAgICAgICAgICAgICBbbWF4XT1cIjFcIlxuICAgICAgICAgICAgICAgIHBsYWNlaG9sZGVyPVwiQVwiXG4gICAgICAgICAgICAgICAgWyh2YWx1ZSldPVwicmdiYS5hXCJcbiAgICAgICAgICAgICAgICBbYXV0b0NvcnJlY3RdPVwidHJ1ZVwiXG4gICAgICAgICAgICAgICAgW3NwaW5uZXJzXT1cImZhbHNlXCJcbiAgICAgICAgICAgICAgICBbc3RlcF09XCIwLjAxXCJcbiAgICAgICAgICAgICAgICBbZm9ybWF0XT1cIiduMidcIlxuICAgICAgICAgICAgICAgIFtkZWNpbWFsc109XCIyXCJcbiAgICAgICAgICAgICAgICAoYmx1cik9XCJoYW5kbGVSZ2JhSW5wdXRCbHVyKClcIlxuICAgICAgICAgICAgICAgICh2YWx1ZUNoYW5nZSk9XCJoYW5kbGVSZ2JhVmFsdWVDaGFuZ2UoKVwiXG4gICAgICAgICAgICA+XG4gICAgICAgICAgICA8L2tlbmRvLW51bWVyaWN0ZXh0Ym94PlxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgPGRpdiBjbGFzcz1cImstaGJveCBrLWdyYWRpZW50LXZhbHVlc1wiPlxuICAgICAgICAgICAgPGRpdiBjbGFzcz1cImstaGV4LXZhbHVlXCI+aGV4PC9kaXY+XG4gICAgICAgICAgICA8ZGl2PnI8L2Rpdj5cbiAgICAgICAgICAgIDxkaXY+ZzwvZGl2PlxuICAgICAgICAgICAgPGRpdj5iPC9kaXY+XG4gICAgICAgICAgICA8ZGl2ICpuZ0lmPVwib3BhY2l0eVwiPmE8L2Rpdj5cbiAgICAgICAgPC9kaXY+XG4gICAgYFxuICAgICAgICAgICAgfSxdIH0sXG5dO1xuLyoqIEBub2NvbGxhcHNlICovXG5Db2xvcklucHV0Q29tcG9uZW50LmN0b3JQYXJhbWV0ZXJzID0gKCkgPT4gW1xuICAgIHsgdHlwZTogRWxlbWVudFJlZiB9XG5dO1xuQ29sb3JJbnB1dENvbXBvbmVudC5wcm9wRGVjb3JhdG9ycyA9IHtcbiAgICB2YWx1ZTogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgb3BhY2l0eTogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgZGlzYWJsZWQ6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIHJlYWRvbmx5OiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICB2YWx1ZUNoYW5nZTogW3sgdHlwZTogT3V0cHV0IH1dLFxuICAgIGNvbG9ySW5wdXRDbGFzczogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnY2xhc3Muay1jb2xvcmlucHV0cycsXSB9XVxufTtcblxuLyoqXG4gKiBAaGlkZGVuXG4gKi9cbmNsYXNzIEZvY3VzT25Eb21SZWFkeURpcmVjdGl2ZSB7XG4gICAgY29uc3RydWN0b3IoaG9zdCwgbmdab25lKSB7XG4gICAgICAgIHRoaXMuaG9zdCA9IGhvc3Q7XG4gICAgICAgIHRoaXMubmdab25lID0gbmdab25lO1xuICAgIH1cbiAgICBuZ0FmdGVyQ29udGVudEluaXQoKSB7XG4gICAgICAgIHRoaXMuZm9jdXNPbk5leHRUaWNrKCk7XG4gICAgfVxuICAgIGZvY3VzT25OZXh0VGljaygpIHtcbiAgICAgICAgdGhpcy5uZ1pvbmUucnVuT3V0c2lkZUFuZ3VsYXIoKCkgPT4gc2V0VGltZW91dCgoKSA9PiB0aGlzLmhvc3QubmF0aXZlRWxlbWVudC5mb2N1cygpKSk7XG4gICAgfVxufVxuRm9jdXNPbkRvbVJlYWR5RGlyZWN0aXZlLmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBEaXJlY3RpdmUsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgc2VsZWN0b3I6ICdba2VuZG9Gb2N1c09uRG9tUmVhZHldJ1xuICAgICAgICAgICAgfSxdIH0sXG5dO1xuLyoqIEBub2NvbGxhcHNlICovXG5Gb2N1c09uRG9tUmVhZHlEaXJlY3RpdmUuY3RvclBhcmFtZXRlcnMgPSAoKSA9PiBbXG4gICAgeyB0eXBlOiBFbGVtZW50UmVmIH0sXG4gICAgeyB0eXBlOiBOZ1pvbmUgfVxuXTtcblxuY29uc3QgUFVCTElDX0RJUkVDVElWRVMgPSBbXG4gICAgQ29sb3JQaWNrZXJDb21wb25lbnQsXG4gICAgQ29sb3JQYWxldHRlQ29tcG9uZW50LFxuICAgIENvbG9yR3JhZGllbnRDb21wb25lbnRcbl07XG5jb25zdCBJTlRFUk5BTF9ESVJFQ1RJVkVTID0gW1xuICAgIENvbG9ySW5wdXRDb21wb25lbnQsXG4gICAgRm9jdXNPbkRvbVJlYWR5RGlyZWN0aXZlXG5dO1xuLyoqXG4gKiBSZXByZXNlbnRzIHRoZSBbTmdNb2R1bGVdKHt7IHNpdGUuZGF0YS51cmxzLmFuZ3VsYXJbJ25nbW9kdWxlYXBpJ10gfX0pXG4gKiBkZWZpbml0aW9uIGZvciB0aGUgQ29sb3JQaWNrZXIuXG4gKi9cbmNsYXNzIENvbG9yUGlja2VyTW9kdWxlIHtcbn1cbkNvbG9yUGlja2VyTW9kdWxlLmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBOZ01vZHVsZSwgYXJnczogW3tcbiAgICAgICAgICAgICAgICBkZWNsYXJhdGlvbnM6IFtcbiAgICAgICAgICAgICAgICAgICAgUFVCTElDX0RJUkVDVElWRVMsXG4gICAgICAgICAgICAgICAgICAgIElOVEVSTkFMX0RJUkVDVElWRVNcbiAgICAgICAgICAgICAgICBdLFxuICAgICAgICAgICAgICAgIGV4cG9ydHM6IFtQVUJMSUNfRElSRUNUSVZFU10sXG4gICAgICAgICAgICAgICAgaW1wb3J0czogW1xuICAgICAgICAgICAgICAgICAgICBTbGlkZXJNb2R1bGUsXG4gICAgICAgICAgICAgICAgICAgIE51bWVyaWNUZXh0Qm94TW9kdWxlLFxuICAgICAgICAgICAgICAgICAgICBDb21tb25Nb2R1bGUsXG4gICAgICAgICAgICAgICAgICAgIFBvcHVwTW9kdWxlLFxuICAgICAgICAgICAgICAgICAgICBEcmFnZ2FibGVNb2R1bGVcbiAgICAgICAgICAgICAgICBdXG4gICAgICAgICAgICB9LF0gfSxcbl07XG5cbi8qKlxuICogUmVwcmVzZW50cyB0aGUgZGlyZWN0aXZlIHRoYXQgcmVuZGVycyB0aGUgW0tlbmRvIFVJIENoZWNrQm94XSh7JSBzbHVnIG92ZXJ2aWV3X2NoZWNrYm94ICV9KSBpbnB1dCBjb21wb25lbnQuXG4gKiBUaGUgZGlyZWN0aXZlIGlzIHBsYWNlZCBvbiBpbnB1dCB0eXBlPVwiY2hlY2tib3hcIiBlbGVtZW50cy5cbiAqXG4gKiBAZXhhbXBsZVxuICogYGBgdHMtbm8tcnVuXG4gKiA8aW5wdXQgdHlwZT1cImNoZWNrYm94XCIga2VuZG9DaGVja0JveCAvPlxuICogYGBgXG4gKi9cbmNsYXNzIENoZWNrQm94RGlyZWN0aXZlIHtcbiAgICBjb25zdHJ1Y3RvcigpIHtcbiAgICAgICAgdGhpcy5rZW5kb0NsYXNzID0gdHJ1ZTtcbiAgICB9XG59XG5DaGVja0JveERpcmVjdGl2ZS5kZWNvcmF0b3JzID0gW1xuICAgIHsgdHlwZTogRGlyZWN0aXZlLCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIHNlbGVjdG9yOiAnaW5wdXRba2VuZG9DaGVja0JveF0nXG4gICAgICAgICAgICB9LF0gfSxcbl07XG5DaGVja0JveERpcmVjdGl2ZS5wcm9wRGVjb3JhdG9ycyA9IHtcbiAgICBrZW5kb0NsYXNzOiBbeyB0eXBlOiBIb3N0QmluZGluZywgYXJnczogWydjbGFzcy5rLWNoZWNrYm94JyxdIH1dXG59O1xuXG4vKipcbiAqIFJlcHJlc2VudHMgdGhlIFtOZ01vZHVsZV0oe3sgc2l0ZS5kYXRhLnVybHMuYW5ndWxhclsnbmdtb2R1bGVhcGknXSB9fSlcbiAqIGRlZmluaXRpb24gZm9yIHRoZSBDaGVja0JveCBkaXJlY3RpdmUuXG4gKlxuICogQGV4YW1wbGVcbiAqXG4gKiBgYGB0cy1uby1ydW5cbiAqIC8vIEltcG9ydCB0aGUgQ2hlY2tCb3ggbW9kdWxlXG4gKiBpbXBvcnQgeyBDaGVja0JveE1vZHVsZSB9IGZyb20gJ0Bwcm9ncmVzcy9rZW5kby1hbmd1bGFyLWlucHV0cyc7XG4gKlxuICogLy8gVGhlIGJyb3dzZXIgcGxhdGZvcm0gd2l0aCBhIGNvbXBpbGVyXG4gKiBpbXBvcnQgeyBwbGF0Zm9ybUJyb3dzZXJEeW5hbWljIH0gZnJvbSAnQGFuZ3VsYXIvcGxhdGZvcm0tYnJvd3Nlci1keW5hbWljJztcbiAqXG4gKiBpbXBvcnQgeyBOZ01vZHVsZSB9IGZyb20gJ0Bhbmd1bGFyL2NvcmUnO1xuICpcbiAqIC8vIEltcG9ydCB0aGUgYXBwIGNvbXBvbmVudFxuICogaW1wb3J0IHsgQXBwQ29tcG9uZW50IH0gZnJvbSAnLi9hcHAuY29tcG9uZW50JztcbiAqXG4gKiAvLyBEZWZpbmUgdGhlIGFwcCBtb2R1bGVcbiAqIF9ATmdNb2R1bGUoe1xuICogICAgIGRlY2xhcmF0aW9uczogW0FwcENvbXBvbmVudF0sIC8vIGRlY2xhcmUgYXBwIGNvbXBvbmVudFxuICogICAgIGltcG9ydHM6ICAgICAgW0Jyb3dzZXJNb2R1bGUsIENoZWNrQm94TW9kdWxlXSwgLy8gaW1wb3J0IENoZWNrQm94IG1vZHVsZVxuICogICAgIGJvb3RzdHJhcDogICAgW0FwcENvbXBvbmVudF1cbiAqIH0pXG4gKiBleHBvcnQgY2xhc3MgQXBwTW9kdWxlIHt9XG4gKlxuICogLy8gQ29tcGlsZSBhbmQgbGF1bmNoIHRoZSBtb2R1bGVcbiAqIHBsYXRmb3JtQnJvd3NlckR5bmFtaWMoKS5ib290c3RyYXBNb2R1bGUoQXBwTW9kdWxlKTtcbiAqXG4gKiBgYGBcbiAqL1xuY2xhc3MgQ2hlY2tCb3hNb2R1bGUge1xufVxuQ2hlY2tCb3hNb2R1bGUuZGVjb3JhdG9ycyA9IFtcbiAgICB7IHR5cGU6IE5nTW9kdWxlLCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIGRlY2xhcmF0aW9uczogW0NoZWNrQm94RGlyZWN0aXZlXSxcbiAgICAgICAgICAgICAgICBleHBvcnRzOiBbQ2hlY2tCb3hEaXJlY3RpdmVdLFxuICAgICAgICAgICAgICAgIGltcG9ydHM6IFtDb21tb25Nb2R1bGVdXG4gICAgICAgICAgICB9LF0gfSxcbl07XG5cbi8qKlxuICogUmVwcmVzZW50cyB0aGUgZGlyZWN0aXZlIHRoYXQgcmVuZGVycyB0aGUgW0tlbmRvIFVJIFJhZGlvQnV0dG9uXSh7JSBzbHVnIG92ZXJ2aWV3X2NoZWNrYm94ICV9KSBpbnB1dCBjb21wb25lbnQuXG4gKiBUaGUgZGlyZWN0aXZlIGlzIHBsYWNlZCBvbiBpbnB1dCB0eXBlPVwicmFkaW9cIiBlbGVtZW50cy5cbiAqXG4gKiBAZXhhbXBsZVxuICogYGBgdHMtbm8tcnVuXG4gKiA8aW5wdXQgdHlwZT1cInJhZGlvXCIga2VuZG9SYWRpb0J1dHRvbiAvPlxuICogYGBgXG4gKi9cbmNsYXNzIFJhZGlvQnV0dG9uRGlyZWN0aXZlIHtcbiAgICBjb25zdHJ1Y3RvcigpIHtcbiAgICAgICAgdGhpcy5rZW5kb0NsYXNzID0gdHJ1ZTtcbiAgICB9XG59XG5SYWRpb0J1dHRvbkRpcmVjdGl2ZS5kZWNvcmF0b3JzID0gW1xuICAgIHsgdHlwZTogRGlyZWN0aXZlLCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIHNlbGVjdG9yOiAnaW5wdXRba2VuZG9SYWRpb0J1dHRvbl0nXG4gICAgICAgICAgICB9LF0gfSxcbl07XG5SYWRpb0J1dHRvbkRpcmVjdGl2ZS5wcm9wRGVjb3JhdG9ycyA9IHtcbiAgICBrZW5kb0NsYXNzOiBbeyB0eXBlOiBIb3N0QmluZGluZywgYXJnczogWydjbGFzcy5rLXJhZGlvJyxdIH1dXG59O1xuXG4vKipcbiAqIFJlcHJlc2VudHMgdGhlIFtOZ01vZHVsZV0oe3sgc2l0ZS5kYXRhLnVybHMuYW5ndWxhclsnbmdtb2R1bGVhcGknXSB9fSlcbiAqIGRlZmluaXRpb24gZm9yIHRoZSBSYWRpb0J1dHRvbiBkaXJlY3RpdmUuXG4gKlxuICogQGV4YW1wbGVcbiAqXG4gKiBgYGB0cy1uby1ydW5cbiAqIC8vIEltcG9ydCB0aGUgUmFkaW9CdXR0b24gbW9kdWxlXG4gKiBpbXBvcnQgeyBSYWRpb0J1dHRvbk1vZHVsZSB9IGZyb20gJ0Bwcm9ncmVzcy9rZW5kby1hbmd1bGFyLWlucHV0cyc7XG4gKlxuICogLy8gVGhlIGJyb3dzZXIgcGxhdGZvcm0gd2l0aCBhIGNvbXBpbGVyXG4gKiBpbXBvcnQgeyBwbGF0Zm9ybUJyb3dzZXJEeW5hbWljIH0gZnJvbSAnQGFuZ3VsYXIvcGxhdGZvcm0tYnJvd3Nlci1keW5hbWljJztcbiAqXG4gKiBpbXBvcnQgeyBOZ01vZHVsZSB9IGZyb20gJ0Bhbmd1bGFyL2NvcmUnO1xuICpcbiAqIC8vIEltcG9ydCB0aGUgYXBwIGNvbXBvbmVudFxuICogaW1wb3J0IHsgQXBwQ29tcG9uZW50IH0gZnJvbSAnLi9hcHAuY29tcG9uZW50JztcbiAqXG4gKiAvLyBEZWZpbmUgdGhlIGFwcCBtb2R1bGVcbiAqIF9ATmdNb2R1bGUoe1xuICogICAgIGRlY2xhcmF0aW9uczogW0FwcENvbXBvbmVudF0sIC8vIGRlY2xhcmUgYXBwIGNvbXBvbmVudFxuICogICAgIGltcG9ydHM6ICAgICAgW0Jyb3dzZXJNb2R1bGUsIFJhZGlvQnV0dG9uTW9kdWxlXSwgLy8gaW1wb3J0IFJhZGlvQnV0dG9uIG1vZHVsZVxuICogICAgIGJvb3RzdHJhcDogICAgW0FwcENvbXBvbmVudF1cbiAqIH0pXG4gKiBleHBvcnQgY2xhc3MgQXBwTW9kdWxlIHt9XG4gKlxuICogLy8gQ29tcGlsZSBhbmQgbGF1bmNoIHRoZSBtb2R1bGVcbiAqIHBsYXRmb3JtQnJvd3NlckR5bmFtaWMoKS5ib290c3RyYXBNb2R1bGUoQXBwTW9kdWxlKTtcbiAqXG4gKiBgYGBcbiAqL1xuY2xhc3MgUmFkaW9CdXR0b25Nb2R1bGUge1xufVxuUmFkaW9CdXR0b25Nb2R1bGUuZGVjb3JhdG9ycyA9IFtcbiAgICB7IHR5cGU6IE5nTW9kdWxlLCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIGRlY2xhcmF0aW9uczogW1JhZGlvQnV0dG9uRGlyZWN0aXZlXSxcbiAgICAgICAgICAgICAgICBleHBvcnRzOiBbUmFkaW9CdXR0b25EaXJlY3RpdmVdLFxuICAgICAgICAgICAgICAgIGltcG9ydHM6IFtDb21tb25Nb2R1bGVdXG4gICAgICAgICAgICB9LF0gfSxcbl07XG5cbmxldCBzZXJpYWwkMyA9IDA7XG4vKipcbiAqIFJlcHJlc2VudHMgYW4gZXJyb3IgbWVzc2FnZSB0aGF0IHdpbGwgYmUgc2hvd24gdW5kZXJuZWF0aFxuICogYSBLZW5kbyBjb250cm9sIG9yIG5hdGl2ZSBIVE1MIGZvcm0tYm91bmQgY29tcG9uZW50IGFmdGVyIGEgdmFsaWRhdGlvbi5cbiAqL1xuY2xhc3MgRXJyb3JDb21wb25lbnQge1xuICAgIGNvbnN0cnVjdG9yKCkge1xuICAgICAgICB0aGlzLmhvc3RDbGFzcyA9IHRydWU7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBTcGVjaWZpZXMgdGhlIGFsaWdubWVudCBvZiB0aGUgRXJyb3IgbWVzc2FnZS5cbiAgICAgICAgICpcbiAgICAgICAgICogVGhlIHBvc3NpYmxlIHZhbHVlcyBhcmU6XG4gICAgICAgICAqICogKERlZmF1bHQpIGBzdGFydGBcbiAgICAgICAgICogKiBgZW5kYFxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5hbGlnbiA9ICdzdGFydCc7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAaGlkZGVuXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLmlkID0gYGtlbmRvLWVycm9yLSR7c2VyaWFsJDMrK31gO1xuICAgICAgICB0aGlzLnJvbGVBdHRyaWJ1dGUgPSAnYWxlcnQnO1xuICAgIH1cbiAgICBnZXQgc3RhcnRDbGFzcygpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuYWxpZ24gPT09ICdzdGFydCc7XG4gICAgfVxuICAgIGdldCBlbmRDbGFzcygpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuYWxpZ24gPT09ICdlbmQnO1xuICAgIH1cbiAgICBnZXQgaWRBdHRyaWJ1dGUoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmlkO1xuICAgIH1cbn1cbkVycm9yQ29tcG9uZW50LmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBDb21wb25lbnQsIGFyZ3M6IFt7XG4gICAgICAgICAgICAgICAgc2VsZWN0b3I6ICdrZW5kby1mb3JtZXJyb3InLFxuICAgICAgICAgICAgICAgIHRlbXBsYXRlOiBgXG4gICAgICAgIDxuZy1jb250ZW50PjwvbmctY29udGVudD5cbiAgICBgXG4gICAgICAgICAgICB9LF0gfSxcbl07XG5FcnJvckNvbXBvbmVudC5wcm9wRGVjb3JhdG9ycyA9IHtcbiAgICBob3N0Q2xhc3M6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstZm9ybS1lcnJvcicsXSB9XSxcbiAgICBhbGlnbjogW3sgdHlwZTogSW5wdXQgfV0sXG4gICAgcm9sZUF0dHJpYnV0ZTogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnYXR0ci5yb2xlJyxdIH1dLFxuICAgIHN0YXJ0Q2xhc3M6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstdGV4dC1zdGFydCcsXSB9XSxcbiAgICBlbmRDbGFzczogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnY2xhc3Muay10ZXh0LWVuZCcsXSB9XSxcbiAgICBpZEF0dHJpYnV0ZTogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnYXR0ci5pZCcsXSB9XVxufTtcblxubGV0IHNlcmlhbCQ0ID0gMDtcbi8qKlxuICogUmVwcmVzZW50cyBhIGhpbnQgbWVzc2FnZSB0aGF0IHdpbGwgYmUgc2hvd24gdW5kZXJuZWF0aCBhIGZvcm0tYm91bmQgY29tcG9uZW50LlxuICovXG5jbGFzcyBIaW50Q29tcG9uZW50IHtcbiAgICBjb25zdHJ1Y3RvcigpIHtcbiAgICAgICAgLyoqXG4gICAgICAgICAqIFNwZWNpZmllcyB0aGUgYWxpZ25tZW50IG9mIHRoZSBIaW50IG1lc3NhZ2UuXG4gICAgICAgICAqXG4gICAgICAgICAqIFRoZSBwb3NzaWJsZSB2YWx1ZXMgYXJlOlxuICAgICAgICAgKiAqIChEZWZhdWx0KSBgc3RhcnRgXG4gICAgICAgICAqICogYGVuZGBcbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuYWxpZ24gPSAnc3RhcnQnO1xuICAgICAgICAvKipcbiAgICAgICAgICogQGhpZGRlblxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5pZCA9IGBrZW5kby1oaW50LSR7c2VyaWFsJDQrK31gO1xuICAgICAgICB0aGlzLmhvc3RDbGFzcyA9IHRydWU7XG4gICAgfVxuICAgIGdldCBzdGFydENsYXNzKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5hbGlnbiA9PT0gJ3N0YXJ0JztcbiAgICB9XG4gICAgZ2V0IGVuZENsYXNzKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5hbGlnbiA9PT0gJ2VuZCc7XG4gICAgfVxuICAgIGdldCBpZEF0dHJpYnV0ZSgpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuaWQ7XG4gICAgfVxufVxuSGludENvbXBvbmVudC5kZWNvcmF0b3JzID0gW1xuICAgIHsgdHlwZTogQ29tcG9uZW50LCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIHNlbGVjdG9yOiAna2VuZG8tZm9ybWhpbnQnLFxuICAgICAgICAgICAgICAgIHRlbXBsYXRlOiBgXG4gICAgICAgIDxuZy1jb250ZW50PjwvbmctY29udGVudD5cbiAgICBgXG4gICAgICAgICAgICB9LF0gfSxcbl07XG5IaW50Q29tcG9uZW50LnByb3BEZWNvcmF0b3JzID0ge1xuICAgIGFsaWduOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBob3N0Q2xhc3M6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstZm9ybS1oaW50JyxdIH1dLFxuICAgIHN0YXJ0Q2xhc3M6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstdGV4dC1zdGFydCcsXSB9XSxcbiAgICBlbmRDbGFzczogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnY2xhc3Muay10ZXh0LWVuZCcsXSB9XSxcbiAgICBpZEF0dHJpYnV0ZTogW3sgdHlwZTogSG9zdEJpbmRpbmcsIGFyZ3M6IFsnYXR0ci5pZCcsXSB9XVxufTtcblxuLyoqXG4gKiBTcGVjaWZpZXMgYSBjb250YWluZXIgZm9yIGZvcm0tYm91bmQgY29udHJvbHMgKEtlbmRvIGNvbnRyb2xzIG9yIG5hdGl2ZSBIVE1MIGNvbnRyb2xzKS5cbiAqIEFwcGxpZXMgc3R5bGluZyBhbmQgYmVoYXZpb3IgcnVsZXMuXG4gKi9cbmNsYXNzIEZvcm1GaWVsZENvbXBvbmVudCB7XG4gICAgY29uc3RydWN0b3IocmVuZGVyZXIsIGxvY2FsaXphdGlvblNlcnZpY2UpIHtcbiAgICAgICAgdGhpcy5yZW5kZXJlciA9IHJlbmRlcmVyO1xuICAgICAgICB0aGlzLmxvY2FsaXphdGlvblNlcnZpY2UgPSBsb2NhbGl6YXRpb25TZXJ2aWNlO1xuICAgICAgICB0aGlzLmhvc3RDbGFzcyA9IHRydWU7XG4gICAgICAgIC8qKlxuICAgICAgICAgKlxuICAgICAgICAgKiBTcGVjaWZpZXMgd2hlbiB0aGUgSGludCBtZXNzYWdlcyB3aWxsIGJlIHNob3duLlxuICAgICAgICAgKlxuICAgICAgICAgKiBUaGUgcG9zc2libGUgdmFsdWVzIGFyZTpcbiAgICAgICAgICpcbiAgICAgICAgICogKiAoRGVmYXVsdCkgYGluaXRpYWxgJm1kYXNoO0FsbG93cyBkaXNwbGF5aW5nIGhpbnRzIHdoZW4gdGhlIGZvcm0tYm91bmQgY29tcG9uZW50IHN0YXRlIGlzXG4gICAgICAgICAqIGB2YWxpZGAgb3IgYHVudG91Y2hlZGAgYW5kIGBwcmlzdGluZWAuXG4gICAgICAgICAqICogYGFsd2F5c2AmbWRhc2g7QWxsb3dzIGZ1bGwgY29udHJvbCBvdmVyIHRoZSB2aXNpYmlsaXR5IG9mIHRoZSBoaW50cy5cbiAgICAgICAgICpcbiAgICAgICAgICovXG4gICAgICAgIHRoaXMuc2hvd0hpbnRzID0gJ2luaXRpYWwnO1xuICAgICAgICAvKipcbiAgICAgICAgICogU3BlY2lmaWVzIHRoZSBsYXlvdXQgb3JpZW50YXRpb24gb2YgdGhlIGZvcm0gZmllbGQuXG4gICAgICAgICAqXG4gICAgICAgICAqICogVGhlIHBvc3NpYmxlIHZhbHVlcyBhcmU6XG4gICAgICAgICAqXG4gICAgICAgICAqICogKERlZmF1bHQpIGB2ZXJ0aWNhbGBcbiAgICAgICAgICogKiBgaG9yaXpvbnRhbGBcbiAgICAgICAgICovXG4gICAgICAgIHRoaXMub3JpZW50YXRpb24gPSAndmVydGljYWwnO1xuICAgICAgICAvKipcbiAgICAgICAgICogU3BlY2lmaWVzIHdoZW4gdGhlIEVycm9yIG1lc3NhZ2VzIHdpbGwgYmUgc2hvd24uXG4gICAgICAgICAqXG4gICAgICAgICAqIFRoZSBwb3NzaWJsZSB2YWx1ZXMgYXJlOlxuICAgICAgICAgKlxuICAgICAgICAgKiAqIChEZWZhdWx0KSBgaW5pdGlhbGAmbWRhc2g7QWxsb3dzIGRpc3BsYXlpbmcgZXJyb3JzIHdoZW4gdGhlIGZvcm0tYm91bmQgY29tcG9uZW50IHN0YXRlIGlzXG4gICAgICAgICAqIGBpbnZhbGlkYCBhbmQgYHRvdWNoZWRgIG9yIGBkaXJ0eWAuXG4gICAgICAgICAqICogYGFsd2F5c2AmbWRhc2g7QWxsb3dzIGZ1bGwgY29udHJvbCBvdmVyIHRoZSB2aXNpYmlsaXR5IG9mIHRoZSBlcnJvcnMuXG4gICAgICAgICAqXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLnNob3dFcnJvcnMgPSAnaW5pdGlhbCc7XG4gICAgICAgIHRoaXMuc3Vic2NyaXB0aW9ucyA9IG5ldyBTdWJzY3JpcHRpb24oKTtcbiAgICAgICAgdGhpcy5ydGwgPSBmYWxzZTtcbiAgICAgICAgdGhpcy5zdWJzY3JpcHRpb25zLmFkZCh0aGlzLmxvY2FsaXphdGlvblNlcnZpY2UuY2hhbmdlcy5zdWJzY3JpYmUoKHsgcnRsIH0pID0+IHtcbiAgICAgICAgICAgIHRoaXMucnRsID0gcnRsO1xuICAgICAgICAgICAgdGhpcy5kaXJlY3Rpb24gPSB0aGlzLnJ0bCA/ICdydGwnIDogJ2x0cic7XG4gICAgICAgIH0pKTtcbiAgICB9XG4gICAgZ2V0IGVycm9yQ2xhc3MoKSB7XG4gICAgICAgIGlmICghdGhpcy5jb250cm9sKSB7XG4gICAgICAgICAgICByZXR1cm4gZmFsc2U7XG4gICAgICAgIH1cbiAgICAgICAgcmV0dXJuIHRoaXMuY29udHJvbC5pbnZhbGlkICYmICh0aGlzLmNvbnRyb2wudG91Y2hlZCB8fCB0aGlzLmNvbnRyb2wuZGlydHkpO1xuICAgIH1cbiAgICBnZXQgZGlzYWJsZWRDbGFzcygpIHtcbiAgICAgICAgaWYgKCF0aGlzLmNvbnRyb2wpIHtcbiAgICAgICAgICAgIHJldHVybiBmYWxzZTtcbiAgICAgICAgfVxuICAgICAgICAvLyByYWRpb2J1dHRvbiBncm91cFxuICAgICAgICBpZiAodGhpcy5pc1JhZGlvQ29udHJvbCh0aGlzLmNvbnRyb2wpKSB7XG4gICAgICAgICAgICByZXR1cm4gZmFsc2U7XG4gICAgICAgIH1cbiAgICAgICAgcmV0dXJuIHRoaXMuZGlzYWJsZWRDb250cm9sKCkgfHxcbiAgICAgICAgICAgIHRoaXMuZGlzYWJsZWRFbGVtZW50KCkgfHxcbiAgICAgICAgICAgIHRoaXMuZGlzYWJsZWRLZW5kb0lucHV0KCk7XG4gICAgfVxuICAgIHNldCBmb3JtQ29udHJvbHMoZm9ybUNvbnRyb2xzKSB7XG4gICAgICAgIHRoaXMudmFsaWRhdGVGb3JtQ29udHJvbChmb3JtQ29udHJvbHMpO1xuICAgICAgICB0aGlzLmNvbnRyb2wgPSBmb3JtQ29udHJvbHMuZmlyc3Q7XG4gICAgfVxuICAgIC8qKlxuICAgICAqIEBoaWRkZW5cbiAgICAgKi9cbiAgICBnZXQgaG9yaXpvbnRhbCgpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMub3JpZW50YXRpb24gPT09ICdob3Jpem9udGFsJztcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIGdldCBoYXNIaW50cygpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuc2hvd0hpbnRzID09PSAnYWx3YXlzJyA/IHRydWUgOiB0aGlzLnNob3dIaW50c0luaXRpYWwoKTtcbiAgICB9XG4gICAgLyoqXG4gICAgICogQGhpZGRlblxuICAgICAqL1xuICAgIGdldCBoYXNFcnJvcnMoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLnNob3dFcnJvcnMgPT09ICdhbHdheXMnID8gdHJ1ZSA6IHRoaXMuc2hvd0Vycm9yc0luaXRpYWwoKTtcbiAgICB9XG4gICAgbmdBZnRlclZpZXdJbml0KCkge1xuICAgICAgICB0aGlzLnNldERlc2NyaXB0aW9uKCk7XG4gICAgfVxuICAgIG5nT25EZXN0cm95KCkge1xuICAgICAgICB0aGlzLnN1YnNjcmlwdGlvbnMudW5zdWJzY3JpYmUoKTtcbiAgICB9XG4gICAgZGlzYWJsZWRLZW5kb0lucHV0KCkge1xuICAgICAgICByZXR1cm4gdGhpcy5rZW5kb0lucHV0ICYmIHRoaXMua2VuZG9JbnB1dC5kaXNhYmxlZDtcbiAgICB9XG4gICAgZGlzYWJsZWRDb250cm9sKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5jb250cm9sLmRpc2FibGVkO1xuICAgIH1cbiAgICBkaXNhYmxlZEVsZW1lbnQoKSB7XG4gICAgICAgIGNvbnN0IGVsZW1lbnRzID0gdGhpcy5jb250cm9sRWxlbWVudFJlZnMudG9BcnJheSgpO1xuICAgICAgICByZXR1cm4gZWxlbWVudHMuZXZlcnkoZSA9PiBlLm5hdGl2ZUVsZW1lbnQuaGFzQXR0cmlidXRlKCdkaXNhYmxlZCcpKTtcbiAgICB9XG4gICAgdmFsaWRhdGVGb3JtQ29udHJvbChmb3JtQ29udHJvbHMpIHtcbiAgICAgICAgaWYgKGlzRGV2TW9kZSgpICYmIGZvcm1Db250cm9scy5sZW5ndGggIT09IDEgJiYgIXRoaXMuaXNDb250cm9sR3JvdXAoZm9ybUNvbnRyb2xzKSkge1xuICAgICAgICAgICAgdGhyb3cgbmV3IEVycm9yKCdUaGUgYGtlbmRvLWZvcm1maWVsZGAgY29tcG9uZW50IHNob3VsZCBjb250YWluICcgK1xuICAgICAgICAgICAgICAgICdvbmx5IG9uZSBjb250cm9sIG9mIHR5cGUgTmdDb250cm9sIHdpdGggYSBmb3JtQ29udHJvbE5hbWUoaHR0cHM6Ly9hbmd1bGFyLmlvL2FwaS9mb3Jtcy9Gb3JtQ29udHJvbE5hbWUpJyArXG4gICAgICAgICAgICAgICAgJ29yIGFuIG5nTW9kZWwoaHR0cHM6Ly9hbmd1bGFyLmlvL2FwaS9mb3Jtcy9OZ01vZGVsKSBiaW5kaW5nLicpO1xuICAgICAgICB9XG4gICAgfVxuICAgIGlzQ29udHJvbEdyb3VwKGZvcm1Db250cm9scykge1xuICAgICAgICBpZiAoIWZvcm1Db250cm9scy5sZW5ndGgpIHtcbiAgICAgICAgICAgIHJldHVybiBmYWxzZTtcbiAgICAgICAgfVxuICAgICAgICBjb25zdCBuYW1lID0gZm9ybUNvbnRyb2xzLmZpcnN0Lm5hbWU7XG4gICAgICAgIHJldHVybiBmb3JtQ29udHJvbHMudG9BcnJheSgpLmV2ZXJ5KGMgPT4gYy5uYW1lID09PSBuYW1lICYmICh0aGlzLmlzUmFkaW9Db250cm9sKGMpKSk7XG4gICAgfVxuICAgIGlzUmFkaW9Db250cm9sKGNvbnRyb2wpIHtcbiAgICAgICAgcmV0dXJuIGNvbnRyb2wudmFsdWVBY2Nlc3NvciBpbnN0YW5jZW9mIFJhZGlvQ29udHJvbFZhbHVlQWNjZXNzb3I7XG4gICAgfVxuICAgIHVwZGF0ZURlc2NyaXB0aW9uKCkge1xuICAgICAgICBjb25zdCBjb250cm9scyA9IHRoaXMuZmluZENvbnRyb2xFbGVtZW50cygpO1xuICAgICAgICBpZiAoIWNvbnRyb2xzKSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgY29udHJvbHMuZm9yRWFjaCgoY29udHJvbCkgPT4ge1xuICAgICAgICAgICAgY29uc3QgYXJpYUlkcyA9IHRoaXMuZ2VuZXJhdGVEZXNjcmlwdGlvbklkcyhjb250cm9sKTtcbiAgICAgICAgICAgIHRoaXMucmVuZGVyZXIuc2V0QXR0cmlidXRlKGNvbnRyb2wsICdhcmlhLWRlc2NyaWJlZGJ5JywgYXJpYUlkcyk7XG4gICAgICAgIH0pO1xuICAgIH1cbiAgICBmaW5kQ29udHJvbEVsZW1lbnRzKCkge1xuICAgICAgICBpZiAoIXRoaXMuY29udHJvbEVsZW1lbnRSZWZzKSB7XG4gICAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgLy8gaWYgdGhlIGNvbnRyb2wgaXMgS2VuZG9JbnB1dCBhbmQgaGFzIGZvY3VzYWJsZUlkIC0gZHJvcGRvd25zLCBkYXRlaW5wdXRzXG4gICAgICAgIGlmICh0aGlzLmtlbmRvSW5wdXQgJiYgdGhpcy5rZW5kb0lucHV0LmZvY3VzYWJsZUlkICYmIGlzRG9jdW1lbnRBdmFpbGFibGUoKSkge1xuICAgICAgICAgICAgcmV0dXJuIFtkb2N1bWVudC5nZXRFbGVtZW50QnlJZCh0aGlzLmtlbmRvSW5wdXQuZm9jdXNhYmxlSWQpXTtcbiAgICAgICAgfVxuICAgICAgICByZXR1cm4gdGhpcy5jb250cm9sRWxlbWVudFJlZnMubWFwKGVsID0+IGVsLm5hdGl2ZUVsZW1lbnQpO1xuICAgIH1cbiAgICBnZW5lcmF0ZURlc2NyaXB0aW9uSWRzKGNvbnRyb2wpIHtcbiAgICAgICAgY29uc3QgaWRzID0gbmV3IFNldCgpO1xuICAgICAgICBpZiAoY29udHJvbC5oYXNBdHRyaWJ1dGUoJ2FyaWEtZGVzY3JpYmVkYnknKSkge1xuICAgICAgICAgICAgY29uc3QgYXR0cmlidXRlcyA9IGNvbnRyb2wuZ2V0QXR0cmlidXRlKCdhcmlhLWRlc2NyaWJlZGJ5Jykuc3BsaXQoJyAnKTtcbiAgICAgICAgICAgIGF0dHJpYnV0ZXMuZm9yRWFjaCgoYXR0cikgPT4ge1xuICAgICAgICAgICAgICAgIGlmIChhdHRyLmluY2x1ZGVzKCdrZW5kby1oaW50LScpIHx8IGF0dHIuaW5jbHVkZXMoJ2tlbmRvLWVycm9yLScpKSB7XG4gICAgICAgICAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgaWRzLmFkZChhdHRyKTtcbiAgICAgICAgICAgIH0pO1xuICAgICAgICB9XG4gICAgICAgIHRoaXMuaGludENoaWxkcmVuLmZvckVhY2goKGhpbnQpID0+IHtcbiAgICAgICAgICAgIGlkcy5hZGQoaGludC5pZCk7XG4gICAgICAgIH0pO1xuICAgICAgICB0aGlzLmVycm9yQ2hpbGRyZW4uZm9yRWFjaCgoZXJyb3IpID0+IHtcbiAgICAgICAgICAgIGlkcy5hZGQoZXJyb3IuaWQpO1xuICAgICAgICB9KTtcbiAgICAgICAgcmV0dXJuIEFycmF5LmZyb20oaWRzKS5qb2luKCcgJyk7XG4gICAgfVxuICAgIHNob3dIaW50c0luaXRpYWwoKSB7XG4gICAgICAgIGlmICghdGhpcy5jb250cm9sKSB7XG4gICAgICAgICAgICByZXR1cm4gdHJ1ZTtcbiAgICAgICAgfVxuICAgICAgICBjb25zdCB7IHZhbGlkLCB1bnRvdWNoZWQsIHByaXN0aW5lIH0gPSB0aGlzLmNvbnRyb2w7XG4gICAgICAgIHJldHVybiB2YWxpZCB8fCAodW50b3VjaGVkICYmIHByaXN0aW5lKTtcbiAgICB9XG4gICAgc2hvd0Vycm9yc0luaXRpYWwoKSB7XG4gICAgICAgIGlmICghdGhpcy5jb250cm9sKSB7XG4gICAgICAgICAgICByZXR1cm4gZmFsc2U7XG4gICAgICAgIH1cbiAgICAgICAgY29uc3QgeyBpbnZhbGlkLCBkaXJ0eSwgdG91Y2hlZCB9ID0gdGhpcy5jb250cm9sO1xuICAgICAgICByZXR1cm4gaW52YWxpZCAmJiAoZGlydHkgfHwgdG91Y2hlZCk7XG4gICAgfVxuICAgIHNldERlc2NyaXB0aW9uKCkge1xuICAgICAgICB0aGlzLnVwZGF0ZURlc2NyaXB0aW9uKCk7XG4gICAgICAgIHRoaXMuc3Vic2NyaXB0aW9ucy5hZGQodGhpcy5lcnJvckNoaWxkcmVuLmNoYW5nZXMuc3Vic2NyaWJlKCgpID0+IHRoaXMudXBkYXRlRGVzY3JpcHRpb24oKSkpO1xuICAgICAgICB0aGlzLnN1YnNjcmlwdGlvbnMuYWRkKHRoaXMuaGludENoaWxkcmVuLmNoYW5nZXMuc3Vic2NyaWJlKCgpID0+IHRoaXMudXBkYXRlRGVzY3JpcHRpb24oKSkpO1xuICAgIH1cbn1cbkZvcm1GaWVsZENvbXBvbmVudC5kZWNvcmF0b3JzID0gW1xuICAgIHsgdHlwZTogQ29tcG9uZW50LCBhcmdzOiBbe1xuICAgICAgICAgICAgICAgIHNlbGVjdG9yOiAna2VuZG8tZm9ybWZpZWxkJyxcbiAgICAgICAgICAgICAgICB0ZW1wbGF0ZTogYFxuICAgICAgICA8bmctY29udGVudCBzZWxlY3Q9XCJsYWJlbCwga2VuZG8tbGFiZWxcIj48L25nLWNvbnRlbnQ+XG4gICAgICAgIDxkaXYgW2NsYXNzLmstZm9ybS1maWVsZC13cmFwXT1cImhvcml6b250YWxcIj5cbiAgICAgICAgICAgIDxuZy1jb250ZW50PjwvbmctY29udGVudD5cbiAgICAgICAgICAgIDxuZy1jb250ZW50IHNlbGVjdD1cImtlbmRvLWZvcm1oaW50XCIgKm5nSWY9XCJoYXNIaW50c1wiPjwvbmctY29udGVudD5cbiAgICAgICAgICAgIDxuZy1jb250ZW50IHNlbGVjdD1cImtlbmRvLWZvcm1lcnJvclwiICpuZ0lmPVwiaGFzRXJyb3JzXCI+PC9uZy1jb250ZW50PlxuICAgICAgICA8L2Rpdj5cbiAgICBgLFxuICAgICAgICAgICAgICAgIHByb3ZpZGVyczogW1xuICAgICAgICAgICAgICAgICAgICBMb2NhbGl6YXRpb25TZXJ2aWNlLFxuICAgICAgICAgICAgICAgICAgICB7XG4gICAgICAgICAgICAgICAgICAgICAgICBwcm92aWRlOiBMMTBOX1BSRUZJWCxcbiAgICAgICAgICAgICAgICAgICAgICAgIHVzZVZhbHVlOiAna2VuZG8uZm9ybWZpZWxkJ1xuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgXVxuICAgICAgICAgICAgfSxdIH0sXG5dO1xuLyoqIEBub2NvbGxhcHNlICovXG5Gb3JtRmllbGRDb21wb25lbnQuY3RvclBhcmFtZXRlcnMgPSAoKSA9PiBbXG4gICAgeyB0eXBlOiBSZW5kZXJlcjIgfSxcbiAgICB7IHR5cGU6IExvY2FsaXphdGlvblNlcnZpY2UgfVxuXTtcbkZvcm1GaWVsZENvbXBvbmVudC5wcm9wRGVjb3JhdG9ycyA9IHtcbiAgICBob3N0Q2xhc3M6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstZm9ybS1maWVsZCcsXSB9XSxcbiAgICBkaXJlY3Rpb246IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2F0dHIuZGlyJyxdIH1dLFxuICAgIGVycm9yQ2xhc3M6IFt7IHR5cGU6IEhvc3RCaW5kaW5nLCBhcmdzOiBbJ2NsYXNzLmstZm9ybS1maWVsZC1lcnJvcicsXSB9XSxcbiAgICBkaXNhYmxlZENsYXNzOiBbeyB0eXBlOiBIb3N0QmluZGluZywgYXJnczogWydjbGFzcy5rLWZvcm0tZmllbGQtZGlzYWJsZWQnLF0gfV0sXG4gICAgZm9ybUNvbnRyb2xzOiBbeyB0eXBlOiBDb250ZW50Q2hpbGRyZW4sIGFyZ3M6IFtOZ0NvbnRyb2wsIHsgZGVzY2VuZGFudHM6IHRydWUsIHN0YXRpYzogdHJ1ZSB9LF0gfV0sXG4gICAgY29udHJvbEVsZW1lbnRSZWZzOiBbeyB0eXBlOiBDb250ZW50Q2hpbGRyZW4sIGFyZ3M6IFtOZ0NvbnRyb2wsIHsgcmVhZDogRWxlbWVudFJlZiwgZGVzY2VuZGFudHM6IHRydWUsIHN0YXRpYzogdHJ1ZSB9LF0gfV0sXG4gICAga2VuZG9JbnB1dDogW3sgdHlwZTogQ29udGVudENoaWxkLCBhcmdzOiBbS2VuZG9JbnB1dCwgeyBzdGF0aWM6IHRydWUgfSxdIH1dLFxuICAgIGVycm9yQ2hpbGRyZW46IFt7IHR5cGU6IENvbnRlbnRDaGlsZHJlbiwgYXJnczogW0Vycm9yQ29tcG9uZW50LCB7IGRlc2NlbmRhbnRzOiB0cnVlLCBzdGF0aWM6IHRydWUgfSxdIH1dLFxuICAgIGhpbnRDaGlsZHJlbjogW3sgdHlwZTogQ29udGVudENoaWxkcmVuLCBhcmdzOiBbSGludENvbXBvbmVudCwgeyBkZXNjZW5kYW50czogdHJ1ZSwgc3RhdGljOiB0cnVlIH0sXSB9XSxcbiAgICBzaG93SGludHM6IFt7IHR5cGU6IElucHV0IH1dLFxuICAgIG9yaWVudGF0aW9uOiBbeyB0eXBlOiBJbnB1dCB9XSxcbiAgICBzaG93RXJyb3JzOiBbeyB0eXBlOiBJbnB1dCB9XVxufTtcblxuLyoqXG4gKiBSZXByZXNlbnRzIHRoZSBbTmdNb2R1bGVdKHt7IHNpdGUuZGF0YS51cmxzLmFuZ3VsYXJbJ25nbW9kdWxlYXBpJ10gfX0pXG4gKiBkZWZpbml0aW9uIGZvciB0aGUgRm9ybUZpZWxkLCBFcnJvciBhbmQgSGludCBjb21wb25lbnRzLlxuICpcbiAqIEBleGFtcGxlXG4gKlxuICogYGBgdHMtbm8tcnVuXG4gKiAvLyBJbXBvcnQgdGhlIEZvcm1GaWVsZCBtb2R1bGVcbiAqIGltcG9ydCB7IEZvcm1GaWVsZE1vZHVsZSB9IGZyb20gJ0Bwcm9ncmVzcy9rZW5kby1hbmd1bGFyLWlucHV0cyc7XG4gKlxuICogLy8gVGhlIGJyb3dzZXIgcGxhdGZvcm0gd2l0aCBhIGNvbXBpbGVyXG4gKiBpbXBvcnQgeyBwbGF0Zm9ybUJyb3dzZXJEeW5hbWljIH0gZnJvbSAnQGFuZ3VsYXIvcGxhdGZvcm0tYnJvd3Nlci1keW5hbWljJztcbiAqXG4gKiBpbXBvcnQgeyBOZ01vZHVsZSB9IGZyb20gJ0Bhbmd1bGFyL2NvcmUnO1xuICpcbiAqIC8vIEltcG9ydCB0aGUgYXBwIGNvbXBvbmVudFxuICogaW1wb3J0IHsgQXBwQ29tcG9uZW50IH0gZnJvbSAnLi9hcHAuY29tcG9uZW50JztcbiAqXG4gKiAvLyBEZWZpbmUgdGhlIGFwcCBtb2R1bGVcbiAqIF9ATmdNb2R1bGUoe1xuICogICAgIGRlY2xhcmF0aW9uczogW0FwcENvbXBvbmVudF0sIC8vIGRlY2xhcmUgYXBwIGNvbXBvbmVudFxuICogICAgIGltcG9ydHM6ICAgICAgW0Jyb3dzZXJNb2R1bGUsIEZvcm1GaWVsZE1vZHVsZV0sIC8vIGltcG9ydCBGb3JtRmllbGQgbW9kdWxlXG4gKiAgICAgYm9vdHN0cmFwOiAgICBbQXBwQ29tcG9uZW50XVxuICogfSlcbiAqIGV4cG9ydCBjbGFzcyBBcHBNb2R1bGUge31cbiAqXG4gKiAvLyBDb21waWxlIGFuZCBsYXVuY2ggdGhlIG1vZHVsZVxuICogcGxhdGZvcm1Ccm93c2VyRHluYW1pYygpLmJvb3RzdHJhcE1vZHVsZShBcHBNb2R1bGUpO1xuICpcbiAqIGBgYFxuICovXG5jbGFzcyBGb3JtRmllbGRNb2R1bGUge1xufVxuRm9ybUZpZWxkTW9kdWxlLmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBOZ01vZHVsZSwgYXJnczogW3tcbiAgICAgICAgICAgICAgICBkZWNsYXJhdGlvbnM6IFtIaW50Q29tcG9uZW50LCBFcnJvckNvbXBvbmVudCwgRm9ybUZpZWxkQ29tcG9uZW50XSxcbiAgICAgICAgICAgICAgICBleHBvcnRzOiBbSGludENvbXBvbmVudCwgRXJyb3JDb21wb25lbnQsIEZvcm1GaWVsZENvbXBvbmVudF0sXG4gICAgICAgICAgICAgICAgaW1wb3J0czogW0NvbW1vbk1vZHVsZV1cbiAgICAgICAgICAgIH0sXSB9LFxuXTtcblxuLyoqXG4gKiBSZXByZXNlbnRzIHRoZSBbTmdNb2R1bGVdKHt7IHNpdGUuZGF0YS51cmxzLmFuZ3VsYXJbJ25nbW9kdWxlYXBpJ10gfX0pXG4gKiBkZWZpbml0aW9uIGZvciB0aGUgSW5wdXRzIGNvbXBvbmVudHMuXG4gKlxuICogQGV4YW1wbGVcbiAqXG4gKiBgYGB0cy1uby1ydW5cbiAqIC8vIEltcG9ydCB0aGUgSW5wdXRzIG1vZHVsZVxuICogaW1wb3J0IHsgSW5wdXRzTW9kdWxlIH0gZnJvbSAnQHByb2dyZXNzL2tlbmRvLWFuZ3VsYXItaW5wdXRzJztcbiAqXG4gKiAvLyBUaGUgYnJvd3NlciBwbGF0Zm9ybSB3aXRoIGEgY29tcGlsZXJcbiAqIGltcG9ydCB7IHBsYXRmb3JtQnJvd3NlckR5bmFtaWMgfSBmcm9tICdAYW5ndWxhci9wbGF0Zm9ybS1icm93c2VyLWR5bmFtaWMnO1xuICogaW1wb3J0IHsgQnJvd3NlckFuaW1hdGlvbnNNb2R1bGUgfSBmcm9tICdAYW5ndWxhci9wbGF0Zm9ybS1icm93c2VyL2FuaW1hdGlvbnMnO1xuICpcbiAqIGltcG9ydCB7IE5nTW9kdWxlIH0gZnJvbSAnQGFuZ3VsYXIvY29yZSc7XG4gKlxuICogLy8gSW1wb3J0IHRoZSBhcHAgY29tcG9uZW50XG4gKiBpbXBvcnQgeyBBcHBDb21wb25lbnQgfSBmcm9tICcuL2FwcC5jb21wb25lbnQnO1xuICpcbiAqIC8vIERlZmluZSB0aGUgYXBwIG1vZHVsZVxuICogX0BOZ01vZHVsZSh7XG4gKiAgICAgZGVjbGFyYXRpb25zOiBbQXBwQ29tcG9uZW50XSwgLy8gZGVjbGFyZSBhcHAgY29tcG9uZW50XG4gKiAgICAgaW1wb3J0czogICAgICBbQnJvd3Nlck1vZHVsZSwgQnJvd3NlckFuaW1hdGlvbnNNb2R1bGUsIElucHV0c01vZHVsZV0sIC8vIGltcG9ydCBJbnB1dHMgbW9kdWxlXG4gKiAgICAgYm9vdHN0cmFwOiAgICBbQXBwQ29tcG9uZW50XVxuICogfSlcbiAqIGV4cG9ydCBjbGFzcyBBcHBNb2R1bGUge31cbiAqXG4gKiAvLyBDb21waWxlIGFuZCBsYXVuY2ggdGhlIG1vZHVsZVxuICogcGxhdGZvcm1Ccm93c2VyRHluYW1pYygpLmJvb3RzdHJhcE1vZHVsZShBcHBNb2R1bGUpO1xuICpcbiAqIGBgYFxuICovXG5jbGFzcyBJbnB1dHNNb2R1bGUge1xufVxuSW5wdXRzTW9kdWxlLmRlY29yYXRvcnMgPSBbXG4gICAgeyB0eXBlOiBOZ01vZHVsZSwgYXJnczogW3tcbiAgICAgICAgICAgICAgICBleHBvcnRzOiBbVGV4dEJveE1vZHVsZSwgU2xpZGVyTW9kdWxlLCBSYW5nZVNsaWRlck1vZHVsZSwgU3dpdGNoTW9kdWxlLCBOdW1lcmljVGV4dEJveE1vZHVsZSwgTWFza2VkVGV4dEJveE1vZHVsZSwgQ29sb3JQaWNrZXJNb2R1bGUsIENoZWNrQm94TW9kdWxlLCBSYWRpb0J1dHRvbk1vZHVsZSwgRm9ybUZpZWxkTW9kdWxlXSxcbiAgICAgICAgICAgICAgICBpbXBvcnRzOiBbQ29tbW9uTW9kdWxlXVxuICAgICAgICAgICAgfSxdIH0sXG5dO1xuXG4vKipcbiAqIEdlbmVyYXRlZCBidW5kbGUgaW5kZXguIERvIG5vdCBlZGl0LlxuICovXG5cbmV4cG9ydCB7IENoZWNrQm94TW9kdWxlLCBDb2xvcklucHV0Q29tcG9uZW50LCBGb2N1c09uRG9tUmVhZHlEaXJlY3RpdmUsIENvbG9yUGFsZXR0ZVNlcnZpY2UsIE1hc2tpbmdTZXJ2aWNlLCBOdW1lcmljVGV4dEJveE1lc3NhZ2VzLCBSYWRpb0J1dHRvbk1vZHVsZSwgUmFuZ2VTbGlkZXJDdXN0b21NZXNzYWdlc0NvbXBvbmVudCwgUmFuZ2VTbGlkZXJNZXNzYWdlcywgU2xpZGVyQ3VzdG9tTWVzc2FnZXNDb21wb25lbnQsIFNsaWRlck1lc3NhZ2VzLCBTbGlkZXJCYXNlLCBTbGlkZXJzQ29tbW9uTW9kdWxlLCBTd2l0Y2hDdXN0b21NZXNzYWdlc0NvbXBvbmVudCwgTWVzc2FnZXMsIFRleHRCb3hDdXN0b21NZXNzYWdlc0NvbXBvbmVudCwgTG9jYWxpemVkVGV4dEJveE1lc3NhZ2VzRGlyZWN0aXZlLCBUZXh0Qm94TWVzc2FnZXMsIFRleHRCb3hQcmVmaXhUZW1wbGF0ZURpcmVjdGl2ZSwgVGV4dEJveFNlcGFyYXRvckNvbXBvbmVudCwgVGV4dEJveFN1ZmZpeFRlbXBsYXRlRGlyZWN0aXZlLCBUZXh0Qm94Q29tcG9uZW50LCBTbGlkZXJDb21wb25lbnQsIFJhbmdlU2xpZGVyQ29tcG9uZW50LCBMYWJlbFRlbXBsYXRlRGlyZWN0aXZlLCBTd2l0Y2hDb21wb25lbnQsIFRleHRCb3hDb250YWluZXJDb21wb25lbnQsIFRleHRCb3hEaXJlY3RpdmUsIFRleHRBcmVhRGlyZWN0aXZlLCBOdW1lcmljVGV4dEJveENvbXBvbmVudCwgTnVtZXJpY1RleHRCb3hDdXN0b21NZXNzYWdlc0NvbXBvbmVudCwgTWFza2VkVGV4dEJveENvbXBvbmVudCwgSW5wdXRzTW9kdWxlLCBTbGlkZXJUaWNrc0NvbXBvbmVudCwgU2xpZGVyTW9kdWxlLCBSYW5nZVNsaWRlck1vZHVsZSwgU3dpdGNoTW9kdWxlLCBOdW1lcmljVGV4dEJveE1vZHVsZSwgTWFza2VkVGV4dEJveE1vZHVsZSwgVGV4dEJveE1vZHVsZSwgQ29sb3JQaWNrZXJDb21wb25lbnQsIENvbG9yUGFsZXR0ZUNvbXBvbmVudCwgQ29sb3JHcmFkaWVudENvbXBvbmVudCwgQ29sb3JQaWNrZXJNb2R1bGUsIEFjdGl2ZUNvbG9yQ2xpY2tFdmVudCwgQ2hlY2tCb3hEaXJlY3RpdmUsIFJhZGlvQnV0dG9uRGlyZWN0aXZlLCBIaW50Q29tcG9uZW50LCBFcnJvckNvbXBvbmVudCwgRm9ybUZpZWxkQ29tcG9uZW50LCBGb3JtRmllbGRNb2R1bGUsIExvY2FsaXplZE51bWVyaWNUZXh0Qm94TWVzc2FnZXNEaXJlY3RpdmUsIExvY2FsaXplZFNsaWRlck1lc3NhZ2VzRGlyZWN0aXZlLCBMb2NhbGl6ZWRSYW5nZVNsaWRlck1lc3NhZ2VzRGlyZWN0aXZlLCBMb2NhbGl6ZWRTd2l0Y2hNZXNzYWdlc0RpcmVjdGl2ZSB9O1xuIl19